(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 6401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AnalyticsPluginAdobe; }
/* harmony export */ });
/* harmony import */ var _growth_object_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7106);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var config = {
  adobeDataLayer: []
};

var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
      section = _ref.section,
      lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};

var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';

  var configs = _extends({}, pluginConfig);

  var init = function init() {
    var _window$top;

    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }

    config.adobeDataLayer = (_window$top = window.top) == null ? void 0 : _window$top.adobeDataLayer; // return the created window dataLayer. Helps in testing

    return config.adobeDataLayer;
  };

  var track = function track(_ref2) {
    var payload = _ref2.payload;

    if (typeof config.adobeDataLayer !== 'undefined') {
      var formattedPayload = (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(_extends({}, configs));
      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(payload.eventProperties, formattedPayload);

      if (debug) {
        console.log('track payload ', _extends({
          event: payload.event
        }, formattedPayload));
      } // since ctaclick all the parameters are mandatory i.e. why adding check here


      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      } // don't push the event if adobe script is not present


      if (config.adobeDataLayer) config.adobeDataLayer.push(_extends({
        event: payload.event
      }, formattedPayload));
      return formattedPayload;
    }

    return {};
  };

  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
          _ref3$eventProperties = _ref3.eventProperties,
          eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;

      var formattedPayload = _extends({}, pluginConfig);

      (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepMerge */ .RH)(eventProperties, formattedPayload); // updating the global config data with every pageView Data

      configs = _extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }

    return {};
  };

  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};




/***/ }),

/***/ 2775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ googleTagManager; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var config = {
  dataLayer: []
};

function googleTagManager(pluginConfig) {
  if (pluginConfig === void 0) {
    pluginConfig = {};
  }

  return {
    name: 'google-tag-manager',
    configs: _extends({}, config, pluginConfig),
    init: function init() {
      var _window$top;

      // if dataLayer is not declared yet, assign an empty Array
      if (window.top && !window.top.dataLayer) {
        window.top.dataLayer = [];
      }

      config.dataLayer = (_window$top = window.top) == null ? void 0 : _window$top.dataLayer; // return the created window dataLayer. Helps in testing

      return config.dataLayer;
    },
    track: function track(_ref) {
      var payload = _ref.payload;

      if (typeof config.dataLayer !== 'undefined') {
        var _ref2 = payload || {},
            event = _ref2.event,
            anonymousId = _ref2.anonymousId,
            userId = _ref2.userId,
            eventProperties = _ref2.eventProperties,
            globalProperties = _ref2.globalProperties;

        var formattedPayload = _extends({}, eventProperties, globalProperties);

        if (userId) {
          formattedPayload.userId = userId;
        }

        if (anonymousId) {
          formattedPayload.anonymousId = anonymousId;
        }

        var finalPayload = _extends({
          event: event
        }, formattedPayload);

        config.dataLayer.push(finalPayload);
        return finalPayload;
      }

      return {};
    }
  };
}




/***/ }),

/***/ 2961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdtAnalytics; }
});

;// CONCATENATED MODULE: ../../node_modules/@growth/location/dist/growth-location.esm.js
var getAllQueryStrings = function getAllQueryStrings() {
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams;
};

var getQueryParam = function getQueryParam(param) {
  if (!param) {
    console.warn('Missing argument param for getQueryParam');
    return null;
  }

  var searchParams = getAllQueryStrings();
  if (searchParams && searchParams.get) return searchParams.get(param);
  return null;
};

var getLocationPathName = function getLocationPathName() {
  return window.location.pathname;
};

var isMatchesCurrentHost = function isMatchesCurrentHost(url, whileListedHost) {
  var currentHost = window.location.hostname;

  try {
    var matchHost = new URL(url).hostname;
    var isMatchHostWhitelisted = whileListedHost == null ? void 0 : whileListedHost.some(function (item) {
      return typeof item === 'string' ? item === matchHost : item.test(matchHost);
    });
    if (isMatchHostWhitelisted) return true;
    return currentHost === matchHost;
  } catch (_unused) {
    return false;
  }
};

var navigateWindowBack = function navigateWindowBack(opts) {
  var _ref = opts || {},
      beforeNavigate = _ref.beforeNavigate;

  var _document = document,
      referrer = _document.referrer;
  beforeNavigate == null ? void 0 : beforeNavigate();

  if (referrer && isMatchesCurrentHost(referrer)) {
    window.location.href = referrer;
  } else {
    window.location.href = '/';
  }
};



// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
;// CONCATENATED MODULE: ../../node_modules/@growth/pdt-schema/schema/dist/growth-pdt-schema-schema.esm.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var growth_pdt_schema_schema_esm_CreateWebCommonSchema = function CreateWebCommonSchema(properties) {
  var _navigator, _navigator$connection;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  var event_details = properties.event_details,
      device = properties.device;
  this.values = {
    context: _extends({
      client_timestamp: Date.now(),
      server_timestamp: Date.now(),
      client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      template_id: '26029',
      topic_name: 'gi_growth_web_logging'
    }, properties == null ? void 0 : properties.context),
    event_details: _extends({
      page_uri: (event_details == null ? void 0 : event_details.page_uri) || window.location.href,
      canonical_host: (event_details == null ? void 0 : event_details.canonical_host) || window.location.origin,
      canonical_url: (event_details == null ? void 0 : event_details.canonical_url) || window.location.pathname,
      page_referrer: (event_details == null ? void 0 : event_details.page_referrer) || document.referrer,
      utm_campaign: (event_details == null ? void 0 : event_details.utm_campaign) || getQueryParam('utm_campaign'),
      utm_medium: (event_details == null ? void 0 : event_details.utm_medium) || getQueryParam('utm_medium'),
      utm_source: (event_details == null ? void 0 : event_details.utm_source) || getQueryParam('utm_source')
    }, properties.event_details),
    user: properties.user,
    device: _extends({
      user_agent: navigator.userAgent,
      network_type: ((_navigator = navigator) == null ? void 0 : (_navigator$connection = _navigator.connection) == null ? void 0 : _navigator$connection.effectiveType) || '',
      visitor_id: (device == null ? void 0 : device.visitor_id) || (0,growth_visitor_id_browser_esm/* getVisitorIdBrowser */.MI)(),
      screen_height: (device == null ? void 0 : device.screen_height) || String(window.screen.height),
      screen_width: (device == null ? void 0 : device.screen_width) || String(window.screen.width)
    }, properties == null ? void 0 : properties.device)
  };
};



// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/pdt-track/dist/growth-pdt-track.esm.js



var isEmptyObject = function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0;
};
var DEFAULT_CONFIG = {
  debug: false
};
var PDT_URL = 'https://pdt.goibibo.com/dts/s/da/n';

var sendToPdt = function sendToPdt(_ref) {
  var url = _ref.url,
      analyticsData = _ref.analyticsData,
      debug = _ref.debug,
      customHeaders = _ref.customHeaders;
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };

  var _ref2 = customHeaders || {},
      dvid = _ref2.dvid,
      gaid = _ref2.gaid;

  if (dvid) headers.dvid = dvid;
  if (gaid) headers.gaid = gaid;
  if (debug) headers['X-DEBUG'] = true;
  return fetch(url, {
    method: 'POST',
    headers: headers,
    credentials: 'omit',
    body: JSON.stringify(analyticsData),
    // @ts-ignore-start
    priority: 'low',
    keepalive: true
  });
};

var pdtTrack = function pdtTrack(eventDetails, configs) {
  if (configs === void 0) {
    configs = DEFAULT_CONFIG;
  }

  if (isEmptyObject(eventDetails)) {
    throw new TypeError("Vaidation error on pdt.track; eventDetails parameter must have event key; eventDetails: " + eventDetails);
  }

  var _configs = configs,
      debug = _configs.debug;
  var allEventDetails = new CreateWebCommonSchema(eventDetails).values;
  /*
    * NOTE: we are not doing any validation on this package, since we want to keep this package size small.
    * For validation and more feature use analytics-plugin-pdt
    *
    * Log final events before sending to pdt
    */

  if (debug) console.log('@growth/pdt-track', allEventDetails);
  var dvid = getItem('__gi_vid');
  var gaid = getItem('_gid');
  return sendToPdt({
    url: PDT_URL,
    analyticsData: [allEventDetails],
    debug: configs.debug,
    customHeaders: {
      dvid: dvid,
      gaid: gaid
    }
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js



function growth_analytics_plugin_pdt_esm_extends() {
  growth_analytics_plugin_pdt_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return growth_analytics_plugin_pdt_esm_extends.apply(this, arguments);
}

var defaultConfig = {
  debug: false,
  pdtUrl: 'https://pdt.goibibo.com/dts/s/da/n',
  validator: function validator(obj) {
    return [];
  },
  batchDelay: 100,
  loadEventBatch: true,
  batchRegex: /(load|growth_non_int)/
};

function pdtAnalytics(pluginConfig) {
  if (pluginConfig === void 0) {
    pluginConfig = {};
  }

  var configs = growth_analytics_plugin_pdt_esm_extends({}, defaultConfig, pluginConfig);

  var loadEventsQueue = [];
  var loadEventScheduled;

  var doTrack = function doTrack(_ref) {
    var payload = _ref.payload;
    var event = payload.event,
        _payload$eventPropert = payload.eventProperties,
        eventProperties = _payload$eventPropert === void 0 ? {} : _payload$eventPropert,
        globalProperties = payload.globalProperties,
        options = payload.options;
    var debug = configs.debug,
        batchDelay = configs.batchDelay,
        loadEventBatch = configs.loadEventBatch,
        batchRegex = configs.batchRegex;
    var commonPayload = {
      context: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.context, eventProperties == null ? void 0 : eventProperties.context),
      device: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.device, eventProperties == null ? void 0 : eventProperties.device),
      event_details: growth_analytics_plugin_pdt_esm_extends({
        event: event
      }, eventProperties.event_details),
      user: growth_analytics_plugin_pdt_esm_extends({}, globalProperties == null ? void 0 : globalProperties.user, eventProperties == null ? void 0 : eventProperties.user)
    };
    var pdtEvent = new growth_pdt_schema_schema_esm_CreateWebCommonSchema(commonPayload).values; // validation of schema

    if (debug && typeof configs.validator === 'function') {
      var invalidKeys = configs.validator(pdtEvent);

      if (invalidKeys.length) {
        console.error("pdt.track() schema validation failed: Sending event properties {" + invalidKeys + "} which are not a part of schema");
        return;
      }
    }

    var send = function send(events) {
      return sendToPdt({
        url: configs.pdtUrl,
        analyticsData: events,
        customHeaders: options == null ? void 0 : options.pdtApiHeaders,
        debug: debug
      });
    };
    /** Send load events in a bulk to avoid concurrent api calls */


    var isALoadEvent = function isALoadEvent(e) {
      return e.toLowerCase().match(batchRegex);
    };

    if (loadEventBatch && isALoadEvent(event)) {
      // keep the load event in an array
      loadEventsQueue.push(pdtEvent); // send the all load events in a batch after a certain delay

      if (!loadEventScheduled) {
        var scheduleSend = function scheduleSend() {
          if (debug) {
            console.log('LoadEvents Queue', loadEventsQueue.length);
          }

          send(loadEventsQueue); // !!! Important clear the array after events are sents

          loadEventsQueue = []; // reset the schedule

          loadEventScheduled = undefined;
        };

        loadEventScheduled = setTimeout(scheduleSend, batchDelay);
      }

      return;
    }

    send([pdtEvent]);
  };

  return {
    name: 'pdt-analytics-plugin',
    configs: configs,
    init: function init() {
      return configs;
    },
    track: function track(_ref2) {
      var payload = _ref2.payload;
      return doTrack({
        payload: payload
      });
    }
  };
}




/***/ }),

/***/ 332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YH": function() { return /* binding */ fetchBookingSummary; },
  "VE": function() { return /* binding */ fetchConfigStoreData; },
  "z1": function() { return /* binding */ fetchGoCashBalance; },
  "aL": function() { return /* binding */ fetchLoyaltyUserInfo; }
});

// UNUSED EXPORTS: fetchAppContext, fetchAppOpenUrl, fetchArgusFingerPrinting, fetchAutoSuggetDailyStealDeal, fetchGdprData, fetchPokusAssignVariantData, fetchPokusDynamicConfigs, fetchPokusImpressionAndHonourDetails, fetchPushRecentSearch, fetchRecentSearch, fetchRecommendEarnDetails, fetchSkywalkerClientData, fetchUserDetails, fetchUserGeoLocation, pushUserGdprData

;// CONCATENATED MODULE: ../../node_modules/@growth/api-calls/dist/pokus-dynamic-config-089f1c78.esm.js
function pokus_dynamic_config_089f1c78_esm_extends() {
  pokus_dynamic_config_089f1c78_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return pokus_dynamic_config_089f1c78_esm_extends.apply(this, arguments);
}

var pokus_dynamic_config_089f1c78_esm_generatePokusAssignVariantBodyRequest = function generatePokusAssignVariantBodyRequest(_ref) {
  var lob = _ref.lob,
      isMobile = _ref.isMobile,
      deviceId = _ref.deviceId,
      _ref$extraOptions = _ref.extraOptions,
      extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: pokus_dynamic_config_089f1c78_esm_extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: pokus_dynamic_config_089f1c78_esm_extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes)
  };
  return {
    request: request
  };
};

var pokus_dynamic_config_089f1c78_esm_generateSkywalkerBodyRequest = function generateSkywalkerBodyRequest(_ref) {
  var extraReqBody = _ref.extraReqBody;

  var request = pokus_dynamic_config_089f1c78_esm_extends({
    brand: 'gi',
    user: {
      loginChannel: 'GI'
    }
  }, extraReqBody);

  return request;
};

/**
 *
 * @docs http://confluence.mmt.com/pages/viewpage.action?pageId=823704867
 */
var pokus_dynamic_config_089f1c78_esm_generatePokusDynamicConfigBodyRequest = function generatePokusDynamicConfigBodyRequest(_ref) {
  var lob = _ref.lob,
      isMobile = _ref.isMobile,
      deviceId = _ref.deviceId,
      _ref$extraOptions = _ref.extraOptions,
      extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: pokus_dynamic_config_089f1c78_esm_extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: pokus_dynamic_config_089f1c78_esm_extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes),
    scope: {
      lob: lob,
      deviceOS: device.toUpperCase() // scope values must be in uppercase

    }
  };
  var propertiesToAssign = ['productFeatureConfigKeys', 'features', 'applicationProperties', 'experimentIds'];
  propertiesToAssign.forEach(function (property) {
    if (extraOptions[property]) {
      request[property] = extraOptions[property];
    }
  });
  return request;
};



// EXTERNAL MODULE: ../../node_modules/@growth/fetch-request/dist/growth-fetch-request.esm.js
var growth_fetch_request_esm = __webpack_require__(6963);
;// CONCATENATED MODULE: ../../node_modules/@growth/api-calls/node_modules/@growth/api-configs/dist/index-9be0dea2.esm.js
var hosts = {
  goibibo: '//www.goibibo.com',
  pokus: '//pokus.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalker: '//mapi.goibibo.com',
  voyagerX: '//voyagerx.goibibo.com',
  voyager: '//voyager.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com',
  gdpr: '//consentmgmt.makemytrip.com',
  appBannerUrl: "//userservice.goibibo.com",
  userGeoLocation: '//mapi.goibibo.com',
  configStore: '//configstore.goibibo.com',
  argus: '//www.goibibo.com',
  loyaltyUserInfo: '//membership-service.goibibo.com',
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: '//www.goibibo.com'
};

var PP = 'pp';
var LOCAL = 'local';
var PROD_PP = 'prodpp';
var PROD = 'prod';
var envs = [PROD, PP, PROD_PP, LOCAL];

var index_9be0dea2_esm_filterConfigForEnv = function filterConfigForEnv(configs, env) {
  if (env === void 0) {
    env = 'prod';
  }

  var normalizeEnvVar = function normalizeEnvVar(v) {
    var validEnvVar = function validEnvVar(ve) {
      return envs.includes(ve);
    };

    if (!validEnvVar(v)) {
      throw new Error("getConfig:normalizeEnvVar:validEnvVar error, " + v + " is not a valid env");
    } // pp & local will get the local hosts.
    // prodpp & prod will get the prod hosts.


    var e = [PP, LOCAL].includes(env) ? LOCAL : PROD;
    return e.toLowerCase();
  };

  var BuildEnv = normalizeEnvVar(env);
  return configs[BuildEnv];
};

var index_9be0dea2_esm_getConfigValueFromEnv = function getConfigValueFromEnv(key) {
  if (typeof GROWTH_API_CONFIG !== 'undefined') {
    var value = GROWTH_API_CONFIG[key];
    if (value) return value;
  }

  return hosts[key];
};

var index_9be0dea2_esm_endpoints = {
  appBannerUrlGuest: '/ext/web/pwa/send/token/DEEP_LINK',
  appBannerUrlLoggedIn: '/ext/web/pwa/send/token/LINK',
  pokusAssignVariant: '/experiment/assignVariant',
  userWidget: "/common/userwidget/?random=+" + Math.random(),
  // random to avoid browser cache
  recommendEarnUrl: "/recEarn/infl/details",
  skywalkerV1: '/empeiria/api/v1',
  dsdVoyager: '/api/v1/hotels_search/find_node_by_name',
  appContext: '/api/v2/utils/get_context/',
  recentSearchPush: '/fs/w',
  gdpr: '/ext/hcs/cmp/userconsents/get',
  userGdpr: '/ext/hcs/cmp/userconsents/save',
  userGeoLocation: '/locus/web/v2/graphQl',
  voyagerPagemake: '/pagemaker',
  argus: '/argus/pwa/login_details/save',
  configStore: '/get/configKey',
  getRecentSearch: '/empeiria/api/v1/recentSearchResponseByLob',
  loyaltyUserInfo: '/loyalty/userInfoWrapper',
  gocashBalance: '/gocash/v2/get_balance/',
  bookingSummary: '/tripsbackend/v2/bookingsummary',
  pokusImpressionAndHonour: '/measurement/impressionAndHonourConditions',
  pokusDynamicConfigs: '/measurement/getDynamicConfigs'
};



;// CONCATENATED MODULE: ../../node_modules/@growth/api-calls/node_modules/@growth/api-configs/dist/growth-api-configs.esm.js



/** Will reverse proxy/mock all local & pp api via moxy */
var moxy = '//newprodpp.goibibo.com/moxy';
var growth_api_configs_esm_hosts = {
  goibibo: '//www.goibibo.com',
  pokus: moxy,
  recommendEarnUrl: moxy,
  skywalker: moxy,
  voyagerX: moxy,
  voyager: moxy,
  recentSearchPush: moxy,
  gdpr: moxy,
  appBannerUrl: moxy,
  userGeoLocation: moxy,
  configStore: moxy,
  argus: moxy,
  loyaltyUserInfo: moxy,
  gocashBalance: '//gocash.goibibo.com',
  bookingSummary: moxy
};

/**
 * Default index gives the client side api configs
 * eg:
 * import getConfig from '@growth/api-configs'
 */
var configs = {
  local: growth_api_configs_esm_hosts,
  prod: hosts
};

var getConfig = function getConfig(env) {
  var c = filterConfigForEnv(configs, env);
  return c;
};



// EXTERNAL MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js + 1 modules
var growth_visitor_id_browser_esm = __webpack_require__(6939);
// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
// EXTERNAL MODULE: ../../node_modules/@growth/object-utils/dist/growth-object-utils.esm.js
var growth_object_utils_esm = __webpack_require__(7106);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(1917);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-utils/dist/growth-dom-utils.esm.js
var growth_dom_utils_esm = __webpack_require__(6871);
// EXTERNAL MODULE: ../../node_modules/@growth/date-utils/dist/growth-date-utils.esm.js
var growth_date_utils_esm = __webpack_require__(2830);
;// CONCATENATED MODULE: ../../node_modules/@growth/api-calls/node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js










var HOST = "//userservice.goibibo.com";
var PATHS = {
  dweb: "ext/web/desktop",
  mweb: "ext/web/pwa"
};

var getApiUrls = function getApiUrls(p) {
  var config = {
    USER_DETAILS: HOST + "/" + PATHS[p] + "/user/details",
    LOGOUT: HOST + "/" + PATHS[p] + "/user/logout",
    MOBILE_DETAILS: HOST + "/" + PATHS[p] + "/send/token/OTP_IS_REG",
    LOGIN: HOST + "/" + PATHS[p] + "/login",
    SIGN_UP: HOST + "/" + PATHS[p] + "/verify/token/SIGNUP_OTP",
    CREATE_NEW_USER: HOST + "/" + PATHS[p] + "/user/create/false",
    UPDATE_PROFILE: HOST + "/" + PATHS[p] + "/user/update",
    GET_EMAIL_TOKEN: HOST + "/" + PATHS[p] + "/send/token/EMAIL",
    VERIFY_EMAIL: HOST + "/" + PATHS[p] + "/verify/token/EMAIL",
    UPDATE_PROFILE_PIC: HOST + "/" + PATHS[p] + "/user/upload/imageclass/displaypic",
    REDIRECT_TO_APP: HOST + "/" + PATHS[p] + "/UserService/send/token/LINK",
    DELETE_OTP: HOST + "/" + PATHS[p] + "/send/token/OTP_DELETE",
    SOCIAL_LOGIN: HOST + "/" + PATHS[p] + "/appSocialLogin",
    JWT_TOKEN: HOST + "/" + PATHS[p] + "/jwt/loginToken"
  };
  return config;
};

var GI_TOKEN_NAME = 'OAUTH-GOIBIBO';
var GA_TOKEN = 'gapauthtoken';
var GI_UUID = 'gitokenid';
var GI_SESSIONID = 'sessionid';

var clearUserTokens = function clearUserTokens() {
  removeItem(GI_TOKEN_NAME, '/', 'goibibo.com');
  removeItem(GA_TOKEN, '/', 'goibibo.com');
  removeItem(GI_UUID, '/', 'goibibo.com');
};

var growth_auth_helpers_esm_getAuthToken = function getAuthToken() {
  return (0,growth_cookies_esm/* getItem */.rV)('OAUTH-GOIBIBO');
};

var growth_auth_helpers_esm_isUserTokenPresent = function isUserTokenPresent() {
  var authToken = growth_auth_helpers_esm_getAuthToken();
  return !!authToken;
};

var getEncryptedUuid = function getEncryptedUuid() {
  return getItem('gapauthtoken');
};

var growth_auth_helpers_esm_getUuidFromCookie = function getUuidFromCookie() {
  return getItem('gitokenid');
};

var setUserTokenAndUuid = function setUserTokenAndUuid(_ref) {
  var _window;

  var authToken = _ref.authToken,
      uuid = _ref.uuid;
  (0,growth_cookies_esm/* setItem */.LS)(GI_TOKEN_NAME, authToken, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,growth_cookies_esm/* setItem */.LS)(GA_TOKEN, (_window = window) == null ? void 0 : _window.btoa(uuid), {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,growth_cookies_esm/* setItem */.LS)(GI_UUID, uuid, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
};

var deleteSessionId = function deleteSessionId() {
  return removeItem(GI_SESSIONID, '/', 'goibibo.com');
};

var API_AUTH = {
  MWEB: 'h4nhc9jcgpAGIjp',
  DWEB: 'jkO7Ivpwsh4KaQ9',
  HCS: 'cmVzdDoxMjM0NTY='
};

var getUserIdentifierHeader = function getUserIdentifierHeader(_ref) {
  var platform = _ref.platform;
  return JSON.stringify({
    type: 'auth',
    deviceId: (0,growth_visitor_id_browser_esm/* getVisitorIdBrowser */.MI)() || 'deviceId',
    os: platform === 'mweb' ? 'pwa' : 'desktop',
    osVersion: 'osVersion',
    appVersion: 'appVersion',
    imie: 'imie',
    ipAddress: 'ipAddress',
    timeZone: '+5.30 GMT',
    value: growth_auth_helpers_esm_getAuthToken() || ''
  });
};

var growth_auth_helpers_esm_getEssentialHeader = function getEssentialHeader(_ref2) {
  var platform = _ref2.platform;
  return {
    Authorization: API_AUTH[platform.toUpperCase()],
    'User-Identifier': getUserIdentifierHeader({
      platform: platform
    }),
    'X-request-tracker': (0,growth_visitor_id_browser_esm/* generateVid */.im)()
  };
};

var profileViewQuery = {
  query: [[{
    name: 'extendedUser',
    keys: ['profileId', 'uuid', 'primaryEmailId', 'userType', 'profileType', 'loginInfoList', 'personalDetails']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'personalDetails',
    keys: ['gender', 'dateOfBirth']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'userImages',
    keys: ['fileUrl', 'imageClass'],
    filters: [{
      name: 'imageClass',
      type: 'string',
      value: 'displaypic'
    }]
  }], [{
    name: 'extendedUser'
  }, {
    name: 'profileCompletionDetails',
    keys: ['ctaDetails', 'completionScore', 'title', 'subText', 'component']
  }], [{
    name: 'loginInfoList',
    keys: ['loginId', 'loginType', 'primary', 'status', 'countryCode', 'verified']
  }], [{
    name: 'miscFields',
    keys: ['altEmailId']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'addressDetails',
    keys: ['addressId', 'city', 'name', 'category', 'houseNo', 'street', 'state', 'country', 'postalCode', 'landMark', 'status', 'lastUpdated', 'address1']
  }]]
};
var BILLING_CATEGORY = 'BILLING';

var fetchProfileDetails = function fetchProfileDetails(_ref) {
  var platform = _ref.platform;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).USER_DETAILS, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    body: profileViewQuery,
    credentials: 'omit'
  }).post();
};

var generateProfileUpdateQuery = function generateProfileUpdateQuery(profileFields) {
  var firstName = profileFields.firstName,
      lastName = profileFields.lastName,
      dob = profileFields.dob,
      gender = profileFields.gender,
      email = profileFields.email,
      addressDetails = profileFields.addressDetails;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        personalDetails: {
          gender: gender,
          name: {
            firstName: firstName,
            lastName: lastName
          },
          dateOfBirth: dob
        },
        miscFields: {
          altEmailId: email
        },
        addressDetails: addressDetails
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,growth_object_utils_esm/* removeEmptyValues */.ks)(q);
};

var generateUserCreateQuery = function generateUserCreateQuery(fields) {
  var mobileNumber = fields.mobileNumber,
      fullName = fields.fullName,
      email = fields.email,
      _fields$countryCode = fields.countryCode,
      countryCode = _fields$countryCode === void 0 ? '91' : _fields$countryCode;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        profileType: 'PERSONAL',
        personalDetails: {
          name: {
            firstName: fullName
          }
        },
        miscFields: {
          altEmailId: email
        },
        loginInfoList: [{
          loginId: mobileNumber,
          countryCode: countryCode,
          loginType: 'MOBILE'
        }]
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,growth_object_utils_esm/* removeEmptyValues */.ks)(q);
};

var fetchProfileUpdate = function fetchProfileUpdate(_ref) {
  var platform = _ref.platform,
      data = _ref.data;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).UPDATE_PROFILE, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    body: generateProfileUpdateQuery(data),
    credentials: 'omit'
  }).post();
};

function growth_auth_helpers_esm_extends() {
  growth_auth_helpers_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_auth_helpers_esm_extends.apply(this, arguments);
}

var fetchUpdateProfilePic = function fetchUpdateProfilePic(_ref) {
  var platform = _ref.platform,
      file = _ref.file;
  var formData = new FormData();
  formData.append('file', file);
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).UPDATE_PROFILE_PIC, {
    headers: growth_auth_helpers_esm_extends({}, growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    })),
    body: formData,
    credentials: 'omit'
  }).post();
};

var fetchSendOTP = function fetchSendOTP(_ref) {
  var platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      loginType = _ref.loginType;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).MOBILE_DETAILS, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: mobileNumber,
      countryCode: '91',
      channel: [loginType],
      appHashKey: platform === 'mweb' ? "@" + (0,growth_ssr_utils_esm/* getBaseHostName */.l_)() + " #" : ''
    },
    credentials: 'omit'
  }).post();
};

var fetchCreateUser = function fetchCreateUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      transactionId = _ref.transactionId,
      mobileNumber = _ref.mobileNumber,
      fullName = _ref.fullName,
      email = _ref.email,
      countryCode = _ref.countryCode;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).CREATE_NEW_USER + "?guest=false&trxId=" + transactionId, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: generateUserCreateQuery({
      mobileNumber: mobileNumber,
      fullName: fullName,
      email: email,
      countryCode: countryCode
    })
  }).post();
};

var fetchLoginUser = function fetchLoginUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      passwordType = _ref.passwordType,
      password = _ref.password;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).LOGIN, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      mobileNumber: mobileNumber,
      countryCode: '91',
      password: password,
      type: 'MOBILE',
      passwordType: passwordType,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchSignupViaOTP = function fetchSignupViaOTP(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? 91 : _ref$countryCode,
      password = _ref.password;

  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).SIGN_UP, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      mobileNumber: mobileNumber,
      countryCode: countryCode,
      type: '6',
      token: password
    }
  }).post();
};

var fetchLogoutUser = function fetchLogoutUser(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).LOGOUT, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  })["delete"]().then(function (res) {
    if (res != null && res.success) {
      clearUserTokens();
    }

    return res;
  })["catch"](function (e) {
    return e;
  });
};

var fetchSendDeleteOTP = function fetchSendDeleteOTP(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).DELETE_OTP, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '16',
      channel: ['MOBILE']
    },
    credentials: 'omit'
  }).post();
};

var TRUECALLER_DEEPLINK_DATA = {
  partnerKey: 'YDO2j919392e8b6fa4a059b697fd280503e67',
  partnerName: 'Goibibo',
  lang: 'en',
  privacyUrl: 'https://www.goibibo.com/info/privacy-policy/',
  termsUrl: 'https://www.goibibo.com/info/user-agreement/',
  loginPrefix: 'getstarted',
  loginSuffix: 'signin',
  btnShape: 'rect',
  skipOption: 'manualdetails',
  ctaPrefix: 'use',
  ctaColor: '%23ff6d38',
  ctaTextColor: '%23ffffff',
  PollingDefaultTimeout: 1000,
  PollingIntervalTimeout: {
    "default": 1000,
    stage1: 1500,
    stage2: 2500
  },
  PollingTimeoutCountSessionKey: 'truecaller_timer_count',
  PollingThreshold: 25,
  pollingHitStage: {
    stage1: 8,
    stage2: 15
  },
  PollingState: {
    pending: 'PROCESSING',
    complete: 'SUCCESS',
    skipped: 'TRUE_CALLER_LOGIN_SKIPPED',
    error: 'error'
  }
};
var getTruecallerDeepLink = function getTruecallerDeepLink(reqId, deepLinkData) {
  return "truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=" + reqId + "&partnerKey=" + deepLinkData.partnerKey + "&partnerName=" + deepLinkData.partnerName + "&lang=" + deepLinkData.lang + "&skipOption=" + deepLinkData.skipOption + "&btnShape=" + deepLinkData.btnShape + "&loginPrefix=" + deepLinkData.loginPrefix + "&loginSuffix=" + deepLinkData.loginSuffix + "&ctaPrefix=" + deepLinkData.ctaPrefix + "&ctaColor=" + deepLinkData.ctaColor + "&ctaTextColor=" + deepLinkData.ctaTextColor + "&privacyUrl=" + deepLinkData.privacyUrl + "&termsUrl=" + deepLinkData.termsUrl;
};

var INVALID_AUTH_TOKEN_CODE = 5405;
var EXISTING_USER_STATUS_CODE = 4200;
var NEW_USER_STATUS_CODE = 4404;
var INVALID_OTP_CODE = 403;

var fetchTruecallerLogin = function fetchTruecallerLogin(opts) {
  var platform = opts.platform,
      requestId = opts.requestId;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + getApiUrls(platform).SOCIAL_LOGIN, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      accType: 'TRUE_CALLER',
      requestId: requestId,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchVerifyEmail = function fetchVerifyEmail(_ref) {
  var platform = _ref.platform,
      token = _ref.token;
  return fetchRequest(getApiUrls(platform).VERIFY_EMAIL, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '2',
      token: token
    },
    credentials: 'omit'
  }).post();
};

var fetchRequestEmailVerification = function fetchRequestEmailVerification(_ref) {
  var platform = _ref.platform,
      email = _ref.email;
  return fetchRequest(getApiUrls(platform).GET_EMAIL_TOKEN, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: email,
      type: '2',
      channel: ['EMAIL']
    },
    credentials: 'omit'
  }).post();
};

var fetchLoginJwtToken = function fetchLoginJwtToken(_ref) {
  var platform = _ref.platform,
      client = _ref.client;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)(getApiUrls(platform).JWT_TOKEN, {
    headers: growth_auth_helpers_esm_getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      client: client
    }
  }).post();
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun$7 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, extendedUser, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchProfileUpdate({
              platform: platform,
              data: data
            });

          case 3:
            res = _context.sent;
            _context.next = 6;
            return (0,growth_dom_utils_esm/* promiseDelay */.Ob)(1000);

          case 6:
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            value = extendedUser;
            return _context.abrupt("return", value);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileUpdateStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$7.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess,
        onError: opts == null ? void 0 : opts.onError
      });
    }
  });
});

var fetchFun$6 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _userImages$;

    var platform, res, _ref3, extendedUser, personalDetails, miscFields, userImages, uuid, profileId, profileType, profileCompletionDetails, loginInfoList, addressDetails, _ref4, gender, name, firstName, lastName, middleName, _ref5, _ref5$altEmailId, altEmailId, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform;
            _context.next = 3;
            return fetchProfileDetails({
              platform: platform
            });

          case 3:
            res = _context.sent;
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            personalDetails = extendedUser.personalDetails, miscFields = extendedUser.miscFields, userImages = extendedUser.userImages, uuid = extendedUser.uuid, profileId = extendedUser.profileId, profileType = extendedUser.profileType, profileCompletionDetails = extendedUser.profileCompletionDetails, loginInfoList = extendedUser.loginInfoList, addressDetails = extendedUser.addressDetails;
            _ref4 = personalDetails || {}, gender = _ref4.gender, name = _ref4.name;
            firstName = name.firstName, lastName = name.lastName, middleName = name.middleName;
            _ref5 = miscFields || {}, _ref5$altEmailId = _ref5.altEmailId, altEmailId = _ref5$altEmailId === void 0 ? '' : _ref5$altEmailId;
            value = {
              firstName: !firstName && !middleName && !lastName ? 'TRAVELLER' : firstName,
              middleName: middleName,
              lastName: lastName,
              mobileNumber: '',
              mobileVerified: '',
              email: '',
              emailVerified: '',
              gender: gender,

              /* API gives epoc -> convert it to yyyy-mm-dd */
              dob: personalDetails.dateOfBirth ? (0,growth_date_utils_esm/* epocToDate */.Ow)(personalDetails.dateOfBirth) : undefined,
              profileImage: userImages == null ? void 0 : (_userImages$ = userImages[0]) == null ? void 0 : _userImages$.fileUrl,
              uuid: uuid,
              profileId: profileId,
              profileType: profileType,
              countryCode: '',
              isLoggedIn: !!uuid,
              profileCompletionDetails: (profileCompletionDetails == null ? void 0 : profileCompletionDetails[0]) || {},
              addressDetails: addressDetails
            };
            loginInfoList.forEach(function (item) {
              if ((item == null ? void 0 : item.loginType) === 'MOBILE') {
                var _item$countryCode;

                value.mobileVerified = item == null ? void 0 : item.verified;
                value.countryCode = item == null ? void 0 : item.countryCode;
                value.mobileNumber = item.loginId.slice(item == null ? void 0 : (_item$countryCode = item.countryCode) == null ? void 0 : _item$countryCode.length);
              }

              if (item.loginType === 'EMAIL') {
                value.emailVerified = item.verified;
                value.email = item.loginId;
              }
            });

            if (!value.email) {
              value.email = altEmailId;
            }

            return _context.abrupt("return", value);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$6.bind(null, opts),
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message,
            status: err == null ? void 0 : err.status
          });
        }
      });
    }
  });
});

var fetchFun$5 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, file, res, _ref3, data, success, message;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, file = _ref.file;
            _context.next = 3;
            return fetchUpdateProfilePic({
              platform: platform,
              file: file
            });

          case 3:
            res = _context.sent;
            _ref3 = res || {}, data = _ref3.data, success = _ref3.success, message = _ref3.message;

            if (success) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              error: true,
              errorMsg: message
            });

          case 7:
            return _context.abrupt("return", {
              error: false,
              uploadedImage: data
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useUploadProfileImageStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {
      uploadedImage: '',
      successMsg: '',
      error: false,
      errorMsg: ''
    },
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$5.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var loginWithMobileErrors = {
  typeErrorMsg: 'Alphabets and Special Characters are not allowed',
  notAValidMobileNumber: 'Please enter a valid mobile number',
  lengthErrorMsg: 'Please enter a 10 digit mobile number'
};
var MOBILE_NUMBER_REGEX = /^[6-9]\d{9}$/;
var MOBILE_NUMBER_MAX_LENGTH = 10;
var mobileValidation = function mobileValidation(phone) {
  if (phone) {
    if (Number.isNaN(Number(phone))) {
      return {
        valid: false,
        errorMsg: loginWithMobileErrors.typeErrorMsg
      };
    }

    if (typeof phone === 'string') {
      if (phone.length !== MOBILE_NUMBER_MAX_LENGTH) {
        return {
          valid: false,
          errorMsg: loginWithMobileErrors.lengthErrorMsg
        };
      }
    }

    if (MOBILE_NUMBER_REGEX.test(phone)) {
      return {
        valid: true,
        errorMsg: ''
      };
    }
  }

  return {
    valid: false,
    errorMsg: loginWithMobileErrors.notAValidMobileNumber
  };
};

var fetchFun$4 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchSendOTP(growth_auth_helpers_esm_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", growth_auth_helpers_esm_extends({}, res, {
              mobileNumber: data.mobileNumber
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var intialState = {
  validation: {
    isValidMobile: false,
    message: ''
  },
  error: {
    errorMsg: '',
    errorDetails: null
  }
};
var useSendOtpStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: growth_auth_helpers_esm_extends({}, intialState),
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$4.bind(null, opts),
        onSuccess: function onSuccess(res) {
          if (res.success) {
            if (opts.onSuccess) opts.onSuccess(res);
          } else {
            set(function (s) {
              return {
                error: true,
                data: growth_auth_helpers_esm_extends({}, s.data, {
                  error: {
                    errorMsg: res.message
                  }
                })
              };
            });
            if (opts.onError) opts.onError();
          }
        },
        onError: function onError(err) {
          set(function (s) {
            return {
              error: true,
              data: growth_auth_helpers_esm_extends({}, s.data, {
                error: {
                  errorMsg: 'Some error occurred, please try again.',
                  errorDetails: err
                }
              })
            };
          });
          if (opts.onError) opts.onError();
        }
      });
    },
    checkValid: function checkValid(mobileNumber) {
      var data = mobileValidation(mobileNumber);
      set({
        data: {
          validation: {
            isValidMobile: data.valid,
            message: data.errorMsg
          }
        }
      });
      return data.valid;
    }
  });
});

var clearSendOtpStore = function clearSendOtpStore() {
  return useSendOtpStore.setState({
    data: growth_auth_helpers_esm_extends({}, intialState),
    error: false
  });
};

var fetchFun$3 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _resData$profileLogin;

    var platform, data, res, _ref3, resData, code, message, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchLoginUser(growth_auth_helpers_esm_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, code = _ref3.code, message = _ref3.message;
            /* Error case */

            if (!code) {
              _context.next = 7;
              break;
            }

            throw {
              code: code,
              message: message
            };

          case 7:
            profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
            authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
            _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

            if (authToken && uuid) {
              setUserTokenAndUuid({
                authToken: authToken,
                uuid: uuid
              });
            }

            return _context.abrupt("return", res);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginUserStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$3.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun$2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _res$data, trxID;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchSignupViaOTP(growth_auth_helpers_esm_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;

            if (!res.success) {
              _context.next = 7;
              break;
            }

            trxID = (_res$data = res.data) == null ? void 0 : _res$data.trxId;
            return _context.abrupt("return", {
              transactionId: trxID
            });

          case 7:
            if (!res.code) {
              _context.next = 9;
              break;
            }

            throw growth_auth_helpers_esm_extends({}, res);

          case 9:
            return _context.abrupt("return", {});

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useSignupViaOTPStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$2.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res.trxID);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    },
    createUser: function createUser(opts) {
      return fetchCreateUser(opts);
    }
  });
});

var fetchFun$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, resData, message, _resData$profileLogin, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchTruecallerLogin(growth_auth_helpers_esm_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, _ref3.code, message = _ref3.message;

            if (message === 'SUCCESS') {
              profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
              authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
              _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

              if (authToken && uuid) {
                setUserTokenAndUuid({
                  authToken: authToken,
                  uuid: uuid
                });
              }
            }

            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useTruecallerLoginStore = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun$1.bind(null, opts),
        onSuccess: function onSuccess(details) {
          return opts == null ? void 0 : opts.onSuccess(details);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, client;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, client = _ref.client;
            return _context.abrupt("return", fetchLoginJwtToken({
              platform: platform,
              client: client
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginEncryptedJwtToken = (0,esm/* create */.Ue)(function (set) {
  return growth_auth_helpers_esm_extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun.bind(null, opts),
        onError: opts.onError,
        onSuccess: opts.onSuccess
      });
    }
  });
});

var EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

var isEmailValid = function isEmailValid(emailId) {
  if (emailId) return EMAIL_REGEX.test(emailId);
  return false;
};

var ALPHABET_REGEX = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/;

var isNameValid = function isNameValid(fullName) {
  if (fullName) return ALPHABET_REGEX.test(fullName);
  return false;
};

var NUMREGEX = /^[0-9]+$/;
var isNumberValid = function isNumberValid(num) {
  if (num) return NUMREGEX.test(num);
  return false;
};



// EXTERNAL MODULE: ../../node_modules/@growth/auth-utils/dist/growth-auth-utils.esm.js
var growth_auth_utils_esm = __webpack_require__(8132);
;// CONCATENATED MODULE: ../../node_modules/@growth/api-calls/dist/growth-api-calls.esm.js







var fetchAppOpenUrl = function fetchAppOpenUrl(opts) {
  var isLoggedIn = !!getAuthToken();
  var apiPayload = (opts == null ? void 0 : opts.apiPayload) || {};
  var vid = getVisitorIdBrowser();
  var payload = {
    /*
     * keep the timeout small for this api,
     */
    body: {
      type: '18',
      deepLink: {
        data: {
          deeplink_tag: apiPayload == null ? void 0 : apiPayload.tagid,
          deeplink_godata: _extends({}, apiPayload == null ? void 0 : apiPayload.godata, {
            login_req: (apiPayload == null ? void 0 : apiPayload.loginReq) || false,
            referral_flow: (apiPayload == null ? void 0 : apiPayload.referral_flow) || false
          }),
          traffic_source: (apiPayload == null ? void 0 : apiPayload.trafficSource) || undefined,
          '~campaign': apiPayload == null ? void 0 : apiPayload.campaign,
          web_vid: vid,
          '~feature': 'app'
        }
      }
    },
    credentials: 'omit',
    headers: getEssentialHeader({
      platform: 'mweb'
    })
  };
  var appBannerHost = getConfigValueFromEnv('appBannerUrl');
  var appBannerEndpoint = isLoggedIn ? endpoints.appBannerUrlLoggedIn : endpoints.appBannerUrlGuest;
  return fetchRequest("" + appBannerHost + appBannerEndpoint, payload).post();
};

var fetchPokusAssignVariantData = function fetchPokusAssignVariantData(opts) {
  var pokusOptions = opts.pokusOptions,
      _opts$extraHeader = opts.extraHeader,
      extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
      timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob || 'COMMON';

  var _generatePokusAssignV = generatePokusAssignVariantBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  }),
      request = _generatePokusAssignV.request;

  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {};
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusAssignVariant, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post().then(function (res) {
    var _res$perLobMap;

    return (_res$perLobMap = res.perLobMap) == null ? void 0 : _res$perLobMap[lobName].metadataValues;
  });
};

var fetchUserDetails = function fetchUserDetails(_ref) {
  var timeout = _ref.timeout;
  var host = getConfigValueFromEnv('goibibo');
  return fetchRequest("" + host + endpoints.userWidget, {
    timeout: timeout
  }).post();
};

var fetchRecommendEarnDetails = function fetchRecommendEarnDetails(details) {
  var recommendEarnUrl = getConfigValueFromEnv('recommendEarnUrl');
  var token = getAuthToken$1();
  var headers = {
    auth: token,
    os: details == null ? void 0 : details.flavour
  };
  return fetchRequest("" + recommendEarnUrl + endpoints.recommendEarnUrl, {
    headers: headers,
    body: {
      hotelId: details.hotelId,
      source: details.source
    },
    credentials: 'omit'
  }).post();
};

var fetchSkywalkerClientData = function fetchSkywalkerClientData(skywalkerOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }

  var endpointPath = skywalkerOptions.endpointPath,
      extraReqBody = skywalkerOptions.extraReqBody;
  var request = generateSkywalkerBodyRequest({
    extraReqBody: extraReqBody
  });
  var skywalkerUrl = getConfigValueFromEnv('skywalker');
  var headers = {
    brand: 'gi',
    deviceid: String
  };

  if (isUserTokenPresent()) {
    headers.auth = getAuthToken$1();
  }

  var dvid = getVisitorIdBrowser();

  if (dvid) {
    headers.deviceid = dvid;
  }

  return fetchRequest("" + skywalkerUrl + endpoints.skywalkerV1 + endpointPath, {
    body: request,
    credentials: 'omit',
    query: 'language=eng&currency=inr&region=in&brand=GI',
    headers: _extends({}, headers, extraHeaders)
  }).post();
};

var fetchAutoSuggetDailyStealDeal = function fetchAutoSuggetDailyStealDeal(userLocation) {
  var dsdVoyagerUrl = getConfigValueFromEnv('voyagerX');
  var userSelectedLocation = userLocation.userVal;
  return fetchRequest("" + dsdVoyagerUrl + endpoints.dsdVoyager, {
    credentials: 'omit',
    query: "search_query=" + userSelectedLocation + "&limit=10&include_t=[\"voy.city\"]"
  }).post();
};

var fetchPushRecentSearch = function fetchPushRecentSearch(searchCollection) {
  var url = getConfigValueFromEnv('recentSearchPush');
  var token = getAuthToken$1();
  var deviceid = getVisitorIdBrowser();
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };
  if (token) headers['oauth-goibibo'] = token;
  if (deviceid) headers.deviceid = deviceid;
  return fetchRequest("" + url + endpoints.recentSearchPush, {
    headers: headers,
    body: JSON.stringify(searchCollection),
    credentials: 'omit',
    extraOptions: {
      keepalive: true
    }
  }).post();
};

var fetchAppContext = function fetchAppContext(link) {
  var url = getConfigValueFromEnv('voyager') || prod.voyager;
  var raw = "url=" + (link || '');
  return fetchRequest("" + url + endpoints.appContext, {
    body: raw,
    credentials: 'omit'
  }).post();
};

var fetchGdprData = function fetchGdprData() {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.gdpr, {
    headers: headers,
    body: {
      org: 'GI',
      consent_id: 1,
      profile_type: 0,
      show_meta: true
    },
    credentials: 'omit'
  }).post();
};

var pushUserGdprData = function pushUserGdprData(gdpConsents) {
  var host = getConfigValueFromEnv('gdpr');
  var token = getAuthToken$1();
  var headers = {};
  if (token) headers.Authorization = JSON.stringify({
    type: 'auth',
    value: token
  });
  return fetchRequest("" + host + endpoints.userGdpr, {
    headers: headers,
    body: {
      org: 'GI',
      author: 'USER',
      consents: [_extends({
        status_active: true
      }, gdpConsents)]
    },
    credentials: 'omit'
  }).post();
};

var fetchUserGeoLocation = function fetchUserGeoLocation(_ref) {
  _ref.timeout;
  var host = getConfigValueFromEnv('userGeoLocation');
  return fetchRequest("" + host + endpoints.userGeoLocation, {
    body: "{ locationHierarchy(lat:,lng:) { country { id name centre } state { id name centre } city { id name centre postal_code } area { id name primary_area centre postal_code } } }",
    headers: {
      'Api-key': 'GROWTH-MMTGROWTH-71815232081313207181523208'
    }
  }).post();
};

var fetchConfigStoreData = function fetchConfigStoreData(opts) {
  var fetchOpts = opts.fetchOpts;
  var headers = fetchOpts.headers,
      timeout = fetchOpts.timeout;
  var host = index_9be0dea2_esm_getConfigValueFromEnv('configStore');
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + host + index_9be0dea2_esm_endpoints.configStore, {
    headers: pokus_dynamic_config_089f1c78_esm_extends({
      authorization: 'Tect685j8xMpLJF'
    }, headers),
    body: {
      isAbKey: opts.isAbKey,
      lobList: opts.lobList,
      cfgKeyList: opts.cfgKeyList
      /**
       * below three options helps on more granular query on bacnkend
       * these keys are not part of v1(present) api. Keep it commented
       * */
      // status: string,
      // submodule: string,
      // pgname: string,

    },
    credentials: 'omit',
    timeout: timeout
  }).post();
};

var fetchArgusFingerPrinting = function fetchArgusFingerPrinting(_ref) {
  var asyToken = _ref.asyToken,
      additionalData = _ref.additionalData;
  var url = getConfigValueFromEnv('argus');
  var token = getAuthToken();
  var headers = {
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
  if (token) headers['oauth-goibibo'] = token;
  fetchRequest("" + url + endpoints.argus, {
    headers: _extends({
      Authorization: 'P0s6jZGIkwMrnS2',
      'X-Request-Tracker': generateVid()
    }, headers),
    credentials: 'omit',
    body: {
      asyToken: asyToken,
      additionalData: additionalData
    }
  }).post();
};

var fetchRecentSearch = function fetchRecentSearch(_ref) {
  var lob = _ref.lob,
      strategy = _ref.strategy;
  var url = getConfigValueFromEnv('skywalker');
  return fetchRequest("" + url + endpoints.getRecentSearch + "?lob=" + lob + "&strategy=" + strategy, {
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'omit',
    body: JSON.stringify({
      user: {
        profile_type: 'PERSONAL',
        uuid: getUuidFromCookie(),
        device_id: getVisitorIdBrowser(),
        domain: {
          country: 'in',
          language: 'eng',
          currency: 'inr'
        }
      }
    })
  }).post();
};

var fetchLoyaltyUserInfo = function fetchLoyaltyUserInfo() {
  var url = index_9be0dea2_esm_getConfigValueFromEnv('loyaltyUserInfo');
  var token = (0,growth_auth_utils_esm/* getAuthToken */.bW)();
  var headers = {
    'Content-Type': 'application/json',
    authorization: '7NP82fpV0TsA9JrK',
    org: 'GI'
  };
  if (token) headers.auth = token;
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_9be0dea2_esm_endpoints.loyaltyUserInfo, {
    headers: headers,
    body: JSON.stringify({}),
    // empty data object is require for this endpoint
    credentials: 'omit'
  }).post();
};

var fetchGoCashBalance = function fetchGoCashBalance() {
  var url = index_9be0dea2_esm_getConfigValueFromEnv('gocashBalance');
  var headers = {
    'oauth-goibibo': (0,growth_auth_utils_esm/* getAuthToken */.bW)()
  };
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_9be0dea2_esm_endpoints.gocashBalance, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

/** List of all bookings */

var fetchBookingSummary = function fetchBookingSummary() {
  var url = index_9be0dea2_esm_getConfigValueFromEnv('bookingSummary');
  var headers = {
    auth: (0,growth_auth_utils_esm/* getAuthToken */.bW)()
  };
  return (0,growth_fetch_request_esm/* fetchRequest */.t)("" + url + index_9be0dea2_esm_endpoints.bookingSummary, {
    headers: headers,
    credentials: 'omit'
  }).get();
};

var fetchPokusImpressionAndHonourDetails = function fetchPokusImpressionAndHonourDetails(opts) {
  var _ref = opts || {},
      analyticsNode = _ref.analyticsNode;

  var host = getConfigValueFromEnv('pokus');
  return fetchRequest("" + host + endpoints.pokusImpressionAndHonour, {
    body: {
      analyticsNode: analyticsNode
    },
    credentials: 'omit'
  }).post();
};

var fetchPokusDynamicConfigs = function fetchPokusDynamicConfigs(opts) {
  var pokusOptions = opts.pokusOptions,
      _opts$extraHeader = opts.extraHeader,
      extraHeader = _opts$extraHeader === void 0 ? {} : _opts$extraHeader,
      timeout = opts.timeout;
  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob;
  var request = generatePokusDynamicConfigBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  });
  var pokusUrl = getConfigValueFromEnv('pokus');
  var authToken = pokusOptions.authToken || getAuthToken$1();
  var headers = {
    region: 'IN',
    language: 'EN'
  };
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusDynamicConfigs, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeader),
    timeout: timeout
  }).post();
};




/***/ }),

/***/ 1225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uH": function() { return /* binding */ defaultTheme; }
/* harmony export */ });
/* unused harmony exports breakPoints, buildTheme, colors, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = {
  fontWeight: 400
};
var fwMedium = {
  fontWeight: 500
};
var fwSemiBold = {
  fontWeight: 600
};
var fwBold = {
  fontWeight: 700
};
var fs32 = {
  fontSize: '32px'
};
var fs24 = {
  fontSize: '24px'
};
var fs18 = {
  fontSize: '18px'
};
var fs16 = {
  fontSize: '16px'
};
var fs14 = {
  fontSize: '14px'
};
var fs12 = {
  fontSize: '12px'
};
var lhAuto = {
  lineHeight: 'auto'
}; //  Font Headings

var xLarge = _extends({}, fwBold, fs32, lhAuto);

var Large = _extends({}, fwBold, fs24, lhAuto);

var Small = _extends({}, fwSemiBold, fs18, lhAuto);

var Base = _extends({}, fwSemiBold, fs16, lhAuto); // Font Labels


var LargeW1 = _extends({}, fwRegular, fs18, lhAuto);

var LargeW2 = _extends({}, fwMedium, fs18, lhAuto);

var LargeW3 = _extends({}, fwSemiBold, fs18, lhAuto);

var MediumW1 = _extends({}, fwRegular, fs16, lhAuto);

var MediumW2 = _extends({}, fwMedium, fs16, lhAuto);

var MediumW3 = _extends({}, fwSemiBold, fs16, lhAuto);

var BaseW1 = _extends({}, fwRegular, fs14, lhAuto);

var BaseW2 = _extends({}, fwMedium, fs14, lhAuto);

var BaseW3 = _extends({}, fwSemiBold, fs14, lhAuto);

var SmallW1 = _extends({}, fwRegular, fs12, lhAuto);

var SmallW2 = _extends({}, fwMedium, fs12, lhAuto);

var SmallW3 = _extends({}, fwSemiBold, fs12, lhAuto);

var giFontStandard = {
  xLarge: xLarge,
  Large: Large,
  Small: Small,
  Base: Base,
  LargeW1: LargeW1,
  LargeW2: LargeW2,
  LargeW3: LargeW3,
  MediumW1: MediumW1,
  MediumW2: MediumW2,
  MediumW3: MediumW3,
  BaseW1: BaseW1,
  BaseW2: BaseW2,
  BaseW3: BaseW3,
  SmallW1: SmallW1,
  SmallW2: SmallW2,
  SmallW3: SmallW3
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: _extends({}, giFontStandard)
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

var defaultSpacingThemeProperties = {
  unit: 1
};
function buildSpacing(spacingThemeProperties) {
  if (spacingThemeProperties === void 0) {
    spacingThemeProperties = defaultSpacingThemeProperties;
  }

  return {
    nospacing: 0,
    xxsmall: spacingThemeProperties.unit * 0.1 + "rem",
    // 1px | 0.1rem
    xsmall: spacingThemeProperties.unit * 0.2 + "rem",
    // 2px | 0.2rem
    small: spacingThemeProperties.unit * 0.5 + "rem",
    // 5px | 0.5rem
    base: spacingThemeProperties.unit + "rem",
    // 10px | 1rem
    large: spacingThemeProperties.unit * 1.5 + "rem",
    // 15px | 1.5rem
    xlarge: spacingThemeProperties.unit * 2 + "rem",
    // 20px | 2rem
    xxlarge: spacingThemeProperties.unit * 2.5 + "rem",
    // 25px | 2.5rem
    custom: function custom(multiplier // 3px 4px 6px 7px 8px | 0.3rem 0.4rem etc...
    ) {
      return spacingThemeProperties.unit * (multiplier * 0.1) + "rem";
    }
  };
}

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}




/***/ }),

/***/ 4653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ useTruecallerLoginStore; },
/* harmony export */   "H": function() { return /* binding */ clearUserTokens; },
/* harmony export */   "IR": function() { return /* binding */ useProfileUpdateStore; },
/* harmony export */   "Ju": function() { return /* binding */ isEmailValid; },
/* harmony export */   "Oz": function() { return /* binding */ useProfileStore; },
/* harmony export */   "P_": function() { return /* binding */ getUuidFromCookie; },
/* harmony export */   "Pz": function() { return /* binding */ isNameValid; },
/* harmony export */   "Tq": function() { return /* binding */ isUserTokenPresent; },
/* harmony export */   "W3": function() { return /* binding */ useSignupViaOTPStore; },
/* harmony export */   "Wp": function() { return /* binding */ INVALID_OTP_CODE; },
/* harmony export */   "XP": function() { return /* binding */ LOGIN_SUCCESS; },
/* harmony export */   "Xv": function() { return /* binding */ isNumberValid; },
/* harmony export */   "Y6": function() { return /* binding */ useSendOtpStore; },
/* harmony export */   "Zb": function() { return /* binding */ MOBILE_NUMBER_MAX_LENGTH; },
/* harmony export */   "dt": function() { return /* binding */ usePrefillLoginDetails; },
/* harmony export */   "eR": function() { return /* binding */ getTruecallerDeepLink; },
/* harmony export */   "gR": function() { return /* binding */ isMobileEncoded; },
/* harmony export */   "hM": function() { return /* binding */ fetchLogoutUser; },
/* harmony export */   "lq": function() { return /* binding */ useLoginUserStore; },
/* harmony export */   "ti": function() { return /* binding */ clearSendOtpStore; },
/* harmony export */   "tt": function() { return /* binding */ EXISTING_USER_STATUS_CODE; },
/* harmony export */   "vw": function() { return /* binding */ TRUECALLER_DEEPLINK_DATA; },
/* harmony export */   "zv": function() { return /* binding */ getEncryptedUuid; }
/* harmony export */ });
/* unused harmony exports ALPHABET_REGEX, BILLING_CATEGORY, EMAIL_REGEX, INVALID_AUTH_TOKEN_CODE, NEW_USER_STATUS_CODE, deleteSessionId, fetchCreateUser, fetchLoginJwtToken, fetchLoginUser, fetchMultipleLogins, fetchProfileDetails, fetchProfileUpdate, fetchRequestEmailVerification, fetchSendDeleteOTP, fetchSendOTP, fetchSignupViaOTP, fetchTruecallerLogin, fetchUpdateProfilePic, fetchVerifyEmail, getAuthToken, getEssentialHeader, logoutSpecificDevice, mobileValidation, profileViewQuery, setUserTokenAndUuid, useLoginEncryptedJwtToken, useUploadProfileImageStore */
/* harmony import */ var _growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6963);
/* harmony import */ var _growth_visitor_id_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6939);
/* harmony import */ var _growth_user_agents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6253);
/* harmony import */ var _growth_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2048);
/* harmony import */ var _growth_object_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7106);
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1917);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(624);
/* harmony import */ var _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6880);
/* harmony import */ var _growth_dom_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6871);
/* harmony import */ var _growth_date_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2830);











var HOST = "//userservice.goibibo.com";
var PATHS = {
  dweb: "ext/web/desktop",
  mweb: "ext/web/pwa"
};

var getApiUrls = function getApiUrls(p) {
  var config = {
    USER_DETAILS: HOST + "/" + PATHS[p] + "/user/details",
    LOGOUT: HOST + "/" + PATHS[p] + "/user/logout",
    MOBILE_DETAILS: HOST + "/" + PATHS[p] + "/send/token/OTP_IS_REG",
    LOGIN: HOST + "/" + PATHS[p] + "/login",
    SIGN_UP: HOST + "/" + PATHS[p] + "/verify/token/SIGNUP_OTP",
    CREATE_NEW_USER: HOST + "/" + PATHS[p] + "/user/create/false",
    UPDATE_PROFILE: HOST + "/" + PATHS[p] + "/user/update",
    GET_EMAIL_TOKEN: HOST + "/" + PATHS[p] + "/send/token/EMAIL",
    VERIFY_EMAIL: HOST + "/" + PATHS[p] + "/verify/token/EMAIL",
    UPDATE_PROFILE_PIC: HOST + "/" + PATHS[p] + "/user/upload/imageclass/displaypic",
    REDIRECT_TO_APP: HOST + "/" + PATHS[p] + "/UserService/send/token/LINK",
    DELETE_OTP: HOST + "/" + PATHS[p] + "/send/token/OTP_DELETE",
    SOCIAL_LOGIN: HOST + "/" + PATHS[p] + "/appSocialLogin",
    JWT_TOKEN: HOST + "/" + PATHS[p] + "/jwt/loginToken",
    LOGOUT_DEVICE: HOST + "/" + PATHS[p] + "/user/logout",
    MULTIPLE_LOGINS: HOST + "/" + PATHS[p] + "/user/activeSessions",
    PREFILL_DETAILS: HOST + "/" + PATHS[p] + "/prefill/login/details"
  };
  return config;
};

var GI_TOKEN_NAME = 'OAUTH-GOIBIBO';
var GA_TOKEN = 'gapauthtoken';
var GI_UUID = 'gitokenid';
var GI_SESSIONID = 'sessionid';

var clearUserTokens = function clearUserTokens() {
  (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .removeItem */ .cl)(GI_TOKEN_NAME, '/', 'goibibo.com');
  (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .removeItem */ .cl)(GA_TOKEN, '/', 'goibibo.com');
  (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .removeItem */ .cl)(GI_UUID, '/', 'goibibo.com');
};

var getAuthToken = function getAuthToken() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .getItem */ .rV)('OAUTH-GOIBIBO');
};

var isUserTokenPresent = function isUserTokenPresent() {
  var authToken = getAuthToken();
  return !!authToken;
};

var getEncryptedUuid = function getEncryptedUuid() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .getItem */ .rV)('gapauthtoken');
};

var getUuidFromCookie = function getUuidFromCookie() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .getItem */ .rV)('gitokenid');
};

var setUserTokenAndUuid = function setUserTokenAndUuid(_ref) {
  var _window;

  var authToken = _ref.authToken,
      uuid = _ref.uuid;
  (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .setItem */ .LS)(GI_TOKEN_NAME, authToken, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .setItem */ .LS)(GA_TOKEN, (_window = window) == null ? void 0 : _window.btoa(uuid), {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
  (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_2__/* .setItem */ .LS)(GI_UUID, uuid, {
    expires: 7776000,
    path: '/',
    domain: 'goibibo.com',
    secure: true
  });
};

var deleteSessionId = function deleteSessionId() {
  return removeItem(GI_SESSIONID, '/', 'goibibo.com');
};

var API_AUTH = {
  MWEB: 'h4nhc9jcgpAGIjp',
  DWEB: 'jkO7Ivpwsh4KaQ9',
  HCS: 'cmVzdDoxMjM0NTY='
};

var getUserIdentifierHeader = function getUserIdentifierHeader(_ref) {
  var _getBrowserDetails;

  var platform = _ref.platform;
  return JSON.stringify({
    type: 'auth',
    deviceId: (0,_growth_visitor_id_browser__WEBPACK_IMPORTED_MODULE_0__/* .getVisitorIdBrowser */ .MI)() || 'deviceId',
    os: platform === 'mweb' ? 'pwa' : 'desktop',
    osVersion: 'osVersion',
    appVersion: 'appVersion',
    imie: 'imie',
    ipAddress: 'ipAddress',
    timeZone: '+5.30 GMT',
    value: getAuthToken() || '',
    deviceOrBrowserInfo: ((_getBrowserDetails = (0,_growth_user_agents__WEBPACK_IMPORTED_MODULE_1__/* .getBrowserDetails */ .hf)()) == null ? void 0 : _getBrowserDetails.browserName) || ''
  });
};

var getEssentialHeader = function getEssentialHeader(_ref2) {
  var platform = _ref2.platform;
  return {
    Authorization: API_AUTH[platform.toUpperCase()],
    'User-Identifier': getUserIdentifierHeader({
      platform: platform
    }),
    'X-request-tracker': (0,_growth_visitor_id_browser__WEBPACK_IMPORTED_MODULE_0__/* .generateVid */ .im)(),
    region: 'in',
    currency: 'inr',
    language: 'eng'
  };
};

var profileViewQuery = {
  query: [[{
    name: 'extendedUser',
    keys: ['profileId', 'uuid', 'primaryEmailId', 'userType', 'profileType', 'loginInfoList', 'personalDetails']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'personalDetails',
    keys: ['gender', 'dateOfBirth']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'userImages',
    keys: ['fileUrl', 'imageClass'],
    filters: [{
      name: 'imageClass',
      type: 'string',
      value: 'displaypic'
    }]
  }], [{
    name: 'extendedUser'
  }, {
    name: 'profileCompletionDetails',
    keys: ['ctaDetails', 'completionScore', 'title', 'subText', 'component']
  }], [{
    name: 'loginInfoList',
    keys: ['loginId', 'loginType', 'primary', 'status', 'countryCode', 'verified']
  }], [{
    name: 'miscFields',
    keys: ['altEmailId']
  }], [{
    name: 'extendedUser'
  }, {
    name: 'addressDetails',
    keys: ['addressId', 'city', 'name', 'category', 'houseNo', 'street', 'state', 'country', 'postalCode', 'landMark', 'status', 'lastUpdated', 'address1']
  }]]
};
var BILLING_CATEGORY = 'BILLING';

var fetchProfileDetails = function fetchProfileDetails(_ref) {
  var platform = _ref.platform;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).USER_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: profileViewQuery,
    credentials: 'omit'
  }).post();
};

var generateProfileUpdateQuery = function generateProfileUpdateQuery(profileFields) {
  var firstName = profileFields.firstName,
      lastName = profileFields.lastName,
      dob = profileFields.dob,
      gender = profileFields.gender,
      email = profileFields.email,
      addressDetails = profileFields.addressDetails;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        personalDetails: {
          gender: gender,
          name: {
            firstName: firstName,
            lastName: lastName
          },
          dateOfBirth: dob
        },
        miscFields: {
          altEmailId: email
        },
        addressDetails: addressDetails
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_6__/* .removeEmptyValues */ .ks)(q);
};

var generateUserCreateQuery = function generateUserCreateQuery(fields) {
  var mobileNumber = fields.mobileNumber,
      fullName = fields.fullName,
      email = fields.email,
      _fields$countryCode = fields.countryCode,
      countryCode = _fields$countryCode === void 0 ? '91' : _fields$countryCode;
  var q = {
    query: [[{
      name: 'extendedUser',
      values: {
        profileType: 'PERSONAL',
        personalDetails: {
          name: {
            firstName: fullName
          }
        },
        miscFields: {
          altEmailId: email
        },
        loginInfoList: [{
          loginId: mobileNumber,
          countryCode: countryCode,
          loginType: 'MOBILE'
        }]
      }
    }]]
  };
  /* remove all empty keys from query */

  return (0,_growth_object_utils__WEBPACK_IMPORTED_MODULE_6__/* .removeEmptyValues */ .ks)(q);
};

var fetchProfileUpdate = function fetchProfileUpdate(_ref) {
  var platform = _ref.platform,
      data = _ref.data;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).UPDATE_PROFILE, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: generateProfileUpdateQuery(data),
    credentials: 'omit'
  }).post();
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var fetchUpdateProfilePic = function fetchUpdateProfilePic(_ref) {
  var platform = _ref.platform,
      file = _ref.file;
  var formData = new FormData();
  formData.append('file', file);
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).UPDATE_PROFILE_PIC, {
    headers: _extends({}, getEssentialHeader({
      platform: platform
    })),
    body: formData,
    credentials: 'omit'
  }).post();
};

var fetchSendOTP = function fetchSendOTP(_ref) {
  var platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      loginType = _ref.loginType,
      isEncoded = _ref.isEncoded;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).MOBILE_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: mobileNumber,
      countryCode: '91',
      channel: [loginType],
      type: 6,
      isEncoded: isEncoded,
      appHashKey: platform === 'mweb' ? "@" + (0,_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_3__/* .getBaseHostName */ .l_)() + " #" : ''
    },
    credentials: 'include'
  }).post();
};

var fetchCreateUser = function fetchCreateUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      transactionId = _ref.transactionId,
      mobileNumber = _ref.mobileNumber,
      fullName = _ref.fullName,
      email = _ref.email,
      countryCode = _ref.countryCode;

  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).CREATE_NEW_USER + "?guest=false&trxId=" + transactionId, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: generateUserCreateQuery({
      mobileNumber: mobileNumber,
      fullName: fullName,
      email: email,
      countryCode: countryCode
    })
  }).post();
};

var fetchLoginUser = function fetchLoginUser(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      passwordType = _ref.passwordType,
      password = _ref.password,
      isEncoded = _ref.isEncoded,
      encodedLoginId = _ref.encodedLoginId;

  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).LOGIN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      mobileNumber: isEncoded ? encodedLoginId : mobileNumber,
      countryCode: '91',
      password: password,
      type: 'MOBILE',
      passwordType: passwordType,
      isEncoded: isEncoded,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchSignupViaOTP = function fetchSignupViaOTP(opts) {
  var _ref = opts || {},
      platform = _ref.platform,
      mobileNumber = _ref.mobileNumber,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? 91 : _ref$countryCode,
      password = _ref.password;

  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).SIGN_UP, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'include',
    body: {
      mobileNumber: mobileNumber,
      countryCode: countryCode,
      type: '6',
      token: password
    }
  }).post();
};

var fetchLogoutUser = function fetchLogoutUser(_ref) {
  var platform = _ref.platform;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).LOGOUT, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  })["delete"]().then(function (res) {
    if (res != null && res.success) {
      clearUserTokens();
    }

    return res;
  })["catch"](function (e) {
    return e;
  });
};

var fetchSendDeleteOTP = function fetchSendDeleteOTP(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).DELETE_OTP, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '16',
      channel: ['MOBILE']
    },
    credentials: 'include'
  }).post();
};

var TRUECALLER_DEEPLINK_DATA = {
  partnerKey: 'YDO2j919392e8b6fa4a059b697fd280503e67',
  partnerName: 'Goibibo',
  lang: 'en',
  privacyUrl: 'https://www.goibibo.com/info/privacy-policy/',
  termsUrl: 'https://www.goibibo.com/info/user-agreement/',
  loginPrefix: 'getstarted',
  loginSuffix: 'signin',
  btnShape: 'rect',
  skipOption: 'manualdetails',
  ctaPrefix: 'use',
  ctaColor: '%23ff6d38',
  ctaTextColor: '%23ffffff',
  PollingDefaultTimeout: 1000,
  PollingIntervalTimeout: {
    "default": 1000,
    stage1: 1500,
    stage2: 2500
  },
  PollingTimeoutCountSessionKey: 'truecaller_timer_count',
  PollingThreshold: 25,
  pollingHitStage: {
    stage1: 8,
    stage2: 15
  },
  skipCtaTruecallerActivate: 5,
  PollingState: {
    pending: 'PROCESSING',
    complete: 'SUCCESS',
    skipped: 'TRUE_CALLER_LOGIN_SKIPPED',
    error: 'error'
  }
};
var getTruecallerDeepLink = function getTruecallerDeepLink(reqId, deepLinkData) {
  return "truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=" + reqId + "&partnerKey=" + deepLinkData.partnerKey + "&partnerName=" + deepLinkData.partnerName + "&lang=" + deepLinkData.lang + "&skipOption=" + deepLinkData.skipOption + "&btnShape=" + deepLinkData.btnShape + "&loginPrefix=" + deepLinkData.loginPrefix + "&loginSuffix=" + deepLinkData.loginSuffix + "&ctaPrefix=" + deepLinkData.ctaPrefix + "&ctaColor=" + deepLinkData.ctaColor + "&ctaTextColor=" + deepLinkData.ctaTextColor + "&privacyUrl=" + deepLinkData.privacyUrl + "&termsUrl=" + deepLinkData.termsUrl;
};

var INVALID_AUTH_TOKEN_CODE = 5405;
var EXISTING_USER_STATUS_CODE = 4200;
var NEW_USER_STATUS_CODE = 4404;
var INVALID_OTP_CODE = 403;

// used on mweb and dweb both for login success event
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';

var fetchTruecallerLogin = function fetchTruecallerLogin(opts) {
  var platform = opts.platform,
      requestId = opts.requestId;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)("" + getApiUrls(platform).SOCIAL_LOGIN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      accType: 'TRUE_CALLER',
      requestId: requestId,
      query: profileViewQuery.query
    }
  }).post();
};

var fetchVerifyEmail = function fetchVerifyEmail(_ref) {
  var platform = _ref.platform,
      token = _ref.token;
  return fetchRequest(getApiUrls(platform).VERIFY_EMAIL, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      type: '2',
      token: token
    },
    credentials: 'omit'
  }).post();
};

var fetchRequestEmailVerification = function fetchRequestEmailVerification(_ref) {
  var platform = _ref.platform,
      email = _ref.email;
  return fetchRequest(getApiUrls(platform).GET_EMAIL_TOKEN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      loginId: email,
      type: '2',
      channel: ['EMAIL']
    },
    credentials: 'omit'
  }).post();
};

var fetchLoginJwtToken = function fetchLoginJwtToken(_ref) {
  var platform = _ref.platform,
      client = _ref.client;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).JWT_TOKEN, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    body: {
      client: client
    }
  }).post();
};

var fetchMultipleLogins = function fetchMultipleLogins(_ref) {
  var platform = _ref.platform;
  return fetchRequest(getApiUrls(platform).MULTIPLE_LOGINS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit'
  }).post();
};

var logoutSpecificDevice = function logoutSpecificDevice(_ref) {
  var platform = _ref.platform,
      id = _ref.id;
  return fetchRequest(getApiUrls(platform).LOGOUT_DEVICE, {
    headers: getEssentialHeader({
      platform: platform
    }),
    credentials: 'omit',
    query: "id=" + id
  })["delete"]();
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun$7 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, extendedUser, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchProfileUpdate({
              platform: platform,
              data: data
            });

          case 3:
            res = _context.sent;
            _context.next = 6;
            return (0,_growth_dom_utils__WEBPACK_IMPORTED_MODULE_7__/* .promiseDelay */ .Ob)(1000);

          case 6:
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            value = extendedUser;
            return _context.abrupt("return", value);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileUpdateStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$7.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess,
        onError: opts == null ? void 0 : opts.onError
      });
    }
  });
});

var fetchFun$6 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _userImages$;

    var platform, res, _ref3, extendedUser, personalDetails, miscFields, userImages, uuid, profileId, profileType, profileCompletionDetails, loginInfoList, addressDetails, _ref4, gender, name, firstName, lastName, middleName, _ref5, _ref5$altEmailId, altEmailId, value;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform;
            _context.next = 3;
            return fetchProfileDetails({
              platform: platform
            });

          case 3:
            res = _context.sent;
            _ref3 = (res == null ? void 0 : res.result) || {}, extendedUser = _ref3.extendedUser;
            personalDetails = extendedUser.personalDetails, miscFields = extendedUser.miscFields, userImages = extendedUser.userImages, uuid = extendedUser.uuid, profileId = extendedUser.profileId, profileType = extendedUser.profileType, profileCompletionDetails = extendedUser.profileCompletionDetails, loginInfoList = extendedUser.loginInfoList, addressDetails = extendedUser.addressDetails;
            _ref4 = personalDetails || {}, gender = _ref4.gender, name = _ref4.name;
            firstName = name.firstName, lastName = name.lastName, middleName = name.middleName;
            _ref5 = miscFields || {}, _ref5$altEmailId = _ref5.altEmailId, altEmailId = _ref5$altEmailId === void 0 ? '' : _ref5$altEmailId;
            value = {
              firstName: !firstName && !middleName && !lastName ? 'TRAVELLER' : firstName,
              middleName: middleName,
              lastName: lastName,
              mobileNumber: '',
              mobileVerified: '',
              email: '',
              emailVerified: '',
              gender: gender,

              /* API gives epoc -> convert it to yyyy-mm-dd */
              dob: personalDetails.dateOfBirth ? (0,_growth_date_utils__WEBPACK_IMPORTED_MODULE_9__/* .epocToDate */ .Ow)(personalDetails.dateOfBirth) : undefined,
              profileImage: userImages == null ? void 0 : (_userImages$ = userImages[0]) == null ? void 0 : _userImages$.fileUrl,
              uuid: uuid,
              profileId: profileId,
              profileType: profileType,
              countryCode: '',
              isLoggedIn: !!uuid,
              profileCompletionDetails: (profileCompletionDetails == null ? void 0 : profileCompletionDetails[0]) || {},
              addressDetails: addressDetails
            };
            loginInfoList.forEach(function (item) {
              if ((item == null ? void 0 : item.loginType) === 'MOBILE') {
                var _item$countryCode;

                value.mobileVerified = item == null ? void 0 : item.verified;
                value.countryCode = item == null ? void 0 : item.countryCode;
                value.mobileNumber = item.loginId.slice(item == null ? void 0 : (_item$countryCode = item.countryCode) == null ? void 0 : _item$countryCode.length);
              }

              if (item.loginType === 'EMAIL') {
                value.emailVerified = item.verified;
                value.email = item.loginId;
              }
            });

            if (!value.email) {
              value.email = altEmailId;
            }

            return _context.abrupt("return", value);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useProfileStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)()(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$6.bind(null, opts),
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message,
            status: err == null ? void 0 : err.status
          });
        }
      });
    }
  });
});

var fetchFun$5 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, file, res, _ref3, data, success, message;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, file = _ref.file;
            _context.next = 3;
            return fetchUpdateProfilePic({
              platform: platform,
              file: file
            });

          case 3:
            res = _context.sent;
            _ref3 = res || {}, data = _ref3.data, success = _ref3.success, message = _ref3.message;

            if (success) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", {
              error: true,
              errorMsg: message
            });

          case 7:
            return _context.abrupt("return", {
              error: false,
              uploadedImage: data
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useUploadProfileImageStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: {
      uploadedImage: '',
      successMsg: '',
      error: false,
      errorMsg: ''
    },
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$5.bind(null, opts),
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var loginWithMobileErrors = {
  typeErrorMsg: 'Alphabets and Special Characters are not allowed',
  notAValidMobileNumber: 'Please enter a valid mobile number',
  lengthErrorMsg: 'Please enter a 10 digit mobile number'
};
var MOBILE_NUMBER_REGEX = /^[6-9]\d{9}$/;
var MOBILE_NUMBER_MAX_LENGTH = 10;
var mobileValidation = function mobileValidation(phone) {
  if (phone) {
    if (Number.isNaN(Number(phone))) {
      return {
        valid: false,
        errorMsg: loginWithMobileErrors.typeErrorMsg
      };
    }

    if (typeof phone === 'string') {
      if (phone.length !== MOBILE_NUMBER_MAX_LENGTH) {
        return {
          valid: false,
          errorMsg: loginWithMobileErrors.lengthErrorMsg
        };
      }
    }

    if (MOBILE_NUMBER_REGEX.test(phone)) {
      return {
        valid: true,
        errorMsg: ''
      };
    }
  }

  return {
    valid: false,
    errorMsg: loginWithMobileErrors.notAValidMobileNumber
  };
};
var isMobileEncoded = function isMobileEncoded(mobileNumber, encodedMobileNumber) {
  if (mobileNumber.includes('**') && encodedMobileNumber === mobileNumber) return true;
  return false;
};

var fetchFun$4 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchSendOTP(_extends({
              platform: platform
            }, data, {
              mobileNumber: data.isEncoded ? data.encodedLoginId : data.mobileNumber
            }));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", _extends({}, res, {
              mobileNumber: data.mobileNumber,
              isMobileNumberEncoded: data.isEncoded || false
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var intialState = {
  validation: {
    isValidMobile: false,
    message: ''
  },
  error: {
    errorMsg: '',
    errorDetails: null
  }
};
var useSendOtpStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: _extends({}, intialState),
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$4.bind(null, opts),
        onSuccess: function onSuccess(res) {
          if (res.success) {
            if (opts.onSuccess) opts.onSuccess(res);
          } else {
            set(function (s) {
              return {
                error: true,
                data: _extends({}, s.data, {
                  error: {
                    errorMsg: res.message
                  }
                })
              };
            });
            if (opts.onError) opts.onError();
          }
        },
        onError: function onError(err) {
          set(function (s) {
            return {
              error: true,
              data: _extends({}, s.data, {
                error: {
                  errorMsg: 'Some error occurred, please try again.',
                  errorDetails: err
                }
              })
            };
          });
          if (opts.onError) opts.onError();
        }
      });
    },
    checkValid: function checkValid(mobileNumber, isMobileNumberEncoded) {
      var validDetails = _extends({}, intialState.validation);

      if (isMobileNumberEncoded) {
        validDetails.isValidMobile = true;
      } else {
        var data = mobileValidation(mobileNumber);
        validDetails.isValidMobile = data.valid;
        validDetails.message = data.errorMsg;
      }

      set({
        data: {
          validation: validDetails
        }
      });
      return validDetails.isValidMobile;
    }
  });
});

var clearSendOtpStore = function clearSendOtpStore() {
  return useSendOtpStore.setState({
    data: _extends({}, intialState),
    error: false
  });
};

var fetchFun$3 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _resData$profileLogin;

    var platform, data, res, _ref3, resData, code, message, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchLoginUser(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, code = _ref3.code, message = _ref3.message;
            /* Error case */

            if (!code) {
              _context.next = 7;
              break;
            }

            throw {
              code: code,
              message: message
            };

          case 7:
            profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
            authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
            _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

            if (authToken && uuid) {
              setUserTokenAndUuid({
                authToken: authToken,
                uuid: uuid
              });
            }

            return _context.abrupt("return", res);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginUserStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$3.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun$2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _res$data, trxID;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data, _ref.onError;
            _context.next = 3;
            return fetchSignupViaOTP(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;

            if (!res.success) {
              _context.next = 7;
              break;
            }

            trxID = (_res$data = res.data) == null ? void 0 : _res$data.trxId;
            return _context.abrupt("return", {
              transactionId: trxID
            });

          case 7:
            if (!res.code) {
              _context.next = 9;
              break;
            }

            throw _extends({}, res);

          case 9:
            return _context.abrupt("return", {});

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useSignupViaOTPStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$2.bind(null, opts),
        onSuccess: function onSuccess(res) {
          return opts == null ? void 0 : opts.onSuccess(res.trxID);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    },
    createUser: function createUser(opts) {
      return fetchCreateUser(opts);
    }
  });
});

var fetchFun$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, data, res, _ref3, resData, message, _resData$profileLogin, profileDetails, authToken, _profileDetails$userD, userDetails, _ref4, uuid;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, data = _ref.data;
            _context.next = 3;
            return fetchTruecallerLogin(_extends({
              platform: platform
            }, data));

          case 3:
            res = _context.sent;
            _ref3 = res || {}, resData = _ref3.data, _ref3.code, message = _ref3.message;

            if (message === 'SUCCESS') {
              profileDetails = (resData == null ? void 0 : (_resData$profileLogin = resData.profileLoginResponse) == null ? void 0 : _resData$profileLogin[0]) || {};
              authToken = profileDetails.authToken, _profileDetails$userD = profileDetails.userDetails, userDetails = _profileDetails$userD === void 0 ? {} : _profileDetails$userD;
              _ref4 = userDetails.extendedUser || {}, uuid = _ref4.uuid;

              if (authToken && uuid) {
                setUserTokenAndUuid({
                  authToken: authToken,
                  uuid: uuid
                });
              }
            }

            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useTruecallerLoginStore = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun$1.bind(null, opts),
        onSuccess: function onSuccess(details) {
          return opts == null ? void 0 : opts.onSuccess(details);
        },
        onError: function onError(err) {
          var res = err == null ? void 0 : err.response;
          opts == null ? void 0 : opts.onError({
            code: res == null ? void 0 : res.code,
            message: res == null ? void 0 : res.message
          });
        }
      });
    }
  });
});

var fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, client;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, client = _ref.client;
            return _context.abrupt("return", fetchLoginJwtToken({
              platform: platform,
              client: client
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useLoginEncryptedJwtToken = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    data: {},
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: fetchFun.bind(null, opts),
        onError: opts.onError,
        onSuccess: opts.onSuccess
      });
    }
  });
});

var fetchPrefillLoginDetails = function fetchPrefillLoginDetails(_ref) {
  var platform = _ref.platform,
      controller = _ref.controller;
  return (0,_growth_fetch_request__WEBPACK_IMPORTED_MODULE_5__/* .fetchRequest */ .t)(getApiUrls(platform).PREFILL_DETAILS, {
    headers: getEssentialHeader({
      platform: platform
    }),
    body: {
      retryCount: 1
    },
    credentials: 'omit',
    controller: controller
  }).post();
};

var _fetchFun = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var platform, controller, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            platform = _ref.platform, controller = _ref.controller;
            _context.next = 3;
            return fetchPrefillLoginDetails({
              platform: platform,
              controller: controller
            });

          case 3:
            res = _context.sent;
            return _context.abrupt("return", {
              encodedMobileNumber: res == null ? void 0 : res.loginId,
              countryCode: res == null ? void 0 : res.countryCode,
              encLoginId: res == null ? void 0 : res.encLoginId
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var usePrefillLoginDetails = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)(function (set) {
  var controller = typeof AbortController === 'function' ? new AbortController() : undefined;
  return _extends({}, _growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_STATE */ .L, {
    controller: controller,
    userInputMobileNumber: null,
    fetch: function fetch(opts) {
      return (0,_growth_store_helpers__WEBPACK_IMPORTED_MODULE_4__/* .fetchSetter */ .x)({
        set: set,
        fetchFun: function fetchFun() {
          return _fetchFun(_extends({}, opts, {
            controller: controller
          }));
        }
      });
    },
    setUserInputMobileNumber: function setUserInputMobileNumber(mobileNumber) {
      return set({
        userInputMobileNumber: mobileNumber
      });
    }
  });
});

var EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

var isEmailValid = function isEmailValid(emailId) {
  if (emailId) return EMAIL_REGEX.test(emailId);
  return false;
};

var ALPHABET_REGEX = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/;

var isNameValid = function isNameValid(fullName) {
  if (fullName) return ALPHABET_REGEX.test(fullName);
  return false;
};

var NUMREGEX = /^[0-9]+$/;
var isNumberValid = function isNumberValid(num) {
  if (num) return NUMREGEX.test(num);
  return false;
};




/***/ }),

/***/ 8132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bW": function() { return /* binding */ getAuthToken; },
/* harmony export */   "zv": function() { return /* binding */ getEncryptedUuid; }
/* harmony export */ });
/* unused harmony exports doLogOut, isExistingUser, isUserTokenPresent */
/* harmony import */ var _growth_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2048);


function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var getAuthToken = function getAuthToken() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)('OAUTH-GOIBIBO');
}; // TODO: Make it isomorphic


var isUserTokenPresent = function isUserTokenPresent() {
  var authToken = getAuthToken();
  return !!authToken;
};
/**
	if existing user:
	response = { SSK : "RS01F" }

	if new user:
	response = { SSK : "RS02F" }
*/


var isExistingUser = function isExistingUser(k) {
  return k === "RS01F";
};

var doLogOut = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var endpointUrl, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpointUrl = '/logoutuser/';
            _context.prev = 1;
            _context.next = 4;
            return fetch("" + endpointUrl);

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw Error(response.statusText);

          case 7:
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Promise.reject(new Error('Unsuccessful attempt to logout.')));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));

  return function doLogOut() {
    return _ref.apply(this, arguments);
  };
}()));

var getEncryptedUuid = function getEncryptedUuid() {
  return (0,_growth_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)('gapauthtoken');
};




/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ docSessionStorage; },
/* harmony export */   "U": function() { return /* binding */ docLocalStorage; }
/* harmony export */ });
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


var BROWSER_STORAGE_TYPE = {
  LOCAL_STORAGE: _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK ? window.localStorage : '',
  SESSION_STORAGE: _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK ? window.sessionStorage : ''
};

var makeExpireTime = function makeExpireTime(sec) {
  if (sec === void 0) {
    sec = 0;
  }

  // take ttl in sec to keep the api same across all other cache utils
  var d = new Date();
  d.setSeconds(d.getSeconds() + sec);
  return d.getTime();
};

var isTimeExpired = function isTimeExpired(time) {
  return new Date().getTime() - time >= 0;
};

function storageAvailable(type) {
  var storage;

  try {
    storage = type;
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

var storage = function storage(backed) {
  return {
    setItem: function setItem(key, value, expiryTime) {
      if (!storageAvailable(backed)) return null;

      if (value === undefined) {
        backed.removeItem(key);
      } else {
        var storageValue = {
          value: value
        };

        if (expiryTime) {
          storageValue.timeStamp = makeExpireTime(expiryTime);
        }

        backed.setItem(key, JSON.stringify(storageValue));
      }

      return value;
    },
    getItem: function getItem(key) {
      if (!storageAvailable(backed)) return null;
      var value; // undefined

      var str = backed.getItem(key);

      if (str) {
        try {
          var _JSON$parse = JSON.parse(str),
              respValue = _JSON$parse.value,
              timeStamp = _JSON$parse.timeStamp;

          if (timeStamp && isTimeExpired(timeStamp)) {
            backed.removeItem(key);
          } else {
            value = respValue;
          }
        } catch (e) {
          // console.log(`Error parsing storage ['${ key }']`);
          backed.removeItem(key);
        }
      }

      return value;
    },
    removeItem: function removeItem(key) {
      if (!storageAvailable(backed)) return null;
      return backed.removeItem(key);
    }
  };
};

var getLocalStorage = function getLocalStorage() {
  return storage(BROWSER_STORAGE_TYPE.LOCAL_STORAGE);
};

var getSessionStorage = function getSessionStorage() {
  return storage(BROWSER_STORAGE_TYPE.SESSION_STORAGE);
};

var docLocalStorage = getLocalStorage();
var docSessionStorage = getSessionStorage();




/***/ }),

/***/ 4668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ao": function() { return /* binding */ createConfigStore; },
  "a_": function() { return /* binding */ setData; }
});

// UNUSED EXPORTS: getConfigStoreDataClient

// NAMESPACE OBJECT: ../../node_modules/@growth/browser-storage/indexDB/dist/growth-browser-storage-indexDB.esm.js
var growth_browser_storage_indexDB_esm_namespaceObject = {};
__webpack_require__.r(growth_browser_storage_indexDB_esm_namespaceObject);

// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
// EXTERNAL MODULE: ../../node_modules/@growth/api-calls/dist/growth-api-calls.esm.js + 4 modules
var growth_api_calls_esm = __webpack_require__(332);
;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/dist/xhr-d89d7e83.esm.js


function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var formatConfigResp = function formatConfigResp(configKeys) {
  var lobsKey = Object.keys(configKeys);
  var configs = lobsKey.reduce == null ? void 0 : lobsKey.reduce(function (acc, l) {
    var _configKeys$l$reduce, _configKeys$l;

    acc[l] = (_configKeys$l$reduce = (_configKeys$l = configKeys[l]).reduce) == null ? void 0 : _configKeys$l$reduce.call(_configKeys$l, function (kk, k) {
      var cloneKK = Object(kk);
      cloneKK[k.cfgKey] = k.value;
      return cloneKK;
    }, {});
    return acc;
  }, {});
  return configs;
};

var getConfigStoreData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, fetchOpts, initData, lobList, keyList, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lobs = opts.lobs, keys = opts.keys, fetchOpts = opts.fetchOpts, initData = opts.initData;
            /**
             * Return the initData if present, this helps to use the data passed in
             * SSR and avoid the api calls on client again.
             * */

            if (!initData) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.resolve(initData));

          case 3:
            lobList = typeof lobs === 'string' ? [lobs] : lobs;
            keyList = typeof keys === 'string' ? [keys] : keys;
            _context.next = 7;
            return (0,growth_api_calls_esm/* fetchConfigStoreData */.VE)({
              lobList: lobList,
              cfgKeyList: keyList,
              fetchOpts: {
                timeout: fetchOpts.timeout
              }
            });

          case 7:
            data = _context.sent;
            return _context.abrupt("return", formatConfigResp(data == null ? void 0 : data.configKeys));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getConfigStoreData(_x) {
    return _ref.apply(this, arguments);
  };
}();



// EXTERNAL MODULE: ../../node_modules/@growth/browser-storage/dist/growth-browser-storage.esm.js
var growth_browser_storage_esm = __webpack_require__(2927);
;// CONCATENATED MODULE: ../../node_modules/@growth/browser-storage/indexDB/dist/growth-browser-storage-indexDB.esm.js
/*
 https://dev.to/alexeagleson/how-to-use-indexeddb-to-store-data-for-your-web-application-in-the-browser-1o90#browsing-your-database
*/
var requestIndexDB = function requestIndexDB(name, ver) {
  if (!name || !ver) {
    throw new Error('name or ver argument is missing for requestIndexDB');
  }

  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  return new Promise(function (resolve, reject) {
    if (!indexedDB) {
      reject(new Error('IndexedDB could not be found in this browser.'));
    }

    var request = indexedDB.open(name, ver);
    resolve(request);
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/browser-caching/dist/growth-browser-caching.esm.js



function growth_browser_caching_esm_regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  growth_browser_caching_esm_regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function growth_browser_caching_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        growth_browser_caching_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var SESSION_STORE = 'sessionStorage';
var LOCAL_STORE = 'localStorage';
var INDEX_DB = 'indexDb';
var INDEX_DB_DETAILS = {
  objectName: 'with-cache',
  keyPath: 'id',
  dbName: 'grow-with-fetch-cache',
  dbVer: 1
};

var withBrowserStorageCaching = /*#__PURE__*/function () {
  var _ref = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee3(opts) {
    var key, asyncMethod, _opts$ttl, ttl, type, _opts$cacheResponseKe, cacheResponseKeys, ignoreCache, revalidate, getLocalStore, isLocalStore, getItem, setItem, cache, res, saveResp;

    return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            key = opts.key, asyncMethod = opts.asyncMethod, _opts$ttl = opts.ttl, ttl = _opts$ttl === void 0 ? 0 : _opts$ttl, type = opts.type, _opts$cacheResponseKe = opts.cacheResponseKeys, cacheResponseKeys = _opts$cacheResponseKe === void 0 ? [] : _opts$cacheResponseKe, ignoreCache = opts.ignoreCache, revalidate = opts.revalidate; // ignore the caching if ignoreCache is true

            if (!ignoreCache) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", asyncMethod());

          case 3:
            if (key) {
              _context3.next = 5;
              break;
            }

            throw new Error('withBrowserStorageCaching: For browser caching key name is mandatory');

          case 5:
            getLocalStore = function getLocalStore() {
              return type === SESSION_STORE ? growth_browser_storage_esm/* docSessionStorage */.F : growth_browser_storage_esm/* docLocalStorage */.U;
            };

            isLocalStore = function isLocalStore(_type) {
              return _type === LOCAL_STORE || _type === SESSION_STORE || _type === undefined;
            };

            getItem = /*#__PURE__*/function () {
              var _ref2 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee() {
                var store, value, dbName, dbVer, objectName, keyPath, record;
                return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!isLocalStore(opts.type)) {
                          _context.next = 4;
                          break;
                        }

                        store = getLocalStore();
                        value = store.getItem(key);
                        return _context.abrupt("return", value);

                      case 4:
                        if (!(opts.type === INDEX_DB)) {
                          _context.next = 10;
                          break;
                        }

                        dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                        _context.next = 8;
                        return (0,growth_browser_storage_indexDB_esm_namespaceObject.getAllObjects)({
                          dbName: dbName,
                          dbVer: dbVer,
                          objectName: objectName,
                          id: key,
                          keyPath: keyPath
                        });

                      case 8:
                        record = _context.sent;
                        return _context.abrupt("return", record);

                      case 10:
                        return _context.abrupt("return", undefined);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function getItem() {
                return _ref2.apply(this, arguments);
              };
            }();

            setItem = /*#__PURE__*/function () {
              var _ref3 = growth_browser_caching_esm_asyncToGenerator( /*#__PURE__*/growth_browser_caching_esm_regeneratorRuntime().mark(function _callee2(value) {
                var store, dbName, dbVer, objectName, keyPath, res;
                return growth_browser_caching_esm_regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!isLocalStore(type)) {
                          _context2.next = 3;
                          break;
                        }

                        store = getLocalStore();
                        return _context2.abrupt("return", store.setItem(key, value, ttl));

                      case 3:
                        if (!(opts.type === INDEX_DB)) {
                          _context2.next = 9;
                          break;
                        }

                        dbName = INDEX_DB_DETAILS.dbName, dbVer = INDEX_DB_DETAILS.dbVer, objectName = INDEX_DB_DETAILS.objectName, keyPath = INDEX_DB_DETAILS.keyPath;
                        _context2.next = 7;
                        return (0,growth_browser_storage_indexDB_esm_namespaceObject.addNewObject)({
                          dbName: dbName,
                          dbVer: dbVer,
                          objectName: objectName,
                          keyPath: keyPath,
                          id: key,
                          data: value
                        });

                      case 7:
                        res = _context2.sent;
                        return _context2.abrupt("return", res);

                      case 9:
                        return _context2.abrupt("return", undefined);

                      case 10:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function setItem(_x2) {
                return _ref3.apply(this, arguments);
              };
            }(); // return from cache if exist and revalidate is not true


            _context3.next = 11;
            return getItem();

          case 11:
            cache = _context3.sent;

            if (!(cache && !revalidate)) {
              _context3.next = 14;
              break;
            }

            return _context3.abrupt("return", cache);

          case 14:
            if (!(typeof asyncMethod === 'function')) {
              _context3.next = 20;
              break;
            }

            _context3.next = 17;
            return asyncMethod();

          case 17:
            res = _context3.sent;

            // keep only few keys in cache instead of whole response.
            if (typeof res === 'object' && cacheResponseKeys.length) {
              saveResp = {};
              cacheResponseKeys.forEach(function (item) {
                saveResp[item] = res == null ? void 0 : res[item];
              });
              setItem(saveResp);
            } else {
              setItem(res);
            }

            return _context3.abrupt("return", res);

          case 20:
            throw new Error('withBrowserStorageCaching: the second parameter should be async method');

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function withBrowserStorageCaching(_x) {
    return _ref.apply(this, arguments);
  };
}();



;// CONCATENATED MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js






function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var getConfigStoreDataClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, cacheOpts, fetchOpts, initData, cacheKey, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lobs = opts.lobs, keys = opts.keys, cacheOpts = opts.cacheOpts, fetchOpts = opts.fetchOpts, initData = opts.initData;

            cacheKey = function cacheKey() {
              // merge the lob and keys to make a cachekey
              var l = typeof lobs === 'string' ? [lobs] : lobs;
              var k = typeof keys === 'string' ? [keys] : keys;
              var ckey = l.join('-') + "-" + k.join('-');
              return ckey.toLowerCase();
            };

            _context.next = 4;
            return withBrowserStorageCaching({
              key: cacheKey(),
              asyncMethod: function asyncMethod() {
                return getConfigStoreData({
                  lobs: lobs,
                  keys: keys,
                  fetchOpts: {
                    timeout: (fetchOpts == null ? void 0 : fetchOpts.timeout) || 2000
                  },
                  initData: initData
                });
              },
              ttl: (cacheOpts == null ? void 0 : cacheOpts.ttl) || 15
              /* minutes */
              ,
              ignoreCache: cacheOpts == null ? void 0 : cacheOpts.ignoreCache,
              revalidate: cacheOpts == null ? void 0 : cacheOpts.revalidate,
              type: 'indexDb'
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getConfigStoreDataClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createConfigStore = function createConfigStore() {
  return (0,esm/* create */.Ue)()(function (set) {
    return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
      fetch: function fetch(opts) {
        return (0,growth_store_helpers_esm/* fetchSetter */.x)({
          set: set,
          fetchFun: function fetchFun() {
            return getConfigStoreDataClient({
              lobs: opts.lobs,
              keys: opts.keys,
              cacheOpts: opts == null ? void 0 : opts.cacheOpts,
              initData: opts == null ? void 0 : opts.initData
            });
          },
          onSuccess: opts == null ? void 0 : opts.onSuccess
        });
      }
    });
  });
};

var setData = function setData(store, value) {
  return store.setState(function (s) {
    return {
      data: _extends({}, s.data, value),
      loaded: true
    };
  });
};




/***/ }),

/***/ 2048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
/* unused harmony export keys */
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


/* eslint-disable no-useless-escape */

/**
 * This function well help to get, set, remove and itrate over
 * the cookies the cookies.
 * @methods
 *  getItem
 *  setItem
 *  removeItem
 *  hasItem
 *  keys
 */

var error = function error(x) {
  console.error(new TypeError("key is required for @growth/cookies " + x));
};

var getItem = function getItem(key) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return null;

  if (!key) {
    error('get');
    return null;
  }

  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" +
  /* eslint-disable-next-line no-useless-escape */
  encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + "\\s*\\=\\s*([^;]*).*$)|^.*$"), '$1')) || null;
};
/* eslint-disable-next-line max-params */


var setItem = function setItem(key, value, options) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return false;

  var _ref = options || {},
      expires = _ref.expires,
      path = _ref.path,
      domain = _ref.domain,
      secure = _ref.secure;

  if (!key) {
    error('set');
    return false;
  }

  var sMaxAge = expires ? "; max-age=" + expires : '';
  document.cookie = encodeURIComponent(key) + "=" + value + sMaxAge + (domain ? "; domain=" + domain : '') + (path ? "; path=" + path : '') + (secure ? '; secure' : '');
  return true;
};

var removeItem = function removeItem(key, path, domain) {
  if (!_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK) return false;

  if (!getItem(key)) {
    error('remove');
    return false;
  }

  document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : '') + (path ? "; path=" + path : '');
  return true;
};

var keys = function keys() {
  if (!isOnClient) return [];
  var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);

  for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx += 1) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
  }

  return aKeys;
};




/***/ }),

/***/ 3509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useHasMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * READ THIS! IF YOU ARE A REACT DEVELOPER YOU SHOULD
 *  https://joshwcomeau.com/react/the-perils-of-rehydration
 */

function useHasMounted() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      hasMounted = _useState[0],
      setHasMounted = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHasMounted(true);
  }, []);
  return hasMounted;
}




/***/ }),

/***/ 2830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ow": function() { return /* binding */ epocToDate; }
/* harmony export */ });
/* unused harmony exports dateToEPOC, getDateFormat, getYearsAgoDate, getYearsAgoDateFromNow, isDateExpired */
var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
      format = opts.format,
      _opts$seperator = opts.seperator,
      seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();

  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }

  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();

  switch (format) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;

    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;

    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;

    default:
      return year + seperator + month + seperator + day;
  }
};

var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};

var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};

var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }

  if (month === void 0) {
    month = 0;
  }

  if (day === void 0) {
    day = 1;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};

var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
      expire = _ref.expire;
  return now > expire;
};




/***/ }),

/***/ 3767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ headingSizes; },
/* harmony export */   "iH": function() { return /* binding */ textSizes; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports Box, Heading, breakPoints, buildTheme, colors, defaultTheme, font, misc, spacing, useTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

// https://html.mmt.com/htmls/projects/HTMLFrontendHub/baseProjects/TypeSystem/gi/index.html

/* NOTE: not using the @React_UI_Lib/GIFontStandard since it does not support the type script
 import Styles from '@React_UI_Lib/GIFontStandard';
*/
// Type - Family and Weight
var fwRegular = '400';
var fwMedium = '500';
var fwSemiBold = '600';
var fwBold = '700';
var fs32 = '32px';
var fs24 = '24px';
var fs22 = '22px';
var fs18 = '18px';
var fs16 = '16px';
var fs14 = '14px';
var fs12 = '12px';
var lhAuto = 'normal'; //  Lable

var textSizes = {
  LargeW1: {
    'font-weight': fwRegular,
    'font-size': fs18,
    'line-height': lhAuto
  },
  LargeW2: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwMedium
  },
  LargeW3: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwRegular
  },
  MediumW2: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwMedium
  },
  MediumW3: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  },
  BaseW1: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwRegular
  },
  BaseW2: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwMedium
  },
  BaseW3: {
    'line-height': lhAuto,
    'font-size': fs14,
    'font-weight': fwSemiBold
  },
  SmallW1: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwRegular
  },
  SmallW2: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwMedium
  },
  SmallW3: {
    'line-height': lhAuto,
    'font-size': fs12,
    'font-weight': fwSemiBold
  }
}; //  Lable

var headingSizes = {
  xLarge: {
    'font-weight': fwBold,
    'font-size': fs32,
    'line-height': lhAuto
  },
  Large: {
    'line-height': lhAuto,
    'font-size': fs24,
    'font-weight': fwBold
  },
  MediumW1: {
    'line-height': lhAuto,
    'font-size': fs22,
    'font-weight': fwSemiBold
  },
  Small: {
    'line-height': lhAuto,
    'font-size': fs18,
    'font-weight': fwSemiBold
  },
  Base: {
    'line-height': lhAuto,
    'font-size': fs16,
    'font-weight': fwSemiBold
  }
};

var fontFamilyGenerics = 'Avenir, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
var fontFamilyRubik = "Rubik, " + fontFamilyGenerics;
var defaultFontThemeProperties = {
  fontFamilyDefault: fontFamilyRubik,
  fontFamilyQuicksand: fontFamilyRubik,
  fontFamilyRoboto: fontFamilyRubik,
  fontFamilyHelvetica: fontFamilyRubik,
  token: {
    label: _extends({}, textSizes),
    heading: _extends({}, headingSizes)
  }
};

var buildFont = function buildFont(fontThemeProperties) {
  if (fontThemeProperties === void 0) {
    fontThemeProperties = defaultFontThemeProperties;
  }

  return _extends({}, fontThemeProperties);
};

// https://www.figma.com/file/pZZHuwNbapoBxoxGJFSyZJ/GI-Foundations?type=design&node-id=25-2&t=pZslRhH1ZwNtrFHa-0
var spacing$1 = {
  '0': 0,
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '56': '56px',
  '64': '64px'
};

var buildSpacing = function buildSpacing() {
  return spacing$1;
};

var defaultMiscThemeProperties = {
  borderRadius: {
    unit: 0.4,
    unitScale: 0.2
  },
  border: {
    unit: 0.1
  },
  breakpoints: {
    md: 60 + "rem" // 600px

  }
};
function buildMisc(miscThemeProperties) {
  if (miscThemeProperties === void 0) {
    miscThemeProperties = defaultMiscThemeProperties;
  }

  return {
    borderRadius: {
      base: miscThemeProperties.borderRadius.unit + "rem",
      // 4px | 0.4rem
      // 2px | 0.2rem
      small: miscThemeProperties.borderRadius.unit - miscThemeProperties.borderRadius.unitScale + "rem",
      // 6px | 0.6rem
      large: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale + "rem",
      // 8px | 0.8rem
      xlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 2 + "rem",
      // 10px | 1rem
      xxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 3 + "rem",
      // 12px | 1.2rem
      xxxlarge: miscThemeProperties.borderRadius.unit + miscThemeProperties.borderRadius.unitScale * 4 + "rem",
      round: '50%',
      // 15px | 1.5rem
      custom: function custom(multiplier // 15 - 15px, 20 - 20px
      ) {
        return multiplier * 0.1 + "rem";
      }
    },
    border: {
      base: miscThemeProperties.border.unit + "rem" // 1px

    },
    zIndex: {
      xxsmall: '2',
      xsmall: '3',
      small: '4',
      base: '5',
      large: '6',
      xlarge: '9',
      xxlarge: '99',
      xxxlarge: '999',
      maximum: '1999'
    }
  };
}

var colorPalette = {
  goBrandBlue: {
    base: '#2274E0',
    dark: '#1958B6',
    medium: '#D1E5FF',
    light: '#E8F3FF'
  },
  goBrandOrange: {
    base: '#FF6D38',
    dark: '#D95204',
    medium: '#EB6125',
    light: '#FFF1ED'
  },
  downriver: {
    base: '#141823',
    dark: '#46484d',
    medium: '#777777',
    light: '#C2C2C2'
  },
  goWhite: {
    base: '#FFFFFF',
    dark: 'rgba(255, 255, 255, .8)',
    medium: 'rgba(255, 255, 255, .5)',
    light: 'rgba(255, 255, 255, .2)'
  },
  ash: {
    base: '#647A97',
    dark: '#E1E7EE',
    medium: '#EFF3F8',
    light: '#F4F7FA'
  },
  goGreen: {
    base: '#18A160',
    dark: '#148730',
    medium: '#1ABA32',
    light: '#E9F6EA'
  },
  goTeal: {
    base: '#00a2ad',
    dark: '#008a93',
    medium: '#00B3C6',
    light: '#e1f6f6'
  },
  goYellow: {
    base: '#ffc24a',
    dark: '#FBAC43',
    medium: '#FFEA67',
    light: '#FFFDE9'
  },
  goPurple: {
    base: '#8f22e3',
    dark: '#7022D9',
    medium: '#9D3DE8',
    light: '#FBF1FF'
  },
  goRed: {
    base: '#FF3A5C',
    dark: '#E63148',
    medium: '#F83466',
    light: '#FFF5F7'
  },
  shadow: {
    light: 'rgba(0, 0, 0, 0.13)',
    base: 'rgba(0,0,0,0.25)',
    dark: 'rgba(0,0,0,0.5)'
  },
  black: {
    base: '#000'
  }
};
function buildColors() {
  return colorPalette;
}

function breakPoints$1() {
  return {
    mobileM: '37.5rem',
    mobileL: '42.5rem',
    tablet: '76.8rem',
    laptop: '102.4rem',
    laptopL: '144.0rem',
    desktop: '256.0rem'
  };
}

var font = buildFont();
var spacing = buildSpacing();
var misc = buildMisc();
var colors = buildColors();
var breakPoints = breakPoints$1();
function buildTheme() {
  return {
    font: font,
    spacing: spacing,
    misc: misc,
    colors: colors,
    breakPoints: breakPoints
  };
}
/**
 * always defaultTheme should get consumed all over
 * we might be introducing further customization in buildTheme step
 */

var defaultTheme = buildTheme();
/**
 * to check if theme exists on caller, else return defaultTheme
 */

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme || defaultTheme;
}

var Box = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(function (_ref) {
  var _ref$mr = _ref.mr,
      mr = _ref$mr === void 0 ? '' : _ref$mr,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? '' : _ref$mt,
      _ref$ml = _ref.ml,
      ml = _ref$ml === void 0 ? '' : _ref$ml,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? '' : _ref$mb,
      _ref$my = _ref.my,
      my = _ref$my === void 0 ? '' : _ref$my,
      _ref$mx = _ref.mx,
      mx = _ref$mx === void 0 ? '' : _ref$mx,
      _ref$pt = _ref.pt,
      pt = _ref$pt === void 0 ? '' : _ref$pt,
      _ref$pr = _ref.pr,
      pr = _ref$pr === void 0 ? '' : _ref$pr,
      _ref$pb = _ref.pb,
      pb = _ref$pb === void 0 ? '' : _ref$pb,
      _ref$pl = _ref.pl,
      pl = _ref$pl === void 0 ? '' : _ref$pl,
      _ref$py = _ref.py,
      py = _ref$py === void 0 ? '' : _ref$py,
      _ref$px = _ref.px,
      px = _ref$px === void 0 ? '' : _ref$px;
  return "\n\tmargin-right: " + (spacing$1[mr || mx] || '') + ";\n\tmargin-left: " + (spacing$1[ml || mx] || '') + ";\n\tmargin-top: " + (spacing$1[mt || my] || '') + ";\n\tmargin-bottom: " + (spacing$1[mb || my] || '') + ";\n\tpadding-right: " + (spacing$1[pr || px] || '') + ";\n\tpadding-left: " + (spacing$1[pl || px] || '') + ";\n\tpadding-top: " + (spacing$1[pt || py] || '') + ";\n\tpadding-bottom: " + (spacing$1[pb || py] || '') + ";\n";
});

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$1;
var Text = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p */ .ZP.p(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return textSizes[size || 'BaseW1'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});

var _templateObject;
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2 */ .ZP.h2(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return headingSizes[size || 'Large'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});




/***/ }),

/***/ 3377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DomEventEmitter; }
/* harmony export */ });
var DomEventEmitter = function () {
  return {
    on: function on(eventName, listener) {
      return document.addEventListener(eventName, listener);
    },
    off: function off(eventName, listener) {
      return document.removeEventListener(eventName, listener);
    },
    emit: function emit(eventName, opts) {
      var event = new CustomEvent(eventName, {
        detail: opts,
        cancelable: true
      });
      return document.dispatchEvent(event);
    }
  };
}();




/***/ }),

/***/ 6871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ob": function() { return /* binding */ promiseDelay; }
/* harmony export */ });
/* unused harmony exports addScript, isArrowDownKey, isArrowLeftKey, isArrowRightKey, isArrowUpKey, isEnterEvent */
var isEnterEvent = function isEnterEvent(event) {
  var keyCode = event.key;
  return keyCode === 'Enter';
};

var isArrowDownKey = function isArrowDownKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowDown';
};

var isArrowUpKey = function isArrowUpKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowUp';
};

var isArrowLeftKey = function isArrowLeftKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowLeft';
};

var isArrowRightKey = function isArrowRightKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowRight';
};

var addScript = function addScript(scriptURl, opts) {
  if (typeof window !== 'undefined') {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptURl;
    script.async = opts.async || false;
    script.onload = opts.onload || null;
    var position = document.querySelector(opts.position || 'body');

    if (position) {
      position.append(script);
    }
  }
};

// this method add delay in resolving the promise
var promiseDelay = function promiseDelay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};




/***/ }),

/***/ 6963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ fetchRequest; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function assertPath(path) {
  var type = typeof path;

  if (type !== 'string') {
    throw new TypeError("The path should be a string, instead received a " + type);
  }
}

var parseResponse = function parseResponse(res) {
  // If a body response exists, parse anx extract the possible properties
  var response = res.json();

  try {
    if (res.status >= 200 && res.status < 300) {
      return Promise.resolve(response);
    }

    if (res.status >= 400 && res.status < 599) {
      return response.then(function (data) {
        var errorResponse = {
          response: data,
          status: res.status,
          statusText: res.statusText
        };
        return Promise.reject(errorResponse);
      });
    }
  } catch (_unused) {
    return response.then(function (data) {
      var errorResponse = {
        response: data,
        status: res.status,
        statusText: res.statusText
      };
      return Promise.reject(errorResponse);
    });
  }

  return Promise.resolve(response);
  /* Add any custom logic related to how you want to handle the response
   *
   * In case success is false,
   * trigger a new expection to capture later on request call site
   */
  // throw new Error(JSON.stringify({response,status:res.status,statusText: res.statusText}));
  // Otherwise, simply resolve the received data
};

var fetchRequest = function fetchRequest(path, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$headers = _options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      _options$query = _options.query,
      query = _options$query === void 0 ? null : _options$query,
      _options$method = _options.method,
      method = _options$method === void 0 ? 'GET' : _options$method,
      _options$timeout = _options.timeout,
      timeout = _options$timeout === void 0 ? null : _options$timeout,
      _options$credentials = _options.credentials,
      credentials = _options$credentials === void 0 ? 'include' : _options$credentials,
      _options$extraOptions = _options.extraOptions,
      extraOptions = _options$extraOptions === void 0 ? {} : _options$extraOptions;
  var _options2 = options,
      body = _options2.body;
  assertPath(path);

  if (body && typeof body === 'object' && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers['content-type'] = 'application/json';
  }

  var genericHeaders = {};

  var reqOptions = _extends({
    method: method,
    headers: _extends({}, genericHeaders, headers),
    credentials: credentials
  }, extraOptions, {
    body: body
  });

  var queryString = '';

  if (query) {
    // Convert to encoded string and prepend with ?
    queryString = new URLSearchParams(query).toString();
    queryString = queryString && "?" + queryString;
  }

  var controller;
  var requestTimeout;

  if (timeout) {
    controller = new AbortController();
    requestTimeout = setTimeout(function () {
      return controller.abort();
    }, timeout);
  }

  function makeFetchRequest(requestMethod) {
    var config = _extends({}, reqOptions, {
      method: requestMethod
    });

    if (timeout && controller) {
      config.signal = controller.signal;
    }

    return fetch("" + path + queryString, config).then(function (res) {
      if (timeout && requestTimeout) {
        clearTimeout(requestTimeout);
      }

      return parseResponse(res);
    });
  }

  return {
    get: function get() {
      return makeFetchRequest('GET');
    },
    post: function post() {
      return makeFetchRequest('POST');
    },
    "delete": function _delete() {
      return makeFetchRequest('DELETE');
    }
  };
};




/***/ }),

/***/ 7644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CONFIG_KEY_DWEB_AUTH": function() { return /* binding */ CONFIG_KEY_DWEB_AUTH; },
  "default": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(2390);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../node_modules/@growth/app-theme/dist/growth-app-theme.esm.js
var growth_app_theme_esm = __webpack_require__(1225);
// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(2019);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-gtm/dist/growth-analytics-plugin-gtm.esm.js
var growth_analytics_plugin_gtm_esm = __webpack_require__(2775);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js + 3 modules
var growth_analytics_plugin_pdt_esm = __webpack_require__(2961);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js
var growth_analytics_plugin_adobe_esm = __webpack_require__(6401);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(2532);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js
var growth_auth_helpers_esm = __webpack_require__(4653);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(3377);
// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var growth_design_system_esm = __webpack_require__(3767);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(4607);
// EXTERNAL MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js + 1 modules
var growth_loader_esm = __webpack_require__(305);
// EXTERNAL MODULE: ../../node_modules/@growth/tooltip/dist/growth-tooltip.esm.js
var growth_tooltip_esm = __webpack_require__(7792);
;// CONCATENATED MODULE: ../../node_modules/fecha/lib/fecha.js
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function fecha_assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = fecha_assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = fecha_assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return fecha_assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var fecha_format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = fecha_assign(fecha_assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = fecha_assign(fecha_assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: fecha_format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ var lib_fecha = ((/* unused pure expression or super */ null && (fecha)));

//# sourceMappingURL=fecha.js.map

;// CONCATENATED MODULE: ../../node_modules/@growth/gi-dweb-auth/node_modules/@growth/date-utils/dist/growth-date-utils.esm.js


var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
      f = opts.format,
      _opts$seperator = opts.seperator,
      seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();

  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }

  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();

  switch (f) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;

    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;

    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;

    default:
      return year + seperator + month + seperator + day;
  }
};

var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};

var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};

var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }

  if (month === void 0) {
    month = 0;
  }

  if (day === void 0) {
    day = 1;
  }

  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};

var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
      expire = _ref.expire;
  return now > expire;
};

var formatDate = function formatDate(date, formatStr) {
  if (formatStr === void 0) {
    formatStr = "D MMM'YY dddd";
  }

  return format(date, formatStr);
};

var formatDateString = function formatDateString(date) {
  return date && formatDate(date).split(' ').slice(0, 2).join(' ');
};

var formatDayString = function formatDayString(date) {
  return date && formatDate(date).split(' ').slice(2).join('');
};

var addDays = function addDays(date, days) {
  var currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate;
};

var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};

var getTimeZone = function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};



// EXTERNAL MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 3 modules
var growth_config_store_browser_esm = __webpack_require__(4668);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@growth/toast/dist/growth-toast.esm.js





function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2;
var ToastWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\tleft: 50%;\n\tbottom: 70px;\n\tbackground-color: #2a2d31;\n\tcolor: #fff;\n\tmax-height: 80px;\n\ttext-align: center;\n\toverflow: auto;\n\tborder-radius: 8px;\n\ttransform: translateX(-50%);\n\tpadding: 10px 12px;\n\tanimation: slideUp 0.3s ease-in-out forwards;\n\tbox-shadow: 0px 4px 4px rgb(0 0 0 / 9%);\n\tz-index: 1040;\n\n\t@keyframes slideUp {\n\t\tfrom {\n\t\t\tbottom: -100px;\n\t\t\topacity: 0;\n\t\t}\n\n\t\tto {\n\t\t\tbottom: 80px;\n\t\t\topacity: 1;\n\t\t}\n\t}\n"])));
var ToastMessage = styled_components_browser_esm/* default.p */.ZP.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #fff;\n\ttext-align: center;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);

var Toast = function Toast(props) {
  var message = props.message,
      onClose = props.onClose,
      _props$style = props.style,
      style = _props$style === void 0 ? null : _props$style,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? 2500 : _props$autoHideDurati,
      close = props.close,
      children = props.children;
  (0,react.useEffect)(function () {
    var closeTimmer = setTimeout(function () {
      if (close) close(false);
      if (onClose) onClose();
    }, autoHideDuration);
    return function () {
      if (closeTimmer) clearTimeout(closeTimmer);
    };
  }, [autoHideDuration, close, onClose]);
  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/react.createElement(ToastWrapper, {
    style: style
  }, /*#__PURE__*/(0,react.isValidElement)(children) ? children : /*#__PURE__*/react.createElement(ToastMessage, null, message)), document.body);
};

Toast.defaultProps = {
  autoHideDuration: 2500,
  onClose: function onClose() {},
  children: undefined,
  style: undefined
};

var useToast = function useToast() {
  var _useState = useState({}),
      toastData = _useState[0],
      setShowToast = _useState[1];

  var closeToast = function closeToast() {
    setShowToast({
      show: false,
      message: '',
      close: closeToast
    });
  };

  var showToast = function showToast(_ref) {
    var message = _ref.message,
        autoHideDuration = _ref.autoHideDuration;
    setShowToast({
      show: true,
      message: message,
      autoHideDuration: autoHideDuration,
      close: closeToast
    });
  };

  var ToastComponent = function ToastComponent() {
    var _toastData$message = toastData.message,
        message = _toastData$message === void 0 ? '' : _toastData$message,
        show = toastData.show,
        autoHideDuration = toastData.autoHideDuration,
        close = toastData.close;
    return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Toast, {
      message: message,
      autoHideDuration: autoHideDuration,
      close: close
    }));
  };

  return {
    ToastComponent: ToastComponent,
    showToast: showToast
  };
};



;// CONCATENATED MODULE: ../../node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js




















var authWebEvents = ['HAPPY_AUTH_WEBA__UI_MOBILE_INPUT_CLICK', 'HAPPY_AUTH_WEBA__UI_CLICK_SEND_OTP', 'HAPPY_AUTH_WEBA__CLICK_SEND_OTP', 'HAPPY_AUTH_WEBA__CLICK_CLOSE_MODAL', 'HAPPY_AUTH_WEBA__CLICK_RESEND_OTP_SMS', 'HAPPY_AUTH_WEBA__CLICK_LOGIN_VIA_PASSWORD', 'HAPPY_AUTH_WEBA__CLICK_LOGIN_VIA_OTP', 'HAPPY_AUTH_WEBA__CLICK_MOBILE_CHANGE', 'HAPPY_AUTH_WEBA__UX_LOGIN_DIALOG_OPEN', 'HAPPY_AUTH_WEBA__UX_MOBILE_ERROR', 'HAPPY_AUTH_WEBA__UX_AUTH_COMP_RENDER', 'HAPPY_AUTH_WEBA__UX_LOGIN_SUCCESS'];
var desktopAuthEvents = new Set(authWebEvents);

var initGoogleAnalytics = function initGoogleAnalytics(_ref) {
  var gaInstance = _ref.gaInstance,
      lobName = _ref.lobName,
      debug = _ref.debug;
  gaInstance.initialize({
    plugin: (0,growth_analytics_plugin_gtm_esm/* default */.Z)(),
    globalProperties: {
      category: 'happy-header',
      device: 'desktop',
      lob: lobName
    },
    eventNames: desktopAuthEvents,
    debug: debug || false
  });
};

var initPdtAnalytics = function initPdtAnalytics(_ref) {
  var pdtInstance = _ref.pdtInstance,
      lobName = _ref.lobName,
      debug = _ref.debug;
  pdtInstance.initialize({
    plugin: (0,growth_analytics_plugin_pdt_esm/* default */.Z)({
      debug: false
    }),
    globalProperties: {
      eventProperties: {
        lob: lobName
      }
    },
    debug: debug || false
  });
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var initOmnitureAnalytics = function initOmnitureAnalytics(_ref) {
  var _window$adobeDataLaye, _window$adobeDataLaye2;

  var adobeInstance = _ref.adobeInstance,
      lobName = _ref.lobName,
      debug = _ref.debug;
  var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
  var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
  adobeInstance.initialize({
    plugin: (0,growth_analytics_plugin_adobe_esm/* default */.Z)({
      page: {
        pageInfo: _extends({}, pageInfo, {
          lob: lobName
        })
      },
      account: {
        accountInfo: _extends({}, accountInfo, {
          website: 'goibibo'
        })
      }
    }, debug || false),
    debug: debug || false
  });
};

var initAnalytics = function initAnalytics(_ref) {
  var lobName = _ref.lobName,
      debug = _ref.debug;
  var gaInstance = new growth_web_analytics_esm/* default */.Z();
  var pdtInstance = new growth_web_analytics_esm/* default */.Z();
  var adobeInstance = new growth_web_analytics_esm/* default */.Z();
  initGoogleAnalytics({
    gaInstance: gaInstance,
    lobName: lobName,
    debug: debug
  });
  initPdtAnalytics({
    pdtInstance: pdtInstance,
    lobName: lobName,
    debug: debug
  });
  initOmnitureAnalytics({
    adobeInstance: adobeInstance,
    lobName: lobName,
    debug: debug
  });
  return {
    gaInstance: gaInstance,
    pdtInstance: pdtInstance,
    adobeInstance: adobeInstance
  };
};

function growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$a;
var AuthContainer$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$a || (_templateObject$a = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])));

var _templateObject$9, _templateObject2$7;
var AuthVerificationFlowSection = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$9 || (_templateObject$9 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 400px;\n    height: ", ";\n    border-radius: 12px;\n    overflow: hidden;\n    flex-shrink: 0;\n    box-shadow: -5px 0 9px 0 rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    padding: 50px 50px 30px 50px;\n  position: relative;\n"])), function (props) {
  return props != null && props.height ? props.height : '456px';
});
var AuthVerificationFlowCloseIcon = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2$7 || (_templateObject2$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n"])));

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3, _templateObject7$1;
var MobileContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$8 || (_templateObject$8 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100%;\n\tposition: relative;\n"])));
var MobileHeading = styled_components_browser_esm/* default.h3 */.ZP.h3(_templateObject2$6 || (_templateObject2$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1);
var MobileInputWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$5 || (_templateObject3$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 56px;\n\tborder-radius: 4px;\n\tborder: solid 2px #016eff;\n\tposition: relative;\n\tdisplay: flex;\n\t", "\n\t.loginCont__input {\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\t", "\n\t\tcolor: #4f525a;\n\t\tpadding-left: 5px;\n\t\tborder-radius: 0 4px 4px 0;\n\t}\n\n\t.loginCont__code {\n\t\tbackground: #fff;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #c2c2c2;\n\t\tdisplay: inline-flex;\n\t\tpadding: 0 5px 0 20px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t.loginCont__label {\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: -11px;\n\t\tbackground-color: #fff;\n\t\tpadding: 3px 8px;\n\t\t", "\n\t\tcolor: #016eff;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])), function (props) {
  if (props.error) {
    return "\n    border-color: rgb(229, 52, 66);\n    .loginCont__label{\n    \tcolor: rgb(229, 52, 66) !important;\n    }\n   \n    ";
  }

  if (props.valid) {
    return "\n    border-color: #00962d;\n    .loginCont__label{\n    \tcolor: #00962d !important;\n    }\n   \n    ";
  }

  return null;
}, growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var LoginSubmitButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject4$5 || (_templateObject4$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", "\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var LoginTermsAndCondition = styled_components_browser_esm/* default.p */.ZP.p(_templateObject5$4 || (_templateObject5$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var InputMessageIcon = styled_components_browser_esm/* default.span */.ZP.span(_templateObject6$3 || (_templateObject6$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: 20px;\n\ttop: 17px;\n"])));
var MessageText = styled_components_browser_esm/* default.p */.ZP.p(_templateObject7$1 || (_templateObject7$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\n\t", "\n"])), function (props) {
  if (props.error) {
    return "color: rgb(229, 52, 66);\n\t\t\t margin-top: 10px;\n\t\t\t";
  }

  if (props.success) {
    return "\n            color: #00962d;\n            \n             margin-top: 10px;\n            ";
  }

  if (props.loading) {
    return "\n\t\t\t margin-top: 10px;\n\t\t\t ";
  }

  return '';
});

var LOGIN_WITH_MOBILE = {
  heading: 'Login/Signup',
  subHeading: '',
  submitButton: 'Continue',
  label: 'Enter your Mobile Number',
  termsPolicy: 'By proceeding, you agree to GoIbibo’s <a href="https://www.goibibo.com/info/privacy/" target="_blank">Privacy Policy</a>, <a href="https://www.goibibo.com/info/user-agreement/" target="_blank">User Agreement</a> and <a href="https://www.goibibo.com/info/terms-of-services/" target="_blank">Terms of Service</a>'
};

var InputWrapper = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      _ref$inputName = _ref.inputName,
      inputName = _ref$inputName === void 0 ? 'text' : _ref$inputName,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      maxlength = _ref.maxlength,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
      inputPrefix = _ref.inputPrefix,
      onChange = _ref.onChange,
      _ref$isError = _ref.isError,
      isError = _ref$isError === void 0 ? false : _ref$isError,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? false : _ref$isValid,
      inputClassName = _ref.inputClassName,
      placeholder = _ref.placeholder,
      inputVal = _ref.inputVal,
      _ref$inputDisabled = _ref.inputDisabled,
      inputDisabled = _ref$inputDisabled === void 0 ? false : _ref$inputDisabled,
      onInputClick = _ref.onInputClick;

  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) onChange(e);
  };

  return /*#__PURE__*/react.createElement(MobileInputWrapper, {
    error: isError,
    valid: isValid
  }, /*#__PURE__*/react.createElement("span", {
    className: "loginCont__label"
  }, label), inputPrefix && /*#__PURE__*/react.createElement("span", {
    className: "loginCont__code"
  }, inputPrefix), /*#__PURE__*/react.createElement("input", {
    ref: ref,
    className: inputClassName,
    onChange: onChangeHandler,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    onClick: onInputClick,
    autoFocus: autoFocus,
    placeholder: placeholder,
    value: inputVal,
    disabled: inputDisabled
  }), (isError || isValid) && /*#__PURE__*/react.createElement(InputMessageIcon, {
    className: "logSprite " + (isError ? 'icInfoPink' : 'icSuccessSmall')
  }));
});
InputWrapper.displayName = 'InputWrapper';

var MobileForm = function MobileForm(_ref) {
  var _data$validation, _data$validation2, _data$validation3, _data$validation4, _data$validation5, _data$validation6;

  var onFormSubmit = _ref.onFormSubmit,
      prefillMobileNumber = _ref.prefillMobileNumber,
      isMobileNumberDisabled = _ref.isMobileNumberDisabled,
      skipMobileScreen = _ref.skipMobileScreen;

  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state;
  }),
      fetch = _useSendOtpStore.fetch,
      data = _useSendOtpStore.data,
      checkValid = _useSendOtpStore.checkValid,
      loading = _useSendOtpStore.loading,
      error = _useSendOtpStore.error;

  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
    return {
      prefillData: s.data,
      prefillfetch: s.fetch,
      prefillDetailsloaded: s.loaded,
      prefillLoading: s.loading,
      prefillError: s.error,
      controller: s.controller,
      setUserInputMobileNumber: s.setUserInputMobileNumber,
      userInputMobileNumber: s.userInputMobileNumber
    };
  }, shallow/* shallow */.X),
      prefillData = _usePrefillLoginDetai.prefillData,
      prefillfetch = _usePrefillLoginDetai.prefillfetch,
      prefillDetailsloaded = _usePrefillLoginDetai.prefillDetailsloaded,
      prefillError = _usePrefillLoginDetai.prefillError,
      controller = _usePrefillLoginDetai.controller,
      prefillLoading = _usePrefillLoginDetai.prefillLoading,
      setUserInputMobileNumber = _usePrefillLoginDetai.setUserInputMobileNumber,
      userInputMobileNumber = _usePrefillLoginDetai.userInputMobileNumber;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var _useState = (0,react.useState)(true),
      buttonDisabled = _useState[0],
      setButtonDisabled = _useState[1];

  var inputRef = (0,react.useRef)(null);

  var onOtpSendSuccess = function onOtpSendSuccess() {
    pdt.track('HAPPY_AUTH_WEBA__CLICK_SEND_OTP', {
      custom1: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
    });
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Success',
        type: "itemSuccess",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (onFormSubmit) onFormSubmit();
  };

  var handleFormSubmit = function handleFormSubmit(e) {
    if (e) e.preventDefault();
    pdt.track('HAPPY_AUTH_WEBA__UI_CLICK_SEND_OTP');
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Clicked',
        type: "cardClick",
        componentName: 'GI_USER_ONBOARDING'
      }
    });

    if (!loading) {
      var _inputRef$current;

      var mobileNumber = ((_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.value) || '';
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      var isValid = checkValid(mobileNumber, isMobileNumberEncoded);

      if (isValid) {
        setUserInputMobileNumber(mobileNumber);
        fetch({
          platform: 'dweb',
          data: {
            mobileNumber: mobileNumber,
            loginType: 'mobile',
            encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
            isEncoded: isMobileNumberEncoded || undefined
          },
          onSuccess: onOtpSendSuccess
        });
      }
    }
  };

  (0,react.useEffect)(function () {
    if (!prefillMobileNumber && !userInputMobileNumber) {
      prefillfetch({
        platform: 'dweb'
      });
    }
  }, [prefillMobileNumber, userInputMobileNumber]);
  (0,react.useEffect)(function () {
    if (inputRef.current) {
      var prefillMobileNumberViaApi = prefillDetailsloaded && !prefillError ? prefillData == null ? void 0 : prefillData.encodedMobileNumber : null;
      var mobile = prefillMobileNumber || userInputMobileNumber || prefillMobileNumberViaApi;

      if (mobile) {
        inputRef.current.value = mobile;
        setButtonDisabled(false);
      }

      if (prefillMobileNumber && skipMobileScreen) {
        handleFormSubmit();
      }
    }
  }, [prefillMobileNumber, skipMobileScreen, prefillDetailsloaded, prefillError, prefillData, userInputMobileNumber]);
  /**
   *
   * @param e synthetic event
   * auto submit when user enters 10 digit
   */

  var handleInputChange = function handleInputChange(e) {
    var _inputRef$current2, _inputRef$current2$va;

    setButtonDisabled(true);
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();

    if (((_inputRef$current2 = inputRef.current) == null ? void 0 : (_inputRef$current2$va = _inputRef$current2.value) == null ? void 0 : _inputRef$current2$va.length) === growth_auth_helpers_esm/* MOBILE_NUMBER_MAX_LENGTH */.Zb) {
      setButtonDisabled(false);
      handleFormSubmit(e);
    }
  };

  var subText = function subText(_ref2) {
    var waiting = _ref2.loading,
        failure = _ref2.error,
        validationMessage = _ref2.validationMessage;

    if (waiting) {
      return 'Sending OTP...';
    }

    if (!waiting && failure) {
      var _data$error;

      return (_data$error = data.error) == null ? void 0 : _data$error.errorMsg;
    }

    if (validationMessage) {
      return validationMessage;
    }

    return '';
  };

  var handleInputClick = function handleInputClick() {
    var _inputRef$current3;

    if (prefillLoading) {
      controller.abort();
    }

    if ((0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(inputRef == null ? void 0 : (_inputRef$current3 = inputRef.current) == null ? void 0 : _inputRef$current3.value, prefillData == null ? void 0 : prefillData.encodedMobileNumber)) {
      inputRef.current.value = '';
      setButtonDisabled(true);
    }
  };

  return /*#__PURE__*/react.createElement("form", {
    onSubmit: handleFormSubmit,
    autoComplete: "on"
  }, /*#__PURE__*/react.createElement(InputWrapper, {
    label: LOGIN_WITH_MOBILE.label,
    maxlength: 10,
    onInputClick: handleInputClick,
    inputPrefix: "+91 -",
    onChange: handleInputChange,
    isError: error || ((_data$validation = data.validation) == null ? void 0 : _data$validation.message),
    isValid: (_data$validation2 = data.validation) == null ? void 0 : _data$validation2.isValidMobile,
    ref: inputRef,
    inputName: "phone",
    inputType: "text",
    inputClassName: "loginCont__input",
    inputDisabled: loading || !((_data$validation3 = data.validation) != null && _data$validation3.message) && isMobileNumberDisabled
  }), /*#__PURE__*/react.createElement(MessageText, {
    success: ((_data$validation4 = data.validation) == null ? void 0 : _data$validation4.isValidMobile) && !loading,
    error: !loading && error || ((_data$validation5 = data.validation) == null ? void 0 : _data$validation5.message),
    loading: loading
  }, subText({
    loading: loading,
    error: error,
    validationMessage: (_data$validation6 = data.validation) == null ? void 0 : _data$validation6.message
  })), /*#__PURE__*/react.createElement(LoginSubmitButton, {
    className: " " + (buttonDisabled ? 'disabled' : ''),
    type: "submit"
  }, LOGIN_WITH_MOBILE.submitButton));
};

var AUTH_FLOW_STEPS = {
  STEP_MOBILE: 'mobile',
  STEP_OTP: 'otp',
  STEP_PASSWORD: 'pwd',
  STEP_POST_AUTH: 'postlogin',
  LOADER: 'loader'
};

var useAuthFlow = (0,esm/* create */.Ue)(function (set) {
  return {
    activeAuthFlow: AUTH_FLOW_STEPS.STEP_MOBILE,
    setActiveAuthFlow: function setActiveAuthFlow(type) {
      return set({
        activeAuthFlow: type
      });
    }
  };
});

var LoginWithMobile = function LoginWithMobile(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
      isMobileNumberDisabled = _ref.isMobileNumberDisabled,
      skipMobileScreen = _ref.skipMobileScreen;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe;

  var setActiveAuthFlow = useAuthFlow(function (state) {
    return state.setActiveAuthFlow;
  });

  var onFormSubmit = function onFormSubmit() {
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_OTP);
  };

  var termsAndConditionClick = function termsAndConditionClick() {
    adobe.track('ctaClick', {
      cta: {
        name: "Login_TNC",
        type: "itemClick",
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };

  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, LOGIN_WITH_MOBILE.heading), /*#__PURE__*/react.createElement(MobileForm, {
    prefillMobileNumber: prefillMobileNumber,
    onFormSubmit: onFormSubmit,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, {
    onClick: termsAndConditionClick,
    "data-id": "terms-condition",
    dangerouslySetInnerHTML: {
      __html: LOGIN_WITH_MOBILE.termsPolicy
    }
  }));
};

var Heading = 'Verify OTP';
var SubHeading$1 = 'Enter 4 digit OTP sent to';
var RESEND_OTP = {
  label: "Didn't get the OTP?",
  timerHeading: 'Resend OTP in'
};
var OTP_TYPE = {
  sms: 'mobile',
  whatsApp: 'whatsapp'
};
var VERIFY_OTP_MSG = {
  verified: 'OTP verified',
  verifying: 'Verifying OTP...',
  invalidOtp: 'Please enter a valid OTP'
};
var TERMS_CONDITION = 'I agree to receive critical messages such as OTP, booking details on WhatsApp.';

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2;
var SubHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$7 || (_templateObject$7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 30px;\n\tmargin-top: -22px;\n\t", "\n\tspan {\n\t\t", "\n\t}\n\t.icEdit {\n\t\tmargin-left: 3px;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW1 */.iH.BaseW1, growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var OtpWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$5 || (_templateObject2$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t.verifyOtpCont__otpFiled {\n\t\theight: 56px;\n\t\tborder-radius: 4px;\n\t\tborder: 2px solid rgb(1, 110, 255);\n\t\tcolor: rgb(79, 82, 90);\n\t\toutline: 0px;\n\t\twidth: 60px !important;\n\t\ttext-align: center;\n\t\tpadding: 0;\n\t\t", "\n\t}\n\t&.otpError .verifyOtpCont__otpFiled {\n\t\tborder-color: rgb(229, 52, 66);\n\t}\n\t.verifyOtpCont__message {\n\t\tmin-height: 50px;\n\t}\n\t.verifyOtpCont__otpCont {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OtpErrorContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$4 || (_templateObject3$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 8px;\n\t.errorIcon {\n\t\tmargin-right: 10px;\n\t}\n\t.errorMessage {\n\t\tcolor: rgb(229, 52, 66);\n\t\t", "\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimerContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$4 || (_templateObject4$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 10px;\n\t.gi-resend-timer {\n\t\tmargin-left: 5px;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var ResendOtpTimer = styled_components_browser_esm/* default.span */.ZP.span(_templateObject5$3 || (_templateObject5$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tcolor: rgb(0, 0, 0);\n\t", "\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var ResendSmsTypeContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$2 || (_templateObject6$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t&.disableInfo {\n\t\topacity: 0.3;\n\t\tpointer-events: none;\n\t}\n\t.otpScreen__social {\n\t\tdisplay: flex;\n\t}\n\t.otpScreen__social > li {\n\t\twidth: 94px;\n\t\tmargin: 0 0 0 10px;\n\t\tpadding: 4px 14px 5px 8px;\n\t\tborder-radius: 2px;\n\t\tborder: solid 1px #cecece;\n\t\tbackground-color: #fff;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t}\n\t.otpScreen__social > li .gi-tooltip {\n\t\tdisplay: none;\n\t}\n\t.otpScreen__social > li:hover .gi-tooltip {\n\t\tdisplay: block;\n\t}\n"])));

var OtpInputWrapper = function OtpInputWrapper(_ref) {
  var mobileNumber = _ref.mobileNumber,
      onOtpSuccess = _ref.onOtpSuccess,
      isExistingUser = _ref.isExistingUser;
  var verifyNewUser = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (state) {
    return state.fetch;
  });
  var fetchLoginDetails = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (state) {
    return state.fetch;
  });
  var otpData = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state.data;
  });

  var _useState = (0,react.useState)(''),
      otp = _useState[0],
      setOtp = _useState[1];

  var _useState2 = (0,react.useState)(false),
      otpVerifying = _useState2[0],
      setOtpVerifying = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      otpError = _useState3[0],
      setOtpError = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      otpErrorMsg = _useState4[0],
      setOtpErrorMsg = _useState4[1];

  (0,react.useEffect)(function () {
    /**
     * this check if otp is invalid then bring focus to 4th input field
     */
    if (otpError && !otpVerifying) {
      var otpList = document.querySelectorAll('input.verifyOtpCont__otpFiled') || [];

      if (otpList[3]) {
        otpList[3].focus();
      }
    }
  }, [otpError, otpVerifying]);

  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
    return {
      prefillData: s.data
    };
  }, shallow/* shallow */.X),
      prefillData = _usePrefillLoginDetai.prefillData;

  var onOtpVerificationSuccess = function onOtpVerificationSuccess(details) {
    setOtpVerifying(false);
    if (onOtpSuccess) onOtpSuccess(details);
  };

  var onOtpVerificationError = function onOtpVerificationError(_ref2) {
    var code = _ref2.code;
    setOtpVerifying(false);

    if (code && code === growth_auth_helpers_esm/* INVALID_OTP_CODE */.Wp) {
      setOtpError(true);
      setOtpErrorMsg('Please enter a valid OTP');
    } else {
      setOtpError(true);
      setOtpErrorMsg('Some error occurred, please try again.');
    }
  };

  var resetErrorState = function resetErrorState() {
    setOtpError(false);
    setOtpErrorMsg('');
  };

  var submitOtp = function submitOtp(value) {
    setOtpVerifying(true);
    resetErrorState();

    if (isExistingUser) {
      fetchLoginDetails({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          passwordType: 'OTP',
          password: value,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: otpData.isMobileNumberEncoded || undefined
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    } else {
      verifyNewUser({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          passwordType: 'OTP',
          password: value
        },
        onSuccess: onOtpVerificationSuccess,
        onError: onOtpVerificationError
      });
    }
  };

  var handleOtpChange = function handleOtpChange(value) {
    setOtpVerifying(false);
    setOtp(value);

    if (value.length === 4) {
      submitOtp(value);
    }
  };

  return /*#__PURE__*/react.createElement(OtpWrapper, {
    className: otpError ? 'otpError' : ''
  }, /*#__PURE__*/react.createElement(lib/* default */.Z, {
    value: otp,
    onChange: handleOtpChange,
    numInputs: 4,
    separator: /*#__PURE__*/react.createElement("span", null, "\xA0"),
    containerStyle: "verifyOtpCont__otpCont",
    inputStyle: otpVerifying ? 'verifyOtpCont__otpFiled disabled' : 'verifyOtpCont__otpFiled',
    isInputNum: true,
    shouldAutoFocus: true,
    isDisabled: otpVerifying
  }), /*#__PURE__*/react.createElement("div", {
    className: "verifyOtpCont__message"
  }, otpVerifying && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, {
    theme: "blue"
  }), /*#__PURE__*/react.createElement("p", {
    className: "gr-append-left10 robotoRegular gr-font12"
  }, VERIFY_OTP_MSG.verifying)), otpError && /*#__PURE__*/react.createElement(OtpErrorContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icInfoPink errorIcon"
  }), /*#__PURE__*/react.createElement("p", {
    className: "errorMessage"
  }, otpErrorMsg))));
};

var OTP_RESEND_TIME = 30;
var CONFIG_KEY_DWEB_AUTH = 'growth-dweb-header-config';

var tooltipStyle = {
  width: '250px',
  top: 32
};
var tooltipStyle2 = {
  width: '250px',
  top: 32,
  right: 14
};
var ResendOtp = function ResendOtp(_ref) {
  var isExistingUser = _ref.isExistingUser;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return {
      resendOtpApi: state.fetch,
      apiLoading: state.loading,
      mobileNumber: state.data.mobileNumber
    };
  }, shallow/* shallow */.X),
      resendOtpApi = _useSendOtpStore.resendOtpApi,
      mobileNumber = _useSendOtpStore.mobileNumber,
      apiLoading = _useSendOtpStore.apiLoading;

  var _usePrefillLoginDetai = (0,growth_auth_helpers_esm/* usePrefillLoginDetails */.dt)(function (s) {
    return {
      prefillData: s.data
    };
  }, shallow/* shallow */.X),
      prefillData = _usePrefillLoginDetai.prefillData;

  var _useState = (0,react.useState)(OTP_RESEND_TIME),
      resendTimer = _useState[0],
      setResendTimer = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isTimerActive = _useState2[0],
      setIsTimerActive = _useState2[1];

  (0,react.useEffect)(function () {
    var timerInterval;

    if (isTimerActive) {
      if (resendTimer === 0) {
        clearInterval(timerInterval);
        setIsTimerActive(false);
      }

      timerInterval = setInterval(function () {
        setResendTimer(function (timer) {
          return timer - 1;
        });
      }, 1000);
    }

    return function () {
      clearInterval(timerInterval);
    };
  }, [isTimerActive, resendTimer]);

  var resendOtp = function resendOtp(type) {
    if (!apiLoading) {
      pdt.track('HAPPY_AUTH_WEBA__CLICK_RESEND_OTP_SMS', {
        action: type
      });
      adobe.track('ctaClick', {
        cta: {
          name: "resend_otp",
          type: "cardClick|method:" + type + "|flow:" + (isExistingUser ? 'login' : 'signup'),
          componentName: 'GI_USER_ONBOARDING'
        }
      });
      setResendTimer(OTP_RESEND_TIME);
      setIsTimerActive(true);
      var isMobileNumberEncoded = (0,growth_auth_helpers_esm/* isMobileEncoded */.gR)(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      resendOtpApi({
        platform: 'dweb',
        data: {
          mobileNumber: mobileNumber,
          loginType: type,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: isMobileNumberEncoded || undefined
        }
      });
    }
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ResendOtpTimerContainer, null, RESEND_OTP.label, ' ', resendTimer ? /*#__PURE__*/react.createElement("span", null, RESEND_OTP.timerHeading, /*#__PURE__*/react.createElement(ResendOtpTimer, {
    className: "gi-resend-timer"
  }, resendTimer < 10 ? "00:0" + resendTimer : "00:" + resendTimer)) : null), /*#__PURE__*/react.createElement(ResendSmsTypeContainer, {
    className: "" + (resendTimer ? 'disableInfo' : '')
  }, /*#__PURE__*/react.createElement(ResendOtpTimer, null, "Resend via :"), /*#__PURE__*/react.createElement("ul", {
    className: "otpScreen__social"
  }, /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.whatsApp);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icWhatsapp gr-append-right5"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "WhatsApp"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle,
    notchPosition: "middle"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please ensure that you have entered your WhatsApp number for OTP"))), /*#__PURE__*/react.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.sms);
    },
    role: "presentation"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSms gr-appendRight10"
  }), /*#__PURE__*/react.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "SMS"), /*#__PURE__*/react.createElement(growth_tooltip_esm/* ToolTip */.e, {
    customClass: "gi-tooltip",
    customStyle: tooltipStyle2,
    notchPosition: "right"
  }, /*#__PURE__*/react.createElement("p", {
    className: "gr-font12"
  }, "Please don\u2019t share your OTP with anyone"))))));
};

var LoginWithOtp = function LoginWithOtp(_ref) {
  var isMobileNumberDisabled = _ref.isMobileNumberDisabled;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe,
      analyticsTrackAll = _useAnalytics.analyticsTrackAll;

  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state.data;
  }),
      mobileNumber = _useSendOtpStore.mobileNumber,
      data = _useSendOtpStore.data;

  var _useAuthFlow = useAuthFlow(function (state) {
    return state;
  }),
      setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;

  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'OTP_Screen_Loaded',
        type: "itemLoaded|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);

  var onEditMobile = function onEditMobile() {
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    pdt.track('HAPPY_AUTH_WEBA__CLICK_MOBILE_CHANGE', {
      screen_name: AUTH_FLOW_STEPS.STEP_OTP
    });
    adobe.track('ctaClick', {
      cta: {
        name: "Edit_Phone_Number",
        destination: 'Login_Popup_Load',
        type: "itemClick|flow:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };

  var onOtpSuccess = function onOtpSuccess() {
    adobe.track('User_Login', {
      account: {
        accountInfo: {
          flow: "" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'login' : 'signup')
        }
      },
      cta: {
        type: 'manual',
        name: "Onboarding_" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt ? 'Login' : 'Signup') + "_Success",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    analyticsTrackAll('HAPPY_AUTH_WEBA__UX_LOGIN_SUCCESS', {
      custom1: "existing:" + (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt) + ",type:manual"
    });
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_POST_AUTH);
  };

  return /*#__PURE__*/react.createElement(MobileContainer, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(MobileHeading, null, Heading), /*#__PURE__*/react.createElement(SubHeading, null, SubHeading$1, /*#__PURE__*/react.createElement("span", null, " ", mobileNumber), !isMobileNumberDisabled && /*#__PURE__*/react.createElement("span", {
    className: "logSprite icEdit",
    onClick: onEditMobile,
    role: "presentation"
  })), /*#__PURE__*/react.createElement(OtpInputWrapper, {
    mobileNumber: mobileNumber,
    onOtpSuccess: onOtpSuccess,
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  }), /*#__PURE__*/react.createElement(ResendOtp, {
    isExistingUser: data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt
  })), /*#__PURE__*/react.createElement(LoginTermsAndCondition, null, TERMS_CONDITION));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$1, _templateObject7;
var PostAuthContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$6 || (_templateObject$6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tjustify-content: flex-start;\n\tmargin: -31px -37px -18px -37px !important;\n\theight: 486px;\n\tinput.loginCont__input {\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #4f525a;\n\t\tborder-radius: 4px;\n\t\tpadding: 0 20px;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\tline-height: 20px !important;\n\t\topacity: 1;\n\t\tfont-weight: 600 !important;\n\t}\n"])));
var PostAuthHeader = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$4 || (_templateObject2$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground-color: #e5f2ff;\n\tcolor: #2d67b2;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 24px 16px;\n\tborder-radius: 10px;\n\tspan {\n\t\tmargin-right: 20px;\n\t}\n\n\t.successMsg__title {\n\t\tfont-size: 22px;\n\t\tline-height: 27px;\n\t\tcolor: #00962d;\n\n\t\tfont-weight: 500;\n\t}\n\n\t.successMsg__subTitle {\n\t\tfont-size: 18px;\n\t\tline-height: 27px;\n\t\tcolor: #4f525a;\n\n\t\tfont-weight: 500;\n\t}\n"])));
var postAuthForms = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$3 || (_templateObject3$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin: 30px 27px 15px 37px;\n\twidth: 300px;\n\t.gi-marginBottom25 {\n\t\tmargin-bottom: 25px;\n\t}\n"])));
var postAuthFormHeading = styled_components_browser_esm/* default.p */.ZP.p(_templateObject4$3 || (_templateObject4$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 13px;\n\tmargin-bottom: 20px;\n\tline-height: 18px !important;\n"])));
var PostAuthSubmitButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject5$2 || (_templateObject5$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 44px;\n\tpadding: 13px 118px 13px 116px;\n\tmargin-top: 22px;\n\tborder-radius: 8px;\n\tbackground-color: #ff6d38;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\n\t&.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])));
var SkipUpdate = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$1 || (_templateObject6$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tmargin-top: 30px;\n\n\tbutton {\n\t\tcolor: #008cff !important;\n\t\tcursor: pointer;\n\t\tborder: 0;\n\t\tbackground-color: transparent;\n\t\ttext-decoration: none;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t}\n"])));
var ErrorMsg = styled_components_browser_esm/* default.p */.ZP.p(_templateObject7 || (_templateObject7 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 10px !important;\n\n\tcolor: #e53442;\n"])));

var SIGNUP_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'Account created successfully'
};
var LOGIN_SUCCESS_TOAST = {
  title: 'Congratulations',
  subTitle: 'You have successfully logged in'
};
var DO_IT_LATER = {
  title: 'I’ll do it later'
};
var VALIDATION_MSG = {
  email: {
    invalid: "Enter a valid email"
  },
  name: {
    invalid: "Please enter valid name using only alphabets"
  }
};

var UpdateDetailsForm = function UpdateDetailsForm(_ref) {
  var firstName = _ref.firstName,
      primaryEmailId = _ref.primaryEmailId,
      handleUserUpdate = _ref.handleUserUpdate,
      handleDoItLaterClick = _ref.handleDoItLaterClick,
      apiFailureMsg = _ref.apiFailureMsg,
      isExistingUser = _ref.isExistingUser;

  var _useState = (0,react.useState)(false),
      isFormValid = _useState[0],
      setIsFormValid = _useState[1];

  var _useState2 = (0,react.useState)(''),
      name = _useState2[0],
      setName = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      email = _useState3[0],
      setEmail = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isError = _useState4[0],
      setIsError = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      errorMsg = _useState5[0],
      setErrorMsg = _useState5[1];

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe;

  (0,react.useEffect)(function () {
    setErrorMsg(apiFailureMsg);
    setIsError(!!apiFailureMsg);
  }, [apiFailureMsg]);

  var handleNameChange = function handleNameChange(e) {
    setName(e.target.value);
  };

  var handleEmailChange = function handleEmailChange(e) {
    setEmail(e.target.value);
  };

  var validateProfileUpdate = function validateProfileUpdate(_ref2) {
    var _ref2$fullName = _ref2.fullName,
        fullName = _ref2$fullName === void 0 ? '' : _ref2$fullName,
        _ref2$inputEmail = _ref2.inputEmail,
        inputEmail = _ref2$inputEmail === void 0 ? '' : _ref2$inputEmail;

    if (fullName && email) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }

    if (!fullName && inputEmail) {
      if (!(0,growth_auth_helpers_esm/* isEmailValid */.Ju)(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
    }

    if (!inputEmail && fullName) {
      if (!(0,growth_auth_helpers_esm/* isNameValid */.Pz)(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }

    return {
      isValid: true,
      errorMessage: ''
    };
  };

  var onUserUpdate = function onUserUpdate() {
    var _validateProfileUpdat = validateProfileUpdate({
      fullName: name,
      inputEmail: email
    }),
        isValid = _validateProfileUpdat.isValid,
        errorMessage = _validateProfileUpdat.errorMessage;

    if (isValid) {
      if (handleUserUpdate) handleUserUpdate({
        fullName: name,
        email: email
      });
    } else {
      setErrorMsg(errorMessage);
      setIsError(true);
    }
  };

  var onSkipClick = function onSkipClick() {
    if (handleDoItLaterClick) handleDoItLaterClick();
  };

  (0,react.useEffect)(function () {
    if (name || email) {
      setIsFormValid(true);
    } else {
      setIsError(false);
      setErrorMsg('');
    }
  }, [name, email]);
  (0,react.useEffect)(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Profile_Update_Screen_Loaded',
        type: "itemLoaded|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);
  return /*#__PURE__*/react.createElement(postAuthForms, null, /*#__PURE__*/react.createElement(postAuthFormHeading, null, "Just one more thing."), /*#__PURE__*/react.createElement("div", {
    className: "gi-marginBottom25"
  }, !firstName ? /*#__PURE__*/react.createElement(InputWrapper, {
    type: "text",
    name: "name",
    label: "What do we call you?",
    placeholder: "Enter your full name",
    inputClassName: "loginCont__input",
    inputVal: name,
    onChange: handleNameChange
  }) : null), !primaryEmailId ? /*#__PURE__*/react.createElement(InputWrapper, {
    type: "email",
    name: "Email",
    label: "What's your email id?",
    placeholder: "Enter your email address",
    inputClassName: "loginCont__input",
    inputVal: email,
    onChange: handleEmailChange
  }) : null, isError && /*#__PURE__*/react.createElement(ErrorMsg, null, errorMsg, " "), /*#__PURE__*/react.createElement(PostAuthSubmitButton, {
    type: "button",
    className: !isFormValid ? 'disabled' : '',
    onClick: onUserUpdate
  }, "Lets Go"), /*#__PURE__*/react.createElement(SkipUpdate, null, /*#__PURE__*/react.createElement("button", {
    type: "button",
    onClick: onSkipClick || null
  }, DO_IT_LATER.title)));
};

var CloseIcon = function CloseIcon(_ref) {
  var closeAuth = _ref.closeAuth;
  return /*#__PURE__*/react.createElement(AuthVerificationFlowCloseIcon, {
    "aria-hidden": "true"
  }, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icClose",
    onClick: closeAuth,
    role: "presentation"
  }));
};

var UpdateProfile = function UpdateProfile(props) {
  var _userDetails$data, _userDetails$data$pro;

  var closeAndLogin = props.closeAndLogin,
      onProfileComplete = props.onProfileComplete,
      onLoginComplete = props.onLoginComplete;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe,
      analyticsTrackAll = _useAnalytics.analyticsTrackAll;

  var _useState = (0,react.useState)(''),
      apiFailureMsg = _useState[0],
      setApiFailureMsg = _useState[1];

  var _useSendOtpStore = (0,growth_auth_helpers_esm/* useSendOtpStore */.Y6)(function (state) {
    return state.data;
  }),
      mobileNumber = _useSendOtpStore.mobileNumber,
      data = _useSendOtpStore.data;

  var _useLoginUserStore = (0,growth_auth_helpers_esm/* useLoginUserStore */.lq)(function (s) {
    return {
      userDetails: s.data,
      fetchLoginDetails: s.fetch
    };
  }, shallow/* shallow */.X),
      userDetails = _useLoginUserStore.userDetails,
      fetchLoginDetails = _useLoginUserStore.fetchLoginDetails;

  var _useSignupViaOTPStore = (0,growth_auth_helpers_esm/* useSignupViaOTPStore */.W3)(function (s) {
    var _s$data;

    return {
      transactionId: (_s$data = s.data) == null ? void 0 : _s$data.transactionId,
      createNewUser: s.createUser
    };
  }, shallow/* shallow */.X),
      transactionId = _useSignupViaOTPStore.transactionId,
      createNewUser = _useSignupViaOTPStore.createNewUser;

  var updateUserDetails = (0,growth_auth_helpers_esm/* useProfileUpdateStore */.IR)(function (s) {
    return s.fetch;
  });
  var profileDetails = (userDetails == null ? void 0 : (_userDetails$data = userDetails.data) == null ? void 0 : (_userDetails$data$pro = _userDetails$data.profileLoginResponse) == null ? void 0 : _userDetails$data$pro[0]) || {};

  var _ref = profileDetails.userDetails || {},
      _ref$extendedUser = _ref.extendedUser,
      extendedUser = _ref$extendedUser === void 0 ? {} : _ref$extendedUser;

  var _extendedUser$persona = extendedUser.personalDetails,
      personalDetails = _extendedUser$persona === void 0 ? {} : _extendedUser$persona,
      _extendedUser$loginIn = extendedUser.loginInfoList,
      loginInfoList = _extendedUser$loginIn === void 0 ? [] : _extendedUser$loginIn,
      _extendedUser$miscFie = extendedUser.miscFields,
      miscFields = _extendedUser$miscFie === void 0 ? {} : _extendedUser$miscFie;
  var _personalDetails$name = personalDetails.name,
      name = _personalDetails$name === void 0 ? {} : _personalDetails$name;
  var isExistingUser = data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt;
  var primaryEmailId = '';
  loginInfoList.forEach(function (item) {
    if (item.loginType === 'EMAIL') {
      primaryEmailId = item.loginId;
    }
  });

  if (!primaryEmailId) {
    primaryEmailId = miscFields == null ? void 0 : miscFields.altEmailId;
  }

  var onLoginSuccess = function onLoginSuccess() {
    // adding timeout as api take some time to remove cache and update user details
    analyticsTrackAll('HAPPY_AUTH_WEBA__CLICK_PROFILE_UPDATE');
    if (onLoginComplete) onLoginComplete(userDetails);
  };

  var onLoginError = function onLoginError(details) {

    setApiFailureMsg('Something went wrong, please try again.');
  };

  var onUserUpdate = function onUserUpdate(_ref2) {
    var fullName = _ref2.fullName,
        email = _ref2.email;
    setApiFailureMsg('');
    adobe.track('Profile_Completion');

    if (data.statusCode === growth_auth_helpers_esm/* EXISTING_USER_STATUS_CODE */.tt) {
      var details = {
        mobileNumber: mobileNumber
      };
      if (fullName) details.firstName = fullName;
      if (email) details.email = email;
      updateUserDetails({
        data: details,
        platform: 'dweb',
        onSuccess: onLoginSuccess,
        onError: onLoginError
      });
    } else if (!isExistingUser) {
      createNewUser({
        platform: 'dweb',
        fullName: fullName,
        email: email,
        mobileNumber: mobileNumber,
        transactionId: transactionId
      }).then(function (res) {
        var _res$result;

        if (res != null && (_res$result = res.result) != null && _res$result.success) {
          fetchLoginDetails({
            platform: 'dweb',
            data: {
              mobileNumber: mobileNumber,
              passwordType: 'TRANSITION_ID',
              password: transactionId
            },
            onSuccess: onLoginSuccess,
            onError: onLoginError
          });
        }
      })["catch"](function () {
        return onLoginError();
      });
    }
  };

  var handleDoItLaterClick = function handleDoItLaterClick() {
    analyticsTrackAll('HAPPY_AUTH_WEBA__CLICK_SKIP_PROFILE_UPDATE');
    adobe.track('ctaClick', {
      cta: {
        name: 'skip-profile-update',
        type: "itemClick|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: 'GI_USER_ONBOARDING'
      }
    });

    if (isExistingUser) {
      if (closeAndLogin) closeAndLogin();
    } else {
      onUserUpdate({
        fullName: '',
        email: ''
      });
    }
  };

  (0,react.useEffect)(function () {
    if (isExistingUser) {
      if (name.firstName && primaryEmailId) {
        onProfileComplete();
      }
    }
  }, [isExistingUser, name, primaryEmailId]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: handleDoItLaterClick
  }), /*#__PURE__*/react.createElement(PostAuthContainer, null, /*#__PURE__*/react.createElement(PostAuthHeader, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, LOGIN_SUCCESS_TOAST.title), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, isExistingUser ? LOGIN_SUCCESS_TOAST.subTitle : SIGNUP_SUCCESS_TOAST.subTitle))), /*#__PURE__*/react.createElement(UpdateDetailsForm, {
    apiFailureMsg: apiFailureMsg,
    firstName: name.firstName,
    primaryEmailId: primaryEmailId,
    handleUserUpdate: onUserUpdate,
    handleDoItLaterClick: handleDoItLaterClick,
    isExistingUser: isExistingUser
  })));
};

/** Create a new configStore instance for dweb-auth */

var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$1;
var AuthOfferStyle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$5 || (_templateObject$5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 343px;\n\theight: 432px;\n\tbackground-color: rgb(255, 255, 255);\n\tborder-radius: 20px 0px 0px 20px;\n\tflex-shrink: 0;\n\toverflow: hidden;\n\tpadding: 22px 20px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\t", "\n\tcursor: ", ";\n"])), function (_ref) {
  var bg = _ref.bg;
  return !bg ? "background:linear-gradient(\n\t\t197.24deg,\n\t\trgb(194, 212, 255) 16.45%,\n\t\trgb(251, 241, 255) 39.26%,\n\t\trgb(234, 243, 243) 59.99%\n\t);\n\tbackground-size:0% 0% / cover;" : "background: #fff url(" + bg + ") top left no-repeat;\n\tbackground-size: cover;";
}, function (_ref2) {
  var clickable = _ref2.clickable;
  return clickable ? 'pointer' : 'auto';
});
var offerBannerHeading = styled_components_browser_esm/* default.h3 */.ZP.h3(_templateObject2$3 || (_templateObject2$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tletter-spacing: 1px;\n\ttext-transform: uppercase;\n\tcolor: rgb(20, 24, 35);\n\tmargin-bottom: 30px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var offerBannerSubHeading = styled_components_browser_esm/* default.p */.ZP.p(_templateObject3$2 || (_templateObject3$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4f525a;\n"])), growth_design_system_esm/* textSizes.BaseW2 */.iH.BaseW2);
var smooth = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject4$2 || (_templateObject4$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose([" {\n\tfrom {\n\t  opacity: 0;\n\t}\n  \n\tto {\n\t  opacity: 2;\n\t}\n  }"])));
var Smooth = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5$1 || (_templateObject5$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tanimation: ", ";\n"])), smooth);

var _templateObject$4, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6;
var BenefitsContainer = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject$4 || (_templateObject$4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tmargin-top: 15px;\n\tmargin-left: -6px;\n"])));
var BenefitsList = styled_components_browser_esm/* default.li */.ZP.li(_templateObject2$2 || (_templateObject2$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n\n\t.benefitsList_item_wrapper {\n\t\tflex: 1;\n\t}\n\t.benefitsList_item_IconWrapper {\n\t\twidth: 52px;\n\t\theight: 52px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 20px;\n\t\tmargin-top: -12px;\n\t}\n\n\t.benefitsList_item_IconWrapper.giftIcon {\n\t\tmargin-top: -24px;\n\t}\n\n\t.icGoCash {\n\t\twidth: 73px;\n\t\theight: 44px;\n\t\tbackground: url(https://gos3.ibcdn.com/go-cash-icon-1674207238.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGoTribe {\n\t\twidth: 52px;\n\t\theight: 15px;\n\t\tbackground: url(https://gos3.ibcdn.com/gotribe-logo-1674203779.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n\n\t.icGiftBlue {\n\t\twidth: 37px;\n\t\theight: 42px;\n\t\tbackground: url(https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png);\n\t\tbackground-repeat: no-repeat;\n\t\tcursor: pointer;\n\t}\n"])));
var BenifitsImage = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$1 || (_templateObject3$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\twidth: 52px;\n\theight: 52px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tmargin-right: 20px;\n\tbackground: url(", ");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n\tmargin-top: -10px;\n"])), function (props) {
  return props.imgUrl;
});
var BenefitsContainerHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$1 || (_templateObject4$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\tmargin-bottom: 6px;\n"])), growth_design_system_esm/* headingSizes.Small */.$G.Small);
var BenefitsContainerSubHeading = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5 || (_templateObject5 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n\t&.lastChild {\n\t\tborder-bottom: none;\n\t}\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var BenifitsDivider = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6 || (_templateObject6 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tborder-bottom: 1px solid #cdcdcd;\n\tmargin-top: 20px;\n"])));

var OfferBenefits = function OfferBenefits(props) {
  var _props$benefitsList = props.benefitsList,
      benefitsList = _props$benefitsList === void 0 ? [] : _props$benefitsList;
  return /*#__PURE__*/react.createElement(BenefitsContainer, null, benefitsList.map(function (benefit) {
    return /*#__PURE__*/react.createElement(BenefitsList, {
      key: benefit.id
    }, /*#__PURE__*/react.createElement(BenifitsImage, {
      imgUrl: benefit.imgUrl
    }), /*#__PURE__*/react.createElement("div", {
      className: "benefitsList_item_wrapper"
    }, /*#__PURE__*/react.createElement(BenefitsContainerHeading, null, benefit.heading, " "), /*#__PURE__*/react.createElement(BenefitsContainerSubHeading, null, benefit.subHeading, " "), /*#__PURE__*/react.createElement(BenifitsDivider, null)));
  }));
};

var _templateObject$3, _templateObject2$1, _templateObject3, _templateObject4;
var OfferBanner$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$3 || (_templateObject$3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tbackground: rgb(255, 255, 255);\n\tbox-shadow: rgba(0, 0, 0, 0.08) 2px 4px 8px;\n\tborder-radius: 2px;\n\tpadding: 10px 20px;\n\tborder-left: 6px solid rgb(28, 114, 226);\n\twidth: 303px;\n"])));
var OfferBannerHeading = styled_components_browser_esm/* default.p */.ZP.p(_templateObject2$1 || (_templateObject2$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(79, 82, 90);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var OfferBannerSubHeading = styled_components_browser_esm/* default.p */.ZP.p(_templateObject3 || (_templateObject3 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(101, 102, 104);\n\tmargin-bottom: 5px;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);
var OfferBannerCouponCode = styled_components_browser_esm/* default.p */.ZP.p(_templateObject4 || (_templateObject4 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: rgb(28, 114, 226);\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);

var OfferBanner = function OfferBanner(props) {
  var heading = props.heading,
      subHeading = props.subHeading,
      couponCode = props.couponCode;
  return /*#__PURE__*/react.createElement(OfferBanner$1, null, /*#__PURE__*/react.createElement(OfferBannerHeading, null, heading), /*#__PURE__*/react.createElement(OfferBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBannerCouponCode, null, couponCode));
};

var _templateObject$2, growth_gi_dweb_auth_esm_templateObject2;
var Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$2 || (_templateObject$2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"])));
var Bg = styled_components_browser_esm/* default.div */.ZP.div(growth_gi_dweb_auth_esm_templateObject2 || (growth_gi_dweb_auth_esm_templateObject2 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\theight: 44px;\n\twidth: 44px;\n\tjustify-content: center;\n\talign-items: center;\n\tdisplay: flex;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n\tborder-radius: 50px;\n"])));

var Loader = function Loader() {
  return /*#__PURE__*/react.createElement(Wrap, null, /*#__PURE__*/react.createElement(Bg, null, /*#__PURE__*/react.createElement(growth_loader_esm/* CircularLoader */.V, null)));
};

var DEFAULT_CONFIG = {
  loginPopover: {
    signUp: {
      ctaText: 'Login/Sign Up',
      coupon: 'Use Coupon : WELCOME'
    }
  },
  loginCtaLabels: [{
    text: 'LOGIN / SIGNUP',
    id: 'text_1'
  }, {
    text: 'Exclusive Offers',
    id: 'text_2'
  }, {
    text: 'Earn goCash',
    id: 'text_3'
  }, {
    text: 'Manage Your Trips',
    id: 'text_4'
  }, {
    text: 'LOGIN / SIGNUP',
    id: 'text_5'
  }],
  bookingOffers: {
    growth: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    flights: {
      title: 'FLAT 12% OFF*',
      subTitle: 'on your first Flight booking'
    },
    hotels: {
      title: 'FLAT 25% OFF* ',
      subTitle: 'on your first Hotel booking'
    },
    bus: {
      title: 'FLAT 10% OFF*',
      subTitle: 'on your first Bus booking'
    },
    cabs: {
      title: 'Upto 10% OFF*',
      subTitle: 'on your first Cab booking'
    },
    trains: {
      title: 'Zero service fees',
      subTitle: 'on your first Train booking'
    }
  },
  loginDialog: {
    heading: 'Unlock these benefits',
    subHeading: '',
    salesOffers: {},
    benefits: [{
      id: 1,
      heading: 'Earn goCash',
      subHeading: '100 on Sign Up & Cashback on Bookings',
      imgUrl: 'https://gos3.ibcdn.com/go-cash-icon-1674207238.png'
    }, {
      id: 2,
      heading: 'Loyalty Benefits',
      subHeading: 'Extra Discounts, Free Seat Selection etc.',
      imgUrl: 'https://gos3.ibcdn.com/gotribe-logo-1674203779.png'
    }, {
      id: 3,
      heading: 'Exclusive Offers',
      subHeading: 'Daily Steal Deals & Special Discounts',
      imgUrl: 'https://gos3.ibcdn.com/surprice-offer-icon-1674203743.png'
    }]
  }
};

var AuthOfferBanner = function AuthOfferBanner(props) {
  var _D4, _D4$salesOffers, _D5, _D5$bookingOffers, _D6, _D6$bookingOffers, _D7, _D7$bookingOffers;

  var lobName = props.lobName,
      showBanner = props.showBanner;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe;

  var _ref = useConfigStore(),
      data = _ref.data,
      loading = _ref.loading,
      error = _ref.error,
      loaded = _ref.loaded;

  var configData = function configData() {
    var _data$COMMON, _data$COMMON$CONFIG_K;

    var d = data == null ? void 0 : (_data$COMMON = data.COMMON) == null ? void 0 : (_data$COMMON$CONFIG_K = _data$COMMON[CONFIG_KEY_DWEB_AUTH]) == null ? void 0 : _data$COMMON$CONFIG_K.data;

    if (loaded && !error && d) {
      return d;
    }

    return DEFAULT_CONFIG;
  };

  var _ref2 = configData(),
      loginDialog = _ref2.loginDialog,
      bookingOffers = _ref2.bookingOffers;

  var _ref3 = loginDialog || {},
      benefits = _ref3.benefits,
      salesOffers = _ref3.salesOffers,
      heading = _ref3.heading,
      subHeading = _ref3.subHeading;

  var D;

  if (showBanner && (salesOffers || bookingOffers)) {
    D = {
      salesOffers: salesOffers == null ? void 0 : salesOffers[lobName],
      bookingOffers: bookingOffers == null ? void 0 : bookingOffers[lobName]
    };
  }

  var hasSalesOffersExpired = function hasSalesOffersExpired() {
    var _D, _D$salesOffers, _D2, _D2$salesOffers;

    if ((_D = D) != null && (_D$salesOffers = _D.salesOffers) != null && _D$salesOffers.imgUrl && (_D2 = D) != null && (_D2$salesOffers = _D2.salesOffers) != null && _D2$salesOffers.expiry) {
      // expire date format: MM/DD/YYYY
      return isDateExpired({
        now: new Date().getTime(),
        expire: new Date(D.salesOffers.expiry).getTime()
      });
    }

    return true;
  };

  var shouldShowSalesImage = !hasSalesOffersExpired();

  var handleSalesImageClick = function handleSalesImageClick() {
    var _D3, _D3$salesOffers;

    adobe.track('ctaClick', {
      cta: {
        name: "Sale_Banner_Clicked",
        type: 'itemClick',
        componentName: "GI_USER_ONBOARDING"
      }
    });

    if (shouldShowSalesImage && (_D3 = D) != null && (_D3$salesOffers = _D3.salesOffers) != null && _D3$salesOffers.ctaUrl) {
      window.open(D.salesOffers.ctaUrl, '_blank');
    }
  };

  (0,react.useEffect)(function () {
    if (shouldShowSalesImage) {
      // send event when sales has to be display
      adobe.track('ctaClick', {
        cta: {
          name: 'Sale_Banner_loaded',
          type: "itemLoaded",
          componentName: "GI_USER_ONBOARDING"
        }
      });
    }
  }, [shouldShowSalesImage]);

  if (!showBanner) {
    return null;
  }

  return /*#__PURE__*/react.createElement(AuthOfferStyle, {
    className: "gr-home",
    "data-id": "auth-offer-banner",
    bg: shouldShowSalesImage ? (_D4 = D) == null ? void 0 : (_D4$salesOffers = _D4.salesOffers) == null ? void 0 : _D4$salesOffers.imgUrl : '',
    onClick: handleSalesImageClick,
    clickable: !!shouldShowSalesImage
  }, loading ? /*#__PURE__*/react.createElement(Loader, null) : /*#__PURE__*/react.createElement(Smooth, null, heading && !shouldShowSalesImage && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(offerBannerHeading, {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/react.createElement(offerBannerSubHeading, null, subHeading), /*#__PURE__*/react.createElement(OfferBenefits, {
    benefitsList: benefits
  })), /*#__PURE__*/react.createElement(OfferBanner, {
    heading: (_D5 = D) == null ? void 0 : (_D5$bookingOffers = _D5.bookingOffers) == null ? void 0 : _D5$bookingOffers.title,
    subHeading: (_D6 = D) == null ? void 0 : (_D6$bookingOffers = _D6.bookingOffers) == null ? void 0 : _D6$bookingOffers.subTitle,
    couponCode: (_D7 = D) == null ? void 0 : (_D7$bookingOffers = _D7.bookingOffers) == null ? void 0 : _D7$bookingOffers.coupon
  }))));
};

var _templateObject$1;
var ToastContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$1 || (_templateObject$1 = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\ttext-align: left;\n\n\t.icSuccessBig {\n\t\tmargin-right: 40px;\n\t}\n\n\t.successMsg__title {\n\t\t", "\n\t\tcolor: #00962d;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.successMsg__subTitle {\n\t\t", "\n\t\tcolor: #4f525a;\n\t}\n\n\t.closeIcon {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tright: 20px;\n\t\ttop: 20px;\n\t}\n"])), growth_design_system_esm/* headingSizes.MediumW1 */.$G.MediumW1, growth_design_system_esm/* textSizes.LargeW2 */.iH.LargeW2);

var ProfileCompletedToast = function ProfileCompletedToast(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Toast, {
    style: {
      'width': '600px',
      'background': '#fff',
      'padding': '30px 40px',
      'alignItems': 'center',
      'borderRadius': '10px',
      'maxHeight': 'unset',
      'zIndex': ' 1025'
    },
    autoHideDuration: 3000,
    onClose: onClose
  }, /*#__PURE__*/react.createElement(ToastContainer, null, /*#__PURE__*/react.createElement("span", {
    className: "logSprite icSuccessBig"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("h3", {
    className: "successMsg__title"
  }, "Congratulations"), /*#__PURE__*/react.createElement("p", {
    className: "successMsg__subTitle"
  }, "You have successfully logged in")), /*#__PURE__*/react.createElement("span", {
    className: " closeIcon logSprite icClose"
  }))));
};

var AuthVerificationFlow = function AuthVerificationFlow(props) {
  var _props$showCloseButto = props.showCloseButton,
      showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
      onClose = props.onClose,
      screenName = props.screenName,
      lobName = props.lobName,
      onLoginSuccess = props.onLoginSuccess,
      prefillMobileNumber = props.prefillMobileNumber,
      isMobileNumberDisabled = props.isMobileNumberDisabled,
      skipMobileScreen = props.skipMobileScreen;

  var _useAuthFlow = useAuthFlow(function (state) {
    return {
      activeAuthFlow: state.activeAuthFlow,
      setActiveAuthFlow: state.setActiveAuthFlow
    };
  }, shallow/* shallow */.X),
      activeAuthFlow = _useAuthFlow.activeAuthFlow,
      setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var _useState = (0,react.useState)(false),
      showSuccessToast = _useState[0],
      setShowSuccessToast = _useState[1];

  (0,react.useEffect)(function () {
    if (screenName) setActiveAuthFlow(screenName);
  }, [screenName]);
  (0,react.useEffect)(function () {
    pdt.setUserVars({
      ab_experiment: 'happy-auth',
      lob: lobName
    });
    pdt.track('HAPPY_AUTH_WEBA__UX_AUTH_COMP_RENDER');
    adobe.track('ctaClick', {
      cta: {
        name: 'Login_Popup_Load',
        type: "itemLoaded",
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);

  var closeAuth = function closeAuth() {
    pdt.track('HAPPY_AUTH_WEBA__CLICK_CLOSE_MODAL', {
      screen_name: activeAuthFlow
    });
    adobe.track('ctaClick', {
      cta: {
        name: "Close Modal",
        type: "itemClick|flow:" + activeAuthFlow,
        componentName: "GI_USER_ONBOARDING"
      }
    });
    (0,growth_auth_helpers_esm/* clearSendOtpStore */.ti)();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    if (onClose) onClose();
  };

  var onProfileComplete = function onProfileComplete() {
    setShowSuccessToast(true);
    if (onLoginSuccess) onLoginSuccess();
  };

  var closeAndLogin = function closeAndLogin() {
    var _window$GI;

    /** works on older header, gi-happy-header */

    /** @deprecated */
    if ((_window$GI = window.GI) != null && _window$GI.HeaderEvent) {
      window.GI.HeaderEvent.trigger('LOGIN_SUCCESS');
    }

    growth_dom_event_emitter_esm/* default.emit */.Z.emit(growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP);
    if (onLoginSuccess) onLoginSuccess();
    if (onClose) onClose();
  };

  var onLoginComplete = function onLoginComplete() {
    closeAndLogin();
  };

  if (showSuccessToast) {
    return /*#__PURE__*/react.createElement(ProfileCompletedToast, {
      onClose: onLoginComplete
    });
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(AuthOfferBanner, {
    lobName: lobName,
    showBanner: activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH
  }), /*#__PURE__*/react.createElement(AuthVerificationFlowSection, {
    height: activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH ? '486px' : undefined,
    "data-id": "auth-flow-section"
  }, showCloseButton && activeAuthFlow !== AUTH_FLOW_STEPS.STEP_POST_AUTH ? /*#__PURE__*/react.createElement(CloseIcon, {
    closeAuth: closeAuth
  }) : null, activeAuthFlow === AUTH_FLOW_STEPS.STEP_MOBILE && /*#__PURE__*/react.createElement(LoginWithMobile, {
    prefillMobileNumber: prefillMobileNumber,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_OTP && /*#__PURE__*/react.createElement(LoginWithOtp, {
    isMobileNumberDisabled: isMobileNumberDisabled
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH && /*#__PURE__*/react.createElement(UpdateProfile, {
    closeAndLogin: closeAndLogin,
    onProfileComplete: onProfileComplete,
    onLoginComplete: onLoginComplete
  })));
};

var AuthContainer = function AuthContainer(props) {
  var configData = props.configData;
  /** Memorize b/c we don't want to call the setData again if there in no change in configData */

  (0,react.useMemo)(function () {
    if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
  }, [configData]);

  var _useConfigStore = useConfigStore(function (s) {
    return {
      fetchConfigStore: s.fetch
    };
  }, shallow/* shallow */.X),
      fetchConfigStore = _useConfigStore.fetchConfigStore;

  (0,react.useEffect)(function () {
    fetchConfigStore({
      keys: CONFIG_KEY_DWEB_AUTH,
      lobs: 'COMMON',
      initData: configData
    });
  }, []);
  return /*#__PURE__*/react.createElement(AuthContainer$1, {
    "data-id": "auth-container"
  }, /*#__PURE__*/react.createElement(AuthVerificationFlow, props));
};

var growth_gi_dweb_auth_esm_templateObject;
var CommonSpriteStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(growth_gi_dweb_auth_esm_templateObject || (growth_gi_dweb_auth_esm_templateObject = growth_gi_dweb_auth_esm_taggedTemplateLiteralLoose(["\n\n  .logSprite {\n    background: url(https://gos3.ibcdn.com/happy-sprite-1608708553.png) no-repeat;\n    display: inline-block;\n    background-size: 300px 300px;\n    font-size: 0;\n    flex-shrink: 0;\n  }\n\n  .logSprite.icGift {\n    width: 42px;\n    height: 42px;\n    background-position: -10px -9px;\n  }\n\n  .logSprite.icClose {\n    width: 16px;\n    height: 16px;\n    background-position: -180px -8px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSuccessBig {\n    width: 41px;\n    height: 40px;\n    background-position: -60px -11px;\n  }\n\n  .logSprite.icSuccessSmall {\n    width: 19px;\n    height: 18px;\n    background-position: -132px -33px;\n  }\n\n  .logSprite.icShowPassword {\n    width: 17px;\n    height: 15px;\n    background-position: -105px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icSms {\n    width: 13px;\n    height: 12px;\n    background-position: -110px -39px;\n  }\n\n  .logSprite.icWhatsapp {\n    width: 13px;\n    height: 12px;\n    background-position: -157px -11px;\n  }\n\n  .logSprite.icInfoPink {\n    width: 18px;\n    height: 19px;\n    background-position: -131px -9px;\n    cursor: pointer;\n  }\n\n  .logSprite.icEdit {\n    width: 17px;\n    height: 17px;\n    background-position: -157px -34px;\n    cursor: pointer;\n  }\n\n  .logSprite.icOrangeTick {\n    width: 23px;\n    height: 23px;\n    background-position: -179px -29px;\n    cursor: pointer;\n  }\n\n  .ldrShimmer {\n    animation-duration: 1.5s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: shimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n    background-size: 800px 104px;\n    position: relative;\n  }\n\n\n\n"])));

var Container = function Container(_ref) {
  var prefillMobileNumber = _ref.prefillMobileNumber,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      onClose = _ref.onClose,
      lobName = _ref.lobName,
      onLoginSuccess = _ref.onLoginSuccess,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      _ref$isMobileNumberDi = _ref.isMobileNumberDisabled,
      isMobileNumberDisabled = _ref$isMobileNumberDi === void 0 ? false : _ref$isMobileNumberDi,
      _ref$skipMobileScreen = _ref.skipMobileScreen,
      skipMobileScreen = _ref$skipMobileScreen === void 0 ? false : _ref$skipMobileScreen,
      configData = _ref.configData;

  var _useState = (0,react.useState)(false),
      isOnClient = _useState[0],
      setIsOnClient = _useState[1];

  (0,react.useEffect)(function () {
    setIsOnClient(true);
  }, []);

  if (isOnClient) {
    var _initAnalytics = initAnalytics({
      lobName: lobName,
      debug: debug
    }),
        gaInstance = _initAnalytics.gaInstance,
        pdtInstance = _initAnalytics.pdtInstance,
        adobeInstance = _initAnalytics.adobeInstance;

    return /*#__PURE__*/react.createElement(styled_components_browser_esm/* ThemeProvider */.f6, {
      theme: growth_app_theme_esm/* defaultTheme */.uH
    }, /*#__PURE__*/react.createElement(CommonSpriteStyle, null), /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      gaInstance: gaInstance,
      pdtInstance: pdtInstance,
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(AuthContainer, {
      lobName: lobName,
      onLoginSuccess: onLoginSuccess,
      onClose: onClose,
      showCloseButton: showCloseButton,
      prefillMobileNumber: prefillMobileNumber,
      isMobileNumberDisabled: isMobileNumberDisabled,
      skipMobileScreen: skipMobileScreen,
      configData: configData
    })));
  }

  return null;
};




/***/ }),

/***/ 305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ CircularLoader; }
});

// UNUSED EXPORTS: FullPageLoaderMweb

;// CONCATENATED MODULE: ../../node_modules/@growth/loader/dist/taggedTemplateLiteralLoose-8a80a17d.esm.js
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../node_modules/@growth/loader/dist/growth-loader.esm.js




var _templateObject$1, _templateObject2$1;
var Loader = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  width: 60px;\n  margin: 0 auto;\n  border-radius: 10px;\n  position: relative;\n  background: #d1e5ff;\n  height: 4px;\n  top: ", ";\n"])), function (props) {
  return props.top ? props.top : '12px';
});
var LoaderBar = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  border-radius: 10px;\n  top: 0;\n  right: 100%;\n  bottom: 0;\n  left: 0;\n  background: #2276e3;\n  width: 0;\n  animation: borealisBar 1s linear infinite;\n\n  @keyframes borealisBar {\n    0% {\n      left: 0%;\n      right: 100%;\n      width: 0%;\n    }\n    10% {\n      left: 0%;\n      right: 54%;\n      width: 46%;\n    }\n    90% {\n      right: 54%;\n      width: 15%;\n    }\n    100% {\n      left: 100%;\n      right: 0%;\n      width: 0%;\n    }\n  }\n"])));

var FullPageLoaderMweb = function FullPageLoaderMweb(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/react.createElement(Loader, {
    top: top
  }, /*#__PURE__*/react.createElement(LoaderBar, null));
};

FullPageLoaderMweb.defaultProps = {
  top: '200px'
};

var _templateObject, _templateObject2;
var LoaderWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n"])));
var Spinner = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\tborder: solid 3px transparent;\n\tborder-top-color: #2276e3;\n\tborder-left-color: #2276e3;\n\tborder-right-color: #2276e3;\n\tborder-radius: 34px;\n\tanimation: loading-spinner 700ms linear infinite;\n\n\t@keyframes loading-spinner {\n\t\t0% {\n\t\t\ttransform: rotate(0deg);\n\t\t}\n\t\t100% {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n"])));

var CircularLoader = function CircularLoader() {
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoaderWrap, null, /*#__PURE__*/react.createElement(Spinner, null, "\xA0")));
};




/***/ }),

/***/ 7106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I8": function() { return /* binding */ deepClone; },
/* harmony export */   "RH": function() { return /* binding */ deepMerge; },
/* harmony export */   "ks": function() { return /* binding */ removeEmptyValues; }
/* harmony export */ });
/* unused harmony exports isEmptyObject, safeParse, safeStringify */
/**
 *
 * @param obj
 *
 * return boolean
 *
 * this method check if object is empty or not
 */
var isEmptyObject = function isEmptyObject(obj) {
  if (obj) {
    return Object.keys(obj).length === 0;
  }

  return true;
};
/**
 *
 * @param obj1
 * @param originalPayload
 *
 * this function will update the original payload
 */


var deepMerge = function deepMerge(obj1, originalPayload) {
  if (isEmptyObject(obj1)) {
    return originalPayload || {};
  }

  var recurse = function recurse(obj, current) {
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      var newKey = current;

      if (newKey[key] && typeof newKey[key] === 'object') {
        recurse(value, newKey[key]); // it's a nested object, so do it again
      } else {
        newKey[key] = value; // it's not an object, so set the property
      }
    });
  };

  (function (obj) {
    return recurse(obj, originalPayload);
  })(obj1);

  return originalPayload;
};

function removeEmptyValues(obj) {
  var newObj = Array.isArray(obj) ? [] : {};
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      var value = removeEmptyValues(obj[key]);

      if (Object.keys(value).length !== 0 || Array.isArray(value) && value.length !== 0) {
        newObj[key] = value;
      }
    } else if (obj[key] !== '' && obj[key] !== null && obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}

var safeStringify = function safeStringify(o) {
  try {
    return JSON.stringify(o);
  } catch (e) {
    return '';
  }
};

var safeParse = function safeParse(s) {
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
};

var deepClone = function deepClone(data) {
  if (typeof structuredClone === 'function') {
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
    try {
      return structuredClone(data);
    } catch (e) {
      return null;
    }
  }

  return safeParse(JSON.stringify(data));
};




/***/ }),

/***/ 1917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BK": function() { return /* binding */ isOnClient; },
/* harmony export */   "l_": function() { return /* binding */ getBaseHostName; }
/* harmony export */ });
/* unused harmony exports getHostPathName, getOriginUrl */
var globalAny = __webpack_require__.g;
/** Usage: Whether rendering is on client side or not */

var isOnClient = function f() {
  return typeof window !== 'undefined';
}();

var getBaseHostName = function getBaseHostName(hostname) {
  var host;
  host = '';

  if (isOnClient) {
    host = window.location.hostname;
  } else if (hostname) {
    host = hostname;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    host = globalAny == null ? void 0 : globalAny.hostname;
  }

  return host;
};

var getOriginUrl = function getOriginUrl() {
  var origin = '';

  if (isOnClient) {
    origin = window.location.origin;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    origin = globalAny == null ? void 0 : globalAny.origin;
  }

  return origin;
};

var getHostPathName = function getHostPathName() {
  var pathname = '';

  if (isOnClient) {
    pathname = window.location.pathname;
  } else if (!isOnClient && typeof __webpack_require__.g !== 'undefined') {
    pathname = globalAny == null ? void 0 : globalAny.pathname;
  }

  return pathname;
};




/***/ }),

/***/ 6880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DEFAULT_STATE; },
/* harmony export */   "x": function() { return /* binding */ fetchSetter; }
/* harmony export */ });
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchSetter = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var set, fetchFun, onError, onSuccess, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            set = _ref.set, fetchFun = _ref.fetchFun, onError = _ref.onError, onSuccess = _ref.onSuccess;
            set({
              loading: true
            });
            _context.prev = 2;
            _context.next = 5;
            return fetchFun();

          case 5:
            res = _context.sent;
            set(function (state) {
              return {
                data: _extends({}, state.data, res),
                loaded: true,
                loading: false,
                error: false
              };
            });
            onSuccess == null ? void 0 : onSuccess(res);
            return _context.abrupt("return", res);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            set({
              loaded: true,
              loading: false,
              error: _context.t0
            });
            onError == null ? void 0 : onError(_context.t0);

          case 15:
            return _context.abrupt("return", {});

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function fetchSetter(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var DEFAULT_STATE = {
  data: {},
  loading: false,
  loaded: false,
  error: null
};




/***/ }),

/***/ 7792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ToolTip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);



function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    padding: 10px;\n    border-radius: 6px;\n    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);\n    background-color: #fff;\n    position: absolute;\n    border: 1px solid #efefef;\n\n  .left::after,\n  .left::before {\n    bottom: 100%;\n    left: 20%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .left::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .left::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n  .right::after,\n  .right::before {\n    bottom: 100%;\n    left: 80%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .right::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .right::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n  .middle::after,\n  .middle::before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .middle::after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: #fff;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n\n  .middle::before {\n    border-color: rgba(239, 239, 239, 0);\n    border-bottom-color: #efefef;\n    border-width: 9px;\n    margin-left: -9px;\n  }\n\n"])));

var ToolTip = function ToolTip(props) {
  var customClass = props.customClass,
      notchPosition = props.notchPosition,
      customStyle = props.customStyle,
      children = props.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tooltip, {
    className: (customClass || '') + " " + (notchPosition || ''),
    style: customStyle
  }, children);
};




/***/ }),

/***/ 2390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nx": function() { return /* binding */ AnalyticsContextProvider; },
/* harmony export */   "z$": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* unused harmony export analyticsState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var analyticsState = {
  ga: {
    initialize: function initialize() {},
    setUserVars: function setUserVars() {},
    track: function track() {}
  },
  pdt: {
    initialize: function initialize() {},
    setUserVars: function setUserVars() {},
    track: function track() {}
  },
  adobe: {
    initialize: function initialize() {
      return console.log('Adobe initialize is not available');
    },
    track: function track() {
      return console.log('Adobe track is not initialized');
    },
    pageView: function pageView() {
      return console.log('Adobe pageView is not initialized');
    }
  },
  analyticsTrackAll: function analyticsTrackAll() {}
};
var AnalyticsContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(analyticsState);

var AnalyticsContextProvider = function AnalyticsContextProvider(props) {
  var children = props.children,
      gaInstance = props.gaInstance,
      pdtInstance = props.pdtInstance,
      adobeInstance = props.adobeInstance;

  var analyticsTrackAll = function analyticsTrackAll(eventName, obj) {
    if (gaInstance) gaInstance.track(eventName, obj);
    if (pdtInstance) pdtInstance.track(eventName, obj);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AnalyticsContext.Provider, {
    value: {
      ga: gaInstance,
      pdt: pdtInstance,
      adobe: adobeInstance || analyticsState.adobe,
      analyticsTrackAll: analyticsTrackAll
    }
  }, children);
};

var useAnalytics = function useAnalytics() {
  var state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AnalyticsContext);
  return _extends({}, state);
};




/***/ }),

/***/ 6253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ isAndroidClient; },
/* harmony export */   "hf": function() { return /* binding */ getBrowserDetails; },
/* harmony export */   "qF": function() { return /* binding */ isIOSSafariBrowser; }
/* harmony export */ });
/* unused harmony exports ClientNames, getClientOS, getDeviceType, isIOSClient, isLightHouseAgent, isMobileDevice */
/* harmony import */ var _growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1917);


/* eslint-disable prefer-destructuring */
var ClientNames;

(function (ClientNames) {
  ClientNames["ANDROID"] = "android";
  ClientNames["IOS"] = "ios";
  ClientNames["SAFARI"] = "safari";
  ClientNames["LIGHTHOUSE"] = "lighthouse";
  ClientNames["OTHER"] = "other";
  ClientNames["LINUX"] = "linux";
  ClientNames["MAC"] = "mac";
  ClientNames["WINDOWS"] = "windows";
})(ClientNames || (ClientNames = {}));

var getClientOS = function getClientOS(userAgent) {
  /* const clientStrings = [
  		{ s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
  		{ s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
  		{ s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
  		{ s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
  		{ s: 'Windows Vista', r: /Windows NT 6.0/ },
  		{ s: 'Windows Server 2003', r: /Windows NT 5.2/ },
  		{ s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
  		{ s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
  		{ s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
  		{ s: 'Windows 98', r: /(Windows 98|Win98)/ },
  		{ s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
  		{ s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
  		{ s: 'Windows CE', r: /Windows CE/ },
  		{ s: 'Windows 3.11', r: /Win16/ },
  		{ s: 'Android', r: /Android/ },
  		{ s: 'Open BSD', r: /OpenBSD/ },
  		{ s: 'Sun OS', r: /SunOS/ },
  		{ s: 'Linux', r: /(Linux|X11)/ },
  		{ s: 'iOS', r: /(iPhone|iPad|iPod)/ },
  		{ s: 'Mac OS X', r: /Mac OS X/ },
  		{ s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
  		{ s: 'QNX', r: /QNX/ },
  		{ s: 'UNIX', r: /UNIX/ },
  		{ s: 'BeOS', r: /BeOS/ },
  		{ s: 'OS/2', r: /OS\/2/ },
  		{ s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
  	];
  */
  var ua = userAgent || '';
  if (_growth_ssr_utils__WEBPACK_IMPORTED_MODULE_0__/* .isOnClient */ .BK && !ua) ua = window.navigator.userAgent || window.navigator.vendor; // add more if requires
  // ...

  if (/Android/.test(ua)) return ClientNames.ANDROID;
  if (/(iPhone|iPad|iPod)/.test(ua)) return ClientNames.IOS;
  if (/iPhone|iPad|iPod/.test(ua) && /Safari/.test(ua)) return ClientNames.SAFARI;
  if (/Linux/i.test(ua)) return ClientNames.LINUX;
  if (/Mac/i.test(ua)) return ClientNames.MAC;
  if (/Windows/i.test(ua)) return ClientNames.WINDOWS;
  return ClientNames.OTHER;
};

var isIOSClient = function isIOSClient(userAgent) {
  return getClientOS(userAgent) === ClientNames.IOS;
};

var isAndroidClient = function isAndroidClient(userAgent) {
  return getClientOS(userAgent) === ClientNames.ANDROID;
};

var isIOSSafariBrowser = function isIOSSafariBrowser(userAgent) {
  return getClientOS(userAgent) === ClientNames.SAFARI;
};

var isLightHouseAgent = function isLightHouseAgent(userAgent) {
  var ua = userAgent;
  if (isOnClient && !userAgent) ua = window.navigator.userAgent || window.navigator.vendor;

  if (typeof ua === 'string') {
    return /Chrome-Lighthouse/.test(ua);
  }

  return false;
};

var getDeviceType = function getDeviceType() {
  if (isIOSClient()) return ClientNames.IOS;
  if (isAndroidClient()) return ClientNames.ANDROID;
  return ClientNames.OTHER;
};

var getBrowserDetails = function getBrowserDetails() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;
  var browserName;
  var browserVersion;

  if (/opera|opr/i.test(userAgent)) {
    // Opera browser
    browserName = 'Opera';
    var operaVersion = userAgent.match(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i);

    if (operaVersion) {
      browserVersion = operaVersion[1];
    }
  } else if (/edge|edg/i.test(userAgent)) {
    // Microsoft Edge browser
    browserName = 'Microsoft Edge';
    var edgeVersion = userAgent.match(/(?:edge|edg)\/(\d+(\.\d+)?)/i);

    if (edgeVersion) {
      browserVersion = edgeVersion[1];
    }
  } else if (/chrome|crios/i.test(userAgent)) {
    // Chrome browser
    browserName = 'Chrome';
    var chromeVersion = userAgent.match(/(?:chrome|crios)\/(\d+(\.\d+)?)/i);

    if (chromeVersion) {
      browserVersion = chromeVersion[1];
    }
  } else if (/safari/i.test(userAgent)) {
    // Safari browser
    browserName = 'Safari';
    var safariVersion = userAgent.match(/version\/(\d+(\.\d+)?)/i);

    if (safariVersion) {
      browserVersion = safariVersion[1];
    }
  } else if (/firefox|fxios/i.test(userAgent)) {
    // Firefox browser
    browserName = 'Firefox';
    var firefoxVersion = userAgent.match(/(?:firefox|fxios)\/(\d+(\.\d+)?)/i);

    if (firefoxVersion) {
      browserVersion = firefoxVersion[1];
    }
  } else if (/msie|trident/i.test(userAgent)) {
    // Internet Explorer browser
    browserName = 'Internet Explorer';
    var ieVersion = userAgent.match(/(?:msie |rv:)(\d+(\.\d+)?)/i);

    if (ieVersion) {
      browserVersion = ieVersion[1];
    }
  } else {
    browserName = 'Unknown';
    browserVersion = 'Unknown';
  }

  return {
    browserName: browserName,
    browserVersion: browserVersion
  };
};

var isMobileDevice = function isMobileDevice(userAgent) {
  return /Mobi/i.test(userAgent || window.navigator.userAgent);
};




/***/ }),

/***/ 6939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "im": function() { return /* reexport */ helper_bc63c3dd_esm_generateVid; },
  "MI": function() { return /* binding */ getVisitorIdBrowser; }
});

// UNUSED EXPORTS: config, visitorIdBrowser

// EXTERNAL MODULE: ../../node_modules/@growth/cookies/dist/growth-cookies.esm.js
var growth_cookies_esm = __webpack_require__(2048);
;// CONCATENATED MODULE: ../../node_modules/@growth/visitor-id/dist/helper-bc63c3dd.esm.js
// constant
var helper_bc63c3dd_esm_C = {
  CookieName: '__gi_vid',
  MaxAgeDay: 365,
  // 1 year
  Domain: '.goibibo.com'
}; // vid generator function

var helper_bc63c3dd_esm_generateVid = function generateVid() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    /* eslint-disable-next-line no-bitwise */
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    /* eslint-disable-next-line no-bitwise */

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};



;// CONCATENATED MODULE: ../../node_modules/@growth/visitor-id/browser/dist/growth-visitor-id-browser.esm.js




function visitorIdBrowser(options) {
  var opts = options || {}; // if vid cookie is present

  if (getItem(C.CookieName)) {
    if (opts.debug) console.info('DEBUG visitorIdBrowser: visitorId cookie is already present in browser');
    return true;
  } // if vid is not present in cookie


  var vid = generateVid();
  setItem(C.CookieName, vid, {
    expires: C.MaxAgeDay * 24 * 60 * 60,
    path: "/",
    domain: C.Domain,
    secure: true
  });
  if (opts.debug) console.info('DEBUG visitorIdBrowser: new visitorId cookie has been set to browser');
  return true;
}

var getVisitorIdBrowser = function getVisitorIdBrowser() {
  var vid = (0,growth_cookies_esm/* getItem */.rV)(helper_bc63c3dd_esm_C.CookieName);
  return vid || undefined;
};




/***/ }),

/***/ 2019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebAnalytics; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var WebAnalytics = /*#__PURE__*/function () {
  function WebAnalytics() {}

  var _proto = WebAnalytics.prototype;

  // ! a not null assertion
  _proto.initialize = function initialize(O) {
    this.plugin = O.plugin;
    this.eventNames = O.eventNames;
    this.globalProperties = O.globalProperties;
    this.debug = O.debug;
    this.globalVars = _extends({}, O.globalProperties);
    this.plugin.init();
  };

  _proto.setUserVars = function setUserVars(globalVars) {
    this.globalVars = _extends({}, this.globalVars, globalVars);
    return this.globalVars;
  };

  _proto.track = function track(eventName, properties) {
    try {
      if (!eventName || typeof eventName !== 'string') {
        throw new TypeError('eventName is missing or invalid in webAnalytics().track()');
      }

      if (this.eventNames && !this.eventNames.has(eventName)) {
        throw new TypeError("unknown track webAalyticsEventName \"" + eventName + "\"");
      }

      if (this.debug) {
        /* eslint-disable-next-line no-console */
        console.log("webAnalytics " + this.plugin.name, 'track', {
          event: eventName,
          eventProperties: properties,
          globalProperties: this.globalVars
        });
      }

      var payload = {
        event: eventName,
        eventProperties: properties,
        globalProperties: this.globalVars
      };
      return this.plugin.track({
        payload: payload
      });
    } catch (e) {
      if (this.debug) console.log(e);
      return e;
    }
  };

  _proto.pageView = function pageView(pageName, properties) {
    if (!this.plugin.pageView) {
      throw new Error(this.plugin.name + " plugin does not support pageView property");
    }

    if (!pageName) {
      throw new Error('pageName is mandatory to send page view event');
    }

    var payload = {
      eventProperties: _extends({}, properties),
      globalProperties: this.globalVars
    };

    if (this.debug) {
      /* eslint-disable-next-line no-console */
      console.log("webAnalytics " + this.plugin.name, 'page', _extends({}, payload));
    }

    if (this.plugin.pageView) this.plugin.pageView(pageName, payload);
  };

  return WebAnalytics;
}();




/***/ }),

/***/ 156:
/***/ (function(module) {

/*! For license information please see index.js.LICENSE.txt */
!function(t,e){ true?module.exports=e():0}(this,(()=>(()=>{var t={609:(t,e,r)=>{var n=r(425).default;function o(){"use strict";t.exports=o=function(){return r},t.exports.__esModule=!0,t.exports.default=t.exports;var e,r={},i=Object.prototype,a=i.hasOwnProperty,l=Object.defineProperty||function(t,e,r){t[e]=r.value},c="function"==typeof Symbol?Symbol:{},u=c.iterator||"@@iterator",s=c.asyncIterator||"@@asyncIterator",f=c.toStringTag||"@@toStringTag";function p(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{p({},"")}catch(e){p=function(t,e,r){return t[e]=r}}function h(t,e,r,n){var o=e&&e.prototype instanceof w?e:w,i=Object.create(o.prototype),a=new k(n||[]);return l(i,"_invoke",{value:I(t,r,a)}),i}function y(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}r.wrap=h;var d="suspendedStart",m="suspendedYield",g="executing",v="completed",b={};function w(){}function x(){}function S(){}var E={};p(E,u,(function(){return this}));var _=Object.getPrototypeOf,O=_&&_(_(P([])));O&&O!==i&&a.call(O,u)&&(E=O);var F=S.prototype=w.prototype=Object.create(E);function L(t){["next","throw","return"].forEach((function(e){p(t,e,(function(t){return this._invoke(e,t)}))}))}function C(t,e){function r(o,i,l,c){var u=y(t[o],t,i);if("throw"!==u.type){var s=u.arg,f=s.value;return f&&"object"==n(f)&&a.call(f,"__await")?e.resolve(f.__await).then((function(t){r("next",t,l,c)}),(function(t){r("throw",t,l,c)})):e.resolve(f).then((function(t){s.value=t,l(s)}),(function(t){return r("throw",t,l,c)}))}c(u.arg)}var o;l(this,"_invoke",{value:function(t,n){function i(){return new e((function(e,o){r(t,n,e,o)}))}return o=o?o.then(i,i):i()}})}function I(t,r,n){var o=d;return function(i,a){if(o===g)throw new Error("Generator is already running");if(o===v){if("throw"===i)throw a;return{value:e,done:!0}}for(n.method=i,n.arg=a;;){var l=n.delegate;if(l){var c=T(l,n);if(c){if(c===b)continue;return c}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(o===d)throw o=v,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);o=g;var u=y(t,r,n);if("normal"===u.type){if(o=n.done?v:m,u.arg===b)continue;return{value:u.arg,done:n.done}}"throw"===u.type&&(o=v,n.method="throw",n.arg=u.arg)}}}function T(t,r){var n=r.method,o=t.iterator[n];if(o===e)return r.delegate=null,"throw"===n&&t.iterator.return&&(r.method="return",r.arg=e,T(t,r),"throw"===r.method)||"return"!==n&&(r.method="throw",r.arg=new TypeError("The iterator does not provide a '"+n+"' method")),b;var i=y(o,t.iterator,r.arg);if("throw"===i.type)return r.method="throw",r.arg=i.arg,r.delegate=null,b;var a=i.arg;return a?a.done?(r[t.resultName]=a.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,b):a:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,b)}function j(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function A(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function k(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(j,this),this.reset(!0)}function P(t){if(t||""===t){var r=t[u];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var o=-1,i=function r(){for(;++o<t.length;)if(a.call(t,o))return r.value=t[o],r.done=!1,r;return r.value=e,r.done=!0,r};return i.next=i}}throw new TypeError(n(t)+" is not iterable")}return x.prototype=S,l(F,"constructor",{value:S,configurable:!0}),l(S,"constructor",{value:x,configurable:!0}),x.displayName=p(S,f,"GeneratorFunction"),r.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===x||"GeneratorFunction"===(e.displayName||e.name))},r.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,S):(t.__proto__=S,p(t,f,"GeneratorFunction")),t.prototype=Object.create(F),t},r.awrap=function(t){return{__await:t}},L(C.prototype),p(C.prototype,s,(function(){return this})),r.AsyncIterator=C,r.async=function(t,e,n,o,i){void 0===i&&(i=Promise);var a=new C(h(t,e,n,o),i);return r.isGeneratorFunction(e)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},L(F),p(F,f,"Generator"),p(F,u,(function(){return this})),p(F,"toString",(function(){return"[object Generator]"})),r.keys=function(t){var e=Object(t),r=[];for(var n in e)r.push(n);return r.reverse(),function t(){for(;r.length;){var n=r.pop();if(n in e)return t.value=n,t.done=!1,t}return t.done=!0,t}},r.values=P,k.prototype={constructor:k,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(A),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(n,o){return l.type="throw",l.arg=t,r.next=n,o&&(r.method="next",r.arg=e),!!o}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],l=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var c=a.call(i,"catchLoc"),u=a.call(i,"finallyLoc");if(c&&u){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(c){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,b):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),b},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),A(r),b}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var n=r.completion;if("throw"===n.type){var o=n.arg;A(r)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(t,r,n){return this.delegate={iterator:P(t),resultName:r,nextLoc:n},"next"===this.method&&(this.arg=e),b}},r}t.exports=o,t.exports.__esModule=!0,t.exports.default=t.exports},425:t=>{function e(r){return t.exports=e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t.exports.__esModule=!0,t.exports.default=t.exports,e(r)}t.exports=e,t.exports.__esModule=!0,t.exports.default=t.exports},841:(t,e,r)=>{var n=r(609)();t.exports=n;try{regeneratorRuntime=n}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}}},e={};function r(n){var o=e[n];if(void 0!==o)return o.exports;var i=e[n]={exports:{}};return t[n](i,i.exports,r),i.exports}r.d=(t,e)=>{for(var n in e)r.o(e,n)&&!r.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},r.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),r.r=t=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})};var n={};return(()=>{"use strict";function t(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=new Array(e);r<e;r++)n[r]=t[r];return n}r.r(n),r.d(n,{LS_LIST:()=>O,addKeyConfigMapping:()=>b,getItem:()=>j,handleLocalStorageInGdpr:()=>A,itemType:()=>f,removeItem:()=>T,setItem:()=>I});const e="undefined"!=typeof window;var o,i,a="awefewfuihewfhewfuhiebc",l="limitedConsent",c="enct-",u="GDPR_C",s="clearLocalStorage",f={ES:"essential",N_ES:"nonEssential"};function p(t){return p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},p(t)}function h(t,e,r){return(e=function(t){var e=function(t,e){if("object"!==p(t)||null===t)return t;var r=t[Symbol.toPrimitive];if(void 0!==r){var n=r.call(t,"string");if("object"!==p(n))return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(t)}(t);return"symbol"===p(e)?e:String(e)}(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}var y="GI",d="IGO",m="AFFCGOBIZMMTAIX",g=(h(o={},y,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),h(o,d,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),h(o,m,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),h(i={},y,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),h(i,d,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(t){var r,n,o=t||"";e&&(o=(null===(r=window)||void 0===r||null===(n=r.location)||void 0===n?void 0:n.hostname)||"");var i="";return o&&(-1!==o.indexOf("giholidays")?i=y:-1!==o.indexOf("6eholidays")?i=d:-1!==o.indexOf("hdfcsmartbuyholidays")?i="HDFC_SB":-1!==o.indexOf("airindiaexpressholidays")?i=m:-1!==o.indexOf("flightsexpert.goibibo")?i="AFFCGOBIZGIFLTEXP":-1!==o.indexOf("flightsexpert.makemytrip")&&(i="AFFCGOBIZMMTFLTEXP")),i}),v={},b=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};v[t]=e},w=function(t,r,n,o){var i,a,l=n,c=o,u=(null==v?void 0:v[t])||{};return e&&(l=void 0===n?(null===(i=u[r])||void 0===i?void 0:i.type)||f.N_ES:n,c=void 0===o?(null===(a=u[r])||void 0===a?void 0:a.isPiiData)||!1:o),{essential:l=l===f.ES,piiData:c}},x=function(t){var e,r,n=function(t){return new RegExp("(?:^|;\\s*)".concat(t,"\\s*=\\s*([^;]*)"))}((e=t,(r=g(undefined).toLowerCase())?"".concat(e,"-").concat(r):e)),o=n.exec(document.cookie);return null!==o?decodeURIComponent(o[1]):null},S=function(){return"1"===x("isGdprRegion")},E=function(){var t=x("myBusinessSubscription"),e=x("mmt-auth"),r=null==e?void 0:e.charAt(e.length-1);return!(!t||"b2b"!==t)||"C"===r},_=function(){return!S()||!!E()||(!(t=x(u))||"IS"!==t&&"11"!==t?"fullConsent":l)!==l;var t},O="localStorageList",F="$localStorageExp$",L=(r(841),function(){return e&&g()?".".concat(window.location.hostname):".makemytrip.com"}),C=function(t){return new TypeError("Valid key & value is required for localstorage ".concat(t))},I=function(t,r,n,o){try{if(!e||!localStorage)return!1;if(!t||void 0===r)throw C("get");var i,l=(n||{}).isPiiData,u=(n||{}).shouldStringifyJson,s=w(O,t,o,l);if(i=s.essential,l=s.piiData,!i&&!_())return!1;var f=u?function(t){try{return JSON.stringify(t)}catch(t){return null}}(r):r;if(f&&l){var p=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during encryption:",t),null}}(f,a);if(!p)return!1;f="".concat(c).concat(p)}var h=(n||{}).expiry;if(h){var y="".concat(f).concat(F).concat(h);localStorage.setItem(t,y)}else localStorage.setItem(t,f);return!0}catch(t){return!1}},T=function(t){try{if(!e||!localStorage)return!1;if(!t)throw C("get");return localStorage.removeItem(t),!0}catch(t){return!1}},j=function(r){var n,o,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},l=arguments.length>2?arguments[2]:void 0;try{var u,s;if(!e||!localStorage)return null;if(!r)throw C("get");var f,p=(i||{}).isPiiData,h=(i||{}).shouldParseJson,y=w(O,r,l,p);if(f=y.essential,p=y.piiData,!f&&!_())return null;var d=localStorage.getItem(r),m=null;if(null!==(u=d)&&void 0!==u&&u.includes(F)){var g=(n=d.split(F),o=2,function(t){if(Array.isArray(t))return t}(n)||function(t,e){var r=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=r){var n,o,i,a,l=[],c=!0,u=!1;try{if(i=(r=r.call(t)).next,0===e){if(Object(r)!==r)return;c=!1}else for(;!(c=(n=i.call(r)).done)&&(l.push(n.value),l.length!==e);c=!0);}catch(t){u=!0,o=t}finally{try{if(!c&&null!=r.return&&(a=r.return(),Object(a)!==a))return}finally{if(u)throw o}}return l}}(n,o)||function(e,r){if(e){if("string"==typeof e)return t(e,r);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?t(e,r):void 0}}(n,o)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}());d=g[0],m=g[1]}var v=d;if(void 0===v)return null;if(p&&null!==(s=v)&&void 0!==s&&s.includes(c)){var b=new RegExp("^".concat(c));v=function(t,e){try{var r="",n=0;if(!e)throw new Error("Key is empty");for(var o=0;o<t.length;o+=1){var i=t.charCodeAt(o)^e.charCodeAt(n);r+=String.fromCharCode(i),n=(n+1)%e.length}return r}catch(t){return console.error("An error occurred during the decryption process:",t),null}}(v=v.replace(b,""),a)}if(h&&(v=function(t){try{return JSON.parse(t)}catch(t){return null}}(v)),!m)return v;var x=new Date;return new Date(m)<x?(T(r),null):v}catch(t){return null}},A=function(){var t,e,r,n=null===(t=window)||void 0===t||null===(e=t.app_bridge)||void 0===e||null===(r=e.getUserConsent)||void 0===r?void 0:r.call(e);n&&!x(u)&&(document.cookie="".concat(u,"=").concat(n,"; domain=").concat(L(),"; path=/; secure")),S()&&!n&&x(s)&&(E()||(localStorage.clear(),document.cookie="".concat(s,"=; max-age=0; path=/; domain=.makemytrip.com; secure")))}})(),n})()));

/***/ }),

/***/ 8456:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(()=>(()=>{"use strict";var e={d:(t,r)=>{for(var o in r)e.o(r,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:r[o]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};e.r(t),e.d(t,{SS_LIST:()=>S,addKeyConfigMapping:()=>g,getItemBySession:()=>I,itemType:()=>l,removeItemBySession:()=>w,setItemBySession:()=>C});const r="undefined"!=typeof window;var o,i,n="awefewfuihewfhewfuhiebc",a="limitedConsent",s="enct-",l={ES:"essential",N_ES:"nonEssential"};function u(e){return u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u(e)}function c(e,t,r){return(t=function(e){var t=function(e,t){if("object"!==u(e)||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var o=r.call(e,"string");if("object"!==u(o))return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return"symbol"===u(t)?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}var f="GI",d="IGO",y="AFFCGOBIZMMTAIX",m=(c(o={},f,{colors:{base:{primary:"#016eff"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap"],family:"'Quicksand', sans-serif",familyHeading:"'Quicksand', sans-serif"}}),c(o,d,{colors:{base:{primary:"#00228E"},button:{primary:{bg:"linear-gradient(93deg, #00228E, #00228E)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),c(o,y,{colors:{base:{primary:"#FF6423"},button:{primary:{bg:"linear-gradient(93deg, #FF6D38, #FF6D38)",text:"#FFFFFF"}}},style:{button:{borderRadius:"8px"}},font:{urls:["https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900&display=swap","https://db.onlinewebfonts.com/c/390289fedd068780e28c0f9f259c3782?family=ITC+Bauhaus"],family:"'Lato'",familyHeading:"'ITC Bauhaus'"}}),c(i={},f,{ACCOUNTS_TERMS_CONDITION:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://giholidays.makemytrip.com/legal/gi/privacy_policy.html",TERMS_OF_SERVICE:"https://giholidays.makemytrip.com/legal/gi/user_agreement.html#tos"}),c(i,d,{ACCOUNTS_TERMS_CONDITION:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html",ACCOUNTS_PRIVACY_URL:"https://6eholidays.makemytrip.com/legal/igo/privacy_policy.html",TERMS_OF_SERVICE:"https://6eholidays.makemytrip.com/legal/igo/user_agreement.html#tos"}),function(e){var t,o,i=e||"";r&&(i=(null===(t=window)||void 0===t||null===(o=t.location)||void 0===o?void 0:o.hostname)||"");var n="";return i&&(-1!==i.indexOf("giholidays")?n=f:-1!==i.indexOf("6eholidays")?n=d:-1!==i.indexOf("hdfcsmartbuyholidays")?n="HDFC_SB":-1!==i.indexOf("airindiaexpressholidays")?n=y:-1!==i.indexOf("flightsexpert.goibibo")?n="AFFCGOBIZGIFLTEXP":-1!==i.indexOf("flightsexpert.makemytrip")&&(n="AFFCGOBIZMMTFLTEXP")),n}),p={},g=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};p[e]=t},h=function(e,t,o,i){var n,a,s=o,u=i,c=(null==p?void 0:p[e])||{};return r&&(s=void 0===o?(null===(n=c[t])||void 0===n?void 0:n.type)||l.N_ES:o,u=void 0===i?(null===(a=c[t])||void 0===a?void 0:a.isPiiData)||!1:i),{essential:s=s===l.ES,piiData:u}},v=function(e){var t,r,o=function(e){return new RegExp("(?:^|;\\s*)".concat(e,"\\s*=\\s*([^;]*)"))}((t=e,(r=m(undefined).toLowerCase())?"".concat(t,"-").concat(r):t)),i=o.exec(document.cookie);return null!==i?decodeURIComponent(i[1]):null},b=function(){var e,t,r,o;return"1"!==v("isGdprRegion")||(e=v("myBusinessSubscription"),r=null==(t=v("mmt-auth"))?void 0:t.charAt(t.length-1),!!(e&&"b2b"===e||"C"===r)||(!(o=v("GDPR_C"))||"IS"!==o&&"11"!==o?"fullConsent":a)!==a)},S="sessionList",F=function(e){return new TypeError("Valid key & value is required for sessionStorage ".concat(e))},C=function(e,t,o,i){try{if(!r||!sessionStorage)return!1;if(!e||void 0===t)throw F("get");var a,l=(o||{}).isPiiData,u=(o||{}).shouldStringifyJson,c=h(S,e,i,l);if(a=c.essential,l=c.piiData,!a&&!b())return!1;var f=u?function(e){try{return JSON.stringify(e)}catch(e){return null}}(t):t;if(f&&l){var d=function(e,t){try{var r="",o=0;if(!t)throw new Error("Key is empty");for(var i=0;i<e.length;i+=1){var n=e.charCodeAt(i)^t.charCodeAt(o);r+=String.fromCharCode(n),o=(o+1)%t.length}return r}catch(e){return console.error("An error occurred during encryption:",e),null}}(f,n);if(!d)return!1;f="".concat(s).concat(d)}return sessionStorage.setItem(e,f),!0}catch(e){return!1}},w=function(e){try{if(!r||!sessionStorage)return!1;if(!e)throw F("get");return sessionStorage.removeItem(e),!0}catch(e){return!1}},I=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=arguments.length>2?arguments[2]:void 0;try{var i;if(!r||!sessionStorage)return null;if(!e)throw F("get");var a,l=(t||{}).isPiiData,u=(t||{}).shouldParseJson,c=h(S,e,o,l);if(a=c.essential,l=c.piiData,!a&&!b())return null;var f=sessionStorage.getItem(e);if(l&&null!==(i=f)&&void 0!==i&&i.includes(s)){var d=new RegExp("^".concat(s));f=function(e,t){try{var r="",o=0;if(!t)throw new Error("Key is empty");for(var i=0;i<e.length;i+=1){var n=e.charCodeAt(i)^t.charCodeAt(o);r+=String.fromCharCode(n),o=(o+1)%t.length}return r}catch(e){return console.error("An error occurred during the decryption process:",e),null}}(f=f.replace(d,""),n)}return u&&(f=function(e){try{return JSON.parse(e)}catch(e){return null}}(f)),f}catch(e){return!1}};return t})()));

/***/ }),

/***/ 9644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5644);

/***/ }),

/***/ 353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var settle = __webpack_require__(6955);
var cookies = __webpack_require__(2233);
var buildURL = __webpack_require__(8030);
var buildFullPath = __webpack_require__(7948);
var parseHeaders = __webpack_require__(1875);
var isURLSameOrigin = __webpack_require__(842);
var transitionalDefaults = __webpack_require__(8560);
var AxiosError = __webpack_require__(1218);
var CanceledError = __webpack_require__(8047);
var parseProtocol = __webpack_require__(738);
var platform = __webpack_require__(7721);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var withXSRFToken = config.withXSRFToken;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, req) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    // false, 0 (zero number), and '' (empty string) are valid JSON values
    if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 5644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var bind = __webpack_require__(3644);
var Axios = __webpack_require__(2215);
var mergeConfig = __webpack_require__(2937);
var defaults = __webpack_require__(663);
var formDataToJSON = __webpack_require__(9468);
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(8047);
axios.CancelToken = __webpack_require__(4089);
axios.isCancel = __webpack_require__(8041);
axios.VERSION = (__webpack_require__(9241).version);
axios.toFormData = __webpack_require__(9027);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(1218);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(783);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(5587);

axios.formToJSON = function(thing) {
  return formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
};

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 4089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(8047);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i = token._listeners.length;

    while (i-- > 0) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message, config, request) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message, config, request);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 8047:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(1218);
var utils = __webpack_require__(3044);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 8041:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 2215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var buildURL = __webpack_require__(8030);
var InterceptorManager = __webpack_require__(946);
var dispatchRequest = __webpack_require__(6895);
var mergeConfig = __webpack_require__(2937);
var buildFullPath = __webpack_require__(7948);
var validator = __webpack_require__(7525);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  var paramsSerializer = config.paramsSerializer;

  utils.isFunction(paramsSerializer) && (config.paramsSerializer = {serialize: paramsSerializer});

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 1218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Clear all interceptors from the stack
 */
InterceptorManager.prototype.clear = function clear() {
  if (this.handlers) {
    this.handlers = [];
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 7948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(9192);
var combineURLs = __webpack_require__(8762);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 6895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var transformData = __webpack_require__(8556);
var isCancel = __webpack_require__(8041);
var defaults = __webpack_require__(663);
var CanceledError = __webpack_require__(8047);
var normalizeHeaderName = __webpack_require__(8868);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    null,
    config.transformRequest
  );

  normalizeHeaderName(config.headers, 'Accept');
  normalizeHeaderName(config.headers, 'Content-Type');

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      response.status,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          reason.response.status,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 2937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isEmptyObject(source)) {
      return utils.merge({}, target);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'withXSRFToken': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(1218);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var defaults = __webpack_require__(663);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, status, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers, status);
  });

  return data;
};


/***/ }),

/***/ 663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4406);


var utils = __webpack_require__(3044);
var normalizeHeaderName = __webpack_require__(8868);
var AxiosError = __webpack_require__(1218);
var transitionalDefaults = __webpack_require__(8560);
var toFormData = __webpack_require__(9027);
var toURLEncodedForm = __webpack_require__(1746);
var platform = __webpack_require__(7721);
var formDataToJSON = __webpack_require__(9468);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(353);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(353);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    var contentType = headers && headers['Content-Type'] || '';
    var hasJSONContentType = contentType.indexOf('application/json') > -1;
    var isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    var isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        var _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 8560:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 5694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// eslint-disable-next-line strict
module.exports = __webpack_require__(1688);


/***/ }),

/***/ 9241:
/***/ (function(module) {

module.exports = {
  "version": "0.28.0"
};

/***/ }),

/***/ 3831:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toFormData = __webpack_require__(9027);

function encode(str) {
  var charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

var prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  var _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

module.exports = AxiosURLSearchParams;


/***/ }),

/***/ 3644:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
};


/***/ }),

/***/ 8030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var AxiosURLSearchParams = __webpack_require__(3831);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var hashmarkIndex = url.indexOf('#');

  if (hashmarkIndex !== -1) {
    url = url.slice(0, hashmarkIndex);
  }

  var _encode = options && options.encode || encode;

  var serializerParams = utils.isURLSearchParams(params) ?
    params.toString() :
    new AxiosURLSearchParams(params, options).toString(_encode);

  if (serializerParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializerParams;
  }

  return url;
};


/***/ }),

/***/ 8762:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 2233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 9468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

function arrayToObject(arr) {
  var obj = {};
  var keys = Object.keys(arr);
  var i;
  var len = keys.length;
  var key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    var name = path[index++];
    var isNumericKey = Number.isFinite(+name);
    var isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProperty(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    var result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    var obj = {};

    utils.forEachEntry(formData, function(name, value) {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

module.exports = formDataToJSON;


/***/ }),

/***/ 9192:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 5587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */
      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

    // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 8868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 1875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.slice(0, i)).toLowerCase();
    val = utils.trim(line.slice(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 738:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 783:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 9027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(8834)["lW"];


var utils = __webpack_require__(3044);
var AxiosError = __webpack_require__(1218);
var envFormData = __webpack_require__(5694);

function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

var predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/

function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (envFormData || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  var metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  var visitor = options.visitor || defaultVisitor;
  var dots = options.dots;
  var indexes = options.indexes;
  var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  var useBlob = _Blob && isSpecCompliant(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    var arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        (utils.isFileList(value) || utils.endsWith(key, '[]') && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !utils.isUndefined(el) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  var stack = [];

  var exposedHelpers = Object.assign(predicates, {
    defaultVisitor: defaultVisitor,
    convertValue: convertValue,
    isVisitable: isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      var result = !utils.isUndefined(el) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 1746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3044);
var toFormData = __webpack_require__(9027);
var platform = __webpack_require__(7721);

module.exports = function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
};


/***/ }),

/***/ 7525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(9241).version);
var AxiosError = __webpack_require__(1218);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 319:
/***/ (function(module) {

"use strict";


module.exports = FormData;


/***/ }),

/***/ 1159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosURLSearchParams = __webpack_require__(3831);

module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;


/***/ }),

/***/ 1279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  isBrowser: true,
  classes: {
    URLSearchParams: __webpack_require__(1159),
    FormData: __webpack_require__(319),
    Blob: Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};


/***/ }),

/***/ 7721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1279);


/***/ }),

/***/ 3044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(3644);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */
function isEmptyObject(val) {
  return val && Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  var product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter, propFilter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */
function toArray(thing) {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  var i = thing.length;
  if (!isNumber(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

function forEachEntry(obj, fn) {
  var generator = obj && obj[Symbol.iterator];

  var iterator = generator.call(obj);

  var result;

  while ((result = iterator.next()) && !result.done) {
    var pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

function matchAll(regExp, str) {
  var matches;
  var arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

var isHTMLForm = kindOfTest('HTMLFormElement');

var hasOwnProperty = (function resolver(_hasOwnProperty) {
  return function(obj, prop) {
    return _hasOwnProperty.call(obj, prop);
  };
})(Object.prototype.hasOwnProperty);

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isEmptyObject: isEmptyObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList,
  forEachEntry: forEachEntry,
  matchAll: matchAll,
  isHTMLForm: isHTMLForm,
  hasOwnProperty: hasOwnProperty
};


/***/ }),

/***/ 5766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 8834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(5766)
var ieee754 = __webpack_require__(2333)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 8667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 1645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 9785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 2765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 3761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 8187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 7755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__(2968);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(6700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (!(0,isDate/* default */.Z)(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(8667);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js + 9 modules
var en_US = __webpack_require__(8811);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US/* default */.Z);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 2968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6893);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return value instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ 8811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ en_US; }
});

;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);

/***/ }),

/***/ 6913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3761);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2765);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 6700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6893);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9785);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 9385:
/***/ (function(module) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),

/***/ 1688:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ 3463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(3887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 3459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3459);
} else {}


/***/ }),

/***/ 2333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 6299:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 3335:
/***/ (function(module) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ 5525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5153);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(path__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2817);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1725);
/* harmony import */ var _tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6780);
/* harmony import */ var _tm_utility__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(131);
/* harmony import */ var react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7821);
/* harmony import */ var react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_day_picker_dist_style_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5129);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










 // Magic import




path__WEBPACK_IMPORTED_MODULE_3___default().resolve("./next.config.js");

function CustomApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  (0,_tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_5__/* .setRouter */ .O)(router);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var queryParams = new URLSearchParams(window.location.search);
    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_6__/* .persistUtmParams */ .UO)(queryParams);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    (0,_tm_utility__WEBPACK_IMPORTED_MODULE_8__/* .loadGTM */ .LC)();
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      "data-test-id": "Head",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("title", {
        "data-test-id": "title",
        children: "Tripmoney Insurance"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("main", {
      className: "app",
      "data-test-id": "main",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_7__/* .ErrorBoundary */ .SV, {
        onError: function onError(error) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_7__/* .ErrorScreen */ .Cs, {
            error: error,
            "data-test-id": "ErrorScreen"
          });
        },
        "data-test-id": "ErrorBoundary",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
          "data-test-id": "Component"
        }))
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (CustomApp);

/***/ }),

/***/ 2403:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var AmpStateContext = _react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 2795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadable = _interop_require_default(__webpack_require__(4949));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable.default;
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react.default.createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 3233:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(199)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(2784));

var _sideEffect = _interop_require_default(__webpack_require__(4381));

var _ampContext = __webpack_require__(2403);

var _headManagerContext = __webpack_require__(5285);

var _ampMode = __webpack_require__(7309);

var _utils = __webpack_require__(3177);

'use client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react.default.cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}

/***/ }),

/***/ 9749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var LoadableContext = _react.default.createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 4949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(2624);

var _createClass = __webpack_require__(5458);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(9419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(3903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadableContext = __webpack_require__(9749);

var _ref =  true ? __webpack_require__(2784) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react.default.lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react.default.useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react.default.useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react.default.useMemo(function () {
      if (state.loading || state.error) {
        return _react.default.createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react.default.createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react.default.createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react.default.forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      }).catch(function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks.delete(callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 4381:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(199)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(2784));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.delete(props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 3496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SW": function() { return /* reexport */ API_BASE_URL_HTTP; },
  "qf": function() { return /* reexport */ API_ROUTES; },
  "XO": function() { return /* reexport */ API_ROUTE_PREFIX; },
  "j6": function() { return /* reexport */ API_ROUTE_PREFIX_HTTPS; },
  "Sb": function() { return /* reexport */ API_TIMEOUT_IN_MS; },
  "JQ": function() { return /* reexport */ interceptors; }
});

;// CONCATENATED MODULE: ../../libs/api-utils/src/apiConstants/index.ts
/* provided dependency */ var process = __webpack_require__(4406);
var API_BASE_URL_HTTP = process.env["API_BASE_URL_HTTP"];
var API_ROUTE_PREFIX = "/ext/api/v1/partners";
var API_ROUTE_PREFIX_HTTPS = "/insurance/ext/api/v1/partners";
var API_TIMEOUT_IN_MS = 10000;
var API_ROUTES;

(function (API_ROUTES) {
  API_ROUTES["GET_LANDING_PAGE_DETAILS"] = "insurance/cb/landing";
  API_ROUTES["GET_PRODUCT_LISTING"] = "insurance/cb/quotes";
  API_ROUTES["GET_TRAVEL_ATTRIBUTES"] = "insurance/cb/travelattributes";
  API_ROUTES["PAYMENT_CHECKOUT"] = "insurance/cb/checkout";
  API_ROUTES["GET_PASSPORT_DETAILS"] = "insurance/cb/passportDetails";
  API_ROUTES["EDIT_INSURANCE_DETAILS"] = "insurance/cb/endorsement";
  API_ROUTES["ORDER_CONFIRMED"] = "insurance/cb/thankyou";
  API_ROUTES["ORDER_LISTING"] = "insurance/cb/orders";
  API_ROUTES["ORDER_DETAIL"] = "insurance/cb/orderDetail";
  API_ROUTES["TRIGGER_EMAIL"] = "insurance/cb/email";
  API_ROUTES["GET_NEXT_PAGE_ROUTE"] = "insurance/cb/nextPageData";
})(API_ROUTES || (API_ROUTES = {}));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/enhanceRequestHeaders.ts

var _excluded = ["cookie", "mobile-device", "cmp"];
function enhanceRequestHeaders(headers) {
  var _ref = headers || {},
      _ref$cookie = _ref.cookie,
      cookie = _ref$cookie === void 0 ? "" : _ref$cookie,
      mobile_device = _ref["mobile-device"],
      cmp = _ref.cmp,
      restHeaders = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var x_tm_device = mobile_device === "true" ? "mobile" : "desktop";

  if (typeof navigator !== "undefined") {
    x_tm_device = /Mobile|Android|BlackBerry/.test(navigator.userAgent) ? "mobile" : "desktop";
  }

  if (typeof cmp === "string" && cmp != "") {
    return {
      cmp: cmp,
      cookie: cookie,
      "x-tm-device": x_tm_device,
      "X-Tm-Client": "desktop"
    };
  }

  return {
    cookie: cookie,
    "x-tm-device": x_tm_device,
    "X-Tm-Client": "desktop"
  };
}
;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/retryAxiosRequest.ts
var retryAxiosRequest = function retryAxiosRequest(error, axios) {
  var config = error.config,
      response = error.response;
  var url = config.url;
  console.error(["API RESPONSE ERROR:", JSON.stringify({
    url: url,
    status: response === null || response === void 0 ? void 0 : response.status,
    responseData: response === null || response === void 0 ? void 0 : response.data,
    responseHeaders: response === null || response === void 0 ? void 0 : response.headers,
    requestBody: config === null || config === void 0 ? void 0 : config.data,
    requestHeaders: config === null || config === void 0 ? void 0 : config.headers
  })].join(" | "));

  if (response !== null && response !== void 0 && response.status && response.status < 400 || !config || !config.retry) {
    return Promise.reject(error);
  } //decrease retry count by 1


  config.retry -= 1; // Return Promise to retry the request

  return axios.request(config);
};
;// CONCATENATED MODULE: ../../libs/api-utils/src/interceptors/index.ts


var interceptors = {
  enhanceRequestHeaders: enhanceRequestHeaders,
  retryAxiosRequest: retryAxiosRequest
};


;// CONCATENATED MODULE: ../../libs/api-utils/src/index.ts





/***/ }),

/***/ 4928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CONTEXT": function() { return /* reexport */ CONTEXT; },
  "DATE_FORMATS": function() { return /* reexport */ DATE_FORMATS; },
  "ERROR_CODES": function() { return /* reexport */ ERROR_CODES; },
  "FORM_FIELDS_MAP": function() { return /* reexport */ FORM_FIELDS_MAP; },
  "GENDER_VALUES": function() { return /* reexport */ GENDER_VALUES; },
  "LOB": function() { return /* reexport */ LOB; },
  "PARTNER": function() { return /* reexport */ PARTNER; },
  "PARTNER_DOMAIN_NAME": function() { return /* reexport */ PARTNER_DOMAIN_NAME; },
  "PASSPORT_DETAILS_PAGE_ID": function() { return /* reexport */ PASSPORT_DETAILS_PAGE_ID; },
  "PLATFORM": function() { return /* reexport */ PLATFORM; },
  "RESPONSE_STATUS": function() { return /* reexport */ RESPONSE_STATUS; },
  "STORAGE_KEYS": function() { return /* reexport */ STORAGE_KEYS; },
  "TRAVELLER_NUMBER_CONSTANTS": function() { return /* reexport */ TRAVELLER_NUMBER_CONSTANTS; },
  "TXN_SUCCESS_REDIRECT_TIME": function() { return /* reexport */ TXN_SUCCESS_REDIRECT_TIME; },
  "UTM_PARAMS": function() { return /* reexport */ UTM_PARAMS; },
  "constants": function() { return /* reexport */ constants; },
  "deviceType": function() { return /* reexport */ deviceType; },
  "isOnServer": function() { return /* reexport */ isOnServer; }
});

// UNUSED EXPORTS: LONG_WEEK_DAYS, MONTHS, MONTHS_SHORT, SHORT_WEEK_DAYS, TRIPMONEY_DOMAIN_NAME, TXN_FAILURE_REDIRECT_TIME, breakpoint

;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/constants.ts
var RESPONSE_STATUS;

(function (RESPONSE_STATUS) {
  RESPONSE_STATUS["SUCCESS"] = "SUCCESS";
  RESPONSE_STATUS["ERROR"] = "ERROR";
})(RESPONSE_STATUS || (RESPONSE_STATUS = {}));

var CONTEXT;

(function (CONTEXT) {
  CONTEXT["INSURANCE"] = "insurance";
  CONTEXT["STANDALONE"] = "standalone";
  CONTEXT["STANDALONE_V2"] = "standalone_v2";
})(CONTEXT || (CONTEXT = {}));

var PLATFORM;

(function (PLATFORM) {
  PLATFORM["WEB"] = "web";
})(PLATFORM || (PLATFORM = {}));

var LOB;

(function (LOB) {
  LOB["STANDALONE"] = "standalone";
})(LOB || (LOB = {}));

var ERROR_CODES;

(function (ERROR_CODES) {
  ERROR_CODES["DISPLAY_ERROR"] = "DISPLAY_ERROR";
})(ERROR_CODES || (ERROR_CODES = {}));

var UTM_PARAMS;

(function (UTM_PARAMS) {
  UTM_PARAMS["UTM_SOURCE"] = "utm_source";
  UTM_PARAMS["UTM_MEDIUM"] = "utm_medium";
  UTM_PARAMS["UTM_CAMPAIGN"] = "utm_campaign";
  UTM_PARAMS["UTM_INS_CAMPAIGN"] = "utm_ins_campaign";
})(UTM_PARAMS || (UTM_PARAMS = {}));

var STORAGE_KEYS;

(function (STORAGE_KEYS) {
  STORAGE_KEYS["TRAVELLER_DETAILS"] = "traveller-details";
})(STORAGE_KEYS || (STORAGE_KEYS = {}));

var FORM_FIELDS_MAP = Object.freeze({
  name: "name",
  dob: "date of birth",
  gender: "gender",
  mobile: "mobile number",
  email: "email id",
  passport: "passport number"
});
var GENDER_VALUES = [{
  id: "1",
  label: "Male",
  isSelected: false
}, {
  id: "2",
  label: "Female",
  isSelected: false
}, {
  id: "3",
  label: "Others",
  isSelected: false
}];
var TXN_SUCCESS_REDIRECT_TIME = 5000;
var TXN_FAILURE_REDIRECT_TIME = 5000;
var PASSPORT_DETAILS_PAGE_ID;

(function (PASSPORT_DETAILS_PAGE_ID) {
  PASSPORT_DETAILS_PAGE_ID["PAYMENT_SUCCESS"] = "PAYMENT_SUCCESS";
  PASSPORT_DETAILS_PAGE_ID["ORDER_CONFIRMED"] = "ORDER_CONFIRMED";
})(PASSPORT_DETAILS_PAGE_ID || (PASSPORT_DETAILS_PAGE_ID = {}));

var TRAVELLER_NUMBER_CONSTANTS = {
  MAX_TRAVELLERS: 20,
  MIN_TRAVELLERS: 1
};
var constants = {
  formErrorToast: "Please enter the required details to continue",
  addErrorToast: "Please add all traveller details to continue"
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/date.ts
var DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
  DATE_FORMATS["dd MMM, yyyy"] = "dd MMM, yyyy";
  DATE_FORMATS["YYYY-MM-DD"] = "yyyy-MM-dd";
})(DATE_FORMATS || (DATE_FORMATS = {}));

var MONTHS = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]));
var MONTHS_SHORT = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
var SHORT_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"]));
var LONG_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]));
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/device.ts
// RESPONSIVE BREAKPOINTS
var breakpoint = {
  mobile: 768
};
var deviceType = {
  mobile: "(max-width: ".concat(breakpoint.mobile, "px)"),
  desktop: "(min-width: ".concat(breakpoint.mobile, "px)")
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/domain.ts
var TRIPMONEY_DOMAIN_NAME = {
  MMT: ["tripmoney.makemytrip.com", "insurance.makemytrip.com", "www.makemytrip.com"],
  GI: ["tripmoney.goibibo.com", "insurance.goibibo.com", "www.goibibo.com"],
  TRIPMONEY: ["www.tripmoney.com"]
};
var PARTNER_DOMAIN_NAME;

(function (PARTNER_DOMAIN_NAME) {
  PARTNER_DOMAIN_NAME["MMT"] = ".makemytrip.com";
  PARTNER_DOMAIN_NAME["GI"] = ".goibibo.com";
  PARTNER_DOMAIN_NAME["TRIPMONEY"] = "tripmoney.com";
})(PARTNER_DOMAIN_NAME || (PARTNER_DOMAIN_NAME = {}));
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/partner.ts
var PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown"
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/constants/index.ts





;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/isOnServer/index.ts
var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
;// CONCATENATED MODULE: ../../libs/isomorphic-utils/src/index.ts




/***/ }),

/***/ 3611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tZ": function() { return /* reexport */ akamaiGetDevice; }
});

// UNUSED EXPORTS: getHost, getPartnerOnServerSide

;// CONCATENATED MODULE: ../../libs/server-utils/src/akamaiGetDevice/index.ts
function akamaiGetDevice() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isTabletHeader = headers["tablet-device"];
  var isMobileHeader = headers["mobile-device"];
  var device = "desktop";

  switch ("true") {
    case isTabletHeader:
      device = "tablet";
      break;

    case isMobileHeader:
      device = "mobile";
      break;

    default:
      device = "desktop";
  }

  return device;
}
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
;// CONCATENATED MODULE: ../../libs/server-utils/src/getPartnerOnServerSide/index.ts


var getPartnerOnServerSide = function getPartnerOnServerSide(headers) {
  if (isOnServer()) {
    var host = getHost(headers);

    if (typeof host === "string") {
      if (TRIPMONEY_DOMAIN_NAME.GI.includes(host)) {
        return PARTNER.GI;
      } else {
        return PARTNER.MMT;
      }
    }
  }

  return PARTNER.MMT;
};
;// CONCATENATED MODULE: ../../libs/server-utils/src/index.ts




/***/ }),

/***/ 7109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mq": function() { return /* reexport */ ExperimentTrackingStringContext/* ExperimentTrackingString */.M; },
  "bU": function() { return /* reexport */ useBreakpointV2; },
  "JK": function() { return /* reexport */ withDeviceProvider/* withDeviceProvider */.J; }
});

// UNUSED EXPORTS: InnerContentWrap, usePartnerContext, useReferrerContext

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ExperimentTrackingStringContext.ts
var ExperimentTrackingStringContext = __webpack_require__(5658);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/DeviceContext.ts
var Contexts_DeviceContext = __webpack_require__(9138);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useDeviceContext.ts


var useDeviceContext = function useDeviceContext() {
  return useContext(DeviceContext);
};
var useDeviceV2 = function useDeviceV2() {
  return (0,react.useContext)(Contexts_DeviceContext/* DeviceContextV2 */.M);
};
var useBreakpointV2 = function useBreakpointV2() {
  var device = useDeviceV2();

  switch (device) {
    case "mobile":
      return "sm";

    case "desktop":
      return "lg";

    case "tablet":
      return "md";

    default:
      return "md";
  }
};
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hoc/withDeviceProvider.tsx
var withDeviceProvider = __webpack_require__(6991);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/CommonStyle/CommonStyles.style.ts


var InnerContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CommonStylesstyle__InnerContentWrap",
  componentId: "sc-1tlkskw-0"
})(["width:1200px;margin:0 auto;@media screen and ", "{width:100%;}"], src.deviceType.mobile);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 3 modules
var hooks = __webpack_require__(736);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/index.ts






/***/ }),

/***/ 9138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ DeviceContextV2; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var DeviceContextV2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("mobile");
var DeviceContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext(null)));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (DeviceContext)));

/***/ }),

/***/ 5658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ExperimentTrackingString; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var ExperimentTrackingString = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("");

/***/ }),

/***/ 932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReferrerContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var ReferrerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)("");
/* harmony default export */ __webpack_exports__["Z"] = (ReferrerContext);

/***/ }),

/***/ 6991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ withDeviceProvider; }
/* harmony export */ });
/* harmony import */ var _Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9138);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);


function withDeviceProvider(comp, device) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Contexts_DeviceContext__WEBPACK_IMPORTED_MODULE_0__/* .DeviceContextV2.Provider */ .M.Provider, {
    value: device,
    children: comp
  });
}

/***/ }),

/***/ 736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ useReferrerContext; }
});

// UNUSED EXPORTS: usePartnerContext

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ReferrerContext.ts
var ReferrerContext = __webpack_require__(932);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/useReferrerContext.ts


var useReferrerContext = function useReferrerContext() {
  return (0,react.useContext)(ReferrerContext/* default */.Z);
};
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/Contexts/PartnerContext.tsx



var PartnerContext_PartnerContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext(null)));
var PartnerContextProvider = function PartnerContextProvider(_ref) {
  var hostname = _ref.hostname,
      children = _ref.children,
      partnerType = _ref.partnerType;
  React.useEffect(function () {
    var element = document.getElementById("pageId");
    element.classList.remove("mmtTheme", "giTheme");

    if (partnerType === PARTNER.MMT) {
      element.classList.add("mmtTheme");
    } else if (partnerType === PARTNER.GI) {
      element.classList.add("giTheme");
    }
  }, [partnerType]);
  return /*#__PURE__*/_jsx(PartnerContext_PartnerContext.Provider, {
    value: partnerType,
    children: children
  });
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/usePartnerContext.ts


var usePartnerContext = function usePartnerContext() {
  var context = useContext(PartnerContext);

  if (context === null) {
    console.error("usePartnerContext must be used within a PartnerContextProvider");
  }

  return context;
};
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts



/***/ }),

/***/ 7800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AQ": function() { return /* reexport */ withError; },
  "HC": function() { return /* reexport */ withGIInsuranceHeader; },
  "ZA": function() { return /* reexport */ withMMTInsuranceHeader; },
  "Pw": function() { return /* reexport */ withPartnerInsuranceHeader; }
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/ErrorScreen/index.tsx
var ErrorScreen = __webpack_require__(1175);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withError.tsx


function withError(component, error, pageName) {
  return error ? /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorScreen/* ErrorScreen */.C, {
    error: error,
    pageName: pageName,
    trackError: true,
    "data-test-id": "ErrorScreen"
  }) : component;
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(7109);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/pwa-mmt-ui-header/ssr/header.css
var header = __webpack_require__(4766);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 347 modules
var components = __webpack_require__(6306);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MMTInsuranceHeader/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 //import { Header as MMTHeader } from 'pwa-mmt-ui-header/ssr/header';







var DynamicMMTHeader = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(575), __webpack_require__.e(166)]).then(__webpack_require__.t.bind(__webpack_require__, 8972, 23)).then(function (module) {
    return module.Header;
  });
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8972)];
    }
  }
});
function MMTInsuranceHeader(_ref) {
  var _headerPropsWithDefau;

  var _ref$headerProps = _ref.headerProps,
      headerProps = _ref$headerProps === void 0 ? {} : _ref$headerProps,
      _ref$mobileTitle = _ref.mobileTitle,
      mobileTitle = _ref$mobileTitle === void 0 ? "" : _ref$mobileTitle,
      myOrders = _ref.myOrders,
      goToMyOrders = _ref.goToMyOrders,
      displayWhiteHeader = _ref.displayWhiteHeader,
      isMyBiz = _ref.isMyBiz;
  var device = (0,src/* useBreakpointV2 */.bU)();

  var headerPropsWithDefaults = _objectSpread({
    type: "singleHeader",
    forceLogin: false,
    activeModal: undefined,
    showMyBizFormSwitcher: true,
    profile: "PERSONAL",
    displayLanguageDropdown: false,
    selectedTabName: "Travel Insurance",
    displayCurrencyDropdown: false,
    onLogin: function onLogin() {
      return router_default().reload();
    },
    onLoginFlowComplete: function onLoginFlowComplete() {
      return void 0;
    },
    onModalChange: function onModalChange() {
      return void 0;
    },
    showMoreButton: true,
    showLoginPersuasionSlider: false,
    multiLingualData: {
      "header.login.signup.for.best.prices": "Please login to purchase your travel insurance"
    }
  }, headerProps);

  if (headerPropsWithDefaults.type === "dualHeader") {
    headerPropsWithDefaults.showMoreButton = false;
  }

  if ((_headerPropsWithDefau = headerPropsWithDefaults) !== null && _headerPropsWithDefau !== void 0 && _headerPropsWithDefau.forceLogin) {
    headerPropsWithDefaults = _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      activeModal: "LOGIN"
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMMTHeader, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      "data-test-id": "DynamicMMTHeader"
    }));
  }

  return isMyBiz && device === "lg" ? null : device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMMTHeader, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
    "data-test-id": "DynamicMMTHeader"
  })) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingHeaderMobile */.cQ, {
    headerTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    partnerType: isomorphic_utils_src.PARTNER.MMT,
    insuranceHeader: true,
    "data-test-id": "LandingHeaderMobile"
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withMMTInsuranceHeader.tsx

var _excluded = ["Wrapper"];




function withMMTInsuranceHeader(component) {
  var headerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mobileTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var myOrders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var goToMyOrders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return void 0;
  };
  var displayWhiteHeader = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isMyBiz = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  var Wrapper = headerOptions.Wrapper,
      headerProps = (0,objectWithoutProperties/* default */.Z)(headerOptions, _excluded);

  var authComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(MMTInsuranceHeader, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    isMyBiz: isMyBiz,
    "data-test-id": "authComponent-MMTInsuranceHeader"
  });

  if (headerProps !== null && headerProps !== void 0 && headerProps.forceLogin) {
    return authComponent;
  }

  if (Wrapper) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      "data-test-id": "Wrapper",
      children: [authComponent, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [authComponent, component]
  });
}
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@growth/use-analytics/dist/growth-use-analytics.esm.js
var growth_use_analytics_esm = __webpack_require__(2390);
// EXTERNAL MODULE: ../../node_modules/@growth/dom-event-emitter/dist/growth-dom-event-emitter.esm.js
var growth_dom_event_emitter_esm = __webpack_require__(3377);
// EXTERNAL MODULE: ../../node_modules/@growth/auth-helpers/dist/growth-auth-helpers.esm.js
var growth_auth_helpers_esm = __webpack_require__(4653);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(624);
// EXTERNAL MODULE: ../../node_modules/@growth/store-helpers/dist/growth-store-helpers.esm.js
var growth_store_helpers_esm = __webpack_require__(6880);
// EXTERNAL MODULE: ../../node_modules/@growth/api-calls/dist/growth-api-calls.esm.js + 4 modules
var growth_api_calls_esm = __webpack_require__(332);
;// CONCATENATED MODULE: ../../node_modules/@growth/data-store/dist/growth-data-store.esm.js




function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var useBookingSummaryStore = (0,esm/* create */.Ue)()(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: growth_api_calls_esm/* fetchBookingSummary */.YH,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});
/** Filter the 'UPCOMING' bookings */

var selectUpcomingBookingsCount = function selectUpcomingBookingsCount(state) {
  var _state$data;

  var bookingList = (state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data.bookingDetails) || [];
  var upcomingList = bookingList.filter(function (item) {
    return (item == null ? void 0 : item.status) === 'UPCOMING';
  });
  return upcomingList.length;
};

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var fetchFun = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var resp, _ref2, success, balance;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,growth_api_calls_esm/* fetchGoCashBalance */.z1)();

          case 2:
            resp = _context.sent;
            _ref2 = resp || {}, success = _ref2.success, balance = _ref2.total_credits;

            if (!(success || typeof balance !== 'undefined')) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              balance: balance
            });

          case 6:
            return _context.abrupt("return", 0);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFun() {
    return _ref.apply(this, arguments);
  };
}();

var useGoCashBalanceStore = (0,esm/* create */.Ue)()(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    data: {
      balance: 0
    },
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: fetchFun,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
});

var useLoyaltyUserInfoStore = (0,esm/* create */.Ue)(function (set) {
  return _extends({}, growth_store_helpers_esm/* DEFAULT_STATE */.L, {
    fetch: function fetch(opts) {
      return (0,growth_store_helpers_esm/* fetchSetter */.x)({
        set: set,
        fetchFun: growth_api_calls_esm/* fetchLoyaltyUserInfo */.aL,
        onSuccess: opts == null ? void 0 : opts.onSuccess
      });
    }
  });
}); // https://github.com/pmndrs/zustand/discussions/387#discussioncomment-6339994

var selectLoyaltyMemberType = function selectLoyaltyMemberType(state) {
  var _state$tribe_header;

  return (state == null ? void 0 : (_state$tribe_header = state.tribe_header) == null ? void 0 : _state$tribe_header.type) || 'non_member';
};



// EXTERNAL MODULE: ../../node_modules/zustand/esm/shallow.mjs
var shallow = __webpack_require__(2532);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../node_modules/@growth/design-system/dist/growth-design-system.esm.js
var growth_design_system_esm = __webpack_require__(3767);
// EXTERNAL MODULE: ../../node_modules/@growth/custom-hooks/useHasMounted/dist/growth-custom-hooks-useHasMounted.esm.js
var growth_custom_hooks_useHasMounted_esm = __webpack_require__(3509);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/dom-events-c707d33c.esm.js


var dom_events_c707d33c_esm_DOM_EVENT_NAME = {
  LOGOUT: 'hr_l',
  LOGOUT_SUCCESS: 'hr_lls',
  START_LOGIN_FLOW: 'hr_slf',
  HEADER_ITEM_CLICK: 'hr_hic',
  IS_NEW_USER: 'hr_inu',
  SHOW_LOGIN_POP_OVER: 'hr_slpo',
  HIDE_LOGIN_POP_OVER: 'hr_hlpo',
  REFRESH_HEADER_DATA: 'hr_rhr',
  LOGIN_SUCCESS: growth_auth_helpers_esm/* LOGIN_SUCCESS */.XP
};



// EXTERNAL MODULE: ../../node_modules/@growth/gi-dweb-auth/dist/growth-gi-dweb-auth.esm.js + 3 modules
var growth_gi_dweb_auth_esm = __webpack_require__(7644);
// EXTERNAL MODULE: ../../node_modules/@growth/config-store/browser/dist/growth-config-store-browser.esm.js + 3 modules
var growth_config_store_browser_esm = __webpack_require__(4668);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../node_modules/@growth/modal/dist/growth-modal.esm.js





function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var ModalWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tmin-width: 560px;\n\tmax-width: 1024px;\n\tposition: fixed;\n\tleft: 50vw;\n\ttop: 50vh;\n\ttransform: translate(-50%, -50%);\n\tbackground-color: #fff;\n\tborder-radius: 16px;\n\tz-index: 1026;\n"])));
var ModalCont = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\toverflow: hidden;\n\tposition: relative;\n"])));
var ModalBackdrop = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 1024;\n\tbackground: rgba(20, 24, 35, 0.7);\n"])));
var ModalBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tmax-height: 800px;\n\toverflow-y: auto;\n\t", "\n\n"])), function (p) {
  return p.onClick ? "cursor:pointer" : '';
});
var CloseBtn = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 28.8px;\n\theight: 28.8px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 32px;\n\tright: 32px;\n\tcursor: pointer;\n\tz-index: 1030;\n\n\t&::before,\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: ' ';\n\t\theight: 20px;\n\t\twidth: 2px;\n\t\tbackground-color: #647a97;\n\t}\n\n\t&::before {\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&::after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])));

var Modal = function Modal(_ref) {
  var onClose = _ref.onClose,
      rootStyle = _ref.rootStyle,
      contentStyle = _ref.contentStyle,
      children = _ref.children,
      shouldCloseOutSideClick = _ref.shouldCloseOutSideClick,
      closeBtnStyle = _ref.closeBtnStyle,
      onBodyClick = _ref.onBodyClick;
  var clientOnly = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  (0,react.useEffect)(function () {
    // fixed scrolling when bottom modal is opened
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, []);
  var Com = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(ModalWrapper, {
    style: rootStyle,
    "data-id": "dweb-modal"
  }, /*#__PURE__*/react.createElement(CloseBtn, {
    style: closeBtnStyle,
    onClick: onClose
  }), /*#__PURE__*/react.createElement(ModalCont, {
    style: contentStyle
  }, /*#__PURE__*/react.createElement(ModalBody, {
    onClick: onBodyClick
  }, children))), /*#__PURE__*/react.createElement(ModalBackdrop, {
    onClick: shouldCloseOutSideClick ? onClose : function () {}
  }));
  return clientOnly ? /*#__PURE__*/(0,react_dom.createPortal)(Com, document.body) : null;
};

Modal.defaultProps = {
  rootStyle: {},
  contentStyle: {},
  shouldCloseOutSideClick: true,
  closeBtnStyle: undefined,
  onBodyClick: undefined
};



// EXTERNAL MODULE: ../../node_modules/@growth/web-analytics/dist/growth-web-analytics.esm.js
var growth_web_analytics_esm = __webpack_require__(2019);
// EXTERNAL MODULE: ../../node_modules/@growth/ssr-utils/dist/growth-ssr-utils.esm.js
var growth_ssr_utils_esm = __webpack_require__(1917);
// EXTERNAL MODULE: ../../node_modules/@growth/analytics-plugin-pdt/dist/growth-analytics-plugin-pdt.esm.js + 3 modules
var growth_analytics_plugin_pdt_esm = __webpack_require__(2961);
// EXTERNAL MODULE: ../../node_modules/@growth/object-utils/dist/growth-object-utils.esm.js
var growth_object_utils_esm = __webpack_require__(7106);
;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/node_modules/@growth/analytics-plugin-adobe/dist/growth-analytics-plugin-adobe.esm.js


function growth_analytics_plugin_adobe_esm_extends() {
  growth_analytics_plugin_adobe_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_analytics_plugin_adobe_esm_extends.apply(this, arguments);
}

var config = {
  adobeDataLayer: []
};

var formatPageName = function formatPageName(_ref) {
  var pageName = _ref.pageName,
      section = _ref.section,
      lob = _ref.lob;
  return section + ":" + lob + ":" + pageName.toLowerCase();
};

var AnalyticsPluginAdobe = function AnalyticsPluginAdobe(pluginConfig, debug) {
  var name = 'analytics-adobe-omniture';

  var configs = growth_analytics_plugin_adobe_esm_extends({}, pluginConfig);

  var init = function init() {
    var _window$top;

    if (window.top && !window.top.adobeDataLayer) {
      window.top.adobeDataLayer = [];
    }

    config.adobeDataLayer = (_window$top = window.top) == null ? void 0 : _window$top.adobeDataLayer; // return the created window dataLayer. Helps in testing

    return config.adobeDataLayer;
  };

  var track = function track(_ref2) {
    var payload = _ref2.payload;

    if (typeof config.adobeDataLayer !== 'undefined') {
      var formattedPayload = (0,growth_object_utils_esm/* deepClone */.I8)(growth_analytics_plugin_adobe_esm_extends({}, configs));
      (0,growth_object_utils_esm/* deepMerge */.RH)(payload.eventProperties, formattedPayload);

      if (debug) {
        console.log('track payload ', growth_analytics_plugin_adobe_esm_extends({
          event: payload.event
        }, formattedPayload));
      } // since ctaclick all the parameters are mandatory i.e. why adding check here


      if (payload.event === 'ctaClick') {
        formattedPayload.cta = {
          name: formattedPayload.cta.name || undefined,
          destination: formattedPayload.cta.destination || undefined,
          type: formattedPayload.cta.type || undefined,
          componentName: formattedPayload.cta.componentName || undefined
        };
      } // don't push the event if adobe script is not present


      if (config.adobeDataLayer) config.adobeDataLayer.push(growth_analytics_plugin_adobe_esm_extends({
        event: payload.event
      }, formattedPayload));
      return formattedPayload;
    }

    return {};
  };

  var pageView = function pageView(pageName, properties) {
    if (typeof config.adobeDataLayer !== 'undefined') {
      var _ref3 = properties || {},
          _ref3$eventProperties = _ref3.eventProperties,
          eventProperties = _ref3$eventProperties === void 0 ? {} : _ref3$eventProperties;

      var formattedPayload = growth_analytics_plugin_adobe_esm_extends({}, pluginConfig);

      (0,growth_object_utils_esm/* deepMerge */.RH)(eventProperties, formattedPayload); // updating the global config data with every pageView Data

      configs = growth_analytics_plugin_adobe_esm_extends({}, formattedPayload);
      formattedPayload.page.pageInfo.pageName = formattedPayload != null && formattedPayload.doNotFormatPageName ? pageName.toLowerCase() : formatPageName({
        section: formattedPayload.page.pageInfo.section,
        lob: pluginConfig.page.pageInfo.lob,
        pageName: pageName
      });
      var payload = {
        event: 'Page_View',
        eventProperties: formattedPayload
      };
      track({
        payload: payload
      });
      return formattedPayload;
    }

    return {};
  };

  return {
    name: name,
    configs: configs,
    init: init,
    track: track,
    pageView: pageView
  };
};



;// CONCATENATED MODULE: ../../node_modules/@growth/dweb-header/dist/growth-dweb-header.esm.js



















function growth_dweb_header_esm_regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  growth_dweb_header_esm_regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function growth_dweb_header_esm_asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        growth_dweb_header_esm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function growth_dweb_header_esm_taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$c, _templateObject2$a, _templateObject3$8, _templateObject4$5, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$2;
var bdrAni = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject$c || (_templateObject$c = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t\t0% {\n\t\t\twidth: 0;\n\t\t\tleft: 60%; /* Start from the center */\n\t\t\ttransform: translateX(-50%); /* Center the element horizontally */\n\t\t}\n\t\t50% {\n\t\t\twidth: 100%; /* Expand to the right */\n\t\t\tleft: 0; /* Move to the left edge */\n\t\t\ttransform: translateX(0%);\n\t\t}\n\t\t100% {\n\t\t\twidth: 100%; /* Collapse back to the center */\n\t\t\tleft: 50%; /* End at the center */\n\t\t\ttransform: translateX(-50%);\n\t\t}\n"])));
var HappyNav = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject2$a || (_templateObject2$a = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\theight: 100%;\n"])));
var HappyNavItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3$8 || (_templateObject3$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: transparent;\n\tcursor: pointer;\n\theight: 100%;\n\tposition: relative;\n\t", ";\n\n\t&.active,\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2, function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? '#2274e0' : '#777';
});
var NavLink$1 = styled_components_browser_esm/* default.a */.ZP.a(_templateObject4$5 || (_templateObject4$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tcolor: #717171 !important;\n\talign-items: center;\n\tmargin-right: 30px;\n\tpadding: 20px 0px;\n\tposition: relative;\n\theight: 100%;\n\n\t&:visited {\n\t\tcolor: #717171;\n\t}\n\n\t&.active {\n\t\tcolor: #2274e0;\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tcontent: '';\n\t\t\theight: 3px;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: #2274e0;\n\t\t\tborder-radius: 2px;\n\t\t\tanimation: ", " 0.4s 1;\n\t\t}\n\t}\n"])), bdrAni);
var NewLob = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5$4 || (_templateObject5$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder-radius: 8px;\n\tfont-size: 10px;\n\tpadding: 2px 6px;\n\tcolor: #fff;\n\ttop: -8px;\n\tright: 19px;\n\tbackground: #ff5656;\n\tmargin-left: 5px;\n\tposition: absolute;\n"])));
var NavText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject6$4 || (_templateObject6$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n"])), growth_design_system_esm/* textSizes.MediumW2 */.iH.MediumW2);
var NavLinkSvg = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7$4 || (_templateObject7$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n"])));
var NavIcon$1 = styled_components_browser_esm/* default.span */.ZP.span(_templateObject8$2 || (_templateObject8$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 5px;\n"])));

function growth_dweb_header_esm_extends() {
  growth_dweb_header_esm_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return growth_dweb_header_esm_extends.apply(this, arguments);
}

// We use 'W_' as prefix for writing text constants
var W_GENERICS = {
  loginSignup: 'Login / Sign Up',
  loginSignup2: 'Login/Sign Up',
  internetError: 'Internet is not available. Check your connection.',
  apiErrorMsg: 'Some error occurred, please try again.'
};
var W_LOGIN_POPOVER_PERSUASION_GENERICS = {
  loginSignup: W_GENERICS.loginSignup2,
  coupon: 'Use Coupon : WELCOME'
};
var W_LOGIN_POPOVER_PERSUASION_FLIGHT = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 12% OFF*',
  offerSubTitle: 'on your first Flight booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_HOTEL = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 25% OFF* ',
  offerSubTitle: 'on your first Hotel booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_BUS = growth_dweb_header_esm_extends({
  offerTitle: 'FLAT 10% OFF*',
  offerSubTitle: 'on your first Bus booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_CAB = growth_dweb_header_esm_extends({
  offerTitle: ' Upto 10% OFF*',
  offerSubTitle: 'on your first Cab booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_POPOVER_PERSUASION_TRAIN = growth_dweb_header_esm_extends({
  offerTitle: 'Zero service fees',
  offerSubTitle: 'on your first Train booking'
}, W_LOGIN_POPOVER_PERSUASION_GENERICS);
var W_LOGIN_BANNER_DEFAULT = {
  theme: 'gr-home',
  heading: 'Unlock these benefits',
  subHeading: '',
  benefits: [{
    id: 1,
    heading: 'Earn goCash',
    subHeading: '₹100 on Sign Up & Cashback on Bookings',
    iconClass: 'icGoCash'
  }, {
    id: 2,
    heading: 'Loyalty Benefits',
    subHeading: 'Extra Discounts, Free Seat Selection etc.',
    iconClass: 'icGoTribe'
  }, {
    id: 3,
    heading: 'Exclusive Offers',
    subHeading: 'Daily Steal Deals & Special Discounts',
    iconClass: 'icGiftBlue'
  }],
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
};
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_HOTEL
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_BUS
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_TRAIN
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_CAB
});
growth_dweb_header_esm_extends({}, W_LOGIN_BANNER_DEFAULT, {
  offers: W_LOGIN_POPOVER_PERSUASION_FLIGHT
});
var W_USER_PROFILE_DROPDOWN = function W_USER_PROFILE_DROPDOWN(origin) {
  if (origin === void 0) {
    origin = '';
  }

  return {
    login: {
      label: 'Hey Traveller',
      subLabel: 'Get exclusive deals & Manage your trips',
      ctaText: W_GENERICS.loginSignup2
    },
    view_profile: {
      label: 'View your profile',
      url: origin + "/profile/"
    },
    offers: {
      label: 'Offers',
      subLabel: 'Handpicked best deals',
      icon: 'offers',
      url: origin + "/offers/"
    },
    myTrips: {
      label: 'My Trips',
      subLabel: {
        singular: 'Upcoming Trip',
        plural: "Upcoming Trips"
      },
      icon: 'mytrip',
      url: origin + "/travelhistory"
    },
    gotTribe: {
      label: '',
      subLabel: {
        member: 'View membership benefits',
        nonMember: 'Travel more to get enrolled!'
      },
      icon: 'gotribe',
      goTribeIcon: 'gotribeLogo',
      url: origin + "/loyalty/"
    },
    goCash: {
      label: 'goCash',
      subLabel: 'Current Balance : ',
      subLabelGuest: 'Signup to get ₹100 goCash',
      icon: 'gocash',
      url: origin + "/gocash/"
    },
    logout: {
      label: 'Logout',
      icon: 'logout-icon'
    }
  };
};
var W_RUPEE_SIGN = '₹';
var W_MY_TRIPS = function W_MY_TRIPS(origin) {
  if (origin === void 0) {
    origin = '';
  }

  return {
    label: 'My Trips',
    icon: 'mytrip-icon',
    tooltip: 'Access your bookings, easy cancellation, date change and much more',
    manageBooking: 'Manage Booking',
    url: W_USER_PROFILE_DROPDOWN(origin).myTrips.url
  };
};
var W_LOGIN_WIDGET_CTA = [{
  text: 'LOGIN / SIGNUP',
  id: 'text_1'
}, {
  text: 'Exclusive Offers',
  id: 'text_2'
}, {
  text: 'Earn goCash',
  id: 'text_3'
}, {
  text: 'Manage Your Trips',
  id: 'text_4'
}];

var LOBS_NAME = {
  FLIGHTS: 'Flights',
  HOTELS: 'Hotels',
  HOLIDAYS: 'Holidays',
  BUS: 'Bus',
  CABS: 'Cabs',
  TRAINS: 'Trains',
  VISA: 'Visa',
  FOREX: 'Forex',
  INSURANCE: 'Insurance'
};
var LOBS_CATG = {
  FLIGHTS: 'flights',
  HOTELS: 'hotels',
  BUS: 'bus',
  CABS: 'cabs',
  TRAINS: 'trains',
  HOLIDAYS: 'holidays',
  ACTIVITIES: 'activities',
  GROWTH: 'growth',
  COMMON: 'common',
  METRO: 'metro',
  VISA: 'visa',
  FOREX: 'forex',
  INSURANCE: 'Insurance'
};
var GOTRIBE_MEMBER_TYPES = {
  non_member: {
    value: 'non_member',
    label: ''
  },
  member: {
    value: 'member'
  },
  star: {
    value: 'star',
    label: 'Star'
  },
  superstar: {
    value: 'superstar',
    label: 'SuperStar'
  }
};
var DEFAULT_PROFILE_NAME = 'Traveller';

var isActiveLink = function isActiveLink(navLabel, lobName) {
  if (navLabel && lobName) {
    return navLabel.toLowerCase() === lobName.toLowerCase();
  }

  return false;
};

var goTribeMembers = [GOTRIBE_MEMBER_TYPES.star.value, GOTRIBE_MEMBER_TYPES.superstar.value, GOTRIBE_MEMBER_TYPES.member.value];

var isGoTribeMember = function isGoTribeMember(memberType) {
  return goTribeMembers.includes(memberType);
};

var getUserNameInitials = function getUserNameInitials(name) {
  return name.toString().charAt(0).toUpperCase();
};

var NavBar = function NavBar(_ref) {
  var navList = _ref.navList,
      lobName = _ref.lobName;
  var activeClass = (0,react.useCallback)(function (label, lob) {
    return !!isActiveLink(label, lob);
  }, [lobName]);

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  function navBarGaEvent(item) {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_NAV_ICON', {
      item_selected: item.category
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: item.category,
        type: 'itemClick',
        destination: item.url,
        componentName: 'header'
      }
    });
  }
  /** Hide the last item in nav if viewport is smaller than  1440px */


  var _useState = (0,react.useState)(true),
      hideLastItem = _useState[0],
      setShowLastItem = _useState[1];

  (0,react.useEffect)(function () {
    var viewport = window.matchMedia('(max-width: 1440px)');
    setShowLastItem(viewport.matches);
    viewport.addEventListener('change', function (e) {
      return setShowLastItem(e.matches);
    });
    return function () {
      viewport.removeEventListener('change', function (e) {
        return setShowLastItem(e.matches);
      });
    };
  }, []);
  var currentNavList = hideLastItem ? navList.slice(0, navList.length - 1) : navList.slice(0, navList.length);
  return /*#__PURE__*/react.createElement(HappyNav, null, currentNavList.map(function (item) {
    var _item$icon, _item$icon2;

    return /*#__PURE__*/react.createElement(HappyNavItem, {
      key: item.label,
      isActive: activeClass(item.category, lobName)
    }, /*#__PURE__*/react.createElement(NavLink$1, {
      href: item.url,
      target: "" + (item.targetBlank ? '_blank' : '_self'),
      className: activeClass(item.category, lobName) ? 'active' : '',
      onClick: function onClick() {
        return navBarGaEvent(item);
      }
    }, ((_item$icon = item.icon) == null ? void 0 : _item$icon.type) === 'svg' ? /*#__PURE__*/react.createElement(NavLinkSvg, null, /*#__PURE__*/react.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: (_item$icon2 = item.icon) == null ? void 0 : _item$icon2.source
      }
    })) : /*#__PURE__*/react.createElement(NavIcon$1, {
      className: "header-sprite nav-icon-" + item.icon
    }), /*#__PURE__*/react.createElement(NavText, null, item.label), item["new"] && /*#__PURE__*/react.createElement(NewLob, null, "NEW")));
  }));
};

var _templateObject$b, _templateObject2$9;
var LogoLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject$b || (_templateObject$b = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\twidth: 151px;\n\tmargin-right: 55px;\n\n\t.special-logo {\n\t\tmargin-left: 0;\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: contain;\n\t}\n\t.gi-logo {\n\t\tmargin-left: 32px;\n\t}\n"])));
var Logo = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2$9 || (_templateObject2$9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: inherit;\n\theight: 65px;\n"])));

var HeaderLogo = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var homeURL = _ref.homeURL,
      lobName = _ref.lobName;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      adobe = _useAnalytics.adobe;

  var addAnalyticsEvent = function addAnalyticsEvent() {
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: 'logo',
        destination: homeURL,
        type: 'itemClick',
        componentName: 'header'
      }
    });
  };

  return /*#__PURE__*/react.createElement(LogoLink, {
    href: homeURL,
    onClick: addAnalyticsEvent
  }, /*#__PURE__*/react.createElement(Logo, {
    className: "header-sprite logo gi-logo",
    ref: ref
  }));
});
HeaderLogo.displayName = 'HeaderLogo';

var _templateObject$a, _templateObject2$8, _templateObject3$7, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$3;
var TabContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$a || (_templateObject$a = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tposition: relative;\n\tmin-height: 40px;\n\twidth: 108px;\n\tmargin-right: 20px;\n\n\t&:hover .tooltip {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n"])));
var MyTripTab = (0,styled_components_browser_esm/* default */.ZP)(TabContainer)(_templateObject2$8 || (_templateObject2$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 148px;\n"])));
var NavLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject3$7 || (_templateObject3$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose([""])));
var Tooltip = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$4 || (_templateObject4$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 12px 10px 30px;\n\ttop: 52px;\n\tleft: -66px;\n\tdisplay: none;\n\tcolor: #46484d;\n\n\t", ":hover & {\n\t\tdisplay: block;\n\t\tz-index: 9999999;\n\t}\n\n\t&::after,\n\t&::before {\n\t\tbottom: 100%;\n\t\tleft: 50%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t}\n\n\t&::after {\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n\n\t&::before {\n\t\tborder-color: rgba(227, 227, 227, 0);\n\t\tborder-bottom-color: #e3e3e3;\n\t\tborder-width: 9px;\n\t\tmargin-left: -9px;\n\t}\n\n\tp::before {\n\t\tcontent: '';\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder-radius: 100%;\n\t\tbackground: #50e3c2;\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tleft: 12px;\n\t\ttop: 12px;\n\t}\n"])), MyTripTab);
var NavIcon = styled_components_browser_esm/* default.span */.ZP.span(_templateObject5$3 || (_templateObject5$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 10px;\n"])));
var NotificationTag = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$3 || (_templateObject6$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 100%;\n\tbackground: #ffea67;\n\tborder: solid 1px #fba707;\n\tfont-size: 10px;\n\tcolor: #000;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 12px;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject7$3 || (_templateObject7$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tbackground: url(https://gos3.ibcdn.com/gocash-1656061010.png);\n\theight: 24px;\n\twidth: 30px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n"])));

var NavWidgets = function NavWidgets(props) {
  var upcomingTrip = props.upcomingTrip,
      isLoggedIn = props.isLoggedIn,
      navOrigin = props.navOrigin,
      lobName = props.lobName;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  function sendGAEvent(linkName, url) {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_NAV_WIDGETS', {
      item_selected: linkName
    });
    adobe.track('ctaClick', {
      page: {
        pageInfo: {
          loadedComponents: "action:Item_Selected_clicked_from_" + lobName
        }
      },
      cta: {
        name: linkName,
        type: 'itemClick',
        componentName: 'header',
        destination: url
      }
    });
  }

  var mytrip = W_MY_TRIPS(navOrigin);
  return /*#__PURE__*/react.createElement(NavLink, {
    href: mytrip.url,
    onClick: function onClick() {
      return sendGAEvent('my_trips', mytrip.url);
    }
  }, /*#__PURE__*/react.createElement(MyTripTab, {
    role: "presentation"
  }, /*#__PURE__*/react.createElement(NavIcon, {
    className: "header-sprite " + mytrip.icon
  }), isLoggedIn && upcomingTrip ? /*#__PURE__*/react.createElement(NotificationTag, null, upcomingTrip) : null, /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW2",
    style: {
      color: isLoggedIn ? '#0074eb' : '#666'
    }
  }, mytrip.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2",
    style: {
      color: '#333'
    }
  }, mytrip.manageBooking))), /*#__PURE__*/react.createElement(Tooltip, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1"
  }, mytrip.tooltip))));
};

/*
 * You can change the LOBS nav item in header by changing the below array
 * item order
 *
 * If you are adding a new LOB in this list, make sure 'HeaderUrlConfig'
 * must have the require config for that new LOB.
 */

var lobsListInOrder = ['FLIGHTS', 'HOTELS', 'TRAINS', 'CABS', 'BUS', 'HOLIDAYS', 'FOREX', 'INSURANCE'];
var lobsPathName = {
  HOME: '/',
  FLIGHTS: '/flights/',
  HOTELS: '/hotels/',
  TRAINS: '/trains/',
  CABS: '/cars/',
  BUS: '/bus/',
  VISA: '/visa/',
  HOLIDAYS: '/giholidays/',
  INSURANCE: '/insurance?cmp=desktop_header',
  FOREX: 'https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=header_goibibo&utm_medium=desktop'
};
var lobOffersPath = {
  flights: 'flight-offers/',
  hotels: 'hotel-offers/',
  cabs: 'gocar-offers/',
  trains: 'train-offers/',
  bus: 'bus-offers/'
};
/*
 * Assuming as LOBs pages will be in `/`  path of origin(https://goibibo.com/<lobpage>) if not then lobs can
 pass navOrigin as prop to replace it.
 eg:
 navOrigin: "https://www.goibibo.com" if header is integrated in subdomain or other domain than goibibo.com
 */
// @private

function getNavListUrls(origin) {
  if (origin === void 0) {
    origin = '';
  }

  var urls = {
    FLIGHTS: {
      URL: origin + lobsPathName.FLIGHTS,
      LABEL: LOBS_NAME.FLIGHTS,
      CATEGORY: LOBS_CATG.FLIGHTS,
      ICON: 'flights' // sprite icons class name

    },
    HOTELS: {
      URL: origin + lobsPathName.HOTELS,
      LABEL: LOBS_NAME.HOTELS,
      CATEGORY: LOBS_CATG.HOTELS,
      ICON: 'hotels'
    },
    TRAINS: {
      URL: origin + lobsPathName.TRAINS,
      LABEL: LOBS_NAME.TRAINS,
      CATEGORY: LOBS_CATG.TRAINS,
      ICON: 'trains'
    },
    CABS: {
      URL: origin + lobsPathName.CABS,
      LABEL: LOBS_NAME.CABS,
      CATEGORY: LOBS_CATG.CABS,
      ICON: 'cabs'
    },
    BUS: {
      URL: origin + lobsPathName.BUS,
      LABEL: LOBS_NAME.BUS,
      CATEGORY: LOBS_CATG.BUS,
      ICON: 'bus'
    },
    VISA: {
      URL: origin + lobsPathName.VISA,
      LABEL: LOBS_NAME.VISA,
      CATEGORY: LOBS_CATG.VISA,
      ICON: 'visa',
      NEW: false
    },
    FOREX: {
      URL: lobsPathName.FOREX,
      LABEL: LOBS_NAME.FOREX,
      CATEGORY: LOBS_CATG.FOREX,
      ICON: 'forex',
      TARGET_BLANK: true
    },
    HOLIDAYS: {
      URL: origin + lobsPathName.HOLIDAYS,
      LABEL: LOBS_NAME.HOLIDAYS,
      CATEGORY: LOBS_CATG.HOLIDAYS,
      ICON: 'holiday',
      TARGET_BLANK: true
    },
    INSURANCE: {
      URL: origin + lobsPathName.INSURANCE,
      LABEL: LOBS_NAME.INSURANCE,
      CATEGORY: LOBS_CATG.INSURANCE,
      ICON: 'insurance',
      TARGET_BLANK: false
    }
  };
  return urls;
}

function generateMainNavList(list, navUrls) {
  var finalList = [];
  list.forEach(function (item) {
    var l = {
      url: navUrls[item].URL,
      path: navUrls[item].PATHNAME,
      label: navUrls[item].LABEL,
      icon: navUrls[item].ICON,
      "new": navUrls[item].NEW || false,
      targetBlank: navUrls[item].TARGET_BLANK || false,
      category: navUrls[item].CATEGORY
    };
    finalList.push(l);
  });
  return finalList;
}

var lobsNavList = function lobsNavList(origin) {
  return generateMainNavList(lobsListInOrder, getNavListUrls(origin));
};

var _templateObject$9, _templateObject2$7, _templateObject3$6;
var AvatarWrap = styled_components_browser_esm/* default.span */.ZP.span(_templateObject$9 || (_templateObject$9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tborder-radius: 100%;\n\toverflow: hidden;\n\tmargin-right: 5px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n\t", "\n"])), function (_ref) {
  var image = _ref.image;
  return !image ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2$7 || (_templateObject2$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\t  "]))) : '';
});
var ProfileNameChar = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3$6 || (_templateObject3$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\tfont-stretch: normal;\n\tfont-style: normal;\n\tletter-spacing: normal;\n\tcolor: #fff;\n\ttext-align: center;\n\tposition: absolute;\n\ttop: 4px;\n"])));

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$3;
var placeHolderShimmer = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject$8 || (_templateObject$8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n0% {\n\tbackground-position: -468px 0;\n}\n\n100% {\n\tbackground-position: 468px 0;\n}\n"])));
var Shimmer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$6 || (_templateObject2$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tanimation-duration: 1s;\n\tanimation-fill-mode: forwards;\n\tanimation-iteration-count: infinite;\n\tanimation-name: ", ";\n\tanimation-timing-function: linear;\n\tbackground: #f6f7f8;\n\tbackground: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n\tbackground-size: 800px 104px;\n\tposition: relative;\n"])), placeHolderShimmer);
var HorizontalShimmer = (0,styled_components_browser_esm/* default */.ZP)(Shimmer)(_templateObject3$5 || (_templateObject3$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 80%;\n\theight: 15px;\n"])));
var CircularShimmer = (0,styled_components_browser_esm/* default */.ZP)(Shimmer)(_templateObject4$3 || (_templateObject4$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n"])));

var UserAvatar = function UserAvatar(props) {
  var image = props.image,
      firstName = props.firstName,
      isLoggedIn = props.isLoggedIn,
      loading = props.loading;
  var getNameFirstChar = (0,react.useCallback)(function () {
    return getUserNameInitials(firstName);
  }, [firstName]);

  if (isLoggedIn) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, image ? /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: getNameFirstChar()
    }) : /*#__PURE__*/react.createElement(ProfileNameChar, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
      size: "MediumW3"
    }, getNameFirstChar())));
  }

  if (loading) {
    return /*#__PURE__*/react.createElement(CircularShimmer, null);
  }

  if (image) {
    return /*#__PURE__*/react.createElement(AvatarWrap, {
      image: image
    }, /*#__PURE__*/react.createElement("img", {
      src: image,
      style: {
        objectFit: 'cover'
      },
      alt: "avatar"
    }));
  }

  return /*#__PURE__*/react.createElement("span", {
    className: "header-sprite user-icon",
    style: {
      marginRight: '5px'
    }
  });
};

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
var LoginDropdown = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$7 || (_templateObject$7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tbackground: #fff;\n\tborder: 1px solid #e3e3e3;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);\n\twidth: 250px;\n\tpadding: 10px 20px;\n\tfont-size: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 1000;\n\tcolor: #46484d;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$5 || (_templateObject2$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex-direction: column;\n\talign-items: flex-start !important;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject3$4 || (_templateObject3$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-bottom: 1px !important;\n\tcolor: #4e525b;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$2 || (_templateObject4$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #4e525b;\n\tmargin-bottom: 12px !important;\n"])));
var DropdownListItem = styled_components_browser_esm/* default.a */.ZP.a(_templateObject5$2 || (_templateObject5$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: solid 1px #efefef;\n\tpadding: 8px 0;\n\tcursor: pointer;\n\tcolor: #46484d !important;\n\t&:first-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:last-of-type {\n\t\tborder-bottom: 0;\n\t}\n\t&:visited {\n\t\tcolor: #46484d;\n\t}\n"])));
var DropdownLoginWrap = styled_components_browser_esm/* default.li */.ZP.li(_templateObject6$2 || (_templateObject6$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tmargin: 8px 0px;\n"])));
var DropdownLinkUser = styled_components_browser_esm/* default.a */.ZP.a(_templateObject7$2 || (_templateObject7$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject8$1 || (_templateObject8$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n"])));
var DropdownLinkWrapLoyalty = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9$1 || (_templateObject9$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
styled_components_browser_esm/* default.a */.ZP.a(_templateObject10$1 || (_templateObject10$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #2276e3;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject11$1 || (_templateObject11$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\theight: 28px;\n\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 50%;\n\t}\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject12$1 || (_templateObject12$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 22px;\n\theight: 22px;\n\ttop: 1px;\n\tfont-size: 14px;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject13 || (_templateObject13 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 8px;\n\twidth: 32px;\n\tdisplay: inline-block;\n\tbackground: #e3e3e3;\n"])));
var DropdownMenuWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14 || (_templateObject14 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex: 1;\n"])));
var DropdownSprite = styled_components_browser_esm/* default.div */.ZP.div(_templateObject15 || (_templateObject15 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin-right: 20px;\n"])));
var LoginButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject16 || (_templateObject16 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\t", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ProfileItemWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject17 || (_templateObject17 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tflex: 1 1 0%;\n\tmargin-left: 8px;\n"])));
var ItemLabel = styled_components_browser_esm/* default.p */.ZP.p(_templateObject18 || (_templateObject18 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 3px;\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);
var ItemSubLabel = styled_components_browser_esm/* default.p */.ZP.p(_templateObject19 || (_templateObject19 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #4e525b;\n"])), growth_design_system_esm/* textSizes.SmallW1 */.iH.SmallW1);

var DropDownItemUserProfile = function DropDownItemUserProfile(_ref) {
  var onViewProfileClick = _ref.onViewProfileClick,
      userImage = _ref.userImage,
      fullName = _ref.fullName,
      isLoggedIn = _ref.isLoggedIn,
      onLoginCtaClick = _ref.onLoginCtaClick,
      navOrigin = _ref.navOrigin;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);
  return /*#__PURE__*/react.createElement(DropdownLoginWrap, null, !isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "MediumW2",
    style: {
      marginBottom: '1px',
      color: '#4e525b'
    }
  }, dropDownList.login.label), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      marginBottom: '12px',
      color: '#4e525b'
    }
  }, dropDownList.login.subLabel), /*#__PURE__*/react.createElement(LoginButton, {
    onClick: function onClick() {
      return onLoginCtaClick('login-cta-dropdown');
    },
    type: "button"
  }, dropDownList.login.ctaText)) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(DropdownLinkUser, {
    href: dropDownList.view_profile.url,
    onClick: onViewProfileClick
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: userImage,
    firstName: fullName,
    isLoggedIn: true
  }), /*#__PURE__*/react.createElement(ProfileItemWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#4e525b",
    size: "MediumW2",
    style: {
      marginBottom: '3px',
      textTransform: 'capitalize'
    }
  }, fullName), /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "SmallW1",
    style: {
      color: '#2276e3'
    }
  }, dropDownList.view_profile.label, ' ')))));
};

var _templateObject$6, _templateObject2$4, _templateObject3$3;
var HappyGiHeader = styled_components_browser_esm/* default.header */.ZP.header(_templateObject$6 || (_templateObject$6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbackground: #fff;\n\tdisplay: flex !important;\n\talign-items: center;\n\tpadding: 0px 32px 0 0;\n\tbox-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n\tz-index: 900;\n\tposition: relative;\n\theight: 64px;\n\n\t&.header-sticky {\n\t\tposition: fixed !important;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.logo {\n\t\tmargin-right: 35px;\n\t}\n\n\t@media (max-width: 640px) {\n\t\tdisplay: none !important;\n\t}\n"])));
var LoginWidgetWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$4 || (_templateObject2$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: auto;\n"])));
var GotribeBadge$1 = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3$3 || (_templateObject3$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 1px 5px;\n\tborder-radius: 7px;\n\tbackground-image: ", ";\n\tcolor: #fff;\n\t", "\n"])), function (_ref) {
  var memberType = _ref.memberType;
  return memberType === GOTRIBE_MEMBER_TYPES.superstar.value ? 'linear-gradient(to right, #e63148 40%, #ff4e00)' : 'linear-gradient(to right, #fa961a 19%, #ffb305 95%)';
}, growth_design_system_esm/* textSizes.SmallW3 */.iH.SmallW3);

var DropDownItemLoyalty = function DropDownItemLoyalty(_ref) {
  var _ref$control = _ref.control,
      control = _ref$control === void 0 ? true : _ref$control,
      memberType = _ref.memberType,
      navOrigin = _ref.navOrigin,
      sendEvent = _ref.sendEvent;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);

  var _useState = (0,react.useState)(true),
      show = _useState[0],
      setShow = _useState[1];
  /* GROW-2765
   * to check blacklist gotribe option
   * control true blacklist, control false normal user
   * if there is no cards then it's a control/whitlisted gotribeuser
   */


  (0,react.useEffect)(function () {
    setShow(!!control);
  }, [control]);
  if (!show) return /*#__PURE__*/react.createElement(react.Fragment, null);
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    as: "span"
  }, /*#__PURE__*/react.createElement(DropdownLink, {
    href: dropDownList.gotTribe.url,
    onClick: function onClick() {
      return sendEvent({
        link: 'go_tribe',
        memberType: memberType
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(DropdownLinkWrapLoyalty, null, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + dropDownList.gotTribe.goTribeIcon,
    style: {
      marginLeft: 0,
      marginRight: 0
    }
  }), memberType !== GOTRIBE_MEMBER_TYPES.non_member.value && /*#__PURE__*/react.createElement(GotribeBadge$1, {
    memberType: memberType
  }, GOTRIBE_MEMBER_TYPES[memberType].label)), /*#__PURE__*/react.createElement(ItemSubLabel, null, memberType !== GOTRIBE_MEMBER_TYPES.non_member.value ? dropDownList.gotTribe.subLabel.member : dropDownList.gotTribe.subLabel.nonMember))));
};

var DropDownItemGeneric = function DropDownItemGeneric(_ref) {
  var sendEvent = _ref.sendEvent,
      listItem = _ref.listItem,
      itemChild = _ref.itemChild;
  var url = listItem.url,
      label = listItem.label,
      subLabel = listItem.subLabel,
      icon = listItem.icon;
  return /*#__PURE__*/react.createElement(DropdownListItem, {
    href: url,
    onClick: function onClick() {
      return sendEvent({
        link: label
      });
    }
  }, /*#__PURE__*/react.createElement(DropdownSprite, {
    className: "dropdown-sprite " + icon
  }), /*#__PURE__*/react.createElement(DropdownMenuWrap, null, /*#__PURE__*/react.createElement(ItemLabel, null, label), /*#__PURE__*/react.createElement(ItemSubLabel, null, itemChild || subLabel)));
};

DropDownItemGeneric.defaultProps = {
  itemChild: undefined
};

var UserDropDown = function UserDropDown(props) {
  var _loyaltyUserInfoData$;

  var userInfo = props.userInfo,
      hideDropDown = props.hideDropDown,
      memberType = props.memberType,
      upcomingTripCount = props.upcomingTripCount,
      isLoggedIn = props.isLoggedIn,
      _onLoginCtaClick = props.onLoginCtaClick,
      lobName = props.lobName,
      navOrigin = props.navOrigin,
      positionStyle = props.positionStyle;
  var dropDownList = W_USER_PROFILE_DROPDOWN(navOrigin);
  var loyaltyUserInfoData = useLoyaltyUserInfoStore(function (s) {
    return s.data;
  }, shallow/* shallow */.X);

  var _useGoCashBalanceStor = useGoCashBalanceStore(),
      gocashData = _useGoCashBalanceStor.data,
      gocashLoading = _useGoCashBalanceStor.loading;

  var balance = gocashData.balance;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;
  /* GROW-2765
   * to check blacklist gotribe option
   * control true blacklist, control false normal user
   * if there is no cards then it's a control/whitlisted gotribeuser
   */


  var control = loyaltyUserInfoData == null ? void 0 : (_loyaltyUserInfoData$ = loyaltyUserInfoData.cards) == null ? void 0 : _loyaltyUserInfoData$.length;

  var handleOutsideClick = function handleOutsideClick(e) {
    var el = e.target;
    var dropdownContainer = el.closest('ul.login__dropdown');

    if (!dropdownContainer) {
      hideDropDown();
    }
  };

  var sendEvent = function sendEvent(eventObj) {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_DROPDOWN_LINK', {
      item_selected: eventObj.link
    });
    adobe.track('ctaClick', {
      cta: {
        name: eventObj.link,
        type: 'itemClick',
        componentName: 'Header Dropdown'
      }
    });
  };

  var handleViewProfile = function handleViewProfile() {
    sendEvent({
      link: 'view_profile'
    });
  };

  (0,react.useEffect)(function () {
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  var getOffersUrl = function getOffersUrl() {
    var offersUrl = dropDownList.offers.url;

    if (lobName && lobOffersPath[lobName]) {
      return "" + offersUrl + lobOffersPath[lobName];
    }

    return offersUrl;
  };

  var fullName = userInfo != null && userInfo.firstName ? (userInfo == null ? void 0 : userInfo.firstName) + " " + ((userInfo == null ? void 0 : userInfo.lastName) || '') : DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginDropdown, {
    style: positionStyle,
    "data-id": "header-dropdown"
  }, /*#__PURE__*/react.createElement(DropDownItemUserProfile, {
    onViewProfileClick: handleViewProfile,
    userImage: userInfo == null ? void 0 : userInfo.profileImage,
    fullName: fullName,
    isLoggedIn: isLoggedIn,
    onLoginCtaClick: function onLoginCtaClick() {
      return _onLoginCtaClick({
        name: 'login-cta-dropdown',
        componentName: 'Header Dropdown'
      });
    },
    navOrigin: navOrigin
  }), /*#__PURE__*/react.createElement(DropDownItemLoyalty, {
    control: control,
    memberType: memberType,
    navOrigin: navOrigin,
    sendEvent: sendEvent
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: growth_dweb_header_esm_extends({}, dropDownList.offers, {
      url: getOffersUrl()
    })
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.myTrips,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, upcomingTripCount ? upcomingTripCount + "\n                " + (upcomingTripCount > 1 ? dropDownList.myTrips.subLabel.plural : dropDownList.myTrips.subLabel.singular) : 'Manage your bookings')
  }), /*#__PURE__*/react.createElement(DropDownItemGeneric, {
    sendEvent: sendEvent,
    listItem: dropDownList.goCash,
    itemChild: /*#__PURE__*/react.createElement(react.Fragment, null, isLoggedIn ? /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabel, /*#__PURE__*/react.createElement("span", {
      className: "gr-bold"
    }, gocashLoading ? /*#__PURE__*/react.createElement("span", {
      className: "gocashLoading"
    }) : /*#__PURE__*/react.createElement(react.Fragment, null, W_RUPEE_SIGN, balance))) : /*#__PURE__*/react.createElement(react.Fragment, null, dropDownList.goCash.subLabelGuest))
  }));
};

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var LoginTab = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$5 || (_templateObject$5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 186px;\n\tposition: relative;\n\theight: 44px;\n\tbackground-color: #fff;\n\ttransition: all 0.4s ease;\n\n\t.gr-user {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tborder-radius: 100%;\n\t\toverflow: hidden;\n\n\t\timg {\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\t&.name__text {\n\t\t\tbackground-image: linear-gradient(225deg, #ff3e5e, #ff7f3f);\n\t\t\tfont-size: 16px;\n\t\t\tcolor: #fff;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\n\t.you-are {\n\t\tvertical-align: bottom;\n\t}\n\n\t.horizontal_shimmer {\n\t\tmargin-left: 12px;\n\t}\n"])));
var UserNameWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2$3 || (_templateObject2$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #46484d;\n"])), growth_design_system_esm/* textSizes.SmallW2 */.iH.SmallW2);
var UserNameText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject3$2 || (_templateObject3$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n\ttext-transform: capitalize;\n\tmargin-left: 4px;\n"])));
var LoginTabWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4$1 || (_templateObject4$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\tborder-radius: 8px;\n\tborder: solid 1px #2276e3;\n\tpadding: 0 8px;\n\tcursor: pointer;\n    overflow: hidden;\n"])));
var ScrollItemWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5$1 || (_templateObject5$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var SignUpCtaTextWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6$1 || (_templateObject6$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose([""])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject7$1 || (_templateObject7$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 1px;\n\theight: 29px;\n\tborder-right: solid 1px #eff3f8;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject8 || (_templateObject8 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tcolor: #fff;\n\tfont-size: 8px;\n\tbackground-image: linear-gradient(to right, #e63148 40%, #ff4e00);\n\n\t&.super {\n\t\tbackground-image: linear-gradient(to right, #fa961a 19%, #ffb305 95%);\n\t}\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tmax-width: 50px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmax-width: 70px;\n\tvertical-align: bottom !important;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(_templateObject11 || (_templateObject11 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\theight: 24px;\n\twidth: 24px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tmargin-right: 2px;\n\tmargin-left: 4px;\n"])));
var ArrowIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12 || (_templateObject12 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tborder: solid #2274e0;\n\tborder-width: 0 2px 2px 0;\n\tdisplay: inline-block;\n\tpadding: 2px;\n\tmargin-left: auto;\n\n\t&.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t&.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t&.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t&.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var _templateObject$4, _templateObject2$2, _templateObject3$1;
var MainWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$4 || (_templateObject$4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n    position: relative;\n    overflow: hidden;\n    width: 100vw;\n    max-width: 100%;\n"])));
var List = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject2$2 || (_templateObject2$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  /* overflow: hidden; */\n  transform: ", ";\n    transition: transform 300ms ease-in-out;\n    -webkit-transition: transform 300ms ease-in-out;\n"])), function (props) {
  return "translateY(-" + props.height + ")";
});
var ListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3$1 || (_templateObject3$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  width: 200px;\n"])));

var Carousal = function Carousal(_ref) {
  var _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      contentHeight = _ref.contentHeight,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$loopCount = _ref.loopCount,
      loopCount = _ref$loopCount === void 0 ? 1 : _ref$loopCount;
  var listCount = list.length;
  var listRef = (0,react.useRef)(null);
  var positionRef = (0,react.useRef)(-contentHeight);
  var duration = 0.5;
  var endPosition = listCount * -contentHeight;
  var RotationCount = (0,react.useRef)(1);
  var timeoutId = (0,react.useRef)();

  function nextSlide() {
    if (!listRef.current) {
      return;
    }

    positionRef.current -= contentHeight;

    if (listRef.current) {
      listRef.current.style.transform = "translateY(" + positionRef.current + "px)";
      listRef.current.style.transitionDuration = duration + "s";
    }
  }

  function rotateSlide() {
    if (!listRef.current) {
      return;
    }

    positionRef.current = -contentHeight;
    setTimeout(function () {
      if (listRef.current) {
        listRef.current.style.transform = "translateY(-" + contentHeight + "px)";
        listRef.current.style.transitionDuration = '0s';
      }
    }, 1000);
  }

  var rotate = function rotate() {
    if (!listRef.current) {
      return;
    }

    if (positionRef.current === endPosition) {
      nextSlide();
      rotateSlide();
      RotationCount.current += 1;
    } else {
      nextSlide();
    }

    if (RotationCount.current <= loopCount) {
      timeoutId.current = setTimeout(function () {
        rotate();
      }, 2000);
    }
  };

  (0,react.useEffect)(function () {
    // if list length is greater than 1 and loop is true make loop 2 times otherwise only once
    if (listCount > 1) {
      if (loop) {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      } else {
        timeoutId.current = setTimeout(function () {
          rotate();
        }, 2000);
      }
    }

    return function () {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [loop, listCount]);

  var isTextItem = function isTextItem(item) {
    return typeof item === 'object' && 'text' in item;
  };

  var lastItem = list[listCount - 1];
  var firstItem = list[0];
  return /*#__PURE__*/react.createElement(MainWrapper, {
    style: {
      height: contentHeight + "px"
    }
  }, /*#__PURE__*/react.createElement(List, {
    ref: listRef,
    height: contentHeight + "px"
  }, /*#__PURE__*/react.createElement(ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(lastItem) ? lastItem.text : /*#__PURE__*/react.createElement(lastItem.component, lastItem.props)), list.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      react.createElement(ListItem, {
        key: "txt_para_" + index,
        style: {
          height: contentHeight + "px"
        }
      }, isTextItem(item) ? item.text : /*#__PURE__*/react.createElement(item.component, item.props))
    );
  }), /*#__PURE__*/react.createElement(ListItem, {
    style: {
      height: contentHeight + "px"
    }
  }, isTextItem(firstItem) ? firstItem.text : /*#__PURE__*/react.createElement(firstItem.component, firstItem.props))));
};

var GuestDetails = function GuestDetails() {
  var contentToScroll = [].concat(W_LOGIN_WIDGET_CTA);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(UserAvatar, null), /*#__PURE__*/react.createElement(SignUpCtaTextWrap, {
    role: "presentation",
    id: "get_sign_in"
  }, /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 16,
    loop: false,
    loopCount: 1
  })));
};

var _templateObject$3, _templateObject2$1;
var GotribeInfoWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$3 || (_templateObject$3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var GotribeBadge = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2$1 || (_templateObject2$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tmargin: 0 0 0 2px;\n\tpadding: 1px 5px 2px 5px;\n\tborder-radius: 7px;\n\tbackground-image: ", ";\n\n\tcolor: #fff;\n\t", "\n"])), function (_ref) {
  var memberType = _ref.memberType;
  return memberType === GOTRIBE_MEMBER_TYPES.superstar.value ? 'linear-gradient(to right, #fa961a 19%, #ffb305 95%)' : 'linear-gradient(to right, #e63148 40%, #ff4e00)';
}, growth_design_system_esm/* textSizes.SmallW3 */.iH.SmallW3);

var GoTribeMember = function GoTribeMember(props) {
  var memberType = props.memberType;
  return /*#__PURE__*/react.createElement(react.Fragment, null, isGoTribeMember(memberType) ? /*#__PURE__*/react.createElement(GotribeInfoWrap, null, /*#__PURE__*/react.createElement("span", {
    className: "dropdown-sprite gotribeLogo"
  }), /*#__PURE__*/react.createElement(GotribeBadge, {
    memberType: memberType
  }, GOTRIBE_MEMBER_TYPES[memberType].label)) : null);
};

var UserDetails = function UserDetails(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
      loading = _ref.loading,
      profileImage = _ref.profileImage,
      firstName = _ref.firstName,
      loyaltyMemberType = _ref.loyaltyMemberType;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: profileImage,
    firstName: firstName,
    isLoggedIn: isLoggedIn,
    loading: loading
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement("span", null, "Hey"), /*#__PURE__*/react.createElement(UserNameText, null, firstName)), /*#__PURE__*/react.createElement(GoTribeMember, {
    memberType: loyaltyMemberType
  })));
};

var GocashDetails = function GocashDetails(_ref) {
  var balance = _ref.balance,
      gocashLoading = _ref.gocashLoading;
  return /*#__PURE__*/react.createElement(ScrollItemWrap, {
    style: {
      height: '32px'
    }
  }, /*#__PURE__*/react.createElement(UserAvatar, {
    image: "https://go-assets.ibcdn.com/u/GI/images/1710408879842-gocash-gold.png"
  }), /*#__PURE__*/react.createElement(UserNameWrap, null, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#000",
    size: "SmallW2"
  }, "Gocash"), !gocashLoading && /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW1",
    as: "span"
  }, "Balance:", /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    color: "#717171",
    size: "SmallW3",
    as: "span"
  }, "\u20B9", balance))));
};

var LoggedInDetails = function LoggedInDetails(_ref) {
  var loading = _ref.loading,
      profileImage = _ref.profileImage,
      firstName = _ref.firstName,
      loyaltyMemberType = _ref.loyaltyMemberType;

  var _useGoCashBalanceStor = useGoCashBalanceStore(),
      gocashData = _useGoCashBalanceStor.data,
      gocashLoaded = _useGoCashBalanceStor.loaded,
      gocashLoading = _useGoCashBalanceStor.loading,
      gocashError = _useGoCashBalanceStor.error;

  var balance = gocashData.balance;
  var content = [{
    component: UserDetails,
    props: {
      isLoggedIn: true,
      firstName: firstName,
      loading: loading,
      profileImage: profileImage,
      loyaltyMemberType: loyaltyMemberType
    }
  }];
  /* add items in animation content */
  // Gocash

  if (gocashLoaded && !gocashError) {
    content.push({
      component: GocashDetails,
      props: {
        balance: balance,
        gocashLoading: gocashLoading
      }
    });
  }

  var contentToScroll = [].concat(content);
  return /*#__PURE__*/react.createElement(Carousal, {
    list: contentToScroll,
    contentHeight: 32,
    loop: true,
    loopCount: 2
  });
};

var UserLoginWidget = function UserLoginWidget(props) {
  var _useProfileStore = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return {
      $userDetails: s.data,
      loading: s.loading
    };
  }, shallow/* shallow */.X),
      $userDetails = _useProfileStore.$userDetails,
      loading = _useProfileStore.loading;

  var showLogin = props.showLogin,
      onLogoutSuccess = props.onLogoutSuccess,
      reloadAfterLogout = props.reloadAfterLogout,
      isLoginPopoverVisible = props.isLoginPopoverVisible,
      lobName = props.lobName,
      navOrigin = props.navOrigin,
      upComingTripCounts = props.upComingTripCounts;

  var _useState = (0,react.useState)(false),
      showUserDropDown = _useState[0],
      updateShowUserDropDown = _useState[1];

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var loginCtaRef = (0,react.useRef)('');
  var dropDownTimer;
  var hasMounted = (0,growth_custom_hooks_useHasMounted_esm/* useHasMounted */.f)();
  var loyaltyUserInfoData = useLoyaltyUserInfoStore(function (s) {
    return s.data;
  });
  var loyaltyMemberType = selectLoyaltyMemberType(loyaltyUserInfoData);

  var handleLogout = function handleLogout() {
    updateShowUserDropDown(false);
    (0,growth_auth_helpers_esm/* fetchLogoutUser */.hM)({
      platform: 'dweb'
    }).then(function () {
      updateShowUserDropDown(false);
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);

      if (onLogoutSuccess) {
        growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT_SUCCESS);
        onLogoutSuccess();
      } else if (reloadAfterLogout) window.location.reload();
    });
  };

  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
      handleLogout();
    });
    return function () {
      return growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT, function () {
        handleLogout();
      });
    };
  }, []);
  var toggleUserDropDown = (0,react.useCallback)(function () {
    updateShowUserDropDown(!showUserDropDown);
  }, [showUserDropDown]);

  var handleOnLoginWidgetClick = function handleOnLoginWidgetClick(_ref) {
    var name = _ref.name,
        componentName = _ref.componentName;
    if (loading) return;

    if (!$userDetails.isLoggedIn) {
      pdt.track('HAPPY_HEADER_WEBA__CLICK_LOGIN_BTN', {
        link: name,
        item_selected: loginCtaRef.current
      });
      adobe.track('ctaClick', {
        cta: {
          name: "" + name,
          type: 'itemClick',
          componentName: componentName
        }
      });
      showLogin();
    } else {
      pdt.track('HAPPY_HEADER_WEBA__CLICK_NAV_WIDGETS', {
        link: name
      });
      toggleUserDropDown();
    }
  }; // using this function to show dropdown on hover


  var showDropDown = function showDropDown() {
    if (!isLoginPopoverVisible && !loading) {
      clearTimeout(dropDownTimer);
      updateShowUserDropDown(true);
    }
  }; // function to hide dropdown on mouse leave and
  // adding delay so that when mouse leave user can focus on dropdown list


  var hideDropDown = function hideDropDown() {
    dropDownTimer = setTimeout(function () {
      if (!loading) {
        updateShowUserDropDown(false);
      }
    }, 200);
  };

  var firstName = ($userDetails == null ? void 0 : $userDetails.firstName) || DEFAULT_PROFILE_NAME;
  return /*#__PURE__*/react.createElement(LoginTab, {
    onFocus: showDropDown,
    onMouseOver: showDropDown,
    onMouseLeave: hideDropDown,
    "data-id": "user-info-tab"
  }, /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LoginTabWrapper, {
    role: "presentation",
    onClick: function onClick() {
      return handleOnLoginWidgetClick({
        name: 'login',
        componentName: 'header'
      });
    }
  }, !hasMounted || loading ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(CircularShimmer, null), /*#__PURE__*/react.createElement(HorizontalShimmer, null)) : /*#__PURE__*/react.createElement(react.Fragment, null, $userDetails.isLoggedIn ? /*#__PURE__*/react.createElement(LoggedInDetails, {
    loading: loading,
    profileImage: $userDetails == null ? void 0 : $userDetails.profileImage,
    firstName: firstName,
    loyaltyMemberType: loyaltyMemberType
  }) : /*#__PURE__*/react.createElement(GuestDetails, {
    loginCtaRef: loginCtaRef
  }), /*#__PURE__*/react.createElement(ArrowIcon, {
    className: "" + (showUserDropDown ? 'up' : 'down')
  }))), showUserDropDown && /*#__PURE__*/react.createElement(UserDropDown, {
    lobName: lobName,
    handleLogout: handleLogout,
    userInfo: $userDetails,
    isLoggedIn: $userDetails.isLoggedIn,
    hideDropDown: function hideDropDown() {
      return updateShowUserDropDown(false);
    },
    memberType: loyaltyMemberType,
    upcomingTripCount: upComingTripCounts,
    onLoginCtaClick: handleOnLoginWidgetClick,
    navOrigin: navOrigin,
    positionStyle: {
      top: '53px',
      left: '-66px'
    }
  })));
};

var _templateObject$2, growth_dweb_header_esm_templateObject2, growth_dweb_header_esm_templateObject3, growth_dweb_header_esm_templateObject4, growth_dweb_header_esm_templateObject5, _templateObject6, _templateObject7;
var bounce = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject$2 || (_templateObject$2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-30px);\n  }\n  60% {\n    transform: translateY(-15px);\n  }\n"])));
var HappyLsPop = styled_components_browser_esm/* default.div */.ZP.div(growth_dweb_header_esm_templateObject2 || (growth_dweb_header_esm_templateObject2 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 250px;\n\tposition: absolute;\n\ttop: 65px;\n\tright: 60px;\n\tpadding: 15px 10px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n\tbackground-color: #fff;\n\tz-index: 11;\n\tanimation: ", " 2s 2;\n\n\t&::after {\n\t\tbottom: 100%;\n\t\tleft: 90%;\n\t\tborder: solid transparent;\n\t\tcontent: '';\n\t\theight: 0;\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t\tborder-color: rgba(255, 255, 255, 0);\n\t\tborder-bottom-color: #fff;\n\t\tborder-width: 8px;\n\t\tmargin-left: -8px;\n\t}\n"])), bounce);
var LsPopOffer = styled_components_browser_esm/* default.div */.ZP.div(growth_dweb_header_esm_templateObject3 || (growth_dweb_header_esm_templateObject3 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tpadding: 11px 10px;\n\tborder-radius: 8px;\n\tbackground-color: rgba(80, 227, 194, 0.1);\n\tdisplay: flex;\n\talign-items: center;\n\tmargin: 7px 0 0;\n"])));
var LsPopOfferIcon = styled_components_browser_esm/* default.div */.ZP.div(growth_dweb_header_esm_templateObject4 || (growth_dweb_header_esm_templateObject4 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 28px;\n\tflex-shrink: 0;\n\tmargin-right: 16px;\n\n\timg {\n\t\tmax-width: 100%;\n\t}\n"])));
var LsPopOfferTitle = styled_components_browser_esm/* default.div */.ZP.div(growth_dweb_header_esm_templateObject5 || (growth_dweb_header_esm_templateObject5 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tcolor: #268570;\n\tfont-size: 14px;\n\n\t> span:nth-child(1) {\n\t\tvertical-align: middle;\n\t}\n"])));
var LsPopOfferSubtitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6 || (_templateObject6 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tmargin-top: 3px;\n"])));
var SignUpButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject7 || (_templateObject7 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 36px;\n\tborder-radius: 8px;\n\tbackground-color: #2276e3;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n\toutline: 0;\n\tborder: 0;\n\tcursor: pointer;\n\t", ";\n\n\t&:hover {\n\t\tcolor: #fff;\n\t}\n"])), growth_design_system_esm/* textSizes.BaseW3 */.iH.BaseW3);

var LoginSignupPopup = function LoginSignupPopup(_ref) {
  var _persuationsText$sign;

  var onLogin = _ref.onLogin,
      closePopOver = _ref.closePopOver,
      persuationsText = _ref.persuationsText;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  function closePopup(event) {
    if (!event.target.closest('.happy-lsPop')) {
      if (closePopOver) closePopOver();
    }
  }

  (0,react.useEffect)(function () {
    /**
     * this listeners check if popover is shown then if click is outside the popover
     * it closes the popover
     */
    document.addEventListener('click', closePopup);
    pdt.track('growth_non_int_HEADER_POPOVER_LOGIN_VISIBLES');
    return function () {
      document.removeEventListener('click', closePopup);
    };
  }, []);

  var handleCtaClick = function handleCtaClick() {
    pdt.track('growth_int_HEADER_POPOVER_CTA_CLICK');
    adobe.track('ctaClick', {
      cta: {
        name: "Login Popover",
        type: 'itemClick',
        componentName: 'Login Popover',
        destination: 'Login Popup'
      }
    });
    onLogin();
  };

  return /*#__PURE__*/react.createElement(HappyLsPop, {
    "data-id": "header-popover"
  }, /*#__PURE__*/react.createElement(SignUpButton, {
    onClick: handleCtaClick,
    type: "button"
  }, /*#__PURE__*/react.createElement(growth_design_system_esm/* Text */.xv, {
    size: "BaseW2"
  }, persuationsText == null ? void 0 : (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText)), /*#__PURE__*/react.createElement(LsPopOffer, null, /*#__PURE__*/react.createElement(LsPopOfferIcon, null, /*#__PURE__*/react.createElement("img", {
    src: "https://gos3.ibcdn.com/login-gift-1607962961.png",
    alt: "Offer"
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(LsPopOfferTitle, null, /*#__PURE__*/react.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: persuationsText == null ? void 0 : persuationsText.title
    }
  })), /*#__PURE__*/react.createElement(LsPopOfferSubtitle, null, persuationsText == null ? void 0 : persuationsText.subTitle))));
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {// You can also log the error to an error reporting service
    // console.log('Error', error, errorInfo)
  };

  _proto.render = function render() {
    var hasError = this.state.hasError;
    var children = this.props.children;

    if (hasError) {
      // You can render any custom fallback UI
      return null;
    }

    return children;
  };

  return ErrorBoundary;
}(react.Component);

/** Create a new configStore instance for desktop header */

var useConfigStore = (0,growth_config_store_browser_esm/* createConfigStore */.Ao)();

var hasTimeExpired = function hasTimeExpired(expDate) {
  var xDate = new Date(expDate);

  if (!Number.isNaN(xDate.getDate())) {
    var cDate = new Date();
    if (cDate > xDate) return true;
    return false;
  }

  return false;
};

var useFestivalTheme = function useFestivalTheme(_ref) {
  var headerLogoRef = _ref.headerLogoRef;

  var _useConfigStore = useConfigStore(function (s) {
    return s;
  }),
      configStoreData = _useConfigStore.data,
      configStoreDataLoaded = _useConfigStore.loaded;

  (0,react.useEffect)(function () {
    var _configStoreData$COMM, _configData$data;

    var configData = configStoreData == null ? void 0 : (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm.CONFIG_KEY_DWEB_AUTH];

    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.festivalTheme) {
      var _themes$date;

      var themes = configData.data.festivalTheme; // we keep expire date for special theme.
      // check if theme is still valid for today
      // date format: MM/DD/YYYY

      var expireTime = themes == null ? void 0 : (_themes$date = themes.date) == null ? void 0 : _themes$date.expire;
      if (expireTime && hasTimeExpired(expireTime)) return; // apply special theme to dom direclty, to avoid rerender
      // goibibo image

      if (themes != null && themes.gi_logo && headerLogoRef.current) {
        var giLogoElm = headerLogoRef.current;
        giLogoElm.style.backgroundImage = "url(" + themes.gi_logo + ")";
        giLogoElm.classList.remove('header-sprite', 'logo', 'gi-logo');
        giLogoElm.classList.add('special-logo');
      }
    }
  }, [configStoreData, configStoreDataLoaded, headerLogoRef]);
};

var LOGIN_POPOVER_TIMEOUT = 10000; // 10sec

var useLoginPopover = function useLoginPopover(_ref) {
  var _configStoreData$COMM;

  var loginPersuation = _ref.loginPersuation,
      loginPersuationTimeout = _ref.loginPersuationTimeout,
      sticky = _ref.sticky,
      lobName = _ref.lobName;

  var _useConfigStore = useConfigStore(function (s) {
    return s;
  }),
      configStoreData = _useConfigStore.data,
      configStoreDataLoaded = _useConfigStore.loaded;

  var configData = configStoreData == null ? void 0 : (_configStoreData$COMM = configStoreData.COMMON) == null ? void 0 : _configStoreData$COMM[growth_gi_dweb_auth_esm.CONFIG_KEY_DWEB_AUTH];

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShowLoginPopover = _useState[1];

  var popoverTimerTimeout = (0,react.useRef)(0);

  var closeLogInPopover = function closeLogInPopover() {
    setShowLoginPopover(false);
  };

  var setLoginPopoverTimer = function setLoginPopoverTimer(time) {
    if (popoverTimerTimeout.current) {
      // Exception?
      return;
    } // Remember the timer handle


    popoverTimerTimeout.current = setTimeout(function () {
      closeLogInPopover();
    }, time);
  };

  var showLoginPopOver = function showLoginPopOver(persuationsText) {
    setShowLoginPopover(persuationsText);
    var timeout = loginPersuationTimeout || LOGIN_POPOVER_TIMEOUT;
    setLoginPopoverTimer(timeout);
  };

  var clearLoginPopoverTimer = function clearLoginPopoverTimer() {
    // Is our timer running?
    if (popoverTimerTimeout.current) {
      // Yes, clear it
      clearTimeout(popoverTimerTimeout.current);
    }
  };

  var setLoginPopoverVisiblity = (0,react.useCallback)(function () {
    var _configData$data, _configData$data2;

    if (configData && configStoreDataLoaded && configData != null && (_configData$data = configData.data) != null && _configData$data.loginPopover && configData != null && (_configData$data2 = configData.data) != null && _configData$data2.bookingOffers) {
      var _configData$data3 = configData.data,
          _configData$data3$boo = _configData$data3.bookingOffers,
          bookingOffers = _configData$data3$boo === void 0 ? {} : _configData$data3$boo,
          _configData$data3$log = _configData$data3.loginPopover,
          loginPopover = _configData$data3$log === void 0 ? {} : _configData$data3$log; // lob wise offers text comes from api, select only offer that need to
      // display on current lob

      var persuationsText = growth_dweb_header_esm_extends({}, bookingOffers == null ? void 0 : bookingOffers[lobName], loginPopover);

      if (loginPersuation) {
        var _persuationsText$sign;

        var mandatoryTextToDisplayUI = (persuationsText == null ? void 0 : persuationsText.title) && (persuationsText == null ? void 0 : persuationsText.subTitle) && (persuationsText == null ? void 0 : (_persuationsText$sign = persuationsText.signUp) == null ? void 0 : _persuationsText$sign.ctaText);

        if (!(0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)() && mandatoryTextToDisplayUI) {
          showLoginPopOver(persuationsText);
        } else {
          closeLogInPopover();
        }
      }
    }
  }, [configStoreDataLoaded, lobName, loginPersuation, sticky]);
  (0,react.useEffect)(function () {
    /**
     * on load don't show login popover in "non sticky" header. It does not fit when user scrolls
     * the page when popover is visible in header
     *
     * NOTE: we allow to show popover for no sticky header also via 'SHOW_LOGIN_POP_OVER' dom event
     */
    if (sticky) {
      setLoginPopoverVisiblity();
    }

    return function () {
      clearLoginPopoverTimer();
    };
  }, [setLoginPopoverVisiblity]);
  (0,react.useEffect)(function () {
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER, setLoginPopoverVisiblity);
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER, closeLogInPopover);
    };
  }, [setLoginPopoverVisiblity]);
  return {
    closeLogInPopover: closeLogInPopover,
    show: show
  };
};

var Header$1 = function Header(props) {
  var handleOnLoginModalOpen = props.handleOnLoginModalOpen,
      onLogoutSuccess = props.onLogoutSuccess,
      sticky = props.sticky,
      lobName = props.lobName,
      reloadAfterLogout = props.reloadAfterLogout,
      _props$loginPersuatio = props.loginPersuation,
      loginPersuation = _props$loginPersuatio === void 0 ? true : _props$loginPersuatio,
      loginPersuationTimeout = props.loginPersuationTimeout,
      headerStyle = props.headerStyle,
      _props$navOrigin = props.navOrigin,
      navOrigin = _props$navOrigin === void 0 ? '' : _props$navOrigin;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt;

  var isLoggedIn = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.data.isLoggedIn;
  });
  var bookingSummaryState = useBookingSummaryStore(function (s) {
    return s;
  });
  var upComingTripCounts = selectUpcomingBookingsCount(bookingSummaryState);
  var headerLogoRef = (0,react.useRef)(null);
  var headerLeftThemeRef = (0,react.useRef)(null);
  /**
   * For any special occasions we change gi logo and few theme images.
   * we get this images from api, right now and apply in client side.
   */

  useFestivalTheme({
    headerLogoRef: headerLogoRef
  });

  var _useLoginPopover = useLoginPopover({
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    sticky: sticky,
    lobName: lobName
  }),
      loginPopover = _useLoginPopover.show,
      closeLogInPopover = _useLoginPopover.closeLogInPopover;

  function popoverLoginHandler() {
    pdt.track('HAPPY_HEADER_WEBA__CLICK_POPOVER_LOGIN_BTN');
    handleOnLoginModalOpen();
  }

  var giLogoClickTargetUrl = navOrigin + lobsPathName.HOME;
  return /*#__PURE__*/react.createElement(HappyGiHeader, {
    ref: headerLeftThemeRef,
    "data-id": "dweb-header-root",
    className: sticky ? 'header-sticky' : 'header-sticky-nope',
    style: headerStyle
  }, /*#__PURE__*/react.createElement(HeaderLogo, {
    homeURL: giLogoClickTargetUrl,
    ref: headerLogoRef,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(NavBar, {
    navList: lobsNavList(navOrigin),
    lobName: lobName
  }), ' ', /*#__PURE__*/react.createElement(LoginWidgetWrapper, null, /*#__PURE__*/react.createElement(NavWidgets, {
    isLoggedIn: isLoggedIn || false,
    upcomingTrip: upComingTripCounts,
    navOrigin: navOrigin,
    lobName: lobName
  }), /*#__PURE__*/react.createElement(ErrorBoundary, null, /*#__PURE__*/react.createElement(UserLoginWidget, {
    lobName: lobName,
    onLogoutSuccess: onLogoutSuccess,
    showLogin: handleOnLoginModalOpen,
    reloadAfterLogout: reloadAfterLogout,
    isLoginPopoverVisible: loginPopover,
    navOrigin: navOrigin,
    upComingTripCounts: upComingTripCounts
  }))), loginPopover && /*#__PURE__*/react.createElement(LoginSignupPopup, {
    closePopOver: function closePopOver() {
      return closeLogInPopover();
    },
    onLogin: function onLogin() {
      return popoverLoginHandler();
    },
    persuationsText: loginPopover
  }));
};

var AuthFlowModal = function AuthFlowModal(props) {
  var onLoginClose = props.onLoginClose,
      onLoginSuccess = props.onLoginSuccess,
      lobName = props.lobName,
      modalStyle = props.modalStyle,
      shouldShowCloseButton = props.shouldShowCloseButton;

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt,
      adobe = _useAnalytics.adobe;

  var handleModalClose = function handleModalClose() {
    onLoginClose();
  };

  (0,react.useEffect)(function () {
    pdt.track('HAPPY_AUTH_WEBA__UX_LOGIN_DIALOG_OPEN', {
      ab_experiment: 'happy-auth'
    });
    adobe.track('Login_Popup_Load');
  }, []);
  return /*#__PURE__*/react.createElement(Modal, {
    rootStyle: growth_dweb_header_esm_extends({
      background: 'transparent'
    }, modalStyle)
    /** dweb-auth have a close button, hide the close button of modal */
    ,
    closeBtnStyle: {
      display: 'none'
    },
    onClose: handleModalClose
  }, /*#__PURE__*/react.createElement(growth_gi_dweb_auth_esm["default"], {
    onClose: handleModalClose,
    lobName: lobName,
    onLoginSuccess: onLoginSuccess,
    showCloseButton: shouldShowCloseButton
  }));
};

var _templateObject$1;
var HeaderContainer$1 = styled_components_browser_esm/* default.div */.ZP.div(_templateObject$1 || (_templateObject$1 = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\theight: 64px;\n\twidth: 100%;\n"])));

var HeaderContainer = function HeaderContainer(props) {
  var onLoginSuccess = props.onLoginSuccess,
      lobName = props.lobName,
      onLogoutSuccess = props.onLogoutSuccess,
      sticky = props.sticky,
      reloadAfterLogout = props.reloadAfterLogout,
      loginPersuation = props.loginPersuation,
      loginPersuationTimeout = props.loginPersuationTimeout,
      hideHeader = props.hideHeader,
      headerStyle = props.headerStyle,
      modalStyle = props.modalStyle,
      shouldShowCloseButton = props.shouldShowCloseButton,
      navOrigin = props.navOrigin;

  var _useState = (0,react.useState)(false),
      loginModal = _useState[0],
      toggleLoginModal = _useState[1];

  var fetchProfileDetails = (0,growth_auth_helpers_esm/* useProfileStore */.Oz)(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchBookingSummary = useBookingSummaryStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchLoyaltyInfo = useLoyaltyUserInfoStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);
  var fetchGocash = useGoCashBalanceStore(function (s) {
    return s.fetch;
  }, shallow/* shallow */.X);

  var _useAnalytics = (0,growth_use_analytics_esm/* useAnalytics */.z$)(),
      pdt = _useAnalytics.pdt;

  var onProfileDetailsError = function onProfileDetailsError(err) {
    if ((err == null ? void 0 : err.status) === 404) {
      (0,growth_auth_helpers_esm/* clearUserTokens */.H)();
      growth_dom_event_emitter_esm/* default.emit */.Z.emit(dom_events_c707d33c_esm_DOM_EVENT_NAME.LOGOUT);
    }
  };

  var fetchAllHeaderData = (0,react.useCallback)(function () {
    var token = (0,growth_auth_helpers_esm/* isUserTokenPresent */.Tq)();

    if (token) {
      var userDetail = fetchProfileDetails({
        platform: 'dweb',
        onError: onProfileDetailsError
      });
      Promise.all([fetchLoyaltyInfo(), fetchBookingSummary(), fetchGocash()]);
      return userDetail;
    }

    return Promise.resolve({});
  }, []); // close the login modal

  var handleOnLoginModalClose = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return false;
    });
  }, []); // open the login modal

  var handleOnLoginModalOpen = (0,react.useCallback)(function () {
    toggleLoginModal(function () {
      return true;
    });
  }, []);
  var handleOnLoginSuccess = (0,react.useCallback)(function () {
    if (onLoginSuccess) onLoginSuccess();
    fetchAllHeaderData();
  }, [onLoginSuccess, fetchAllHeaderData]);
  (0,react.useEffect)(function () {
    /** allow refresh the header data from outside
     * usecases:
     * - when new profile image or details are updated in profile page by user we would want to see the
     *   updated info in header as well
     * - when logout happens from somewhere outside the header, we would refresh the data again
     */
    // put all global Header/Auth event listners here.
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
      fetchAllHeaderData();
    });
    growth_dom_event_emitter_esm/* default.on */.Z.on(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    return function () {
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.REFRESH_HEADER_DATA, function () {
        fetchAllHeaderData();
      });
      growth_dom_event_emitter_esm/* default.off */.Z.off(dom_events_c707d33c_esm_DOM_EVENT_NAME.START_LOGIN_FLOW, handleOnLoginModalOpen);
    };
  }, []);
  (0,react.useEffect)(function () {
    // hydrate store with require data and trigger load events
    function loadInitialData() {
      return _loadInitialData.apply(this, arguments);
    }

    function _loadInitialData() {
      _loadInitialData = growth_dweb_header_esm_asyncToGenerator( /*#__PURE__*/growth_dweb_header_esm_regeneratorRuntime().mark(function _callee() {
        var _window;

        return growth_dweb_header_esm_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  fetchAllHeaderData();
                  pdt.setUserVars({
                    user: {
                      uuid: (_window = window) == null ? void 0 : _window.atob((0,growth_auth_helpers_esm/* getEncryptedUuid */.zv)() || '')
                    },
                    lob: lobName
                  });
                  pdt.track('HEADER_LOADED', {
                    item_position: sticky ? 'sticky' : 'scroll'
                  });
                } catch (e) {
                  pdt.setUserVars({
                    user: {
                      uuid: 'error'
                    },
                    lob: lobName
                  });
                  pdt.track('HEADER_LOADED', {
                    item_position: sticky ? 'sticky' : 'scroll'
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadInitialData.apply(this, arguments);
    }

    loadInitialData();
  }, []);
  return /*#__PURE__*/react.createElement(react.Fragment, null, !hideHeader && /*#__PURE__*/react.createElement(HeaderContainer$1, null, /*#__PURE__*/react.createElement(Header$1, {
    handleOnLoginModalOpen: handleOnLoginModalOpen,
    lobName: lobName,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLogoutSuccess: onLogoutSuccess,
    sticky: sticky,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    navOrigin: navOrigin
  })), loginModal && /*#__PURE__*/react.createElement(AuthFlowModal, {
    shouldShowCloseButton: shouldShowCloseButton,
    lobName: lobName,
    onLoginSuccess: handleOnLoginSuccess,
    onLoginClose: handleOnLoginModalClose,
    modalStyle: modalStyle
  }));
};

var growth_dweb_header_esm_templateObject;
var Style = styled_components_browser_esm/* default.div */.ZP.div(growth_dweb_header_esm_templateObject || (growth_dweb_header_esm_templateObject = growth_dweb_header_esm_taggedTemplateLiteralLoose(["\n\t.header-sprite,\n\t.dropdown-sprite {\n\t\tbackground: url(https://gos3.ibcdn.com/giHeaderSprite-1697090884.png) 0 0 no-repeat;\n\t\tbackground-size: 125px 200px;\n\t\tdisplay: block;\n\t\tflex-shrink: 0;\n\t}\n\n\t.header-sprite.logo {\n\t\twidth: 104px;\n\t\theight: 30px;\n\t\tbackground-position: -2px -1px;\n\t}\n\n\t.header-sprite.nav-icon-flights {\n\t\twidth: 32px;\n\t\theight: 20px;\n\t\tbackground-position: -69px -33px;\n\t}\n\n\t.header-sprite.nav-icon-hotels {\n\t\twidth: 24px;\n\t\theight: 22px;\n\t\tbackground-position: -4px -178px;\n\t}\n\n\t.header-sprite.nav-icon-bus {\n\t\twidth: 32px;\n\t\theight: 14px;\n\t\tbackground-position: -3px -89px;\n\t}\n\n\t.header-sprite.nav-icon-trains {\n\t\twidth: 36px;\n\t\theight: 16px;\n\t\tbackground-position: -3px -52px;\n\t}\n\n\t.header-sprite.nav-icon-cabs {\n\t\twidth: 34px;\n\t\theight: 16px;\n\t\tbackground-position: -1px -69px;\n\t}\n\n\t.header-sprite.nav-icon-holiday {\n\t\twidth: 26px;\n\t\theight: 21px;\n\t\tbackground-position: -3px -105px;\n\t}\n\n\t.header-sprite.nav-icon-forex {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -131px;\n\t}\n\n\t.header-sprite.nav-icon-insurance {\n\t\twidth: 20px;\n\t\theight: 22px;\n\t\tbackground-position: -5px -153px;\n\t}\n\n\t.header-sprite.user-icon {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tbackground-position: -41px -56px;\n\t}\n\n\t.header-sprite.mytrip-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tbackground-position: -43px -33px;\n\t}\n\t/* -- DropDown Icons sprites -- */\n\t.dropdown-sprite.gotribeLogo {\n\t\twidth: 50px;\n\t\theight: 14px;\n\t\tbackground-position: -38px -86px;\n\t}\n\t.dropdown-sprite.gotribe {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -2px -33px;\n\t}\n\t.dropdown-sprite.offers {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -19px;\n\t}\n\t.dropdown-sprite.mytrip {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -107px -1px;\n\t}\n\t.dropdown-sprite.gocash {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -22px -33px;\n\t}\n\t/* -- CSS Icons -- */\n\t.arrow-icon {\n\t\tborder: solid #2274e0;\n\t\tborder-width: 0 2px 2px 0;\n\t\tdisplay: inline-block;\n\t\tpadding: 2px;\n\t\tmargin-left: auto;\n\t}\n\n\t.arrow-icon.right {\n\t\ttransform: rotate(-45deg);\n\t\t-webkit-transform: rotate(-45deg);\n\t}\n\n\t.arrow-icon.left {\n\t\ttransform: rotate(135deg);\n\t\t-webkit-transform: rotate(135deg);\n\t}\n\n\t.arrow-icon.up {\n\t\ttransform: rotate(-135deg);\n\t\t-webkit-transform: rotate(-135deg);\n\t}\n\n\t.arrow-icon.down {\n\t\ttransform: rotate(45deg);\n\t\t-webkit-transform: rotate(45deg);\n\t}\n"])));

var RootHoc = function RootHoc(Component) {
  var WithHOC = function WithHOC(props) {
    var headerEnv = props.headerEnv,
        lobName = props.lobName,
        adobeLobName = props.adobeLobName,
        configData = props.configData;
    /** Memorize b/c we don't want to call the setData again if there in no change in configData */

    (0,react.useMemo)(function () {
      if (configData) (0,growth_config_store_browser_esm/* setData */.a_)(useConfigStore, configData);
    }, [configData]);
    var fetchConfigStoreData = useConfigStore(function (s) {
      return s.fetch;
    }, shallow/* shallow */.X);
    (0,react.useEffect)(function () {
      fetchConfigStoreData({
        keys: 'growth-dweb-header-config',
        lobs: 'COMMON',
        cacheOpts: {
          ttl: 15 // min

        },
        initData: configData
      });
    }, []); // Analytics plugin initialization

    var pdtInstance = {};
    var adobeInstance = {};

    if (growth_ssr_utils_esm/* isOnClient */.BK) {
      var _window$adobeDataLaye, _window$adobeDataLaye2;

      pdtInstance = new growth_web_analytics_esm/* default */.Z();
      adobeInstance = new growth_web_analytics_esm/* default */.Z();
      pdtInstance.initialize({
        plugin: (0,growth_analytics_plugin_pdt_esm/* default */.Z)({
          debug: false
        }),
        globalProperties: {
          context: {
            environment: headerEnv || 'error'
          },
          eventProperties: {
            lob: lobName
          }
        },
        debug: false
      });
      var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
      var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null ? void 0 : _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
      adobeInstance.initialize({
        plugin: AnalyticsPluginAdobe({
          page: {
            pageInfo: growth_dweb_header_esm_extends({}, pageInfo, {
              lob: adobeLobName || lobName
            })
          },
          account: {
            accountInfo: growth_dweb_header_esm_extends({}, accountInfo, {
              website: 'goibibo'
            })
          }
        }, false),
        debug: false
      });
    }

    return /*#__PURE__*/react.createElement(Style, null, /*#__PURE__*/react.createElement(growth_use_analytics_esm/* AnalyticsContextProvider */.nx, {
      pdtInstance: pdtInstance,
      adobeInstance: adobeInstance
    }, /*#__PURE__*/react.createElement(Component, props)));
  };

  return WithHOC;
};

var HeaderComponent = function HeaderComponent(_ref) {
  var onLoginSuccess = _ref.onLoginSuccess,
      sticky = _ref.sticky,
      onLogoutSuccess = _ref.onLogoutSuccess,
      lobName = _ref.lobName,
      reloadAfterLogout = _ref.reloadAfterLogout,
      headerEnv = _ref.headerEnv,
      loginPersuation = _ref.loginPersuation,
      loginPersuationTimeout = _ref.loginPersuationTimeout,
      hideHeader = _ref.hideHeader,
      headerStyle = _ref.headerStyle,
      modalStyle = _ref.modalStyle,
      shouldShowCloseButton = _ref.shouldShowCloseButton,
      adobeLobName = _ref.adobeLobName,
      navOrigin = _ref.navOrigin,
      configData = _ref.configData;
  return /*#__PURE__*/react.createElement(HeaderContainer, {
    headerEnv: headerEnv,
    adobeLobName: adobeLobName,
    sticky: sticky,
    lobName: lobName,
    hideHeader: hideHeader,
    loginPersuation: loginPersuation,
    loginPersuationTimeout: loginPersuationTimeout,
    onLoginSuccess: onLoginSuccess,
    onLogoutSuccess: onLogoutSuccess,
    reloadAfterLogout: reloadAfterLogout,
    headerStyle: headerStyle,
    modalStyle: modalStyle,
    shouldShowCloseButton: shouldShowCloseButton,
    configData: configData,
    navOrigin: navOrigin
  });
};

var Header = RootHoc(HeaderComponent);

var showLoginPopOverEvent = function showLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.SHOW_LOGIN_POP_OVER);
};

var hideLoginPopOverEvent = function hideLoginPopOverEvent() {
  return eventEmitter.emit(DOM_EVENT_NAME.HIDE_LOGIN_POP_OVER);
};



;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GIInsuranceHeader/index.tsx


function GIInsuranceHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GIInsuranceHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GIInsuranceHeader_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GIInsuranceHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var GiDwebAuth = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7644)).then(function (p) {
    return p.default;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7644)];
    }
  }
});
var GiMwebAuth = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 154).then(__webpack_require__.bind(__webpack_require__, 7154)).then(function (p) {
    return p.MwebAuth;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7154)];
    }
  }
});
function GIInsuranceHeader(_ref) {
  var _ref$headerProps = _ref.headerProps,
      headerProps = _ref$headerProps === void 0 ? {} : _ref$headerProps,
      _ref$mobileTitle = _ref.mobileTitle,
      mobileTitle = _ref$mobileTitle === void 0 ? "" : _ref$mobileTitle,
      _ref$forceLogin = _ref.forceLogin,
      forceLogin = _ref$forceLogin === void 0 ? false : _ref$forceLogin,
      myOrders = _ref.myOrders,
      goToMyOrders = _ref.goToMyOrders,
      displayWhiteHeader = _ref.displayWhiteHeader;
  var device = (0,src/* useBreakpointV2 */.bU)();

  var headerPropsWithDefaults = GIInsuranceHeader_objectSpread({
    lobName: "insurance",
    sticky: true,
    shouldShowCloseButton: true,
    navOrigin: "https://www.goibibo.com"
  }, headerProps);

  var authComponent = null;

  var _useState = (0,react.useState)(forceLogin),
      isAuthComponentVisible = _useState[0],
      setIsAuthComponentVisible = _useState[1];

  if (isAuthComponentVisible) {
    authComponent = device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(GiDwebAuth, {
      prefillMobileNumber: undefined,
      showCloseButton: false,
      onClose: function onClose() {
        return console.log("Closed");
      },
      lobName: "insurance",
      onLoginSuccess: function onLoginSuccess() {
        return router_default().reload();
      },
      configData: undefined,
      "data-test-id": "GiDwebAuth"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(GiMwebAuth, {
      prefillMobileNumber: undefined,
      showCloseButton: false,
      onClose: function onClose() {
        return console.log("Closed");
      },
      lobName: "",
      onLoginSuccess: function onLoginSuccess() {
        setIsAuthComponentVisible(false);
        setTimeout(function () {
          router_default().reload();
        }, 100);
      },
      showAuth: true,
      "data-test-id": "GiMwebAuth"
    });
    authComponent = /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.7)"
      },
      children: authComponent
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [authComponent, device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(Header, GIInsuranceHeader_objectSpread(GIInsuranceHeader_objectSpread({}, headerPropsWithDefaults), {}, {
      "data-test-id": "Header"
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingHeaderMobile */.cQ, {
      headerTitle: mobileTitle,
      myOrders: myOrders,
      goToMyOrders: goToMyOrders,
      displayWhiteHeader: displayWhiteHeader,
      partnerType: isomorphic_utils_src.PARTNER.GI,
      insuranceHeader: true,
      "data-test-id": "LandingHeaderMobile"
    })]
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withGIInsuranceHeader.tsx

var withGIInsuranceHeader_excluded = ["Wrapper", "forceLogin"];




function withGIInsuranceHeader(component) {
  var headerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mobileTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var myOrders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var goToMyOrders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    return void 0;
  };
  var displayWhiteHeader = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var Wrapper = headerOptions.Wrapper,
      _headerOptions$forceL = headerOptions.forceLogin,
      forceLogin = _headerOptions$forceL === void 0 ? false : _headerOptions$forceL,
      headerProps = (0,objectWithoutProperties/* default */.Z)(headerOptions, withGIInsuranceHeader_excluded);

  var giHeaderWithAuth = /*#__PURE__*/(0,jsx_runtime.jsx)(GIInsuranceHeader, {
    headerProps: headerProps,
    mobileTitle: mobileTitle,
    forceLogin: forceLogin,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    "data-test-id": "giHeaderWithAuth-GIInsuranceHeader"
  });

  if (forceLogin) {
    return giHeaderWithAuth;
  }

  if (Wrapper) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      "data-test-id": "Wrapper",
      children: [giHeaderWithAuth, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [giHeaderWithAuth, component]
  });
}
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 6 modules
var utils = __webpack_require__(1725);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/withPartnerInsuranceHeader.tsx








function withPartnerInsuranceHeader(component) {
  var headerComponent = null;

  var _useState = (0,react.useState)(""),
      partnerHeader = _useState[0],
      setPartnerHeader = _useState[1];

  (0,react.useEffect)(function () {
    var partner = (0,utils/* getPartnerOnClientSide */.et)();
    setPartnerHeader(partner);
  }, []);

  if (partnerHeader === isomorphic_utils_src.PARTNER.MMT) {
    headerComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(MMTInsuranceHeader, {
      "data-test-id": "MMTInsuranceHeader"
    });
  } else if (partnerHeader === isomorphic_utils_src.PARTNER.GI) {
    headerComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(GIInsuranceHeader, {
      "data-test-id": "GIInsuranceHeader"
    });
  }

  if (headerComponent) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [headerComponent, component]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: component
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hoc/index.ts





/***/ }),

/***/ 984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ InnerContentWrap; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4576);


var InnerContentWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonStylesstyle__InnerContentWrap",
  componentId: "tfai8k-0"
})(["width:1200px;margin:0 auto;@media screen and ", "{width:100%;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);

/***/ }),

/***/ 8988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ BulletListItemStyle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2874);


var BulletListItemStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "BulletListItemstyle__BulletListItemStyle",
  componentId: "unxr0c-0"
})(["margin-bottom:20px;padding-left:20px;position:relative;font-size:18px;line-height:22px;color:", ";&:last-child{margin-bottom:0px;}&:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, function (props) {
  return props.bulletColor;
});

/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ CommonModalDwebStyle; },
/* harmony export */   "G7": function() { return /* binding */ CrossIconWrap; },
/* harmony export */   "fm": function() { return /* binding */ CommonModalHeader; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5505);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4576);
/* harmony import */ var _SectionDividers_SectionDividers_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2287);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3139);
/* harmony import */ var _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(599);





var modalAnim = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .keyframes */ .F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var CommonModalDwebStyle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1s62ue-0"
})(["position:fixed;width:", ";height:fit-content;max-height:531px;min-height:260px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, _SectionDividers_SectionDividers_style__WEBPACK_IMPORTED_MODULE_1__/* .SectionDividersStyle */ .$, _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .TMInputWrap */ .dd, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, modalAnim, _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .TMInputWrap */ .dd);
var CommonModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalHeader",
  componentId: "sc-1s62ue-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:flex-start;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .H5TagStyle */ .Wl, function (p) {
  return p.nonClipHeading && "\n     ".concat(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .H5TagStyle */ .Wl, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
var CrossIconWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CrossIconWrap",
  componentId: "sc-1s62ue-2"
})(["flex-shrink:0;cursor:pointer;"]);

/***/ }),

/***/ 7871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPlainText */
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7109);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* Every text node can be of either of the three formats - 
1. string - "Hello"
2. text obj with value and styles - 
   text: {
    value: "Travel Assistance",
    styles: {
      color: "#000000",
      fontFamily: "fontSansBold",
    },
  }
3. Array of text objs with value and styles - 
   text: [
    {
      value: "Travel Assistance",
      styles: {
        color: "#000000",
        fontFamily: "fontSansBold",
      },
    },
  ]
*/




var ListItemText = function ListItemText(_ref) {
  var text = _ref.text,
      style = _ref.style;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("p", {
    style: {
      flexDirection: "row"
    },
    "data-test-id": "ListItemText",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      style: style,
      children: "\u2022 "
    }), text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      style: style,
      children: text
    })]
  });
};

var getPlainText = function getPlainText(data) {
  if (!data) {
    return "";
  } else if (typeof data === "string") {
    return data;
  } else if (data !== null && data !== void 0 && data.text) {
    var text = data.text;

    if (Array.isArray(text)) {
      return text.map(function (node) {
        return node.value;
      }).join("");
    } else if (typeof text === "object") {
      return (text === null || text === void 0 ? void 0 : text.value) || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

var FormattedText = function FormattedText(_ref2) {
  var value = _ref2.value,
      baseStyle = _ref2.baseStyle;
  var device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpointV2 */ .bU)();
  var isList = false;

  if (!value) {
    return null;
  }

  var returnValue = null;

  if (typeof value === "string") {
    returnValue = value;
  } else if (value !== null && value !== void 0 && value.text) {
    var _ref3 = value,
        text = _ref3.text,
        displayType = _ref3.displayType;

    if (displayType === "UNORDERED_LIST") {
      isList = true;
    }

    if (Array.isArray(text)) {
      returnValue = text.map(function (node, index) {
        var _node$styles;

        var mobileStyle = (_node$styles = node.styles) === null || _node$styles === void 0 ? void 0 : _node$styles.mobile;

        var combinedStyles = _objectSpread(_objectSpread({}, node === null || node === void 0 ? void 0 : node.styles), device === "sm" && _objectSpread({}, mobileStyle));

        var textValue = node === null || node === void 0 ? void 0 : node.value;
        return node.value ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: isList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ListItemText, {
            text: textValue ? textValue : "",
            style: node === null || node === void 0 ? void 0 : node.styles,
            "data-test-id": "FormattedText-ListItemText"
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            style: combinedStyles,
            children: node.value
          }, index)
        }, index) : null;
      });
    } else if (typeof text === "object") {
      var _text$styles;

      var mobileStyle = text === null || text === void 0 ? void 0 : (_text$styles = text.styles) === null || _text$styles === void 0 ? void 0 : _text$styles.mobile;

      var combinedStyles = _objectSpread(_objectSpread({}, text === null || text === void 0 ? void 0 : text.styles), device === "sm" && _objectSpread({}, mobileStyle));

      returnValue = text !== null && text !== void 0 && text.value ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        style: combinedStyles,
        "data-test-id": "FormattedText",
        children: text.value
      }) : null;
    } else {
      returnValue = text;
    }
  }

  return value !== null && value !== void 0 && value.html ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
    dangerouslySetInnerHTML: {
      __html: value.html
    },
    style: baseStyle !== null && baseStyle !== void 0 ? baseStyle : {}
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
    style: baseStyle !== null && baseStyle !== void 0 ? baseStyle : {},
    children: returnValue
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormattedText);

/***/ }),

/***/ 5590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aA": function() { return /* binding */ LandingButtonWhiteStyle; },
/* harmony export */   "mS": function() { return /* binding */ LandingButtonTertiaryStyle; },
/* harmony export */   "vj": function() { return /* binding */ ShimmerWrap; },
/* harmony export */   "zm": function() { return /* binding */ LandingButtonStyle; }
/* harmony export */ });
/* unused harmony export LandingButtonBlackOutlineStyle */
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4928);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);



var LandingButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "LandingButtonstyle__LandingButtonStyle",
  componentId: "sc-1ldh0sr-0"
})(["background-image:", ";border-radius:8px;box-shadow:0px 1px 7px rgba(0,0,0,0.21);color:#fff;width:", ";height:", ";border:none;outline:none;cursor:pointer;margin:", ";flex:", ";flex-shrink:", ";display:flex;align-items:center;gap:8px;justify-content:center;position:relative;padding:12px 20px;text-transform:uppercase;", " ", " span{font-size:", ";font-weight:900;flex-shrink:0;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueGradient */ .rS.blueGradient, function (p) {
  return p.customWidth ? p.customWidth : "fit-content";
}, function (p) {
  return p.customHeight ? p.customHeight : "fit-content";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.flex ? p.flex : "unset";
}, function (p) {
  return p.flexShrink ? p.flexShrink : "0";
}, function (p) {
  return p.btnTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "\n    border-radius:8px;\n    " : p.btnTheme === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.GI ? "border-radius: 4px;\n    background: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.orange */ .rS.orange, ";\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.14);") : "";
}, function (props) {
  return props.disableState && "\n  background: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText2 */ .rS.greyText2, ";\n  color: rgba(0, 0, 0, 0.3);\n  pointer-events:none;\n  ");
}, function (p) {
  return p.fontSize ? p.fontSize : "16px";
});
var ShimmerWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "LandingButtonstyle__ShimmerWrap",
  componentId: "sc-1ldh0sr-1"
})(["position:absolute;width:68px;height:48px;z-index:12;top:-43px;animation:shimmmer 2.9s ease-in;animation-iteration-count:infinite;animation-fill-mode:backwards;@keyframes shimmmer{0%{transform:translateX(-311px);}100%{transform:translateX(311px);}}"]);
var LandingButtonWhiteStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonWhiteStyle",
  componentId: "sc-1ldh0sr-2"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);color:", ";span{color:", ";font-size:16px;font-weight:700;}", ""], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, function (props) {
  return props.disableState && "\nbackground: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText2 */ .rS.greyText2, ";\ncolor: rgba(0, 0, 0, 0.3);\npointer-events:none;\nopacity: 0.7;\n");
});
var LandingButtonTertiaryStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonTertiaryStyle",
  componentId: "sc-1ldh0sr-3"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border:1px solid ", ";height:32px;padding:9px;color:", ";span{color:", ";font-size:12px;font-weight:700;}", ""], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText, function (props) {
  return props.disableState && "\nbackground: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText2 */ .rS.greyText2, ";\ncolor: rgba(0, 0, 0, 0.3);\npointer-events:none;\nopacity: 0.7;\n");
});
var LandingButtonBlackOutlineStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(LandingButtonStyle).withConfig({
  displayName: "LandingButtonstyle__LandingButtonBlackOutlineStyle",
  componentId: "sc-1ldh0sr-4"
})(["background:", ";box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;color:", ";border:1px solid black;span{color:", ";}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blackText */ .rS.blackText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blackText */ .rS.blackText);

/***/ }),

/***/ 6518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MarkdownText_MarkdownText; }
});

// NAMESPACE OBJECT: ../../node_modules/micromark/lib/constructs.js
var constructs_namespaceObject = {};
__webpack_require__.r(constructs_namespaceObject);
__webpack_require__.d(constructs_namespaceObject, {
  "attentionMarkers": function() { return attentionMarkers; },
  "contentInitial": function() { return contentInitial; },
  "disable": function() { return disable; },
  "document": function() { return constructs_document; },
  "flow": function() { return constructs_flow; },
  "flowInitial": function() { return flowInitial; },
  "insideSpan": function() { return insideSpan; },
  "string": function() { return constructs_string; },
  "text": function() { return constructs_text; }
});

// NAMESPACE OBJECT: ../../node_modules/react-markdown/node_modules/property-information/lib/util/types.js
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);
__webpack_require__.d(types_namespaceObject, {
  "boolean": function() { return types_boolean; },
  "booleanish": function() { return booleanish; },
  "commaOrSpaceSeparated": function() { return commaOrSpaceSeparated; },
  "commaSeparated": function() { return commaSeparated; },
  "number": function() { return number; },
  "overloadedBoolean": function() { return overloadedBoolean; },
  "spaceSeparated": function() { return spaceSeparated; }
});

// NAMESPACE OBJECT: ../../node_modules/hastscript/node_modules/property-information/lib/util/types.js
var util_types_namespaceObject = {};
__webpack_require__.r(util_types_namespaceObject);
__webpack_require__.d(util_types_namespaceObject, {
  "boolean": function() { return util_types_boolean; },
  "booleanish": function() { return types_booleanish; },
  "commaOrSpaceSeparated": function() { return types_commaOrSpaceSeparated; },
  "commaSeparated": function() { return types_commaSeparated; },
  "number": function() { return types_number; },
  "overloadedBoolean": function() { return types_overloadedBoolean; },
  "spaceSeparated": function() { return types_spaceSeparated; }
});

// NAMESPACE OBJECT: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/types.js
var lib_util_types_namespaceObject = {};
__webpack_require__.r(lib_util_types_namespaceObject);
__webpack_require__.d(lib_util_types_namespaceObject, {
  "boolean": function() { return lib_util_types_boolean; },
  "booleanish": function() { return util_types_booleanish; },
  "commaOrSpaceSeparated": function() { return util_types_commaOrSpaceSeparated; },
  "commaSeparated": function() { return util_types_commaSeparated; },
  "number": function() { return util_types_number; },
  "overloadedBoolean": function() { return util_types_overloadedBoolean; },
  "spaceSeparated": function() { return util_types_spaceSeparated; }
});

// NAMESPACE OBJECT: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/types.js
var property_information_lib_util_types_namespaceObject = {};
__webpack_require__.r(property_information_lib_util_types_namespaceObject);
__webpack_require__.d(property_information_lib_util_types_namespaceObject, {
  "boolean": function() { return property_information_lib_util_types_boolean; },
  "booleanish": function() { return lib_util_types_booleanish; },
  "commaOrSpaceSeparated": function() { return lib_util_types_commaOrSpaceSeparated; },
  "commaSeparated": function() { return lib_util_types_commaSeparated; },
  "number": function() { return lib_util_types_number; },
  "overloadedBoolean": function() { return lib_util_types_overloadedBoolean; },
  "spaceSeparated": function() { return lib_util_types_spaceSeparated; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/is-buffer/index.js
var is_buffer = __webpack_require__(3335);
;// CONCATENATED MODULE: ../../node_modules/unist-util-stringify-position/index.js
/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */

/**
 * Stringify one point, a position (start and end points), or a node’s
 * positional information.
 *
 * @param {Node|NodeLike|Position|Point|null} [value]
 * @returns {string}
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point|undefined} point
 * @returns {string}
 */
function point(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position|undefined} pos
 * @returns {string}
 */
function position(pos) {
  return point(pos && pos.start) + '-' + point(pos && pos.end)
}

/**
 * @param {number|undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ../../node_modules/vfile-message/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */



class VFileMessage extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string|Error|VFileMessage} reason
   *   Reason for message.
   *   Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place at which the message occurred in a file.
   * @param {string} [origin]
   *   Place in code the message originates from (example `'my-package:my-rule-name'`)
   */
  constructor(reason, place, origin) {
    /** @type {[string|null, string|null]} */
    const parts = [null, null]
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    }

    super()

    if (typeof place === 'string') {
      origin = place
      place = undefined
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        parts[1] = origin
      } else {
        parts[0] = origin.slice(0, index)
        parts[1] = origin.slice(index + 1)
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          // @ts-expect-error: looks like a position.
          position = place.position
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        // @ts-expect-error: looks like a position.
        position = place
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        position.start = place
      }
    }

    // Fields from `Error`
    this.name = stringifyPosition(place) || '1:1'
    /** @type {string} */
    this.message = typeof reason === 'object' ? reason.message : reason
    /** @type {string} */
    this.stack = ''

    if (typeof reason === 'object' && reason.stack) {
      this.stack = reason.stack
    }

    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.reason = this.message

    /* eslint-disable no-unused-expressions */
    /**
     * Whether this is a fatal problem that marks an associated file as no
     * longer processable.
     * If `true`, marks associated file as no longer processable.
     * If `false`, necessitates a (potential) change.
     * The value can also be `null` or `undefined`, for things that might not
     * need changing.
     *
     * @type {boolean?}
     */
    this.fatal

    /**
     * Starting line of error.
     *
     * @type {number?}
     */
    this.line = position.start.line

    /**
     * Starting column of error.
     *
     * @type {number?}
     */
    this.column = position.start.column

    /**
     * Full range information, when available.
     * Has `start` and `end` fields, both set to an object with `line` and
     * `column`, set to `number?`.
     *
     * @type {Position?}
     */
    this.position = position

    /**
     * Namespace of warning (example: `'my-package'`).
     *
     * @type {string?}
     */
    this.source = parts[0]

    /**
     * Category of message (example: `'my-rule-name'`).
     *
     * @type {string?}
     */
    this.ruleId = parts[1]

    /**
     * Path of a file (used throughout the VFile ecosystem).
     *
     * @type {string?}
     */
    this.file

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string?}
     */
    this.actual

    /**
     * Suggest values that should be used instead of `actual`, one or more
     * values that are deemed as acceptable.
     *
     * @type {Array<string>?}
     */
    this.expected

    /**
     * Link to documentation for the message.
     *
     * @type {string?}
     */
    this.url

    /**
     * Long form description of the message (supported by `vfile-reporter`).
     *
     * @type {string?}
     */
    this.note
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = ''
VFileMessage.prototype.name = ''
VFileMessage.prototype.reason = ''
VFileMessage.prototype.message = ''
VFileMessage.prototype.stack = ''
VFileMessage.prototype.fatal = null
VFileMessage.prototype.column = null
VFileMessage.prototype.line = null
VFileMessage.prototype.source = null
VFileMessage.prototype.ruleId = null
VFileMessage.prototype.position = null

;// CONCATENATED MODULE: ../../node_modules/vfile/lib/minpath.browser.js
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const path = {basename, dirname, extname, join, sep: '/'}

/* eslint-disable max-depth, complexity */

/**
 * @param {string} path
 * @param {string} [ext]
 * @returns {string}
 */
function basename(path, ext) {
  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath(path)
  let start = 0
  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let seenNonSlash

  if (ext === undefined || ext.length === 0 || ext.length > path.length) {
    while (index--) {
      if (path.charCodeAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  let firstNonSlashEnd = -1
  let extIndex = ext.length - 1

  while (index--) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function dirname(path) {
  assertPath(path)

  if (path.length === 0) {
    return '.'
  }

  let end = -1
  let index = path.length
  /** @type {boolean|undefined} */
  let unmatchedSlash

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.charCodeAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.charCodeAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

/**
 * @param {string} path
 * @returns {string}
 */
function extname(path) {
  assertPath(path)

  let index = path.length

  let end = -1
  let startPart = 0
  let startDot = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0
  /** @type {boolean|undefined} */
  let unmatchedSlash

  while (index--) {
    const code = path.charCodeAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * @param {Array<string>} segments
 * @returns {string}
 */
function join(...segments) {
  let index = -1
  /** @type {string|undefined} */
  let joined

  while (++index < segments.length) {
    assertPath(segments[index])

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index]
    }
  }

  return joined === undefined ? '.' : normalize(joined)
}

/**
 * Note: `normalize` is not exposed as `path.normalize`, so some code is
 * manually removed from it.
 *
 * @param {string} path
 * @returns {string}
 */
function normalize(path) {
  assertPath(path)

  const absolute = path.charCodeAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute)

  if (value.length === 0 && !absolute) {
    value = '.'
  }

  if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 * @param {boolean} allowAboveRoot
 * @returns {string}
 */
function normalizeString(path, allowAboveRoot) {
  let result = ''
  let lastSegmentLength = 0
  let lastSlash = -1
  let dots = 0
  let index = -1
  /** @type {number|undefined} */
  let code
  /** @type {number} */
  let lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.charCodeAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.charCodeAt(result.length - 1) !== 46 /* `.` */ ||
          result.charCodeAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length > 0) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

/**
 * @param {string} path
 */
function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

;// CONCATENATED MODULE: ../../node_modules/vfile/lib/minproc.browser.js
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const proc = {cwd}

function cwd() {
  return '/'
}

;// CONCATENATED MODULE: ../../node_modules/vfile/lib/minurl.shared.js
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * @param {unknown} fileURLOrPath
 * @returns {fileURLOrPath is URL}
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function isUrl(fileURLOrPath) {
  return (
    fileURLOrPath !== null &&
    typeof fileURLOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileURLOrPath.href &&
    // @ts-expect-error: indexable.
    fileURLOrPath.origin
  )
}

;// CONCATENATED MODULE: ../../node_modules/vfile/lib/minurl.browser.js
/// <reference lib="dom" />



// See: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js>

/**
 * @param {string|URL} path
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path)
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    )
    error.code = 'ERR_INVALID_ARG_TYPE'
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file')
    error.code = 'ERR_INVALID_URL_SCHEME'
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * @param {URL} url
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    )
    error.code = 'ERR_INVALID_FILE_URL_HOST'
    throw error
  }

  const pathname = url.pathname
  let index = -1

  while (++index < pathname.length) {
    if (
      pathname.charCodeAt(index) === 37 /* `%` */ &&
      pathname.charCodeAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.charCodeAt(index + 2)
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        )
        error.code = 'ERR_INVALID_FILE_URL_PATH'
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}



;// CONCATENATED MODULE: ../../node_modules/vfile/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {Record<string, unknown> & {type: string, position?: Position|undefined}} NodeLike
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 *
 * @typedef {'ascii'|'utf8'|'utf-8'|'utf16le'|'ucs2'|'ucs-2'|'base64'|'base64url'|'latin1'|'binary'|'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *   This is a copy of the typing from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Value|Options|VFile|URL} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 * @property {Value} [value]
 * @property {string} [cwd]
 * @property {Array<string>} [history]
 * @property {string|URL} [path]
 * @property {string} [basename]
 * @property {string} [stem]
 * @property {string} [extname]
 * @property {string} [dirname]
 * @property {Data} [data]
 *
 * @typedef Map
 *   Raw source map, see:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 * @property {Array<string>} sources
 * @property {Array<string>} names
 * @property {string|undefined} [sourceRoot]
 * @property {Array<string>|undefined} [sourcesContent]
 * @property {string} mappings
 * @property {string} file
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration: a bunch of keys that will be shallow copied over to the new
 *   file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 * @typedef {<T = ReporterSettings>(files: Array<VFile>, options: T) => string} Reporter
 */







// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
const order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname']

class VFile {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, it’s treated as `{value: options}`.
   * If `options` is a `URL`, it’s treated as `{path: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All fields in `options` are set on the newly created `VFile`.
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {Compatible} [value]
   */
  constructor(value) {
    /** @type {Options} */
    let options

    if (!value) {
      options = {}
    } else if (typeof value === 'string' || is_buffer(value)) {
      // @ts-expect-error Looks like a buffer.
      options = {value}
    } else if (isUrl(value)) {
      options = {path: value}
    } else {
      // @ts-expect-error Looks like file or options.
      options = value
    }

    /**
     * Place to store custom information (default: `{}`).
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     * @type {Data}
     */
    this.data = {}

    /**
     * List of messages associated with the file.
     * @type {Array<VFileMessage>}
     */
    this.messages = []

    /**
     * List of filepaths the file moved between.
     * The first is the original path and the last is the current path.
     * @type {Array<string>}
     */
    this.history = []

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     * @type {string}
     */
    this.cwd = proc.cwd()

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     * @type {Value}
     */
    this.value

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     * This is used by vfile reporters.
     * @type {boolean}
     */
    this.stored

    /**
     * Sometimes files have a non-string, compiled, representation.
     * This can be stored in the `result` field.
     * One example is when turning markdown into React nodes.
     * This is used by unified to store non-string results.
     * @type {unknown}
     */
    this.result

    /**
     * Sometimes files have a source map associated with them.
     * This can be stored in the `map` field.
     * This should be a `Map` type, which is equivalent to the `RawSourceMap`
     * type from the `source-map` module.
     * @type {Map|undefined}
     */
    this.map
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1

    while (++index < order.length) {
      const prop = order[index]

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (prop in options && options[prop] !== undefined) {
        // @ts-expect-error: TS is confused by the different types for `history`.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop]
      }
    }

    /** @type {string} */
    let prop

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(prop)) this[prop] = options[prop]
    }
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   * @param {string|URL} path
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path)
    }

    assertNonEmpty(path, 'path')

    if (this.path !== path) {
      this.history.push(path)
    }
  }

  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(dirname) {
    lib_assertPath(this.basename, 'dirname')
    this.path = path.join(dirname || '', this.basename)
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename')
    assertPart(basename, 'basename')
    this.path = path.join(this.dirname || '', basename)
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(extname) {
    assertPart(extname, 'extname')
    lib_assertPath(this.dirname, 'extname')

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path.join(this.dirname, this.stem + (extname || ''))
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? path.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem')
    assertPart(stem, 'stem')
    this.path = path.join(this.dirname || '', stem + (this.extname || ''))
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8']
   *   When `value` is a `Buffer`, `encoding` is a character encoding to
   *   understand it as (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return (this.value || '').toString(encoding)
  }

  /**
   * Constructs a new `VFileMessage`, where `fatal` is set to `false`, and
   * associates it with the file by adding it to `vfile.messages` and setting
   * `message.file` to the current filepath.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  message(reason, place, origin) {
    const message = new VFileMessage(reason, place, origin)

    if (this.path) {
      message.name = this.path + ':' + message.name
      message.file = this.path
    }

    message.fatal = false

    this.messages.push(message)

    return message
  }

  /**
   * Like `VFile#message()`, but associates an informational message where
   * `fatal` is set to `null`.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {VFileMessage}
   *   Message.
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = null

    return message
  }

  /**
   * Like `VFile#message()`, but associates a fatal message where `fatal` is
   * set to `true`, and then immediately throws it.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string|Error|VFileMessage} reason
   *   Human readable reason for the message, uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place]
   *   Place where the message occurred in the file.
   * @param {string} [origin]
   *   Computer readable reason for the message
   * @returns {never}
   *   Message.
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = true

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {void}
 */
function assertPart(part, name) {
  if (part && part.includes(path.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {asserts part is string}
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string|undefined} path
 * @param {string} name
 * @returns {asserts path is string}
 */
function lib_assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

;// CONCATENATED MODULE: ../../node_modules/bail/index.js
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

// EXTERNAL MODULE: ../../node_modules/extend/index.js
var extend = __webpack_require__(9385);
;// CONCATENATED MODULE: ../../node_modules/is-plain-obj/index.js
function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

;// CONCATENATED MODULE: ../../node_modules/trough/index.js
/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = []
  /** @type {Pipeline} */
  const pipeline = {run, use}

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1
    /** @type {Callback} */
    const callback = values.pop()

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values)

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex]
      let index = -1

      if (error) {
        callback(error)
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index]
        }
      }

      // Save the newly created `output` for the next call.
      values = output

      // Next or done.
      if (fn) {
        wrap(fn, next)(...output)
      } else {
        callback(null, ...output)
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware)
    return pipeline
  }
}

/**
 * Wrap `middleware`.
 * Can be sync or async; return a promise, receive a callback, or return new
 * values and errors.
 *
 * @param {Middleware} middleware
 * @param {Callback} callback
 */
function wrap(middleware, callback) {
  /** @type {boolean} */
  let called

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length
    /** @type {any} */
    let result

    if (fnExpectsCallback) {
      parameters.push(done)
    }

    try {
      result = middleware.apply(this, parameters)
    } catch (error) {
      const exception = /** @type {Error} */ (error)

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result instanceof Promise) {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  /**
   * Call `callback`, only once.
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true
      callback(error, ...output)
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value)
  }
}

;// CONCATENATED MODULE: ../../node_modules/unified/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */








// Expose a frozen processor.
const unified = base().freeze()

const own = {}.hasOwnProperty

// Function to create the first processor.
/**
 * @returns {Processor}
 */
function base() {
  const transformers = trough()
  /** @type {Processor['attachers']} */
  const attachers = []
  /** @type {Record<string, unknown>} */
  let namespace = {}
  /** @type {boolean|undefined} */
  let frozen
  let freezeIndex = -1

  // Data management.
  // @ts-expect-error: overloads are handled.
  processor.data = data
  processor.Parser = undefined
  processor.Compiler = undefined

  // Lock.
  processor.freeze = freeze

  // Plugins.
  processor.attachers = attachers
  // @ts-expect-error: overloads are handled.
  processor.use = use

  // API.
  processor.parse = parse
  processor.stringify = stringify
  // @ts-expect-error: overloads are handled.
  processor.run = run
  processor.runSync = runSync
  // @ts-expect-error: overloads are handled.
  processor.process = process
  processor.processSync = processSync

  // Expose.
  return processor

  // Create a new processor based on the processor in the current scope.
  /** @type {Processor} */
  function processor() {
    const destination = base()
    let index = -1

    while (++index < attachers.length) {
      destination.use(...attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)
        namespace[key] = value
        return processor
      }

      // Get `key`.
      return (own.call(namespace, key) && namespace[key]) || null
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    // Get space.
    return namespace
  }

  /** @type {Processor['freeze']} */
  function freeze() {
    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      const [attacher, ...options] = attachers[freezeIndex]

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined
      }

      /** @type {Transformer|void} */
      const transformer = attacher.call(processor, ...options)

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Number.POSITIVE_INFINITY

    return processor
  }

  /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */
  function use(value, ...options) {
    /** @type {Record<string, unknown>|undefined} */
    let settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      // Empty.
    } else if (typeof value === 'function') {
      addPlugin(value, ...options)
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = Object.assign(namespace.settings || {}, settings)
    }

    return processor

    /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...options] = value
          addPlugin(plugin, ...options)
        } else {
          addPreset(value)
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {void}
     */
    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = Object.assign(settings || {}, result.settings)
      }
    }

    /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */
    function addList(plugins) {
      let index = -1

      if (plugins === null || plugins === undefined) {
        // Empty.
      } else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index]
          add(thing)
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */
    function addPlugin(plugin, value) {
      let index = -1
      /** @type {Processor['attachers'][number]|undefined} */
      let entry

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entry = attachers[index]
          break
        }
      }

      if (entry) {
        if (isPlainObject(entry[1]) && isPlainObject(value)) {
          value = extend(true, entry[1], value)
        }

        entry[1] = value
      } else {
        // @ts-expect-error: fine.
        attachers.push([...arguments])
      }
    }
  }

  /** @type {Processor['parse']} */
  function parse(doc) {
    processor.freeze()
    const file = vfile(doc)
    const Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser, 'parse')) {
      // @ts-expect-error: `newable` checks this.
      return new Parser(String(file), file).parse()
    }

    // @ts-expect-error: `newable` checks this.
    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /** @type {Processor['stringify']} */
  function stringify(node, doc) {
    processor.freeze()
    const file = vfile(doc)
    const Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler, 'compile')) {
      // @ts-expect-error: `newable` checks this.
      return new Compiler(node, file).compile()
    }

    // @ts-expect-error: `newable` checks this.
    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */
  function run(node, doc, callback) {
    assertNode(node)
    processor.freeze()

    if (!callback && typeof doc === 'function') {
      callback = doc
      doc = undefined
    }

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
      transformers.run(node, vfile(doc), done)

      /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */
      function done(error, tree, file) {
        tree = tree || node
        if (error) {
          reject(error)
        } else if (resolve) {
          resolve(tree)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, tree, file)
        }
      }
    }
  }

  /** @type {Processor['runSync']} */
  function runSync(node, file) {
    /** @type {Node|undefined} */
    let result
    /** @type {boolean|undefined} */
    let complete

    processor.run(node, file, done)

    assertDone('runSync', 'run', complete)

    // @ts-expect-error: we either bailed on an error or have a tree.
    return result

    /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */
    function done(error, tree) {
      bail(error)
      result = tree
      complete = true
    }
  }

  /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */
  function process(doc, callback) {
    processor.freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      const file = vfile(doc)

      processor.run(processor.parse(file), file, (error, tree, file) => {
        if (error || !tree || !file) {
          done(error)
        } else {
          /** @type {unknown} */
          const result = processor.stringify(tree, file)

          if (result === undefined || result === null) {
            // Empty.
          } else if (looksLikeAVFileValue(result)) {
            file.value = result
          } else {
            file.result = result
          }

          done(error, file)
        }
      })

      /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */
      function done(error, file) {
        if (error || !file) {
          reject(error)
        } else if (resolve) {
          resolve(file)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, file)
        }
      }
    }
  }

  /** @type {Processor['processSync']} */
  function processSync(doc) {
    /** @type {boolean|undefined} */
    let complete

    processor.freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)

    const file = vfile(doc)

    processor.process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */
    function done(error) {
      complete = true
      bail(error)
    }
  }
}

/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */
function newable(value, name) {
  return (
    typeof value === 'function' &&
    // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype &&
    // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    (keys(value.prototype) || name in value.prototype)
  )
}

/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */
function keys(value) {
  /** @type {string} */
  let key

  for (key in value) {
    if (own.call(value, key)) {
      return true
    }
  }

  return false
}

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */
function looksLikeAVFileValue(value) {
  return typeof value === 'string' || is_buffer(value)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-from-markdown/node_modules/mdast-util-to-string/index.js
/**
 * @typedef Options
 * @property {boolean} [includeImageAlt=true]
 */

/**
 * Get the text content of a node.
 * Prefer the node’s plain-text fields, otherwise serialize its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} node
 * @param {Options} [options]
 * @returns {string}
 */
function mdast_util_to_string_toString(node, options) {
  var {includeImageAlt = true} = options || {}
  return one(node, includeImageAlt)
}

/**
 * @param {unknown} node
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function one(node, includeImageAlt) {
  return (
    (node &&
      typeof node === 'object' &&
      // @ts-ignore looks like a literal.
      (node.value ||
        // @ts-ignore looks like an image.
        (includeImageAlt ? node.alt : '') ||
        // @ts-ignore looks like a parent.
        ('children' in node && mdast_util_to_string_all(node.children, includeImageAlt)) ||
        (Array.isArray(node) && mdast_util_to_string_all(node, includeImageAlt)))) ||
    ''
  )
}

/**
 * @param {Array.<unknown>} values
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function mdast_util_to_string_all(values, includeImageAlt) {
  /** @type {Array.<string>} */
  var result = []
  var index = -1

  while (++index < values.length) {
    result[index] = one(values[index], includeImageAlt)
  }

  return result.join('')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-chunked/index.js
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {number} start
 * @param {number} remove
 * @param {T[]} items
 * @returns {void}
 */
function splice(list, start, remove, items) {
  const end = list.length
  let chunkStart = 0
  /** @type {unknown[]} */

  let parameters // Make start between zero and `end` (included).

  if (start < 0) {
    start = -start > end ? 0 : end + start
  } else {
    start = start > end ? end : start
  }

  remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.

  if (items.length < 10000) {
    parameters = Array.from(items)
    parameters.unshift(start, remove) // @ts-expect-error Hush, it’s fine.
    ;[].splice.apply(list, parameters)
  } else {
    // Delete `remove` items starting from `start`
    if (remove) [].splice.apply(list, [start, remove]) // Insert the items in chunks to not cause stack overflows.

    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000)
      parameters.unshift(start, 0) // @ts-expect-error Hush, it’s fine.
      ;[].splice.apply(list, parameters)
      chunkStart += 10000
      start += 10000
    }
  }
}
/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {T[]} items
 * @returns {T[]}
 */

function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items)
    return list
  }

  return items
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-combine-extensions/index.js
/**
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */



const micromark_util_combine_extensions_hasOwnProperty = {}.hasOwnProperty

/**
 * Combine several syntax extensions into one.
 *
 * @param {Extension[]} extensions List of syntax extensions.
 * @returns {NormalizedExtension} A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {}
  let index = -1

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index])
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all Extension to merge into.
 * @param {Extension} extension Extension to merge.
 * @returns {void}
 */
function syntaxExtension(all, extension) {
  /** @type {string} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {string} */
    let code

    for (code in right) {
      if (!micromark_util_combine_extensions_hasOwnProperty.call(left, code)) left[code] = []
      const value = right[code]
      constructs(
        // @ts-expect-error Looks like a list.
        left[code],
        Array.isArray(value) ? value : value ? [value] : []
      )
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {unknown[]} existing
 * @param {unknown[]} list
 * @returns {void}
 */
function constructs(existing, list) {
  let index = -1
  /** @type {unknown[]} */
  const before = []

  while (++index < list.length) {
    // @ts-expect-error Looks like an object.
    ;(list[index].add === 'after' ? existing : before).push(list[index])
  }

  splice(existing, 0, 0, before)
}

/**
 * Combine several HTML extensions into one.
 *
 * @param {HtmlExtension[]} htmlExtensions List of HTML extensions.
 * @returns {HtmlExtension} A single combined extension.
 */
function combineHtmlExtensions(htmlExtensions) {
  /** @type {HtmlExtension} */
  const handlers = {}
  let index = -1

  while (++index < htmlExtensions.length) {
    htmlExtension(handlers, htmlExtensions[index])
  }

  return handlers
}

/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all Extension to merge into.
 * @param {HtmlExtension} extension Extension to merge.
 * @returns {void}
 */
function htmlExtension(all, extension) {
  /** @type {string} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {string} */
    let type

    if (right) {
      for (type in right) {
        left[type] = right[type]
      }
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-character/lib/unicode-punctuation-regex.js
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
const unicodePunctuationRegex =
  /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/

;// CONCATENATED MODULE: ../../node_modules/micromark-util-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 */

const asciiAlpha = regexCheck(/[A-Za-z]/)
/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 */

const asciiDigit = regexCheck(/\d/)
/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 */

const asciiHexDigit = regexCheck(/[\dA-Fa-f]/)
/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 */

const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/)
/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 */

const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/)
/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 */

const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/)
/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  )
}
/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32)
}
/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEnding(code) {
  return code !== null && code < -2
}
/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}
/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */

const unicodeWhitespace = regexCheck(/\s/)
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */
// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.

const unicodePunctuation = regexCheck(unicodePunctuationRegex)
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => code is number}
 */

function regexCheck(regex) {
  return check
  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code Character code
   * @returns {code is number} Whether the character code matches the bound regex
   */

  function check(code) {
    return code !== null && regex.test(String.fromCharCode(code))
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-space/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {string} type
 * @param {number} [max=Infinity]
 * @returns {State}
 */

function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type)
      return prefix(code)
    }

    return ok(code)
  }
  /** @type {State} */

  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code)
      return prefix
    }

    effects.exit(type)
    return ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/content.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {InitialConstruct} */
const content = {
  tokenize: initializeContent
}
/** @type {Initializer} */

function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  )
  /** @type {Token} */

  let previous
  return contentStart
  /** @type {State} */

  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, contentStart, 'linePrefix')
  }
  /** @type {State} */

  function paragraphInitial(code) {
    effects.enter('paragraph')
    return lineStart(code)
  }
  /** @type {State} */

  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    })

    if (previous) {
      previous.next = token
    }

    previous = token
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      effects.exit('chunkText')
      effects.exit('paragraph')
      effects.consume(code)
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code)
      effects.exit('chunkText')
      return lineStart
    } // Data.

    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/document.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Point} Point
 */

/**
 * @typedef {Record<string, unknown>} StackState
 * @typedef {[Construct, StackState]} StackItem
 */



/** @type {InitialConstruct} */

const document_document = {
  tokenize: initializeDocument
}
/** @type {Construct} */

const containerConstruct = {
  tokenize: tokenizeContainer
}
/** @type {Initializer} */

function initializeDocument(effects) {
  const self = this
  /** @type {Array<StackItem>} */

  const stack = []
  let continued = 0
  /** @type {TokenizeContext|undefined} */

  let childFlow
  /** @type {Token|undefined} */

  let childToken
  /** @type {number} */

  let lineStartOffset
  return start
  /** @type {State} */

  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued]
      self.containerState = item[1]
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    } // Done.

    return checkNewContainers(code)
  }
  /** @type {State} */

  function documentContinue(code) {
    continued++ // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.

    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined

      if (childFlow) {
        closeFlow()
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.

      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {Point|undefined} */

      let point // Find the flow chunk.

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end
          break
        }
      }

      exitContainers(continued) // Fix positions.

      let index = indexBeforeExits

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ) // Discard the duplicate exits.

      self.events.length = index
      return checkNewContainers(code)
    }

    return start(code)
  }
  /** @type {State} */

  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      } // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.

      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      } // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.

      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      )
    } // Check if there is a new container.

    self.containerState = {}
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }
  /** @type {State} */

  function thereIsANewContainer(code) {
    if (childFlow) closeFlow()
    exitContainers(continued)
    return documentContinued(code)
  }
  /** @type {State} */

  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length
    lineStartOffset = self.now().offset
    return flowStart(code)
  }
  /** @type {State} */

  function documentContinued(code) {
    // Try new containers.
    self.containerState = {}
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }
  /** @type {State} */

  function containerContinue(code) {
    continued++
    stack.push([self.currentConstruct, self.containerState]) // Try another.

    return documentContinued(code)
  }
  /** @type {State} */

  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow()
      exitContainers(0)
      effects.consume(code)
      return
    }

    childFlow = childFlow || self.parser.flow(self.now())
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    })
    return flowContinue(code)
  }
  /** @type {State} */

  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true)
      exitContainers(0)
      effects.consume(code)
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code)
      writeToChild(effects.exit('chunkFlow')) // Get ready for the next line.

      continued = 0
      self.interrupt = undefined
      return start
    }

    effects.consume(code)
    return flowContinue
  }
  /**
   * @param {Token} token
   * @param {boolean} [eof]
   * @returns {void}
   */

  function writeToChild(token, eof) {
    const stream = self.sliceStream(token)
    if (eof) stream.push(null)
    token.previous = childToken
    if (childToken) childToken.next = token
    childToken = token
    childFlow.defineSkip(token.start)
    childFlow.write(stream) // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.

    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length

      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index][1].end || // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.

      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {boolean|undefined} */

      let seen
      /** @type {Point|undefined} */

      let point // Find the previous chunk (the one before the lazy line).

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end
            break
          }

          seen = true
        }
      }

      exitContainers(continued) // Fix positions.

      index = indexBeforeExits

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ) // Discard the duplicate exits.

      self.events.length = index
    }
  }
  /**
   * @param {number} size
   * @returns {void}
   */

  function exitContainers(size) {
    let index = stack.length // Exit open containers.

    while (index-- > size) {
      const entry = stack[index]
      self.containerState = entry[1]
      entry[0].exit.call(self, effects)
    }

    stack.length = size
  }

  function closeFlow() {
    childFlow.write([null])
    childToken = undefined
    childFlow = undefined
    self.containerState._closeFlow = undefined
  }
}
/** @type {Tokenizer} */

function tokenizeContainer(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/blank-line.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeBlankLine(effects, ok, nok) {
  return factorySpace(effects, afterWhitespace, 'linePrefix')
  /** @type {State} */

  function afterWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-subtokenize/index.js
/**
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 */


/**
 * Tokenize subcontent.
 *
 * @param {Event[]} events
 * @returns {boolean}
 */
function subtokenize(events) {
  /** @type {Record<string, number>} */
  const jumps = {}
  let index = -1
  /** @type {Event} */

  let event
  /** @type {number|undefined} */

  let lineIndex
  /** @type {number} */

  let otherIndex
  /** @type {Event} */

  let otherEvent
  /** @type {Event[]} */

  let parameters
  /** @type {Event[]} */

  let subevents
  /** @type {boolean|undefined} */

  let more

  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index]
    }

    event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.

    if (
      index &&
      event[1].type === 'chunkFlow' &&
      events[index - 1][1].type === 'listItemPrefix'
    ) {
      subevents = event[1]._tokenizer.events
      otherIndex = 0

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'lineEndingBlank'
      ) {
        otherIndex += 2
      }

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'content'
      ) {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break
          }

          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true
            otherIndex++
          }
        }
      }
    } // Enter.

    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index))
        index = jumps[index]
        more = true
      }
    } // Exit.
    else if (event[1]._container) {
      otherIndex = index
      lineIndex = undefined

      while (otherIndex--) {
        otherEvent = events[otherIndex]

        if (
          otherEvent[1].type === 'lineEnding' ||
          otherEvent[1].type === 'lineEndingBlank'
        ) {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank'
            }

            otherEvent[1].type = 'lineEnding'
            lineIndex = otherIndex
          }
        } else {
          break
        }
      }

      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events[lineIndex][1].start) // Switch container exit w/ line endings.

        parameters = events.slice(lineIndex, index)
        parameters.unshift(event)
        splice(events, lineIndex, index - lineIndex + 1, parameters)
      }
    }
  }

  return !more
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Event[]} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */

function subcontent(events, eventIndex) {
  const token = events[eventIndex][1]
  const context = events[eventIndex][2]
  let startPosition = eventIndex - 1
  /** @type {number[]} */

  const startPositions = []
  const tokenizer =
    token._tokenizer || context.parser[token.contentType](token.start)
  const childEvents = tokenizer.events
  /** @type {[number, number][]} */

  const jumps = []
  /** @type {Record<string, number>} */

  const gaps = {}
  /** @type {Chunk[]} */

  let stream
  /** @type {Token|undefined} */

  let previous
  let index = -1
  /** @type {Token|undefined} */

  let current = token
  let adjust = 0
  let start = 0
  const breaks = [start] // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.

  while (current) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== current) {
      // Empty.
    }

    startPositions.push(startPosition)

    if (!current._tokenizer) {
      stream = context.sliceStream(current)

      if (!current.next) {
        stream.push(null)
      }

      if (previous) {
        tokenizer.defineSkip(current.start)
      }

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true
      }

      tokenizer.write(stream)

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined
      }
    } // Unravel the next token.

    previous = current
    current = current.next
  } // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.

  current = token

  while (++index < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index][0] === 'exit' &&
      childEvents[index - 1][0] === 'enter' &&
      childEvents[index][1].type === childEvents[index - 1][1].type &&
      childEvents[index][1].start.line !== childEvents[index][1].end.line
    ) {
      start = index + 1
      breaks.push(start) // Help GC.

      current._tokenizer = undefined
      current.previous = undefined
      current = current.next
    }
  } // Help GC.

  tokenizer.events = [] // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.

  if (current) {
    // Help GC.
    current._tokenizer = undefined
    current.previous = undefined
  } else {
    breaks.pop()
  } // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.

  index = breaks.length

  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1])
    const start = startPositions.pop()
    jumps.unshift([start, start + slice.length - 1])
    splice(events, start, 2, slice)
  }

  index = -1

  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1]
    adjust += jumps[index][1] - jumps[index][0] - 1
  }

  return gaps
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/content.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */




/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content_content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
}
/** @type {Construct} */

const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
}
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */

function resolveContent(events) {
  subtokenize(events)
  return events
}
/** @type {Tokenizer} */

function tokenizeContent(effects, ok) {
  /** @type {Token} */
  let previous
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('content')
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    })
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      return contentEnd(code)
    }

    if (markdownLineEnding(code)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code)
    } // Data.

    effects.consume(code)
    return data
  }
  /** @type {State} */

  function contentEnd(code) {
    effects.exit('chunkContent')
    effects.exit('content')
    return ok(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    effects.consume(code)
    effects.exit('chunkContent')
    previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous
    })
    previous = previous.next
    return data
  }
}
/** @type {Tokenizer} */

function tokenizeContinuation(effects, ok, nok) {
  const self = this
  return startLookahead
  /** @type {State} */

  function startLookahead(code) {
    effects.exit('chunkContent')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, prefixed, 'linePrefix')
  }
  /** @type {State} */

  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    const tail = self.events[self.events.length - 1]

    if (
      !self.parser.constructs.disable.null.includes('codeIndented') &&
      tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
    ) {
      return ok(code)
    }

    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/flow.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 */




/** @type {InitialConstruct} */
const flow = {
  tokenize: initializeFlow
}
/** @type {Initializer} */

function initializeFlow(effects) {
  const self = this
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content_content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  )
  return initial
  /** @type {State} */

  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    self.currentConstruct = undefined
    return initial
  }
  /** @type {State} */

  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }

    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    self.currentConstruct = undefined
    return initial
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/initialize/text.js
/**
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */
const resolver = {
  resolveAll: createResolver()
}
const string = initializeFactory('string')
const text_text = initializeFactory('text')
/**
 * @param {'string'|'text'} field
 * @returns {InitialConstruct}
 */

function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }
  /** @type {Initializer} */

  function initializeText(effects) {
    const self = this
    const constructs = this.parser.constructs[field]
    const text = effects.attempt(constructs, start, notText)
    return start
    /** @type {State} */

    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }
    /** @type {State} */

    function notText(code) {
      if (code === null) {
        effects.consume(code)
        return
      }

      effects.enter('data')
      effects.consume(code)
      return data
    }
    /** @type {State} */

    function data(code) {
      if (atBreak(code)) {
        effects.exit('data')
        return text(code)
      } // Data.

      effects.consume(code)
      return data
    }
    /**
     * @param {Code} code
     * @returns {boolean}
     */

    function atBreak(code) {
      if (code === null) {
        return true
      }

      const list = constructs[code]
      let index = -1

      if (list) {
        while (++index < list.length) {
          const item = list[index]

          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }

      return false
    }
  }
}
/**
 * @param {Resolver} [extraResolver]
 * @returns {Resolver}
 */

function createResolver(extraResolver) {
  return resolveAllText
  /** @type {Resolver} */

  function resolveAllText(events, context) {
    let index = -1
    /** @type {number|undefined} */

    let enter // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.

    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index
          index++
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end
          events.splice(enter + 2, index - enter - 2)
          index = enter + 2
        }

        enter = undefined
      }
    }

    return extraResolver ? extraResolver(events, context) : events
  }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */

function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0 // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1]
      const chunks = context.sliceStream(data)
      let index = chunks.length
      let bufferIndex = -1
      let size = 0
      /** @type {boolean|undefined} */

      let tabs

      while (index--) {
        const chunk = chunks[index]

        if (typeof chunk === 'string') {
          bufferIndex = chunk.length

          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++
            bufferIndex--
          }

          if (bufferIndex) break
          bufferIndex = -1
        } // Number
        else if (chunk === -2) {
          tabs = true
          size++
        } else if (chunk === -1) {
          // Empty
        } else {
          // Replacement character, exit.
          index++
          break
        }
      }

      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        }
        data.end = Object.assign({}, token.start)

        if (data.start.offset === data.end.offset) {
          Object.assign(data, token)
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          )
          eventIndex += 2
        }
      }

      eventIndex++
    }
  }

  return events
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-resolve-all/index.js
/**
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {{resolveAll?: Resolver}[]} constructs
 * @param {Event[]} events
 * @param {TokenizeContext} context
 * @returns {Event[]}
 */
function resolveAll(constructs, events, context) {
  /** @type {Resolver[]} */
  const called = []
  let index = -1

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context)
      called.push(resolve)
    }
  }

  return events
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/create-tokenizer.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 */

/**
 * @typedef Info
 * @property {() => void} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */




/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_index'|'_bufferIndex'>} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  )
  /** @type {Record<string, number>} */

  const columnStart = {}
  /** @type {Array<Construct>} */

  const resolveAllConstructs = []
  /** @type {Array<Chunk>} */

  let chunks = []
  /** @type {Array<Token>} */

  let stack = []
  /** @type {boolean|undefined} */

  let consumed = true
  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */

  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  }
  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */

  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  }
  /**
   * The state function.
   *
   * @type {State|void}
   */

  let state = initialize.tokenize.call(context, effects)
  /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */

  let expectedCode

  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize)
  }

  return context
  /** @type {TokenizeContext['write']} */

  function write(slice) {
    chunks = push(chunks, slice)
    main() // Exit if we’re not done, resolve might change stuff.

    if (chunks[chunks.length - 1] !== null) {
      return []
    }

    addResult(initialize, 0) // Otherwise, resolve, and exit.

    context.events = resolveAll(resolveAllConstructs, context.events, context)
    return context.events
  } //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */

  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }
  /** @type {TokenizeContext['sliceStream']} */

  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }
  /** @type {TokenizeContext['now']} */

  function now() {
    return Object.assign({}, point)
  }
  /** @type {TokenizeContext['defineSkip']} */

  function defineSkip(value) {
    columnStart[value.line] = value.column
    accountForPotentialSkip()
  } //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */

  function main() {
    /** @type {number} */
    let chunkIndex

    while (point._index < chunks.length) {
      const chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.

      if (typeof chunk === 'string') {
        chunkIndex = point._index

        if (point._bufferIndex < 0) {
          point._bufferIndex = 0
        }

        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex))
        }
      } else {
        go(chunk)
      }
    }
  }
  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */

  function go(code) {
    consumed = undefined
    expectedCode = code
    state = state(code)
  }
  /** @type {Effects['consume']} */

  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++
      point.column = 1
      point.offset += code === -3 ? 2 : 1
      accountForPotentialSkip()
    } else if (code !== -1) {
      point.column++
      point.offset++
    } // Not in a string chunk.

    if (point._bufferIndex < 0) {
      point._index++
    } else {
      point._bufferIndex++ // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.

      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1
        point._index++
      }
    } // Expose the previous character.

    context.previous = code // Mark as consumed.

    consumed = true
  }
  /** @type {Effects['enter']} */

  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {}
    token.type = type
    token.start = now()
    context.events.push(['enter', token, context])
    stack.push(token)
    return token
  }
  /** @type {Effects['exit']} */

  function exit(type) {
    const token = stack.pop()
    token.end = now()
    context.events.push(['exit', token, context])
    return token
  }
  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from)
  }
  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulcheck(_, info) {
    info.restore()
  }
  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {Record<string, unknown>} [fields]
   */

  function constructFactory(onreturn, fields) {
    return hook
    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Construct|Array<Construct>|ConstructRecord} constructs
     * @param {State} returnState
     * @param {State} [bogusState]
     * @returns {State}
     */

    function hook(constructs, returnState, bogusState) {
      /** @type {Array<Construct>} */
      let listOfConstructs
      /** @type {number} */

      let constructIndex
      /** @type {Construct} */

      let currentConstruct
      /** @type {Info} */

      let info
      return Array.isArray(constructs)
        ? /* c8 ignore next 1 */
          handleListOfConstructs(constructs)
        : 'tokenize' in constructs // @ts-expect-error Looks like a construct.
        ? handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)
      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */

      function handleMapOfConstructs(map) {
        return start
        /** @type {State} */

        function start(code) {
          const def = code !== null && map[code]
          const all = code !== null && map.null
          const list = [
            // To do: add more extension tests.

            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ]
          return handleListOfConstructs(list)(code)
        }
      }
      /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */

      function handleListOfConstructs(list) {
        listOfConstructs = list
        constructIndex = 0

        if (list.length === 0) {
          return bogusState
        }

        return handleConstruct(list[constructIndex])
      }
      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */

      function handleConstruct(construct) {
        return start
        /** @type {State} */

        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store()
          currentConstruct = construct

          if (!construct.partial) {
            context.currentConstruct = construct
          }

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok(code)
          }

          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }
      /** @type {State} */

      function ok(code) {
        consumed = true
        onreturn(currentConstruct, info)
        return returnState
      }
      /** @type {State} */

      function nok(code) {
        consumed = true
        info.restore()

        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }

        return bogusState
      }
    }
  }
  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */

  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct)
    }

    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      )
    }

    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context)
    }
  }
  /**
   * Store state.
   *
   * @returns {Info}
   */

  function store() {
    const startPoint = now()
    const startPrevious = context.previous
    const startCurrentConstruct = context.currentConstruct
    const startEventsIndex = context.events.length
    const startStack = Array.from(stack)
    return {
      restore,
      from: startEventsIndex
    }
    /**
     * Restore state.
     *
     * @returns {void}
     */

    function restore() {
      point = startPoint
      context.previous = startPrevious
      context.currentConstruct = startCurrentConstruct
      context.events.length = startEventsIndex
      stack = startStack
      accountForPotentialSkip()
    }
  }
  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */

  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line]
      point.offset += columnStart[point.line] - 1
    }
  }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'start'|'end'>} token
 * @returns {Array<Chunk>}
 */

function sliceChunks(chunks, token) {
  const startIndex = token.start._index
  const startBufferIndex = token.start._bufferIndex
  const endIndex = token.end._index
  const endBufferIndex = token.end._bufferIndex
  /** @type {Array<Chunk>} */

  let view

  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)]
  } else {
    view = chunks.slice(startIndex, endIndex)

    if (startBufferIndex > -1) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view[0] = view[0].slice(startBufferIndex)
    }

    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex))
    }
  }

  return view
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean} [expandTabs=false]
 * @returns {string}
 */

function serializeChunks(chunks, expandTabs) {
  let index = -1
  /** @type {Array<string>} */

  const result = []
  /** @type {boolean|undefined} */

  let atTab

  while (++index < chunks.length) {
    const chunk = chunks[index]
    /** @type {string} */

    let value

    if (typeof chunk === 'string') {
      value = chunk
    } else
      switch (chunk) {
        case -5: {
          value = '\r'
          break
        }

        case -4: {
          value = '\n'
          break
        }

        case -3: {
          value = '\r' + '\n'
          break
        }

        case -2: {
          value = expandTabs ? ' ' : '\t'
          break
        }

        case -1: {
          if (!expandTabs && atTab) continue
          value = ' '
          break
        }

        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk)
        }
      }

    atTab = chunk === -2
    result.push(value)
  }

  return result.join('')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/thematic-break.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const thematicBreak = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
}
/** @type {Tokenizer} */

function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('thematicBreak')
    marker = code
    return atBreak(code)
  }
  /** @type {State} */

  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence')
      return sequence(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, 'whitespace')(code)
    }

    if (size < 3 || (code !== null && !markdownLineEnding(code))) {
      return nok(code)
    }

    effects.exit('thematicBreak')
    return ok(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      size++
      return sequence
    }

    effects.exit('thematicBreakSequence')
    return atBreak(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/list.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @typedef {Record<string, unknown> & {marker: Code, type: string, size: number}} ListContainerState
 * @typedef {TokenizeContext & {containerState: ListContainerState}} TokenizeContextWithState
 */




/** @type {Construct} */

const list = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
}
/** @type {Construct} */

const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
}
/** @type {Construct} */

const indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListStart(effects, ok, nok) {
  const self = this
  const tail = self.events[self.events.length - 1]
  let initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    const kind =
      self.containerState.type ||
      (code === 42 || code === 43 || code === 45
        ? 'listUnordered'
        : 'listOrdered')

    if (
      kind === 'listUnordered'
        ? !self.containerState.marker || code === self.containerState.marker
        : asciiDigit(code)
    ) {
      if (!self.containerState.type) {
        self.containerState.type = kind
        effects.enter(kind, {
          _container: true
        })
      }

      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix')
        return code === 42 || code === 45
          ? effects.check(thematicBreak, nok, atMarker)(code)
          : atMarker(code)
      }

      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix')
        effects.enter('listItemValue')
        return inside(code)
      }
    }

    return nok(code)
  }
  /** @type {State} */

  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code)
      return inside
    }

    if (
      (!self.interrupt || size < 2) &&
      (self.containerState.marker
        ? code === self.containerState.marker
        : code === 41 || code === 46)
    ) {
      effects.exit('listItemValue')
      return atMarker(code)
    }

    return nok(code)
  }
  /**
   * @type {State}
   **/

  function atMarker(code) {
    effects.enter('listItemMarker')
    effects.consume(code)
    effects.exit('listItemMarker')
    self.containerState.marker = self.containerState.marker || code
    return effects.check(
      blankLine, // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    )
  }
  /** @type {State} */

  function onBlank(code) {
    self.containerState.initialBlankLine = true
    initialSize++
    return endOfPrefix(code)
  }
  /** @type {State} */

  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace')
      effects.consume(code)
      effects.exit('listItemPrefixWhitespace')
      return endOfPrefix
    }

    return nok(code)
  }
  /** @type {State} */

  function endOfPrefix(code) {
    self.containerState.size =
      initialSize +
      self.sliceSerialize(effects.exit('listItemPrefix'), true).length
    return ok(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListContinuation(effects, ok, nok) {
  const self = this
  self.containerState._closeFlow = undefined
  return effects.check(blankLine, onBlank, notBlank)
  /** @type {State} */

  function onBlank(code) {
    self.containerState.furtherBlankLines =
      self.containerState.furtherBlankLines ||
      self.containerState.initialBlankLine // We have a blank line.
    // Still, try to consume at most the items size.

    return factorySpace(
      effects,
      ok,
      'listItemIndent',
      self.containerState.size + 1
    )(code)
  }
  /** @type {State} */

  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined
      self.containerState.initialBlankLine = undefined
      return notInCurrentItem(code)
    }

    self.containerState.furtherBlankLines = undefined
    self.containerState.initialBlankLine = undefined
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code)
  }
  /** @type {State} */

  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.

    self.interrupt = undefined
    return factorySpace(
      effects,
      effects.attempt(list, ok, nok),
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemIndent',
    self.containerState.size + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'listItemIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === self.containerState.size
      ? ok(code)
      : nok(code)
  }
}
/**
 * @type {Exiter}
 * @this {TokenizeContextWithState}
 */

function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type)
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemPrefixWhitespace',
    self.parser.constructs.disable.null.includes('codeIndented')
      ? undefined
      : 4 + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return !markdownSpace(code) &&
      tail &&
      tail[1].type === 'listItemPrefixWhitespace'
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/block-quote.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    if (code === 62) {
      const state = self.containerState

      if (!state.open) {
        effects.enter('blockQuote', {
          _container: true
        })
        state.open = true
      }

      effects.enter('blockQuotePrefix')
      effects.enter('blockQuoteMarker')
      effects.consume(code)
      effects.exit('blockQuoteMarker')
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (markdownSpace(code)) {
      effects.enter('blockQuotePrefixWhitespace')
      effects.consume(code)
      effects.exit('blockQuotePrefixWhitespace')
      effects.exit('blockQuotePrefix')
      return ok
    }

    effects.exit('blockQuotePrefix')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(blockQuote, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}
/** @type {Exiter} */

function exit(effects) {
  effects.exit('blockQuote')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-destination/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} literalType
 * @param {string} literalMarkerType
 * @param {string} rawType
 * @param {string} stringType
 * @param {number} [max=Infinity]
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY
  let balance = 0
  return start
  /** @type {State} */

  function start(code) {
    if (code === 60) {
      effects.enter(type)
      effects.enter(literalType)
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      return destinationEnclosedBefore
    }

    if (code === null || code === 41 || asciiControl(code)) {
      return nok(code)
    }

    effects.enter(type)
    effects.enter(rawType)
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return destinationRaw(code)
  }
  /** @type {State} */

  function destinationEnclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      effects.exit(literalType)
      effects.exit(type)
      return ok
    }

    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationEnclosed(code) {
    if (code === 62) {
      effects.exit('chunkString')
      effects.exit(stringType)
      return destinationEnclosedBefore(code)
    }

    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }

    effects.consume(code)
    return code === 92 ? destinationEnclosedEscape : destinationEnclosed
  }
  /** @type {State} */

  function destinationEnclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code)
      return destinationEnclosed
    }

    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationRaw(code) {
    if (code === 40) {
      if (++balance > limit) return nok(code)
      effects.consume(code)
      return destinationRaw
    }

    if (code === 41) {
      if (!balance--) {
        effects.exit('chunkString')
        effects.exit(stringType)
        effects.exit(rawType)
        effects.exit(type)
        return ok(code)
      }

      effects.consume(code)
      return destinationRaw
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      if (balance) return nok(code)
      effects.exit('chunkString')
      effects.exit(stringType)
      effects.exit(rawType)
      effects.exit(type)
      return ok(code)
    }

    if (asciiControl(code)) return nok(code)
    effects.consume(code)
    return code === 92 ? destinationRawEscape : destinationRaw
  }
  /** @type {State} */

  function destinationRawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code)
      return destinationRaw
    }

    return destinationRaw(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-label/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').State} State
 */


/**
 * @this {TokenizeContext}
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this
  let size = 0
  /** @type {boolean} */

  let data
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    effects.enter(stringType)
    return atBreak
  }
  /** @type {State} */

  function atBreak(code) {
    if (
      code === null ||
      code === 91 ||
      (code === 93 && !data) ||
      /* To do: remove in the future once we’ve switched from
       * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
       * which doesn’t need this */

      /* Hidden footnotes hook */

      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs) ||
      size > 999
    ) {
      return nok(code)
    }

    if (code === 93) {
      effects.exit(stringType)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return atBreak
    }

    effects.enter('chunkString', {
      contentType: 'string'
    })
    return label(code)
  }
  /** @type {State} */

  function label(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString')
      return atBreak(code)
    }

    effects.consume(code)
    data = data || !markdownSpace(code)
    return code === 92 ? labelEscape : label
  }
  /** @type {State} */

  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return label
    }

    return label(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-title/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    marker = code === 40 ? 41 : code
    return atFirstTitleBreak
  }
  /** @type {State} */

  function atFirstTitleBreak(code) {
    if (code === marker) {
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    effects.enter(stringType)
    return atTitleBreak(code)
  }
  /** @type {State} */

  function atTitleBreak(code) {
    if (code === marker) {
      effects.exit(stringType)
      return atFirstTitleBreak(marker)
    }

    if (code === null) {
      return nok(code)
    } // Note: blank lines can’t exist in content.

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return factorySpace(effects, atTitleBreak, 'linePrefix')
    }

    effects.enter('chunkString', {
      contentType: 'string'
    })
    return title(code)
  }
  /** @type {State} */

  function title(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      return atTitleBreak(code)
    }

    effects.consume(code)
    return code === 92 ? titleEscape : title
  }
  /** @type {State} */

  function titleEscape(code) {
    if (code === marker || code === 92) {
      effects.consume(code)
      return title
    }

    return title(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-factory-whitespace/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */



/**
 * @param {Effects} effects
 * @param {State} ok
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen
  return start
  /** @type {State} */

  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      seen = true
      return start
    }

    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }

    return ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-normalize-identifier/index.js
/**
 * Normalize an identifier (such as used in definitions).
 *
 * @param {string} value
 * @returns {string}
 */
function normalizeIdentifier(value) {
  return (
    value // Collapse Markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ') // Trim.
      .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/definition.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */








/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
}
/** @type {Construct} */

const titleConstruct = {
  tokenize: tokenizeTitle,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeDefinition(effects, ok, nok) {
  const self = this
  /** @type {string} */

  let identifier
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('definition')
    return factoryLabel.call(
      self,
      effects,
      labelAfter,
      nok,
      'definitionLabel',
      'definitionLabelMarker',
      'definitionLabelString'
    )(code)
  }
  /** @type {State} */

  function labelAfter(code) {
    identifier = normalizeIdentifier(
      self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
    )

    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker') // Note: blank lines can’t exist in content.

      return factoryWhitespace(
        effects,
        factoryDestination(
          effects,
          effects.attempt(
            titleConstruct,
            factorySpace(effects, after, 'whitespace'),
            factorySpace(effects, after, 'whitespace')
          ),
          nok,
          'definitionDestination',
          'definitionDestinationLiteral',
          'definitionDestinationLiteralMarker',
          'definitionDestinationRaw',
          'definitionDestinationString'
        )
      )
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('definition')

      if (!self.parser.defined.includes(identifier)) {
        self.parser.defined.push(identifier)
      }

      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeTitle(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, before)(code)
      : nok(code)
  }
  /** @type {State} */

  function before(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factorySpace(effects, after, 'whitespace'),
        nok,
        'definitionTitle',
        'definitionTitleMarker',
        'definitionTitleString'
      )(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/code-indented.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
}
/** @type {Construct} */

const indentedContent = {
  tokenize: tokenizeIndentedContent,
  partial: true
}
/** @type {Tokenizer} */

function tokenizeCodeIndented(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeIndented')
    return factorySpace(effects, afterStartPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterStartPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? afterPrefix(code)
      : nok(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(indentedContent, afterPrefix, after)(code)
    }

    effects.enter('codeFlowValue')
    return content(code)
  }
  /** @type {State} */

  function content(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return afterPrefix(code)
    }

    effects.consume(code)
    return content
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeIndented')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeIndentedContent(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return start
    }

    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? ok(code)
      : markdownLineEnding(code)
      ? start(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/heading-atx.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */




/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
}
/** @type {Resolver} */

function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2
  let contentStart = 3
  /** @type {Token} */

  let content
  /** @type {Token} */

  let text // Prefix whitespace, part of the opening.

  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2
  } // Suffix whitespace, part of the closing.

  if (
    contentEnd - 2 > contentStart &&
    events[contentEnd][1].type === 'whitespace'
  ) {
    contentEnd -= 2
  }

  if (
    events[contentEnd][1].type === 'atxHeadingSequence' &&
    (contentStart === contentEnd - 1 ||
      (contentEnd - 4 > contentStart &&
        events[contentEnd - 2][1].type === 'whitespace'))
  ) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4
  }

  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    }
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      // @ts-expect-error Constants are fine to assign.
      contentType: 'text'
    }
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ['enter', content, context],
      ['enter', text, context],
      ['exit', text, context],
      ['exit', content, context]
    ])
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHeadingAtx(effects, ok, nok) {
  const self = this
  let size = 0
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('atxHeading')
    effects.enter('atxHeadingSequence')
    return fenceOpenInside(code)
  }
  /** @type {State} */

  function fenceOpenInside(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code)
      return fenceOpenInside
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingSequence')
      return self.interrupt ? ok(code) : headingBreak(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function headingBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence')
      return sequence(code)
    }

    if (code === null || markdownLineEnding(code)) {
      effects.exit('atxHeading')
      return ok(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, headingBreak, 'whitespace')(code)
    }

    effects.enter('atxHeadingText')
    return data(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === 35) {
      effects.consume(code)
      return sequence
    }

    effects.exit('atxHeadingSequence')
    return headingBreak(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingText')
      return headingBreak(code)
    }

    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/setext-underline.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
}
/** @type {Resolver} */

function resolveToSetextUnderline(events, context) {
  let index = events.length
  /** @type {number|undefined} */

  let content
  /** @type {number|undefined} */

  let text
  /** @type {number|undefined} */

  let definition // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.

  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index
        break
      }

      if (events[index][1].type === 'paragraph') {
        text = index
      }
    } // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1)
      }

      if (!definition && events[index][1].type === 'definition') {
        definition = index
      }
    }
  }

  const heading = {
    type: 'setextHeading',
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  } // Change the paragraph to setext heading text.

  events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.

  if (definition) {
    events.splice(text, 0, ['enter', heading, context])
    events.splice(definition + 1, 0, ['exit', events[content][1], context])
    events[content][1].end = Object.assign({}, events[definition][1].end)
  } else {
    events[content][1] = heading
  } // Add the heading exit at the end.

  events.push(['exit', heading, context])
  return events
}
/** @type {Tokenizer} */

function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {NonNullable<Code>} */

  let marker
  /** @type {boolean} */

  let paragraph // Find an opening.

  while (index--) {
    // Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (
      self.events[index][1].type !== 'lineEnding' &&
      self.events[index][1].type !== 'linePrefix' &&
      self.events[index][1].type !== 'content'
    ) {
      paragraph = self.events[index][1].type === 'paragraph'
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine')
      effects.enter('setextHeadingLineSequence')
      marker = code
      return closingSequence(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function closingSequence(code) {
    if (code === marker) {
      effects.consume(code)
      return closingSequence
    }

    effects.exit('setextHeadingLineSequence')
    return factorySpace(effects, closingSequenceEnd, 'lineSuffix')(code)
  }
  /** @type {State} */

  function closingSequenceEnd(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('setextHeadingLine')
      return ok(code)
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-html-tag-name/index.js
/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result
 * in more relaxed rules (condition 6): because they are known blocks, the
 * HTML-like syntax doesn’t have to be strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
]

/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result in
 * HTML that can include lines w/o exiting, until a closing tag also in this
 * list is found (condition 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * Note that `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea']

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/html-flow.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */

const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
}
/** @type {Construct} */

const nextBlankConstruct = {
  tokenize: tokenizeNextBlank,
  partial: true
}
/** @type {Resolver} */

function resolveToHtmlFlow(events) {
  let index = events.length

  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break
    }
  }

  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.

    events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.

    events.splice(index - 2, 2)
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this
  /** @type {number} */

  let kind
  /** @type {boolean} */

  let startTag
  /** @type {string} */

  let buffer
  /** @type {number} */

  let index
  /** @type {Code} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlFlow')
    effects.enter('htmlFlowData')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationStart
    }

    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code)
      kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.

      return self.interrupt ? ok : continuationDeclarationInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      buffer = String.fromCharCode(code)
      startTag = true
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationStart(code) {
    if (code === 45) {
      effects.consume(code)
      kind = 2
      return commentOpenInside
    }

    if (code === 91) {
      effects.consume(code)
      kind = 5
      buffer = 'CDATA['
      index = 0
      return cdataOpenInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      kind = 4
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function cdataOpenInside(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code)
      return index === buffer.length
        ? self.interrupt
          ? ok
          : continuation
        : cdataOpenInside
    }

    return nok(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      buffer = String.fromCharCode(code)
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function tagName(code) {
    if (
      code === null ||
      code === 47 ||
      code === 62 ||
      markdownLineEndingOrSpace(code)
    ) {
      if (
        code !== 47 &&
        startTag &&
        htmlRawNames.includes(buffer.toLowerCase())
      ) {
        kind = 1
        return self.interrupt ? ok(code) : continuation(code)
      }

      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        kind = 6

        if (code === 47) {
          effects.consume(code)
          return basicSelfClosing
        }

        return self.interrupt ? ok(code) : continuation(code)
      }

      kind = 7 // Do not support complete HTML when interrupting

      return self.interrupt && !self.parser.lazy[self.now().line]
        ? nok(code)
        : startTag
        ? completeAttributeNameBefore(code)
        : completeClosingTagAfter(code)
    }

    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code)
      return self.interrupt ? ok : continuation
    }

    return nok(code)
  }
  /** @type {State} */

  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeClosingTagAfter
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code)
      return completeEnd
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return completeAttributeName
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameBefore
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return completeAttributeName
    }

    return completeAttributeNameAfter(code)
  }
  /** @type {State} */

  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return completeAttributeValueBefore
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameAfter
    }

    return completeAttributeNameBefore(code)
  }
  /** @type {State} */

  function completeAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return completeAttributeValueQuoted
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeValueBefore
    }

    marker = null
    return completeAttributeValueUnquoted(code)
  }
  /** @type {State} */

  function completeAttributeValueQuoted(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    if (code === marker) {
      effects.consume(code)
      return completeAttributeValueQuotedAfter
    }

    effects.consume(code)
    return completeAttributeValueQuoted
  }
  /** @type {State} */

  function completeAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      markdownLineEndingOrSpace(code)
    ) {
      return completeAttributeNameAfter(code)
    }

    effects.consume(code)
    return completeAttributeValueUnquoted
  }
  /** @type {State} */

  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code)
      return completeAfter
    }

    return nok(code)
  }
  /** @type {State} */

  function completeAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAfter
    }

    return code === null || markdownLineEnding(code)
      ? continuation(code)
      : nok(code)
  }
  /** @type {State} */

  function continuation(code) {
    if (code === 45 && kind === 2) {
      effects.consume(code)
      return continuationCommentInside
    }

    if (code === 60 && kind === 1) {
      effects.consume(code)
      return continuationRawTagOpen
    }

    if (code === 62 && kind === 4) {
      effects.consume(code)
      return continuationClose
    }

    if (code === 63 && kind === 3) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    if (code === 93 && kind === 5) {
      effects.consume(code)
      return continuationCharacterDataInside
    }

    if (markdownLineEnding(code) && (kind === 6 || kind === 7)) {
      return effects.check(
        nextBlankConstruct,
        continuationClose,
        continuationAtLineEnding
      )(code)
    }

    if (code === null || markdownLineEnding(code)) {
      return continuationAtLineEnding(code)
    }

    effects.consume(code)
    return continuation
  }
  /** @type {State} */

  function continuationAtLineEnding(code) {
    effects.exit('htmlFlowData')
    return htmlContinueStart(code)
  }
  /** @type {State} */

  function htmlContinueStart(code) {
    if (code === null) {
      return done(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        {
          tokenize: htmlLineEnd,
          partial: true
        },
        htmlContinueStart,
        done
      )(code)
    }

    effects.enter('htmlFlowData')
    return continuation(code)
  }
  /** @type {Tokenizer} */

  function htmlLineEnd(effects, ok, nok) {
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {State} */

  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code)
      buffer = ''
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawEndTag(code) {
    if (code === 62 && htmlRawNames.includes(buffer.toLowerCase())) {
      effects.consume(code)
      return continuationClose
    }

    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationCharacterDataInside(code) {
    if (code === 93) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code)
      return continuationClose
    } // More dashes.

    if (code === 45 && kind === 2) {
      effects.consume(code)
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return done(code)
    }

    effects.consume(code)
    return continuationClose
  }
  /** @type {State} */

  function done(code) {
    effects.exit('htmlFlow')
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeNextBlank(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.exit('htmlFlowData')
    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    return effects.attempt(blankLine, ok, nok)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/code-fenced.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
}
/** @type {Tokenizer} */

function tokenizeCodeFenced(effects, ok, nok) {
  const self = this
  /** @type {Construct} */

  const closingFenceConstruct = {
    tokenize: tokenizeClosingFence,
    partial: true
  }
  /** @type {Construct} */

  const nonLazyLine = {
    tokenize: tokenizeNonLazyLine,
    partial: true
  }
  const tail = this.events[this.events.length - 1]
  const initialPrefix =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let sizeOpen = 0
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeFenced')
    effects.enter('codeFencedFence')
    effects.enter('codeFencedFenceSequence')
    marker = code
    return sequenceOpen(code)
  }
  /** @type {State} */

  function sequenceOpen(code) {
    if (code === marker) {
      effects.consume(code)
      sizeOpen++
      return sequenceOpen
    }

    effects.exit('codeFencedFenceSequence')
    return sizeOpen < 3
      ? nok(code)
      : factorySpace(effects, infoOpen, 'whitespace')(code)
  }
  /** @type {State} */

  function infoOpen(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceInfo')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return info(code)
  }
  /** @type {State} */

  function info(code) {
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return factorySpace(effects, infoAfter, 'whitespace')(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code)
    return info
  }
  /** @type {State} */

  function infoAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceMeta')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return meta(code)
  }
  /** @type {State} */

  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceMeta')
      return openAfter(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code)
    return meta
  }
  /** @type {State} */

  function openAfter(code) {
    effects.exit('codeFencedFence')
    return self.interrupt ? ok(code) : contentStart(code)
  }
  /** @type {State} */

  function contentStart(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        nonLazyLine,
        effects.attempt(
          closingFenceConstruct,
          after,
          initialPrefix
            ? factorySpace(
                effects,
                contentStart,
                'linePrefix',
                initialPrefix + 1
              )
            : contentStart
        ),
        after
      )(code)
    }

    effects.enter('codeFlowValue')
    return contentContinue(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return contentStart(code)
    }

    effects.consume(code)
    return contentContinue
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeFenced')
    return ok(code)
  }
  /** @type {Tokenizer} */

  function tokenizeNonLazyLine(effects, ok, nok) {
    const self = this
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {Tokenizer} */

  function tokenizeClosingFence(effects, ok, nok) {
    let size = 0
    return factorySpace(
      effects,
      closingSequenceStart,
      'linePrefix',
      this.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
    /** @type {State} */

    function closingSequenceStart(code) {
      effects.enter('codeFencedFence')
      effects.enter('codeFencedFenceSequence')
      return closingSequence(code)
    }
    /** @type {State} */

    function closingSequence(code) {
      if (code === marker) {
        effects.consume(code)
        size++
        return closingSequence
      }

      if (size < sizeOpen) return nok(code)
      effects.exit('codeFencedFenceSequence')
      return factorySpace(effects, closingSequenceEnd, 'whitespace')(code)
    }
    /** @type {State} */

    function closingSequenceEnd(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('codeFencedFence')
        return ok(code)
      }

      return nok(code)
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/decode-named-character-reference/index.dom.js
/// <reference lib="dom" />

/* eslint-env browser */

const index_dom_element = document.createElement('i')

/**
 * @param {string} value
 * @returns {string|false}
 */
function decodeNamedCharacterReference(value) {
  const characterReference = '&' + value + ';'
  index_dom_element.innerHTML = characterReference
  const char = index_dom_element.textContent

  // Some named character references do not require the closing semicolon
  // (`&not`, for instance), which leads to situations where parsing the assumed
  // named reference of `&notit;` will result in the string `¬it;`.
  // When we encounter a trailing semicolon after parsing, and the character
  // reference to decode was not a semicolon (`&semi;`), we can assume that the
  // matching was not complete.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  if (char.charCodeAt(char.length - 1) === 59 /* `;` */ && value !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the character reference was
  // not valid.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  return char === characterReference ? false : char
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/character-reference.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
}
/** @type {Tokenizer} */

function tokenizeCharacterReference(effects, ok, nok) {
  const self = this
  let size = 0
  /** @type {number} */

  let max
  /** @type {(code: Code) => code is number} */

  let test
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterReference')
    effects.enter('characterReferenceMarker')
    effects.consume(code)
    effects.exit('characterReferenceMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric')
      effects.consume(code)
      effects.exit('characterReferenceMarkerNumeric')
      return numeric
    }

    effects.enter('characterReferenceValue')
    max = 31
    test = asciiAlphanumeric
    return value(code)
  }
  /** @type {State} */

  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal')
      effects.consume(code)
      effects.exit('characterReferenceMarkerHexadecimal')
      effects.enter('characterReferenceValue')
      max = 6
      test = asciiHexDigit
      return value
    }

    effects.enter('characterReferenceValue')
    max = 7
    test = asciiDigit
    return value(code)
  }
  /** @type {State} */

  function value(code) {
    /** @type {Token} */
    let token

    if (code === 59 && size) {
      token = effects.exit('characterReferenceValue')

      if (
        test === asciiAlphanumeric &&
        !decodeNamedCharacterReference(self.sliceSerialize(token))
      ) {
        return nok(code)
      }

      effects.enter('characterReferenceMarker')
      effects.consume(code)
      effects.exit('characterReferenceMarker')
      effects.exit('characterReference')
      return ok
    }

    if (test(code) && size++ < max) {
      effects.consume(code)
      return value
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/character-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
}
/** @type {Tokenizer} */

function tokenizeCharacterEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    effects.exit('escapeMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue')
      effects.consume(code)
      effects.exit('characterEscapeValue')
      effects.exit('characterEscape')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/line-ending.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */



/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
}
/** @type {Tokenizer} */

function tokenizeLineEnding(effects, ok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, ok, 'linePrefix')
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/label-end.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */









/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
}
/** @type {Construct} */

const resourceConstruct = {
  tokenize: tokenizeResource
}
/** @type {Construct} */

const fullReferenceConstruct = {
  tokenize: tokenizeFullReference
}
/** @type {Construct} */

const collapsedReferenceConstruct = {
  tokenize: tokenizeCollapsedReference
}
/** @type {Resolver} */

function resolveAllLabelEnd(events) {
  let index = -1
  /** @type {Token} */

  let token

  while (++index < events.length) {
    token = events[index][1]

    if (
      token.type === 'labelImage' ||
      token.type === 'labelLink' ||
      token.type === 'labelEnd'
    ) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2)
      token.type = 'data'
      index++
    }
  }

  return events
}
/** @type {Resolver} */

function resolveToLabelEnd(events, context) {
  let index = events.length
  let offset = 0
  /** @type {Token} */

  let token
  /** @type {number|undefined} */

  let open
  /** @type {number|undefined} */

  let close
  /** @type {Event[]} */

  let media // Find an opening.

  while (index--) {
    token = events[index][1]

    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (
        token.type === 'link' ||
        (token.type === 'labelLink' && token._inactive)
      ) {
        break
      } // Mark other link openings as inactive, as we can’t have links in
      // links.

      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true
      }
    } else if (close) {
      if (
        events[index][0] === 'enter' &&
        (token.type === 'labelImage' || token.type === 'labelLink') &&
        !token._balanced
      ) {
        open = index

        if (token.type !== 'labelLink') {
          offset = 2
          break
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index
    }
  }

  const group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  const label = {
    type: 'label',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  }
  const text = {
    type: 'labelText',
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  }
  media = [
    ['enter', group, context],
    ['enter', label, context]
  ] // Opening marker.

  media = push(media, events.slice(open + 1, open + offset + 3)) // Text open.

  media = push(media, [['enter', text, context]]) // Between.

  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  ) // Text close, marker close, label close.

  media = push(media, [
    ['exit', text, context],
    events[close - 2],
    events[close - 1],
    ['exit', label, context]
  ]) // Reference, resource, or so.

  media = push(media, events.slice(close + 1)) // Media close.

  media = push(media, [['exit', group, context]])
  splice(events, open, events.length, media)
  return events
}
/** @type {Tokenizer} */

function tokenizeLabelEnd(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Token} */

  let labelStart
  /** @type {boolean} */

  let defined // Find an opening.

  while (index--) {
    if (
      (self.events[index][1].type === 'labelImage' ||
        self.events[index][1].type === 'labelLink') &&
      !self.events[index][1]._balanced
    ) {
      labelStart = self.events[index][1]
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!labelStart) {
      return nok(code)
    } // It’s a balanced bracket, but contains a link.

    if (labelStart._inactive) return balanced(code)
    defined = self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize({
          start: labelStart.end,
          end: self.now()
        })
      )
    )
    effects.enter('labelEnd')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelEnd')
    return afterLabelEnd
  }
  /** @type {State} */

  function afterLabelEnd(code) {
    // Resource: `[asd](fgh)`.
    if (code === 40) {
      return effects.attempt(
        resourceConstruct,
        ok,
        defined ? ok : balanced
      )(code)
    } // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?

    if (code === 91) {
      return effects.attempt(
        fullReferenceConstruct,
        ok,
        defined
          ? effects.attempt(collapsedReferenceConstruct, ok, balanced)
          : balanced
      )(code)
    } // Shortcut reference: `[asd]`?

    return defined ? ok(code) : balanced(code)
  }
  /** @type {State} */

  function balanced(code) {
    labelStart._balanced = true
    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeResource(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('resource')
    effects.enter('resourceMarker')
    effects.consume(code)
    effects.exit('resourceMarker')
    return factoryWhitespace(effects, open)
  }
  /** @type {State} */

  function open(code) {
    if (code === 41) {
      return end(code)
    }

    return factoryDestination(
      effects,
      destinationAfter,
      nok,
      'resourceDestination',
      'resourceDestinationLiteral',
      'resourceDestinationLiteralMarker',
      'resourceDestinationRaw',
      'resourceDestinationString',
      32
    )(code)
  }
  /** @type {State} */

  function destinationAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, between)(code)
      : end(code)
  }
  /** @type {State} */

  function between(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factoryWhitespace(effects, end),
        nok,
        'resourceTitle',
        'resourceTitleMarker',
        'resourceTitleString'
      )(code)
    }

    return end(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 41) {
      effects.enter('resourceMarker')
      effects.consume(code)
      effects.exit('resourceMarker')
      effects.exit('resource')
      return ok
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeFullReference(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    return factoryLabel.call(
      self,
      effects,
      afterLabel,
      nok,
      'reference',
      'referenceMarker',
      'referenceString'
    )(code)
  }
  /** @type {State} */

  function afterLabel(code) {
    return self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
      )
    )
      ? ok(code)
      : nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeCollapsedReference(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('reference')
    effects.enter('referenceMarker')
    effects.consume(code)
    effects.exit('referenceMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 93) {
      effects.enter('referenceMarker')
      effects.consume(code)
      effects.exit('referenceMarker')
      effects.exit('reference')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/label-start-image.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */

const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
}
/** @type {Tokenizer} */

function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelImage')
    effects.enter('labelImageMarker')
    effects.consume(code)
    effects.exit('labelImageMarker')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker')
      effects.consume(code)
      effects.exit('labelMarker')
      effects.exit('labelImage')
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-classify-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */


/**
 * Classify whether a character code represents whitespace, punctuation, or
 * something else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * Note that eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 * @returns {number|undefined}
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }

  if (unicodePunctuation(code)) {
    return 2
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/attention.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Point} Point
 */




/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
}
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */

function resolveAllAttention(events, context) {
  let index = -1
  /** @type {number} */

  let open
  /** @type {Token} */

  let group
  /** @type {Token} */

  let text
  /** @type {Token} */

  let openingSequence
  /** @type {Token} */

  let closingSequence
  /** @type {number} */

  let use
  /** @type {Event[]} */

  let nextEvents
  /** @type {number} */

  let offset // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.

  while (++index < events.length) {
    // Find a token that can close.
    if (
      events[index][0] === 'enter' &&
      events[index][1].type === 'attentionSequence' &&
      events[index][1]._close
    ) {
      open = index // Now walk back to find an opener.

      while (open--) {
        // Find a token that can open the closer.
        if (
          events[open][0] === 'exit' &&
          events[open][1].type === 'attentionSequence' &&
          events[open][1]._open && // If the markers are the same:
          context.sliceSerialize(events[open][1]).charCodeAt(0) ===
            context.sliceSerialize(events[index][1]).charCodeAt(0)
        ) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if (
            (events[open][1]._close || events[index][1]._open) &&
            (events[index][1].end.offset - events[index][1].start.offset) % 3 &&
            !(
              (events[open][1].end.offset -
                events[open][1].start.offset +
                events[index][1].end.offset -
                events[index][1].start.offset) %
              3
            )
          ) {
            continue
          } // Number of markers to use from the sequence.

          use =
            events[open][1].end.offset - events[open][1].start.offset > 1 &&
            events[index][1].end.offset - events[index][1].start.offset > 1
              ? 2
              : 1
          const start = Object.assign({}, events[open][1].end)
          const end = Object.assign({}, events[index][1].start)
          movePoint(start, -use)
          movePoint(end, use)
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start,
            end: Object.assign({}, events[open][1].end)
          }
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: Object.assign({}, events[index][1].start),
            end
          }
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          }
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          }
          events[open][1].end = Object.assign({}, openingSequence.start)
          events[index][1].start = Object.assign({}, closingSequence.end)
          nextEvents = [] // If there are more markers in the opening, add them before.

          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ['enter', events[open][1], context],
              ['exit', events[open][1], context]
            ])
          } // Opening.

          nextEvents = push(nextEvents, [
            ['enter', group, context],
            ['enter', openingSequence, context],
            ['exit', openingSequence, context],
            ['enter', text, context]
          ]) // Between.

          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          ) // Closing.

          nextEvents = push(nextEvents, [
            ['exit', text, context],
            ['enter', closingSequence, context],
            ['exit', closingSequence, context],
            ['exit', group, context]
          ]) // If there are more markers in the closing, add them after.

          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2
            nextEvents = push(nextEvents, [
              ['enter', events[index][1], context],
              ['exit', events[index][1], context]
            ])
          } else {
            offset = 0
          }

          splice(events, open - 1, index - open + 3, nextEvents)
          index = open + nextEvents.length - offset - 2
          break
        }
      }
    }
  } // Remove remaining sequences.

  index = -1

  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data'
    }
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null
  const previous = this.previous
  const before = classifyCharacter(previous)
  /** @type {NonNullable<Code>} */

  let marker
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('attentionSequence')
    marker = code
    return sequence(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      return sequence
    }

    const token = effects.exit('attentionSequence')
    const after = classifyCharacter(code)
    const open =
      !after || (after === 2 && before) || attentionMarkers.includes(code)
    const close =
      !before || (before === 2 && after) || attentionMarkers.includes(previous)
    token._open = Boolean(marker === 42 ? open : open && (before || !close))
    token._close = Boolean(marker === 42 ? close : close && (after || !open))
    return ok(code)
  }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */

function movePoint(point, offset) {
  point.column += offset
  point.offset += offset
  point._bufferIndex += offset
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/autolink.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
}
/** @type {Tokenizer} */

function tokenizeAutolink(effects, ok, nok) {
  let size = 1
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('autolink')
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.enter('autolinkProtocol')
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return schemeOrEmailAtext
    }

    return asciiAtext(code) ? emailAtext(code) : nok(code)
  }
  /** @type {State} */

  function schemeOrEmailAtext(code) {
    return code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)
      ? schemeInsideOrEmailAtext(code)
      : emailAtext(code)
  }
  /** @type {State} */

  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code)
      return urlInside
    }

    if (
      (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) &&
      size++ < 32
    ) {
      effects.consume(code)
      return schemeInsideOrEmailAtext
    }

    return emailAtext(code)
  }
  /** @type {State} */

  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol')
      return end(code)
    }

    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code)
    }

    effects.consume(code)
    return urlInside
  }
  /** @type {State} */

  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }

    if (asciiAtext(code)) {
      effects.consume(code)
      return emailAtext
    }

    return nok(code)
  }
  /** @type {State} */

  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code)
  }
  /** @type {State} */

  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }

    if (code === 62) {
      // Exit, then change the type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail'
      return end(code)
    }

    return emailValue(code)
  }
  /** @type {State} */

  function emailValue(code) {
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      effects.consume(code)
      return code === 45 ? emailValue : emailLabel
    }

    return nok(code)
  }
  /** @type {State} */

  function end(code) {
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.exit('autolink')
    return ok
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/html-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */



/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
}
/** @type {Tokenizer} */

function tokenizeHtmlText(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code>|undefined} */

  let marker
  /** @type {string} */

  let buffer
  /** @type {number} */

  let index
  /** @type {State} */

  let returnState
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlText')
    effects.enter('htmlTextData')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }

    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code)
      return instruction
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentOpen
    }

    if (code === 91) {
      effects.consume(code)
      buffer = 'CDATA['
      index = 0
      return cdataOpen
    }

    if (asciiAlpha(code)) {
      effects.consume(code)
      return declaration
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentStart
    }

    return nok(code)
  }
  /** @type {State} */

  function commentStart(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code)
      return commentStartDash
    }

    return comment(code)
  }
  /** @type {State} */

  function commentStartDash(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    return comment(code)
  }
  /** @type {State} */

  function comment(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code)
      return commentClose
    }

    if (markdownLineEnding(code)) {
      returnState = comment
      return atLineEnding(code)
    }

    effects.consume(code)
    return comment
  }
  /** @type {State} */

  function commentClose(code) {
    if (code === 45) {
      effects.consume(code)
      return end
    }

    return comment(code)
  }
  /** @type {State} */

  function cdataOpen(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code)
      return index === buffer.length ? cdata : cdataOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function cdata(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 93) {
      effects.consume(code)
      return cdataClose
    }

    if (markdownLineEnding(code)) {
      returnState = cdata
      return atLineEnding(code)
    }

    effects.consume(code)
    return cdata
  }
  /** @type {State} */

  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function cdataEnd(code) {
    if (code === 62) {
      return end(code)
    }

    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function declaration(code) {
    if (code === null || code === 62) {
      return end(code)
    }

    if (markdownLineEnding(code)) {
      returnState = declaration
      return atLineEnding(code)
    }

    effects.consume(code)
    return declaration
  }
  /** @type {State} */

  function instruction(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 63) {
      effects.consume(code)
      return instructionClose
    }

    if (markdownLineEnding(code)) {
      returnState = instruction
      return atLineEnding(code)
    }

    effects.consume(code)
    return instruction
  }
  /** @type {State} */

  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagClose
    }

    return nok(code)
  }
  /** @type {State} */

  function tagClose(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagClose
    }

    return tagCloseBetween(code)
  }
  /** @type {State} */

  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagCloseBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpen(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagOpen
    }

    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code)
      return end
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return tagOpenAttributeName
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpenAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return tagOpenAttributeName
    }

    return tagOpenAttributeNameAfter(code)
  }
  /** @type {State} */

  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeNameAfter
    }

    return tagOpenBetween(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return tagOpenAttributeValueQuoted
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }

    effects.consume(code)
    marker = undefined
    return tagOpenAttributeValueUnquoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code)
      return tagOpenAttributeValueQuotedAfter
    }

    if (code === null) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted
      return atLineEnding(code)
    }

    effects.consume(code)
    return tagOpenAttributeValueQuoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 62 || code === 47 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  } // We can’t have blank lines in content, so no need to worry about empty
  // tokens.

  /** @type {State} */

  function atLineEnding(code) {
    effects.exit('htmlTextData')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(
      effects,
      afterPrefix,
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
  }
  /** @type {State} */

  function afterPrefix(code) {
    effects.enter('htmlTextData')
    return returnState(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 62) {
      effects.consume(code)
      effects.exit('htmlTextData')
      effects.exit('htmlText')
      return ok
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/label-start-link.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */

const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
}
/** @type {Tokenizer} */

function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelLink')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelLink')
    return after
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook. */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/hard-break-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
}
/** @type {Tokenizer} */

function tokenizeHardBreakEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('hardBreakEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    return open
  }
  /** @type {State} */

  function open(code) {
    if (markdownLineEnding(code)) {
      effects.exit('escapeMarker')
      effects.exit('hardBreakEscape')
      return ok(code)
    }

    return nok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-core-commonmark/lib/code-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */


/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
}
/** @type {Resolver} */

function resolveCodeText(events) {
  let tailExitIndex = events.length - 4
  let headEnterIndex = 3
  /** @type {number} */

  let index
  /** @type {number|undefined} */

  let enter // If we start and end with an EOL or a space.

  if (
    (events[headEnterIndex][1].type === 'lineEnding' ||
      events[headEnterIndex][1].type === 'space') &&
    (events[tailExitIndex][1].type === 'lineEnding' ||
      events[tailExitIndex][1].type === 'space')
  ) {
    index = headEnterIndex // And we have data.

    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[headEnterIndex][1].type = 'codeTextPadding'
        events[tailExitIndex][1].type = 'codeTextPadding'
        headEnterIndex += 2
        tailExitIndex -= 2
        break
      }
    }
  } // Merge adjacent spaces and data.

  index = headEnterIndex - 1
  tailExitIndex++

  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index
      }
    } else if (
      index === tailExitIndex ||
      events[index][1].type === 'lineEnding'
    ) {
      events[enter][1].type = 'codeTextData'

      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end
        events.splice(enter + 2, index - enter - 2)
        tailExitIndex -= index - enter - 2
        index = enter + 2
      }

      enter = undefined
    }
  }

  return events
}
/** @type {Previous} */

function previous(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 96 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}
/** @type {Tokenizer} */

function tokenizeCodeText(effects, ok, nok) {
  const self = this
  let sizeOpen = 0
  /** @type {number} */

  let size
  /** @type {Token} */

  let token
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeText')
    effects.enter('codeTextSequence')
    return openingSequence(code)
  }
  /** @type {State} */

  function openingSequence(code) {
    if (code === 96) {
      effects.consume(code)
      sizeOpen++
      return openingSequence
    }

    effects.exit('codeTextSequence')
    return gap(code)
  }
  /** @type {State} */

  function gap(code) {
    // EOF.
    if (code === null) {
      return nok(code)
    } // Closing fence?
    // Could also be data.

    if (code === 96) {
      token = effects.enter('codeTextSequence')
      size = 0
      return closingSequence(code)
    } // Tabs don’t work, and virtual spaces don’t make sense.

    if (code === 32) {
      effects.enter('space')
      effects.consume(code)
      effects.exit('space')
      return gap
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return gap
    } // Data.

    effects.enter('codeTextData')
    return data(code)
  } // In code.

  /** @type {State} */

  function data(code) {
    if (
      code === null ||
      code === 32 ||
      code === 96 ||
      markdownLineEnding(code)
    ) {
      effects.exit('codeTextData')
      return gap(code)
    }

    effects.consume(code)
    return data
  } // Closing fence.

  /** @type {State} */

  function closingSequence(code) {
    // More.
    if (code === 96) {
      effects.consume(code)
      size++
      return closingSequence
    } // Done!

    if (size === sizeOpen) {
      effects.exit('codeTextSequence')
      effects.exit('codeText')
      return ok(code)
    } // More or less accents: mark as data.

    token.type = 'codeTextData'
    return data(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/constructs.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */


/** @type {Extension['document']} */

const constructs_document = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
}
/** @type {Extension['contentInitial']} */

const contentInitial = {
  [91]: definition
}
/** @type {Extension['flowInitial']} */

const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
}
/** @type {Extension['flow']} */

const constructs_flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
}
/** @type {Extension['string']} */

const constructs_string = {
  [38]: characterReference,
  [92]: characterEscape
}
/** @type {Extension['text']} */

const constructs_text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
}
/** @type {Extension['insideSpan']} */

const insideSpan = {
  null: [attention, resolver]
}
/** @type {Extension['attentionMarkers']} */

const attentionMarkers = {
  null: [42, 95]
}
/** @type {Extension['disable']} */

const disable = {
  null: []
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/parse.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Create} Create
 */







/**
 * @param {ParseOptions} [options]
 * @returns {ParseContext}
 */

function parse(options = {}) {
  /** @type {FullNormalizedExtension} */
  // @ts-expect-error `defaultConstructs` is full, so the result will be too.
  const constructs = combineExtensions(
    // @ts-expect-error Same as above.
    [constructs_namespaceObject].concat(options.extensions || [])
  )
  /** @type {ParseContext} */

  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content),
    document: create(document_document),
    flow: create(flow),
    string: create(string),
    text: create(text_text)
  }
  return parser
  /**
   * @param {InitialConstruct} initial
   */

  function create(initial) {
    return creator
    /** @type {Create} */

    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/preprocess.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding} [encoding]
 * @param {boolean} [end=false]
 * @returns {Array<Chunk>}
 */
const search = /[\0\t\n\r]/g
/**
 * @returns {Preprocessor}
 */

function preprocess() {
  let column = 1
  let buffer = ''
  /** @type {boolean|undefined} */

  let start = true
  /** @type {boolean|undefined} */

  let atCarriageReturn
  return preprocessor
  /** @type {Preprocessor} */

  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = []
    /** @type {RegExpMatchArray|null} */

    let match
    /** @type {number} */

    let next
    /** @type {number} */

    let startPosition
    /** @type {number} */

    let endPosition
    /** @type {Code} */

    let code // @ts-expect-error `Buffer` does allow an encoding.

    value = buffer + value.toString(encoding)
    startPosition = 0
    buffer = ''

    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++
      }

      start = undefined
    }

    while (startPosition < value.length) {
      search.lastIndex = startPosition
      match = search.exec(value)
      endPosition =
        match && match.index !== undefined ? match.index : value.length
      code = value.charCodeAt(endPosition)

      if (!match) {
        buffer = value.slice(startPosition)
        break
      }

      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3)
        atCarriageReturn = undefined
      } else {
        if (atCarriageReturn) {
          chunks.push(-5)
          atCarriageReturn = undefined
        }

        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition))
          column += endPosition - startPosition
        }

        switch (code) {
          case 0: {
            chunks.push(65533)
            column++
            break
          }

          case 9: {
            next = Math.ceil(column / 4) * 4
            chunks.push(-2)

            while (column++ < next) chunks.push(-1)

            break
          }

          case 10: {
            chunks.push(-4)
            column = 1
            break
          }

          default: {
            atCarriageReturn = true
            column = 1
          }
        }
      }

      startPosition = endPosition + 1
    }

    if (end) {
      if (atCarriageReturn) chunks.push(-5)
      if (buffer) chunks.push(buffer)
      chunks.push(null)
    }

    return chunks
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark/lib/postprocess.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @param {Array<Event>} events
 * @returns {Array<Event>}
 */

function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }

  return events
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-decode-numeric-character-reference/index.js
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base)

  if (
    // C0 except for HT, LF, FF, CR, space
    code < 9 ||
    code === 11 ||
    (code > 13 && code < 32) || // Control character (DEL) of the basic block and C1 controls.
    (code > 126 && code < 160) || // Lone high surrogates and low surrogates.
    (code > 55295 && code < 57344) || // Noncharacters.
    (code > 64975 && code < 65008) ||
    (code & 65535) === 65535 ||
    (code & 65535) === 65534 || // Out of range
    code > 1114111
  ) {
    return '\uFFFD'
  }

  return String.fromCharCode(code)
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-decode-string/index.js


const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi
/**
 * Utility to decode markdown strings (which occur in places such as fenced
 * code info strings, destinations, labels, and titles).
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 * @returns {string}
 */

function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode)
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */

function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  } // Reference.

  const head = $2.charCodeAt(0)

  if (head === 35) {
    const head = $2.charCodeAt(1)
    const hex = head === 120 || head === 88
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }

  return decodeNamedCharacterReference($2) || $0
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-from-markdown/lib/index.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {UnistParent & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */

/**
 * @typedef _CompileDataFields
 * @property {boolean|undefined} expectingFirstListItemValue
 * @property {boolean|undefined} flowCodeInside
 * @property {boolean|undefined} setextHeadingSlurpLineEnding
 * @property {boolean|undefined} atHardBreak
 * @property {'collapsed'|'full'} referenceType
 * @property {boolean|undefined} inReference
 * @property {'characterReferenceMarkerHexadecimal'|'characterReferenceMarkerNumeric'} characterReferenceType
 *
 * @typedef {Record<string, unknown> & Partial<_CompileDataFields>} CompileData
 *
 * @typedef {(tree: Root) => Root|void} Transform
 * @typedef {(this: CompileContext, token: Token) => void} Handle
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 * @typedef {Record<string, Record<string, unknown>|Array<unknown>> & {canContainEols: Array<string>, transforms: Array<Transform>, enter: Handles, exit: Handles}} NormalizedExtension
 * @typedef {Partial<NormalizedExtension>} Extension
 *   An mdast extension changes how markdown tokens are turned into mdast.
 *
 * @typedef {(this: Omit<CompileContext, 'sliceSerialize'>, left: Token|undefined, right: Token) => void} OnEnterError
 * @typedef {(this: Omit<CompileContext, 'sliceSerialize'>, left: Token, right: Token) => void} OnExitError
 *
 * @typedef CompileContext
 *   mdast compiler context
 * @property {Array<Node | Fragment>} stack
 * @property {Array<[Token, OnEnterError|undefined]>} tokenStack
 * @property {(key: string, value?: unknown) => void} setData
 *   Set data into the key-value store.
 * @property {<K extends string>(key: K) => CompileData[K]} getData
 *   Get data from the key-value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<N extends Node>(this: CompileContext, node: N, token: Token, onError?: OnEnterError) => N} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {NormalizedExtension} config
 *   Configuration.
 *
 * @typedef {{mdastExtensions?: Array<Extension|Array<Extension>>}} FromMarkdownOptions
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 */









const lib_own = {}.hasOwnProperty
/**
 * @param value Markdown to parse (`string` or `Buffer`).
 * @param [encoding] Character encoding to understand `value` as when it’s a `Buffer` (`string`, default: `'utf8'`).
 * @param [options] Configuration
 */

const fromMarkdown =
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options) => Root) &
   *   ((value: Value, options?: Options) => Root)
   * )}
   */

  /**
   * @param {Value} value
   * @param {Encoding} [encoding]
   * @param {Options} [options]
   * @returns {Root}
   */
  function (value, encoding, options) {
    if (typeof encoding !== 'string') {
      options = encoding
      encoding = undefined
    }

    return compiler(options)(
      postprocess(
        parse(options).document().write(preprocess()(value, encoding, true))
      )
    )
  }
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options} [options]
 */

function compiler(options = {}) {
  /** @type {NormalizedExtension} */
  // @ts-expect-error: our base has all required fields, so the result will too.
  const config = configure(
    {
      transforms: [],
      canContainEols: [
        'emphasis',
        'fragment',
        'heading',
        'paragraph',
        'strong'
      ],
      enter: {
        autolink: opener(link),
        autolinkProtocol: onenterdata,
        autolinkEmail: onenterdata,
        atxHeading: opener(heading),
        blockQuote: opener(blockQuote),
        characterEscape: onenterdata,
        characterReference: onenterdata,
        codeFenced: opener(codeFlow),
        codeFencedFenceInfo: buffer,
        codeFencedFenceMeta: buffer,
        codeIndented: opener(codeFlow, buffer),
        codeText: opener(codeText, buffer),
        codeTextData: onenterdata,
        data: onenterdata,
        codeFlowValue: onenterdata,
        definition: opener(definition),
        definitionDestinationString: buffer,
        definitionLabelString: buffer,
        definitionTitleString: buffer,
        emphasis: opener(emphasis),
        hardBreakEscape: opener(hardBreak),
        hardBreakTrailing: opener(hardBreak),
        htmlFlow: opener(html, buffer),
        htmlFlowData: onenterdata,
        htmlText: opener(html, buffer),
        htmlTextData: onenterdata,
        image: opener(image),
        label: buffer,
        link: opener(link),
        listItem: opener(listItem),
        listItemValue: onenterlistitemvalue,
        listOrdered: opener(list, onenterlistordered),
        listUnordered: opener(list),
        paragraph: opener(paragraph),
        reference: onenterreference,
        referenceString: buffer,
        resourceDestinationString: buffer,
        resourceTitleString: buffer,
        setextHeading: opener(heading),
        strong: opener(strong),
        thematicBreak: opener(thematicBreak)
      },
      exit: {
        atxHeading: closer(),
        atxHeadingSequence: onexitatxheadingsequence,
        autolink: closer(),
        autolinkEmail: onexitautolinkemail,
        autolinkProtocol: onexitautolinkprotocol,
        blockQuote: closer(),
        characterEscapeValue: onexitdata,
        characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
        characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
        characterReferenceValue: onexitcharacterreferencevalue,
        codeFenced: closer(onexitcodefenced),
        codeFencedFence: onexitcodefencedfence,
        codeFencedFenceInfo: onexitcodefencedfenceinfo,
        codeFencedFenceMeta: onexitcodefencedfencemeta,
        codeFlowValue: onexitdata,
        codeIndented: closer(onexitcodeindented),
        codeText: closer(onexitcodetext),
        codeTextData: onexitdata,
        data: onexitdata,
        definition: closer(),
        definitionDestinationString: onexitdefinitiondestinationstring,
        definitionLabelString: onexitdefinitionlabelstring,
        definitionTitleString: onexitdefinitiontitlestring,
        emphasis: closer(),
        hardBreakEscape: closer(onexithardbreak),
        hardBreakTrailing: closer(onexithardbreak),
        htmlFlow: closer(onexithtmlflow),
        htmlFlowData: onexitdata,
        htmlText: closer(onexithtmltext),
        htmlTextData: onexitdata,
        image: closer(onexitimage),
        label: onexitlabel,
        labelText: onexitlabeltext,
        lineEnding: onexitlineending,
        link: closer(onexitlink),
        listItem: closer(),
        listOrdered: closer(),
        listUnordered: closer(),
        paragraph: closer(),
        referenceString: onexitreferencestring,
        resourceDestinationString: onexitresourcedestinationstring,
        resourceTitleString: onexitresourcetitlestring,
        resource: onexitresource,
        setextHeading: closer(onexitsetextheading),
        setextHeadingLineSequence: onexitsetextheadinglinesequence,
        setextHeadingText: onexitsetextheadingtext,
        strong: closer(),
        thematicBreak: closer()
      }
    },
    options.mdastExtensions || []
  )
  /** @type {CompileData} */

  const data = {}
  return compile
  /**
   * @param {Array<Event>} events
   * @returns {Root}
   */

  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    }
    /** @type {CompileContext['stack']} */

    const stack = [tree]
    /** @type {CompileContext['tokenStack']} */

    const tokenStack = []
    /** @type {Array<number>} */

    const listStack = []
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */

    const context = {
      stack,
      tokenStack,
      config,
      enter,
      exit,
      buffer,
      resume,
      setData,
      getData
    }
    let index = -1

    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (
        events[index][1].type === 'listOrdered' ||
        events[index][1].type === 'listUnordered'
      ) {
        if (events[index][0] === 'enter') {
          listStack.push(index)
        } else {
          const tail = listStack.pop()
          index = prepareList(events, tail, index)
        }
      }
    }

    index = -1

    while (++index < events.length) {
      const handler = config[events[index][0]]

      if (lib_own.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index][2].sliceSerialize
            },
            context
          ),
          events[index][1]
        )
      }
    }

    if (tokenStack.length > 0) {
      const tail = tokenStack[tokenStack.length - 1]
      const handler = tail[1] || defaultOnError
      handler.call(context, undefined, tail[0])
    } // Figure out `root` position.

    tree.position = {
      start: point(
        events.length > 0
          ? events[0][1].start
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      ),
      end: point(
        events.length > 0
          ? events[events.length - 2][1].end
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      )
    }
    index = -1

    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree
    }

    return tree
  }
  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */

  function prepareList(events, start, length) {
    let index = start - 1
    let containerBalance = -1
    let listSpread = false
    /** @type {Token|undefined} */

    let listItem
    /** @type {number|undefined} */

    let lineIndex
    /** @type {number|undefined} */

    let firstBlankLineIndex
    /** @type {boolean|undefined} */

    let atMarker

    while (++index <= length) {
      const event = events[index]

      if (
        event[1].type === 'listUnordered' ||
        event[1].type === 'listOrdered' ||
        event[1].type === 'blockQuote'
      ) {
        if (event[0] === 'enter') {
          containerBalance++
        } else {
          containerBalance--
        }

        atMarker = undefined
      } else if (event[1].type === 'lineEndingBlank') {
        if (event[0] === 'enter') {
          if (
            listItem &&
            !atMarker &&
            !containerBalance &&
            !firstBlankLineIndex
          ) {
            firstBlankLineIndex = index
          }

          atMarker = undefined
        }
      } else if (
        event[1].type === 'linePrefix' ||
        event[1].type === 'listItemValue' ||
        event[1].type === 'listItemMarker' ||
        event[1].type === 'listItemPrefix' ||
        event[1].type === 'listItemPrefixWhitespace'
      ) {
        // Empty.
      } else {
        atMarker = undefined
      }

      if (
        (!containerBalance &&
          event[0] === 'enter' &&
          event[1].type === 'listItemPrefix') ||
        (containerBalance === -1 &&
          event[0] === 'exit' &&
          (event[1].type === 'listUnordered' ||
            event[1].type === 'listOrdered'))
      ) {
        if (listItem) {
          let tailIndex = index
          lineIndex = undefined

          while (tailIndex--) {
            const tailEvent = events[tailIndex]

            if (
              tailEvent[1].type === 'lineEnding' ||
              tailEvent[1].type === 'lineEndingBlank'
            ) {
              if (tailEvent[0] === 'exit') continue

              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank'
                listSpread = true
              }

              tailEvent[1].type = 'lineEnding'
              lineIndex = tailIndex
            } else if (
              tailEvent[1].type === 'linePrefix' ||
              tailEvent[1].type === 'blockQuotePrefix' ||
              tailEvent[1].type === 'blockQuotePrefixWhitespace' ||
              tailEvent[1].type === 'blockQuoteMarker' ||
              tailEvent[1].type === 'listItemIndent'
            ) {
              // Empty
            } else {
              break
            }
          }

          if (
            firstBlankLineIndex &&
            (!lineIndex || firstBlankLineIndex < lineIndex)
          ) {
            // @ts-expect-error Patched.
            listItem._spread = true
          } // Fix position.

          listItem.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          )
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]])
          index++
          length++
        } // Create a new list item.

        if (event[1].type === 'listItemPrefix') {
          listItem = {
            type: 'listItem',
            // @ts-expect-error Patched
            _spread: false,
            start: Object.assign({}, event[1].start)
          } // @ts-expect-error: `listItem` is most definitely defined, TS...

          events.splice(index, 0, ['enter', listItem, event[2]])
          index++
          length++
          firstBlankLineIndex = undefined
          atMarker = true
        }
      }
    } // @ts-expect-error Patched.

    events[start][1]._spread = listSpread
    return length
  }
  /**
   * @type {CompileContext['setData']}
   * @param [value]
   */

  function setData(key, value) {
    data[key] = value
  }
  /**
   * @type {CompileContext['getData']}
   * @template {string} K
   * @param {K} key
   * @returns {CompileData[K]}
   */

  function getData(key) {
    return data[key]
  }
  /**
   * @param {Point} d
   * @returns {Point}
   */

  function point(d) {
    return {
      line: d.line,
      column: d.column,
      offset: d.offset
    }
  }
  /**
   * @param {(token: Token) => Node} create
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function opener(create, and) {
    return open
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function open(token) {
      enter.call(this, create(token), token)
      if (and) and.call(this, token)
    }
  }
  /** @type {CompileContext['buffer']} */

  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    })
  }
  /**
   * @type {CompileContext['enter']}
   * @template {Node} N
   * @this {CompileContext}
   * @param {N} node
   * @param {Token} token
   * @param {OnEnterError} [errorHandler]
   * @returns {N}
   */

  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1]
    // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
    parent.children.push(node)
    this.stack.push(node)
    this.tokenStack.push([token, errorHandler]) // @ts-expect-error: `end` will be patched later.

    node.position = {
      start: point(token.start)
    }
    return node
  }
  /**
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function closer(and) {
    return close
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function close(token) {
      if (and) and.call(this, token)
      exit.call(this, token)
    }
  }
  /**
   * @type {CompileContext['exit']}
   * @this {CompileContext}
   * @param {Token} token
   * @param {OnExitError} [onExitError]
   * @returns {Node}
   */

  function exit(token, onExitError) {
    const node = this.stack.pop()
    const open = this.tokenStack.pop()

    if (!open) {
      throw new Error(
        'Cannot close `' +
          token.type +
          '` (' +
          stringifyPosition({
            start: token.start,
            end: token.end
          }) +
          '): it’s not open'
      )
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0])
      } else {
        const handler = open[1] || defaultOnError
        handler.call(this, token, open[0])
      }
    }

    node.position.end = point(token.end)
    return node
  }
  /**
   * @this {CompileContext}
   * @returns {string}
   */

  function resume() {
    return mdast_util_to_string_toString(this.stack.pop())
  } //
  // Handlers.
  //

  /** @type {Handle} */

  function onenterlistordered() {
    setData('expectingFirstListItemValue', true)
  }
  /** @type {Handle} */

  function onenterlistitemvalue(token) {
    if (getData('expectingFirstListItemValue')) {
      const ancestor =
        /** @type {List} */
        this.stack[this.stack.length - 2]
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10)
      setData('expectingFirstListItemValue')
    }
  }
  /** @type {Handle} */

  function onexitcodefencedfenceinfo() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.lang = data
  }
  /** @type {Handle} */

  function onexitcodefencedfencemeta() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.meta = data
  }
  /** @type {Handle} */

  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (getData('flowCodeInside')) return
    this.buffer()
    setData('flowCodeInside', true)
  }
  /** @type {Handle} */

  function onexitcodefenced() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '')
    setData('flowCodeInside')
  }
  /** @type {Handle} */

  function onexitcodeindented() {
    const data = this.resume()
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1]
    node.value = data.replace(/(\r?\n|\r)$/g, '')
  }
  /** @type {Handle} */

  function onexitdefinitionlabelstring(token) {
    // Discard label, use the source content instead.
    const label = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }
  /** @type {Handle} */

  function onexitdefinitiontitlestring() {
    const data = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.title = data
  }
  /** @type {Handle} */

  function onexitdefinitiondestinationstring() {
    const data = this.resume()
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1]
    node.url = data
  }
  /** @type {Handle} */

  function onexitatxheadingsequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1]

    if (!node.depth) {
      const depth = this.sliceSerialize(token).length
      node.depth = depth
    }
  }
  /** @type {Handle} */

  function onexitsetextheadingtext() {
    setData('setextHeadingSlurpLineEnding', true)
  }
  /** @type {Handle} */

  function onexitsetextheadinglinesequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1]
    node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2
  }
  /** @type {Handle} */

  function onexitsetextheading() {
    setData('setextHeadingSlurpLineEnding')
  }
  /** @type {Handle} */

  function onenterdata(token) {
    const parent =
      /** @type {Parent} */
      this.stack[this.stack.length - 1]
    /** @type {Node} */

    let tail = parent.children[parent.children.length - 1]

    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text() // @ts-expect-error: we’ll add `end` later.

      tail.position = {
        start: point(token.start)
      } // @ts-expect-error: Assume `parent` accepts `text`.

      parent.children.push(tail)
    }

    this.stack.push(tail)
  }
  /** @type {Handle} */

  function onexitdata(token) {
    const tail = this.stack.pop()
    tail.value += this.sliceSerialize(token)
    tail.position.end = point(token.end)
  }
  /** @type {Handle} */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1]

    // If we’re at a hard break, include the line ending in there.
    if (getData('atHardBreak')) {
      const tail = context.children[context.children.length - 1]
      tail.position.end = point(token.end)
      setData('atHardBreak')
      return
    }

    if (
      !getData('setextHeadingSlurpLineEnding') &&
      config.canContainEols.includes(context.type)
    ) {
      onenterdata.call(this, token)
      onexitdata.call(this, token)
    }
  }
  /** @type {Handle} */

  function onexithardbreak() {
    setData('atHardBreak', true)
  }
  /** @type {Handle} */

  function onexithtmlflow() {
    const data = this.resume()
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexithtmltext() {
    const data = this.resume()
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexitcodetext() {
    const data = this.resume()
    const node =
      /** @type {InlineCode} */
      this.stack[this.stack.length - 1]
    node.value = data
  }
  /** @type {Handle} */

  function onexitlink() {
    const context =
      /** @type {Link & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference' // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut' // @ts-expect-error: mutate.

      delete context.url
      delete context.title
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier // @ts-expect-error: mutate.

      delete context.label
    }

    setData('referenceType')
  }
  /** @type {Handle} */

  function onexitimage() {
    const context =
      /** @type {Image & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference' // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut' // @ts-expect-error: mutate.

      delete context.url
      delete context.title
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier // @ts-expect-error: mutate.

      delete context.label
    }

    setData('referenceType')
  }
  /** @type {Handle} */

  function onexitlabeltext(token) {
    const ancestor =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 2]
    const string = this.sliceSerialize(token)
    ancestor.label = decodeString(string)
    ancestor.identifier = normalizeIdentifier(string).toLowerCase()
  }
  /** @type {Handle} */

  function onexitlabel() {
    const fragment =
      /** @type {Fragment} */
      this.stack[this.stack.length - 1]
    const value = this.resume()
    const node =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1] // Assume a reference.

    setData('inReference', true)

    if (node.type === 'link') {
      // @ts-expect-error: Assume static phrasing content.
      node.children = fragment.children
    } else {
      node.alt = value
    }
  }
  /** @type {Handle} */

  function onexitresourcedestinationstring() {
    const data = this.resume()
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1]
    node.url = data
  }
  /** @type {Handle} */

  function onexitresourcetitlestring() {
    const data = this.resume()
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1]
    node.title = data
  }
  /** @type {Handle} */

  function onexitresource() {
    setData('inReference')
  }
  /** @type {Handle} */

  function onenterreference() {
    setData('referenceType', 'collapsed')
  }
  /** @type {Handle} */

  function onexitreferencestring(token) {
    const label = this.resume()
    const node =
      /** @type {LinkReference|ImageReference} */
      this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
    setData('referenceType', 'full')
  }
  /** @type {Handle} */

  function onexitcharacterreferencemarker(token) {
    setData('characterReferenceType', token.type)
  }
  /** @type {Handle} */

  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token)
    const type = getData('characterReferenceType')
    /** @type {string} */

    let value

    if (type) {
      value = decodeNumericCharacterReference(
        data,
        type === 'characterReferenceMarkerNumeric' ? 10 : 16
      )
      setData('characterReferenceType')
    } else {
      // @ts-expect-error `decodeNamedCharacterReference` can return false for
      // invalid named character references, but everything we’ve tokenized is
      // valid.
      value = decodeNamedCharacterReference(data)
    }

    const tail = this.stack.pop()
    tail.value += value
    tail.position.end = point(token.end)
  }
  /** @type {Handle} */

  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token)
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1]
    node.url = this.sliceSerialize(token)
  }
  /** @type {Handle} */

  function onexitautolinkemail(token) {
    onexitdata.call(this, token)
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1]
    node.url = 'mailto:' + this.sliceSerialize(token)
  } //
  // Creaters.
  //

  /** @returns {Blockquote} */

  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    }
  }
  /** @returns {Code} */

  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    }
  }
  /** @returns {InlineCode} */

  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    }
  }
  /** @returns {Definition} */

  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    }
  }
  /** @returns {Emphasis} */

  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    }
  }
  /** @returns {Heading} */

  function heading() {
    // @ts-expect-error `depth` will be set later.
    return {
      type: 'heading',
      depth: undefined,
      children: []
    }
  }
  /** @returns {Break} */

  function hardBreak() {
    return {
      type: 'break'
    }
  }
  /** @returns {HTML} */

  function html() {
    return {
      type: 'html',
      value: ''
    }
  }
  /** @returns {Image} */

  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    }
  }
  /** @returns {Link} */

  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {List}
   */

  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      // @ts-expect-error Patched.
      spread: token._spread,
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {ListItem}
   */

  function listItem(token) {
    return {
      type: 'listItem',
      // @ts-expect-error Patched.
      spread: token._spread,
      checked: null,
      children: []
    }
  }
  /** @returns {Paragraph} */

  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    }
  }
  /** @returns {Strong} */

  function strong() {
    return {
      type: 'strong',
      children: []
    }
  }
  /** @returns {Text} */

  function text() {
    return {
      type: 'text',
      value: ''
    }
  }
  /** @returns {ThematicBreak} */

  function thematicBreak() {
    return {
      type: 'thematicBreak'
    }
  }
}
/**
 * @param {Extension} combined
 * @param {Array<Extension|Array<Extension>>} extensions
 * @returns {Extension}
 */

function configure(combined, extensions) {
  let index = -1

  while (++index < extensions.length) {
    const value = extensions[index]

    if (Array.isArray(value)) {
      configure(combined, value)
    } else {
      extension(combined, value)
    }
  }

  return combined
}
/**
 * @param {Extension} combined
 * @param {Extension} extension
 * @returns {void}
 */

function extension(combined, extension) {
  /** @type {string} */
  let key

  for (key in extension) {
    if (lib_own.call(extension, key)) {
      const list = key === 'canContainEols' || key === 'transforms'
      const maybe = lib_own.call(combined, key) ? combined[key] : undefined
      /* c8 ignore next */

      const left = maybe || (combined[key] = list ? [] : {})
      const right = extension[key]

      if (right) {
        if (list) {
          // @ts-expect-error: `left` is an array.
          combined[key] = [...left, ...right]
        } else {
          Object.assign(left, right)
        }
      }
    }
  }
}
/** @type {OnEnterError} */

function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      'Cannot close `' +
        left.type +
        '` (' +
        stringifyPosition({
          start: left.start,
          end: left.end
        }) +
        '): a different token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is open'
    )
  } else {
    throw new Error(
      'Cannot close document, a token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is still open'
    )
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/remark-parse/lib/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */



/** @type {import('unified').Plugin<[Options?] | void[], string, Root>} */
function remarkParse(options) {
  /** @type {import('unified').ParserFunction<Root>} */
  const parser = (doc) => {
    // Assume options.
    const settings = /** @type {Options} */ (this.data('settings'))

    return fromMarkdown(
      doc,
      Object.assign({}, settings, options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data('micromarkExtensions') || [],
        mdastExtensions: this.data('fromMarkdownExtensions') || []
      })
    )
  }

  Object.assign(this, {Parser: parser})
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/remark-parse/index.js


/* harmony default export */ var remark_parse = (remarkParse);

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/micromark-util-sanitize-uri/index.js


/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri`).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * A regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`, or
 * `/^https?$/i` for `img[src]` (this is what `github.com` allows).
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string | undefined} url
 *   URI to sanitize.
 * @param {RegExp | null | undefined} [protocol]
 *   Allowed protocols.
 * @returns {string}
 *   Sanitized URI.
 */
function sanitizeUri(url, protocol) {
  const value = encode(normalizeUri(url || ''))
  if (!protocol) {
    return value
  }
  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')
  if (
    // If there is no protocol, it’s relative.
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) ||
    // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }
  return ''
}

/**
 * Normalize a URL.
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 *   URI to normalize.
 * @returns {string}
 *   Normalized URI.
 */
function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = []
  let index = -1
  let start = 0
  let skip = 0
  while (++index < value.length) {
    const code = value.charCodeAt(index)
    /** @type {string} */
    let replace = ''

    // A correct percent encoded value.
    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2
    }
    // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code)
      }
    }
    // Astral.
    else if (code > 55295 && code < 57344) {
      const next = value.charCodeAt(index + 1)

      // A correct surrogate pair.
      if (code < 56320 && next > 56319 && next < 57344) {
        replace = String.fromCharCode(code, next)
        skip = 1
      }
      // Lone surrogate.
      else {
        replace = '\uFFFD'
      }
    }
    // Unicode.
    else {
      replace = String.fromCharCode(code)
    }
    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace))
      start = index + skip + 1
      replace = ''
    }
    if (skip) {
      index += skip
      skip = 0
    }
  }
  return result.join('') + value.slice(start)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/footer.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */



/**
 * Generate a hast footer for called footnote definitions.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Element | undefined}
 *   `section` element or `undefined`.
 */
function footer(state) {
  /** @type {Array<ElementContent>} */
  const listItems = []
  let index = -1

  while (++index < state.footnoteOrder.length) {
    const def = state.footnoteById[state.footnoteOrder[index]]

    if (!def) {
      continue
    }

    const content = state.all(def)
    const id = String(def.identifier).toUpperCase()
    const safeId = normalizeUri(id.toLowerCase())
    let referenceIndex = 0
    /** @type {Array<ElementContent>} */
    const backReferences = []

    while (++referenceIndex <= state.footnoteCounts[id]) {
      /** @type {Element} */
      const backReference = {
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            state.clobberPrefix +
            'fnref-' +
            safeId +
            (referenceIndex > 1 ? '-' + referenceIndex : ''),
          dataFootnoteBackref: true,
          className: ['data-footnote-backref'],
          ariaLabel: state.footnoteBackLabel
        },
        children: [{type: 'text', value: '↩'}]
      }

      if (referenceIndex > 1) {
        backReference.children.push({
          type: 'element',
          tagName: 'sup',
          children: [{type: 'text', value: String(referenceIndex)}]
        })
      }

      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '})
      }

      backReferences.push(backReference)
    }

    const tail = content[content.length - 1]

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1]
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' '
      } else {
        tail.children.push({type: 'text', value: ' '})
      }

      tail.children.push(...backReferences)
    } else {
      content.push(...backReferences)
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: state.clobberPrefix + 'fn-' + safeId},
      children: state.wrap(content, true)
    }

    state.patch(def, listItem)

    listItems.push(listItem)
  }

  if (listItems.length === 0) {
    return
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: state.footnoteLabelTagName,
        properties: {
          // To do: use structured clone.
          ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
          id: 'footnote-label'
        },
        children: [{type: 'text', value: state.footnoteLabel}]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: state.wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

;// CONCATENATED MODULE: ../../node_modules/unist-util-is/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 *
 * @typedef {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} Test
 */

/**
 * Check if a node passes a test
 *
 * @callback TestFunctionAnything
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean|void}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} X
 * @callback TestFunctionPredicate
 * @param {Node} node
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is X}
 */

/**
 * @callback AssertAnything
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {boolean}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} Y
 * @callback AssertPredicate
 * @param {unknown} [node]
 * @param {number|null|undefined} [index]
 * @param {Parent|null|undefined} [parent]
 * @returns {node is Y}
 */

const is =
  /**
   * Check if a node passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @type {(
   *   (<T extends Node>(node: unknown, test: T['type']|Partial<T>|TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|TestFunctionPredicate<T>>, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => node is T) &
   *   ((node?: unknown, test?: Test, index?: number|null|undefined, parent?: Parent|null|undefined, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * Check if a node passes a test.
     * When a `parent` node is known the `index` of node should also be given.
     *
     * @param {unknown} [node] Node to check
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @param {number|null|undefined} [index] Position of `node` in `parent`
     * @param {Parent|null|undefined} [parent] Parent of `node`
     * @param {unknown} [context] Context object to invoke `test` with
     * @returns {boolean} Whether test passed and `node` is a `Node` (object with `type` set to non-empty `string`).
     */
    // eslint-disable-next-line max-params
    function is(node, test, index, parent, context) {
      const check = convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      // @ts-expect-error Looks like a node.
      return node && node.type && typeof node.type === 'string'
        ? Boolean(check.call(context, node, index, parent))
        : false
    }
  )

const convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  const checks = []
  let index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    // @ts-expect-error: spreading is fine.
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function ok() {
  return true
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-visit-parents/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-visit-parents/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types.js').Action} Action
 * @typedef {import('./complex-types.js').Index} Index
 * @typedef {import('./complex-types.js').ActionTuple} ActionTuple
 * @typedef {import('./complex-types.js').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */




/**
 * Continue traversing as normal
 */
const CONTINUE = true
/**
 * Do not traverse this node’s children
 */
const SKIP = 'skip'
/**
 * Stop traversing immediately
 */
const EXIT = false

/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param [reverse=false]
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor<Node>} visitor
     * @param {boolean} [reverse=false]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, null, [])()

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {}
        /** @type {string|undefined} */
        let name

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents))

            if (result[0] === EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-visit/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */



/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/unist-util-position/index.js
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {Record<string, unknown> & {type: string, position?: PositionLike|undefined}} NodeLike
 * @typedef {import('unist').Point} Point
 *
 * @typedef {Partial<Point>} PointLike
 *
 * @typedef PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 */

const pointStart = unist_util_position_point('start')
const pointEnd = unist_util_position_point('end')

/**
 * Get the positional info of `node`.
 *
 * @param {NodeLike|Node} [node]
 * @returns {Position}
 */
function unist_util_position_position(node) {
  return {start: pointStart(node), end: pointEnd(node)}
}

/**
 * Get the positional info of `node`.
 *
 * @param {'start'|'end'} type
 */
function unist_util_position_point(type) {
  return point

  /**
   * Get the positional info of `node`.
   *
   * @param {NodeLike|Node} [node]
   * @returns {Point}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    return {
      line: point.line || null,
      column: point.column || null,
      offset: point.offset > -1 ? point.offset : null
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/unist-util-generated/index.js
/**
 * @typedef {Object} PointLike
 * @property {number} [line]
 * @property {number} [column]
 * @property {number} [offset]
 *
 * @typedef {Object} PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 *
 * @typedef {Object} NodeLike
 * @property {PositionLike} [position]
 */

/**
 * Check if `node` is *generated*.
 *
 * @param {NodeLike} [node]
 * @returns {boolean}
 */
function generated(node) {
  return (
    !node ||
    !node.position ||
    !node.position.start ||
    !node.position.start.line ||
    !node.position.start.column ||
    !node.position.end ||
    !node.position.end.line ||
    !node.position.end.column
  )
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/node_modules/mdast-util-definitions/index.js
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 * @typedef {import('mdast').Definition} Definition
 */



const mdast_util_definitions_own = {}.hasOwnProperty

/**
 * Find definitions in `node`.
 * Uses CommonMark precedence, which means that earlier definitions are
 * preferred over duplicate later definitions.
 *
 * @param {Node} node
 */
function definitions(node) {
  /** @type {Record<string, Definition>} */
  const cache = Object.create(null)

  if (!node || !node.type) {
    throw new Error('mdast-util-definitions expected node')
  }

  visit(node, 'definition', (definition) => {
    const id = clean(definition.identifier)
    if (id && !mdast_util_definitions_own.call(cache, id)) {
      cache[id] = definition
    }
  })

  return definition

  /**
   * Get a node from the bound definition cache.
   *
   * @param {string} identifier
   * @returns {Definition|null}
   */
  function definition(identifier) {
    const id = clean(identifier)
    return id && mdast_util_definitions_own.call(cache, id) ? cache[id] : null
  }
}

/**
 * @param {string} [value]
 * @returns {string}
 */
function clean(value) {
  return String(value || '').toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function blockquote(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'blockquote',
    properties: {},
    children: state.wrap(state.all(node), true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */
function hardBreak(state, node) {
  /** @type {Element} */
  const result = {type: 'element', tagName: 'br', properties: {}, children: []}
  state.patch(node, result)
  return [state.applyData(node, result), {type: 'text', value: '\n'}]
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/code.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */

/**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function code(state, node) {
  const value = node.value ? node.value + '\n' : ''
  // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.
  const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null
  /** @type {Properties} */
  const properties = {}

  if (lang) {
    properties.className = ['language-' + lang]
  }

  // Create `<code>`.
  /** @type {Element} */
  let result = {
    type: 'element',
    tagName: 'code',
    properties,
    children: [{type: 'text', value}]
  }

  if (node.meta) {
    result.data = {meta: node.meta}
  }

  state.patch(node, result)
  result = state.applyData(node, result)

  // Create `<pre>`.
  result = {type: 'element', tagName: 'pre', properties: {}, children: [result]}
  state.patch(node, result)
  return result
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/delete.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */

/**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strikethrough(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'del',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function emphasis(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'em',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `footnoteReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {FootnoteReference} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnoteReference(state, node) {
  const id = String(node.identifier).toUpperCase()
  const safeId = normalizeUri(id.toLowerCase())
  const index = state.footnoteOrder.indexOf(id)
  /** @type {number} */
  let counter

  if (index === -1) {
    state.footnoteOrder.push(id)
    state.footnoteCounts[id] = 1
    counter = state.footnoteOrder.length
  } else {
    state.footnoteCounts[id]++
    counter = index + 1
  }

  const reuseCounter = state.footnoteCounts[id]

  /** @type {Element} */
  const link = {
    type: 'element',
    tagName: 'a',
    properties: {
      href: '#' + state.clobberPrefix + 'fn-' + safeId,
      id:
        state.clobberPrefix +
        'fnref-' +
        safeId +
        (reuseCounter > 1 ? '-' + reuseCounter : ''),
      dataFootnoteRef: true,
      ariaDescribedBy: ['footnote-label']
    },
    children: [{type: 'text', value: String(counter)}]
  }
  state.patch(node, link)

  /** @type {Element} */
  const sup = {
    type: 'element',
    tagName: 'sup',
    properties: {},
    children: [link]
  }
  state.patch(node, sup)
  return state.applyData(node, sup)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/footnote.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */



// To do: when both:
// * <https://github.com/micromark/micromark-extension-footnote>
// * <https://github.com/syntax-tree/mdast-util-footnote>
// …are archived, remove this (also from mdast).
// These inline notes are not used in GFM.

/**
 * Turn an mdast `footnote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Footnote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnote(state, node) {
  const footnoteById = state.footnoteById
  let no = 1

  while (no in footnoteById) no++

  const identifier = String(no)

  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  }

  return footnoteReference(state, {
    type: 'footnoteReference',
    identifier,
    position: node.position
  })
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/heading.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function heading(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'h' + node.depth,
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/html.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */

/**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */
function html(state, node) {
  if (state.dangerous) {
    /** @type {Raw} */
    const result = {type: 'raw', value: node.value}
    state.patch(node, result)
    return state.applyData(node, result)
  }

  // To do: next major: return `undefined`.
  return null
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/revert.js
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */

/**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */

// To do: next major: always return array.

/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */
function revert(state, node) {
  const subtype = node.referenceType
  let suffix = ']'

  if (subtype === 'collapsed') {
    suffix += '[]'
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']'
  }

  if (node.type === 'imageReference') {
    return {type: 'text', value: '![' + node.alt + suffix}
  }

  const contents = state.all(node)
  const head = contents[0]

  if (head && head.type === 'text') {
    head.value = '[' + head.value
  } else {
    contents.unshift({type: 'text', value: '['})
  }

  const tail = contents[contents.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += suffix
  } else {
    contents.push({type: 'text', value: suffix})
  }

  return contents
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */




/**
 * Turn an mdast `imageReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ImageReference} node
 *   mdast node.
 * @returns {ElementContent | Array<ElementContent>}
 *   hast node.
 */
function imageReference(state, node) {
  const def = state.definition(node.identifier)

  if (!def) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {src: normalizeUri(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    properties.title = def.title
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/image.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `image` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Image} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function image_image(state, node) {
  /** @type {Properties} */
  const properties = {src: normalizeUri(node.url)}

  if (node.alt !== null && node.alt !== undefined) {
    properties.alt = node.alt
  }

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function inlineCode(state, node) {
  /** @type {Text} */
  const text = {type: 'text', value: node.value.replace(/\r?\n|\r/g, ' ')}
  state.patch(node, text)

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'code',
    properties: {},
    children: [text]
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */




/**
 * Turn an mdast `linkReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {LinkReference} node
 *   mdast node.
 * @returns {ElementContent | Array<ElementContent>}
 *   hast node.
 */
function linkReference(state, node) {
  const def = state.definition(node.identifier)

  if (!def) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {href: normalizeUri(def.url || '')}

  if (def.title !== null && def.title !== undefined) {
    properties.title = def.title
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/link.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `link` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Link} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function link_link(state, node) {
  /** @type {Properties} */
  const properties = {href: normalizeUri(node.url)}

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/list-item.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */

/**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */

/**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function listItem(state, node, parent) {
  const results = state.all(node)
  const loose = parent ? listLoose(parent) : listItemLoose(node)
  /** @type {Properties} */
  const properties = {}
  /** @type {Array<ElementContent>} */
  const children = []

  if (typeof node.checked === 'boolean') {
    const head = results[0]
    /** @type {Element} */
    let paragraph

    if (head && head.type === 'element' && head.tagName === 'p') {
      paragraph = head
    } else {
      paragraph = {type: 'element', tagName: 'p', properties: {}, children: []}
      results.unshift(paragraph)
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift({type: 'text', value: ' '})
    }

    paragraph.children.unshift({
      type: 'element',
      tagName: 'input',
      properties: {type: 'checkbox', checked: node.checked, disabled: true},
      children: []
    })

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    properties.className = ['task-list-item']
  }

  let index = -1

  while (++index < results.length) {
    const child = results[index]

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      children.push({type: 'text', value: '\n'})
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      children.push(...child.children)
    } else {
      children.push(child)
    }
  }

  const tail = results[results.length - 1]

  // Add a final eol.
  if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) {
    children.push({type: 'text', value: '\n'})
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'li', properties, children}
  state.patch(node, result)
  return state.applyData(node, result)
}

/**
 * @param {Parents} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = false
  if (node.type === 'list') {
    loose = node.spread || false
    const children = node.children
    let index = -1

    while (!loose && ++index < children.length) {
      loose = listItemLoose(children[index])
    }
  }

  return loose
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread

  return spread === undefined || spread === null
    ? node.children.length > 1
    : spread
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/list.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function list_list(state, node) {
  /** @type {Properties} */
  const properties = {}
  const results = state.all(node)
  let index = -1

  if (typeof node.start === 'number' && node.start !== 1) {
    properties.start = node.start
  }

  // Like GitHub, add a class for custom styling.
  while (++index < results.length) {
    const child = results[index]

    if (
      child.type === 'element' &&
      child.tagName === 'li' &&
      child.properties &&
      Array.isArray(child.properties.className) &&
      child.properties.className.includes('task-list-item')
    ) {
      properties.className = ['contains-task-list']
      break
    }
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: node.ordered ? 'ol' : 'ul',
    properties,
    children: state.wrap(results, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function paragraph(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'p',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/root.js
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */
function root(state, node) {
  /** @type {HastRoot} */
  const result = {type: 'root', children: state.wrap(state.all(node))}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/strong.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strong(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'strong',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/table.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `table` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Table} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function table(state, node) {
  const rows = state.all(node)
  const firstRow = rows.shift()
  /** @type {Array<Element>} */
  const tableContent = []

  if (firstRow) {
    /** @type {Element} */
    const head = {
      type: 'element',
      tagName: 'thead',
      properties: {},
      children: state.wrap([firstRow], true)
    }
    state.patch(node.children[0], head)
    tableContent.push(head)
  }

  if (rows.length > 0) {
    /** @type {Element} */
    const body = {
      type: 'element',
      tagName: 'tbody',
      properties: {},
      children: state.wrap(rows, true)
    }

    const start = pointStart(node.children[1])
    const end = pointEnd(node.children[node.children.length - 1])
    if (start.line && end.line) body.position = {start, end}
    tableContent.push(body)
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'table',
    properties: {},
    children: state.wrap(tableContent, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/table-row.js
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */

/**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */

/**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function tableRow(state, node, parent) {
  const siblings = parent ? parent.children : undefined
  // Generate a body row when without parent.
  const rowIndex = siblings ? siblings.indexOf(node) : 1
  const tagName = rowIndex === 0 ? 'th' : 'td'
  const align = parent && parent.type === 'table' ? parent.align : undefined
  const length = align ? align.length : node.children.length
  let cellIndex = -1
  /** @type {Array<ElementContent>} */
  const cells = []

  while (++cellIndex < length) {
    // Note: can also be undefined.
    const cell = node.children[cellIndex]
    /** @type {Properties} */
    const properties = {}
    const alignValue = align ? align[cellIndex] : undefined

    if (alignValue) {
      properties.align = alignValue
    }

    /** @type {Element} */
    let result = {type: 'element', tagName, properties, children: []}

    if (cell) {
      result.children = state.all(cell)
      state.patch(cell, result)
      result = state.applyData(node, result)
    }

    cells.push(result)
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'tr',
    properties: {},
    children: state.wrap(cells, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/table-cell.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function tableCell(state, node) {
  // Note: this function is normally not called: see `table-row` for how rows
  // and their cells are compiled.
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'td', // Assume body cell.
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/trim-lines/index.js
const tab = 9 /* `\t` */
const space = 32 /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value)
  const search = /\r?\n|\r/g
  let match = search.exec(source)
  let last = 0
  /** @type {Array<string>} */
  const lines = []

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    )

    last = match.index + match[0].length
    match = search.exec(source)
  }

  lines.push(trimLine(source.slice(last), last > 0, false))

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0
  let endIndex = value.length

  if (start) {
    let code = value.codePointAt(startIndex)

    while (code === tab || code === space) {
      startIndex++
      code = value.codePointAt(startIndex)
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1)

    while (code === tab || code === space) {
      endIndex--
      code = value.codePointAt(endIndex - 1)
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/text.js
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `text` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastText} node
 *   mdast node.
 * @returns {HastText | HastElement}
 *   hast node.
 */
function handlers_text_text(state, node) {
  /** @type {HastText} */
  const result = {type: 'text', value: trimLines(String(node.value))}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function thematic_break_thematicBreak(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'hr',
    properties: {},
    children: []
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/handlers/index.js

























/**
 * Default handlers for nodes.
 */
const handlers = {
  blockquote: blockquote,
  break: hardBreak,
  code: code,
  delete: strikethrough,
  emphasis: emphasis,
  footnoteReference: footnoteReference,
  footnote: footnote,
  heading: heading,
  html: html,
  imageReference: imageReference,
  image: image_image,
  inlineCode: inlineCode,
  linkReference: linkReference,
  link: link_link,
  listItem: listItem,
  list: list_list,
  paragraph: paragraph,
  root: root,
  strong: strong,
  table: table,
  tableCell: tableCell,
  tableRow: tableRow,
  text: handlers_text_text,
  thematicBreak: thematic_break_thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

// Return nothing for nodes that are ignored.
function ignore() {
  // To do: next major: return `undefined`.
  return null
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/state.js
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */

/**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */







const state_own = {}.hasOwnProperty

/**
 * Create `state` from an mdast tree.
 *
 * @param {MdastNodes} tree
 *   mdast node to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {State}
 *   `state` function.
 */
function createState(tree, options) {
  const settings = options || {}
  const dangerous = settings.allowDangerousHtml || false
  /** @type {Record<string, MdastFootnoteDefinition>} */
  const footnoteById = {}

  // To do: next major: add `options` to state, remove:
  // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
  // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
  // `unknownHandler`.

  // To do: next major: move to `state.options.allowDangerousHtml`.
  state.dangerous = dangerous
  // To do: next major: move to `state.options`.
  state.clobberPrefix =
    settings.clobberPrefix === undefined || settings.clobberPrefix === null
      ? 'user-content-'
      : settings.clobberPrefix
  // To do: next major: move to `state.options`.
  state.footnoteLabel = settings.footnoteLabel || 'Footnotes'
  // To do: next major: move to `state.options`.
  state.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2'
  // To do: next major: move to `state.options`.
  state.footnoteLabelProperties = settings.footnoteLabelProperties || {
    className: ['sr-only']
  }
  // To do: next major: move to `state.options`.
  state.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content'
  // To do: next major: move to `state.options`.
  state.unknownHandler = settings.unknownHandler
  // To do: next major: move to `state.options`.
  state.passThrough = settings.passThrough

  state.handlers = {...handlers, ...settings.handlers}

  // To do: next major: replace utility with `definitionById` object, so we
  // only walk once (as we need footnotes too).
  state.definition = definitions(tree)
  state.footnoteById = footnoteById
  /** @type {Array<string>} */
  state.footnoteOrder = []
  /** @type {Record<string, number>} */
  state.footnoteCounts = {}

  state.patch = patch
  state.applyData = applyData
  state.one = oneBound
  state.all = allBound
  state.wrap = state_wrap
  // To do: next major: remove `augment`.
  state.augment = augment

  visit(tree, 'footnoteDefinition', (definition) => {
    const id = String(definition.identifier).toUpperCase()

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
    if (!state_own.call(footnoteById, id)) {
      footnoteById[id] = definition
    }
  })

  // @ts-expect-error Hush, it’s fine!
  return state

  /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */
  /* c8 ignore start */
  // To do: next major: remove.
  function augment(left, right) {
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && 'data' in left && left.data) {
      /** @type {MdastData} */
      const data = left.data

      if (data.hName) {
        if (right.type !== 'element') {
          right = {
            type: 'element',
            tagName: '',
            properties: {},
            children: []
          }
        }

        right.tagName = data.hName
      }

      if (right.type === 'element' && data.hProperties) {
        right.properties = {...right.properties, ...data.hProperties}
      }

      if ('children' in right && right.children && data.hChildren) {
        right.children = data.hChildren
      }
    }

    if (left) {
      const ctx = 'type' in left ? left : {position: left}

      if (!generated(ctx)) {
        // @ts-expect-error: fine.
        right.position = {start: pointStart(ctx), end: pointEnd(ctx)}
      }
    }

    return right
  }
  /* c8 ignore stop */

  /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */
  /* c8 ignore start */
  // To do: next major: remove.
  function state(node, tagName, props, children) {
    if (Array.isArray(props)) {
      children = props
      props = {}
    }

    // @ts-expect-error augmenting an element yields an element.
    return augment(node, {
      type: 'element',
      tagName,
      properties: props || {},
      children: children || []
    })
  }
  /* c8 ignore stop */

  /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */
  function oneBound(node, parent) {
    // @ts-expect-error: that’s a state :)
    return state_one(state, node, parent)
  }

  /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */
  function allBound(parent) {
    // @ts-expect-error: that’s a state :)
    return state_all(state, parent)
  }
}

/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */
function patch(from, to) {
  if (from.position) to.position = unist_util_position_position(from)
}

/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */
function applyData(from, to) {
  /** @type {Type | HastElement} */
  let result = to

  // Handle `data.hName`, `data.hProperties, `data.hChildren`.
  if (from && from.data) {
    const hName = from.data.hName
    const hChildren = from.data.hChildren
    const hProperties = from.data.hProperties

    if (typeof hName === 'string') {
      // Transforming the node resulted in an element with a different name
      // than wanted:
      if (result.type === 'element') {
        result.tagName = hName
      }
      // Transforming the node resulted in a non-element, which happens for
      // raw, text, and root nodes (unless custom handlers are passed).
      // The intent is likely to keep the content around (otherwise: pass
      // `hChildren`).
      else {
        result = {
          type: 'element',
          tagName: hName,
          properties: {},
          children: []
        }

        // To do: next major: take the children from the `root`, or inject the
        // raw/text/comment or so into the element?
        // if ('children' in node) {
        //   // @ts-expect-error: assume `children` are allowed in elements.
        //   result.children = node.children
        // } else {
        //   // @ts-expect-error: assume `node` is allowed in elements.
        //   result.children.push(node)
        // }
      }
    }

    if (result.type === 'element' && hProperties) {
      result.properties = {...result.properties, ...hProperties}
    }

    if (
      'children' in result &&
      result.children &&
      hChildren !== null &&
      hChildren !== undefined
    ) {
      // @ts-expect-error: assume valid children are defined.
      result.children = hChildren
    }
  }

  return result
}

/**
 * Transform an mdast node into a hast node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   mdast node.
 * @param {MdastParents | null | undefined} [parent]
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   Resulting hast node.
 */
// To do: next major: do not expose, keep bound.
function state_one(state, node, parent) {
  const type = node && node.type

  // Fail on non-nodes.
  if (!type) {
    throw new Error('Expected node, got `' + node + '`')
  }

  if (state_own.call(state.handlers, type)) {
    return state.handlers[type](state, node, parent)
  }

  if (state.passThrough && state.passThrough.includes(type)) {
    // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return 'children' in node ? {...node, children: state_all(state, node)} : node
  }

  if (state.unknownHandler) {
    return state.unknownHandler(state, node, parent)
  }

  return defaultUnknownHandler(state, node)
}

/**
 * Transform the children of an mdast node into hast nodes.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} parent
 *   mdast node to compile
 * @returns {Array<HastElementContent>}
 *   Resulting hast nodes.
 */
// To do: next major: do not expose, keep bound.
function state_all(state, parent) {
  /** @type {Array<HastElementContent>} */
  const values = []

  if ('children' in parent) {
    const nodes = parent.children
    let index = -1
    while (++index < nodes.length) {
      const result = state_one(state, nodes[index], parent)

      // To do: see if we van clean this? Can we merge texts?
      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (!Array.isArray(result) && result.type === 'text') {
            result.value = result.value.replace(/^\s+/, '')
          }

          if (!Array.isArray(result) && result.type === 'element') {
            const head = result.children[0]

            if (head && head.type === 'text') {
              head.value = head.value.replace(/^\s+/, '')
            }
          }
        }

        if (Array.isArray(result)) {
          values.push(...result)
        } else {
          values.push(result)
        }
      }
    }
  }

  return values
}

/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */
function defaultUnknownHandler(state, node) {
  const data = node.data || {}
  /** @type {HastText | HastElement} */
  const result =
    'value' in node &&
    !(state_own.call(data, 'hProperties') || state_own.call(data, 'hChildren'))
      ? {type: 'text', value: node.value}
      : {
          type: 'element',
          tagName: 'div',
          properties: {},
          children: state_all(state, node)
        }

  state.patch(node, result)
  return state.applyData(node, result)
}

/**
 * Wrap `nodes` with line endings between each node.
 *
 * @template {HastContent} Type
 *   Node type.
 * @param {Array<Type>} nodes
 *   List of nodes to wrap.
 * @param {boolean | null | undefined} [loose=false]
 *   Whether to add line endings at start and end.
 * @returns {Array<Type | HastText>}
 *   Wrapped nodes.
 */
function state_wrap(nodes, loose) {
  /** @type {Array<Type | HastText>} */
  const result = []
  let index = -1

  if (loose) {
    result.push({type: 'text', value: '\n'})
  }

  while (++index < nodes.length) {
    if (index) result.push({type: 'text', value: '\n'})
    result.push(nodes[index])
  }

  if (loose && nodes.length > 0) {
    result.push({type: 'text', value: '\n'})
  }

  return result
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-hast/lib/index.js
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */

/**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */




/**
 * Transform mdast to hast.
 *
 * ##### Notes
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most utilities ignore `raw` nodes but two notable ones don’t:
 *
 * *   `hast-util-to-html` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful
 *     if you completely trust authors
 * *   `hast-util-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only
 *     way to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `mdast-util-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * Example: headings (DOM clobbering) in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @param {MdastNodes} tree
 *   mdast tree.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {HastNodes | null | undefined}
 *   hast tree.
 */
// To do: next major: always return a single `root`.
function toHast(tree, options) {
  const state = createState(tree, options)
  const node = state.one(tree, null)
  const foot = footer(state)

  if (foot) {
    // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({type: 'text', value: '\n'}, foot)
  }

  // To do: next major: always return root?
  return Array.isArray(node) ? {type: 'root', children: node} : node
}

;// CONCATENATED MODULE: ../../node_modules/remark-rehype/lib/index.js
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */



// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(

/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */
const remarkRehype =
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  (
    function (destination, options) {
      return destination && 'run' in destination
        ? bridge(destination, options)
        : mutate(destination || options)
    }
  )

/* harmony default export */ var lib = (remarkRehype);

/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */
function bridge(destination, options) {
  return (node, file, next) => {
    destination.run(toHast(node, options), file, (error) => {
      next(error)
    })
  }
}

/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */
function mutate(options) {
  // @ts-expect-error: assume a corresponding node is returned by `toHast`.
  return (node) => toHast(node, options)
}

// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
Schema.prototype.property = {}
/** @type {Normal} */
Schema.prototype.normal = {}
/** @type {string|null} */
Schema.prototype.space = null

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/info.js
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
Info.prototype.space = null
Info.prototype.boolean = false
Info.prototype.booleanish = false
Info.prototype.overloadedBoolean = false
Info.prototype.number = false
Info.prototype.commaSeparated = false
Info.prototype.spaceSeparated = false
Info.prototype.commaOrSpaceSeparated = false
Info.prototype.mustUseProperty = false
Info.prototype.defined = false

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/types.js
let powers = 0

const types_boolean = increment()
const booleanish = increment()
const overloadedBoolean = increment()
const number = increment()
const spaceSeparated = increment()
const commaSeparated = increment()
const commaOrSpaceSeparated = increment()

function increment() {
  return 2 ** ++powers
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks = Object.keys(types_namespaceObject)

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index]
        mark(this, checks[index], (mask & types_namespaceObject[check]) === types_namespaceObject[check])
      }
    }
  }
}

DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[normalize_normalize(prop)] = prop
      normal[normalize_normalize(info.attribute)] = prop
    }
  }

  return new Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/xlink.js


const xlink = create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/xml.js


const xml = create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/xmlns.js



const xmlns = create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/aria.js



const aria = create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/html.js




const html_html = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: types_boolean,
    allowPaymentRequest: types_boolean,
    allowUserMedia: types_boolean,
    alt: null,
    as: null,
    async: types_boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: types_boolean,
    autoPlay: types_boolean,
    capture: types_boolean,
    charSet: null,
    checked: types_boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: types_boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: types_boolean,
    defer: types_boolean,
    dir: null,
    dirName: null,
    disabled: types_boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: types_boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: types_boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: types_boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: types_boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: types_boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: types_boolean,
    muted: types_boolean,
    name: null,
    nonce: null,
    noModule: types_boolean,
    noValidate: types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: types_boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: types_boolean,
    poster: null,
    preload: null,
    readOnly: types_boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: types_boolean,
    reversed: types_boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: types_boolean,
    seamless: types_boolean,
    selected: types_boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: types_boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: types_boolean, // `<frame>`
    noHref: types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: types_boolean,
    disableRemotePlayback: types_boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/svg.js




const svg = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const property_information_html = merge([xml, xlink, xmlns, aria, html_html], 'html')
const property_information_svg = merge([xml, xlink, xmlns, aria, svg], 'svg')

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-visit-parents/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function color_browser_color(d) {
  return d
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-visit-parents/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types.js').Action} Action
 * @typedef {import('./complex-types.js').Index} Index
 * @typedef {import('./complex-types.js').ActionTuple} ActionTuple
 * @typedef {import('./complex-types.js').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */




/**
 * Continue traversing as normal
 */
const unist_util_visit_parents_CONTINUE = true
/**
 * Do not traverse this node’s children
 */
const unist_util_visit_parents_SKIP = 'skip'
/**
 * Stop traversing immediately
 */
const unist_util_visit_parents_EXIT = false

/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param [reverse=false]
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const unist_util_visit_parents_visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor<Node>} visitor
     * @param {boolean} [reverse=false]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, null, [])()

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {}
        /** @type {string|undefined} */
        let name

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color_browser_color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = unist_util_visit_parents_toResult(visitor(node, parents))

            if (result[0] === unist_util_visit_parents_EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== unist_util_visit_parents_SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === unist_util_visit_parents_EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function unist_util_visit_parents_toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [unist_util_visit_parents_CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/unist-util-visit/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */



/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const unist_util_visit_visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      unist_util_visit_parents_visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/rehype-filter.js


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef Options
 * @property {Array<string>} [allowedElements]
 * @property {Array<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[Options], Root>}
 */
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError(
      'Only one of `allowedElements` and `disallowedElements` should be defined'
    )
  }

  if (
    options.allowedElements ||
    options.disallowedElements ||
    options.allowElement
  ) {
    return (tree) => {
      unist_util_visit_visit(tree, 'element', (node, index, parent_) => {
        const parent = /** @type {Element|Root} */ (parent_)
        /** @type {boolean|undefined} */
        let remove

        if (options.allowedElements) {
          remove = !options.allowedElements.includes(node.tagName)
        } else if (options.disallowedElements) {
          remove = options.disallowedElements.includes(node.tagName)
        }

        if (!remove && options.allowElement && typeof index === 'number') {
          remove = !options.allowElement(node, index, parent)
        }

        if (remove && typeof index === 'number') {
          if (options.unwrapDisallowed && node.children) {
            parent.children.splice(index, 1, ...node.children)
          } else {
            parent.children.splice(index, 1)
          }

          return index
        }

        return undefined
      })
    }
  }
}

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(8570);
;// CONCATENATED MODULE: ../../node_modules/hast-util-whitespace/index.js
/**
 * @param {unknown} thing
 * @returns {boolean}
 */
function whitespace(thing) {
  /** @type {string} */
  var value =
    // @ts-ignore looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text'
      ? // @ts-ignore looks like a text.
        thing.value || ''
      : thing

  // HTML whitespace expression.
  // See <https://html.spec.whatwg.org/#space-character>.
  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === ''
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const valid = /^data[-\w.:]+$/i
const dash = /-[a-z]/g
const cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  const normal = normalize_normalize(value)
  let prop = value
  let Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/property-information/lib/hast-to-react.js
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/space-separated-tokens/index.js
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function stringify(values) {
  return values.join(' ').trim()
}

;// CONCATENATED MODULE: ../../node_modules/comma-separated-tokens/index.js
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */

/**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function comma_separated_tokens_parse(value) {
  /** @type {Array<string>} */
  const tokens = []
  const input = String(value || '')
  let index = input.indexOf(',')
  let start = 0
  /** @type {boolean} */
  let end = false

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    const token = input.slice(start, index).trim()

    if (token || !end) {
      tokens.push(token)
    }

    start = index + 1
    index = input.indexOf(',', start)
  }

  return tokens
}

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function comma_separated_tokens_stringify(values, options) {
  const settings = options || {}

  // Ensure the last empty entry is seen.
  const input = values[values.length - 1] === '' ? [...values, ''] : values

  return input
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

// EXTERNAL MODULE: ../../node_modules/react-markdown/node_modules/style-to-object/index.js
var style_to_object = __webpack_require__(6772);
;// CONCATENATED MODULE: ../../node_modules/react-markdown/node_modules/style-to-object/index.mjs


/* harmony default export */ var node_modules_style_to_object = (style_to_object);

;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/uri-transformer.js
const protocols = ['http', 'https', 'mailto', 'tel']

/**
 * @param {string} uri
 * @returns {string}
 */
function uriTransformer(uri) {
  const url = (uri || '').trim()
  const first = url.charAt(0)

  if (first === '#' || first === '/') {
    return url
  }

  const colon = url.indexOf(':')
  if (colon === -1) {
    return url
  }

  let index = -1

  while (++index < protocols.length) {
    const protocol = protocols[index]

    if (
      colon === protocol.length &&
      url.slice(0, protocol.length).toLowerCase() === protocol
    ) {
      return url
    }
  }

  index = url.indexOf('?')
  if (index !== -1 && colon > index) {
    return url
  }

  index = url.indexOf('#')
  if (index !== -1 && colon > index) {
    return url
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)'
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/ast-to-react.js
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */

/**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */










const ast_to_react_own = {}.hasOwnProperty

// The table-related elements that must not contain whitespace text according
// to React.
const tableElements = new Set(['table', 'thead', 'tbody', 'tfoot', 'tr'])

/**
 * @param {Context} context
 * @param {Element|Root} node
 */
function childrenToReact(context, node) {
  /** @type {Array<ReactNode>} */
  const children = []
  let childIndex = -1
  /** @type {Comment|Doctype|Element|Raw|Text} */
  let child

  while (++childIndex < node.children.length) {
    child = node.children[childIndex]

    if (child.type === 'element') {
      children.push(toReact(context, child, childIndex, node))
    } else if (child.type === 'text') {
      // Currently, a warning is triggered by react for *any* white space in
      // tables.
      // So we drop it.
      // See: <https://github.com/facebook/react/pull/7081>.
      // See: <https://github.com/facebook/react/pull/7515>.
      // See: <https://github.com/remarkjs/remark-react/issues/64>.
      // See: <https://github.com/remarkjs/react-markdown/issues/576>.
      if (
        node.type !== 'element' ||
        !tableElements.has(node.tagName) ||
        !whitespace(child)
      ) {
        children.push(child.value)
      }
    } else if (child.type === 'raw' && !context.options.skipHtml) {
      // Default behavior is to show (encoded) HTML.
      children.push(child.value)
    }
  }

  return children
}

/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */
function toReact(context, node, index, parent) {
  const options = context.options
  const transform =
    options.transformLinkUri === undefined
      ? uriTransformer
      : options.transformLinkUri
  const parentSchema = context.schema
  /** @type {ReactMarkdownNames} */
  // @ts-expect-error assume a known HTML/SVG element.
  const name = node.tagName
  /** @type {Record<string, unknown>} */
  const properties = {}
  let schema = parentSchema
  /** @type {string} */
  let property

  if (parentSchema.space === 'html' && name === 'svg') {
    schema = property_information_svg
    context.schema = schema
  }

  if (node.properties) {
    for (property in node.properties) {
      if (ast_to_react_own.call(node.properties, property)) {
        addProperty(properties, property, node.properties[property], context)
      }
    }
  }

  if (name === 'ol' || name === 'ul') {
    context.listDepth++
  }

  const children = childrenToReact(context, node)

  if (name === 'ol' || name === 'ul') {
    context.listDepth--
  }

  // Restore parent schema.
  context.schema = parentSchema

  // Nodes created by plugins do not have positional info, in which case we use
  // an object that matches the position interface.
  const position = node.position || {
    start: {line: null, column: null, offset: null},
    end: {line: null, column: null, offset: null}
  }
  const component =
    options.components && ast_to_react_own.call(options.components, name)
      ? options.components[name]
      : name
  const basic = typeof component === 'string' || component === react.Fragment

  if (!react_is.isValidElementType(component)) {
    throw new TypeError(
      `Component for name \`${name}\` not defined or is not renderable`
    )
  }

  properties.key = index

  if (name === 'a' && options.linkTarget) {
    properties.target =
      typeof options.linkTarget === 'function'
        ? options.linkTarget(
            String(properties.href || ''),
            node.children,
            typeof properties.title === 'string' ? properties.title : null
          )
        : options.linkTarget
  }

  if (name === 'a' && transform) {
    properties.href = transform(
      String(properties.href || ''),
      node.children,
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (
    !basic &&
    name === 'code' &&
    parent.type === 'element' &&
    parent.tagName !== 'pre'
  ) {
    properties.inline = true
  }

  if (
    !basic &&
    (name === 'h1' ||
      name === 'h2' ||
      name === 'h3' ||
      name === 'h4' ||
      name === 'h5' ||
      name === 'h6')
  ) {
    properties.level = Number.parseInt(name.charAt(1), 10)
  }

  if (name === 'img' && options.transformImageUri) {
    properties.src = options.transformImageUri(
      String(properties.src || ''),
      String(properties.alt || ''),
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (!basic && name === 'li' && parent.type === 'element') {
    const input = getInputElement(node)
    properties.checked =
      input && input.properties ? Boolean(input.properties.checked) : null
    properties.index = getElementsBeforeCount(parent, node)
    properties.ordered = parent.tagName === 'ol'
  }

  if (!basic && (name === 'ol' || name === 'ul')) {
    properties.ordered = name === 'ol'
    properties.depth = context.listDepth
  }

  if (name === 'td' || name === 'th') {
    if (properties.align) {
      if (!properties.style) properties.style = {}
      // @ts-expect-error assume `style` is an object
      properties.style.textAlign = properties.align
      delete properties.align
    }

    if (!basic) {
      properties.isHeader = name === 'th'
    }
  }

  if (!basic && name === 'tr' && parent.type === 'element') {
    properties.isHeader = Boolean(parent.tagName === 'thead')
  }

  // If `sourcePos` is given, pass source information (line/column info from markdown source).
  if (options.sourcePos) {
    properties['data-sourcepos'] = flattenPosition(position)
  }

  if (!basic && options.rawSourcePos) {
    properties.sourcePosition = node.position
  }

  // If `includeElementIndex` is given, pass node index info to components.
  if (!basic && options.includeElementIndex) {
    properties.index = getElementsBeforeCount(parent, node)
    properties.siblingCount = getElementsBeforeCount(parent)
  }

  if (!basic) {
    properties.node = node
  }

  // Ensure no React warnings are emitted for void elements w/ children.
  return children.length > 0
    ? react.createElement(component, properties, children)
    : react.createElement(component, properties)
}

/**
 * @param {Element|Root} node
 * @returns {Element?}
 */
function getInputElement(node) {
  let index = -1

  while (++index < node.children.length) {
    const child = node.children[index]

    if (child.type === 'element' && child.tagName === 'input') {
      return child
    }
  }

  return null
}

/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */
function getElementsBeforeCount(parent, node) {
  let index = -1
  let count = 0

  while (++index < parent.children.length) {
    if (parent.children[index] === node) break
    if (parent.children[index].type === 'element') count++
  }

  return count
}

/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */
function addProperty(props, prop, value, ctx) {
  const info = find(ctx.schema, prop)
  let result = value

  // Ignore nullish and `NaN` values.
  // eslint-disable-next-line no-self-compare
  if (result === null || result === undefined || result !== result) {
    return
  }

  // Accept `array`.
  // Most props are space-separated.
  if (Array.isArray(result)) {
    result = info.commaSeparated ? comma_separated_tokens_stringify(result) : stringify(result)
  }

  if (info.property === 'style' && typeof result === 'string') {
    result = parseStyle(result)
  }

  if (info.space && info.property) {
    props[
      ast_to_react_own.call(hastToReact, info.property)
        ? hastToReact[info.property]
        : info.property
    ] = result
  } else if (info.attribute) {
    props[info.attribute] = result
  }
}

/**
 * @param {string} value
 * @returns {Record<string, string>}
 */
function parseStyle(value) {
  /** @type {Record<string, string>} */
  const result = {}

  try {
    node_modules_style_to_object(value, iterator)
  } catch {
    // Silent.
  }

  return result

  /**
   * @param {string} name
   * @param {string} v
   */
  function iterator(name, v) {
    const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name
    result[k.replace(/-([a-z])/g, styleReplacer)] = v
  }
}

/**
 * @param {unknown} _
 * @param {string} $1
 */
function styleReplacer(_, $1) {
  return $1.toUpperCase()
}

/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */
function flattenPosition(pos) {
  return [
    pos.start.line,
    ':',
    pos.start.column,
    '-',
    pos.end.line,
    ':',
    pos.end.column
  ]
    .map(String)
    .join('')
}

;// CONCATENATED MODULE: ../../node_modules/react-markdown/lib/react-markdown.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */











const react_markdown_own = {}.hasOwnProperty
const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md'

/** @type {Record<string, Deprecation>} */
const deprecated = {
  plugins: {to: 'remarkPlugins', id: 'change-plugins-to-remarkplugins'},
  renderers: {to: 'components', id: 'change-renderers-to-components'},
  astPlugins: {id: 'remove-buggy-html-in-markdown-parser'},
  allowDangerousHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  escapeHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  source: {to: 'children', id: 'change-source-to-children'},
  allowNode: {
    to: 'allowElement',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  allowedTypes: {
    to: 'allowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  disallowedTypes: {
    to: 'disallowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  includeNodeIndex: {
    to: 'includeElementIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  }
}

/**
 * React component to render markdown.
 *
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */
function ReactMarkdown(options) {
  for (const key in deprecated) {
    if (react_markdown_own.call(deprecated, key) && react_markdown_own.call(options, key)) {
      const deprecation = deprecated[key]
      console.warn(
        `[react-markdown] Warning: please ${
          deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'
        } \`${key}\` (see <${changelog}#${deprecation.id}> for more info)`
      )
      delete deprecated[key]
    }
  }

  const processor = unified()
    .use(remark_parse)
    .use(options.remarkPlugins || [])
    .use(lib, {
      ...options.remarkRehypeOptions,
      allowDangerousHtml: true
    })
    .use(options.rehypePlugins || [])
    .use(rehypeFilter, options)

  const file = new VFile()

  if (typeof options.children === 'string') {
    file.value = options.children
  } else if (options.children !== undefined && options.children !== null) {
    console.warn(
      `[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`
    )
  }

  const hastNode = processor.runSync(processor.parse(file), file)

  if (hastNode.type !== 'root') {
    throw new TypeError('Expected a `root` node')
  }

  /** @type {ReactElement} */
  let result = react.createElement(
    react.Fragment,
    {},
    childrenToReact({options, schema: property_information_html, listDepth: 0}, hastNode)
  )

  if (options.className) {
    result = react.createElement('div', {className: options.className}, result)
  }

  return result
}

ReactMarkdown.propTypes = {
  // Core options:
  children: prop_types.string,
  // Layout options:
  className: prop_types.string,
  // Filter options:
  allowElement: prop_types.func,
  allowedElements: prop_types.arrayOf(prop_types.string),
  disallowedElements: prop_types.arrayOf(prop_types.string),
  unwrapDisallowed: prop_types.bool,
  // Plugin options:
  remarkPlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: prop_types.bool,
  rawSourcePos: prop_types.bool,
  skipHtml: prop_types.bool,
  includeElementIndex: prop_types.bool,
  transformLinkUri: prop_types.oneOfType([prop_types.func, prop_types.bool]),
  linkTarget: prop_types.oneOfType([prop_types.func, prop_types.string]),
  transformImageUri: prop_types.func,
  components: prop_types.object
}

// EXTERNAL MODULE: ../../node_modules/parse5/lib/parser/index.js
var lib_parser = __webpack_require__(7045);
;// CONCATENATED MODULE: ../../node_modules/hast-util-raw/node_modules/unist-util-position/index.js
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {Record<string, unknown> & {type: string, position?: PositionLike|undefined}} NodeLike
 * @typedef {import('unist').Point} Point
 *
 * @typedef {Partial<Point>} PointLike
 *
 * @typedef PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 */

const unist_util_position_pointStart = node_modules_unist_util_position_point('start')
const unist_util_position_pointEnd = node_modules_unist_util_position_point('end')

/**
 * Get the positional info of `node`.
 *
 * @param {NodeLike|Node} [node]
 * @returns {Position}
 */
function node_modules_unist_util_position_position(node) {
  return {start: unist_util_position_pointStart(node), end: unist_util_position_pointEnd(node)}
}

/**
 * Get the positional info of `node`.
 *
 * @param {'start'|'end'} type
 */
function node_modules_unist_util_position_point(type) {
  return point

  /**
   * Get the positional info of `node`.
   *
   * @param {NodeLike|Node} [node]
   * @returns {Point}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    return {
      line: point.line || null,
      column: point.column || null,
      offset: point.offset > -1 ? point.offset : null
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-raw/node_modules/unist-util-visit-parents/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function unist_util_visit_parents_color_browser_color(d) {
  return d
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-raw/node_modules/unist-util-visit-parents/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types.js').Action} Action
 * @typedef {import('./complex-types.js').Index} Index
 * @typedef {import('./complex-types.js').ActionTuple} ActionTuple
 * @typedef {import('./complex-types.js').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */




/**
 * Continue traversing as normal
 */
const node_modules_unist_util_visit_parents_CONTINUE = true
/**
 * Do not traverse this node’s children
 */
const node_modules_unist_util_visit_parents_SKIP = 'skip'
/**
 * Stop traversing immediately
 */
const node_modules_unist_util_visit_parents_EXIT = false

/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param [reverse=false]
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const node_modules_unist_util_visit_parents_visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor<Node>} visitor
     * @param {boolean} [reverse=false]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, null, [])()

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {}
        /** @type {string|undefined} */
        let name

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              unist_util_visit_parents_color_browser_color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = node_modules_unist_util_visit_parents_toResult(visitor(node, parents))

            if (result[0] === node_modules_unist_util_visit_parents_EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== node_modules_unist_util_visit_parents_SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === node_modules_unist_util_visit_parents_EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function node_modules_unist_util_visit_parents_toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [node_modules_unist_util_visit_parents_CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-raw/node_modules/unist-util-visit/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types.js').Visitor} Visitor
 */



/**
 * Visit children of tree which pass test.
 *
 * @param tree
 *   Tree to walk
 * @param [test]
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Function called for nodes that pass `test`.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of preorder (NLR) (default).
 */
const node_modules_unist_util_visit_visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types.js').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types.js').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types.js').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      node_modules_unist_util_visit_parents_visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class schema_Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
schema_Schema.prototype.property = {}
/** @type {Normal} */
schema_Schema.prototype.normal = {}
/** @type {string|null} */
schema_Schema.prototype.space = null

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge_merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new schema_Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function lib_normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/info.js
class info_Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
info_Info.prototype.space = null
info_Info.prototype.boolean = false
info_Info.prototype.booleanish = false
info_Info.prototype.overloadedBoolean = false
info_Info.prototype.number = false
info_Info.prototype.commaSeparated = false
info_Info.prototype.spaceSeparated = false
info_Info.prototype.commaOrSpaceSeparated = false
info_Info.prototype.mustUseProperty = false
info_Info.prototype.defined = false

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/types.js
let types_powers = 0

const util_types_boolean = types_increment()
const types_booleanish = types_increment()
const types_overloadedBoolean = types_increment()
const types_number = types_increment()
const types_spaceSeparated = types_increment()
const types_commaSeparated = types_increment()
const types_commaOrSpaceSeparated = types_increment()

function types_increment() {
  return 2 ** ++types_powers
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const defined_info_checks = Object.keys(util_types_namespaceObject)

class defined_info_DefinedInfo extends info_Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    defined_info_mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < defined_info_checks.length) {
        const check = defined_info_checks[index]
        defined_info_mark(this, defined_info_checks[index], (mask & util_types_namespaceObject[check]) === util_types_namespaceObject[check])
      }
    }
  }
}

defined_info_DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function defined_info_mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const util_create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create_create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (util_create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new defined_info_DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[lib_normalize_normalize(prop)] = prop
      normal[lib_normalize_normalize(info.attribute)] = prop
    }
  }

  return new schema_Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/xlink.js


const xlink_xlink = create_create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/xml.js


const xml_xml = create_create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function case_sensitive_transform_caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function case_insensitive_transform_caseInsensitiveTransform(attributes, property) {
  return case_sensitive_transform_caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/xmlns.js



const xmlns_xmlns = create_create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: case_insensitive_transform_caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/aria.js



const aria_aria = create_create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: types_booleanish,
    ariaAutoComplete: null,
    ariaBusy: types_booleanish,
    ariaChecked: types_booleanish,
    ariaColCount: types_number,
    ariaColIndex: types_number,
    ariaColSpan: types_number,
    ariaControls: types_spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: types_spaceSeparated,
    ariaDetails: null,
    ariaDisabled: types_booleanish,
    ariaDropEffect: types_spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: types_booleanish,
    ariaFlowTo: types_spaceSeparated,
    ariaGrabbed: types_booleanish,
    ariaHasPopup: null,
    ariaHidden: types_booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: types_spaceSeparated,
    ariaLevel: types_number,
    ariaLive: null,
    ariaModal: types_booleanish,
    ariaMultiLine: types_booleanish,
    ariaMultiSelectable: types_booleanish,
    ariaOrientation: null,
    ariaOwns: types_spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: types_number,
    ariaPressed: types_booleanish,
    ariaReadOnly: types_booleanish,
    ariaRelevant: null,
    ariaRequired: types_booleanish,
    ariaRoleDescription: types_spaceSeparated,
    ariaRowCount: types_number,
    ariaRowIndex: types_number,
    ariaRowSpan: types_number,
    ariaSelected: types_booleanish,
    ariaSetSize: types_number,
    ariaSort: null,
    ariaValueMax: types_number,
    ariaValueMin: types_number,
    ariaValueNow: types_number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/html.js




const lib_html_html = create_create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: case_insensitive_transform_caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: types_commaSeparated,
    acceptCharset: types_spaceSeparated,
    accessKey: types_spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: util_types_boolean,
    allowPaymentRequest: util_types_boolean,
    allowUserMedia: util_types_boolean,
    alt: null,
    as: null,
    async: util_types_boolean,
    autoCapitalize: null,
    autoComplete: types_spaceSeparated,
    autoFocus: util_types_boolean,
    autoPlay: util_types_boolean,
    capture: util_types_boolean,
    charSet: null,
    checked: util_types_boolean,
    cite: null,
    className: types_spaceSeparated,
    cols: types_number,
    colSpan: null,
    content: null,
    contentEditable: types_booleanish,
    controls: util_types_boolean,
    controlsList: types_spaceSeparated,
    coords: types_number | types_commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: util_types_boolean,
    defer: util_types_boolean,
    dir: null,
    dirName: null,
    disabled: util_types_boolean,
    download: types_overloadedBoolean,
    draggable: types_booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: util_types_boolean,
    formTarget: null,
    headers: types_spaceSeparated,
    height: types_number,
    hidden: util_types_boolean,
    high: types_number,
    href: null,
    hrefLang: null,
    htmlFor: types_spaceSeparated,
    httpEquiv: types_spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: util_types_boolean,
    itemId: null,
    itemProp: types_spaceSeparated,
    itemRef: types_spaceSeparated,
    itemScope: util_types_boolean,
    itemType: types_spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: util_types_boolean,
    low: types_number,
    manifest: null,
    max: null,
    maxLength: types_number,
    media: null,
    method: null,
    min: null,
    minLength: types_number,
    multiple: util_types_boolean,
    muted: util_types_boolean,
    name: null,
    nonce: null,
    noModule: util_types_boolean,
    noValidate: util_types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: util_types_boolean,
    optimum: types_number,
    pattern: null,
    ping: types_spaceSeparated,
    placeholder: null,
    playsInline: util_types_boolean,
    poster: null,
    preload: null,
    readOnly: util_types_boolean,
    referrerPolicy: null,
    rel: types_spaceSeparated,
    required: util_types_boolean,
    reversed: util_types_boolean,
    rows: types_number,
    rowSpan: types_number,
    sandbox: types_spaceSeparated,
    scope: null,
    scoped: util_types_boolean,
    seamless: util_types_boolean,
    selected: util_types_boolean,
    shape: null,
    size: types_number,
    sizes: null,
    slot: null,
    span: types_number,
    spellCheck: types_booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: types_number,
    step: null,
    style: null,
    tabIndex: types_number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: util_types_boolean,
    useMap: null,
    value: types_booleanish,
    width: types_number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: types_spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: types_number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: types_number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: util_types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: util_types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: types_number, // `<img>` and `<object>`
    leftMargin: types_number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: types_number, // `<body>`
    marginWidth: types_number, // `<body>`
    noResize: util_types_boolean, // `<frame>`
    noHref: util_types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: util_types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: util_types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: types_number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: types_booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: types_number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: types_number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: util_types_boolean,
    disableRemotePlayback: util_types_boolean,
    prefix: null,
    property: null,
    results: types_number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/svg.js




const svg_svg = create_create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: case_sensitive_transform_caseSensitiveTransform,
  properties: {
    about: types_commaOrSpaceSeparated,
    accentHeight: types_number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: types_number,
    amplitude: types_number,
    arabicForm: null,
    ascent: types_number,
    attributeName: null,
    attributeType: null,
    azimuth: types_number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: types_number,
    by: null,
    calcMode: null,
    capHeight: types_number,
    className: types_spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: types_number,
    diffuseConstant: types_number,
    direction: null,
    display: null,
    dur: null,
    divisor: types_number,
    dominantBaseline: null,
    download: util_types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: types_number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: types_number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: types_number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: types_commaSeparated,
    g2: types_commaSeparated,
    glyphName: types_commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: types_number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: types_number,
    horizOriginX: types_number,
    horizOriginY: types_number,
    id: null,
    ideographic: types_number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: types_number,
    k: types_number,
    k1: types_number,
    k2: types_number,
    k3: types_number,
    k4: types_number,
    kernelMatrix: types_commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: types_number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: types_number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: types_number,
    overlineThickness: types_number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: types_number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: types_spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: types_number,
    pointsAtY: types_number,
    pointsAtZ: types_number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: types_commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: types_commaOrSpaceSeparated,
    rev: types_commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: types_commaOrSpaceSeparated,
    requiredFeatures: types_commaOrSpaceSeparated,
    requiredFonts: types_commaOrSpaceSeparated,
    requiredFormats: types_commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: types_number,
    specularExponent: types_number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: types_number,
    strikethroughThickness: types_number,
    string: null,
    stroke: null,
    strokeDashArray: types_commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: types_number,
    strokeOpacity: types_number,
    strokeWidth: null,
    style: null,
    surfaceScale: types_number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: types_commaOrSpaceSeparated,
    tabIndex: types_number,
    tableValues: null,
    target: null,
    targetX: types_number,
    targetY: types_number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: types_commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: types_number,
    underlineThickness: types_number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: types_number,
    values: null,
    vAlphabetic: types_number,
    vMathematical: types_number,
    vectorEffect: null,
    vHanging: types_number,
    vIdeographic: types_number,
    version: null,
    vertAdvY: types_number,
    vertOriginX: types_number,
    vertOriginY: types_number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: types_number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const node_modules_property_information_html = merge_merge([xml_xml, xlink_xlink, xmlns_xmlns, aria_aria, lib_html_html], 'html')
const node_modules_property_information_svg = merge_merge([xml_xml, xlink_xlink, xmlns_xmlns, aria_aria, svg_svg], 'svg')

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const find_valid = /^data[-\w.:]+$/i
const find_dash = /-[a-z]/g
const find_cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find_find(schema, value) {
  const normal = lib_normalize_normalize(value)
  let prop = value
  let Type = info_Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && find_valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(find_dash, find_camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!find_dash.test(rest)) {
        let dashes = rest.replace(find_cap, find_kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = defined_info_DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function find_kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function find_camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-parse-selector/lib/index.js
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 */

const lib_search = /[#.]/g

/**
 * Create a hast element from a simple CSS selector.
 *
 * @template {string} Selector
 *   Type of selector.
 * @template {string} [DefaultTagName='div']
 *   Type of default tag name.
 * @param {Selector | null | undefined} [selector]
 *   Simple CSS selector.
 *
 *   Can contain a tag name (`foo`), classes (`.bar`), and an ID (`#baz`).
 *   Multiple classes are allowed.
 *   Uses the last ID if multiple IDs are found.
 * @param {DefaultTagName | null | undefined} [defaultTagName='div']
 *   Tag name to use if `selector` does not specify one (default: `'div'`).
 * @returns {Element & {tagName: import('./extract.js').ExtractTagName<Selector, DefaultTagName>}}
 *   Built element.
 */
function parseSelector(selector, defaultTagName) {
  const value = selector || ''
  /** @type {Properties} */
  const props = {}
  let start = 0
  /** @type {string | undefined} */
  let previous
  /** @type {string | undefined} */
  let tagName

  while (start < value.length) {
    lib_search.lastIndex = start
    const match = lib_search.exec(value)
    const subvalue = value.slice(start, match ? match.index : value.length)

    if (subvalue) {
      if (!previous) {
        tagName = subvalue
      } else if (previous === '#') {
        props.id = subvalue
      } else if (Array.isArray(props.className)) {
        props.className.push(subvalue)
      } else {
        props.className = [subvalue]
      }

      start += subvalue.length
    }

    if (match) {
      previous = match[0]
      start++
    }
  }

  return {
    type: 'element',
    // @ts-expect-error: fine.
    tagName: tagName || defaultTagName || 'div',
    properties: props,
    children: []
  }
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/node_modules/space-separated-tokens/index.js
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function node_modules_space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function space_separated_tokens_stringify(values) {
  return values.join(' ').trim()
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/lib/core.js
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Content} Content
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 */

/**
 * @typedef {Content | Root} Node
 *   Any concrete `hast` node.
 * @typedef {Root | Element} HResult
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {string | number} HStyleValue
 *   Value for a CSS style field.
 * @typedef {Record<string, HStyleValue>} HStyle
 *   Supported value of a `style` prop.
 * @typedef {string | number | boolean | null | undefined} HPrimitiveValue
 *   Primitive property value.
 * @typedef {Array<string | number>} HArrayValue
 *   List of property values for space- or comma separated values (such as `className`).
 * @typedef {HPrimitiveValue | HArrayValue} HPropertyValue
 *   Primitive value or list value.
 * @typedef {{[property: string]: HPropertyValue | HStyle}} HProperties
 *   Acceptable value for element properties.
 *
 * @typedef {string | number | null | undefined} HPrimitiveChild
 *   Primitive children, either ignored (nullish), or turned into text nodes.
 * @typedef {Array<Node | HPrimitiveChild>} HArrayChild
 *   List of children.
 * @typedef {Node | HPrimitiveChild | HArrayChild} HChild
 *   Acceptable child value.
 */






const buttonTypes = new Set(['menu', 'submit', 'reset', 'button'])

const core_own = {}.hasOwnProperty

/**
 * @param {Schema} schema
 * @param {string} defaultTagName
 * @param {Array<string>} [caseSensitive]
 */
function core(schema, defaultTagName, caseSensitive) {
  const adjust = caseSensitive && createAdjustMap(caseSensitive)

  const h =
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    (
      /**
       * Hyperscript compatible DSL for creating virtual hast trees.
       *
       * @param {string | null} [selector]
       * @param {HProperties | HChild} [properties]
       * @param {Array<HChild>} children
       * @returns {HResult}
       */
      function (selector, properties, ...children) {
        let index = -1
        /** @type {HResult} */
        let node

        if (selector === undefined || selector === null) {
          node = {type: 'root', children: []}
          // @ts-expect-error Properties are not supported for roots.
          children.unshift(properties)
        } else {
          node = parseSelector(selector, defaultTagName)
          // Normalize the name.
          node.tagName = node.tagName.toLowerCase()
          if (adjust && core_own.call(adjust, node.tagName)) {
            node.tagName = adjust[node.tagName]
          }

          // Handle props.
          if (isProperties(properties, node.tagName)) {
            /** @type {string} */
            let key

            for (key in properties) {
              if (core_own.call(properties, key)) {
                // @ts-expect-error `node.properties` is set.
                core_addProperty(schema, node.properties, key, properties[key])
              }
            }
          } else {
            children.unshift(properties)
          }
        }

        // Handle children.
        while (++index < children.length) {
          addChild(node.children, children[index])
        }

        if (node.type === 'element' && node.tagName === 'template') {
          node.content = {type: 'root', children: node.children}
          node.children = []
        }

        return node
      }
    )

  return h
}

/**
 * @param {HProperties | HChild} value
 * @param {string} name
 * @returns {value is HProperties}
 */
function isProperties(value, name) {
  if (
    value === null ||
    value === undefined ||
    typeof value !== 'object' ||
    Array.isArray(value)
  ) {
    return false
  }

  if (name === 'input' || !value.type || typeof value.type !== 'string') {
    return true
  }

  if ('children' in value && Array.isArray(value.children)) {
    return false
  }

  if (name === 'button') {
    return buttonTypes.has(value.type.toLowerCase())
  }

  return !('value' in value)
}

/**
 * @param {Schema} schema
 * @param {Properties} properties
 * @param {string} key
 * @param {HStyle | HPropertyValue} value
 * @returns {void}
 */
function core_addProperty(schema, properties, key, value) {
  const info = find_find(schema, key)
  let index = -1
  /** @type {HPropertyValue} */
  let result

  // Ignore nullish and NaN values.
  if (value === undefined || value === null) return

  if (typeof value === 'number') {
    // Ignore NaN.
    if (Number.isNaN(value)) return

    result = value
  }
  // Booleans.
  else if (typeof value === 'boolean') {
    result = value
  }
  // Handle list values.
  else if (typeof value === 'string') {
    if (info.spaceSeparated) {
      result = node_modules_space_separated_tokens_parse(value)
    } else if (info.commaSeparated) {
      result = comma_separated_tokens_parse(value)
    } else if (info.commaOrSpaceSeparated) {
      result = node_modules_space_separated_tokens_parse(comma_separated_tokens_parse(value).join(' '))
    } else {
      result = parsePrimitive(info, info.property, value)
    }
  } else if (Array.isArray(value)) {
    result = value.concat()
  } else {
    result = info.property === 'style' ? style(value) : String(value)
  }

  if (Array.isArray(result)) {
    /** @type {Array<string | number>} */
    const finalResult = []

    while (++index < result.length) {
      // @ts-expect-error Assume no booleans in array.
      finalResult[index] = parsePrimitive(info, info.property, result[index])
    }

    result = finalResult
  }

  // Class names (which can be added both on the `selector` and here).
  if (info.property === 'className' && Array.isArray(properties.className)) {
    // @ts-expect-error Assume no booleans in `className`.
    result = properties.className.concat(result)
  }

  properties[info.property] = result
}

/**
 * @param {Array<Content>} nodes
 * @param {HChild} value
 * @returns {void}
 */
function addChild(nodes, value) {
  let index = -1

  if (value === undefined || value === null) {
    // Empty.
  } else if (typeof value === 'string' || typeof value === 'number') {
    nodes.push({type: 'text', value: String(value)})
  } else if (Array.isArray(value)) {
    while (++index < value.length) {
      addChild(nodes, value[index])
    }
  } else if (typeof value === 'object' && 'type' in value) {
    if (value.type === 'root') {
      addChild(nodes, value.children)
    } else {
      nodes.push(value)
    }
  } else {
    throw new Error('Expected node, nodes, or string, got `' + value + '`')
  }
}

/**
 * Parse a single primitives.
 *
 * @param {Info} info
 * @param {string} name
 * @param {HPrimitiveValue} value
 * @returns {HPrimitiveValue}
 */
function parsePrimitive(info, name, value) {
  if (typeof value === 'string') {
    if (info.number && value && !Number.isNaN(Number(value))) {
      return Number(value)
    }

    if (
      (info.boolean || info.overloadedBoolean) &&
      (value === '' || lib_normalize_normalize(value) === lib_normalize_normalize(name))
    ) {
      return true
    }
  }

  return value
}

/**
 * Serialize a `style` object as a string.
 *
 * @param {HStyle} value
 *   Style object.
 * @returns {string}
 *   CSS string.
 */
function style(value) {
  /** @type {Array<string>} */
  const result = []
  /** @type {string} */
  let key

  for (key in value) {
    if (core_own.call(value, key)) {
      result.push([key, value[key]].join(': '))
    }
  }

  return result.join('; ')
}

/**
 * Create a map to adjust casing.
 *
 * @param {Array<string>} values
 *   List of properly cased keys.
 * @returns {Record<string, string>}
 *   Map of lowercase keys to uppercase keys.
 */
function createAdjustMap(values) {
  /** @type {Record<string, string>} */
  const result = {}
  let index = -1

  while (++index < values.length) {
    result[values[index].toLowerCase()] = values[index]
  }

  return result
}

;// CONCATENATED MODULE: ../../node_modules/hastscript/lib/svg-case-sensitive-tag-names.js
const svgCaseSensitiveTagNames = [
  'altGlyph',
  'altGlyphDef',
  'altGlyphItem',
  'animateColor',
  'animateMotion',
  'animateTransform',
  'clipPath',
  'feBlend',
  'feColorMatrix',
  'feComponentTransfer',
  'feComposite',
  'feConvolveMatrix',
  'feDiffuseLighting',
  'feDisplacementMap',
  'feDistantLight',
  'feDropShadow',
  'feFlood',
  'feFuncA',
  'feFuncB',
  'feFuncG',
  'feFuncR',
  'feGaussianBlur',
  'feImage',
  'feMerge',
  'feMergeNode',
  'feMorphology',
  'feOffset',
  'fePointLight',
  'feSpecularLighting',
  'feSpotLight',
  'feTile',
  'feTurbulence',
  'foreignObject',
  'glyphRef',
  'linearGradient',
  'radialGradient',
  'solidColor',
  'textArea',
  'textPath'
]

;// CONCATENATED MODULE: ../../node_modules/hastscript/lib/svg.js
/**
 * @typedef {import('./core.js').HChild} Child
 *   Acceptable child value.
 * @typedef {import('./core.js').HProperties} Properties
 *   Acceptable value for element properties.
 * @typedef {import('./core.js').HResult} Result
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {import('./jsx-classic.js').Element} s.JSX.Element
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} s.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} s.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} s.JSX.ElementChildrenAttribute
 */





const s = core(node_modules_property_information_svg, 'g', svgCaseSensitiveTagNames)

;// CONCATENATED MODULE: ../../node_modules/hastscript/lib/html.js
/**
 * @typedef {import('./core.js').HChild} Child
 *   Acceptable child value.
 * @typedef {import('./core.js').HProperties} Properties
 *   Acceptable value for element properties.
 * @typedef {import('./core.js').HResult} Result
 *   Result from a `h` (or `s`) call.
 *
 * @typedef {import('./jsx-classic.js').Element} h.JSX.Element
 * @typedef {import('./jsx-classic.js').IntrinsicAttributes} h.JSX.IntrinsicAttributes
 * @typedef {import('./jsx-classic.js').IntrinsicElements} h.JSX.IntrinsicElements
 * @typedef {import('./jsx-classic.js').ElementChildrenAttribute} h.JSX.ElementChildrenAttribute
 */




const h = core(node_modules_property_information_html, 'div')

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class util_schema_Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
util_schema_Schema.prototype.property = {}
/** @type {Normal} */
util_schema_Schema.prototype.normal = {}
/** @type {string|null} */
util_schema_Schema.prototype.space = null

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function util_merge_merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new util_schema_Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function property_information_lib_normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/info.js
class util_info_Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
util_info_Info.prototype.space = null
util_info_Info.prototype.boolean = false
util_info_Info.prototype.booleanish = false
util_info_Info.prototype.overloadedBoolean = false
util_info_Info.prototype.number = false
util_info_Info.prototype.commaSeparated = false
util_info_Info.prototype.spaceSeparated = false
util_info_Info.prototype.commaOrSpaceSeparated = false
util_info_Info.prototype.mustUseProperty = false
util_info_Info.prototype.defined = false

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/types.js
let util_types_powers = 0

const lib_util_types_boolean = util_types_increment()
const util_types_booleanish = util_types_increment()
const util_types_overloadedBoolean = util_types_increment()
const util_types_number = util_types_increment()
const util_types_spaceSeparated = util_types_increment()
const util_types_commaSeparated = util_types_increment()
const util_types_commaOrSpaceSeparated = util_types_increment()

function util_types_increment() {
  return 2 ** ++util_types_powers
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const util_defined_info_checks = Object.keys(lib_util_types_namespaceObject)

class util_defined_info_DefinedInfo extends util_info_Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    util_defined_info_mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < util_defined_info_checks.length) {
        const check = util_defined_info_checks[index]
        util_defined_info_mark(this, util_defined_info_checks[index], (mask & lib_util_types_namespaceObject[check]) === lib_util_types_namespaceObject[check])
      }
    }
  }
}

util_defined_info_DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function util_defined_info_mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const lib_util_create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function util_create_create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (lib_util_create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new util_defined_info_DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[property_information_lib_normalize_normalize(prop)] = prop
      normal[property_information_lib_normalize_normalize(info.attribute)] = prop
    }
  }

  return new util_schema_Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/xlink.js


const lib_xlink_xlink = util_create_create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/xml.js


const lib_xml_xml = util_create_create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function util_case_sensitive_transform_caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function util_case_insensitive_transform_caseInsensitiveTransform(attributes, property) {
  return util_case_sensitive_transform_caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/xmlns.js



const lib_xmlns_xmlns = util_create_create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: util_case_insensitive_transform_caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/aria.js



const lib_aria_aria = util_create_create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: util_types_booleanish,
    ariaAutoComplete: null,
    ariaBusy: util_types_booleanish,
    ariaChecked: util_types_booleanish,
    ariaColCount: util_types_number,
    ariaColIndex: util_types_number,
    ariaColSpan: util_types_number,
    ariaControls: util_types_spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: util_types_spaceSeparated,
    ariaDetails: null,
    ariaDisabled: util_types_booleanish,
    ariaDropEffect: util_types_spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: util_types_booleanish,
    ariaFlowTo: util_types_spaceSeparated,
    ariaGrabbed: util_types_booleanish,
    ariaHasPopup: null,
    ariaHidden: util_types_booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: util_types_spaceSeparated,
    ariaLevel: util_types_number,
    ariaLive: null,
    ariaModal: util_types_booleanish,
    ariaMultiLine: util_types_booleanish,
    ariaMultiSelectable: util_types_booleanish,
    ariaOrientation: null,
    ariaOwns: util_types_spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: util_types_number,
    ariaPressed: util_types_booleanish,
    ariaReadOnly: util_types_booleanish,
    ariaRelevant: null,
    ariaRequired: util_types_booleanish,
    ariaRoleDescription: util_types_spaceSeparated,
    ariaRowCount: util_types_number,
    ariaRowIndex: util_types_number,
    ariaRowSpan: util_types_number,
    ariaSelected: util_types_booleanish,
    ariaSetSize: util_types_number,
    ariaSort: null,
    ariaValueMax: util_types_number,
    ariaValueMin: util_types_number,
    ariaValueNow: util_types_number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/html.js




const property_information_lib_html_html = util_create_create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: util_case_insensitive_transform_caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: util_types_commaSeparated,
    acceptCharset: util_types_spaceSeparated,
    accessKey: util_types_spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: lib_util_types_boolean,
    allowPaymentRequest: lib_util_types_boolean,
    allowUserMedia: lib_util_types_boolean,
    alt: null,
    as: null,
    async: lib_util_types_boolean,
    autoCapitalize: null,
    autoComplete: util_types_spaceSeparated,
    autoFocus: lib_util_types_boolean,
    autoPlay: lib_util_types_boolean,
    capture: lib_util_types_boolean,
    charSet: null,
    checked: lib_util_types_boolean,
    cite: null,
    className: util_types_spaceSeparated,
    cols: util_types_number,
    colSpan: null,
    content: null,
    contentEditable: util_types_booleanish,
    controls: lib_util_types_boolean,
    controlsList: util_types_spaceSeparated,
    coords: util_types_number | util_types_commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: lib_util_types_boolean,
    defer: lib_util_types_boolean,
    dir: null,
    dirName: null,
    disabled: lib_util_types_boolean,
    download: util_types_overloadedBoolean,
    draggable: util_types_booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: lib_util_types_boolean,
    formTarget: null,
    headers: util_types_spaceSeparated,
    height: util_types_number,
    hidden: lib_util_types_boolean,
    high: util_types_number,
    href: null,
    hrefLang: null,
    htmlFor: util_types_spaceSeparated,
    httpEquiv: util_types_spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: lib_util_types_boolean,
    itemId: null,
    itemProp: util_types_spaceSeparated,
    itemRef: util_types_spaceSeparated,
    itemScope: lib_util_types_boolean,
    itemType: util_types_spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: lib_util_types_boolean,
    low: util_types_number,
    manifest: null,
    max: null,
    maxLength: util_types_number,
    media: null,
    method: null,
    min: null,
    minLength: util_types_number,
    multiple: lib_util_types_boolean,
    muted: lib_util_types_boolean,
    name: null,
    nonce: null,
    noModule: lib_util_types_boolean,
    noValidate: lib_util_types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: lib_util_types_boolean,
    optimum: util_types_number,
    pattern: null,
    ping: util_types_spaceSeparated,
    placeholder: null,
    playsInline: lib_util_types_boolean,
    poster: null,
    preload: null,
    readOnly: lib_util_types_boolean,
    referrerPolicy: null,
    rel: util_types_spaceSeparated,
    required: lib_util_types_boolean,
    reversed: lib_util_types_boolean,
    rows: util_types_number,
    rowSpan: util_types_number,
    sandbox: util_types_spaceSeparated,
    scope: null,
    scoped: lib_util_types_boolean,
    seamless: lib_util_types_boolean,
    selected: lib_util_types_boolean,
    shape: null,
    size: util_types_number,
    sizes: null,
    slot: null,
    span: util_types_number,
    spellCheck: util_types_booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: util_types_number,
    step: null,
    style: null,
    tabIndex: util_types_number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: lib_util_types_boolean,
    useMap: null,
    value: util_types_booleanish,
    width: util_types_number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: util_types_spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: util_types_number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: util_types_number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: lib_util_types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: lib_util_types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: util_types_number, // `<img>` and `<object>`
    leftMargin: util_types_number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: util_types_number, // `<body>`
    marginWidth: util_types_number, // `<body>`
    noResize: lib_util_types_boolean, // `<frame>`
    noHref: lib_util_types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: lib_util_types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: lib_util_types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: util_types_number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: util_types_booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: util_types_number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: util_types_number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: lib_util_types_boolean,
    disableRemotePlayback: lib_util_types_boolean,
    prefix: null,
    property: null,
    results: util_types_number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/svg.js




const lib_svg_svg = util_create_create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: util_case_sensitive_transform_caseSensitiveTransform,
  properties: {
    about: util_types_commaOrSpaceSeparated,
    accentHeight: util_types_number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: util_types_number,
    amplitude: util_types_number,
    arabicForm: null,
    ascent: util_types_number,
    attributeName: null,
    attributeType: null,
    azimuth: util_types_number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: util_types_number,
    by: null,
    calcMode: null,
    capHeight: util_types_number,
    className: util_types_spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: util_types_number,
    diffuseConstant: util_types_number,
    direction: null,
    display: null,
    dur: null,
    divisor: util_types_number,
    dominantBaseline: null,
    download: lib_util_types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: util_types_number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: util_types_number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: util_types_number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: util_types_commaSeparated,
    g2: util_types_commaSeparated,
    glyphName: util_types_commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: util_types_number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: util_types_number,
    horizOriginX: util_types_number,
    horizOriginY: util_types_number,
    id: null,
    ideographic: util_types_number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: util_types_number,
    k: util_types_number,
    k1: util_types_number,
    k2: util_types_number,
    k3: util_types_number,
    k4: util_types_number,
    kernelMatrix: util_types_commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: util_types_number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: util_types_number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: util_types_number,
    overlineThickness: util_types_number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: util_types_number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: util_types_spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: util_types_number,
    pointsAtY: util_types_number,
    pointsAtZ: util_types_number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: util_types_commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: util_types_commaOrSpaceSeparated,
    rev: util_types_commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: util_types_commaOrSpaceSeparated,
    requiredFeatures: util_types_commaOrSpaceSeparated,
    requiredFonts: util_types_commaOrSpaceSeparated,
    requiredFormats: util_types_commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: util_types_number,
    specularExponent: util_types_number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: util_types_number,
    strikethroughThickness: util_types_number,
    string: null,
    stroke: null,
    strokeDashArray: util_types_commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: util_types_number,
    strokeOpacity: util_types_number,
    strokeWidth: null,
    style: null,
    surfaceScale: util_types_number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: util_types_commaOrSpaceSeparated,
    tabIndex: util_types_number,
    tableValues: null,
    target: null,
    targetX: util_types_number,
    targetY: util_types_number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: util_types_commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: util_types_number,
    underlineThickness: util_types_number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: util_types_number,
    values: null,
    vAlphabetic: util_types_number,
    vMathematical: util_types_number,
    vectorEffect: null,
    vHanging: util_types_number,
    vIdeographic: util_types_number,
    version: null,
    vertAdvY: util_types_number,
    vertOriginX: util_types_number,
    vertOriginY: util_types_number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: util_types_number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const hast_util_from_parse5_node_modules_property_information_html = util_merge_merge([lib_xml_xml, lib_xlink_xlink, lib_xmlns_xmlns, lib_aria_aria, property_information_lib_html_html], 'html')
const hast_util_from_parse5_node_modules_property_information_svg = util_merge_merge([lib_xml_xml, lib_xlink_xlink, lib_xmlns_xmlns, lib_aria_aria, lib_svg_svg], 'svg')

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const lib_find_valid = /^data[-\w.:]+$/i
const lib_find_dash = /-[a-z]/g
const lib_find_cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function lib_find_find(schema, value) {
  const normal = property_information_lib_normalize_normalize(value)
  let prop = value
  let Type = util_info_Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && lib_find_valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(lib_find_dash, lib_find_camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!lib_find_dash.test(rest)) {
        let dashes = rest.replace(lib_find_cap, lib_find_kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = util_defined_info_DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function lib_find_kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function lib_find_camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/vfile-location/lib/index.js
/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('vfile').Value} Value
 */

/**
 * @typedef Point
 *   unist point, where `line` and `column` can be `undefined`.
 * @property {number | undefined} line
 *   Line.
 * @property {number | undefined} column
 *   Column.
 * @property {number | undefined} [offset]
 *   Offset.
 *
 * @typedef PointLike
 *   unist point, allowed as input.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @callback ToPoint
 *   Get a line/column-based `point` from `offset`.
 * @param {number | null | undefined} [offset]
 *   Something that should be an `offset.
 * @returns {Point}
 *   Point, line/column are undefined for invalid or out of bounds input.
 *
 * @callback ToOffset
 *   Get an offset from a line/column-based `point`.
 * @param {Point | null | undefined} [point]
 *   Something that should be a `point.
 * @returns {number}
 *   Offset or `-1` for invalid or out of bounds input.
 *
 * @typedef Location
 *   Accessors for index.
 * @property {ToPoint} toPoint
 *   Get a line/column-based `point` from `offset`.
 * @property {ToOffset} toOffset
 *   Get an offset from a line/column-based `point`.
 */

/**
 * Index the given document so you can translate between line/column and offset
 * based positional info.
 *
 * @param {VFile | Value} file
 *   File to index.
 * @returns {Location}
 *   Accessors for index.
 */
function lib_location(file) {
  const value = String(file)
  /** @type {Array<number>} */
  const indices = []
  const search = /\r?\n|\r/g

  while (search.test(value)) {
    indices.push(search.lastIndex)
  }

  indices.push(value.length + 1)

  return {toPoint, toOffset}

  /** @type {ToPoint} */
  function toPoint(offset) {
    let index = -1

    if (
      typeof offset === 'number' &&
      offset > -1 &&
      offset < indices[indices.length - 1]
    ) {
      while (++index < indices.length) {
        if (indices[index] > offset) {
          return {
            line: index + 1,
            column: offset - (index > 0 ? indices[index - 1] : 0) + 1,
            offset
          }
        }
      }
    }

    return {line: undefined, column: undefined, offset: undefined}
  }

  /** @type {ToOffset} */
  function toOffset(point) {
    const line = point && point.line
    const column = point && point.column

    if (
      typeof line === 'number' &&
      typeof column === 'number' &&
      !Number.isNaN(line) &&
      !Number.isNaN(column) &&
      line - 1 in indices
    ) {
      const offset = (indices[line - 2] || 0) + column - 1 || 0

      if (offset > -1 && offset < indices[indices.length - 1]) {
        return offset
      }
    }

    return -1
  }
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/node_modules/web-namespaces/index.js
/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */
const webNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/'
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-from-parse5/lib/index.js
/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Content} Content
 * @typedef {import('parse5').DefaultTreeAdapterMap} DefaultTreeAdapterMap
 * @typedef {import('parse5').Token.ElementLocation} P5ElementLocation
 * @typedef {import('parse5').Token.Location} P5Location
 */

/**
 * @typedef {Content | Root} Node
 * @typedef {DefaultTreeAdapterMap['document']} P5Document
 * @typedef {DefaultTreeAdapterMap['documentFragment']} P5DocumentFragment
 * @typedef {DefaultTreeAdapterMap['documentType']} P5DocumentType
 * @typedef {DefaultTreeAdapterMap['commentNode']} P5Comment
 * @typedef {DefaultTreeAdapterMap['textNode']} P5Text
 * @typedef {DefaultTreeAdapterMap['element']} P5Element
 * @typedef {DefaultTreeAdapterMap['node']} P5Node
 * @typedef {DefaultTreeAdapterMap['template']} P5Template
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef Options
 *   Configuration.
 * @property {Space | null | undefined} [space='html']
 *   Which space the document is in.
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {VFile | null | undefined} [file]
 *   File used to add positional info to nodes.
 *
 *   If given, the file should represent the original HTML source.
 * @property {boolean} [verbose=false]
 *   Whether to add extra positional info about starting tags, closing tags,
 *   and attributes to elements.
 *
 *   > 👉 **Note**: only used when `file` is given.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {Schema} schema
 *   Current schema.
 * @property {VFile | undefined} file
 *   Corresponding file.
 * @property {boolean | undefined} verbose
 *   Add extra positional info.
 * @property {boolean} location
 *   Whether location info was found.
 */






const hast_util_from_parse5_lib_own = {}.hasOwnProperty
/** @type {unknown} */
// type-coverage:ignore-next-line
const proto = Object.prototype

/**
 * Transform a `parse5` AST to hast.
 *
 * @param {P5Node} tree
 *   `parse5` tree to transform.
 * @param {Options | VFile | null | undefined} [options]
 *   Configuration.
 * @returns {Node}
 *   hast tree.
 */
function fromParse5(tree, options) {
  const options_ = options || {}
  /** @type {Options} */
  let settings
  /** @type {VFile | undefined} */
  let file

  if (isFile(options_)) {
    file = options_
    settings = {}
  } else {
    file = options_.file || undefined
    settings = options_
  }

  return lib_one(
    {
      schema: settings.space === 'svg' ? hast_util_from_parse5_node_modules_property_information_svg : hast_util_from_parse5_node_modules_property_information_html,
      file,
      verbose: settings.verbose,
      location: false
    },
    tree
  )
}

/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {P5Node} node
 *   p5 node.
 * @returns {Node}
 *   hast node.
 */
function lib_one(state, node) {
  /** @type {Node} */
  let result

  switch (node.nodeName) {
    case '#comment': {
      const reference = /** @type {P5Comment} */ (node)
      result = {type: 'comment', value: reference.data}
      lib_patch(state, reference, result)
      return result
    }

    case '#document':
    case '#document-fragment': {
      const reference = /** @type {P5Document | P5DocumentFragment} */ (node)
      const quirksMode =
        'mode' in reference
          ? reference.mode === 'quirks' || reference.mode === 'limited-quirks'
          : false

      result = {
        type: 'root',
        children: lib_all(state, node.childNodes),
        data: {quirksMode}
      }

      if (state.file && state.location) {
        const doc = String(state.file)
        const loc = lib_location(doc)
        const start = loc.toPoint(0)
        const end = loc.toPoint(doc.length)
        // @ts-expect-error: always defined as we give valid input.
        result.position = {start, end}
      }

      return result
    }

    case '#documentType': {
      const reference = /** @type {P5DocumentType} */ (node)
      // @ts-expect-error Types are out of date.
      result = {type: 'doctype'}
      lib_patch(state, reference, result)
      return result
    }

    case '#text': {
      const reference = /** @type {P5Text} */ (node)
      result = {type: 'text', value: reference.value}
      lib_patch(state, reference, result)
      return result
    }

    // Element.
    default: {
      const reference = /** @type {P5Element} */ (node)
      result = lib_element(state, reference)
      return result
    }
  }
}

/**
 * Transform children.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Array<P5Node>} nodes
 *   Nodes.
 * @returns {Array<Content>}
 *   hast nodes.
 */
function lib_all(state, nodes) {
  let index = -1
  /** @type {Array<Content>} */
  const result = []

  while (++index < nodes.length) {
    // @ts-expect-error Assume no roots in `nodes`.
    result[index] = lib_one(state, nodes[index])
  }

  return result
}

/**
 * Transform an element.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {P5Element} node
 *   `parse5` node to transform.
 * @returns {Element}
 *   hast node.
 */
function lib_element(state, node) {
  const schema = state.schema

  state.schema = node.namespaceURI === webNamespaces.svg ? hast_util_from_parse5_node_modules_property_information_svg : hast_util_from_parse5_node_modules_property_information_html

  // Props.
  let index = -1
  /** @type {Record<string, string>} */
  const props = {}

  while (++index < node.attrs.length) {
    const attribute = node.attrs[index]
    const name =
      (attribute.prefix ? attribute.prefix + ':' : '') + attribute.name
    if (!hast_util_from_parse5_lib_own.call(proto, name)) {
      props[name] = attribute.value
    }
  }

  // Build.
  const fn = state.schema.space === 'svg' ? s : h
  const result = fn(node.tagName, props, lib_all(state, node.childNodes))
  lib_patch(state, node, result)

  // Switch content.
  if (result.tagName === 'template') {
    const reference = /** @type {P5Template} */ (node)
    const pos = reference.sourceCodeLocation
    const startTag = pos && pos.startTag && lib_position(pos.startTag)
    const endTag = pos && pos.endTag && lib_position(pos.endTag)

    /** @type {Root} */
    // @ts-expect-error Types are wrong.
    const content = lib_one(state, reference.content)

    if (startTag && endTag && state.file) {
      content.position = {start: startTag.end, end: endTag.start}
    }

    result.content = content
  }

  state.schema = schema

  return result
}

/**
 * Patch positional info from `from` onto `to`.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {P5Node} from
 *   p5 node.
 * @param {Node} to
 *   hast node.
 * @returns {void}
 *   Nothing.
 */
function lib_patch(state, from, to) {
  if ('sourceCodeLocation' in from && from.sourceCodeLocation && state.file) {
    const position = createLocation(state, to, from.sourceCodeLocation)

    if (position) {
      state.location = true
      to.position = position
    }
  }
}

/**
 * Create clean positional information.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Node} node
 *   hast node.
 * @param {P5ElementLocation} location
 *   p5 location info.
 * @returns {Position | undefined}
 *   Position, or nothing.
 */
function createLocation(state, node, location) {
  const result = lib_position(location)

  if (node.type === 'element') {
    const tail = node.children[node.children.length - 1]

    // Bug for unclosed with children.
    // See: <https://github.com/inikulin/parse5/issues/109>.
    if (
      result &&
      !location.endTag &&
      tail &&
      tail.position &&
      tail.position.end
    ) {
      result.end = Object.assign({}, tail.position.end)
    }

    if (state.verbose) {
      /** @type {Record<string, Position | undefined>} */
      const props = {}
      /** @type {string} */
      let key

      if (location.attrs) {
        for (key in location.attrs) {
          if (hast_util_from_parse5_lib_own.call(location.attrs, key)) {
            props[lib_find_find(state.schema, key).property] = lib_position(
              location.attrs[key]
            )
          }
        }
      }

      node.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: lib_position(location.startTag),
          closing: location.endTag ? lib_position(location.endTag) : null,
          properties: props
        }
      }
    }
  }

  return result
}

/**
 * Turn a p5 location into a position.
 *
 * @param {P5Location} loc
 *   Location.
 * @returns {Position | undefined}
 *   Position or nothing.
 */
function lib_position(loc) {
  const start = lib_point({
    line: loc.startLine,
    column: loc.startCol,
    offset: loc.startOffset
  })
  const end = lib_point({
    line: loc.endLine,
    column: loc.endCol,
    offset: loc.endOffset
  })
  // @ts-expect-error `undefined` is fine.
  return start || end ? {start, end} : undefined
}

/**
 * Filter out invalid points.
 *
 * @param {Point} point
 *   Point with potentially `undefined` values.
 * @returns {Point | undefined}
 *   Point or nothing.
 */
function lib_point(point) {
  return point.line && point.column ? point : undefined
}

/**
 * Check if something is a file.
 *
 * @param {VFile | Options} value
 *   File or options.
 * @returns {value is VFile}
 *   Whether `value` is a file.
 */
function isFile(value) {
  return 'messages' in value
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class lib_util_schema_Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
lib_util_schema_Schema.prototype.property = {}
/** @type {Normal} */
lib_util_schema_Schema.prototype.normal = {}
/** @type {string|null} */
lib_util_schema_Schema.prototype.space = null

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function lib_util_merge_merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new lib_util_schema_Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function node_modules_property_information_lib_normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/info.js
class lib_util_info_Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
lib_util_info_Info.prototype.space = null
lib_util_info_Info.prototype.boolean = false
lib_util_info_Info.prototype.booleanish = false
lib_util_info_Info.prototype.overloadedBoolean = false
lib_util_info_Info.prototype.number = false
lib_util_info_Info.prototype.commaSeparated = false
lib_util_info_Info.prototype.spaceSeparated = false
lib_util_info_Info.prototype.commaOrSpaceSeparated = false
lib_util_info_Info.prototype.mustUseProperty = false
lib_util_info_Info.prototype.defined = false

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/types.js
let lib_util_types_powers = 0

const property_information_lib_util_types_boolean = lib_util_types_increment()
const lib_util_types_booleanish = lib_util_types_increment()
const lib_util_types_overloadedBoolean = lib_util_types_increment()
const lib_util_types_number = lib_util_types_increment()
const lib_util_types_spaceSeparated = lib_util_types_increment()
const lib_util_types_commaSeparated = lib_util_types_increment()
const lib_util_types_commaOrSpaceSeparated = lib_util_types_increment()

function lib_util_types_increment() {
  return 2 ** ++lib_util_types_powers
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const lib_util_defined_info_checks = Object.keys(property_information_lib_util_types_namespaceObject)

class lib_util_defined_info_DefinedInfo extends lib_util_info_Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    lib_util_defined_info_mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < lib_util_defined_info_checks.length) {
        const check = lib_util_defined_info_checks[index]
        lib_util_defined_info_mark(this, lib_util_defined_info_checks[index], (mask & property_information_lib_util_types_namespaceObject[check]) === property_information_lib_util_types_namespaceObject[check])
      }
    }
  }
}

lib_util_defined_info_DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function lib_util_defined_info_mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const property_information_lib_util_create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function lib_util_create_create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (property_information_lib_util_create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new lib_util_defined_info_DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[node_modules_property_information_lib_normalize_normalize(prop)] = prop
      normal[node_modules_property_information_lib_normalize_normalize(info.attribute)] = prop
    }
  }

  return new lib_util_schema_Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/xlink.js


const property_information_lib_xlink_xlink = lib_util_create_create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/xml.js


const property_information_lib_xml_xml = lib_util_create_create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function lib_util_case_sensitive_transform_caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function lib_util_case_insensitive_transform_caseInsensitiveTransform(attributes, property) {
  return lib_util_case_sensitive_transform_caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/xmlns.js



const property_information_lib_xmlns_xmlns = lib_util_create_create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: lib_util_case_insensitive_transform_caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/aria.js



const property_information_lib_aria_aria = lib_util_create_create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: lib_util_types_booleanish,
    ariaAutoComplete: null,
    ariaBusy: lib_util_types_booleanish,
    ariaChecked: lib_util_types_booleanish,
    ariaColCount: lib_util_types_number,
    ariaColIndex: lib_util_types_number,
    ariaColSpan: lib_util_types_number,
    ariaControls: lib_util_types_spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: lib_util_types_spaceSeparated,
    ariaDetails: null,
    ariaDisabled: lib_util_types_booleanish,
    ariaDropEffect: lib_util_types_spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: lib_util_types_booleanish,
    ariaFlowTo: lib_util_types_spaceSeparated,
    ariaGrabbed: lib_util_types_booleanish,
    ariaHasPopup: null,
    ariaHidden: lib_util_types_booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: lib_util_types_spaceSeparated,
    ariaLevel: lib_util_types_number,
    ariaLive: null,
    ariaModal: lib_util_types_booleanish,
    ariaMultiLine: lib_util_types_booleanish,
    ariaMultiSelectable: lib_util_types_booleanish,
    ariaOrientation: null,
    ariaOwns: lib_util_types_spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: lib_util_types_number,
    ariaPressed: lib_util_types_booleanish,
    ariaReadOnly: lib_util_types_booleanish,
    ariaRelevant: null,
    ariaRequired: lib_util_types_booleanish,
    ariaRoleDescription: lib_util_types_spaceSeparated,
    ariaRowCount: lib_util_types_number,
    ariaRowIndex: lib_util_types_number,
    ariaRowSpan: lib_util_types_number,
    ariaSelected: lib_util_types_booleanish,
    ariaSetSize: lib_util_types_number,
    ariaSort: null,
    ariaValueMax: lib_util_types_number,
    ariaValueMin: lib_util_types_number,
    ariaValueNow: lib_util_types_number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/html.js




const node_modules_property_information_lib_html_html = lib_util_create_create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: lib_util_case_insensitive_transform_caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: lib_util_types_commaSeparated,
    acceptCharset: lib_util_types_spaceSeparated,
    accessKey: lib_util_types_spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: property_information_lib_util_types_boolean,
    allowPaymentRequest: property_information_lib_util_types_boolean,
    allowUserMedia: property_information_lib_util_types_boolean,
    alt: null,
    as: null,
    async: property_information_lib_util_types_boolean,
    autoCapitalize: null,
    autoComplete: lib_util_types_spaceSeparated,
    autoFocus: property_information_lib_util_types_boolean,
    autoPlay: property_information_lib_util_types_boolean,
    capture: property_information_lib_util_types_boolean,
    charSet: null,
    checked: property_information_lib_util_types_boolean,
    cite: null,
    className: lib_util_types_spaceSeparated,
    cols: lib_util_types_number,
    colSpan: null,
    content: null,
    contentEditable: lib_util_types_booleanish,
    controls: property_information_lib_util_types_boolean,
    controlsList: lib_util_types_spaceSeparated,
    coords: lib_util_types_number | lib_util_types_commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: property_information_lib_util_types_boolean,
    defer: property_information_lib_util_types_boolean,
    dir: null,
    dirName: null,
    disabled: property_information_lib_util_types_boolean,
    download: lib_util_types_overloadedBoolean,
    draggable: lib_util_types_booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: property_information_lib_util_types_boolean,
    formTarget: null,
    headers: lib_util_types_spaceSeparated,
    height: lib_util_types_number,
    hidden: property_information_lib_util_types_boolean,
    high: lib_util_types_number,
    href: null,
    hrefLang: null,
    htmlFor: lib_util_types_spaceSeparated,
    httpEquiv: lib_util_types_spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: property_information_lib_util_types_boolean,
    itemId: null,
    itemProp: lib_util_types_spaceSeparated,
    itemRef: lib_util_types_spaceSeparated,
    itemScope: property_information_lib_util_types_boolean,
    itemType: lib_util_types_spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: property_information_lib_util_types_boolean,
    low: lib_util_types_number,
    manifest: null,
    max: null,
    maxLength: lib_util_types_number,
    media: null,
    method: null,
    min: null,
    minLength: lib_util_types_number,
    multiple: property_information_lib_util_types_boolean,
    muted: property_information_lib_util_types_boolean,
    name: null,
    nonce: null,
    noModule: property_information_lib_util_types_boolean,
    noValidate: property_information_lib_util_types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: property_information_lib_util_types_boolean,
    optimum: lib_util_types_number,
    pattern: null,
    ping: lib_util_types_spaceSeparated,
    placeholder: null,
    playsInline: property_information_lib_util_types_boolean,
    poster: null,
    preload: null,
    readOnly: property_information_lib_util_types_boolean,
    referrerPolicy: null,
    rel: lib_util_types_spaceSeparated,
    required: property_information_lib_util_types_boolean,
    reversed: property_information_lib_util_types_boolean,
    rows: lib_util_types_number,
    rowSpan: lib_util_types_number,
    sandbox: lib_util_types_spaceSeparated,
    scope: null,
    scoped: property_information_lib_util_types_boolean,
    seamless: property_information_lib_util_types_boolean,
    selected: property_information_lib_util_types_boolean,
    shape: null,
    size: lib_util_types_number,
    sizes: null,
    slot: null,
    span: lib_util_types_number,
    spellCheck: lib_util_types_booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: lib_util_types_number,
    step: null,
    style: null,
    tabIndex: lib_util_types_number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: property_information_lib_util_types_boolean,
    useMap: null,
    value: lib_util_types_booleanish,
    width: lib_util_types_number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: lib_util_types_spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: lib_util_types_number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: lib_util_types_number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: property_information_lib_util_types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: property_information_lib_util_types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: lib_util_types_number, // `<img>` and `<object>`
    leftMargin: lib_util_types_number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: lib_util_types_number, // `<body>`
    marginWidth: lib_util_types_number, // `<body>`
    noResize: property_information_lib_util_types_boolean, // `<frame>`
    noHref: property_information_lib_util_types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: property_information_lib_util_types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: property_information_lib_util_types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: lib_util_types_number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: lib_util_types_booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: lib_util_types_number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: lib_util_types_number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: property_information_lib_util_types_boolean,
    disableRemotePlayback: property_information_lib_util_types_boolean,
    prefix: null,
    property: null,
    results: lib_util_types_number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/svg.js




const property_information_lib_svg_svg = lib_util_create_create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: lib_util_case_sensitive_transform_caseSensitiveTransform,
  properties: {
    about: lib_util_types_commaOrSpaceSeparated,
    accentHeight: lib_util_types_number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: lib_util_types_number,
    amplitude: lib_util_types_number,
    arabicForm: null,
    ascent: lib_util_types_number,
    attributeName: null,
    attributeType: null,
    azimuth: lib_util_types_number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: lib_util_types_number,
    by: null,
    calcMode: null,
    capHeight: lib_util_types_number,
    className: lib_util_types_spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: lib_util_types_number,
    diffuseConstant: lib_util_types_number,
    direction: null,
    display: null,
    dur: null,
    divisor: lib_util_types_number,
    dominantBaseline: null,
    download: property_information_lib_util_types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: lib_util_types_number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: lib_util_types_number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: lib_util_types_number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: lib_util_types_commaSeparated,
    g2: lib_util_types_commaSeparated,
    glyphName: lib_util_types_commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: lib_util_types_number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: lib_util_types_number,
    horizOriginX: lib_util_types_number,
    horizOriginY: lib_util_types_number,
    id: null,
    ideographic: lib_util_types_number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: lib_util_types_number,
    k: lib_util_types_number,
    k1: lib_util_types_number,
    k2: lib_util_types_number,
    k3: lib_util_types_number,
    k4: lib_util_types_number,
    kernelMatrix: lib_util_types_commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: lib_util_types_number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: lib_util_types_number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: lib_util_types_number,
    overlineThickness: lib_util_types_number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: lib_util_types_number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: lib_util_types_spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: lib_util_types_number,
    pointsAtY: lib_util_types_number,
    pointsAtZ: lib_util_types_number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: lib_util_types_commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: lib_util_types_commaOrSpaceSeparated,
    rev: lib_util_types_commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: lib_util_types_commaOrSpaceSeparated,
    requiredFeatures: lib_util_types_commaOrSpaceSeparated,
    requiredFonts: lib_util_types_commaOrSpaceSeparated,
    requiredFormats: lib_util_types_commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: lib_util_types_number,
    specularExponent: lib_util_types_number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: lib_util_types_number,
    strikethroughThickness: lib_util_types_number,
    string: null,
    stroke: null,
    strokeDashArray: lib_util_types_commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: lib_util_types_number,
    strokeOpacity: lib_util_types_number,
    strokeWidth: null,
    style: null,
    surfaceScale: lib_util_types_number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: lib_util_types_commaOrSpaceSeparated,
    tabIndex: lib_util_types_number,
    tableValues: null,
    target: null,
    targetX: lib_util_types_number,
    targetY: lib_util_types_number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: lib_util_types_commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: lib_util_types_number,
    underlineThickness: lib_util_types_number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: lib_util_types_number,
    values: null,
    vAlphabetic: lib_util_types_number,
    vMathematical: lib_util_types_number,
    vectorEffect: null,
    vHanging: lib_util_types_number,
    vIdeographic: lib_util_types_number,
    version: null,
    vertAdvY: lib_util_types_number,
    vertOriginX: lib_util_types_number,
    vertOriginY: lib_util_types_number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: lib_util_types_number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const hast_util_to_parse5_node_modules_property_information_html = lib_util_merge_merge([property_information_lib_xml_xml, property_information_lib_xlink_xlink, property_information_lib_xmlns_xmlns, property_information_lib_aria_aria, node_modules_property_information_lib_html_html], 'html')
const hast_util_to_parse5_node_modules_property_information_svg = lib_util_merge_merge([property_information_lib_xml_xml, property_information_lib_xlink_xlink, property_information_lib_xmlns_xmlns, property_information_lib_aria_aria, property_information_lib_svg_svg], 'svg')

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const property_information_lib_find_valid = /^data[-\w.:]+$/i
const property_information_lib_find_dash = /-[a-z]/g
const property_information_lib_find_cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function property_information_lib_find_find(schema, value) {
  const normal = node_modules_property_information_lib_normalize_normalize(value)
  let prop = value
  let Type = lib_util_info_Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && property_information_lib_find_valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(property_information_lib_find_dash, property_information_lib_find_camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!property_information_lib_find_dash.test(rest)) {
        let dashes = rest.replace(property_information_lib_find_cap, property_information_lib_find_kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = lib_util_defined_info_DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function property_information_lib_find_kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function property_information_lib_find_camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/space-separated-tokens/index.js
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function hast_util_to_parse5_node_modules_space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function node_modules_space_separated_tokens_stringify(values) {
  return values.join(' ').trim()
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/node_modules/web-namespaces/index.js
/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */
const web_namespaces_webNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/'
}

;// CONCATENATED MODULE: ../../node_modules/zwitch/index.js
/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */

/**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */

/**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */

/**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */

const zwitch_own = {}.hasOwnProperty

/**
 * Handle values based on a field.
 *
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @param {string} key
 *   Field to switch on.
 * @param {Options<Invalid, Unknown, Handlers>} [options]
 *   Configuration (required).
 * @returns {{unknown: Unknown, invalid: Invalid, handlers: Handlers, (...parameters: Parameters<Handlers[keyof Handlers]>): ReturnType<Handlers[keyof Handlers]>, (...parameters: Parameters<Unknown>): ReturnType<Unknown>}}
 */
function zwitch(key, options) {
  const settings = options || {}

  /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */
  function one(value, ...parameters) {
    /** @type {Handler|undefined} */
    let fn = one.invalid
    const handlers = one.handlers

    if (value && zwitch_own.call(value, key)) {
      // @ts-expect-error Indexable.
      const id = String(value[key])
      // @ts-expect-error Indexable.
      fn = zwitch_own.call(handlers, id) ? handlers[id] : one.unknown
    }

    if (fn) {
      return fn.call(this, value, ...parameters)
    }
  }

  one.handlers = settings.handlers || {}
  one.invalid = settings.invalid
  one.unknown = settings.unknown

  // @ts-expect-error: matches!
  return one
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-to-parse5/lib/index.js
/**
 * @typedef {import('parse5').DefaultTreeAdapterMap} DefaultTreeAdapterMap
 * @typedef {DefaultTreeAdapterMap['document']} P5Document
 * @typedef {DefaultTreeAdapterMap['documentFragment']} P5Fragment
 * @typedef {DefaultTreeAdapterMap['element']} P5Element
 * @typedef {DefaultTreeAdapterMap['node']} P5Node
 * @typedef {DefaultTreeAdapterMap['documentType']} P5Doctype
 * @typedef {DefaultTreeAdapterMap['commentNode']} P5Comment
 * @typedef {DefaultTreeAdapterMap['textNode']} P5Text
 * @typedef {DefaultTreeAdapterMap['parentNode']} P5Parent
 * @typedef {import('parse5').Token.Attribute} P5Attribute
 * @typedef {Exclude<P5Node, P5Document | P5Fragment>} P5Child
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Content} Content
 */

/**
 * @typedef {Content | Root} Node
 * @typedef {'html' | 'svg'} Space
 *
 * @typedef Options
 *   Configuration.
 * @property {Space | null | undefined} [space='html']
 *   Which space the document is in.
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 */







const hast_util_to_parse5_lib_own = {}.hasOwnProperty

/** @type {(from: Node, schema: Schema) => P5Node} */
const hast_util_to_parse5_lib_one = zwitch('type', {handlers: {root: lib_root, element: hast_util_to_parse5_lib_element, text: lib_text, comment, doctype}})

/**
 * Transform a hast tree to Parse5’s AST.
 *
 * @param {Node} tree
 *   Tree to transform.
 * @param {Options | Space | null | undefined} [options]
 *   Configuration.
 * @returns {P5Node}
 *   `parse5` node.
 */
function toParse5(tree, options) {
  const space = options && typeof options === 'object' ? options.space : options
  return hast_util_to_parse5_lib_one(tree, space === 'svg' ? hast_util_to_parse5_node_modules_property_information_svg : hast_util_to_parse5_node_modules_property_information_html)
}

/**
 * @param {Root} node
 * @param {Schema} schema
 *   Current schema.
 * @returns {P5Document}
 */
function lib_root(node, schema) {
  /** @type {P5Document} */
  const result = {
    nodeName: '#document',
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (node.data || {}).quirksMode ? 'quirks' : 'no-quirks',
    childNodes: []
  }
  result.childNodes = hast_util_to_parse5_lib_all(node.children, result, schema)
  hast_util_to_parse5_lib_patch(node, result)
  return result
}

/**
 * @param {Root} node
 * @param {Schema} schema
 *   Current schema.
 * @returns {P5Fragment}
 */
function fragment(node, schema) {
  /** @type {P5Fragment} */
  const result = {nodeName: '#document-fragment', childNodes: []}
  result.childNodes = hast_util_to_parse5_lib_all(node.children, result, schema)
  hast_util_to_parse5_lib_patch(node, result)
  return result
}

/**
 * @param {Doctype} node
 * @returns {P5Doctype}
 */
function doctype(node) {
  /** @type {P5Doctype} */
  const result = {
    nodeName: '#documentType',
    name: 'html',
    publicId: '',
    systemId: '',
    // @ts-expect-error: change to `null` in a major?
    parentNode: undefined
  }

  hast_util_to_parse5_lib_patch(node, result)
  return result
}

/**
 * @param {Text} node
 * @returns {P5Text}
 */
function lib_text(node) {
  /** @type {P5Text} */
  const result = {
    nodeName: '#text',
    value: node.value,
    // @ts-expect-error: no `parentNode`
    parentNode: undefined
  }
  hast_util_to_parse5_lib_patch(node, result)
  return result
}

/**
 * @param {Comment} node
 * @returns {P5Comment}
 */
function comment(node) {
  /** @type {P5Comment} */
  const result = {
    nodeName: '#comment',
    data: node.value,
    // @ts-expect-error: no `parentNode`
    parentNode: undefined
  }

  hast_util_to_parse5_lib_patch(node, result)

  return result
}

/**
 * @param {Element} node
 * @param {Schema} schema
 *   Current schema.
 * @returns {P5Element}
 *   `parse5` node.
 */
function hast_util_to_parse5_lib_element(node, schema) {
  const parentSchema = schema
  let currentSchema = parentSchema

  if (
    node.type === 'element' &&
    node.tagName.toLowerCase() === 'svg' &&
    parentSchema.space === 'html'
  ) {
    currentSchema = hast_util_to_parse5_node_modules_property_information_svg
  }

  /** @type {Array<P5Attribute>} */
  const attrs = []
  /** @type {string} */
  let prop

  if (node.properties) {
    for (prop in node.properties) {
      if (prop !== 'children' && hast_util_to_parse5_lib_own.call(node.properties, prop)) {
        const result = createProperty(
          currentSchema,
          prop,
          node.properties[prop]
        )

        if (result) {
          attrs.push(result)
        }
      }
    }
  }

  /** @type {P5Element} */
  const result = {
    nodeName: node.tagName,
    tagName: node.tagName,
    attrs,
    // @ts-expect-error: html and svg both have a space.
    namespaceURI: web_namespaces_webNamespaces[currentSchema.space],
    childNodes: [],
    // @ts-expect-error: no `parentNode`
    parentNode: undefined
  }
  result.childNodes = hast_util_to_parse5_lib_all(node.children, result, currentSchema)
  hast_util_to_parse5_lib_patch(node, result)

  if (node.tagName === 'template' && node.content) {
    // @ts-expect-error: `parse5` types are wrong.
    result.content = fragment(node.content, currentSchema)
  }

  return result
}

/**
 * Handle a property.
 *
 * @param {Schema} schema
 *   Current schema.
 * @param {string} prop
 *   Key.
 * @param {Array<string | number> | string | number | boolean | null | undefined} value
 *   hast property value.
 * @returns {P5Attribute | void}
 *   Field for runtime, optional.
 */
function createProperty(schema, prop, value) {
  const info = property_information_lib_find_find(schema, prop)

  // Ignore nullish and `NaN` values.
  if (
    value === undefined ||
    value === null ||
    value === false ||
    (typeof value === 'number' && Number.isNaN(value)) ||
    (!value && info.boolean)
  ) {
    return
  }

  if (Array.isArray(value)) {
    // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? comma_separated_tokens_stringify(value) : node_modules_space_separated_tokens_stringify(value)
  }

  /** @type {P5Attribute} */
  const attribute = {
    name: info.attribute,
    value: value === true ? '' : String(value)
  }

  if (info.space && info.space !== 'html' && info.space !== 'svg') {
    const index = attribute.name.indexOf(':')

    if (index < 0) {
      attribute.prefix = ''
    } else {
      attribute.name = attribute.name.slice(index + 1)
      attribute.prefix = info.attribute.slice(0, index)
    }

    attribute.namespace = web_namespaces_webNamespaces[info.space]
  }

  return attribute
}

/**
 * Transform all hast nodes.
 *
 * @param {Array<Content>} children
 *   List of children.
 * @param {P5Parent} parentNode
 *   `parse5` parent node.
 * @param {Schema} schema
 *   Current schema.
 * @returns {Array<P5Child>}
 *   Transformed children.
 */
function hast_util_to_parse5_lib_all(children, parentNode, schema) {
  let index = -1
  /** @type {Array<P5Child>} */
  const results = []

  if (children) {
    while (++index < children.length) {
      /** @type {P5Child} */
      // @ts-expect-error assume no document.
      const child = hast_util_to_parse5_lib_one(children[index], schema)

      child.parentNode = parentNode

      results.push(child)
    }
  }

  return results
}

/**
 * Add position info from `from` to `to`.
 *
 * @param {Node} from
 *   hast node.
 * @param {P5Node} to
 *   `parse5` node.
 * @returns {void}
 *   Nothing.
 */
function hast_util_to_parse5_lib_patch(from, to) {
  const position = from.position

  if (position && position.start && position.end) {
    to.sourceCodeLocation = {
      startLine: position.start.line,
      startCol: position.start.column,
      // @ts-expect-error assume this is set.
      startOffset: position.start.offset,
      endLine: position.end.line,
      endCol: position.end.column,
      // @ts-expect-error assume this is set.
      endOffset: position.end.offset
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/html-void-elements/index.js
/**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */
const htmlVoidElements = [
  'area',
  'base',
  'basefont',
  'bgsound',
  'br',
  'col',
  'command',
  'embed',
  'frame',
  'hr',
  'image',
  'img',
  'input',
  'isindex',
  'keygen',
  'link',
  'menuitem',
  'meta',
  'nextid',
  'param',
  'source',
  'track',
  'wbr'
]

;// CONCATENATED MODULE: ../../node_modules/hast-util-raw/node_modules/web-namespaces/index.js
/**
 * Map of web namespaces.
 *
 * @type {Record<string, string>}
 */
const node_modules_web_namespaces_webNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xmlns: 'http://www.w3.org/2000/xmlns/'
}

;// CONCATENATED MODULE: ../../node_modules/hast-util-raw/lib/index.js
/**
 * @typedef {import('vfile').VFile} VFile
 * @typedef {import('parse5').Document} P5Document
 * @typedef {import('parse5').DocumentFragment} P5Fragment
 * @typedef {Omit<import('parse5').Element, 'parentNode'>} P5Element
 * @typedef {import('parse5').Attribute} P5Attribute
 * @typedef {Omit<import('parse5').Location, 'startOffset' | 'endOffset'> & {startOffset: number|undefined, endOffset: number|undefined}} P5Location
 * @typedef {import('parse5').ParserOptions} P5ParserOptions
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {import('../complex-types').Raw} Raw
 *
 * @typedef {Omit<Comment, 'value'> & {value: {stitch: Node}}} Stitch
 *
 * @typedef Options
 * @property {Array<string>} [passThrough]
 *   List of custom hast node types to pass through (keep) in hast.
 *   If the passed through nodes have children, those children are expected to
 *   be hast and will be handled.
 *
 * @typedef HiddenTokenizer
 * @property {Array<HiddenLocationTracker>} __mixins
 *   Way too simple, but works for us.
 * @property {HiddenPreprocessor} preprocessor
 * @property {(value: string) => void} write
 * @property {() => number} _consume
 * @property {Array<HiddenToken>} tokenQueue
 * @property {string} state
 * @property {string} returnState
 * @property {number} charRefCode
 * @property {Array<number>} tempBuff
 * @property {Function} _flushCodePointsConsumedAsCharacterReference
 * @property {string} lastStartTagName
 * @property {number} consumedAfterSnapshot
 * @property {boolean} active
 * @property {HiddenToken|undefined} currentCharacterToken
 * @property {HiddenToken|undefined} currentToken
 * @property {unknown} currentAttr
 * @property {Function} NAMED_CHARACTER_REFERENCE_STATE
 * @property {Function} NUMERIC_CHARACTER_REFERENCE_END_STATE
 *
 * @typedef {Record<string, unknown> & {location: P5Location}} HiddenToken
 *
 * @typedef HiddenPreprocessor
 * @property {string|undefined} html
 * @property {number} pos
 * @property {number} lastGapPos
 * @property {number} lastCharPos
 * @property {Array<number>} gapStack
 * @property {boolean} skipNextNewLine
 * @property {boolean} lastChunkWritten
 * @property {boolean} endOfChunkHit
 *
 * @typedef HiddenLocationTracker
 * @property {P5Location|undefined} currentAttrLocation
 * @property {P5Location} ctLoc
 * @property {HiddenPosTracker} posTracker
 *
 * @typedef HiddenPosTracker
 * @property {boolean} isEol
 * @property {number} lineStartPos
 * @property {number} droppedBufferSize
 * @property {number} offset
 * @property {number} col
 * @property {number} line
 */

// @ts-expect-error: untyped.









const inTemplateMode = 'IN_TEMPLATE_MODE'
const dataState = 'DATA_STATE'
const characterToken = 'CHARACTER_TOKEN'
const startTagToken = 'START_TAG_TOKEN'
const endTagToken = 'END_TAG_TOKEN'
const commentToken = 'COMMENT_TOKEN'
const doctypeToken = 'DOCTYPE_TOKEN'

/** @type {P5ParserOptions} */
const parseOptions = {sourceCodeLocationInfo: true, scriptingEnabled: false}

/**
 * Given a hast tree and an optional vfile (for positional info), return a new
 * parsed-again hast tree.
 *
 * @param tree
 *   Original hast tree.
 * @param file
 *   Virtual file for positional info, optional.
 * @param options
 *   Configuration.
 */
const raw =
  /**
   * @type {(
   *   ((tree: Node, file: VFile|undefined, options?: Options) => Node) &
   *   ((tree: Node, options?: Options) => Node)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {VFile} [file]
     * @param {Options} [options]
     */
    function (tree, file, options) {
      let index = -1
      const parser = new lib_parser(parseOptions)
      const one = zwitch('type', {
        handlers: {root, element, text, comment, doctype, raw: handleRaw},
        // @ts-expect-error: hush.
        unknown
      })
      /** @type {boolean|undefined} */
      let stitches
      /** @type {HiddenTokenizer|undefined} */
      let tokenizer
      /** @type {HiddenPreprocessor|undefined} */
      let preprocessor
      /** @type {HiddenPosTracker|undefined} */
      let posTracker
      /** @type {HiddenLocationTracker|undefined} */
      let locationTracker

      if (isOptions(file)) {
        options = file
        file = undefined
      }

      if (options && options.passThrough) {
        while (++index < options.passThrough.length) {
          // @ts-expect-error: hush.
          one.handlers[options.passThrough[index]] = stitch
        }
      }

      const result = fromParse5(
        documentMode(tree) ? document() : fragment(),
        file
      )

      if (stitches) {
        node_modules_unist_util_visit_visit(result, 'comment', (node, index, parent) => {
          const stitch = /** @type {Stitch} */ (/** @type {unknown} */ (node))
          if (stitch.value.stitch && parent !== null && index !== null) {
            // @ts-expect-error: assume the stitch is allowed.
            parent.children[index] = stitch.value.stitch
            return index
          }
        })
      }

      // Unpack if possible and when not given a `root`.
      if (
        tree.type !== 'root' &&
        result.type === 'root' &&
        result.children.length === 1
      ) {
        return result.children[0]
      }

      return result

      /**
       * @returns {P5Fragment}
       */
      function fragment() {
        /** @type {P5Element} */
        const context = {
          nodeName: 'template',
          tagName: 'template',
          attrs: [],
          namespaceURI: node_modules_web_namespaces_webNamespaces.html,
          childNodes: []
        }
        /** @type {P5Element} */
        const mock = {
          nodeName: 'documentmock',
          tagName: 'documentmock',
          attrs: [],
          namespaceURI: node_modules_web_namespaces_webNamespaces.html,
          childNodes: []
        }
        /** @type {P5Fragment} */
        const doc = {nodeName: '#document-fragment', childNodes: []}

        parser._bootstrap(mock, context)
        parser._pushTmplInsertionMode(inTemplateMode)
        parser._initTokenizerForFragmentParsing()
        parser._insertFakeRootElement()
        parser._resetInsertionMode()
        parser._findFormInFragmentContext()

        tokenizer = parser.tokenizer
        /* c8 ignore next */
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        preprocessor = tokenizer.preprocessor
        locationTracker = tokenizer.__mixins[0]
        posTracker = locationTracker.posTracker

        one(tree)

        resetTokenizer()

        parser._adoptNodes(mock.childNodes[0], doc)

        return doc
      }

      /**
       * @returns {P5Document}
       */
      function document() {
        /** @type {P5Document} */
        const doc = parser.treeAdapter.createDocument()

        parser._bootstrap(doc, undefined)
        tokenizer = parser.tokenizer
        /* c8 ignore next */
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        preprocessor = tokenizer.preprocessor
        locationTracker = tokenizer.__mixins[0]
        posTracker = locationTracker.posTracker

        one(tree)

        resetTokenizer()

        return doc
      }

      /**
       * @param {Array<Content>} nodes
       * @returns {void}
       */
      function all(nodes) {
        let index = -1

        /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */
        if (nodes) {
          while (++index < nodes.length) {
            one(nodes[index])
          }
        }
      }

      /**
       * @param {Root} node
       * @returns {void}
       */
      function root(node) {
        all(node.children)
      }

      /**
       * @param {Element} node
       * @returns {void}
       */
      function element(node) {
        resetTokenizer()
        parser._processInputToken(startTag(node))

        all(node.children)

        if (!htmlVoidElements.includes(node.tagName)) {
          resetTokenizer()
          parser._processInputToken(endTag(node))
        }
      }

      /**
       * @param {Text} node
       * @returns {void}
       */
      function text(node) {
        resetTokenizer()
        parser._processInputToken({
          type: characterToken,
          chars: node.value,
          location: createParse5Location(node)
        })
      }

      /**
       * @param {Doctype} node
       * @returns {void}
       */
      function doctype(node) {
        resetTokenizer()
        parser._processInputToken({
          type: doctypeToken,
          name: 'html',
          forceQuirks: false,
          publicId: '',
          systemId: '',
          location: createParse5Location(node)
        })
      }

      /**
       * @param {Comment|Stitch} node
       * @returns {void}
       */
      function comment(node) {
        resetTokenizer()
        parser._processInputToken({
          type: commentToken,
          data: node.value,
          location: createParse5Location(node)
        })
      }

      /**
       * @param {Raw} node
       * @returns {void}
       */
      function handleRaw(node) {
        const start = unist_util_position_pointStart(node)
        const line = start.line || 1
        const column = start.column || 1
        const offset = start.offset || 0

        /* c8 ignore next 4 */
        if (!preprocessor) throw new Error('Expected `preprocessor`')
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        if (!posTracker) throw new Error('Expected `posTracker`')
        if (!locationTracker) throw new Error('Expected `locationTracker`')

        // Reset preprocessor:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/preprocessor.js#L17>.
        preprocessor.html = undefined
        preprocessor.pos = -1
        preprocessor.lastGapPos = -1
        preprocessor.lastCharPos = -1
        preprocessor.gapStack = []
        preprocessor.skipNextNewLine = false
        preprocessor.lastChunkWritten = false
        preprocessor.endOfChunkHit = false

        // Reset preprocessor mixin:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/position-tracking/preprocessor-mixin.js>.
        posTracker.isEol = false
        posTracker.lineStartPos = -column + 1 // Looks weird, but ensures we get correct positional info.
        posTracker.droppedBufferSize = offset
        posTracker.offset = 0
        posTracker.col = 1
        posTracker.line = line

        // Reset location tracker:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js>.
        locationTracker.currentAttrLocation = undefined
        locationTracker.ctLoc = createParse5Location(node)

        // See the code for `parse` and `parseFragment`:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/parser/index.js#L371>.
        tokenizer.write(node.value)
        parser._runParsingLoop(null)

        // Character references hang, so if we ended there, we need to flush
        // those too.
        // We reset the preprocessor as if the document ends here.
        // Then one single call to the relevant state does the trick, parse5
        // consumes the whole token.
        if (
          tokenizer.state === 'NAMED_CHARACTER_REFERENCE_STATE' ||
          tokenizer.state === 'NUMERIC_CHARACTER_REFERENCE_END_STATE'
        ) {
          preprocessor.lastChunkWritten = true
          tokenizer[tokenizer.state](tokenizer._consume())
        }
      }

      /**
       * @param {Node} node
       */
      function stitch(node) {
        stitches = true

        /** @type {Node} */
        let clone

        // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
        // passed through node).
        if ('children' in node) {
          clone = {
            ...node,
            children: raw(
              {type: 'root', children: node.children},
              file,
              options
              // @ts-expect-error Assume a given parent yields a parent.
            ).children
          }
        } else {
          clone = {...node}
        }

        // Hack: `value` is supposed to be a string, but as none of the tools
        // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
        // through.
        comment({type: 'comment', value: {stitch: clone}})
      }

      function resetTokenizer() {
        /* c8 ignore next 2 */
        if (!tokenizer) throw new Error('Expected `tokenizer`')
        if (!posTracker) throw new Error('Expected `posTracker`')

        // Process final characters if they’re still there after hibernating.
        // Similar to:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js#L95>.
        const token = tokenizer.currentCharacterToken

        if (token) {
          token.location.endLine = posTracker.line
          token.location.endCol = posTracker.col + 1
          token.location.endOffset = posTracker.offset + 1
          parser._processInputToken(token)
        }

        // Reset tokenizer:
        // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/index.js#L218-L234>.
        // Especially putting it back in the `data` state is useful: some elements,
        // like textareas and iframes, change the state.
        // See GH-7.
        // But also if broken HTML is in `raw`, and then a correct element is given.
        // See GH-11.
        tokenizer.tokenQueue = []
        tokenizer.state = dataState
        tokenizer.returnState = ''
        tokenizer.charRefCode = -1
        tokenizer.tempBuff = []
        tokenizer.lastStartTagName = ''
        tokenizer.consumedAfterSnapshot = -1
        tokenizer.active = false
        tokenizer.currentCharacterToken = undefined
        tokenizer.currentToken = undefined
        tokenizer.currentAttr = undefined
      }
    }
  )
/**
 * @param {Element} node
 * @returns {HiddenToken}
 */
function startTag(node) {
  /** @type {P5Location} */
  const location = Object.assign(createParse5Location(node))
  // @ts-expect-error extra positional info.
  location.startTag = Object.assign({}, location)

  // Untyped token.
  return {
    type: startTagToken,
    tagName: node.tagName,
    selfClosing: false,
    attrs: attributes(node),
    location
  }
}

/**
 * @param {Element} node
 * @returns {Array<P5Attribute>}
 */
function attributes(node) {
  return toParse5({
    tagName: node.tagName,
    type: 'element',
    properties: node.properties,
    children: []
    // @ts-expect-error Assume element.
  }).attrs
}

/**
 * @param {Element} node
 * @returns {HiddenToken}
 */
function endTag(node) {
  /** @type {P5Location} */
  const location = Object.assign(createParse5Location(node))
  // @ts-expect-error extra positional info.
  location.startTag = Object.assign({}, location)

  // Untyped token.
  return {
    type: endTagToken,
    tagName: node.tagName,
    attrs: [],
    location
  }
}

/**
 * @param {Node} node
 */
function unknown(node) {
  throw new Error('Cannot compile `' + node.type + '` node')
}

/**
 * @param {Node} node
 * @returns {boolean}
 */
function documentMode(node) {
  const head = node.type === 'root' ? node.children[0] : node
  return Boolean(
    head &&
      (head.type === 'doctype' ||
        (head.type === 'element' && head.tagName === 'html'))
  )
}

/**
 * @param {Node|Stitch} node
 * @returns {P5Location}
 */
function createParse5Location(node) {
  const start = unist_util_position_pointStart(node)
  const end = unist_util_position_pointEnd(node)

  return {
    startLine: start.line,
    startCol: start.column,
    startOffset: start.offset,
    endLine: end.line,
    endCol: end.column,
    endOffset: end.offset
  }
}

/**
 * @param {VFile|Options|undefined} value
 * @return {value is Options}
 */
function isOptions(value) {
  return Boolean(value && !('message' in value && 'messages' in value))
}

;// CONCATENATED MODULE: ../../node_modules/rehype-raw/index.js
/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} Options
 * @typedef {import('hast-util-raw')} DoNotTouchAsThisImportIncludesRawInTree
 */



/**
 * Plugin to parse the tree again (and raw nodes).
 * Keeping positional info OK.  🙌
 *
 * @type {import('unified').Plugin<[Options?] | Array<void>, Root>}
 */
function rehypeRaw(options = {}) {
  return (tree, file) => {
    // Assume that when a root was given, it’s also returned.
    const result = /** @type {Root} */ (raw(tree, file, options))
    return result
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-autolink-literal/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
}
const domain = {
  tokenize: tokenizeDomain,
  partial: true
}
const syntax_path = {
  tokenize: tokenizePath,
  partial: true
}
const trail = {
  tokenize: tokenizeTrail,
  partial: true
}
const emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
}
const wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}
const protocolAutolink = {
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}
const emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}

/** @type {ConstructRecord} */
const syntax_text = {}

// To do: next major: expose functions that yields extension.

/**
 * Extension for `micromark` that can be passed in `extensions` to enable GFM
 * autolink literal syntax.
 *
 * @type {Extension}
 */
const gfmAutolinkLiteral = {
  text: syntax_text
}

/** @type {Code} */
let syntax_code = 48

// Add alphanumerics.
while (syntax_code < 123) {
  syntax_text[syntax_code] = emailAutolink
  syntax_code++
  if (syntax_code === 58) syntax_code = 65
  else if (syntax_code === 91) syntax_code = 97
}
syntax_text[43] = emailAutolink
syntax_text[45] = emailAutolink
syntax_text[46] = emailAutolink
syntax_text[95] = emailAutolink
syntax_text[72] = [emailAutolink, protocolAutolink]
syntax_text[104] = [emailAutolink, protocolAutolink]
syntax_text[87] = [emailAutolink, wwwAutolink]
syntax_text[119] = [emailAutolink, wwwAutolink]

// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.

/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailAutolink(effects, ok, nok) {
  const self = this
  /** @type {boolean | undefined} */
  let dot
  /** @type {boolean} */
  let data
  return start

  /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (
      !gfmAtext(code) ||
      !previousEmail.call(self, self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }
    effects.enter('literalAutolink')
    effects.enter('literalAutolinkEmail')
    return atext(code)
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code)
      return atext
    }
    if (code === 64) {
      effects.consume(code)
      return emailDomain
    }
    return nok(code)
  }

  /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */
  function emailDomain(code) {
    // Dot followed by alphanumerical (not `-` or `_`).
    if (code === 46) {
      return effects.check(
        emailDomainDotTrail,
        emailDomainAfter,
        emailDomainDot
      )(code)
    }

    // Alphanumerical, `-`, and `_`.
    if (code === 45 || code === 95 || asciiAlphanumeric(code)) {
      data = true
      effects.consume(code)
      return emailDomain
    }

    // To do: `/` if xmpp.

    // Note: normally we’d truncate trailing punctuation from the link.
    // However, email autolink literals cannot contain any of those markers,
    // except for `.`, but that can only occur if it isn’t trailing.
    // So we can ignore truncating!
    return emailDomainAfter(code)
  }

  /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */
  function emailDomainDot(code) {
    effects.consume(code)
    dot = true
    return emailDomain
  }

  /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function emailDomainAfter(code) {
    // Domain must not be empty, must include a dot, and must end in alphabetical.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
    if (data && dot && asciiAlpha(self.previous)) {
      effects.exit('literalAutolinkEmail')
      effects.exit('literalAutolink')
      return ok(code)
    }
    return nok(code)
  }
}

/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwAutolink(effects, ok, nok) {
  const self = this
  return wwwStart

  /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function wwwStart(code) {
    if (
      (code !== 87 && code !== 119) ||
      !previousWww.call(self, self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }
    effects.enter('literalAutolink')
    effects.enter('literalAutolinkWww')
    // Note: we *check*, so we can discard the `www.` we parsed.
    // If it worked, we consider it as a part of the domain.
    return effects.check(
      wwwPrefix,
      effects.attempt(domain, effects.attempt(syntax_path, wwwAfter), nok),
      nok
    )(code)
  }

  /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */
  function wwwAfter(code) {
    effects.exit('literalAutolinkWww')
    effects.exit('literalAutolink')
    return ok(code)
  }
}

/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeProtocolAutolink(effects, ok, nok) {
  const self = this
  let buffer = ''
  let seen = false
  return protocolStart

  /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function protocolStart(code) {
    if (
      (code === 72 || code === 104) &&
      previousProtocol.call(self, self.previous) &&
      !previousUnbalanced(self.events)
    ) {
      effects.enter('literalAutolink')
      effects.enter('literalAutolinkHttp')
      buffer += String.fromCodePoint(code)
      effects.consume(code)
      return protocolPrefixInside
    }
    return nok(code)
  }

  /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */
  function protocolPrefixInside(code) {
    // `5` is size of `https`
    if (asciiAlpha(code) && buffer.length < 5) {
      // @ts-expect-error: definitely number.
      buffer += String.fromCodePoint(code)
      effects.consume(code)
      return protocolPrefixInside
    }
    if (code === 58) {
      const protocol = buffer.toLowerCase()
      if (protocol === 'http' || protocol === 'https') {
        effects.consume(code)
        return protocolSlashesInside
      }
    }
    return nok(code)
  }

  /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */
  function protocolSlashesInside(code) {
    if (code === 47) {
      effects.consume(code)
      if (seen) {
        return afterProtocol
      }
      seen = true
      return protocolSlashesInside
    }
    return nok(code)
  }

  /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */
  function afterProtocol(code) {
    // To do: this is different from `markdown-rs`:
    // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
    return code === null ||
      asciiControl(code) ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)
      ? nok(code)
      : effects.attempt(domain, effects.attempt(syntax_path, protocolAfter), nok)(code)
  }

  /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */
  function protocolAfter(code) {
    effects.exit('literalAutolinkHttp')
    effects.exit('literalAutolink')
    return ok(code)
  }
}

/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwPrefix(effects, ok, nok) {
  let size = 0
  return wwwPrefixInside

  /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixInside(code) {
    if ((code === 87 || code === 119) && size < 3) {
      size++
      effects.consume(code)
      return wwwPrefixInside
    }
    if (code === 46 && size === 3) {
      effects.consume(code)
      return wwwPrefixAfter
    }
    return nok(code)
  }

  /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixAfter(code) {
    // If there is *anything*, we can link.
    return code === null ? nok(code) : ok(code)
  }
}

/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDomain(effects, ok, nok) {
  /** @type {boolean | undefined} */
  let underscoreInLastSegment
  /** @type {boolean | undefined} */
  let underscoreInLastLastSegment
  /** @type {boolean | undefined} */
  let seen
  return domainInside

  /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */
  function domainInside(code) {
    // Check whether this marker, which is a trailing punctuation
    // marker, optionally followed by more trailing markers, and then
    // followed by an end.
    if (code === 46 || code === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code)
    }

    // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
    if (
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code) ||
      (code !== 45 && unicodePunctuation(code))
    ) {
      return domainAfter(code)
    }
    seen = true
    effects.consume(code)
    return domainInside
  }

  /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */
  function domainAtPunctuation(code) {
    // There is an underscore in the last segment of the domain
    if (code === 95) {
      underscoreInLastSegment = true
    }
    // Otherwise, it’s a `.`: save the last segment underscore in the
    // penultimate segment slot.
    else {
      underscoreInLastLastSegment = underscoreInLastSegment
      underscoreInLastSegment = undefined
    }
    effects.consume(code)
    return domainInside
  }

  /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */
  function domainAfter(code) {
    // Note: that’s GH says a dot is needed, but it’s not true:
    // <https://github.com/github/cmark-gfm/issues/279>
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code)
    }
    return ok(code)
  }
}

/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePath(effects, ok) {
  let sizeOpen = 0
  let sizeClose = 0
  return pathInside

  /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */
  function pathInside(code) {
    if (code === 40) {
      sizeOpen++
      effects.consume(code)
      return pathInside
    }

    // To do: `markdown-rs` also needs this.
    // If this is a paren, and there are less closings than openings,
    // we don’t check for a trail.
    if (code === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code)
    }

    // Check whether this trailing punctuation marker is optionally
    // followed by more trailing markers, and then followed
    // by an end.
    if (
      code === 33 ||
      code === 34 ||
      code === 38 ||
      code === 39 ||
      code === 41 ||
      code === 42 ||
      code === 44 ||
      code === 46 ||
      code === 58 ||
      code === 59 ||
      code === 60 ||
      code === 63 ||
      code === 93 ||
      code === 95 ||
      code === 126
    ) {
      return effects.check(trail, ok, pathAtPunctuation)(code)
    }
    if (
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    effects.consume(code)
    return pathInside
  }

  /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function pathAtPunctuation(code) {
    // Count closing parens.
    if (code === 41) {
      sizeClose++
    }
    effects.consume(code)
    return pathInside
  }
}

/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTrail(effects, ok, nok) {
  return trail

  /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */
  function trail(code) {
    // Regular trailing punctuation.
    if (
      code === 33 ||
      code === 34 ||
      code === 39 ||
      code === 41 ||
      code === 42 ||
      code === 44 ||
      code === 46 ||
      code === 58 ||
      code === 59 ||
      code === 63 ||
      code === 95 ||
      code === 126
    ) {
      effects.consume(code)
      return trail
    }

    // `&` followed by one or more alphabeticals and then a `;`, is
    // as a whole considered as trailing punctuation.
    // In all other cases, it is considered as continuation of the URL.
    if (code === 38) {
      effects.consume(code)
      return trailCharRefStart
    }

    // Needed because we allow literals after `[`, as we fix:
    // <https://github.com/github/cmark-gfm/issues/278>.
    // Check that it is not followed by `(` or `[`.
    if (code === 93) {
      effects.consume(code)
      return trailBracketAfter
    }
    if (
      // `<` is an end.
      code === 60 ||
      // So is whitespace.
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    return nok(code)
  }

  /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailBracketAfter(code) {
    // Whitespace or something that could start a resource or reference is the end.
    // Switch back to trail otherwise.
    if (
      code === null ||
      code === 40 ||
      code === 91 ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    return trail(code)
  }

  /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharRefStart(code) {
    // When non-alpha, it’s not a trail.
    return asciiAlpha(code) ? trailCharRefInside(code) : nok(code)
  }

  /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharRefInside(code) {
    // Switch back to trail if this is well-formed.
    if (code === 59) {
      effects.consume(code)
      return trail
    }
    if (asciiAlpha(code)) {
      effects.consume(code)
      return trailCharRefInside
    }

    // It’s not a trail.
    return nok(code)
  }
}

/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailDomainDotTrail(effects, ok, nok) {
  return start

  /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Must be dot.
    effects.consume(code)
    return after
  }

  /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Not a trail if alphanumeric.
    return asciiAlphanumeric(code) ? nok(code) : ok(code)
  }
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */
function previousWww(code) {
  return (
    code === null ||
    code === 40 ||
    code === 42 ||
    code === 95 ||
    code === 91 ||
    code === 93 ||
    code === 126 ||
    markdownLineEndingOrSpace(code)
  )
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */
function previousProtocol(code) {
  return !asciiAlpha(code)
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previousEmail(code) {
  // Do not allow a slash “inside” atext.
  // The reference code is a bit weird, but that’s what it results in.
  // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
  // Other than slash, every preceding character is allowed.
  return !(code === 47 || gfmAtext(code))
}

/**
 * @param {Code} code
 * @returns {boolean}
 */
function gfmAtext(code) {
  return (
    code === 43 ||
    code === 45 ||
    code === 46 ||
    code === 95 ||
    asciiAlphanumeric(code)
  )
}

/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */
function previousUnbalanced(events) {
  let index = events.length
  let result = false
  while (index--) {
    const token = events[index][1]
    if (
      (token.type === 'labelLink' || token.type === 'labelImage') &&
      !token._balanced
    ) {
      result = true
      break
    }

    // If we’ve seen this token, and it was marked as not having any unbalanced
    // bracket before it, we can exit.
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false
      break
    }
  }
  if (events.length > 0 && !result) {
    // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true
  }
  return result
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-encode/index.js
const characterReferences = {'"': 'quot', '&': 'amp', '<': 'lt', '>': 'gt'}

/**
 * Encode only the dangerous HTML characters.
 *
 * This ensures that certain characters which have special meaning in HTML are
 * dealt with.
 * Technically, we can skip `>` and `"` in many cases, but CM includes them.
 *
 * @param {string} value
 * @returns {string}
 */
function micromark_util_encode_encode(value) {
  return value.replace(/["&<>]/g, replace)

  /**
   * @param {string} value
   * @returns {string}
   */
  function replace(value) {
    // @ts-expect-error Hush, it’s fine.
    return '&' + characterReferences[value] + ';'
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-util-sanitize-uri/index.js



/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri` below).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * Then, a regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`,
 * or `/^https?$/i` for `img[src]`.
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string|undefined} url
 * @param {RegExp} [protocol]
 * @returns {string}
 */
function micromark_util_sanitize_uri_sanitizeUri(url, protocol) {
  const value = micromark_util_encode_encode(micromark_util_sanitize_uri_normalizeUri(url || ''))

  if (!protocol) {
    return value
  }

  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')

  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}
/**
 * Normalize a URL (such as used in definitions).
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 * @returns {string}
 */

function micromark_util_sanitize_uri_normalizeUri(value) {
  /** @type {Array<string>} */
  const result = []
  let index = -1
  let start = 0
  let skip = 0

  while (++index < value.length) {
    const code = value.charCodeAt(index)
    /** @type {string} */

    let replace = '' // A correct percent encoded value.

    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2
    } // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code)
      }
    } // Astral.
    else if (code > 55295 && code < 57344) {
      const next = value.charCodeAt(index + 1) // A correct surrogate pair.

      if (code < 56320 && next > 56319 && next < 57344) {
        replace = String.fromCharCode(code, next)
        skip = 1
      } // Lone surrogate.
      else {
        replace = '\uFFFD'
      }
    } // Unicode.
    else {
      replace = String.fromCharCode(code)
    }

    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace))
      start = index + skip + 1
      replace = ''
    }

    if (skip) {
      index += skip
      skip = 0
    }
  }

  return result.join('') + value.slice(start)
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-autolink-literal/lib/html.js
/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */



// To do: next major: expose functions that yields extension.

/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to support
 * GFM autolink literals when serializing to HTML.
 *
 * @type {HtmlExtension}
 */
const gfmAutolinkLiteralHtml = {
  exit: {
    literalAutolinkEmail,
    literalAutolinkHttp,
    literalAutolinkWww
  }
}

/**
 * @this {CompileContext}
 * @type {Handle}
 */
function literalAutolinkWww(token) {
  anchorFromToken.call(this, token, 'http://')
}

/**
 * @this {CompileContext}
 * @type {Handle}
 */
function literalAutolinkEmail(token) {
  anchorFromToken.call(this, token, 'mailto:')
}

/**
 * @this {CompileContext}
 * @type {Handle}
 */
function literalAutolinkHttp(token) {
  anchorFromToken.call(this, token)
}

/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */
function anchorFromToken(token, protocol) {
  const url = this.sliceSerialize(token)
  this.tag('<a href="' + micromark_util_sanitize_uri_sanitizeUri((protocol || '') + url) + '">')
  this.raw(this.encode(url))
  this.tag('</a>')
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-strikethrough/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */




/**
 * Create an extension for `micromark` to enable GFM strikethrough syntax.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions`, to
 *   enable GFM strikethrough syntax.
 */
function gfmStrikethrough(options) {
  const options_ = options || {}
  let single = options_.singleTilde
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  }
  if (single === null || single === undefined) {
    single = true
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  }

  /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */
  function resolveAllStrikethrough(events, context) {
    let index = -1

    // Walk through all events.
    while (++index < events.length) {
      // Find a token that can close.
      if (
        events[index][0] === 'enter' &&
        events[index][1].type === 'strikethroughSequenceTemporary' &&
        events[index][1]._close
      ) {
        let open = index

        // Now walk back to find an opener.
        while (open--) {
          // Find a token that can open the closer.
          if (
            events[open][0] === 'exit' &&
            events[open][1].type === 'strikethroughSequenceTemporary' &&
            events[open][1]._open &&
            // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset ===
              events[open][1].end.offset - events[open][1].start.offset
          ) {
            events[index][1].type = 'strikethroughSequence'
            events[open][1].type = 'strikethroughSequence'

            /** @type {Token} */
            const strikethrough = {
              type: 'strikethrough',
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            }

            /** @type {Token} */
            const text = {
              type: 'strikethroughText',
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            }

            // Opening.
            /** @type {Array<Event>} */
            const nextEvents = [
              ['enter', strikethrough, context],
              ['enter', events[open][1], context],
              ['exit', events[open][1], context],
              ['enter', text, context]
            ]
            const insideSpan = context.parser.constructs.insideSpan.null
            if (insideSpan) {
              // Between.
              splice(
                nextEvents,
                nextEvents.length,
                0,
                resolveAll(insideSpan, events.slice(open + 1, index), context)
              )
            }

            // Closing.
            splice(nextEvents, nextEvents.length, 0, [
              ['exit', text, context],
              ['enter', events[index][1], context],
              ['exit', events[index][1], context],
              ['exit', strikethrough, context]
            ])
            splice(events, open - 1, index - open + 3, nextEvents)
            index = open + nextEvents.length - 2
            break
          }
        }
      }
    }
    index = -1
    while (++index < events.length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = 'data'
      }
    }
    return events
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeStrikethrough(effects, ok, nok) {
    const previous = this.previous
    const events = this.events
    let size = 0
    return start

    /** @type {State} */
    function start(code) {
      if (
        previous === 126 &&
        events[events.length - 1][1].type !== 'characterEscape'
      ) {
        return nok(code)
      }
      effects.enter('strikethroughSequenceTemporary')
      return more(code)
    }

    /** @type {State} */
    function more(code) {
      const before = classifyCharacter(previous)
      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code)
        effects.consume(code)
        size++
        return more
      }
      if (size < 2 && !single) return nok(code)
      const token = effects.exit('strikethroughSequenceTemporary')
      const after = classifyCharacter(code)
      token._open = !after || (after === 2 && Boolean(before))
      token._close = !before || (before === 2 && Boolean(after))
      return ok(code)
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-strikethrough/lib/html.js
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */

// To do: next major: expose function instead of object.

/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */
const gfmStrikethroughHtml = {
  enter: {
    strikethrough() {
      this.tag('<del>')
    }
  },
  exit: {
    strikethrough() {
      this.tag('</del>')
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-table/lib/edit-map.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

// Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.

// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.

/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */

/**
 * Tracks a bunch of edits.
 */
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */
    this.map = []
  }

  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */
  add(index, remove, add) {
    addImpl(this, index, remove, add)
  }

  // To do: not used here.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {void}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }

  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */
  consume(events) {
    this.map.sort((a, b) => a[0] - b[0])

    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
    if (this.map.length === 0) {
      return
    }

    // To do: if links are added in events, like they are in `markdown-rs`,
    // this is needed.
    // // Calculate jumps: where items in the current list move to.
    // /** @type {Array<Jump>} */
    // const jumps = []
    // let index = 0
    // let addAcc = 0
    // let removeAcc = 0
    // while (index < this.map.length) {
    //   const [at, remove, add] = this.map[index]
    //   removeAcc += remove
    //   addAcc += add.length
    //   jumps.push([at, removeAcc, addAcc])
    //   index += 1
    // }
    //
    // . shiftLinks(events, jumps)

    let index = this.map.length
    /** @type {Array<Array<Event>>} */
    const vecs = []
    while (index > 0) {
      index -= 1
      vecs.push(events.slice(this.map[index][0] + this.map[index][1]))
      // eslint-disable-next-line unicorn/no-array-push-push
      vecs.push(this.map[index][2])

      // Truncate rest.
      events.length = this.map[index][0]
    }
    vecs.push([...events])
    events.length = 0
    let slice = vecs.pop()
    while (slice) {
      events.push(...slice)
      slice = vecs.pop()
    }

    // Truncate everything.
    this.map.length = 0
  }
}

/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */
function addImpl(editMap, at, remove, add) {
  let index = 0

  /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
  if (remove === 0 && add.length === 0) {
    return
  }
  while (index < editMap.map.length) {
    if (editMap.map[index][0] === at) {
      editMap.map[index][1] += remove

      // To do: before not used.
      // if (before) {
      //   add.push(...editMap.map[index][2])
      //   editMap.map[index][2] = add
      // } else {
      editMap.map[index][2].push(...add)
      // }

      return
    }
    index += 1
  }
  editMap.map.push([at, remove, add])
}

// /**
//  * Shift `previous` and `next` links according to `jumps`.
//  *
//  * This fixes links in case there are events removed or added between them.
//  *
//  * @param {Array<Event>} events
//  * @param {Array<Jump>} jumps
//  */
// function shiftLinks(events, jumps) {
//   let jumpIndex = 0
//   let index = 0
//   let add = 0
//   let rm = 0

//   while (index < events.length) {
//     const rmCurr = rm

//     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
//       add = jumps[jumpIndex][2]
//       rm = jumps[jumpIndex][1]
//       jumpIndex += 1
//     }

//     // Ignore items that will be removed.
//     if (rm > rmCurr) {
//       index += rm - rmCurr
//     } else {
//       console.log('to do: links?', add, rmCurr)
//       // ?
//       // if let Some(link) = &events[index].link {
//       //     if let Some(next) = link.next {
//       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
//       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
//       //             add = jumps[jumpIndex].2;
//       //             rm = jumps[jumpIndex].1;
//       //             jumpIndex += 1;
//       //         }
//       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
//       //         index = next;
//       //         continue;
//       //     }
//       // }
//       index += 1
//     }
//   }
// }

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-table/lib/infer.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */

/**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */
function gfmTableAlign(events, index) {
  let inDelimiterRow = false
  /** @type {Array<Align>} */
  const align = []
  while (index < events.length) {
    const event = events[index]
    if (inDelimiterRow) {
      if (event[0] === 'enter') {
        // Start of alignment value: set a new column.
        // To do: `markdown-rs` uses `tableDelimiterCellValue`.
        if (event[1].type === 'tableContent') {
          align.push(
            events[index + 1][1].type === 'tableDelimiterMarker'
              ? 'left'
              : 'none'
          )
        }
      }
      // Exits:
      // End of alignment value: change the column.
      // To do: `markdown-rs` uses `tableDelimiterCellValue`.
      else if (event[1].type === 'tableContent') {
        if (events[index - 1][1].type === 'tableDelimiterMarker') {
          const alignIndex = align.length - 1
          align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right'
        }
      }
      // Done!
      else if (event[1].type === 'tableDelimiterRow') {
        break
      }
    } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') {
      inDelimiterRow = true
    }
    index += 1
  }
  return align
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-table/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */






// To do: next major: expose functions.

/**
 * Extension for `micromark` that can be passed in `extensions` to enable GFM
 * table syntax.
 *
 * @type {Extension}
 */
const gfmTable = {
  flow: {
    null: {
      tokenize: tokenizeTable,
      resolveAll: resolveTable
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTable(effects, ok, nok) {
  const self = this
  let size = 0
  let sizeB = 0
  /** @type {boolean | undefined} */
  let seen
  return start

  /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */
  function start(code) {
    let index = self.events.length - 1
    while (index > -1) {
      const type = self.events[index][1].type
      if (
        type === 'lineEnding' ||
        // Note: markdown-rs uses `whitespace` instead of `linePrefix`
        type === 'linePrefix'
      )
        index--
      else break
    }
    const tail = index > -1 ? self.events[index][1].type : null
    const next =
      tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore

    // Don’t allow lazy body rows.
    if (next === bodyRowStart && self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    return next(code)
  }

  /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBefore(code) {
    effects.enter('tableHead')
    effects.enter('tableRow')
    return headRowStart(code)
  }

  /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowStart(code) {
    if (code === 124) {
      return headRowBreak(code)
    }

    // To do: micromark-js should let us parse our own whitespace in extensions,
    // like `markdown-rs`:
    //
    // ```js
    // // 4+ spaces.
    // if (markdownSpace(code)) {
    //   return nok(code)
    // }
    // ```

    seen = true
    // Count the first character, that isn’t a pipe, double.
    sizeB += 1
    return headRowBreak(code)
  }

  /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBreak(code) {
    if (code === null) {
      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
      if (sizeB > 1) {
        sizeB = 0
        // To do: check if this works.
        // Feel free to interrupt:
        self.interrupt = true
        effects.exit('tableRow')
        effects.enter('lineEnding')
        effects.consume(code)
        effects.exit('lineEnding')
        return headDelimiterStart
      }

      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code)
    }
    if (markdownSpace(code)) {
      // To do: check if this is fine.
      // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
      // State::Retry(space_or_tab(tokenizer))
      return factorySpace(effects, headRowBreak, 'whitespace')(code)
    }
    sizeB += 1
    if (seen) {
      seen = false
      // Header cell count.
      size += 1
    }
    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      // Whether a delimiter was seen.
      seen = true
      return headRowBreak
    }

    // Anything else is cell data.
    effects.enter('data')
    return headRowData(code)
  }

  /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('data')
      return headRowBreak(code)
    }
    effects.consume(code)
    return code === 92 ? headRowEscape : headRowData
  }

  /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */
  function headRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return headRowData
    }
    return headRowData(code)
  }

  /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterStart(code) {
    // Reset `interrupt`.
    self.interrupt = false

    // Note: in `markdown-rs`, we need to handle piercing here too.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    effects.enter('tableDelimiterRow')
    // Track if we’ve seen a `:` or `|`.
    seen = false
    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        headDelimiterBefore,
        'linePrefix',
        self.parser.constructs.disable.null.includes('codeIndented')
          ? undefined
          : 4
      )(code)
    }
    return headDelimiterBefore(code)
  }

  /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterBefore(code) {
    if (code === 45 || code === 58) {
      return headDelimiterValueBefore(code)
    }
    if (code === 124) {
      seen = true
      // If we start with a pipe, we open a cell marker.
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return headDelimiterCellBefore
    }

    // More whitespace / empty row not allowed at start.
    return headDelimiterNok(code)
  }

  /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellBefore(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterValueBefore, 'whitespace')(code)
    }
    return headDelimiterValueBefore(code)
  }

  /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterValueBefore(code) {
    // Align: left.
    if (code === 58) {
      sizeB += 1
      seen = true
      effects.enter('tableDelimiterMarker')
      effects.consume(code)
      effects.exit('tableDelimiterMarker')
      return headDelimiterLeftAlignmentAfter
    }

    // Align: none.
    if (code === 45) {
      sizeB += 1
      // To do: seems weird that this *isn’t* left aligned, but that state is used?
      return headDelimiterLeftAlignmentAfter(code)
    }
    if (code === null || markdownLineEnding(code)) {
      return headDelimiterCellAfter(code)
    }
    return headDelimiterNok(code)
  }

  /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterLeftAlignmentAfter(code) {
    if (code === 45) {
      effects.enter('tableDelimiterFiller')
      return headDelimiterFiller(code)
    }

    // Anything else is not ok after the left-align colon.
    return headDelimiterNok(code)
  }

  /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterFiller(code) {
    if (code === 45) {
      effects.consume(code)
      return headDelimiterFiller
    }

    // Align is `center` if it was `left`, `right` otherwise.
    if (code === 58) {
      seen = true
      effects.exit('tableDelimiterFiller')
      effects.enter('tableDelimiterMarker')
      effects.consume(code)
      effects.exit('tableDelimiterMarker')
      return headDelimiterRightAlignmentAfter
    }
    effects.exit('tableDelimiterFiller')
    return headDelimiterRightAlignmentAfter(code)
  }

  /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterRightAlignmentAfter(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterCellAfter, 'whitespace')(code)
    }
    return headDelimiterCellAfter(code)
  }

  /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellAfter(code) {
    if (code === 124) {
      return headDelimiterBefore(code)
    }
    if (code === null || markdownLineEnding(code)) {
      // Exit when:
      // * there was no `:` or `|` at all (it’s a thematic break or setext
      //   underline instead)
      // * the header cell count is not the delimiter cell count
      if (!seen || size !== sizeB) {
        return headDelimiterNok(code)
      }

      // Note: in markdown-rs`, a reset is needed here.
      effects.exit('tableDelimiterRow')
      effects.exit('tableHead')
      // To do: in `markdown-rs`, resolvers need to be registered manually.
      // effects.register_resolver(ResolveName::GfmTable)
      return ok(code)
    }
    return headDelimiterNok(code)
  }

  /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterNok(code) {
    // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
    return nok(code)
  }

  /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */
  function bodyRowStart(code) {
    // Note: in `markdown-rs` we need to manually take care of a prefix,
    // but in `micromark-js` that is done for us, so if we’re here, we’re
    // never at whitespace.
    effects.enter('tableRow')
    return bodyRowBreak(code)
  }

  /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowBreak(code) {
    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return bodyRowBreak
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('tableRow')
      return ok(code)
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, bodyRowBreak, 'whitespace')(code)
    }

    // Anything else is cell content.
    effects.enter('data')
    return bodyRowData(code)
  }

  /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */
  function bodyRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('data')
      return bodyRowBreak(code)
    }
    effects.consume(code)
    return code === 92 ? bodyRowEscape : bodyRowData
  }

  /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return bodyRowData
    }
    return bodyRowData(code)
  }
}

/** @type {Resolver} */
// eslint-disable-next-line complexity
function resolveTable(events, context) {
  let index = -1
  let inFirstCellAwaitingPipe = true
  /** @type {RowKind} */
  let rowKind = 0
  /** @type {Range} */
  let lastCell = [0, 0, 0, 0]
  /** @type {Range} */
  let cell = [0, 0, 0, 0]
  let afterHeadAwaitingFirstBodyRow = false
  let lastTableEnd = 0
  /** @type {Token | undefined} */
  let currentTable
  /** @type {Token | undefined} */
  let currentBody
  /** @type {Token | undefined} */
  let currentCell
  const map = new EditMap()
  while (++index < events.length) {
    const event = events[index]
    const token = event[1]
    if (event[0] === 'enter') {
      // Start of head.
      if (token.type === 'tableHead') {
        afterHeadAwaitingFirstBodyRow = false

        // Inject previous (body end and) table end.
        if (lastTableEnd !== 0) {
          flushTableEnd(map, context, lastTableEnd, currentTable, currentBody)
          currentBody = undefined
          lastTableEnd = 0
        }

        // Inject table start.
        currentTable = {
          type: 'table',
          start: Object.assign({}, token.start),
          // Note: correct end is set later.
          end: Object.assign({}, token.end)
        }
        map.add(index, 0, [['enter', currentTable, context]])
      } else if (
        token.type === 'tableRow' ||
        token.type === 'tableDelimiterRow'
      ) {
        inFirstCellAwaitingPipe = true
        currentCell = undefined
        lastCell = [0, 0, 0, 0]
        cell = [0, index + 1, 0, 0]

        // Inject table body start.
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false
          currentBody = {
            type: 'tableBody',
            start: Object.assign({}, token.start),
            // Note: correct end is set later.
            end: Object.assign({}, token.end)
          }
          map.add(index, 0, [['enter', currentBody, context]])
        }
        rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1
      }
      // Cell data.
      else if (
        rowKind &&
        (token.type === 'data' ||
          token.type === 'tableDelimiterMarker' ||
          token.type === 'tableDelimiterFiller')
      ) {
        inFirstCellAwaitingPipe = false

        // First value in cell.
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1]
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              undefined,
              currentCell
            )
            lastCell = [0, 0, 0, 0]
          }
          cell[2] = index
        }
      } else if (token.type === 'tableCellDivider') {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1]
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              undefined,
              currentCell
            )
          }
          lastCell = cell
          cell = [lastCell[1], index, 0, 0]
        }
      }
    }
    // Exit events.
    else if (token.type === 'tableHead') {
      afterHeadAwaitingFirstBodyRow = true
      lastTableEnd = index
    } else if (
      token.type === 'tableRow' ||
      token.type === 'tableDelimiterRow'
    ) {
      lastTableEnd = index
      if (lastCell[1] !== 0) {
        cell[0] = cell[1]
        currentCell = flushCell(
          map,
          context,
          lastCell,
          rowKind,
          index,
          currentCell
        )
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map, context, cell, rowKind, index, currentCell)
      }
      rowKind = 0
    } else if (
      rowKind &&
      (token.type === 'data' ||
        token.type === 'tableDelimiterMarker' ||
        token.type === 'tableDelimiterFiller')
    ) {
      cell[3] = index
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map, context, lastTableEnd, currentTable, currentBody)
  }
  map.consume(context.events)

  // To do: move this into `html`, when events are exposed there.
  // That’s what `markdown-rs` does.
  // That needs updates to `mdast-util-gfm-table`.
  index = -1
  while (++index < context.events.length) {
    const event = context.events[index]
    if (event[0] === 'enter' && event[1].type === 'table') {
      event[1]._align = gfmTableAlign(context.events, index)
    }
  }
  return events
}

/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */
// eslint-disable-next-line max-params
function flushCell(map, context, range, rowKind, rowEnd, previousCell) {
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
  const groupName =
    rowKind === 1
      ? 'tableHeader'
      : rowKind === 2
      ? 'tableDelimiter'
      : 'tableData'
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
  const valueName = 'tableContent'

  // Insert an exit for the previous cell, if there is one.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //          ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]))
    map.add(range[0], 0, [['exit', previousCell, context]])
  }

  // Insert enter of this cell.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //           ^-- enter
  //           ^^^^-- this cell
  // ```
  const now = getPoint(context.events, range[1])
  previousCell = {
    type: groupName,
    start: Object.assign({}, now),
    // Note: correct end is set later.
    end: Object.assign({}, now)
  }
  map.add(range[1], 0, [['enter', previousCell, context]])

  // Insert text start at first data start and end at last data end, and
  // remove events between.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //            ^-- enter
  //             ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2])
    const relatedEnd = getPoint(context.events, range[3])
    /** @type {Token} */
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    }
    map.add(range[2], 0, [['enter', valueToken, context]])
    if (rowKind !== 2) {
      // Fix positional info on remaining events
      const start = context.events[range[2]]
      const end = context.events[range[3]]
      start[1].end = Object.assign({}, end[1].end)
      start[1].type = 'chunkText'
      start[1].contentType = 'text'

      // Remove if needed.
      if (range[3] > range[2] + 1) {
        const a = range[2] + 1
        const b = range[3] - range[2] - 1
        map.add(a, b, [])
      }
    }
    map.add(range[3] + 1, 0, [['exit', valueToken, context]])
  }

  // Insert an exit for the last cell, if at the row end.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //                    ^-- exit
  //               ^^^^^^-- this cell (the last one contains two “between” parts)
  // ```
  if (rowEnd !== undefined) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd))
    map.add(rowEnd, 0, [['exit', previousCell, context]])
    previousCell = undefined
  }
  return previousCell
}

/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */
// eslint-disable-next-line max-params
function flushTableEnd(map, context, index, table, tableBody) {
  /** @type {Array<Event>} */
  const exits = []
  const related = getPoint(context.events, index)
  if (tableBody) {
    tableBody.end = Object.assign({}, related)
    exits.push(['exit', tableBody, context])
  }
  table.end = Object.assign({}, related)
  exits.push(['exit', table, context])
  map.add(index + 1, 0, exits)
}

/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */
function getPoint(events, index) {
  const event = events[index]
  const side = event[0] === 'enter' ? 'start' : 'end'
  return event[1][side]
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-table/lib/html.js
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */

/**
 * @typedef {import('./infer.js').Align} Align
 */

const alignment = {
  none: '',
  left: ' align="left"',
  right: ' align="right"',
  center: ' align="center"'
}

// To do: next major: expose functions.
// To do: next major: use `infer` here, when all events are exposed.

/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to support
 * GFM tables when serializing to HTML.
 *
 * @type {HtmlExtension}
 */
const gfmTableHtml = {
  enter: {
    table(token) {
      const tableAlign = token._align
      this.lineEndingIfNeeded()
      this.tag('<table>')
      this.setData('tableAlign', tableAlign)
    },
    tableBody() {
      this.tag('<tbody>')
    },
    tableData() {
      const tableAlign = this.getData('tableAlign')
      const tableColumn = this.getData('tableColumn')
      const align = alignment[tableAlign[tableColumn]]
      if (align === undefined) {
        // Capture results to ignore them.
        this.buffer()
      } else {
        this.lineEndingIfNeeded()
        this.tag('<td' + align + '>')
      }
    },
    tableHead() {
      this.lineEndingIfNeeded()
      this.tag('<thead>')
    },
    tableHeader() {
      const tableAlign = this.getData('tableAlign')
      const tableColumn = this.getData('tableColumn')
      const align = alignment[tableAlign[tableColumn]]
      this.lineEndingIfNeeded()
      this.tag('<th' + align + '>')
    },
    tableRow() {
      this.setData('tableColumn', 0)
      this.lineEndingIfNeeded()
      this.tag('<tr>')
    }
  },
  exit: {
    // Overwrite the default code text data handler to unescape escaped pipes when
    // they are in tables.
    codeTextData(token) {
      let value = this.sliceSerialize(token)
      if (this.getData('tableAlign')) {
        value = value.replace(/\\([\\|])/g, replace)
      }
      this.raw(this.encode(value))
    },
    table() {
      this.setData('tableAlign')
      // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
      // but we do need to reset it to match a funky newline GH generates for
      // list items combined with tables.
      this.setData('slurpAllLineEndings')
      this.lineEndingIfNeeded()
      this.tag('</table>')
    },
    tableBody() {
      this.lineEndingIfNeeded()
      this.tag('</tbody>')
    },
    tableData() {
      const tableAlign = this.getData('tableAlign')
      const tableColumn = this.getData('tableColumn')
      if (tableColumn in tableAlign) {
        this.tag('</td>')
        this.setData('tableColumn', tableColumn + 1)
      } else {
        // Stop capturing.
        this.resume()
      }
    },
    tableHead() {
      this.lineEndingIfNeeded()
      this.tag('</thead>')
    },
    tableHeader() {
      const tableColumn = this.getData('tableColumn')
      this.tag('</th>')
      this.setData('tableColumn', tableColumn + 1)
    },
    tableRow() {
      const tableAlign = this.getData('tableAlign')
      let tableColumn = this.getData('tableColumn')
      while (tableColumn < tableAlign.length) {
        this.lineEndingIfNeeded()
        this.tag('<td' + alignment[tableAlign[tableColumn]] + '></td>')
        tableColumn++
      }
      this.setData('tableColumn', tableColumn)
      this.lineEndingIfNeeded()
      this.tag('</tr>')
    }
  }
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-tagfilter/index.js
/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */

// An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const reFlow =
  /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi

// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const reText = new RegExp('^' + reFlow.source, 'i')

/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GitHub’s weird and useless tagfilter when serializing to HTML.
 *
 * @type {HtmlExtension}
 */
const gfmTagfilterHtml = {
  exit: {
    htmlFlowData(token) {
      exitHtmlData.call(this, token, reFlow)
    },
    htmlTextData(token) {
      exitHtmlData.call(this, token, reText)
    }
  }
}

/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */
function exitHtmlData(token, filter) {
  let value = this.sliceSerialize(token)

  if (this.options.allowDangerousHtml) {
    value = value.replace(filter, '&lt;$1$2')
  }

  this.raw(this.encode(value))
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-task-list-item/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



const tasklistCheck = {
  tokenize: tokenizeTasklistCheck
}

// To do: next major: expose function to make extension.

/**
 * Extension for `micromark` that can be passed in `extensions`, to
 * enable GFM task list items syntax.
 *
 * @type {Extension}
 */
const gfmTaskListItem = {
  text: {
    [91]: tasklistCheck
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTasklistCheck(effects, ok, nok) {
  const self = this
  return open

  /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (
      // Exit if there’s stuff before.
      self.previous !== null ||
      // Exit if not in the first content that is the first child of a list
      // item.
      !self._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code)
    }
    effects.enter('taskListCheck')
    effects.enter('taskListCheckMarker')
    effects.consume(code)
    effects.exit('taskListCheckMarker')
    return inside
  }

  /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // Currently we match how GH works in files.
    // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
    // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
    if (markdownLineEndingOrSpace(code)) {
      effects.enter('taskListCheckValueUnchecked')
      effects.consume(code)
      effects.exit('taskListCheckValueUnchecked')
      return close
    }
    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked')
      effects.consume(code)
      effects.exit('taskListCheckValueChecked')
      return close
    }
    return nok(code)
  }

  /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */
  function close(code) {
    if (code === 93) {
      effects.enter('taskListCheckMarker')
      effects.consume(code)
      effects.exit('taskListCheckMarker')
      effects.exit('taskListCheck')
      return after
    }
    return nok(code)
  }

  /**
   * @type {State}
   */
  function after(code) {
    // EOL in paragraph means there must be something else after it.
    if (markdownLineEnding(code)) {
      return ok(code)
    }

    // Space or tab?
    // Check what comes after.
    if (markdownSpace(code)) {
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok,
        nok
      )(code)
    }

    // EOF, or non-whitespace, both wrong.
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function spaceThenNonSpace(effects, ok, nok) {
  return factorySpace(effects, after, 'whitespace')

  /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // EOF means there was nothing, so bad.
    // EOL means there’s content after it, so good.
    // Impossible to have more spaces.
    // Anything else is good.
    return code === null ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm-task-list-item/lib/html.js
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */

// To do: next major: expose function to make extension.

/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */
const gfmTaskListItemHtml = {
  enter: {
    taskListCheck() {
      this.tag('<input type="checkbox" disabled="" ')
    }
  },
  exit: {
    taskListCheck() {
      this.tag('/>')
    },
    taskListCheckValueChecked() {
      this.tag('checked="" ')
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/micromark-extension-gfm/index.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 */








/**
 * Support GFM or markdown on github.com.
 *
 * @param {Options} [options]
 * @returns {Extension}
 */
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral,
    gfmStrikethrough(options),
    gfmTable,
    gfmTaskListItem
  ])
}

/** @type {HtmlExtension} */
const gfmHtml = combineHtmlExtensions([
  gfmAutolinkLiteralHtml,
  gfmStrikethroughHtml,
  gfmTableHtml,
  gfmTagfilterHtml,
  gfmTaskListItemHtml
])

;// CONCATENATED MODULE: ../../node_modules/mdast-util-gfm-autolink-literal/node_modules/ccount/index.js
/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value)

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0
  let index = source.indexOf(character)

  while (index !== -1) {
    count++
    index = source.indexOf(character, index + character.length)
  }

  return count
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-find-and-replace/node_modules/escape-string-regexp/index.js
function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-find-and-replace/node_modules/unist-util-visit-parents/lib/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function lib_color_browser_color(d) {
  return d
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-find-and-replace/node_modules/unist-util-visit-parents/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */

/**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */

/**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */

/**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */




/**
 * Continue traversing as normal.
 */
const lib_CONTINUE = true

/**
 * Stop traversing immediately.
 */
const lib_EXIT = false

/**
 * Do not traverse this node’s children.
 */
const lib_SKIP = 'skip'

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @param tree
 *   Tree to traverse.
 * @param test
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Handle each node.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns
 *   Nothing.
 */
const lib_visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, undefined, [])()

      /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = node && typeof node === 'object' ? node : {}

        if (typeof value.type === 'string') {
          const name =
            // `hast`
            typeof value.tagName === 'string'
              ? value.tagName
              : // `xast`
              typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' + lib_color_browser_color(node.type + (name ? '<' + name + '>' : '')) + ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = lib_toResult(visitor(node, parents))

            if (result[0] === lib_EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== lib_SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === lib_EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */
function lib_toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [lib_CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-find-and-replace/lib/index.js
/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */





const mdast_util_find_and_replace_lib_own = {}.hasOwnProperty

/**
 * Find patterns in a tree and replace them.
 *
 * The algorithm searches the tree in *preorder* for complete values in `Text`
 * nodes.
 * Partial matches are not supported.
 *
 * @param tree
 *   Tree to change.
 * @param find
 *   Patterns to find.
 * @param replace
 *   Things to replace with (when `find` is `Find`) or configuration.
 * @param options
 *   Configuration (when `find` is not `Find`).
 * @returns
 *   Given, modified, tree.
 */
// To do: next major: remove `find` & `replace` combo, remove schema.
const findAndReplace =
  /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/
  (
    /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */
    function (tree, find, replace, options) {
      /** @type {Options | null | undefined} */
      let settings
      /** @type {FindAndReplaceSchema|FindAndReplaceList} */
      let schema

      if (typeof find === 'string' || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [[find, replace]]
        settings = options
      } else {
        schema = find
        // @ts-expect-error don’t expect replace twice.
        settings = replace
      }

      if (!settings) {
        settings = {}
      }

      const ignored = convert(settings.ignore || [])
      const pairs = toPairs(schema)
      let pairIndex = -1

      while (++pairIndex < pairs.length) {
        lib_visitParents(tree, 'text', visitor)
      }

      // To do next major: don’t return the given tree.
      return tree

      /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */
      function visitor(node, parents) {
        let index = -1
        /** @type {Parent | undefined} */
        let grandparent

        while (++index < parents.length) {
          const parent = parents[index]

          if (
            ignored(
              parent,
              // @ts-expect-error: TS doesn’t understand but it’s perfect.
              grandparent ? grandparent.children.indexOf(parent) : undefined,
              grandparent
            )
          ) {
            return
          }

          grandparent = parent
        }

        if (grandparent) {
          return handler(node, parents)
        }
      }

      /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */
      function handler(node, parents) {
        const parent = parents[parents.length - 1]
        const find = pairs[pairIndex][0]
        const replace = pairs[pairIndex][1]
        let start = 0
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node)
        let change = false
        /** @type {Array<PhrasingContent>} */
        let nodes = []

        find.lastIndex = 0

        let match = find.exec(node.value)

        while (match) {
          const position = match.index
          /** @type {RegExpMatchObject} */
          const matchObject = {
            index: match.index,
            input: match.input,
            // @ts-expect-error: stack is fine.
            stack: [...parents, node]
          }
          let value = replace(...match, matchObject)

          if (typeof value === 'string') {
            value = value.length > 0 ? {type: 'text', value} : undefined
          }

          // It wasn’t a match after all.
          if (value !== false) {
            if (start !== position) {
              nodes.push({
                type: 'text',
                value: node.value.slice(start, position)
              })
            }

            if (Array.isArray(value)) {
              nodes.push(...value)
            } else if (value) {
              nodes.push(value)
            }

            start = position + match[0].length
            change = true
          }

          if (!find.global) {
            break
          }

          match = find.exec(node.value)
        }

        if (change) {
          if (start < node.value.length) {
            nodes.push({type: 'text', value: node.value.slice(start)})
          }

          parent.children.splice(index, 1, ...nodes)
        } else {
          nodes = [node]
        }

        return index + nodes.length
      }
    }
  )

/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */
function toPairs(schema) {
  /** @type {Pairs} */
  const result = []

  if (typeof schema !== 'object') {
    throw new TypeError('Expected array or object as schema')
  }

  if (Array.isArray(schema)) {
    let index = -1

    while (++index < schema.length) {
      result.push([
        toExpression(schema[index][0]),
        toFunction(schema[index][1])
      ])
    }
  } else {
    /** @type {string} */
    let key

    for (key in schema) {
      if (mdast_util_find_and_replace_lib_own.call(schema, key)) {
        result.push([toExpression(key), toFunction(schema[key])])
      }
    }
  }

  return result
}

/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */
function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escapeStringRegexp(find), 'g') : find
}

/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */
function toFunction(replace) {
  return typeof replace === 'function' ? replace : () => replace
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-gfm-autolink-literal/lib/index.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */





/** @type {ConstructName} */
const inConstruct = 'phrasing'
/** @type {Array<ConstructName>} */
const notInConstruct = ['autolink', 'link', 'image', 'label']

// To do: next major: expose functions instead of extensions.

/**
 * Extension for `mdast-util-from-markdown` to enable GFM autolink literals.
 *
 * @type {FromMarkdownExtension}
 */
const gfmAutolinkLiteralFromMarkdown = {
  transforms: [transformGfmAutolinkLiterals],
  enter: {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
  },
  exit: {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
  }
}

/**
 * Extension for `mdast-util-to-markdown` to enable GFM autolink literals.
 *
 * @type {ToMarkdownExtension}
 */
const gfmAutolinkLiteralToMarkdown = {
  unsafe: [
    {
      character: '@',
      before: '[+\\-.\\w]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {
      character: '.',
      before: '[Ww]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {character: ':', before: '[ps]', after: '\\/', inConstruct, notInConstruct}
  ]
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolink(token) {
  this.enter({type: 'link', title: null, url: '', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token)
  const node = /** @type {Link} */ (this.stack[this.stack.length - 1])
  node.url = 'http://' + this.sliceSerialize(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolink(token) {
  this.exit(token)
}

/** @type {FromMarkdownTransform} */
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, findEmail]
    ],
    {ignore: ['link', 'linkReference']}
  )
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */
// eslint-disable-next-line max-params
function findUrl(_, protocol, domain, path, match) {
  let prefix = ''

  // Not an expected previous character.
  if (!lib_previous(match)) {
    return false
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain
    protocol = ''
    prefix = 'http://'
  }

  if (!isCorrectDomain(domain)) {
    return false
  }

  const parts = splitUrl(domain + path)

  if (!parts[0]) return false

  /** @type {Link} */
  const result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{type: 'text', value: protocol + parts[0]}]
  }

  if (parts[1]) {
    return [result, {type: 'text', value: parts[1]}]
  }

  return result
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !lib_previous(match, true) ||
    // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false
  }

  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{type: 'text', value: atext + '@' + label}]
  }
}

/**
 * @param {string} domain
 * @returns {boolean}
 */
function isCorrectDomain(domain) {
  const parts = domain.split('.')

  if (
    parts.length < 2 ||
    (parts[parts.length - 1] &&
      (/_/.test(parts[parts.length - 1]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 1]))) ||
    (parts[parts.length - 2] &&
      (/_/.test(parts[parts.length - 2]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 2])))
  ) {
    return false
  }

  return true
}

/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url)

  if (!trailExec) {
    return [url, undefined]
  }

  url = url.slice(0, trailExec.index)

  let trail = trailExec[0]
  let closingParenIndex = trail.indexOf(')')
  const openingParens = ccount(url, '(')
  let closingParens = ccount(url, ')')

  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail.slice(0, closingParenIndex + 1)
    trail = trail.slice(closingParenIndex + 1)
    closingParenIndex = trail.indexOf(')')
    closingParens++
  }

  return [url, trail]
}

/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */
function lib_previous(match, email) {
  const code = match.input.charCodeAt(match.index - 1)

  return (
    (match.index === 0 ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)) &&
    (!email || code !== 47)
  )
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/util/container-phrasing.js
/**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */

/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */
function containerPhrasing(parent, state, info) {
  const indexStack = state.indexStack
  const children = parent.children || []
  /** @type {Array<string>} */
  const results = []
  let index = -1
  let before = info.before

  indexStack.push(-1)
  let tracker = state.createTracker(info)

  while (++index < children.length) {
    const child = children[index]
    /** @type {string} */
    let after

    indexStack[indexStack.length - 1] = index

    if (index + 1 < children.length) {
      /** @type {Handle} */
      // @ts-expect-error: hush, it’s actually a `zwitch`.
      let handle = state.handle.handlers[children[index + 1].type]
      /** @type {Handle} */
      // @ts-expect-error: hush, it’s actually a `zwitch`.
      if (handle && handle.peek) handle = handle.peek
      after = handle
        ? handle(children[index + 1], parent, state, {
            before: '',
            after: '',
            ...tracker.current()
          }).charAt(0)
        : ''
    } else {
      after = info.after
    }

    // In some cases, html (text) can be found in phrasing right after an eol.
    // When we’d serialize that, in most cases that would be seen as html
    // (flow).
    // As we can’t escape or so to prevent it from happening, we take a somewhat
    // reasonable approach: replace that eol with a space.
    // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
    if (
      results.length > 0 &&
      (before === '\r' || before === '\n') &&
      child.type === 'html'
    ) {
      results[results.length - 1] = results[results.length - 1].replace(
        /(\r?\n|\r)$/,
        ' '
      )
      before = ' '

      // To do: does this work to reset tracker?
      tracker = state.createTracker(info)
      tracker.move(results.join(''))
    }

    results.push(
      tracker.move(
        state.handle(child, parent, state, {
          ...tracker.current(),
          before,
          after
        })
      )
    )

    before = results[results.length - 1].slice(-1)
  }

  indexStack.pop()

  return results.join('')
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/util/track.js
/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */

/**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */
function track(config) {
  // Defaults are used to prevent crashes when older utilities somehow activate
  // this code.
  /* c8 ignore next 5 */
  const options = config || {}
  const now = options.now || {}
  let lineShift = options.lineShift || 0
  let line = now.line || 1
  let column = now.column || 1

  return {move, current, shift}

  /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */
  function current() {
    return {now: {line, column}, lineShift}
  }

  /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */
  function shift(value) {
    lineShift += value
  }

  /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */
  function move(input) {
    // eslint-disable-next-line unicorn/prefer-default-parameters
    const value = input || ''
    const chunks = value.split(/\r?\n|\r/g)
    const tail = chunks[chunks.length - 1]
    line += chunks.length - 1
    column =
      chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift
    return value
  }
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-gfm-strikethrough/lib/index.js
/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */




// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.

/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */
const constructsWithoutStrikethrough = [
  'autolink',
  'destinationLiteral',
  'destinationRaw',
  'reference',
  'titleQuote',
  'titleApostrophe'
]

handleDelete.peek = peekDelete

/**
 * Extension for `mdast-util-from-markdown` to enable GFM strikethrough.
 *
 * @type {FromMarkdownExtension}
 */
const gfmStrikethroughFromMarkdown = {
  canContainEols: ['delete'],
  enter: {strikethrough: enterStrikethrough},
  exit: {strikethrough: exitStrikethrough}
}

/**
 * Extension for `mdast-util-to-markdown` to enable GFM strikethrough.
 *
 * @type {ToMarkdownExtension}
 */
const gfmStrikethroughToMarkdown = {
  unsafe: [
    {
      character: '~',
      inConstruct: 'phrasing',
      notInConstruct: constructsWithoutStrikethrough
    }
  ],
  handlers: {delete: handleDelete}
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterStrikethrough(token) {
  this.enter({type: 'delete', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitStrikethrough(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, context, safeOptions) {
  const tracker = track(safeOptions)
  const exit = context.enter('strikethrough')
  let value = tracker.move('~~')
  value += containerPhrasing(node, context, {
    ...tracker.current(),
    before: value,
    after: '~'
  })
  value += tracker.move('~~')
  exit()
  return value
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~'
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/util/pattern-compile.js
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */
function patternCompile(pattern) {
  if (!pattern._compiled) {
    const before =
      (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') +
      (pattern.before ? '(?:' + pattern.before + ')' : '')

    pattern._compiled = new RegExp(
      (before ? '(' + before + ')' : '') +
        (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') +
        pattern.character +
        (pattern.after ? '(?:' + pattern.after + ')' : ''),
      'g'
    )
  }

  return pattern._compiled
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/handle/inline-code.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */



inline_code_inlineCode.peek = inlineCodePeek

/**
 * @param {InlineCode} node
 * @param {Parent | undefined} _
 * @param {State} state
 * @returns {string}
 */
function inline_code_inlineCode(node, _, state) {
  let value = node.value || ''
  let sequence = '`'
  let index = -1

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`'
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (
    /[^ \r\n]/.test(value) &&
    ((/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value)) || /^`|`$/.test(value))
  ) {
    value = ' ' + value + ' '
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < state.unsafe.length) {
    const pattern = state.unsafe[index]
    const expression = patternCompile(pattern)
    /** @type {RegExpExecArray | null} */
    let match

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue

    while ((match = expression.exec(value))) {
      let position = match.index

      // Support CRLF (patterns only look for one of the characters).
      if (
        value.charCodeAt(position) === 10 /* `\n` */ &&
        value.charCodeAt(position - 1) === 13 /* `\r` */
      ) {
        position--
      }

      value = value.slice(0, position) + ' ' + value.slice(match.index + 1)
    }
  }

  return sequence + value + sequence
}

/**
 * @returns {string}
 */
function inlineCodePeek() {
  return '`'
}

;// CONCATENATED MODULE: ../../node_modules/markdown-table/index.js
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */

/**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */

/**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat()
  const stringLength = options.stringLength || defaultStringLength
  /** @type {Array<number>} Character codes as symbols for alignment per column. */
  const alignments = []
  /** @type {Array<Array<string>>} Cells per row. */
  const cellMatrix = []
  /** @type {Array<Array<number>>} Sizes of each cell per row. */
  const sizeMatrix = []
  /** @type {Array<number>} */
  const longestCellByColumn = []
  let mostCellsPerRow = 0
  let rowIndex = -1

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < table.length) {
    /** @type {Array<string>} */
    const row = []
    /** @type {Array<number>} */
    const sizes = []
    let columnIndex = -1

    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length
    }

    while (++columnIndex < table[rowIndex].length) {
      const cell = serialize(table[rowIndex][columnIndex])

      if (options.alignDelimiters !== false) {
        const size = stringLength(cell)
        sizes[columnIndex] = size

        if (
          longestCellByColumn[columnIndex] === undefined ||
          size > longestCellByColumn[columnIndex]
        ) {
          longestCellByColumn[columnIndex] = size
        }
      }

      row.push(cell)
    }

    cellMatrix[rowIndex] = row
    sizeMatrix[rowIndex] = sizes
  }

  // Figure out which alignments to use.
  let columnIndex = -1

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex])
    }
  } else {
    const code = toAlignment(align)

    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code
    }
  }

  // Inject the alignment row.
  columnIndex = -1
  /** @type {Array<string>} */
  const row = []
  /** @type {Array<number>} */
  const sizes = []

  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex]
    let before = ''
    let after = ''

    if (code === 99 /* `c` */) {
      before = ':'
      after = ':'
    } else if (code === 108 /* `l` */) {
      before = ':'
    } else if (code === 114 /* `r` */) {
      after = ':'
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    let size =
      options.alignDelimiters === false
        ? 1
        : Math.max(
            1,
            longestCellByColumn[columnIndex] - before.length - after.length
          )

    const cell = before + '-'.repeat(size) + after

    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size
      }

      sizes[columnIndex] = size
    }

    row[columnIndex] = cell
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row)
  sizeMatrix.splice(1, 0, sizes)

  rowIndex = -1
  /** @type {Array<string>} */
  const lines = []

  while (++rowIndex < cellMatrix.length) {
    const row = cellMatrix[rowIndex]
    const sizes = sizeMatrix[rowIndex]
    columnIndex = -1
    /** @type {Array<string>} */
    const line = []

    while (++columnIndex < mostCellsPerRow) {
      const cell = row[columnIndex] || ''
      let before = ''
      let after = ''

      if (options.alignDelimiters !== false) {
        const size =
          longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0)
        const code = alignments[columnIndex]

        if (code === 114 /* `r` */) {
          before = ' '.repeat(size)
        } else if (code === 99 /* `c` */) {
          if (size % 2) {
            before = ' '.repeat(size / 2 + 0.5)
            after = ' '.repeat(size / 2 - 0.5)
          } else {
            before = ' '.repeat(size / 2)
            after = before
          }
        } else {
          after = ' '.repeat(size)
        }
      }

      if (options.delimiterStart !== false && !columnIndex) {
        line.push('|')
      }

      if (
        options.padding !== false &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(options.alignDelimiters === false && cell === '') &&
        (options.delimiterStart !== false || columnIndex)
      ) {
        line.push(' ')
      }

      if (options.alignDelimiters !== false) {
        line.push(before)
      }

      line.push(cell)

      if (options.alignDelimiters !== false) {
        line.push(after)
      }

      if (options.padding !== false) {
        line.push(' ')
      }

      if (
        options.delimiterEnd !== false ||
        columnIndex !== mostCellsPerRow - 1
      ) {
        line.push('|')
      }
    }

    lines.push(
      options.delimiterEnd === false
        ? line.join('').replace(/ +$/, '')
        : line.join('')
    )
  }

  return lines.join('\n')
}

/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */
function serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

/**
 * @param {string} value
 * @returns {number}
 */
function defaultStringLength(value) {
  return value.length
}

/**
 * @param {string|null|undefined} value
 * @returns {number}
 */
function toAlignment(value) {
  const code = typeof value === 'string' ? value.codePointAt(0) : 0

  return code === 67 /* `C` */ || code === 99 /* `c` */
    ? 99 /* `c` */
    : code === 76 /* `L` */ || code === 108 /* `l` */
    ? 108 /* `l` */
    : code === 82 /* `R` */ || code === 114 /* `r` */
    ? 114 /* `r` */
    : 0
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-gfm-table/lib/index.js
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */

/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */





// To do: next major: use `state` and `state` utilities from `mdast-util-to-markdown`.
// To do: next major: use `defaultHandlers.inlineCode`.
// To do: next major: expose functions.

/**
 * Extension for `mdast-util-from-markdown` to enable GFM tables.
 *
 * @type {FromMarkdownExtension}
 */
const gfmTableFromMarkdown = {
  enter: {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
  },
  exit: {
    codeText: exitCodeText,
    table: exitTable,
    tableData: lib_exit,
    tableHeader: lib_exit,
    tableRow: lib_exit
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterTable(token) {
  /** @type {Array<'left' | 'right' | 'center' | 'none'>} */
  // @ts-expect-error: `align` is custom.
  const align = token._align
  this.enter(
    {
      type: 'table',
      align: align.map((d) => (d === 'none' ? null : d)),
      children: []
    },
    token
  )
  this.setData('inTable', true)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitTable(token) {
  this.exit(token)
  this.setData('inTable')
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterRow(token) {
  this.enter({type: 'tableRow', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function lib_exit(token) {
  this.exit(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterCell(token) {
  this.enter({type: 'tableCell', children: []}, token)
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCodeText(token) {
  let value = this.resume()

  if (this.getData('inTable')) {
    value = value.replace(/\\([\\|])/g, lib_replace)
  }

  const node = /** @type {InlineCode} */ (this.stack[this.stack.length - 1])
  node.value = value
  this.exit(token)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function lib_replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM tables in
 * markdown.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM tables.
 */
function gfmTableToMarkdown(options) {
  const settings = options || {}
  const padding = settings.tableCellPadding
  const alignDelimiters = settings.tablePipeAlign
  const stringLength = settings.stringLength
  const around = padding ? ' ' : '|'

  return {
    unsafe: [
      {character: '\r', inConstruct: 'tableCell'},
      {character: '\n', inConstruct: 'tableCell'},
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      {atBreak: true, character: '|', after: '[\t :-]'},
      // A pipe in a cell must be encoded.
      {character: '|', inConstruct: 'tableCell'},
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      {atBreak: true, character: ':', after: '-'},
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      {atBreak: true, character: '-', after: '[:|-]'}
    ],
    handlers: {
      table: handleTable,
      tableRow: handleTableRow,
      tableCell: handleTableCell,
      inlineCode: inlineCodeWithTable
    }
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */
  function handleTable(node, _, context, safeOptions) {
    return serializeData(
      handleTableAsData(node, context, safeOptions),
      node.align
    )
  }

  /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */
  function handleTableRow(node, _, context, safeOptions) {
    const row = handleTableRowAsData(node, context, safeOptions)
    const value = serializeData([row])
    // `markdown-table` will always add an align row
    return value.slice(0, value.indexOf('\n'))
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */
  function handleTableCell(node, _, context, safeOptions) {
    const exit = context.enter('tableCell')
    const subexit = context.enter('phrasing')
    const value = containerPhrasing(node, context, {
      ...safeOptions,
      before: around,
      after: around
    })
    subexit()
    exit()
    return value
  }

  /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength
    })
  }

  /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableAsData(node, context, safeOptions) {
    const children = node.children
    let index = -1
    /** @type {Array<Array<string>>} */
    const result = []
    const subexit = context.enter('table')

    while (++index < children.length) {
      result[index] = handleTableRowAsData(
        children[index],
        context,
        safeOptions
      )
    }

    subexit()

    return result
  }

  /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableRowAsData(node, context, safeOptions) {
    const children = node.children
    let index = -1
    /** @type {Array<string>} */
    const result = []
    const subexit = context.enter('tableRow')

    while (++index < children.length) {
      // Note: the positional info as used here is incorrect.
      // Making it correct would be impossible due to aligning cells?
      // And it would need copy/pasting `markdown-table` into this project.
      result[index] = handleTableCell(
        children[index],
        node,
        context,
        safeOptions
      )
    }

    subexit()

    return result
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */
  function inlineCodeWithTable(node, parent, context) {
    let value = inline_code_inlineCode(node, parent, context)

    if (context.stack.includes('tableCell')) {
      value = value.replace(/\|/g, '\\$&')
    }

    return value
  }
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/util/check-bullet.js
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */
function checkBullet(state) {
  const marker = state.options.bullet || '*'

  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bullet`, expected `*`, `+`, or `-`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/util/check-list-item-indent.js
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */
function checkListItemIndent(state) {
  const style = state.options.listItemIndent || 'tab'

  // To do: remove in a major.
  // @ts-expect-error: deprecated.
  if (style === 1 || style === '1') {
    return 'one'
  }

  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error(
      'Cannot serialize items with `' +
        style +
        '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`'
    )
  }

  return style
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-to-markdown/lib/handle/list-item.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */




/**
 * @param {ListItem} node
 * @param {Parent | undefined} parent
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function list_item_listItem(node, parent, state, info) {
  const listItemIndent = checkListItemIndent(state)
  let bullet = state.bulletCurrent || checkBullet(state)

  // Add the marker value for ordered lists.
  if (parent && parent.type === 'list' && parent.ordered) {
    bullet =
      (typeof parent.start === 'number' && parent.start > -1
        ? parent.start
        : 1) +
      (state.options.incrementListMarker === false
        ? 0
        : parent.children.indexOf(node)) +
      bullet
  }

  let size = bullet.length + 1

  if (
    listItemIndent === 'tab' ||
    (listItemIndent === 'mixed' &&
      ((parent && parent.type === 'list' && parent.spread) || node.spread))
  ) {
    size = Math.ceil(size / 4) * 4
  }

  const tracker = state.createTracker(info)
  tracker.move(bullet + ' '.repeat(size - bullet.length))
  tracker.shift(size)
  const exit = state.enter('listItem')
  const value = state.indentLines(
    state.containerFlow(node, tracker.current()),
    map
  )
  exit()

  return value

  /** @type {Map} */
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line
  }
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-gfm-task-list-item/lib/index.js
/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */

/**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */




// To do: next major: rename `context` -> `state`, `safeOptions` -> `info`, use
// `track` from `state`.
// To do: next major: replace exports with functions.
// To do: next major: use `defaulthandlers.listItem`.

/**
 * Extension for `mdast-util-from-markdown` to enable GFM task list items.
 *
 * @type {FromMarkdownExtension}
 */
const gfmTaskListItemFromMarkdown = {
  exit: {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
  }
}

/**
 * Extension for `mdast-util-to-markdown` to enable GFM task list items.
 *
 * @type {ToMarkdownExtension}
 */
const gfmTaskListItemToMarkdown = {
  unsafe: [{atBreak: true, character: '-', after: '[:|-]'}],
  handlers: {listItem: listItemWithTaskListItem}
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCheck(token) {
  const node = /** @type {ListItem} */ (this.stack[this.stack.length - 2])
  // We’re always in a paragraph, in a list item.
  node.checked = token.type === 'taskListCheckValueChecked'
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitParagraphWithTaskListItem(token) {
  const parent = /** @type {Parents} */ (this.stack[this.stack.length - 2])

  if (
    parent &&
    parent.type === 'listItem' &&
    typeof parent.checked === 'boolean'
  ) {
    const node = /** @type {Paragraph} */ (this.stack[this.stack.length - 1])
    const head = node.children[0]

    if (head && head.type === 'text') {
      const siblings = parent.children
      let index = -1
      /** @type {Paragraph | undefined} */
      let firstParaghraph

      while (++index < siblings.length) {
        const sibling = siblings[index]
        if (sibling.type === 'paragraph') {
          firstParaghraph = sibling
          break
        }
      }

      if (firstParaghraph === node) {
        // Must start with a space or a tab.
        head.value = head.value.slice(1)

        if (head.value.length === 0) {
          node.children.shift()
        } else if (
          node.position &&
          head.position &&
          typeof head.position.start.offset === 'number'
        ) {
          head.position.start.column++
          head.position.start.offset++
          node.position.start = Object.assign({}, head.position.start)
        }
      }
    }
  }

  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */
function listItemWithTaskListItem(node, parent, context, safeOptions) {
  const head = node.children[0]
  const checkable =
    typeof node.checked === 'boolean' && head && head.type === 'paragraph'
  const checkbox = '[' + (node.checked ? 'x' : ' ') + '] '
  const tracker = track(safeOptions)

  if (checkable) {
    tracker.move(checkbox)
  }

  let value = list_item_listItem(node, parent, context, {
    ...safeOptions,
    ...tracker.current()
  })

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check)
  }

  return value

  /**
   * @param {string} $0
   * @returns {string}
   */
  function check($0) {
    return $0 + checkbox
  }
}

;// CONCATENATED MODULE: ../../node_modules/mdast-util-gfm/index.js
/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-gfm-table').Options} Options
 */






/**
 * @type {Array.<FromMarkdownExtension>}
 */
const gfmFromMarkdown = [
  gfmAutolinkLiteralFromMarkdown,
  gfmStrikethroughFromMarkdown,
  gfmTableFromMarkdown,
  gfmTaskListItemFromMarkdown
]

/**
 * @param {Options} [options]
 * @returns {ToMarkdownExtension}
 */
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown,
      gfmStrikethroughToMarkdown,
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown
    ]
  }
}

;// CONCATENATED MODULE: ../../node_modules/remark-gfm/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */




/**
 * Plugin to support GitHub Flavored Markdown (GFM).
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root>}
 */
function remarkGfm(options = {}) {
  const data = this.data()

  add('micromarkExtensions', gfm(options))
  add('fromMarkdownExtensions', gfmFromMarkdown)
  add('toMarkdownExtensions', gfmToMarkdown(options))

  /**
   * @param {string} field
   * @param {unknown} value
   */
  function add(field, value) {
    const list = /** @type {unknown[]} */ (
      // Other extensions
      /* c8 ignore next 2 */
      data[field] ? data[field] : (data[field] = [])
    )

    list.push(value)
  }
}

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MarkdownText/MarkdownText.tsx





var MarkdownText = function MarkdownText(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test-id": "MarkdownText",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReactMarkdown, {
      remarkPlugins: [remarkGfm],
      rehypePlugins: [rehypeRaw],
      "data-test-id": "MarkdownText-ReactMarkdown",
      children: value
    })
  });
};

/* harmony default export */ var MarkdownText_MarkdownText = (MarkdownText);

/***/ }),

/***/ 2207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PersuasionBannerStyle; },
/* harmony export */   "c": function() { return /* binding */ BulletListStyle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2874);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3139);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4576);
/* harmony import */ var _BulletListItem_BulletListItem_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8988);
/* harmony import */ var _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5590);






var PersuasionBannerStyle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "sc-1a6nyyd-0"
})(["", " padding:30px 34px;border-radius:25px;background-image:", ";background-size:contain;background-repeat:no-repeat;display:flex;flex-direction:column;height:400px;gap:20px;em{color:", ";font-weight:700;font-style:normal;}", "{width:100%;}& ul{display:flex;flex-direction:column;gap:16px;}& li{position:relative;padding-left:16px;}& li:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}@media ", "{padding:32px 16px;background-size:cover;border:1px solid #fff;margin-bottom:16px;}", "{margin-bottom:16px;&:last-child{margin-bottom:0;}@media ", "{margin-bottom:8px;}}", "{padding:10px 40px;}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return "url(".concat(props.bgImage, ")");
}, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greenText */ .rS.greenText, _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_1__/* .H3TagStyle */ .KO, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.darkYellowText */ .rS.darkYellowText, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile, _BulletListItem_BulletListItem_style__WEBPACK_IMPORTED_MODULE_3__/* .BulletListItemStyle */ .I, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile, _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_4__/* .LandingButtonStyle */ .zm);
var BulletListStyle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "sc-1a6nyyd-1"
})(["display:flex;flex-direction:column;"]);

/***/ }),

/***/ 1643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _MarkdownText_MarkdownText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6518);
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7871);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);





var RichText = function RichText(_ref) {
  var value = _ref.value;

  if (typeof value === "string") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_MarkdownText_MarkdownText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      value: value,
      "data-test-id": "RichText-MarkdownText"
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    value: value,
    "data-test-id": "RichText-FormattedText"
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RichText);

/***/ }),

/***/ 2287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SectionDividersStyle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var SectionDividersStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionDividersstyle__SectionDividersStyle",
  componentId: "sc-1legtm0-0"
})(["background:", ";width:", ";height:", ";border-radius:", ";margin:", ";", ";", ";", ";flex-shrink:0;"], function (p) {
  return p.backgroundColor ? "".concat(p.backgroundColor) : "#f2f2f2";
}, function (p) {
  return p.width ? p.width : "unset";
}, function (p) {
  return p.height ? p.height : "4px";
}, function (p) {
  return p.borderRadius ? p.borderRadius : "0px";
}, function (p) {
  return p.margin ? p.margin : "0px";
}, function (p) {
  return p.xs && "height: 1px;";
}, function (p) {
  return p.small && "height: 10px;";
}, function (p) {
  return p.large && "height: 25px;";
});

/***/ }),

/***/ 9156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ ShimmerVersion3Style; },
/* harmony export */   "aW": function() { return /* binding */ ShimmerVersion2Style; },
/* harmony export */   "zn": function() { return /* binding */ ShimmerComp; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
var ShimmerComp = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Shimmerstyle__ShimmerComp",
  componentId: "sc-1fovdgs-0"
})(["animation:", " 1s linear infinite;background:linear-gradient(to right,#2F2F2F  8%,#393939 18%,#2F2F2F   33%);background-size:800px 104px;position:relative;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;padding:", ";display:flex;align-items:flex-end;}"], shimmer, function (p) {
  return p.width ? p.width : "100%";
}, function (p) {
  return p.height ? p.height : "14px";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.padding ? p.padding : "";
});
var ShimmerVersion2Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion2Style",
  componentId: "sc-1fovdgs-1"
})(["background:linear-gradient(to right,#f6f6f6 8%,#f9fafb 18%,#f6f6f6 33%);background-size:800px 104px;"]);
var ShimmerVersion3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion3Style",
  componentId: "sc-1fovdgs-2"
})(["background:linear-gradient(to right,#cbcbcb 8%,#f9fafb 18%,#cbcbcb 33%);background-size:800px 104px;"]);

/***/ }),

/***/ 3531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Shimmer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Shimmer_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);



function Shimmer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      padding = _ref.padding,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_Shimmer_style__WEBPACK_IMPORTED_MODULE_1__/* .ShimmerComp */ .zn, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerComp",
    children: [" ", children]
  });
}

/***/ }),

/***/ 599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZR": function() { return /* binding */ VerifiedContainer; },
/* harmony export */   "dd": function() { return /* binding */ TMInputWrap; },
/* harmony export */   "qT": function() { return /* binding */ InputWpr; },
/* harmony export */   "qk": function() { return /* binding */ IconContainer; },
/* harmony export */   "se": function() { return /* binding */ TMInputStyle; }
/* harmony export */ });
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5505);


var TMInputWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__TMInputWrap",
  componentId: "l84rpp-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:700;font-size:14px;line-height:20px;color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:10px;top:18px;text-transform:uppercase;", " ", "}", " label span{font-weight:400;text-transform:lowercase;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
}, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, function (props) {
  return props.placeholder && "\n    color: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, ";\n    background: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueLight */ .rS.blueLight, ";\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 16px;\n    top: 5px;\n    ");
}, function (props) {
  return props.disableState && "\n        pointer-events: none;\n        color: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlack */ .rS.lightBlack, ";\n    ");
}, function (props) {
  return props.clickable && "\n        cursor: pointer;\n        background:".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, ";\n        color: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, "\n    ");
});
var TMInputStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "TMFloatingInputstyle__TMInputStyle",
  componentId: "l84rpp-1"
})(["background:", ";border:1px solid ", ";border-radius:4px;padding:26px 10px 10px;font-weight:700;font-size:14px;line-height:19px;display:block;width:100%;", " &:focus + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", "}&:valid + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", " ", " ", " ", "}", " ", " ", " &:focus{outline:none;border:1px solid ", ";background:", ";}&:valid{outline:none;border:1px solid ", ";background:", ";", "}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gray97 */ .rS.gray97, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightGrey */ .rS.lightGrey, function (props) {
  return props.verifiedTag && "\n        padding-right: 80px;\n    ";
}, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueLight */ .rS.blueLight, function (props) {
  return props.errorState && "\n        color: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText2 */ .rS.redText2, ";\n    ");
}, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText6 */ .rS.greyText6, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.smokeWhite */ .rS.smokeWhite, function (props) {
  return props.isActive && "\n            color: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, ";\n            background: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueLight */ .rS.blueLight, ";\n        ");
}, function (props) {
  return props.placeholder && "\n            color: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, ";\n            background: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueLight */ .rS.blueLight, ";\n        ");
}, function (props) {
  return props.errorState && "\n             color: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText2 */ .rS.redText2, ";\n     ");
}, function (props) {
  return props.clickable && "\n        background: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, ";\n    ");
}, function (props) {
  return props.disableState && "\n        pointer-events: none;\n        color:  ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlack */ .rS.lightBlack, ";\n        border: 1px solid ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightSilver */ .rS.lightSilver, ";\n        background: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, ";\n    ");
}, function (props) {
  return props.clickable && "\n        pointer-events: none;\n        background: ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, "  !important;\n        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n    ");
}, function (props) {
  return props.errorState && "\n      border: 1px solid ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText2 */ .rS.redText2, " !important;\n      background: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.snowWhite */ .rS.snowWhite, "  !important;\n    ");
}, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.smokeWhite */ .rS.smokeWhite, function (props) {
  return props.isActive && "\n            border: 1px solid ".concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, ";\n            background: ").concat(_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueLight */ .rS.blueLight, ";\n        ");
});
var VerifiedContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__VerifiedContainer",
  componentId: "l84rpp-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
var InputWpr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__InputWpr",
  componentId: "l84rpp-3"
})(["position:relative;"]);
var IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__IconContainer",
  componentId: "l84rpp-4"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);

/***/ }),

/***/ 3139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ AnchorTagStyle; },
/* harmony export */   "FI": function() { return /* binding */ H2TagStyle; },
/* harmony export */   "KO": function() { return /* binding */ H3TagStyle; },
/* harmony export */   "OG": function() { return /* binding */ ParaTagStyle; },
/* harmony export */   "Wl": function() { return /* binding */ H5TagStyle; },
/* harmony export */   "sz": function() { return /* binding */ H4TagStyle; },
/* harmony export */   "xT": function() { return /* binding */ H6TagStyle; },
/* harmony export */   "zs": function() { return /* binding */ SpanTagStyle; }
/* harmony export */ });
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4928);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);




var renderFont = function renderFont(txtfontSize) {
  switch (txtfontSize) {
    case "xxs":
      return "\n        font-size: 10px;\n        line-height: 16px;\n      ";

    case "xs":
      return "\n        font-size: 12px;\n        line-height: 16px;\n      ";

    case "sm":
      return "\n        font-size: 0.875rem;\n        line-height: 20px;\n      ";

    case "md":
      return "\n        font-size: 1em;\n        line-height: 22px;\n      ";

    case "large":
      return "\n        font-size: 18px;\n        line-height: 24px;\n      ";

    case "xlarge":
      return "\n        font-size: 1.375rem;\n        line-height: 26px;\n      ";

    /* istanbul ignore next */

    case "xxlarge":
      return "\n        font-size: 1.5em;\n        line-height: 32px;\n      ";

    /* istanbul ignore next */

    case "xxxlarge":
      return "\n        font-size: 1.75em;\n        line-height: 32px;\n      ";

    /* istanbul ignore next */

    default:
      return "\n        font-size: 0.875em;\n        line-height: 20px;\n      ";
  }
};

var renderFontWeight = function renderFontWeight(txtfontWeight, context) {
  switch (txtfontWeight) {
    case "regular":
      return "\n          font-weight: 400;\n        ";

    case "bold":
      return "\n          ".concat(context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "font-weight: 700" : "font-weight: 500", ";\n      ");

    case "black":
      return "\n           ".concat(context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "font-weight: 900" : "font-weight: 700", ";\n        ");

    default:
      return "\n      font-weight: 400;\n    ";
  }
};

var H2TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
  displayName: "TextStylesstyle__H2TagStyle",
  componentId: "sc-1ci0hiy-0"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "36px" : "32px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "44px" : "37px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H3TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStylesstyle__H3TagStyle",
  componentId: "sc-1ci0hiy-1"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";text-align:var(--textAlign,left);font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "32px" : "24px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "38px" : "28px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H4TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "TextStylesstyle__H4TagStyle",
  componentId: "sc-1ci0hiy-2"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "24px" : "22px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "28px" : "26px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H5TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
  displayName: "TextStylesstyle__H5TagStyle",
  componentId: "sc-1ci0hiy-3"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "22px" : "18px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "26px" : "21px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var H6TagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
  displayName: "TextStylesstyle__H6TagStyle",
  componentId: "sc-1ci0hiy-4"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", ";color:", ";font-variant-numeric:lining-nums proportional-nums;"], function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "18px" : "16px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "21px" : "18px";
}, function (p) {
  return p.context === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT ? "900" : "700";
}, function (p) {
  return p.margin ? p.margin : "";
}, function (p) {
  return p.txtcolor ? p.txtcolor : "#000";
});
var ParaTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "TextStylesstyle__ParaTagStyle",
  componentId: "sc-1ci0hiy-5"
})(["", " ", " margin:", ";text-align:", ";color:", ";line-height:", ";text-transform:", ";& > .boldText{font-weight:700;}word-break:break-word;"], function (p) {
  return p.txtfontSize ? "\n    ".concat(renderFont(p.txtfontSize), "\n  ") : "";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.txtcolor && p.txtcolor;
}, function (p) {
  return p.lineHeight && p.lineHeight;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var SpanTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStylesstyle__SpanTagStyle",
  componentId: "sc-1ci0hiy-6"
})(["", " ", " display:inline-block;color:", ";margin:", ";text-transform:", ";word-break:break-word;"], function (p) {
  return p.txtfontSize ? "".concat(renderFont(p.txtfontSize)) : "inherit";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.txtcolor && p.txtcolor;
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.textTransform && p.textTransform;
});
var AnchorTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "TextStylesstyle__AnchorTagStyle",
  componentId: "sc-1ci0hiy-7"
})(["", " ", " margin:", ";display:inline-block;color:", ";text-align:", ";text-transform:", ";", ""], function (p) {
  return p.txtfontSize ? "".concat(renderFont(p.txtfontSize)) : "";
}, function (p) {
  return p.txtfontWeight && "\n    ".concat(renderFontWeight(p.txtfontWeight, p.context ? p.context : undefined), "\n  ");
}, function (p) {
  return p.margin && p.margin;
}, function (p) {
  return p.txtcolor ? p.txtcolor : _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.blueText */ .rS.blueText;
}, function (p) {
  return p.textAlign && p.textAlign;
}, function (p) {
  return p.textTransform && p.textTransform;
}, function (p) {
  return p.disableState && "\n    opacity:0.5;\n    pointer-events:none;\n    ";
});

/***/ }),

/***/ 6306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kT": function() { return /* reexport */ AddAlternateContact_AddAlternateContact; },
  "gc": function() { return /* reexport */ AddPassportDetail_AddPassportDetail; },
  "vl": function() { return /* reexport */ PassportNumComp_AddPassportModal; },
  "Gk": function() { return /* reexport */ AddTravellerDetail_AddTravellerDetailShimmer; },
  "Pq": function() { return /* reexport */ AddTravellerDetail_AddTravellerDetails; },
  "Y6": function() { return /* reexport */ TextStyles_AnchorTag; },
  "YP": function() { return /* reexport */ BackDropComp_BackDropComp; },
  "UD": function() { return /* reexport */ InsurancePlans_BenefitItem; },
  "yx": function() { return /* reexport */ BulletListItem_BulletListItem; },
  "nt": function() { return /* reexport */ CheckButton_CheckButton; },
  "Z1": function() { return /* reexport */ ClaimYourInsurance_ClaimYourInsurance; },
  "Eq": function() { return /* reexport */ CommonModalDweb_CommonModalDweb; },
  "Sy": function() { return /* reexport */ ComparePlan_ComparePlan; },
  "Kg": function() { return /* reexport */ CountryCodeInput_CountryCodeInput; },
  "X9": function() { return /* reexport */ DatePickerComp_DatePickerComp; },
  "S_": function() { return /* reexport */ DesktopLayout_DesktopLayout; },
  "yS": function() { return /* reexport */ DnldPolicyComponent_DnldPolicyComponent; },
  "dg": function() { return /* reexport */ DomesticTravelDetail_DomesticTrip; },
  "I$": function() { return /* reexport */ EditTraveller_EditTraveller; },
  "m7": function() { return /* reexport */ EditTraveller_EditTravellerSheet; },
  "ES": function() { return /* reexport */ ExculsiveOffers_ExclusiveOffers; },
  "Zi": function() { return /* reexport */ FilterPlans_FilterPlans; },
  "bA": function() { return /* reexport */ components_FlexComp_FlexComp; },
  "rc": function() { return /* reexport */ FormattedText_FormattedText/* default */.Z; },
  "FJ": function() { return /* reexport */ GreatChoice_GreatChoice; },
  "Pk": function() { return /* reexport */ GreatChoice_GreatChoiceShimmer; },
  "yZ": function() { return /* reexport */ TextStyles_H2Tag; },
  "AI": function() { return /* reexport */ TextStyles_H3Tag; },
  "j9": function() { return /* reexport */ TextStyles_H4Tag; },
  "jN": function() { return /* reexport */ TextStyles_H5Tag; },
  "dp": function() { return /* reexport */ TextStyles_H6Tag; },
  "cu": function() { return /* reexport */ ImageComponent_ImageComponent; },
  "Du": function() { return /* reexport */ ImageTag_ImageTag; },
  "rG": function() { return /* reexport */ InsurancePlans_InsPlanModalCommonInfo; },
  "J1": function() { return /* reexport */ InsuranceBooked_InsuranceBooked; },
  "Cf": function() { return /* reexport */ InsurancePlans_InsurancePlanTypeSection; },
  "FH": function() { return /* reexport */ InsurancePlans_InsurancePlans; },
  "AW": function() { return /* reexport */ InsurancePlans_InsurancePlansComp; },
  "h5": function() { return /* reexport */ InsurancePlans_InsurancePlansHeader; },
  "VF": function() { return /* reexport */ InsuranceStats_InsuranceStats; },
  "WB": function() { return /* reexport */ LandingButton_LandingButton; },
  "Jo": function() { return /* reexport */ LandingButton_LandingButtonTertiary; },
  "Gv": function() { return /* reexport */ LandingButton_LandingButtonWhite; },
  "IS": function() { return /* reexport */ LandingFooter_LandingFooter; },
  "Sx": function() { return /* reexport */ LandingHeader_LandingHeader; },
  "cQ": function() { return /* reexport */ LandingHeader_LandingHeaderMobile; },
  "kb": function() { return /* reexport */ LandingInput_LandingInput; },
  "wI": function() { return /* reexport */ LandingTestimonials_LandingTestimonials; },
  "jH": function() { return /* reexport */ ListingEditDetails_ListingEditDetails; },
  "W_": function() { return /* reexport */ ListingTravelDetails_ListingTravelDetails; },
  "Tx": function() { return /* reexport */ ManageInsurance_ManageInsurance; },
  "e2": function() { return /* reexport */ InsurancePlans_MoreBenefits; },
  "yF": function() { return /* reexport */ OrderDetailComp_OrderDetailInsurance; },
  "rA": function() { return /* reexport */ OrderDetailComp_OrderDetailPlan; },
  "Am": function() { return /* reexport */ OrderDetailComp_OrderDetailTraveller; },
  "P0": function() { return /* reexport */ OrderDetails_OrderDetails; },
  "K2": function() { return /* reexport */ OrderDetailRightComp_OrderGetHelp; },
  "fU": function() { return /* reexport */ OrderDetailRightComp_OrderInsurance; },
  "dy": function() { return /* reexport */ OrderListingComp_OrderListingComp; },
  "VM": function() { return /* reexport */ OrderStatusComp_OrderStatusComp; },
  "dZ": function() { return /* reexport */ TextStyles_ParaTag; },
  "gA": function() { return /* reexport */ PassportNumComp_PassportNumComp; },
  "dL": function() { return /* reexport */ PaymentStatusComp_PaymentStatusComp; },
  "W3": function() { return /* reexport */ PersuasionBanner_PersuasionBanner; },
  "e3": function() { return /* reexport */ PersuasionBanner_PersuasionBannerInsurance; },
  "Xv": function() { return /* reexport */ OrderDetailComp_PrimaryContact; },
  "EU": function() { return /* reexport */ RadioButton_RadioButton; },
  "$m": function() { return /* reexport */ RangeDatePicker_RangeDatePicker; },
  "hK": function() { return /* reexport */ components_ReactPortalComp; },
  "yM": function() { return /* reexport */ SafenSecureTrav_SafenSecureTrav; },
  "LV": function() { return /* reexport */ SectionDividers_SectionDividers; },
  "Jp": function() { return /* reexport */ SecureTravOffer_SecureTravOffer; },
  "GB": function() { return /* reexport */ SelectCountryModal_SelectCountryCodeModal; },
  "es": function() { return /* reexport */ SelectCountryModalSheetV2; },
  "tQ": function() { return /* reexport */ SelectCountryModal_SelectCountryModalV2; },
  "qm": function() { return /* reexport */ Shimmer/* default */.Z; },
  "KQ": function() { return /* reexport */ ShimmerVersion2_ShimmerVersion2; },
  "AO": function() { return /* reexport */ ShimmerVersion3_ShimmerVersion3; },
  "n7": function() { return /* reexport */ ShowInsPlan_ShowInsPlan; },
  "pF": function() { return /* reexport */ TextStyles_SpanTag; },
  "$j": function() { return /* reexport */ Spinner_Spinner; },
  "Wz": function() { return /* reexport */ TMFloatingInput_TMFloatingInput; },
  "$G": function() { return /* reexport */ Tags_Tags; },
  "FN": function() { return /* reexport */ Toast_Toast; },
  "dc": function() { return /* reexport */ Toast_ToastCompare; },
  "ct": function() { return /* reexport */ ToolTipComp_ToolTipComp; },
  "DH": function() { return /* reexport */ TravAssistant_TravAssistant; },
  "Gl": function() { return /* reexport */ InsurancePlans_TravelAssistanceModal; },
  "iw": function() { return /* reexport */ TravelDetails_TravellingTo; },
  "xK": function() { return /* reexport */ TravelDetails_TravellingToShimmer; },
  "Qf": function() { return /* reexport */ TravellingToWidget_TravellingToWidget; },
  "bO": function() { return /* reexport */ WhatsCovered_WhatsCovered; },
  "t": function() { return /* reexport */ WhyBuyTravIns_WhyBuyTravIns; }
});

// UNUSED EXPORTS: DatePicker, FilterBottomComp, InsuranceBookedShimmer, LandingFooterInsurance, ManageInsuranceShimmer, NoInsurancePlan, OrderAmtPaid, OrderDetailPlanShimmer, OrderDetailsShimmer, OrderPriceBreakup

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.style.ts

var AccordianCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddAlternateContactstyle__AccordianCompStyle",
  componentId: "sc-1bmknqe-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.tsx






var AddAlternateContact = function AddAlternateContact(_ref) {
  var title = _ref.title,
      emailAddress = _ref.emailAddress,
      goBackTxt = _ref.goBackTxt,
      handleEmailChange = _ref.handleEmailChange,
      addContactTxt = _ref.addContactTxt,
      handleAlternateContact = _ref.handleAlternateContact,
      handleAddContact = _ref.handleAddContact,
      handleGoBack = _ref.handleGoBack;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    handleClick: handleAlternateContact,
    customTitle: title,
    "data-test-id": "AddAlternateContact-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
      flex: "1",
      placeholderTxt: "Enter 10 digit mobile number",
      requiredField: true,
      labelTxt: "10 Digit Mobile No.",
      inputType: "number",
      margin: "0 0 16px",
      "data-test-id": "AddAlternateContact-LandingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
      inputValue: emailAddress,
      handleChange: handleEmailChange,
      flex: "1",
      placeholderTxt: "Enter Email Id",
      requiredField: true,
      labelTxt: "Email ID",
      "data-test-id": "AddAlternateContact-LandingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "32px 0 0",
      gap: "10px",
      "data-test-id": "AddAlternateContact-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        onClick: handleAddContact,
        customWidth: "210px",
        customTitle: addContactTxt,
        "data-test-id": "AddAlternateContact-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        handleClick: handleGoBack,
        fontSize: "md",
        fontWeight: "bold",
        textTransform: "uppercase",
        "data-test-id": "AddAlternateContact-AnchorTag",
        children: goBackTxt
      })]
    })]
  });
};

/* harmony default export */ var AddAlternateContact_AddAlternateContact = (AddAlternateContact);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.style.ts

var AddPassportDetailStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddPassportDetailstyle__AddPassportDetailStyle",
  componentId: "sc-110cox0-0"
})(["background:#ffedd1;border:1px solid #cf8100;border-radius:16px;padding:24px 16px;gap:8px;display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.tsx






var AddPassportDetail = function AddPassportDetail(_ref) {
  var data = _ref.data,
      handlePassportBtn = _ref.handlePassportBtn;
  var addPasstitle = data.addPasstitle,
      addPassportBtn = data.addPassportBtn,
      addPassInfo = data.addPassInfo,
      addPassportCta = data.addPassportCta;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddPassportDetailStyle, {
    "data-test-id": "AddPassportDetail-AddPassportDetailStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "md",
      "data-test-id": "AddPassportDetail-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: addPasstitle,
        "data-test-id": "AddPassportDetail-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonWhite, {
      btnLeftIcon: addPassportBtn.iconLeft,
      btnRightIcon: addPassportBtn.iconRight,
      customWidth: "100%",
      customTitle: addPassportBtn.title,
      onClick: handlePassportBtn,
      margin: "16px 0 0",
      "data-test-id": "AddPassportDetail-LandingButtonWhite"
    })]
  });
};

/* harmony default export */ var AddPassportDetail_AddPassportDetail = (AddPassportDetail);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(1512);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(7211);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(8521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 6 modules
var utils = __webpack_require__(1725);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(7109);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 6 modules
var utility_src = __webpack_require__(131);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(2874);
;// CONCATENATED MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (react.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName ||
        (Array.isArray(name) &&
            name.some((currentName) => currentName && exact && currentName === signalName))
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react.useRef(props);
    _props.current = props;
    react.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react.useState(control._formState);
    const _mounted = react.useRef(true);
    const _localProxyFormState = react.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    react.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = react.useState(control._getWatch(name, defaultValue));
    react.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    _registerProps.current = control.register(name, props.rules);
    react.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    react.useEffect(() => {
        control._updateDisabledField({
            disabled,
            fields: control._fields,
            name,
        });
    }, [disabled, name, control]);
    return {
        field: {
            name,
            value,
            onChange: react.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: react.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = React.useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event) => {
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data) => {
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            }
            catch (_a) { }
            for (const name of control._names.mount) {
                formData.append(name, get(data, name));
            }
            if (onSubmit) {
                await onSubmit({
                    data,
                    event,
                    method,
                    formData,
                    formDataJson,
                });
            }
            if (action) {
                try {
                    const shouldStringifySubmissionData = [
                        headers && headers['Content-Type'],
                        encType,
                    ].some((value) => value && value.includes('json'));
                    const response = await fetch(action, {
                        method,
                        headers: {
                            ...headers,
                            ...(encType ? { 'Content-Type': encType } : {}),
                        },
                        body: shouldStringifySubmissionData ? formDataJson : formData,
                    });
                    if (response &&
                        (validateStatus
                            ? !validateStatus(response.status)
                            : response.status < 200 || response.status >= 300)) {
                        hasError = true;
                        onError && onError({ response });
                        type = String(response.status);
                    }
                    else {
                        onSuccess && onSuccess({ response });
                    }
                }
                catch (error) {
                    hasError = true;
                    onError && onError({ error });
                }
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false,
            });
            props.control.setError('root.server', {
                type,
            });
        }
    };
    React.useEffect(() => {
        setMounted(true);
    }, []);
    return render ? (React.createElement(React.Fragment, null, render({
        submit,
    }))) : (React.createElement("form", { noValidate: mounted, action: action, method: method, encType: encType, onSubmit: submit, ...rest }, children));
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                }
                else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = react.useState(control._getFieldArray(name));
    const ids = react.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = react.useRef(fields);
    const _name = react.useRef(name);
    const _actioned = react.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = react.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    react.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError
                        ? (!error && existingError.type) ||
                            (error &&
                                (existingError.type !== error.type ||
                                    existingError.message !== error.message))
                        : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field && field._f) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => !!key && key.startsWith(control._names.focus || ''));
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [fields, name, control]);
    react.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: react.useCallback(swap, [updateValues, name, control]),
        move: react.useCallback(move, [updateValues, name, control]),
        prepend: react.useCallback(prepend$1, [updateValues, name, control]),
        append: react.useCallback(append$1, [updateValues, name, control]),
        remove: react.useCallback(remove, [updateValues, name, control]),
        insert: react.useCallback(insert$1, [updateValues, name, control]),
        update: react.useCallback(update, [updateValues, name, control]),
        replace: react.useCallback(replace, [updateValues, name, control]),
        fields: react.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = get(_formState.dirtyFields, name);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated =
                    isNaN(fieldValue) ||
                        fieldValue === get(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => key && get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, }) => {
        if (isBoolean(disabled)) {
            const value = disabled
                ? undefined
                : get(_formValues, name, getFieldValue(field ? field._f : get(fields, name)._f));
            set(_formValues, name, value);
            updateTouchAndDirty(name, value, false, false, true);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _updateDisabledField({
                field,
                disabled: options.disabled,
                name,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        focusFieldBy(_fields, (key) => key && get(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            await onValid(fieldValues, e);
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors),
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react.useRef();
    const _values = react.useRef();
    const [formState, updateFormState] = react.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    react.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    react.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.style.ts


var renderAlign = function renderAlign(alignItems) {
  switch (alignItems) {
    case "center":
      return "align-items: center;";

    case "baseline":
      return "align-items: baseline;";

    case "flex-start":
      return "align-items:flex-start;";

    case "flex-end":
      return "align-items:flex-end;";

    default:
      return "align-items:center;";
  }
};

var renderAlignSelf = function renderAlignSelf(alignSelf) {
  switch (alignSelf) {
    case "center":
      return "align-self: center;";

    case "baseline":
      return "align-self: baseline;";

    case "flex-start":
      return "align-self:flex-start;";

    case "flex-end":
      return "align-self:flex-end;";

    default:
      return "align-self:unset;";
  }
};

var renderJustify = function renderJustify(justifyContent) {
  switch (justifyContent) {
    case "center":
      return "justify-content:center;";

    case "flex-start":
      return "justify-content:flex-start;";

    case "end":
      return "justify-content:end;";

    case "space-between":
      return "justify-content:space-between;";

    case "inherit":
      return "justify-content:inherit;";

    case "right":
      return "justify-content:right;";

    default:
      return "justify-content:center;";
  }
};

var renderDir = function renderDir(flexDirection) {
  switch (flexDirection) {
    case "row":
      return "flex-direction:row;";

    case "column":
      return "flex-direction:column;";

    case "row-reverse":
      return "flex-direction:row-reverse;";

    case "column-reverse":
      return "flex-direction:column-reverse;";

    default:
      return "flex-direction:row;";
  }
};

var FlexCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "sc-11q208e-0"
})(["display:flex;position:relative;cursor:", ";", " ", " ", " ", " gap:", ";flex:", ";flex-shrink:", ";margin:", ";padding:", ";border-bottom:", ";border-top:", ";background:", ";border-radius:", ";height:", ";width:", ";box-shadow:", ";pointer-events:auto;flex-wrap:", ";"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
}, function (p) {
  return p.alignItems && "\n    ".concat(renderAlign(p.alignItems), "\n  ");
}, function (p) {
  return p.alignSelf && "\n    ".concat(renderAlignSelf(p.alignSelf), "\n  ");
}, function (p) {
  return p.justifyContent && "\n    ".concat(renderJustify(p.justifyContent), "\n  ");
}, function (p) {
  return p.flexDirection && "\n    ".concat(renderDir(p.flexDirection), "\n  ");
}, function (p) {
  return p.gap ? p.gap : "0";
}, function (p) {
  return p.flex ? p.flex : "unset";
}, function (p) {
  return p.flexShrink ? p.flexShrink : "unset";
}, function (p) {
  return p.margin ? p.margin : "unset";
}, function (p) {
  return p.padding ? p.padding : "0";
}, function (p) {
  return p.borderBottom ? p.borderBottom : "none";
}, function (p) {
  return p.borderTop ? p.borderTop : "none";
}, function (p) {
  return p.bgColor ? p.bgColor : "transparent";
}, function (p) {
  return p.borderRadius ? p.borderRadius : "0";
}, function (p) {
  return p.height ? p.height : "unset";
}, function (p) {
  return p.width ? p.width : "unset";
}, function (p) {
  return p.boxShadow ? p.boxShadow : "none";
}, function (p) {
  return p.flexWrap ? p.flexWrap : "";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx




var FlexComp_FlexComp = function FlexComp(_ref) {
  var children = _ref.children,
      flexDirection = _ref.flexDirection,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      gap = _ref.gap,
      margin = _ref.margin,
      borderBottom = _ref.borderBottom,
      borderTop = _ref.borderTop,
      padding = _ref.padding,
      flex = _ref.flex,
      bgColor = _ref.bgColor,
      borderRadius = _ref.borderRadius,
      height = _ref.height,
      flexShrink = _ref.flexShrink,
      handleClick = _ref.handleClick,
      boxShadow = _ref.boxShadow,
      width = _ref.width,
      _ref$isCursorPointer = _ref.isCursorPointer,
      isCursorPointer = _ref$isCursorPointer === void 0 ? false : _ref$isCursorPointer,
      flexWrap = _ref.flexWrap,
      alignSelf = _ref.alignSelf;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlexCompStyle, {
    flexDirection: flexDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    gap: gap,
    margin: margin,
    borderBottom: borderBottom,
    borderTop: borderTop,
    padding: padding,
    flex: flex,
    bgColor: bgColor,
    borderRadius: borderRadius,
    height: height,
    flexShrink: flexShrink,
    width: width,
    boxShadow: boxShadow,
    onClick: handleClick,
    flexWrap: flexWrap,
    alignSelf: alignSelf,
    "data-test-id": "FlexComp-FlexCompStyle",
    children: children
  });
};

/* harmony default export */ var components_FlexComp_FlexComp = (FlexComp_FlexComp);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText_FormattedText = __webpack_require__(7871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(3139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.style.tsx



var WebToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WebToaststyle__WebToastStyle",
  componentId: "sc-937kgh-0"
})(["position:", ";top:", ";left:", ";width:", ";height:", ";background:", ";display:flex;align-items:", ";z-index:200;justify-content:", ";box-shadow:0px 3px 30px rgba(0,0,0,0.16);", " padding:12px 16px 12px 16px;border-radius:6px;bottom:", ";right:", ";picture{height:19px;width:19px;padding:2px;}", "{flex-shrink:0;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], function (p) {
  return p.position ? "".concat(p.position) : "absolute";
}, function (p) {
  return "".concat(p.top);
}, function (p) {
  return "".concat(p.left);
}, function (p) {
  return "".concat(p.width);
}, function (p) {
  return "".concat(p.height);
}, function (p) {
  return p.background ? "".concat(p.background) : "#4a4a4a";
}, function (p) {
  return p.alignItems ? "".concat(p.alignItems) : "center";
}, function (p) {
  return p.justifyContent ? "".concat(p.justifyContent) : "space-between";
}, function (p) {
  return p.margin && "margin: ".concat(p.margin, ";");
}, function (p) {
  return "".concat(p.bottom);
}, function (p) {
  return "".concat(p.right);
}, TextStyles_style/* SpanTagStyle */.zs, src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx






var TOAST_BG_COLOR = {
  error: "#FCDADB",
  success: "#B8F5E0",
  default: "#4A4A4A"
};

var WebToast = function WebToast(_ref) {
  var iconUrl = _ref.iconUrl,
      position = _ref.position,
      toastTxt = _ref.toastTxt,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      toastTxtMargin = _ref.toastTxtMargin,
      top = _ref.top,
      left = _ref.left,
      margin = _ref.margin,
      width = _ref.width,
      bottom = _ref.bottom,
      right = _ref.right,
      height = _ref.height,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "default" : _ref$type,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WebToastStyle, {
    top: top,
    bottom: bottom,
    right: right,
    left: left,
    width: width,
    height: height,
    margin: margin,
    position: position,
    justifyContent: type === "success" ? "center" : "space-between",
    background: TOAST_BG_COLOR[type],
    "data-test-id": "WebToast-WebToastStyle",
    children: [iconUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      height: "15px",
      width: "15px",
      src: iconUrl,
      "data-test-id": "WebToast-ImageComponent"
    }), toastTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      gap: "10px",
      alignItems: "center",
      "data-test-id": "WebToast-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: toastTxt,
        baseStyle: {
          fontSize: fontSize ? fontSize : "12px",
          fontWeight: fontWeight ? fontWeight : "normal",
          color: color ? color : "#FFFFFF",
          margin: toastTxtMargin ? toastTxtMargin : "10px"
        },
        "data-test-id": "WebToast-FormattedText"
      })
    })]
  });
};

/* harmony default export */ var Toast_WebToast = (WebToast);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.style.ts
var LandingButton_style = __webpack_require__(5590);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/Toast.style.ts




var ToastStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__ToastStyle",
  componentId: "mow44r-0"
})(["display:flex;align-items:center;justify-content:space-between;padding:12px 18px;background:#4a4a4a;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:12px;width:436px;position:fixed;bottom:30px;right:30px;gap:8px;", "{flex-shrink:0;}", "{width:127px;}@media ", "{width:calc(100% - 32px);padding:8px 16px;right:16px;left:16px;}"], TextStyles_style/* SpanTagStyle */.zs, LandingButton_style/* LandingButtonTertiaryStyle */.mS, src.deviceType.mobile);
var CloseIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__CloseIconWrap",
  componentId: "mow44r-1"
})(["width:28px;height:28px;cursor:pointer;"]);
var ToastIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Toaststyle__ToastIcon",
  componentId: "mow44r-2"
})(["display:flex;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DatePickerComp/DatePickerComp.style.ts



var DatePickerWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerWrap",
  componentId: "sc-128qnt3-0"
})(["width:592px;background:#ffffff;box-sizing:border-box;display:flex;flex-direction:column;z-index:1;border-radius:4px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);position:absolute;left:0;top:30px;", "{position:static;background:#fcdadb;width:fit-content;margin-bottom:16px;margin-left:16px;}", " span{font-size:14px;color:", ";}.rdp-cell{width:38px;height:38px;}.rdp-cell:hover{border-radius:0;}.rdp-weeknumber,.rdp-day{font-size:12px;width:38px;height:38px;}.rdp-day_selected,.rdp-day_selected:focus-visible{background:#eaf5ff;color:#000;border-radius:0;}.rdp-day_range_start,.rdp-day_range_end{background:#008cff;border-radius:0px 2px 2px 0px;color:#fff;}.rdp-head_cell{font-weight:700;font-size:12px;line-height:16px;color:#9b9b9b;}.rdp-caption_label{font-weight:400;font-size:18px;line-height:25px;color:#000;}.rdp-caption_label .boldText{font-weight:700;}.rdp-day_today{font-weight:400;}.rdp-button svg{display:none;}.rdp-button:hover:not([disabled]):not(.rdp-day_selected){background:#eaf5ff;border-radius:0;}.rdp-nav_button_previous:before,.rdp-nav_button_next:before{position:absolute;top:20px;content:\"\";width:20px;height:2px;background:#008cff;border-radius:2px;background-image:none;}.rdp-nav_button_previous:after{left:7px;transform:rotate(-45deg);}.rdp-nav_button_next:after{right:7px;transform:rotate(135deg);}.rdp-nav_button_previous:after,.rdp-nav_button_next:after{position:absolute;top:17px;content:\"\";width:8px;height:8px;background-image:none;border-top:solid 2px #008cff;border-left:solid 2px #008cff;}"], ToastStyle, ToastStyle, Global/* theme.redText */.rS.redText);
var DateLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DateLabel",
  componentId: "sc-128qnt3-1"
})(["background:#ffffff;border-radius:2px;padding:0 8px;", ""], function (p) {
  return p.activeTab && "\n    background: #eaf5ff;\n    border: 1px solid #008cff;\n    border-radius: 2px;\n    ";
});
var DateTab = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "DatePickerCompstyle__DateTab",
  componentId: "sc-128qnt3-2"
})(["display:flex;padding:10px 15px;border-radius:4px 4px 0px 0px;background-color:#f2f2f2;"]);
var DateTabList = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "DatePickerCompstyle__DateTabList",
  componentId: "sc-128qnt3-3"
})(["cursor:pointer;display:flex;align-items:center;gap:4px;margin-right:10px;&:last-child{margin-right:unset;}"]);
var ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__ErrorToast",
  componentId: "sc-128qnt3-4"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
var DobPickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DobPickerStyle",
  componentId: "sc-128qnt3-5"
})(["border-radius:4px;border:0px solid #979797;background:#fff;box-shadow:0px 1px 6px 0px rgba(0,0,0,0.2);width:300px;.rdp-dropdown_year,.rdp-dropdown_month{border-radius:4px;border:1px solid #4a4a4a;padding:0 8px;}.rdp-day_selected,.rdp-day_selected:focus-visible,.rdp-day_selected:hover{border-radius:2px 0px 0px 2px;background:#008cff;color:#fff;}.rdp-head{color:#9b9b9b;text-align:center;font-size:12px;font-weight:700;}.rdp-weeknumber,.rdp-day{font-size:12px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RadioButton/RadioButton.style.ts

var RadioButtonStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "zyhzua-0"
})(["", " display:flex;", " label{user-select:none;}input{display:none;}[type=\"radio\"]:checked,[type=\"radio\"]:not(:checked){position:absolute;left:-9999px;}[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{position:relative;padding-left:24px;cursor:pointer;display:inline-flex;color:#666;width:100%;", "}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{content:\"\";position:absolute;left:0;top:0px;width:15px;height:15px;border:1px solid #008cff;border-radius:100%;background:#fff;", "}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{content:\"\";width:9px;height:9px;background:#008cff;position:absolute;top:3px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type=\"radio\"]:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type=\"radio\"]:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], function (p) {
  return p.isPadding && "\n    padding: 16px 10px;\n";
}, function (p) {
  return p.showLabel && "\n        width: 100%;\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
}, function (p) {
  return !p.showLabel && "\n        margin-top:-12px\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetail.style.ts





var AddTravellerDetailStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerDetailStyle",
  componentId: "sc-1vnwff6-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;@media ", "{border-radius:16px 16px 0 0;}"], src.deviceType.mobile);
var AddTravellerHd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerHd",
  componentId: "sc-1vnwff6-1"
})(["padding:30px;@media ", "{padding:24px 16px;}"], src.deviceType.mobile);
var AddTravellerComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddTravellerComp",
  componentId: "sc-1vnwff6-2"
})(["padding:30px;@media ", "{padding:24px 16px;}"], src.deviceType.mobile);
var StickyBtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__StickyBtnWrap",
  componentId: "sc-1vnwff6-3"
})(["", "{width:100%;}@media ", "{position:fixed;bottom:0;width:100%;z-index:1;background:#fff;padding:8px 16px;left:0;box-shadow:0px 1px 16px rgba(0,0,0,0.2);}"], LandingButton_style/* LandingButtonStyle */.zm, src.deviceType.mobile);
var TravellerDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDetailsStyle",
  componentId: "sc-1vnwff6-4"
})(["padding:16px 30px;border-top:1px solid #e8e8e8;", "{span{font-size:12px;line-height:12px;}}@media ", "{padding:16px;}", "{position:absolute;top:0;right:0;}"], LandingButton_style/* LandingButtonWhiteStyle */.aA, src.deviceType.mobile, DobPickerStyle);
var TravellerAddShimmer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerAddShimmer",
  componentId: "sc-1vnwff6-5"
})(["padding:24px 30px;border-top:1px solid #e8e8e8;display:flex;justify-content:space-between;"]);
var GenderTypeItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__GenderTypeItem",
  componentId: "sc-1vnwff6-6"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:10px 12px;cursor:pointer;", ""], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n    border-radius: 6px;\n";
});
var SelectInsurereItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__SelectInsurereItem",
  componentId: "sc-1vnwff6-7"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:10px 12px;margin-bottom:8px;cursor:pointer;", " ", "{[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{top:31%;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{top:31%;}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{top:19px;}}"], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n    border-radius: 6px;\n";
}, RadioButtonStyle);
var TravellerDescpWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpWrap",
  componentId: "sc-1vnwff6-8"
})([""]);
var TravellerDescpStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpStyle",
  componentId: "sc-1vnwff6-9"
})(["display:flex;align-items:baseline;gap:8px;"]);
var TravellerIndexWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerIndexWrap",
  componentId: "sc-1vnwff6-10"
})(["background:#f6f6f6;border-radius:18px;width:20px;height:20px;flex-shrink:0;display:flex;align-items:center;justify-content:center;"]);
var TravellerDescpError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TravellerDescpError",
  componentId: "sc-1vnwff6-11"
})(["background:#fcdadb;border-radius:4px;padding:4px 8px;text-align:center;margin-top:8px;"]);
var ConfirmTnc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__ConfirmTnc",
  componentId: "sc-1vnwff6-12"
})(["background:#f6f6f6;border-radius:6px;padding:12px 16px;font-size:14px;line-height:20px;color:#4a4a4a;margin-bottom:8px;"]);
var PrimaryContactNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__PrimaryContactNote",
  componentId: "sc-1vnwff6-13"
})(["background:rgba(255,237,209,1);border-radius:8px;padding:12px 16px;margin-top:16px;display:flex;flex-direction:column;gap:8px;"]);
var ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "AddTravellerDetailstyle__ArrowButtonWrap",
  componentId: "sc-1vnwff6-14"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var AddButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddButtonWrap",
  componentId: "sc-1vnwff6-15"
})(["display:flex;", " align-item:baseline;margin:14px 0px 14px 33px;cursor:pointer;align-items:center;"], function (props) {
  return props.isDisabled ? "color: #0000004D;" : "color: #008cff;";
});
var AddOnPlanWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__AddOnPlanWrap",
  componentId: "sc-1vnwff6-16"
})(["display:flex;flex-direction:column;justify-content:space-between;border-radius:8px;padding:12px 16px 12px 16px;border:", ";background:", ";", " position:relative;a{font-size:12px;font-weight:700;}button{span{font-size:12px;}}picture{display:flex;align-items:center;}img{border-radius:4px;}", "{position:static;width:75px;height:32px;}"], function (props) {
  return props.isSelected ? "1px solid #008CFF" : "1px solid #e2e2e2";
}, function (props) {
  return props.isSelected ? "linear-gradient(0deg, #EAF5FF, #EAF5FF), linear-gradient(0deg, #008CFF, #008CFF)" : "linear-gradient(0deg, #f6f6f6, #f6f6f6),linear-gradient(0deg, #e2e2e2, #e2e2e2)";
}, function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, LandingButton_style/* LandingButtonWhiteStyle */.aA);
var TagWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__TagWrap",
  componentId: "sc-1vnwff6-17"
})(["display:flex;background:linear-gradient(88.44deg,#12714f 0.02%,#1ca099 100.01%);padding:2px 8px 2px 8px;border-radius:16px;height:20px;color:#ffffff;align-items:center;font-size:12px;position:absolute;font-weight:700;top:-10px;transform:translateX(-50%);margin:0px 0px 0px 10px;z-index:1;@media ", "{left:11%;}@media ", "{left:16%;}"], src.deviceType.desktop, src.deviceType.mobile);
var VendorIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__VendorIconWrap",
  componentId: "sc-1vnwff6-18"
})(["@media ", "{picutre{align-items:flex-start;}}"], src.deviceType.mobile);
var WebToastWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AddTravellerDetailstyle__WebToastWrap",
  componentId: "sc-1vnwff6-19"
})(["div{height:40px;}@media ", "{position:fixed;bottom:108px;width:100%;& >{width:100%;}div{}}@media ", "{& > div{margin-left:30px;}div{width:502px;}position:sticky;bottom:120px;}"], src.deviceType.mobile, src.deviceType.desktop);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerCommonComp.tsx










var analytics = (0,insurance/* getAnalytics */.I)();

var TravellerCommonComp = function TravellerCommonComp(_ref) {
  var _errors$tncs, _errors$tncs$find, _mobile$isRequired, _email$isRequired;

  var primaryContactData = _ref.primaryContactData,
      title = _ref.title,
      info = _ref.info,
      note = _ref.note,
      primaryContactDetails = _ref.primaryContactDetails,
      saveFormValuesOnBlur = _ref.saveFormValuesOnBlur,
      confirmTnC = _ref.confirmTnC,
      totalAmt = _ref.totalAmt,
      selectedCountry = _ref.selectedCountry,
      isLoading = _ref.isLoading,
      handleBuy = _ref.handleBuy,
      handleTncCheckbox = _ref.handleTncCheckbox,
      addOnPlans = _ref.addOnPlans,
      addOnfilters = _ref.addOnfilters,
      handleAddOnFilters = _ref.handleAddOnFilters,
      handleAddOnSelect = _ref.handleAddOnSelect,
      handleCountryCodeModal = _ref.handleCountryCodeModal,
      componentRef = _ref.componentRef;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _ref2 = primaryContactData || {},
      email = _ref2.email,
      mobile = _ref2.mobile;

  var _useState = (0,react.useState)(-1),
      showAddOnBenefits = _useState[0],
      setShowAddOnBenefits = _useState[1];

  var tncError = (_errors$tncs = errors.tncs) === null || _errors$tncs === void 0 ? void 0 : (_errors$tncs$find = _errors$tncs.find) === null || _errors$tncs$find === void 0 ? void 0 : _errors$tncs$find.call(_errors$tncs, function (item) {
    return item === null || item === void 0 ? void 0 : item.message;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerComp, {
    ref: componentRef,
    "data-test-id": "TravellerCommonComp-AddTravellerComp",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
      margin: "0 0 16px",
      "data-test-id": "TravellerCommonComp-H5Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "TravellerCommonComp-FormattedText"
      })
    }), confirmTnC === null || confirmTnC === void 0 ? void 0 : confirmTnC.map(function (tnc, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
        control: control,
        name: "tncs.".concat(index),
        rules: {
          required: {
            value: true,
            message: "Please confirm"
          }
        },
        render: function render(_ref3) {
          var value = _ref3.field.value;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmTnc, {
            "data-test-id": "TravellerCommonComp-ConfirmTnc",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton_CheckButton, {
              inputId: "confirmTnC",
              handleChange: function handleChange() {
                handleTncCheckbox === null || handleTncCheckbox === void 0 ? void 0 : handleTncCheckbox(index);
              },
              isChecked: value,
              "data-test-id": "TravellerCommonComp-CheckButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: tnc,
                  "data-test-id": "TravellerCommonComp-FormattedText"
                })
              })
            })
          });
        },
        "data-test-id": `TravellerCommonComp-Controller-${index}`
      }, index);
    }), confirmTnC && tncError && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      margin: "0px 0 0 4px",
      color: Global/* theme.redText2 */.rS.redText2,
      fontSize: "xs",
      "data-test-id": "TravellerCommonComp-ParaTag",
      children: tncError.message
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      margin: confirmTnC ? "16px 0 45px" : "16px 0",
      fontSize: "sm",
      color: Global/* theme.greyText7 */.rS.greyText7,
      "data-test-id": "TravellerCommonComp-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: info,
        "data-test-id": "TravellerCommonComp-FormattedText"
      })
    }), primaryContactDetails && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: device == "lg" ? "row" : "column",
        gap: "16px",
        "data-test-id": "TravellerCommonComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
          control: control,
          name: "primaryContactData.mobile",
          rules: {
            required: {
              value: (_mobile$isRequired = mobile === null || mobile === void 0 ? void 0 : mobile.isRequired) !== null && _mobile$isRequired !== void 0 ? _mobile$isRequired : true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("mobile")
            },
            pattern: {
              value: new RegExp((mobile === null || mobile === void 0 ? void 0 : mobile.regex) || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("mobile", mobile === null || mobile === void 0 ? void 0 : mobile.errorMessage)
            }
          },
          render: function render(_ref4) {
            var _errors$primaryContac, _errors$primaryContac2;

            var _ref4$field = _ref4.field,
                onChange = _ref4$field.onChange,
                onBlur = _ref4$field.onBlur,
                value = _ref4$field.value;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CountryCodeInput_CountryCodeInput, {
              errorState: errors === null || errors === void 0 ? void 0 : (_errors$primaryContac = errors.primaryContactData) === null || _errors$primaryContac === void 0 ? void 0 : (_errors$primaryContac2 = _errors$primaryContac.mobile) === null || _errors$primaryContac2 === void 0 ? void 0 : _errors$primaryContac2.message,
              inputValue: value,
              handleChange: onChange,
              handleBlur: function handleBlur() {
                saveFormValuesOnBlur === null || saveFormValuesOnBlur === void 0 ? void 0 : saveFormValuesOnBlur();
                onBlur();
              },
              placeholderTxt: mobile === null || mobile === void 0 ? void 0 : mobile.placeholder,
              requiredField: mobile === null || mobile === void 0 ? void 0 : mobile.isRequired,
              labelTxt: mobile === null || mobile === void 0 ? void 0 : mobile.title,
              inputType: "tel",
              disableState: isLoading,
              autoComplete: "off",
              flex: "1",
              inputWidth: device == "lg" ? "50%" : "100%",
              handleCountryCodeModal: handleCountryCodeModal,
              countryFlag: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryFlag,
              countryCode: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryCode) || "+91",
              "data-test-id": "TravellerCommonComp-CountryCodeInput"
            });
          },
          "data-test-id": "TravellerCommonComp-Controller"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
          control: control,
          name: "primaryContactData.email",
          rules: {
            required: {
              value: (_email$isRequired = email === null || email === void 0 ? void 0 : email.isRequired) !== null && _email$isRequired !== void 0 ? _email$isRequired : true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("email")
            },
            pattern: {
              value: new RegExp((email === null || email === void 0 ? void 0 : email.regex) || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("email", email === null || email === void 0 ? void 0 : email.errorMessage)
            }
          },
          render: function render(_ref5) {
            var _errors$primaryContac3, _errors$primaryContac4;

            var _ref5$field = _ref5.field,
                onChange = _ref5$field.onChange,
                onBlur = _ref5$field.onBlur,
                value = _ref5$field.value;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
              inputValue: value,
              handleChange: onChange,
              handleBlur: function handleBlur() {
                saveFormValuesOnBlur === null || saveFormValuesOnBlur === void 0 ? void 0 : saveFormValuesOnBlur();
                onBlur();
              },
              placeholderTxt: email === null || email === void 0 ? void 0 : email.placeholder,
              requiredField: email === null || email === void 0 ? void 0 : email.isRequired,
              labelTxt: email === null || email === void 0 ? void 0 : email.title,
              errorState: errors === null || errors === void 0 ? void 0 : (_errors$primaryContac3 = errors.primaryContactData) === null || _errors$primaryContac3 === void 0 ? void 0 : (_errors$primaryContac4 = _errors$primaryContac3.email) === null || _errors$primaryContac4 === void 0 ? void 0 : _errors$primaryContac4.message,
              disableState: isLoading,
              autoComplete: "off",
              flex: "1",
              inputWidth: device == "lg" ? "50%" : "100%",
              "data-test-id": "TravellerCommonComp-LandingInput"
            });
          },
          "data-test-id": "TravellerCommonComp-Controller"
        })]
      }), note && /*#__PURE__*/(0,jsx_runtime.jsxs)(PrimaryContactNote, {
        "data-test-id": "TravellerCommonComp-PrimaryContactNote",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          color: Global/* theme.brownText */.rS.brownText,
          fontWeight: "bold",
          "data-test-id": "TravellerCommonComp-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: note.title,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          color: Global/* theme.brownText */.rS.brownText,
          "data-test-id": "TravellerCommonComp-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: note === null || note === void 0 ? void 0 : note.info,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        })]
      })]
    }), confirmTnC && /*#__PURE__*/(0,jsx_runtime.jsx)(StickyBtnWrap, {
      "data-test-id": "TravellerCommonComp-StickyBtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        isLoading: isLoading,
        onClick: handleBuy,
        customTitle: "BUY FOR ".concat(totalAmt),
        "data-test-id": "TravellerCommonComp-LandingButton"
      })
    }), addOnfilters && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      alignItems: device == "lg" ? "center" : "flex-start",
      justifyContent: "space-between",
      margin: "0 0 30px",
      gap: "10px",
      flexDirection: device == "lg" ? "row" : "column",
      "data-test-id": "TravellerCommonComp-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tags_Tags, {
        handleClickTab: handleAddOnFilters,
        data: addOnfilters,
        "data-test-id": "TravellerCommonComp-Tags"
      })
    }), addOnPlans && addOnPlans.map(function (item, index) {
      var _item$comboProductDet, _item$modal, _item$primary, _item$primary2, _item$primary3, _item$primary3$cta, _item$secondary, _item$secondary2, _item$secondary3, _item$secondary3$cta, _item$secondary4, _item$secondary4$cta;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddOnPlanWrap, {
        margin: item !== null && item !== void 0 && item.tag ? "20px 0px 14px 0px" : "0px 0px 14px 0px",
        isSelected: item === null || item === void 0 ? void 0 : item.isSelected,
        "data-test-id": "TravellerCommonComp-AddOnPlanWrap",
        children: [showAddOnBenefits === index && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_MoreBenefits, {
          data: item === null || item === void 0 ? void 0 : item.modal,
          tag: item === null || item === void 0 ? void 0 : item.tag,
          moreBenfitsTitle: "Add-Ons",
          customBtnTitle: item !== null && item !== void 0 && item.isSelected ? "Buy for ".concat(item === null || item === void 0 ? void 0 : (_item$comboProductDet = item.comboProductDetails) === null || _item$comboProductDet === void 0 ? void 0 : _item$comboProductDet.totalAmountToPay) : item === null || item === void 0 ? void 0 : (_item$modal = item.modal) === null || _item$modal === void 0 ? void 0 : _item$modal.buyBtn,
          isAddOnBenefits: true,
          handleClose: function handleClose() {
            setShowAddOnBenefits(-1);
          },
          handleBuyButton: function handleBuyButton() {
            if (item !== null && item !== void 0 && item.isSelected) {
              analytics === null || analytics === void 0 ? void 0 : analytics.trackTravDetailsEvents({
                actionType: "Buy_in_bs"
              });
              handleBuy === null || handleBuy === void 0 ? void 0 : handleBuy();
            } else {
              analytics === null || analytics === void 0 ? void 0 : analytics.trackTravDetailsEvents({
                actionType: "Added_in_bs"
              });
              handleAddOnSelect === null || handleAddOnSelect === void 0 ? void 0 : handleAddOnSelect(item === null || item === void 0 ? void 0 : item.planCode);
            }

            setShowAddOnBenefits(-1);
          },
          "data-test-id": "TravellerCommonComp-MoreBenefits"
        }), (item === null || item === void 0 ? void 0 : item.tag) && /*#__PURE__*/(0,jsx_runtime.jsx)(TagWrap, {
          "data-test-id": "TravellerCommonComp-TagWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: item === null || item === void 0 ? void 0 : item.tag,
            "data-test-id": "TravellerCommonComp-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          flexDirection: "row",
          justifyContent: "space-between",
          margin: item !== null && item !== void 0 && item.tag ? "6px 0 0" : "0",
          "data-test-id": "TravellerCommonComp-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            flexDirection: "row",
            gap: device === "lg" ? "14px" : "8px",
            "data-test-id": "TravellerCommonComp-FlexComp",
            children: [(item === null || item === void 0 ? void 0 : item.planIcon) && /*#__PURE__*/(0,jsx_runtime.jsx)(VendorIconWrap, {
              "data-test-id": "TravellerCommonComp-VendorIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                src: item === null || item === void 0 ? void 0 : item.planIcon,
                height: device === "lg" ? "48px" : "32px",
                width: device === "lg" ? "48px" : "32px",
                "data-test-id": "TravellerCommonComp-ImageComponent"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              flexDirection: "column",
              "data-test-id": "TravellerCommonComp-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item === null || item === void 0 ? void 0 : (_item$primary = item.primary) === null || _item$primary === void 0 ? void 0 : _item$primary.title,
                baseStyle: {
                  fontSize: "14px",
                  fontWeight: "700",
                  color: Global/* theme.greyText */.rS.greyText
                },
                "data-test-id": "TravellerCommonComp-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                flexDirection: device === "lg" ? "row" : "column",
                gap: device === "lg" ? "8px" : "0px",
                "data-test-id": "TravellerCommonComp-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: item === null || item === void 0 ? void 0 : (_item$primary2 = item.primary) === null || _item$primary2 === void 0 ? void 0 : _item$primary2.description,
                  "data-test-id": "TravellerCommonComp-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
                  margin: device === "lg" ? "3px 0px 0px 0px" : "-2px 0px 0px 0px",
                  handleClick: function handleClick() {
                    analytics === null || analytics === void 0 ? void 0 : analytics.trackTravDetailsEvents({
                      actionType: "View_detail_clicked"
                    });
                    setShowAddOnBenefits(index);
                  },
                  "data-test-id": "TravellerCommonComp-AnchorTag",
                  children: item === null || item === void 0 ? void 0 : (_item$primary3 = item.primary) === null || _item$primary3 === void 0 ? void 0 : (_item$primary3$cta = _item$primary3.cta) === null || _item$primary3$cta === void 0 ? void 0 : _item$primary3$cta.value
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            flexDirection: device === "lg" ? "row" : "column",
            gap: device === "lg" ? "12px" : "8px",
            alignItems: " center",
            "data-test-id": "TravellerCommonComp-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              flexDirection: "column",
              "data-test-id": "TravellerCommonComp-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                justifyContent: "right",
                alignItems: "center",
                gap: "8px",
                "data-test-id": "TravellerCommonComp-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: item === null || item === void 0 ? void 0 : (_item$secondary = item.secondary) === null || _item$secondary === void 0 ? void 0 : _item$secondary.title,
                  baseStyle: {
                    fontSize: "14px",
                    fontWeight: "700",
                    padding: "1.5px 0px 1.5px 0px"
                  },
                  "data-test-id": "TravellerCommonComp-FormattedText"
                }), (item === null || item === void 0 ? void 0 : item.isSelected) && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                  src: item === null || item === void 0 ? void 0 : item.addedIcon,
                  height: "16px",
                  width: "16px",
                  "data-test-id": "TravellerCommonComp-ImageComponent"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item === null || item === void 0 ? void 0 : (_item$secondary2 = item.secondary) === null || _item$secondary2 === void 0 ? void 0 : _item$secondary2.description,
                baseStyle: {
                  fontSize: "12px",
                  fontWeight: "400",
                  color: Global/* theme.greyText6 */.rS.greyText6
                },
                "data-test-id": "TravellerCommonComp-FormattedText"
              })]
            }), item !== null && item !== void 0 && item.isSelected ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              handleClick: function handleClick() {
                analytics === null || analytics === void 0 ? void 0 : analytics.trackTravDetailsEvents({
                  actionType: "Remove_clicked"
                });
                handleAddOnSelect === null || handleAddOnSelect === void 0 ? void 0 : handleAddOnSelect(item === null || item === void 0 ? void 0 : item.planCode);
              },
              margin: "6px 12.5px 6px 12.5px",
              "data-test-id": "TravellerCommonComp-AnchorTag",
              children: item === null || item === void 0 ? void 0 : (_item$secondary3 = item.secondary) === null || _item$secondary3 === void 0 ? void 0 : (_item$secondary3$cta = _item$secondary3.cta) === null || _item$secondary3$cta === void 0 ? void 0 : _item$secondary3$cta.toggleValue
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonWhite, {
              customTitle: item === null || item === void 0 ? void 0 : (_item$secondary4 = item.secondary) === null || _item$secondary4 === void 0 ? void 0 : (_item$secondary4$cta = _item$secondary4.cta) === null || _item$secondary4$cta === void 0 ? void 0 : _item$secondary4$cta.value,
              onClick: function onClick() {
                analytics === null || analytics === void 0 ? void 0 : analytics.trackTravDetailsEvents({
                  actionType: item === null || item === void 0 ? void 0 : item.addPlanEvent
                });
                analytics === null || analytics === void 0 ? void 0 : analytics.trackTravDetailsEvents({
                  actionType: "Add_button_clicked"
                });
                handleAddOnSelect === null || handleAddOnSelect === void 0 ? void 0 : handleAddOnSelect(item === null || item === void 0 ? void 0 : item.planCode);
              },
              customHeight: "32px",
              customWidth: "75px",
              "data-test-id": "TravellerCommonComp-LandingButtonWhite"
            })]
          })]
        })]
      });
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerCommonComp = (TravellerCommonComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDescpV2.tsx










var TravellerDescp = function TravellerDescp(_ref) {
  var _errors$travellerData, _error$name, _error$dob, _error$gender, _error$passport, _name$isRequired, _gender$isRequired, _dob$isRequired, _dob$isRequired2, _passport$isRequired;

  var travellerIndex = _ref.travellerIndex,
      genderTypeSelected = _ref.genderTypeSelected,
      secondaryContactData = _ref.secondaryContactData,
      isSelected = _ref.isSelected,
      handleEditState = _ref.handleEditState,
      isDomesticBooking = _ref.isDomesticBooking;

  var _ref2 = secondaryContactData || {},
      name = _ref2.name,
      dob = _ref2.dob,
      gender = _ref2.gender,
      passport = _ref2.passport;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = errors === null || errors === void 0 ? void 0 : (_errors$travellerData = errors.travellerData) === null || _errors$travellerData === void 0 ? void 0 : _errors$travellerData[travellerIndex];
  var errorMessage = (error === null || error === void 0 ? void 0 : (_error$name = error.name) === null || _error$name === void 0 ? void 0 : _error$name.message) || (error === null || error === void 0 ? void 0 : (_error$dob = error.dob) === null || _error$dob === void 0 ? void 0 : _error$dob.message) || (error === null || error === void 0 ? void 0 : (_error$gender = error.gender) === null || _error$gender === void 0 ? void 0 : _error$gender.message) || (error === null || error === void 0 ? void 0 : (_error$passport = error.passport) === null || _error$passport === void 0 ? void 0 : _error$passport.message) || "";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerDescpWrap, {
    "data-test-id": "TravellerDescp-TravellerDescpWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellerDescpStyle, {
      "data-test-id": "TravellerDescp-TravellerDescpStyle",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flex: "auto",
        alignItems: "baseline",
        justifyContent: "space-between",
        "data-test-id": "TravellerDescp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          "data-test-id": "TravellerDescp-SpanTag",
          children: [name && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".name"),
            rules: {
              required: {
                value: isSelected ? (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true : false,
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name")
              },
              pattern: {
                value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name", name === null || name === void 0 ? void 0 : name.errorMessage)
              }
            },
            render: function render(_ref3) {
              var value = _ref3.field.value;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "sm",
                fontWeight: "black",
                margin: "0 0 2px",
                "data-test-id": "TravellerDescp-SpanTag",
                children: value || "Traveller " + (travellerIndex + 1).toString()
              });
            },
            "data-test-id": "TravellerDescp-Controller"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [gender && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
                control: control,
                name: "travellerData.".concat(travellerIndex, ".gender"),
                rules: {
                  required: {
                    value: isSelected ? (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true : false,
                    message: (0,utils/* getFormFieldErrorMsg */.YV)("gender")
                  }
                },
                render: function render(_ref4) {
                  var value = _ref4.field.value;
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
                    fontSize: "xs",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "TravellerDescp-SpanTag",
                    children: [isDomesticBooking && "GENDER: ", value ? value : "---"]
                  });
                },
                "data-test-id": "TravellerDescp-Controller"
              })
            }), dob && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
              control: control,
              name: "travellerData.".concat(travellerIndex, ".dob"),
              rules: {
                required: isSelected && ((_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : false) ? {
                  value: true,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("dob")
                } : false,
                validate: isSelected && ((_dob$isRequired2 = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired2 !== void 0 ? _dob$isRequired2 : false) ? function (value) {
                  return (0,utils/* isDobValid */.qP)(value, dob === null || dob === void 0 ? void 0 : dob.regex) || (0,utils/* getFormFieldErrorMsg */.YV)("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
                } : undefined
              },
              render: function render(_ref5) {
                var value = _ref5.field.value;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "TravellerDescp-SpanTag",
                  children: [", DOB:", " ", (0,utils/* formatDate */.p6)(value, src.DATE_FORMATS["DD/MM/YYYY"]) || "---"]
                });
              },
              "data-test-id": "TravellerDescp-Controller"
            }), passport && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
              control: control,
              name: "travellerData.".concat(travellerIndex, ".passport"),
              rules: {
                required: {
                  value: isSelected ? (_passport$isRequired = passport === null || passport === void 0 ? void 0 : passport.isRequired) !== null && _passport$isRequired !== void 0 ? _passport$isRequired : true : false,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
                },
                pattern: {
                  value: new RegExp((passport === null || passport === void 0 ? void 0 : passport.regex) || ""),
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("passport", passport === null || passport === void 0 ? void 0 : passport.errorMessage)
                }
              },
              render: function render(_ref6) {
                var value = _ref6.field.value;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "TravellerDescp-SpanTag",
                  children: value ? ", Passport: ".concat(value) : ""
                });
              },
              "data-test-id": "TravellerDescp-Controller"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
          onClick: handleEditState,
          "data-test-id": "TravellerDescp-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "9px",
            height: "9px",
            margin: "0px 0px 0px 0px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
            "data-test-id": "TravellerDescp-ImageComponent"
          })
        })]
      })
    }), errorMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerDescpError, {
      "data-test-id": "TravellerDescp-TravellerDescpError",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "TravellerDescp-SpanTag",
        children: errorMessage
      })
    })]
  });
};

/* harmony default export */ var TravellerDescpV2 = (TravellerDescp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsV2.tsx














var minDate = (0,utils/* subtractYrsFromDate */.rv)(new Date(), 70).toISOString().split("T")[0];
var maxDate = new Date().toISOString().split("T")[0];
var TravellerDetailsV2_analytics = (0,insurance/* getAnalytics */.I)();

var TravellerDetailsV2 = function TravellerDetailsV2(_ref) {
  var _errors$travellerData, _name$isRequired, _dob$isRequired, _dob$isRequired2, _gender$isRequired, _passport$isRequired;

  var travellerIndex = _ref.travellerIndex,
      count = _ref.count,
      travellerRef = _ref.travellerRef,
      isLoading = _ref.isLoading,
      firstErrorIndex = _ref.firstErrorIndex,
      travellerNumber = _ref.travellerNumber,
      genderTypes = _ref.genderTypes,
      handleArrowButton = _ref.handleArrowButton,
      travellerSelected = _ref.travellerSelected,
      handleGenderChange = _ref.handleGenderChange,
      handleTravellerSelect = _ref.handleTravellerSelect,
      selectedGender = _ref.selectedGender,
      saveFormValuesOnBlur = _ref.saveFormValuesOnBlur,
      secondaryContactData = _ref.secondaryContactData,
      isSelected = _ref.isSelected,
      travellerCount = _ref.travellerCount,
      isSavedTravellers = _ref.isSavedTravellers,
      isValidForm = _ref.isValidForm,
      isEditable = _ref.isEditable,
      isDomesticBooking = _ref.isDomesticBooking;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors,
      getValues = _useFormContext.getValues;

  var error = errors === null || errors === void 0 ? void 0 : (_errors$travellerData = errors.travellerData) === null || _errors$travellerData === void 0 ? void 0 : _errors$travellerData[travellerIndex];

  var _ref2 = secondaryContactData || {},
      name = _ref2.name,
      dob = _ref2.dob,
      gender = _ref2.gender,
      passport = _ref2.passport;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerDetailsStyle, {
    ref: travellerIndex === firstErrorIndex ? travellerRef : null,
    "data-test-id": "TravellerDetailsV2-TravellerDetailsStyle",
    children: [travellerIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      margin: "0px 0px 20px 0px",
      "data-test-id": "TravellerDetailsV2-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: isSavedTravellers ? "Saved Travellers" : "Travellers",
        baseStyle: {
          color: "#4A4A4A",
          fontSize: "14px",
          fontWeight: "700"
        },
        "data-test-id": "TravellerDetailsV2-FormattedText"
      }), travellerCount && travellerCount > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: (count === null || count === void 0 ? void 0 : count.toString()) + "/" + (travellerCount === null || travellerCount === void 0 ? void 0 : travellerCount.toString()) + " Added",
        baseStyle: {
          color: isValidForm ? "#2B825E" : "#757575",
          fontSize: "14px",
          fontWeight: "700"
        },
        "data-test-id": "TravellerDetailsV2-FormattedText"
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
      control: control,
      name: "travellerData.".concat(travellerIndex, ".isSelected"),
      render: function render(_ref3) {
        var value = _ref3.field.value;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton_CheckButton, {
          isChecked: value,
          isDisabled: !isEditable,
          handleChange: function handleChange() {
            if (!isEditable) return;

            if (!value && getValues("travellerData.".concat(travellerIndex, ".isSavedTraveller"))) {
              if (getValues("travellerData.".concat(travellerIndex, ".isEdited"))) {
                TravellerDetailsV2_analytics === null || TravellerDetailsV2_analytics === void 0 ? void 0 : TravellerDetailsV2_analytics.trackTravDetailsEvents({
                  actionType: "saved_traveller_edit_clicked"
                });
              } else {
                TravellerDetailsV2_analytics === null || TravellerDetailsV2_analytics === void 0 ? void 0 : TravellerDetailsV2_analytics.trackTravDetailsEvents({
                  actionType: "saved_traveller_clicked"
                });
              }
            }

            handleTravellerSelect && handleTravellerSelect(value, travellerIndex);
            saveFormValuesOnBlur();
          },
          "data-test-id": "TravellerDetailsV2-CheckButton",
          children: !travellerSelected ? /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerDescpV2, {
            travellerIndex: travellerIndex,
            isSelected: isSelected,
            saveFormValuesOnBlur: saveFormValuesOnBlur,
            travellerNumber: travellerIndex + 1,
            genderTypeSelected: selectedGender,
            isDomesticBooking: isDomesticBooking,
            secondaryContactData: secondaryContactData,
            handleEditState: handleArrowButton,
            "data-test-id": "TravellerDetailsV2-TravellerDescp"
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            "data-test-id": "TravellerDetailsV2-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H6Tag, {
              "data-test-id": "TravellerDetailsV2-H6Tag",
              children: travellerNumber
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
              onClick: handleArrowButton,
              "data-test-id": "TravellerDetailsV2-ArrowButtonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: travellerSelected ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                "data-test-id": "TravellerDetailsV2-ImageComponent"
              })
            })]
          })
        });
      },
      "data-test-id": "TravellerDetailsV2-Controller"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: travellerSelected && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          flexDirection: device == "lg" ? "row" : "column",
          margin: "16px 0 16px",
          gap: "16px",
          "data-test-id": "TravellerDetailsV2-FlexComp",
          children: [name && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".name"),
            rules: {
              required: {
                value: isSelected ? (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true : false,
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name")
              },
              pattern: {
                value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
                message: (0,utils/* getFormFieldErrorMsg */.YV)("name", name === null || name === void 0 ? void 0 : name.errorMessage)
              }
            },
            render: function render(_ref4) {
              var _error$name;

              var _ref4$field = _ref4.field,
                  value = _ref4$field.value,
                  onChange = _ref4$field.onChange,
                  onBlur = _ref4$field.onBlur;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                flex: "1",
                requiredField: name === null || name === void 0 ? void 0 : name.isRequired,
                placeholderTxt: name === null || name === void 0 ? void 0 : name.placeholder,
                labelTxt: name === null || name === void 0 ? void 0 : name.title,
                inputValue: value,
                errorState: error === null || error === void 0 ? void 0 : (_error$name = error.name) === null || _error$name === void 0 ? void 0 : _error$name.message,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: function handleBlur() {
                  saveFormValuesOnBlur(travellerIndex);
                  onBlur();
                },
                autoComplete: "off",
                inputWidth: "100%",
                isDisabled: !isEditable,
                "data-test-id": "TravellerDetailsV2-LandingInput"
              });
            },
            "data-test-id": "TravellerDetailsV2-Controller"
          }), dob && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
            control: control,
            name: "travellerData.".concat(travellerIndex, ".dob"),
            rules: {
              required: isSelected && ((_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : false) ? {
                value: true,
                message: (0,utils/* getFormFieldErrorMsg */.YV)("dob")
              } : false,
              validate: isSelected && ((_dob$isRequired2 = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired2 !== void 0 ? _dob$isRequired2 : false) ? function (value) {
                return (0,utils/* isDobValid */.qP)(value, dob === null || dob === void 0 ? void 0 : dob.regex) || (0,utils/* getFormFieldErrorMsg */.YV)("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
              } : undefined
            },
            render: function render(_ref5) {
              var _error$dob;

              var _ref5$field = _ref5.field,
                  value = _ref5$field.value,
                  onChange = _ref5$field.onChange,
                  onBlur = _ref5$field.onBlur;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                flex: "1",
                placeholderTxt: dob === null || dob === void 0 ? void 0 : dob.placeholder,
                requiredField: dob === null || dob === void 0 ? void 0 : dob.isRequired,
                labelTxt: dob === null || dob === void 0 ? void 0 : dob.title,
                inputType: "date",
                inputValue: (0,utils/* formatDate */.p6)(value, src.DATE_FORMATS["YYYY-MM-DD"]),
                minValue: minDate,
                maxValue: maxDate,
                errorState: error === null || error === void 0 ? void 0 : (_error$dob = error.dob) === null || _error$dob === void 0 ? void 0 : _error$dob.message,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: function handleBlur() {
                  saveFormValuesOnBlur(travellerIndex);
                  onBlur();
                },
                inputWidth: "100%",
                "data-test-id": "TravellerDetailsV2-LandingInput"
              });
            },
            "data-test-id": "TravellerDetailsV2-Controller"
          })]
        }), gender && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            margin: "0 0 8px",
            fontSize: "md",
            fontWeight: "bold",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "TravellerDetailsV2-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: gender === null || gender === void 0 ? void 0 : gender.title,
              "data-test-id": "TravellerDetailsV2-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
            gap: "8px",
            margin: passport !== null && passport !== void 0 && passport.isEnabled ? "0 0 16px" : "0",
            "data-test-id": "TravellerDetailsV2-FlexComp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
              control: control,
              name: "travellerData.".concat(travellerIndex, ".gender"),
              rules: {
                required: {
                  value: isSelected ? (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true : false,
                  message: (0,utils/* getFormFieldErrorMsg */.YV)("gender")
                }
              },
              render: function render(_ref6) {
                var value = _ref6.field.value;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: genderTypes === null || genderTypes === void 0 ? void 0 : genderTypes.map(function (item) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(GenderTypeItem, {
                      selected: item.label === value,
                      onClick: function onClick() {
                        handleGenderChange(item, travellerIndex);
                        saveFormValuesOnBlur(travellerIndex);
                      },
                      "data-test-id": "TravellerDetailsV2-GenderTypeItem",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButton_RadioButton, {
                        activeBtn: item.label === value,
                        "data-test-id": "TravellerDetailsV2-RadioButton",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                          fontSize: "xs",
                          fontWeight: "bold",
                          color: item.label === value ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
                          "data-test-id": "TravellerDetailsV2-SpanTag",
                          children: item.label
                        })
                      })
                    }, item.id);
                  })
                });
              },
              "data-test-id": "TravellerDetailsV2-Controller"
            })
          })]
        }), passport && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
          control: control,
          name: "travellerData.".concat(travellerIndex, ".passport"),
          rules: {
            required: {
              value: isSelected ? (_passport$isRequired = passport === null || passport === void 0 ? void 0 : passport.isRequired) !== null && _passport$isRequired !== void 0 ? _passport$isRequired : true : false,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
            },
            pattern: {
              value: new RegExp(passport.regex || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport", passport === null || passport === void 0 ? void 0 : passport.errorMessage)
            }
          },
          render: function render(_ref7) {
            var _error$passport;

            var _ref7$field = _ref7.field,
                onChange = _ref7$field.onChange,
                onBlur = _ref7$field.onBlur,
                value = _ref7$field.value;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                requiredField: passport === null || passport === void 0 ? void 0 : passport.isRequired,
                placeholderTxt: passport === null || passport === void 0 ? void 0 : passport.placeholder,
                labelTxt: passport === null || passport === void 0 ? void 0 : passport.title,
                errorState: error === null || error === void 0 ? void 0 : (_error$passport = error.passport) === null || _error$passport === void 0 ? void 0 : _error$passport.message,
                inputValue: value,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: function handleBlur() {
                  saveFormValuesOnBlur(travellerIndex);
                  onBlur();
                },
                autoComplete: "off",
                inputWidth: "100%",
                isDisabled: !isEditable,
                margin: "16px 0 0",
                "data-test-id": "TravellerDetailsV2-LandingInput"
              })
            });
          },
          "data-test-id": "TravellerDetailsV2-Controller"
        })]
      })
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerDetailsV2 = (TravellerDetailsV2);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetails.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var AddTravellerDetails_analytics = (0,insurance/* getAnalytics */.I)();

var AddTravellerDetails = function AddTravellerDetails(_ref) {
  var _savedTravellers$leng, _concent$tnc$length, _concent$tnc, _widgets$formErrorToa, _widgets$addErrorToas, _widgets$offerToast, _widgets$offerToast2;

  var title = _ref.title,
      info = _ref.info,
      data = _ref.data,
      countryData = _ref.countryData,
      travellerCount = _ref.travellerCount,
      benefitsData = _ref.benefitsData,
      benefitsTitle = _ref.benefitsTitle,
      showBenefits = _ref.showBenefits,
      handleCountryCodeModal = _ref.handleCountryCodeModal,
      handleViewBenefits = _ref.handleViewBenefits,
      setAddOnProductDetails = _ref.setAddOnProductDetails,
      addOnProductDetails = _ref.addOnProductDetails;

  var _ref2 = data || {},
      primaryContact = _ref2.primaryContact,
      secondaryContact = _ref2.secondaryContact,
      upcomingTravellerDetails = _ref2.upcomingTravellerDetails,
      savedTravellers = _ref2.savedTravellers,
      note = _ref2.note,
      concent = _ref2.concent,
      totalAmt = _ref2.totalAmt,
      widgets = _ref2.widgets,
      isDomesticBooking = _ref2.isDomesticBooking,
      addOns = _ref2.addOns,
      experiment = _ref2.experiment,
      planInfo = _ref2.planInfo;

  var _ref3 = addOns || {},
      addOnPlans = _ref3.addOnPlans,
      filters = _ref3.filters;

  var _ref4 = (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.fields) || {},
      dob = _ref4.dob,
      name = _ref4.name,
      gender = _ref4.gender,
      passport = _ref4.passport;

  var formErrorToast = src.constants.formErrorToast,
      addErrorToast = src.constants.addErrorToast;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var travellerDataFromStore = (0,utils/* getTravDetailsFromMemory */.fP)();

  var _ref5 = travellerDataFromStore || {},
      travellerDetails = _ref5.travellerDetails,
      primaryContactDetails = _ref5.primaryContactDetails;

  var travellerRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(),
      checkoutError = _useState2[0],
      setCheckoutError = _useState2[1];

  var _useState3 = (0,react.useState)(-1),
      addTrav = _useState3[0],
      setAddTrav = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      quoteId = _useState4[0],
      setQuoteId = _useState4[1];

  var _useState5 = (0,react.useState)(-1),
      firstErrorIndex = _useState5[0],
      setFirstErrorIndex = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isValidForm = _useState6[0],
      setIsValidForm = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isSelectedError = _useState7[0],
      setIsSelectedError = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isFieldError = _useState8[0],
      setIsFieldError = _useState8[1];

  var _useState9 = (0,react.useState)(true),
      showOfferToast = _useState9[0],
      setShowOfferToast = _useState9[1];

  var _useState10 = (0,react.useState)(filters),
      addOnFilters = _useState10[0],
      setAddOnFilters = _useState10[1];

  var _useState11 = (0,react.useState)(addOnPlans),
      addOnPlansData = _useState11[0],
      setAddOnPlansData = _useState11[1];

  var primaryContactRef = (0,react.useRef)(null);
  var tncRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (planInfo !== null && planInfo !== void 0 && planInfo.quoteId) {
      setQuoteId(planInfo.quoteId);
    } else {
      var queryParams = new URLSearchParams(window.location.search);

      var _quoteId = queryParams.get("quoteId");

      setQuoteId(_quoteId);
    }

    setTimeout(function () {
      setShowOfferToast(false);
    }, 3000);
  }, []);
  var methods = useForm({
    defaultValues: {
      travellerData: Array.from({
        length: ((_savedTravellers$leng = savedTravellers === null || savedTravellers === void 0 ? void 0 : savedTravellers.length) !== null && _savedTravellers$leng !== void 0 ? _savedTravellers$leng : 0) + travellerCount
      }).map(function () {
        return {
          name: "",
          dob: "",
          gender: "",
          passport: "",
          isSelected: false
        };
      }),
      primaryContactData: {
        email: "",
        mobile: ""
      },
      tncs: Array.from({
        length: (_concent$tnc$length = concent === null || concent === void 0 ? void 0 : (_concent$tnc = concent.tnc) === null || _concent$tnc === void 0 ? void 0 : _concent$tnc.length) !== null && _concent$tnc$length !== void 0 ? _concent$tnc$length : 0
      }).map(function () {
        return true;
      })
    },
    mode: "onTouched"
  });
  var control = methods.control,
      getValues = methods.getValues,
      setValue = methods.setValue,
      getFieldState = methods.getFieldState,
      setError = methods.setError,
      handleSubmit = methods.handleSubmit,
      trigger = methods.trigger;
  var formValues = getValues();
  var travellerData = useWatch({
    control: control,
    name: "travellerData" // unique name for field array

  });

  var _useFieldArray = useFieldArray({
    control: control,
    name: "travellerData" // unique name for field array

  }),
      travellers = _useFieldArray.fields,
      append = _useFieldArray.append;

  var selectedCount = (0,react.useMemo)(function () {
    var _travellerData$filter, _travellerData$filter2;

    return (_travellerData$filter = travellerData === null || travellerData === void 0 ? void 0 : (_travellerData$filter2 = travellerData.filter(function (traveller) {
      return traveller.isSelected;
    })) === null || _travellerData$filter2 === void 0 ? void 0 : _travellerData$filter2.length) !== null && _travellerData$filter !== void 0 ? _travellerData$filter : 0;
  }, [travellerData]);
  (0,react.useMemo)(function () {
    if (selectedCount === travellerCount) {
      var isValid = true;
      travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (data) {
        if (data.isSelected) {
          var validName = name ? data.name ? true : false : true;
          var validDob = dob ? data.dob ? true : false : true;
          var validPassport = dob ? data.passport ? true : false : true;
          var validGender = gender ? data !== null && data !== void 0 && data.gender ? true : false : true;

          if (!(validDob && validGender && validName && validPassport)) {
            isValid = false;
          }
        }
      });
      setIsValidForm(isValid);
    } else {
      setIsValidForm(false);
    }
  }, [travellerData]); // To add saved travellers and upcoming travellers in memory

  (0,react.useEffect)(function () {
    var travellerDetail = [];
    var queryParams = new URLSearchParams(window.location.search);

    if (!(travellerDetails !== null && travellerDetails !== void 0 && travellerDetails.length) || queryParams.get("isUpcomingTrip") === "true") {
      if (queryParams.get("isUpcomingTrip") === "true" || (savedTravellers === null || savedTravellers === void 0 ? void 0 : savedTravellers.length) === 0) {
        upcomingTravellerDetails === null || upcomingTravellerDetails === void 0 ? void 0 : upcomingTravellerDetails.map(function (data) {
          travellerDetail.push(_objectSpread(_objectSpread({}, data), {}, {
            dob: parseInt(data.dob),
            gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
            isSelected: queryParams.get("isUpcomingTrip") === "true"
          }));
        });
      }

      savedTravellers === null || savedTravellers === void 0 ? void 0 : savedTravellers.map(function (data) {
        travellerDetail.push(_objectSpread(_objectSpread({}, data), {}, {
          gender: data.gender.charAt(0).toUpperCase() + data.gender.slice(1).toLowerCase(),
          isSelected: false,
          isSavedTraveller: true,
          isEdited: false
        }));
      });
      (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
        travellerDetails: travellerDetail,
        primaryContactDetails: primaryContact
      }));

      if (travellerDetail.length === 0) {
        setAddTrav(0);
      }
    } else {
      var selectedTravellersInMemory = travellerDetails === null || travellerDetails === void 0 ? void 0 : travellerDetails.filter(function (data) {
        return data.isSelected;
      });
      var remainingTravellersInMemory = travellerDetails === null || travellerDetails === void 0 ? void 0 : travellerDetails.filter(function (data) {
        return !data.isSelected;
      });

      var _queryParams = new URLSearchParams(window.location.search);

      var _travellers = Number(_queryParams.get("travellers"));

      travellerDetail.push.apply(travellerDetail, _toConsumableArray(selectedTravellersInMemory.slice(0, _travellers)).concat(_toConsumableArray(selectedTravellersInMemory.slice(_travellers).map(function (data) {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: false
        });
      })), _toConsumableArray(remainingTravellersInMemory)));
    }

    var length = travellerDetail !== null && travellerDetail !== void 0 && travellerDetail.length ? travellerDetail === null || travellerDetail === void 0 ? void 0 : travellerDetail.length : upcomingTravellerDetails !== null && upcomingTravellerDetails !== void 0 && upcomingTravellerDetails.length ? upcomingTravellerDetails === null || upcomingTravellerDetails === void 0 ? void 0 : upcomingTravellerDetails.length : 1;
    setValue("travellerData", Array.from({
      length: length
    }).map(function (_, index) {
      var _travellerDetail$inde, _travellerDetail$inde2, _travellerDetail$inde3, _travellerDetail$inde4, _travellerDetail$inde5, _travellerDetail$inde6, _travellerDetail$inde7, _travellerDetail$inde8, _travellerDetail$inde9, _travellerDetail$inde10, _travellerDetail$inde11, _travellerDetail$inde12;

      return {
        name: (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde = travellerDetail[index]) === null || _travellerDetail$inde === void 0 ? void 0 : _travellerDetail$inde.name) || "",
        dob: travellerDetail !== null && travellerDetail !== void 0 && (_travellerDetail$inde2 = travellerDetail[index]) !== null && _travellerDetail$inde2 !== void 0 && _travellerDetail$inde2.isSavedTraveller ? (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde3 = travellerDetail[index]) === null || _travellerDetail$inde3 === void 0 ? void 0 : _travellerDetail$inde3.dob) || "" : (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde4 = travellerDetail[index]) === null || _travellerDetail$inde4 === void 0 ? void 0 : _travellerDetail$inde4.dob) || "yyyy-mm-dd",
        gender: (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde5 = travellerDetail[index]) === null || _travellerDetail$inde5 === void 0 ? void 0 : _travellerDetail$inde5.gender) || "",
        passport: (travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde6 = travellerDetail[index]) === null || _travellerDetail$inde6 === void 0 ? void 0 : _travellerDetail$inde6.passport) || "",
        isSelected: (_travellerDetail$inde7 = travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde8 = travellerDetail[index]) === null || _travellerDetail$inde8 === void 0 ? void 0 : _travellerDetail$inde8.isSelected) !== null && _travellerDetail$inde7 !== void 0 ? _travellerDetail$inde7 : true,
        isEdited: (_travellerDetail$inde9 = travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde10 = travellerDetail[index]) === null || _travellerDetail$inde10 === void 0 ? void 0 : _travellerDetail$inde10.isEdited) !== null && _travellerDetail$inde9 !== void 0 ? _travellerDetail$inde9 : true,
        isSavedTraveller: (_travellerDetail$inde11 = travellerDetail === null || travellerDetail === void 0 ? void 0 : (_travellerDetail$inde12 = travellerDetail[index]) === null || _travellerDetail$inde12 === void 0 ? void 0 : _travellerDetail$inde12.isSavedTraveller) !== null && _travellerDetail$inde11 !== void 0 ? _travellerDetail$inde11 : false
      };
    }));
  }, [secondaryContact, savedTravellers, upcomingTravellerDetails]);
  (0,react.useEffect)(function () {
    var _primaryContact$field, _primaryContact$field2, _primaryContact$field3, _primaryContact$field4;

    setValue("primaryContactData", {
      mobile: (primaryContactDetails === null || primaryContactDetails === void 0 ? void 0 : primaryContactDetails.mobile) || (primaryContact === null || primaryContact === void 0 ? void 0 : (_primaryContact$field = primaryContact.fields) === null || _primaryContact$field === void 0 ? void 0 : (_primaryContact$field2 = _primaryContact$field.mobile) === null || _primaryContact$field2 === void 0 ? void 0 : _primaryContact$field2.value) || "",
      email: (primaryContactDetails === null || primaryContactDetails === void 0 ? void 0 : primaryContactDetails.email) || (primaryContact === null || primaryContact === void 0 ? void 0 : (_primaryContact$field3 = primaryContact.fields) === null || _primaryContact$field3 === void 0 ? void 0 : (_primaryContact$field4 = _primaryContact$field3.email) === null || _primaryContact$field4 === void 0 ? void 0 : _primaryContact$field4.value) || ""
    });
  }, [primaryContact]);
  var selectedCountry = (0,react.useMemo)(function () {
    return countryData === null || countryData === void 0 ? void 0 : countryData.find(function (item) {
      return item.isSelected;
    });
  }, [countryData]);

  var _handleArrowButton = function handleArrowButton(index) {
    if (addTrav === index) {
      setAddTrav(-1);

      if (travellerData !== null && travellerData !== void 0 && travellerData[index].isSelected) {
        trigger("travellerData.".concat(index));
      }
    } else {
      setAddTrav(index);
    }
  };

  var _handleGenderChange = function handleGenderChange(data, index) {
    setValue("travellerData.".concat(index, ".gender"), data.label);
  };

  var saveFormValuesOnBlur = function saveFormValuesOnBlur() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

    if (index != -1 && !getValues("travellerData.".concat(index, ".isEdited"))) {
      setValue("travellerData.".concat(index, ".isEdited"), true);
    }

    var travellerData = formValues.travellerData,
        primaryContactData = formValues.primaryContactData;
    (0,utils/* setTravDetailsInMemory */.Yp)(_objectSpread(_objectSpread({}, travellerDataFromStore), {}, {
      travellerDetails: travellerData,
      primaryContactDetails: primaryContactData
    }));
  };

  var getTravellerDetailList = function getTravellerDetailList(data) {
    var _ref6 = data || {},
        travellerData = _ref6.travellerData,
        _ref6$primaryContactD = _ref6.primaryContactData;

    _ref6$primaryContactD = _ref6$primaryContactD === void 0 ? {} : _ref6$primaryContactD;
    var _ref6$primaryContactD2 = _ref6$primaryContactD.email,
        email = _ref6$primaryContactD2 === void 0 ? "" : _ref6$primaryContactD2,
        _ref6$primaryContactD3 = _ref6$primaryContactD.mobile,
        mobile = _ref6$primaryContactD3 === void 0 ? "" : _ref6$primaryContactD3;
    var travellerList = travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (traveller, index) {
      if (traveller.isSelected) {
        var _traveller$isEdited, _traveller$passport;

        return {
          travellerId: index.toString(),
          name: traveller.name.trim(),
          dob: (0,utils/* formatDate */.p6)(traveller.dob, src.DATE_FORMATS["DD/MM/YYYY"]),
          gender: traveller.gender,
          mobile: "".concat((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryCode) || "+91").concat(mobile.trim()),
          isEdited: (_traveller$isEdited = traveller === null || traveller === void 0 ? void 0 : traveller.isEdited) !== null && _traveller$isEdited !== void 0 ? _traveller$isEdited : false,
          passport: (_traveller$passport = traveller === null || traveller === void 0 ? void 0 : traveller.passport) !== null && _traveller$passport !== void 0 ? _traveller$passport : "",
          email: email,
          countryCode: ""
        };
      } else {
        return null;
      }
    }).filter(function (data) {
      return data != null;
    });
    return travellerList;
  };

  var handleTncCheckbox = function handleTncCheckbox(index) {
    var value = formValues.tncs[index];
    setValue("tncs.".concat(index), !value);
    trigger("tncs.".concat(index));
  };

  var handleServerErrors = function handleServerErrors(error) {
    var _ref7 = (error === null || error === void 0 ? void 0 : error.validationError) || {},
        _ref7$displayPrimaryM = _ref7.displayPrimaryMobileError,
        displayPrimaryMobileError = _ref7$displayPrimaryM === void 0 ? "" : _ref7$displayPrimaryM,
        _ref7$displayPrimaryE = _ref7.displayPrimaryEmailError,
        displayPrimaryEmailError = _ref7$displayPrimaryE === void 0 ? "" : _ref7$displayPrimaryE,
        _ref7$displaySecondar = _ref7.displaySecondaryError,
        displaySecondaryError = _ref7$displaySecondar === void 0 ? [] : _ref7$displaySecondar;

    if (displayPrimaryMobileError) {
      setError("primaryContactData.mobile", {
        message: displayPrimaryMobileError
      });
      AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
        actionType: "error_shown",
        payload: displayPrimaryMobileError
      });
    }

    if (displayPrimaryEmailError) {
      setError("primaryContactData.email", {
        message: displayPrimaryEmailError
      });
      AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
        actionType: "error_shown",
        payload: displayPrimaryEmailError
      });
    }

    var secondaryErrorFirstindex = -1;

    var setSecondaryErrorIndex = function setSecondaryErrorIndex(travellerId, message) {
      AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
        actionType: "error_shown",
        payload: message
      });

      if (secondaryErrorFirstindex < 0) {
        secondaryErrorFirstindex = travellerId;
      }
    };

    displaySecondaryError.map(function (item, index) {
      var travellerId = item.travellerId;

      var _ref8 = (item === null || item === void 0 ? void 0 : item.displayError) || {},
          name = _ref8.name,
          dob = _ref8.dob,
          gender = _ref8.gender,
          passport = _ref8.passport;

      if (name) {
        setError("travellerData.".concat(travellerId || index, ".name"), {
          message: name
        });
        setSecondaryErrorIndex(Number(travellerId || index), name);
      }

      if (dob) {
        setError("travellerData.".concat(travellerId || index, ".dob"), {
          message: dob
        });
        setSecondaryErrorIndex(Number(travellerId || index), dob);
      }

      if (gender) {
        setError("travellerData.".concat(travellerId || index, ".gender"), {
          message: gender
        });
        setSecondaryErrorIndex(Number(travellerId || index), gender);
      }

      if (passport) {
        setError("travellerData.".concat(travellerId || index, ".passport"), {
          message: passport
        });
        setSecondaryErrorIndex(Number(travellerId || index), passport);
      }
    });

    if (displaySecondaryError.length) {
      if (secondaryErrorFirstindex > -1) {
        setFirstErrorIndex(Number(secondaryErrorFirstindex));
      }
    }
  };

  var handleErrorToast = function handleErrorToast() {
    setTimeout(function () {
      setIsSelectedError(false);
      setIsFieldError(false);
    }, 3000);
  };

  var handleTravellerSelect = function handleTravellerSelect(value, index) {
    if (getValues("travellerData.".concat(index, ".isSelected"))) {
      setAddTrav(-1);
      setValue("travellerData.".concat(index, ".isSelected"), false);
    } else {
      if (selectedCount === travellerCount) {
        if (!isSelectedError) {
          setIsSelectedError(true);
          handleErrorToast();
        }
      } else {
        setAddTrav(index);
        setValue("travellerData.".concat(index, ".isSelected"), true);
      }
    }
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(formData) {
      var partner, _travellerDetails, failureUrl, requestData, response, responseStatus, _data, checkoutUrl, _Error, error, _err$response, _ref10, _error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "traveller_name_filled"
              });
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "contact_details_filled"
              });
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "dob_selected"
              });
              AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
                actionType: "gender_selected"
              });
              partner = (0,utils/* getPartnerOnClientSide */.et)();
              _travellerDetails = getTravellerDetailList(formData);
              failureUrl = new URL(window.location.href);
              failureUrl.searchParams.append("paymentSuccess", "false");
              requestData = {
                quoteId: quoteId,
                insurancePurchaseRequest: _travellerDetails,
                failureUrl: failureUrl
              };
              setIsLoading(true);
              _context.next = 13;
              return (0,api/* paymentCheckout */.QW)({
                partner: partner,
                data: requestData
              });

            case 13:
              response = _context.sent;
              responseStatus = response.responseStatus, _data = response.data;

              if (responseStatus === src.RESPONSE_STATUS.SUCCESS && _data !== null && _data !== void 0 && _data.checkoutUrl) {
                checkoutUrl = _data.checkoutUrl;
                setIsLoading(false);
                (0,utils/* openCheckoutPage */.yi)(checkoutUrl);
              } else {
                setIsLoading(false);
                _Error = response.Error, error = response.error;

                if (_Error && (_Error === null || _Error === void 0 ? void 0 : _Error.code) === src.ERROR_CODES.DISPLAY_ERROR) {
                  handleServerErrors(_Error);
                } else {
                  setCheckoutError(error);
                }
              }

              _context.next = 24;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](0);
              console.error("CHECKOUT FAILURE ERROR ----", {
                err: _context.t0
              });
              _ref10 = (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data) || {}, _error = _ref10.error;
              setIsLoading(false);
              setCheckoutError(_error);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));

    return function onSubmit(_x) {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleAddTraveller = function handleAddTraveller() {
    if (selectedCount != travellerCount) {
      setAddTrav(travellers.length);
      append({
        name: "",
        dob: "yyyy-mm-dd",
        gender: "",
        passport: "",
        isSelected: true
      });
    }
  };

  var onSubmitError = function onSubmitError(errors) {
    var _errors$travellerData, _errors$primaryContac, _errors$primaryContac2, _errors$tncs;

    if (!isFieldError) {
      setIsFieldError(true);
      handleErrorToast();
    }

    if ((_errors$travellerData = errors.travellerData) !== null && _errors$travellerData !== void 0 && _errors$travellerData.length) {
      var _errors$travellerData2, _errors$travellerData3;

      var errorIndex = (_errors$travellerData2 = errors.travellerData) === null || _errors$travellerData2 === void 0 ? void 0 : (_errors$travellerData3 = _errors$travellerData2.findIndex) === null || _errors$travellerData3 === void 0 ? void 0 : _errors$travellerData3.call(_errors$travellerData2, function (error) {
        return error;
      });

      if (errorIndex != null && errorIndex > -1) {
        setFirstErrorIndex(errorIndex);
      }
    } else if ((_errors$primaryContac = errors.primaryContactData) !== null && _errors$primaryContac !== void 0 && _errors$primaryContac.email || (_errors$primaryContac2 = errors.primaryContactData) !== null && _errors$primaryContac2 !== void 0 && _errors$primaryContac2.mobile) {
      var _primaryContactRef$cu;

      (_primaryContactRef$cu = primaryContactRef.current) === null || _primaryContactRef$cu === void 0 ? void 0 : _primaryContactRef$cu.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "center"
      });
    } else if ((_errors$tncs = errors.tncs) !== null && _errors$tncs !== void 0 && _errors$tncs.length) {
      var _tncRef$current;

      (_tncRef$current = tncRef.current) === null || _tncRef$current === void 0 ? void 0 : _tncRef$current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center"
      });
    }
  };

  (0,react.useEffect)(function () {
    if (firstErrorIndex > -1) {
      var _travellerRef$current;

      (_travellerRef$current = travellerRef.current) === null || _travellerRef$current === void 0 ? void 0 : _travellerRef$current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
      setAddTrav(-1);
    }

    setFirstErrorIndex(-1);
  }, [firstErrorIndex]);

  var _handleBuy = function handleBuy() {
    var fromBenefitModal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (showBenefits) {
      handleViewBenefits();
    }

    if (selectedCount !== travellerCount) {
      if (!isFieldError) {
        setIsFieldError(true);
        setFirstErrorIndex(0);
        handleErrorToast();
      }
    } else {
      var _formValues$traveller;

      if (isDomesticBooking) {
        if (fromBenefitModal) {
          AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
            actionType: "buy_clicked_details_domestic"
          });
        } else {
          AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
            actionType: "buy_clicked_outside_domestic"
          });
        }
      } else {
        AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
          actionType: "buy_clicked"
        });
      }

      var _formValues = getValues();

      _formValues === null || _formValues === void 0 ? void 0 : (_formValues$traveller = _formValues.travellerData) === null || _formValues$traveller === void 0 ? void 0 : _formValues$traveller.map(function (item, index) {
        var _ref11 = item || {},
            fullName = _ref11.name,
            dobValue = _ref11.dob,
            genderType = _ref11.gender,
            passportType = _ref11.passport;

        var fieldState = getFieldState("travellerData.".concat(index));
        var isTouched = fieldState.isTouched;

        if (!isTouched) {
          if (name && !fullName) {
            setError("travellerData.".concat(index, ".name"), {
              message: (0,utils/* getFormFieldErrorMsg */.YV)("name")
            });
          } else if (dob && !dobValue) {
            setError("travellerData.".concat(index, ".dob"), {
              message: (0,utils/* getFormFieldErrorMsg */.YV)("dob")
            });
          } else if (gender && !genderType) {
            setError("travellerData.".concat(index, ".gender"), {
              message: (0,utils/* getFormFieldErrorMsg */.YV)("gender")
            });
          } else if (passport && !passportType) {
            setError("travellerData.".concat(index, ".passport"), {
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
            });
          }
        }
      });
      handleSubmit(onSubmit, onSubmitError)();
    }
  };

  if (checkoutError && true) {
    throw new utility_src/* ClientError */.XF(checkoutError);
  }

  var handleAddOnFilters = function handleAddOnFilters(selectedFilterId) {
    var _filterData$filter, _filterData$filter$, _addOnPlans$map;

    AddTravellerDetails_analytics === null || AddTravellerDetails_analytics === void 0 ? void 0 : AddTravellerDetails_analytics.trackTravDetailsEvents({
      actionType: "Filter_selected"
    });
    var filterData = filters === null || filters === void 0 ? void 0 : filters.map(function (filter) {
      if (filter.id === selectedFilterId) {
        filter.isSelected = true;
      } else {
        filter.isSelected = false;
      }

      return filter;
    });
    var selectedFilteredPlans = filterData === null || filterData === void 0 ? void 0 : (_filterData$filter = filterData.filter(function (filter) {
      return filter.isSelected;
    })) === null || _filterData$filter === void 0 ? void 0 : (_filterData$filter$ = _filterData$filter[0]) === null || _filterData$filter$ === void 0 ? void 0 : _filterData$filter$.plans;
    var currentAddOnPlans = addOnPlans === null || addOnPlans === void 0 ? void 0 : (_addOnPlans$map = addOnPlans.map(function (plan) {
      if (selectedFilteredPlans !== null && selectedFilteredPlans !== void 0 && selectedFilteredPlans.includes(plan === null || plan === void 0 ? void 0 : plan.planCode)) {
        return plan;
      } else {
        return null;
      }
    })) === null || _addOnPlans$map === void 0 ? void 0 : _addOnPlans$map.filter(function (plan) {
      return plan !== null;
    });
    setAddOnPlansData(currentAddOnPlans);
    setAddOnFilters(filterData);
  };

  var handleAddOnSelect = function handleAddOnSelect(planCode) {
    var _addOnFilters$filter, _addOnFilters$filter$, _addOnPlans$map2, _addOnPlans$filter, _addOnPlans$filter$;

    var selectedFilteredPlans = addOnFilters === null || addOnFilters === void 0 ? void 0 : (_addOnFilters$filter = addOnFilters.filter(function (filter) {
      return filter.isSelected;
    })) === null || _addOnFilters$filter === void 0 ? void 0 : (_addOnFilters$filter$ = _addOnFilters$filter[0]) === null || _addOnFilters$filter$ === void 0 ? void 0 : _addOnFilters$filter$.plans;
    var addOnData = addOnPlans === null || addOnPlans === void 0 ? void 0 : (_addOnPlans$map2 = addOnPlans.map(function (plan, index) {
      if ((plan === null || plan === void 0 ? void 0 : plan.planCode) === planCode) {
        if (plan.isSelected) {
          var queryParams = new URLSearchParams(window.location.search);

          var _quoteId2 = queryParams.get("quoteId");

          setQuoteId(_quoteId2);
          plan.isSelected = false;
        } else {
          setQuoteId(plan === null || plan === void 0 ? void 0 : plan.quoteId);
          plan.isSelected = true;
        }
      } else {
        plan.isSelected = false;
      }

      return plan;
    })) === null || _addOnPlans$map2 === void 0 ? void 0 : _addOnPlans$map2.filter(function (plan) {
      return selectedFilteredPlans === null || selectedFilteredPlans === void 0 ? void 0 : selectedFilteredPlans.includes(plan === null || plan === void 0 ? void 0 : plan.planCode);
    });
    var selectedAddOnProdDetails = addOnPlans === null || addOnPlans === void 0 ? void 0 : (_addOnPlans$filter = addOnPlans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _addOnPlans$filter === void 0 ? void 0 : (_addOnPlans$filter$ = _addOnPlans$filter[0]) === null || _addOnPlans$filter$ === void 0 ? void 0 : _addOnPlans$filter$.comboProductDetails;

    if (selectedAddOnProdDetails) {
      setAddOnProductDetails === null || setAddOnProductDetails === void 0 ? void 0 : setAddOnProductDetails(selectedAddOnProdDetails);
    } else {
      setAddOnProductDetails === null || setAddOnProductDetails === void 0 ? void 0 : setAddOnProductDetails(null);
    }

    setAddOnPlansData(addOnData);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
    "data-test-id": "AddTravellerDetails-FormProvider",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetailStyle, {
      "data-test-id": "AddTravellerDetails-AddTravellerDetailStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerHd, {
        "data-test-id": "AddTravellerDetails-AddTravellerHd",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
          "data-test-id": "AddTravellerDetails-H5Tag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "AddTravellerDetails-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "xs",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "AddTravellerDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: info,
            "data-test-id": "AddTravellerDetails-FormattedText"
          })
        })]
      }), travellers.map(function (traveller, index) {
        var _formValues$traveller2, _secondaryContact$fie, _secondaryContact$fie2;

        var _ref12 = (formValues === null || formValues === void 0 ? void 0 : (_formValues$traveller2 = formValues.travellerData) === null || _formValues$traveller2 === void 0 ? void 0 : _formValues$traveller2[index]) || {},
            gender = _ref12.gender,
            isSelected = _ref12.isSelected;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-test-id": "AddTravellerDetails",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerDetailsV2, {
            handleTravellerSelect: handleTravellerSelect,
            travellerIndex: index,
            travellerRef: travellerRef,
            isLoading: isLoading,
            firstErrorIndex: firstErrorIndex,
            travellerSelected: addTrav == index,
            isSelected: isSelected,
            count: selectedCount,
            travellerNumber: "".concat(secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.title, " ").concat(index + 1),
            isSavedTravellers: savedTravellers !== null && savedTravellers !== void 0 && savedTravellers.length ? true : false,
            secondaryContactData: secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.fields,
            genderTypes: (secondaryContact === null || secondaryContact === void 0 ? void 0 : (_secondaryContact$fie = secondaryContact.fields) === null || _secondaryContact$fie === void 0 ? void 0 : (_secondaryContact$fie2 = _secondaryContact$fie.gender) === null || _secondaryContact$fie2 === void 0 ? void 0 : _secondaryContact$fie2.values) || src.GENDER_VALUES,
            selectedGender: gender,
            handleGenderChange: function handleGenderChange(item) {
              return _handleGenderChange(item, index);
            },
            handleArrowButton: function handleArrowButton() {
              return _handleArrowButton(index);
            },
            travellerCount: travellerCount,
            saveFormValuesOnBlur: saveFormValuesOnBlur,
            isDomesticBooking: isDomesticBooking,
            isValidForm: isValidForm,
            isEditable: (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.isEditable) === false ? false : true,
            "data-test-id": "AddTravellerDetails-TravellerDetailsV2"
          })
        }, traveller.id);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
        height: "1.2px",
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), !isDomesticBooking && /*#__PURE__*/(0,jsx_runtime.jsxs)(AddButtonWrap, {
        isDisabled: selectedCount === travellerCount,
        onClick: handleAddTraveller,
        "data-test-id": "AddTravellerDetails-AddButtonWrap",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "16px",
          height: "16px",
          margin: "0px 10px 0px 0px",
          src: selectedCount === travellerCount ? "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_529ac663fb.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Vector_68e1489f3a.svg",
          "data-test-id": "AddTravellerDetails-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: "ADD ANOTHER TRAVELLER",
          baseStyle: {
            fontWeight: "800" // margin: '10px 0px 10px 0px',

          },
          "data-test-id": "AddTravellerDetails-FormattedText"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), addOns && /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        title: addOns === null || addOns === void 0 ? void 0 : addOns.title,
        info: addOns === null || addOns === void 0 ? void 0 : addOns.subTitle,
        addOnPlans: addOnPlansData,
        addOnfilters: addOnFilters,
        handleBuy: _handleBuy,
        handleAddOnFilters: handleAddOnFilters,
        handleAddOnSelect: handleAddOnSelect,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      }), addOns && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        componentRef: primaryContactRef,
        title: primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.title,
        info: primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.info,
        note: isDomesticBooking ? undefined : note,
        primaryContactDetails: true,
        primaryContactData: primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.fields,
        saveFormValuesOnBlur: saveFormValuesOnBlur,
        countryData: countryData,
        selectedCountry: selectedCountry,
        handleCountryCodeModal: handleCountryCodeModal,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
        small: true,
        "data-test-id": "AddTravellerDetails-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerCommonComp, {
        componentRef: tncRef,
        confirmTnC: concent === null || concent === void 0 ? void 0 : concent.tnc,
        handleTncCheckbox: handleTncCheckbox,
        info: isDomesticBooking ? "" : concent === null || concent === void 0 ? void 0 : concent.info,
        totalAmt: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.totalAmountToPay ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.totalAmountToPay : totalAmt,
        handleBuy: function handleBuy() {
          _handleBuy();
        },
        isLoading: isLoading,
        "data-test-id": "AddTravellerDetails-TravellerCommonComp"
      })]
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
      toastTxt: "Already selected ".concat(travellerCount, " ").concat(travellerCount === 1 ? "traveller" : "travellers", ", Remove before adding one."),
      position: "fixed",
      right: "50px",
      margin: device === "lg" ? "0px 0px 0px 28px" : "",
      height: "40px",
      bottom: device === "sm" ? "70px" : "50px",
      "data-test-id": "AddTravellerDetails-WebToast"
    }), isFieldError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToastWrap, {
      "data-test-id": "AddTravellerDetails-WebToastWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
        type: "error",
        toastTxt: selectedCount === travellerCount ? widgets !== null && widgets !== void 0 && widgets.formErrorToast ? widgets === null || widgets === void 0 ? void 0 : (_widgets$formErrorToa = widgets.formErrorToast) === null || _widgets$formErrorToa === void 0 ? void 0 : _widgets$formErrorToa.message : formErrorToast : widgets !== null && widgets !== void 0 && widgets.addErrorToast ? widgets === null || widgets === void 0 ? void 0 : (_widgets$addErrorToas = widgets.addErrorToast) === null || _widgets$addErrorToas === void 0 ? void 0 : _widgets$addErrorToas.message : addErrorToast,
        color: "#6B4300",
        "data-test-id": "AddTravellerDetails-WebToast"
      })
    }), (widgets === null || widgets === void 0 ? void 0 : widgets.offerToast) && showOfferToast && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
      type: "success",
      iconUrl: widgets === null || widgets === void 0 ? void 0 : (_widgets$offerToast = widgets.offerToast) === null || _widgets$offerToast === void 0 ? void 0 : _widgets$offerToast.iconUrl,
      toastTxt: widgets === null || widgets === void 0 ? void 0 : (_widgets$offerToast2 = widgets.offerToast) === null || _widgets$offerToast2 === void 0 ? void 0 : _widgets$offerToast2.message,
      position: "fixed",
      toastTxtMargin: "0px 0px 0px 5px",
      color: "#1E5C43",
      fontSize: "14px",
      fontWeight: "700",
      right: "50px",
      bottom: device === "sm" ? "70px" : "50px",
      "data-test-id": "AddTravellerDetails-WebToast"
    }), showBenefits && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_MoreBenefits, {
      data: benefitsData,
      moreBenfitsTitle: benefitsTitle,
      handleClose: handleViewBenefits,
      handleBuyButton: function handleBuyButton() {
        _handleBuy(true);
      },
      "data-test-id": "AddTravellerDetails-MoreBenefits"
    })]
  }));
};

/* harmony default export */ var AddTravellerDetail_AddTravellerDetails = (AddTravellerDetails);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
function objectDestructuringEmpty_objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/TravellerDetailsShimmer.tsx







var TravellerDetailsShimmer = function TravellerDetailsShimmer(_ref) {
  objectDestructuringEmpty_objectDestructuringEmpty(_ref);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerDetailsStyle, {
    "data-test-id": "TravellerDetailsShimmer-TravellerDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
      width: "266px",
      height: "20px",
      margin: "0 0 16px",
      "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "16px",
      margin: "0 0 16px",
      "data-test-id": "TravellerDetailsShimmer-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "170px",
          height: "18px",
          margin: "0 0 8px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "258px",
          height: "40px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "170px",
          height: "18px",
          margin: "0 0 8px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "258px",
          height: "40px",
          "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
      width: "170px",
      height: "24px",
      margin: "0 0 8px",
      "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "8px",
      "data-test-id": "TravellerDetailsShimmer-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "77px",
        height: "36px",
        "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "77px",
        height: "36px",
        "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "77px",
        height: "36px",
        "data-test-id": "TravellerDetailsShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_TravellerDetailsShimmer = (TravellerDetailsShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetailShimmer.tsx








var AddTravellerDetailShimmer = function AddTravellerDetailShimmer(_ref) {
  objectDestructuringEmpty_objectDestructuringEmpty(_ref);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerDetailStyle, {
    "data-test-id": "AddTravellerDetailShimmer-AddTravellerDetailStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AddTravellerHd, {
      "data-test-id": "AddTravellerDetailShimmer-AddTravellerHd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "100%",
        height: "28px",
        margin: "0 0 8px",
        "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "266px",
        height: "16px",
        "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddTravellerDetail_TravellerDetailsShimmer, {
      "data-test-id": "AddTravellerDetailShimmer-TravellerDetailsShimmer"
    }), Array.from({
      length: 3
    }).map(function (_item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerAddShimmer, {
        "data-test-id": "AddTravellerDetailShimmer-TravellerAddShimmer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "75px",
          height: "20px",
          "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion3_ShimmerVersion3, {
          width: "60px",
          height: "32px",
          "data-test-id": "AddTravellerDetailShimmer-ShimmerVersion3"
        })]
      }, "".concat(index));
    })]
  });
};

/* harmony default export */ var AddTravellerDetail_AddTravellerDetailShimmer = (AddTravellerDetailShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.style.ts

var BackDropCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BackDropCompstyle__BackDropCompStyle",
  componentId: "f3s9gn-0"
})(["position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.5);z-index:46;width:100%;height:", ";"], function (p) {
  return p.height ? "".concat(p.height, "px") : "100vh";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.tsx




var BackDropComp = function BackDropComp(_ref) {
  var onClose = _ref.onClose;

  var _useState = (0,react.useState)(undefined),
      height = _useState[0],
      setHeight = _useState[1];

  (0,react.useEffect)(function () {
    var handleResize = function handleResize() {
      setHeight(window.innerHeight);
    };

    if (true) {
      setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropCompStyle, {
    onClick: onClose,
    height: height,
    "data-test-id": "BackDropComp-BackDropCompStyle"
  });
};

/* harmony default export */ var BackDropComp_BackDropComp = (BackDropComp);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/BulletListItem/BulletListItem.style.ts
var BulletListItem_style = __webpack_require__(8988);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/BulletListItem/BulletListItem.tsx




var BulletListItem = function BulletListItem(_ref) {
  var children = _ref.children,
      _ref$bulletColor = _ref.bulletColor,
      bulletColor = _ref$bulletColor === void 0 ? Global/* theme.darkYellowText */.rS.darkYellowText : _ref$bulletColor;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BulletListItem_style/* BulletListItemStyle */.I, {
    bulletColor: bulletColor,
    "data-test-id": "BulletListItem-BulletListItemStyle",
    children: children
  });
};

/* harmony default export */ var BulletListItem_BulletListItem = (BulletListItem);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.style.ts

var CheckButtonStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CheckButtonstyle__CheckButtonStyle",
  componentId: "sc-1v2zgji-0"
})(["display:flex;align-items:baseline;cursor:pointer;", " label{margin-left:10px;flex:1;width:100%;cursor:pointer;user-select:none;}}", " input[type=\"checkbox\"]{", " visibility:hidden;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;}@supports (-moz-appearance:none){input[type=\"checkbox\"]{visibility:visible;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;width:18px;height:18px;accent-color:#008CFF;}}input[type='checkbox']::before{width:16px;height:16px;display:flex;visibility:visible;flex-shrink:0;border:1px solid #4a4a4a;border-radius:4px;background:#fff;position:absolute;top:0px;left:-2px;content:'';}input[type='checkbox']::after{content:'';display:block;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin:0px 0 0 4px;position:absolute;visibility:visible;top:3px;left:0px;}input[type='checkbox']:checked::before{", " border:unset;}"], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return props.travellingTo && "\n label{\n  position:absolute;\n  left:8px;\n  bottom:8px;\n }\n";
}, function (props) {
  return !props.isDisabled && "cursor: pointer;";
}, function (props) {
  return props.isDisabled ? "background: #0000004D;" : "background: #008cff;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.tsx





var CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      inputId = _ref.inputId,
      travellingTo = _ref.travellingTo,
      handleChange = _ref.handleChange,
      inputIndex = _ref.inputIndex,
      isDisabled = _ref.isDisabled,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      margin = _ref.margin;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckButtonStyle, {
    margin: margin,
    travellingTo: travellingTo,
    isDisabled: isDisabled,
    "data-test-id": "CheckButton-CheckButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      onChange: handleChange,
      type: "checkbox",
      id: inputId,
      checked: isChecked
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      id: inputId,
      "data-test-id": "CheckButton-label",
      children: children
    })]
  });
};

/* harmony default export */ var CheckButton_CheckButton = (CheckButton);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var static_utils = __webpack_require__(4576);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(984);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.style.ts




var ClaimYourInsuranceStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimYourInsuranceStyle",
  componentId: "uew8se-0"
})(["background:#f6f6f6;width:100%;padding:100px 0;@media ", "{padding:48px 16px;", "{> ", "{overflow-y:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;-webkit-overflow-scrolling:touch;}}}"], static_utils/* deviceType.mobile */.vO.mobile, CommonStyles_style/* InnerContentWrap */.I, FlexCompStyle);
var ClaimStructureStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimStructureStyle",
  componentId: "uew8se-1"
})(["background:#ffffff;border-radius:18.9111px;padding:30px 20px;display:flex;flex-direction:column;gap:16px;width:226px;position:relative;flex-shrink:0;> img{flex-shrink:0;position:absolute;right:-34%;top:40%;}@media ", "{padding:16px;width:180px;> img{right:-21%;}}"], static_utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RichText/RichText.tsx
var RichText = __webpack_require__(1643);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(8524);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/partner.ts
var PARTNER = {
  MMT: "mmt",
  GI: "gi",
  TRIPMONEY: "tripmoney",
  UNKNOWN: "unknown"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/constants/index.ts

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimStructure.tsx











var ClaimStructure = function ClaimStructure(_ref) {
  var claimIndex = _ref.claimIndex,
      claimInfo = _ref.claimInfo,
      showSpiral = _ref.showSpiral;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClaimStructureStyle, {
    "data-test-id": "ClaimStructure-ClaimStructureStyle",
    children: [context === PARTNER.MMT ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H2Tag",
      children: claimIndex
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H3Tag, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H3Tag",
      children: claimIndex
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
      "data-test-id": "ClaimStructure-SpanTag",
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(RichText/* default */.Z, {
        value: claimInfo,
        "data-test-id": "ClaimStructure-RichText"
      })]
    }), !showSpiral && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: device == "lg" ? "57px" : "24px",
      height: device == "lg" ? "57px" : "24px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_Spiral_de40650b4c.svg",
      "data-test-id": "ClaimStructure-ImageComponent"
    })]
  });
};

/* harmony default export */ var ClaimYourInsurance_ClaimStructure = (ClaimStructure);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.tsx












var ClaimYourInsurance = function ClaimYourInsurance(_ref) {
  var data = _ref.data,
      title = _ref.title,
      info = _ref.info;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsuranceStyle, {
    "data-test-id": "ClaimYourInsurance-ClaimYourInsuranceStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "ClaimYourInsurance-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
          color: Global/* theme.greenText */.rS.greenText,
          margin: "0 0 86px",
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
          color: Global/* theme.greenText5 */.rS.greenText5,
          margin: "0 0 20px",
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        gap: device == "lg" ? "100px" : "48px",
        "data-test-id": "ClaimYourInsurance-FlexComp",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsurance_ClaimStructure, {
              claimInfo: item.claimInfo,
              claimIndex: item.claimIndex,
              showSpiral: index == data.length - 1,
              "data-test-id": `ClaimYourInsurance-ClaimStructure-${index}`
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var ClaimYourInsurance_ClaimYourInsurance = (ClaimYourInsurance);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.style.ts
var CommonModalDweb_style = __webpack_require__(9881);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx







var CommonModalDweb = function CommonModalDweb(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      handleClick = _ref.handleClick,
      requiredField = _ref.requiredField,
      crossIcon = _ref.crossIcon,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      nonClipHeading = _ref.nonClipHeading;
  (0,react.useEffect)(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_ReactPortalComp, {
    "data-test-id": "CommonModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_style/* CommonModalDwebStyle */.E5, {
      customWidth: customWidth,
      "data-test-id": "CommonModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_style/* CommonModalHeader */.fm, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "CommonModalDweb-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
          color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
          "data-test-id": "CommonModalDweb-H5Tag",
          children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "40px",
            height: "40px",
            src: customIcon,
            "data-test-id": "CommonModalDweb-ImageComponent"
          }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: customTitle,
            "data-test-id": "CommonModalDweb-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommonModalDweb_style/* CrossIconWrap */.G7, {
          onClick: handleClick,
          "data-test-id": "CommonModalDweb-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "CommonModalDweb-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropComp_BackDropComp, {
      onClose: handleClick,
      "data-test-id": "CommonModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ var CommonModalDweb_CommonModalDweb = (CommonModalDweb);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.style.ts




var BenefitRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitRow",
  componentId: "sc-1pkokku-0"
})(["display:flex;border-bottom:1px solid #d3d9df;gap:10px;", " ", "{height:32px;}", " span{font-size:12px;}@media ", "{gap:0;}"], function (p) {
  return p.lastRow && "\n    border-bottom: none;\n    ";
}, LandingButton_style/* LandingButtonStyle */.zm, LandingButton_style/* LandingButtonStyle */.zm, src.deviceType.mobile);
var BenefitCol1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol1",
  componentId: "sc-1pkokku-1"
})(["display:flex;gap:10px;flex:1.5;padding:12px;@media ", "{padding:12px 4px;flex:1.7;}"], src.deviceType.mobile);
var BenefitCol2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol2",
  componentId: "sc-1pkokku-2"
})(["flex:1.2;display:flex;flex-direction:column;gap:10px;border-left:solid 1px #d3d9df;border-right:solid 1px #d3d9df;padding:12px;", " ", " @media ", "{border-right:none;padding:12px 10px;", "}"], function (p) {
  return p.firstRow && "\n    border-top:solid 1px #d3d9df;\n    border-radius:8px 8px 0 0;\n    ";
}, function (p) {
  return p.lastRow && "\n    border-bottom:solid 1px #d3d9df;\n    border-radius:0 0 8px 8px;\n    ";
}, src.deviceType.mobile, function (p) {
  return p.firstRow && "\n    border-radius:8px 0px 0 0;\n    ";
});
var BenefitCol3 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol3",
  componentId: "sc-1pkokku-3"
})(["flex:1.2;display:flex;flex-direction:column;gap:10px;border-left:solid 1px #d3d9df;border-right:solid 1px #d3d9df;padding:12px;", " ", " @media ", "{padding:12px 10px;", "}"], function (p) {
  return p.firstRow && "\n    border-top:solid 1px #d3d9df;\n    border-radius:8px 8px 0 0;\n    ";
}, function (p) {
  return p.lastRow && "\n    border-bottom:solid 1px #d3d9df;\n    border-radius:0 0 8px 8px;\n    ";
}, src.deviceType.mobile, function (p) {
  return p.firstRow && "\n    border-top:solid 1px #d3d9df;\n    border-radius:0px 8px 0 0;\n    ";
});
var BenefitDescHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitDescHeader",
  componentId: "sc-1pkokku-4"
})(["background:rgba(0,0,0,0.04);border-radius:4px;display:flex;gap:10px;", "{flex-shrink:0;}@media ", "{gap:0;}"], TextStyles_style/* SpanTagStyle */.zs, src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
 // export const useBreakpoint = () => {
//     const [windowSize, setWindowSize] = useState<number>(1200);
//     function handleResize() {
//         console.log('IN THE FUNCTION: ', window.innerWidth);
//         // Set window width/height to state
//         setWindowSize(window.innerWidth);
//     }
//     useEffect(() => {
//         window.addEventListener('resize', handleResize);
//         handleResize();
//         return () => window.removeEventListener('resize', handleResize);
//     }, []); // Empty array ensures that effect is only run on mount
//     return windowSize;
// };

var useBreakpoint = function useBreakpoint() {
  var _useState = (0,react.useState)("lg"),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  (0,react.useEffect)(function () {
    var handleResize = function handleResize() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setBreakpoint("sm");
      } else {
        setBreakpoint("lg");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return breakpoint;
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanBenefit.tsx








var PlanBenefit = function PlanBenefit(_ref) {
  var _benefitData$label, _benefitData$label2, _benefitData$label3, _benefitData$label4, _benefitData$data, _benefitData$data$quo, _benefitData$data2, _benefitData$data3, _benefitData$data4;

  var benefitData = _ref.benefitData,
      quoteID1 = _ref.quoteID1,
      quoteID2 = _ref.quoteID2;
  var device = useBreakpoint();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitRow, {
    "data-test-id": "PlanBenefit-BenefitRow",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitCol1, {
      "data-test-id": "PlanBenefit-BenefitCol1",
      children: [(benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label = benefitData.label) === null || _benefitData$label === void 0 ? void 0 : _benefitData$label.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        src: benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label2 = benefitData.label) === null || _benefitData$label2 === void 0 ? void 0 : _benefitData$label2.icon,
        height: "20",
        width: "20",
        "data-test-id": "PlanBenefit-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        "data-test-id": "PlanBenefit-SpanTag",
        children: (benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label3 = benefitData.label) === null || _benefitData$label3 === void 0 ? void 0 : _benefitData$label3.text) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$label4 = benefitData.label) === null || _benefitData$label4 === void 0 ? void 0 : _benefitData$label4.text,
          "data-test-id": "PlanBenefit-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol2, {
      "data-test-id": "PlanBenefit-BenefitCol2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: device == "lg" ? "black" : "bold",
        color: benefitData !== null && benefitData !== void 0 && (_benefitData$data = benefitData.data) !== null && _benefitData$data !== void 0 && (_benefitData$data$quo = _benefitData$data[quoteID1]) !== null && _benefitData$data$quo !== void 0 && _benefitData$data$quo.text ? Global/* theme.blackText */.rS.blackText : Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "PlanBenefit-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: (benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$data2 = benefitData.data) === null || _benefitData$data2 === void 0 ? void 0 : _benefitData$data2[quoteID1]) || "NA",
          "data-test-id": "PlanBenefit-FormattedText"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol3, {
      "data-test-id": "PlanBenefit-BenefitCol3",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: device == "lg" ? "black" : "bold",
        color: benefitData !== null && benefitData !== void 0 && (_benefitData$data3 = benefitData.data) !== null && _benefitData$data3 !== void 0 && _benefitData$data3[quoteID2] ? Global/* theme.blackText */.rS.blackText : Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "PlanBenefit-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: (benefitData === null || benefitData === void 0 ? void 0 : (_benefitData$data4 = benefitData.data) === null || _benefitData$data4 === void 0 ? void 0 : _benefitData$data4[quoteID2]) || "NA",
          "data-test-id": "PlanBenefit-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ var ComparePlan_PlanBenefit = (PlanBenefit);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanTable.tsx










var PlanTable = function PlanTable(_ref) {
  var _data$header, _data$header2, _data$header3, _data$header4;

  var data = _ref.data,
      quoteID1 = _ref.quoteID1,
      quoteID2 = _ref.quoteID2;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.header) && /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitRow, {
      lastRow: true,
      "data-test-id": "PlanTable-BenefitRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol1, {
        "data-test-id": "PlanTable-BenefitCol1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol2, {
        firstRow: true,
        "data-test-id": "PlanTable-BenefitCol2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: Global/* theme.purpleTxt */.rS.purpleTxt,
          "data-test-id": "PlanTable-SpanTag",
          children: (data === null || data === void 0 ? void 0 : (_data$header = data.header) === null || _data$header === void 0 ? void 0 : _data$header[quoteID1]) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data === null || data === void 0 ? void 0 : (_data$header2 = data.header) === null || _data$header2 === void 0 ? void 0 : _data$header2[quoteID1],
            "data-test-id": "PlanTable-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol3, {
        firstRow: true,
        "data-test-id": "PlanTable-BenefitCol3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: Global/* theme.berryTxt */.rS.berryTxt,
          "data-test-id": "PlanTable-SpanTag",
          children: (data === null || data === void 0 ? void 0 : (_data$header3 = data.header) === null || _data$header3 === void 0 ? void 0 : _data$header3[quoteID2]) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data === null || data === void 0 ? void 0 : (_data$header4 = data.header) === null || _data$header4 === void 0 ? void 0 : _data$header4[quoteID2],
            "data-test-id": "PlanTable-FormattedText"
          })
        })
      })]
    }), (data === null || data === void 0 ? void 0 : data.body) && (data === null || data === void 0 ? void 0 : data.body.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: item.type == "benefit" ? /*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_PlanBenefit, {
          benefitData: item,
          quoteID1: quoteID1,
          quoteID2: quoteID2,
          "data-test-id": `PlanTable-PlanBenefit-${index}`
        }, index) : /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitDescHeader, {
          "data-test-id": "PlanTable-BenefitDescHeader",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol1, {
            "data-test-id": "PlanTable-BenefitCol1",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontSize: "xs",
              color: device == "lg" ? Global/* theme.blackText */.rS.blackText : Global/* theme.greyText7 */.rS.greyText7,
              fontWeight: device == "lg" ? "black" : "bold",
              textTransform: device == "sm" ? "uppercase" : undefined,
              "data-test-id": "PlanTable-SpanTag",
              children: item.label.text
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol2, {
            "data-test-id": "PlanTable-BenefitCol2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol3, {
            "data-test-id": "PlanTable-BenefitCol3"
          })]
        })
      });
    }))]
  });
};

/* harmony default export */ var ComparePlan_PlanTable = (PlanTable);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanTableFooter.tsx







var PlanTableFooter = function PlanTableFooter(_ref) {
  var _footerData$data, _footerData$data$quot, _footerData$data2, _footerData$data2$quo, _footerData$data3, _footerData$data3$quo, _footerData$data4, _footerData$data4$quo;

  var btn1Handler = _ref.btn1Handler,
      btn2Handler = _ref.btn2Handler,
      footerData = _ref.footerData,
      quoteID1 = _ref.quoteID1,
      quoteID2 = _ref.quoteID2;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitRow, {
    lastRow: true,
    "data-test-id": "PlanTableFooter-BenefitRow",
    children: [footerData && /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol1, {
      "data-test-id": "PlanTableFooter-BenefitCol1",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        "data-test-id": "PlanTableFooter-SpanTag",
        children: (footerData === null || footerData === void 0 ? void 0 : footerData.label) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: footerData === null || footerData === void 0 ? void 0 : footerData.label,
          "data-test-id": "PlanTableFooter-FormattedText"
        })
      })
    }), footerData && /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitCol2, {
      lastRow: true,
      "data-test-id": "PlanTableFooter-BenefitCol2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        "data-test-id": "PlanTableFooter-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          "data-test-id": "PlanTableFooter-SpanTag",
          children: (footerData === null || footerData === void 0 ? void 0 : (_footerData$data = footerData.data) === null || _footerData$data === void 0 ? void 0 : (_footerData$data$quot = _footerData$data[quoteID1]) === null || _footerData$data$quot === void 0 ? void 0 : _footerData$data$quot.label) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: footerData === null || footerData === void 0 ? void 0 : (_footerData$data2 = footerData.data) === null || _footerData$data2 === void 0 ? void 0 : (_footerData$data2$quo = _footerData$data2[quoteID1]) === null || _footerData$data2$quo === void 0 ? void 0 : _footerData$data2$quo.label,
            "data-test-id": "PlanTableFooter-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        onClick: btn1Handler,
        customTitle: device == "lg" ? "BUY PLAN" : "BUY",
        customWidth: "100%",
        "data-test-id": "PlanTableFooter-LandingButton"
      })]
    }), footerData && /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitCol3, {
      lastRow: true,
      "data-test-id": "PlanTableFooter-BenefitCol3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        "data-test-id": "PlanTableFooter-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          "data-test-id": "PlanTableFooter-SpanTag",
          children: (footerData === null || footerData === void 0 ? void 0 : (_footerData$data3 = footerData.data) === null || _footerData$data3 === void 0 ? void 0 : (_footerData$data3$quo = _footerData$data3[quoteID2]) === null || _footerData$data3$quo === void 0 ? void 0 : _footerData$data3$quo.label) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: footerData === null || footerData === void 0 ? void 0 : (_footerData$data4 = footerData.data) === null || _footerData$data4 === void 0 ? void 0 : (_footerData$data4$quo = _footerData$data4[quoteID2]) === null || _footerData$data4$quo === void 0 ? void 0 : _footerData$data4$quo.label,
            "data-test-id": "PlanTableFooter-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        onClick: btn2Handler,
        customTitle: device == "lg" ? "BUY PLAN" : "BUY",
        customWidth: "100%",
        "data-test-id": "PlanTableFooter-LandingButton"
      })]
    })]
  });
};

/* harmony default export */ var ComparePlan_PlanTableFooter = (PlanTableFooter);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.tsx







var ComparePlan = function ComparePlan(_ref) {
  var handleClose = _ref.handleClose,
      modalTitle = _ref.modalTitle,
      data = _ref.data,
      handleBuyButton = _ref.handleBuyButton,
      productId1ForCompare = _ref.productId1ForCompare,
      quoteId1ForCompare = _ref.quoteId1ForCompare,
      productId2ForCompare = _ref.productId2ForCompare,
      quoteId2ForCompare = _ref.quoteId2ForCompare;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    customWidth: "524px",
    customTitle: modalTitle,
    handleClick: handleClose,
    "data-test-id": "ComparePlan-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_PlanTable, {
      data: data,
      quoteID1: quoteId1ForCompare,
      quoteID2: quoteId2ForCompare,
      "data-test-id": "ComparePlan-PlanTable"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_PlanTableFooter, {
      btn1Handler: function btn1Handler() {
        return handleBuyButton(quoteId1ForCompare, productId1ForCompare);
      },
      btn2Handler: function btn2Handler() {
        return handleBuyButton(quoteId2ForCompare, productId2ForCompare);
      },
      footerData: data === null || data === void 0 ? void 0 : data.footer,
      quoteID1: quoteId1ForCompare,
      quoteID2: quoteId2ForCompare,
      "data-test-id": "ComparePlan-PlanTableFooter"
    })]
  });
};

/* harmony default export */ var ComparePlan_ComparePlan = (ComparePlan);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.style.ts


var InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryCodeInputstyle__InputWrap",
  componentId: "sc-18gzilo-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:900;font-size:14px;line-height:16px;color:#4a4a4a;display:block;margin-bottom:8px;transition:all 0.3s ease;display:inline-block;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
});
var ErrorTxt = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "CountryCodeInputstyle__ErrorTxt",
  componentId: "sc-18gzilo-1"
})(["color:#eb2026;"]);
var LandingInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "CountryCodeInputstyle__LandingInputStyle",
  componentId: "sc-18gzilo-2"
})(["background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;padding:10px 10px 10px 64px;font-weight:900;font-size:14px;line-height:19px;display:block;&::placeholder{font-weight:400;}&:focus + label{color:#008cff;}", " ", " ", " &:focus{outline:none;border:1px solid #008cff;background:#f9fcff;}&[type=\"number\"]::-webkit-outer-spin-button,&[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=\"number\"]{-moz-appearance:textfield;}"], function (props) {
  return props.disableState && "\n      opacity: 0.3;\n      pointer-events: none;\n\t";
}, function (props) {
  return props.errorState && "\n      border: 1px solid #EB2026;\n\t";
}, function (props) {
  return props.Verify && "\n      color: #008CFF;\n      background: #F9FCFF;\n      border: 1px solid #008CFF;\n      pointer-events: none;\n\t";
});
var CounryCodeWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryCodeInputstyle__CounryCodeWrap",
  componentId: "sc-18gzilo-3"
})(["display:flex;align-items:center;gap:8px;position:absolute;left:16px;top:39px;z-index:1;cursor:pointer;&:after{content:\"\";position:absolute;top:5px;right:-13px;border:solid #008cff;border-width:0 2px 2px 0;display:inline-block;padding:3px;transform:rotate(45deg);-webkit-transform:rotate(45deg);}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.tsx







var CountryCodeInput = function CountryCodeInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      Verify = _ref.Verify,
      flex = _ref.flex,
      requiredField = _ref.requiredField,
      handleKeyDown = _ref.handleKeyDown,
      maxInputLength = _ref.maxInputLength,
      inputType = _ref.inputType,
      handleCountryCodeModal = _ref.handleCountryCodeModal,
      countryCode = _ref.countryCode,
      countryFlag = _ref.countryFlag,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "on" : _ref$autoComplete;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputWrap, {
    margin: margin,
    flex: flex,
    inputWidth: inputWidth,
    Verify: Verify,
    "data-test-id": "CountryCodeInput-InputWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CounryCodeWrap, {
      onClick: handleCountryCodeModal,
      "data-test-id": "CountryCodeInput-CounryCodeWrap",
      children: [countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        src: countryFlag,
        "data-test-id": "CountryCodeInput-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "black",
        "data-test-id": "CountryCodeInput-SpanTag",
        children: countryCode
      })]
    }), labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: labelTxt,
      "data-test-id": "CountryCodeInput-label",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "CountryCodeInput-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInputStyle, {
      onChange: handleChange,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      errorState: errorState,
      id: labelTxt,
      disableState: disableState,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      autoComplete: autoComplete,
      "data-test-id": "CountryCodeInput-LandingInputStyle"
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTxt, {
      txtfontSize: "xs",
      margin: "4px 0 0",
      color: Global/* theme.redText */.rS.redText,
      txtfontWeight: "bold",
      "data-test-id": "CountryCodeInput-ErrorTxt",
      children: errorState
    })]
  });
};

/* harmony default export */ var CountryCodeInput_CountryCodeInput = (CountryCodeInput);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(6700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isAfter/index.js


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js + 9 modules
var en_US = __webpack_require__(8811);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 18 modules
var esm_format = __webpack_require__(7755);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/endOfMonth/index.js


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isSameYear/index.js


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = (0,toInteger/* default */.Z)(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfYear/index.js


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var cleanDate = (0,toDate/* default */.Z)(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(8187);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isSameMonth/index.js


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(8667);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfWeek/index.js




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(3761);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isSameDay/index.js


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(6913);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarDays/index.js



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays_differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isDate/index.js
var isDate = __webpack_require__(2968);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addWeeks/index.js



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  var days = amount * 7;
  return (0,addDays/* default */.Z)(dirtyDate, days);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addMonths/* default */.Z)(dirtyDate, amount * 12);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/endOfWeek/index.js




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/endOfISOWeek/index.js


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6893);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/max/index.js



/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,esm_typeof/* default */.Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/min/index.js



/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dirtyDatesArray) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if ((0,esm_typeof/* default */.Z)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,toDate/* default */.Z)(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getTime/index.js


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getUnixTime/index.js


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(getTime(dirtyDate) / 1000);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfWeekYear/index.js





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, options);
  var startOfWeekRight = startOfWeek(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfWeekRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getWeeksInMonth/index.js




/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date), startOfMonth(date), options) + 1;
}
;// CONCATENATED MODULE: ../../node_modules/react-day-picker/dist/index.esm.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return (0,esm_format/* default */.Z)(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return (0,esm_format/* default */.Z)(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return (0,esm_format/* default */.Z)(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return (0,esm_format/* default */.Z)(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return (0,esm_format/* default */.Z)(year, 'yyyy', options);
}

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return (0,esm_format/* default */.Z)(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return (0,esm_format/* default */.Z)(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale = en_US/* default */.Z;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? startOfDay(fromDate) : undefined,
        toDate: toDate ? startOfDay(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = (0,react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (react.createElement(DayPickerContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = (0,react.useContext)(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (react.createElement("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id }, formatCaption(props.displayMonth, { locale: locale })));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (react.createElement("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props),
        react.createElement("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (react.createElement("div", { className: className, style: style },
        react.createElement("span", { className: dayPicker.classNames.vhidden }, props['aria-label']),
        react.createElement("select", { name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange }, children),
        react.createElement("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true" },
            caption,
            react.createElement(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon }))));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return react.createElement(react.Fragment, null);
    if (!toDate)
        return react.createElement(react.Fragment, null);
    var dropdownMonths = [];
    if (isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = setMonth(startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (react.createElement(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }) }, dropdownMonths.map(function (m) { return (react.createElement("option", { key: m.getMonth(), value: m.getMonth() }, formatMonthCaption(m, { locale: locale }))); })));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return react.createElement(react.Fragment, null);
    if (!toDate)
        return react.createElement(react.Fragment, null);
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(setYear(startOfYear(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = setYear(startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (react.createElement(DropdownComponent, { name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }) }, years.map(function (year) { return (react.createElement("option", { key: year.getFullYear(), value: year.getFullYear() }, formatYearCaption(year, { locale: locale }))); })));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = (0,react.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0,addMonths/* default */.Z)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = startOfMonth(month);
    var end = startOfMonth((0,addMonths/* default */.Z)(start, numberOfMonths));
    var monthsDiff = differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = (0,addMonths/* default */.Z)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!toDate) {
        return (0,addMonths/* default */.Z)(month, offset);
    }
    var monthsDiff = differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return (0,addMonths/* default */.Z)(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = startOfMonth(startingMonth);
    if (!fromDate) {
        return (0,addMonths/* default */.Z)(month, -offset);
    }
    var monthsDiff = differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return (0,addMonths/* default */.Z)(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && isBefore(date, refDate)) {
            goToMonth((0,addMonths/* default */.Z)(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (react.createElement(NavigationContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = (0,react.useContext)(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(newMonth);
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (react.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (react.createElement("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns },
        react.createElement("div", { className: classNames.vhidden }, captionLabel),
        react.createElement(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }),
        react.createElement(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (react.createElement("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props),
        react.createElement("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (react.createElement("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props),
        react.createElement("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" })));
}

/** Render a button HTML element applying the reset class name. */
var Button = (0,react.forwardRef)(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (react.createElement("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return react.createElement(react.Fragment, null);
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (react.createElement("div", { className: classNames.nav, style: styles.nav },
        !props.hidePrevious && (react.createElement(Button, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick }, dir === 'rtl' ? (react.createElement(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (react.createElement(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })))),
        !props.hideNext && (react.createElement(Button, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick }, dir === 'rtl' ? (react.createElement(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (react.createElement(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon }))))));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (react.createElement(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (react.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (react.createElement(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (react.createElement(react.Fragment, null,
            react.createElement(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }),
            react.createElement(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })));
    }
    else {
        caption = (react.createElement(react.Fragment, null,
            react.createElement(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }),
            react.createElement(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })));
    }
    return (react.createElement("div", { className: classNames.caption, style: styles.caption }, caption));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return react.createElement(react.Fragment, null);
    return (react.createElement("tfoot", { className: tfoot, style: styles.tfoot },
        react.createElement("tr", null,
            react.createElement("td", { colSpan: 8 }, footer))));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? startOfISOWeek(new Date())
        : startOfWeek(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = (0,addDays/* default */.Z)(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (react.createElement("tr", { style: styles.head_row, className: classNames.head_row },
        showWeekNumber && (react.createElement("td", { style: styles.head_cell, className: classNames.head_cell })),
        weekdays.map(function (weekday, i) { return (react.createElement("th", { key: i, scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }) }, formatWeekdayName(weekday, { locale: locale }))); })));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (react.createElement("thead", { style: styles.head, className: classNames.head },
        react.createElement(HeadRowComponent, null)));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return react.createElement(react.Fragment, null, formatDay(props.date, { locale: locale }));
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (react.createElement(SelectMultipleContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (react.createElement(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (react.createElement(SelectMultipleContext.Provider, { value: contextValue }, children));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = (0,react.useContext)(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (!from) {
        return { from: day, to: undefined };
    }
    if (!to && isSameDay(from, day)) {
        return { from: from, to: day };
    }
    if (!to && isBefore(day, from)) {
        return { from: day, to: from };
    }
    if (!to) {
        return { from: from, to: day };
    }
    if (isSameDay(to, day) && isSameDay(from, day)) {
        return undefined;
    }
    if (isSameDay(to, day)) {
        return { from: to, to: undefined };
    }
    if (isSameDay(from, day)) {
        return undefined;
    }
    if (isAfter(from, day)) {
        return { from: day, to: to };
    }
    return { from: from, to: day };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (react.createElement(SelectRangeContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (react.createElement(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: (0,subDays/* default */.Z)(selectedFrom, min - 1),
                before: (0,addDays/* default */.Z)(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: (0,addDays/* default */.Z)(selectedFrom, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0,addDays/* default */.Z)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0,addDays/* default */.Z)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = differenceInCalendarDays_differenceInCalendarDays(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0,subDays/* default */.Z)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0,addDays/* default */.Z)(selectedTo, offset)
            });
        }
    }
    return (react.createElement(SelectRangeContext.Provider, { value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers } }, children));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = (0,react.useContext)(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
var InternalModifier;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));

var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = (0,react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (react.createElement(ModifiersContext.Provider, { value: modifiers }, props.children));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = (0,react.useContext)(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (!from) {
        return false;
    }
    if (!to && isSameDay(from, date)) {
        return true;
    }
    if (!to) {
        return false;
    }
    var isRangeInverted = differenceInCalendarDays_differenceInCalendarDays(to, from) < 0;
    if (isRangeInverted) {
        _a = [to, from], from = _a[0], to = _a[1];
    }
    var isInRange = differenceInCalendarDays_differenceInCalendarDays(date, from) >= 0 &&
        differenceInCalendarDays_differenceInCalendarDays(to, date) >= 0;
    return isInRange;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return (0,isDate/* default */.Z)(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(isDate/* default */.Z);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = differenceInCalendarDays_differenceInCalendarDays(matcher.before, day);
            var diffAfter = differenceInCalendarDays_differenceInCalendarDays(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return differenceInCalendarDays_differenceInCalendarDays(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return differenceInCalendarDays_differenceInCalendarDays(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = startOfMonth(displayMonths[0]);
    var lastDayInMonth = endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0,addDays/* default */.Z)(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = (0,addDays/* default */.Z)(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: addDays/* default */.Z,
        week: addWeeks,
        month: addMonths/* default */.Z,
        year: addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? startOfISOWeek(date)
                : startOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? endOfISOWeek(date)
                : endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = (0,react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = (0,react.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0,react.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (react.createElement(FocusContext.Provider, { value: value }, props.children));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = (0,react.useContext)(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = (0,react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (react.createElement(SelectSingleContext.Provider, { value: emptyContextValue }, props.children));
    }
    return (react.createElement(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (react.createElement(SelectSingleContext.Provider, { value: contextValue }, children));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = (0,react.useContext)(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    (0,react.useEffect)(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (react.createElement(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = (0,react.useRef)(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return react.createElement("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return react.createElement("div", __assign({}, dayRender.divProps));
    }
    return react.createElement(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (react.createElement("span", { className: classNames.weeknumber, style: styles.weeknumber }, content));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (react.createElement(Button, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick }, content));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (react.createElement("td", { className: classNames.cell, style: styles.cell },
            react.createElement(WeeknumberComponent, { number: props.weekNumber, dates: props.dates })));
    }
    return (react.createElement("tr", { className: classNames.row, style: styles.row },
        weekNumberCell,
        props.dates.map(function (date) { return (react.createElement("td", { className: classNames.cell, style: styles.cell, key: getUnixTime(date), role: "presentation" },
            react.createElement(DayComponent, { displayMonth: props.displayMonth, date: date }))); })));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? endOfISOWeek(toDate)
        : endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? startOfISOWeek(fromDate)
        : startOfWeek(fromDate, options);
    var nOfDays = differenceInCalendarDays_differenceInCalendarDays(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push((0,addDays/* default */.Z)(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? getISOWeek(date)
            : getWeek(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(startOfMonth(month), endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function index_esm_Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (react.createElement("table", { className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'] },
        !hideHead && react.createElement(HeadComponent, null),
        react.createElement("tbody", { className: classNames.tbody, style: styles.tbody, role: "rowgroup" }, weeks.map(function (week) { return (react.createElement(RowComponent, { displayMonth: props.displayMonth, key: week.weekNumber, dates: week.dates, weekNumber: week.weekNumber })); })),
        react.createElement(FooterComponent, { displayMonth: props.displayMonth })));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM()
    ? react.useLayoutEffect
    : react.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = react.useState(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (react.createElement("div", { key: props.displayIndex, className: className.join(' '), style: style },
        react.createElement(CaptionComponent, { id: captionId, displayMonth: props.displayMonth }),
        react.createElement(index_esm_Table, { "aria-labelledby": captionId, displayMonth: props.displayMonth })));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _b = (0,react.useState)(false), hasInitialFocus = _b[0], setHasInitialFocus = _b[1];
    // Focus the focus target when initialFocus is passed in
    (0,react.useEffect)(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    return (react.createElement("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id }, dataAttributes),
        react.createElement("div", { className: dayPicker.classNames.months, style: dayPicker.styles.months }, navigation.displayMonths.map(function (month, i) { return (react.createElement(Month, { key: i, displayIndex: i, displayMonth: month })); }))));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (react.createElement(DayPickerProvider, { initialProps: initialProps },
        react.createElement(NavigationProvider, null,
            react.createElement(SelectSingleProvider, { initialProps: initialProps },
                react.createElement(SelectMultipleProvider, { initialProps: initialProps },
                    react.createElement(SelectRangeProvider, { initialProps: initialProps },
                        react.createElement(ModifiersProvider, null,
                            react.createElement(FocusProvider, null, children))))))));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function DayPicker(props) {
    return (react.createElement(RootProvider, __assign({}, props),
        react.createElement(Root, { initialProps: props })));
}

/** @private */
function isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale = _a === void 0 ? enUS : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return parse(value, format$1, today, { locale: locale }); };
    // Initialize states
    var _e = useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? format(defaultSelected, format$1, { locale: locale })
        : '';
    var _g = useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? format(date, format$1, { locale: locale }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? format(day, format$1, { locale: locale }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && differenceInCalendarDays(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: format(new Date(), format$1, { locale: locale })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DatePickerComp/DatePickerComp.tsx









var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var DatePickerComp = function DatePickerComp(_ref) {
  var startDateLabel = _ref.startDateLabel,
      endDateLabel = _ref.endDateLabel,
      from = _ref.from,
      to = _ref.to,
      maxEndDate = _ref.maxEndDate,
      dateTab = _ref.dateTab,
      handleDateTab = _ref.handleDateTab,
      handleDayClick = _ref.handleDayClick,
      selected = _ref.selected,
      showToast = _ref.showToast,
      toastMessage = _ref.toastMessage;

  var weekDayNameFormatter = function weekDayNameFormatter(date) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "data-test-id": "DatePickerComp-weekDayNameFormatter",
      children: date.toDateString()[0]
    });
  };

  var monthNameFormatter = function monthNameFormatter(date) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      "data-test-id": "DatePickerComp-monthNameFormatter",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
        "data-test-id": "DatePickerComp-monthNameFormatter-b",
        children: MONTHS[date.getMonth()]
      }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: date.getFullYear().toString().slice(-2)
      })]
    });
  };

  var disabledDays = function disabledDays(date) {
    return isBefore(startOfDay(date), startOfDay(new Date())) || !!(maxEndDate && isAfter(date, maxEndDate));
  };

  var _useState = (0,react.useState)(new Date()),
      currentMonth = _useState[0],
      setCurrentMonth = _useState[1];

  (0,react.useEffect)(function () {
    if (from && to) {
      setCurrentMonth(from);
    }
  }, [from, to]);

  var handleMonthChange = function handleMonthChange(month) {
    setCurrentMonth(month);
  };

  var toastRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (showToast && toastRef.current) {
      window.scrollTo({
        top: toastRef.current.offsetTop - 100,
        behavior: "smooth"
      });
    }
  }, [showToast]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DatePickerWrap, {
    id: "datePickerContainer",
    "data-test-id": "DatePickerComp-DatePickerWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateTab, {
      "data-test-id": "DatePickerComp-DateTab",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DateTabList, {
        onClick: function onClick() {
          return handleDateTab === null || handleDateTab === void 0 ? void 0 : handleDateTab(0);
        },
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: startDateLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateLabel, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "sm",
            fontWeight: dateTab == 0 ? "bold" : "regular",
            color: dateTab == 0 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: from ? (0,static_utils/* calendarLabelFormatter */.IZ)(from) : "Select"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateTabList, {
        "data-test-id": "DatePickerComp-DateTabList",
        children: "-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DateTabList, {
        onClick: function onClick() {
          return handleDateTab === null || handleDateTab === void 0 ? void 0 : handleDateTab(1);
        },
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: endDateLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateLabel, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontWeight: dateTab == 1 ? "bold" : "regular",
            fontSize: "sm",
            color: dateTab == 1 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: to ? (0,static_utils/* calendarLabelFormatter */.IZ)(to) : "Select"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DayPicker, {
      mode: "range",
      numberOfMonths: 2,
      selected: selected,
      disabled: disabledDays,
      onDayClick: handleDayClick,
      formatters: {
        formatWeekdayName: weekDayNameFormatter,
        formatCaption: monthNameFormatter
      },
      month: currentMonth,
      onMonthChange: handleMonthChange,
      "data-test-id": "DatePickerComp-DayPicker"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorToast, {
      ref: toastRef,
      "data-test-id": "DatePickerComp-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "DatePickerComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: toastMessage,
          "data-test-id": "DatePickerComp-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ var DatePickerComp_DatePickerComp = (DatePickerComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ArrowRight.tsx



var ArrowRight = function ArrowRight(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "ArrowRight",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 6.86518L21 6.86182L1 6.86518Z",
      fill: "#008CFF"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1 6.86518L21 6.86182",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.8595 13L20.2086 7.65621C20.5731 7.29196 20.5731 6.70132 20.2075 6.33707L14.8595 1",
      stroke: "#008CFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })]
  });
};

/* harmony default export */ var icons_ArrowRight = (ArrowRight);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.style.ts




var DesktopLayoutStyleSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSectionWrap",
  componentId: "ylfaze-0"
})(["position:relative;padding-top:6px;img,picture{flex-shrink:0;}&:after{position:fixed;width:100%;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/blue_Grad_Bg_563cf7d36a.png\");background-repeat:no-repeat;background-size:cover;content:\"\";top:0;left:0;height:87%;z-index:1;}", " @media ", "{padding-top:0px;&:after{height:0;background:transparent;background-image:none;}}"], function (p) {
  return p.pageTheme === src.PARTNER.MMT && p.landingPageProp ? "\n        &:after {\n        background:transparent;\n        }\n        ".concat(LandingButton_style/* LandingButtonStyle */.zm, "{\n            border-radius:38px;\n        }\n") : p.pageTheme === src.PARTNER.GI && p.landingPageProp ? "\n    &:after {\n    background:transparent;\n    }\n    ".concat(LandingButton_style/* LandingButtonStyle */.zm, "{\n        border-radius:30px;\n    }\n") : "";
}, static_utils/* deviceType.mobile */.vO.mobile);
var DesktopLayoutStyleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSection",
  componentId: "ylfaze-1"
})(["width:", ";margin:0 auto;display:flex;gap:", ";height:100%;z-index:3;position:relative;justify-content:space-between;align-items:", ";flex-direction:", ";margin-bottom:", ";background:", ";", " @media ", "{background:#f2f2f2;width:100%;gap:24px;padding:56px 16px 0;margin-top:0;border-radius:0px;background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/mob_Bg_76aceb3f35.png\");background-repeat:no-repeat;background-size:contain;flex-direction:column;", "}"], function (p) {
  return p.landingMargin ? "1200px" : "1230px";
}, function (p) {
  return p.landingMargin ? "88px" : "58px";
}, function (p) {
  return p.alignCenter ? "flex-start" : "baseline";
}, function (p) {
  return p.flexDirection ? "column" : "row";
}, function (p) {
  return p.landingMargin ? "70px" : "";
}, function (p) {
  return p.landingMargin ? "#fff" : "transparent";
}, function (p) {
  return p.pageTheme === src.PARTNER.MMT && p.landingMargin ? "\n            padding:68px 40px 40px;\n            border-radius:10px;\n            margin-top:26px;\n" : p.pageTheme === src.PARTNER.GI && p.landingMargin ? "\n            padding:38px 40px 40px;\n            border-radius:10px;\n            margin-top:26px;\n" : "";
}, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.landingMargin && "\n            padding-bottom: 238px;\n            margin-bottom: -236px ;\n        ";
});
var DesktopLayoutBotttomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutBotttomSection",
  componentId: "ylfaze-2"
})(["margin-top:20px;display:flex;gap:80px;height:100%;z-index:2;position:relative;align-items:flex-start;flex-direction:column;@media ", "{gap:56px;z-index:3;}"], static_utils/* deviceType.mobile */.vO.mobile);
var DesktopLayoutLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutLeftSection",
  componentId: "ylfaze-3"
})(["display:flex;flex-direction:column;align-self:flex-start;padding-top:", ";gap:32px;margin:", ";height:", ";flex:1;margin-left:", ";position:sticky;top:155px;width:498px;", " @media ", "{margin-left:0;margin-top:11px;padding-top:0;height:unset;gap:10px;position:static;width:100%;}"], function (p) {
  return p.leftSectionHeight ? "" : "0px";
}, function (p) {
  return p.leftSectionMargin ? p.leftSectionMargin : "";
}, function (p) {
  return p.leftSectionHeight ? "100%" : "calc(708px - 130px)";
}, function (p) {
  return p.leftSectionHeight ? "" : "15px";
}, function (p) {
  return p.pageTheme === src.PARTNER.MMT && p.leftSectionHeight ? "\n            margin-top:40px;\n" : p.pageTheme === src.PARTNER.GI ? "\n            margin-top:40px;\n" : "";
}, static_utils/* deviceType.mobile */.vO.mobile);
var DesktopLayoutRightSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutRightSection",
  componentId: "ylfaze-4"
})(["width:", ";flex-shrink:0;padding-bottom:", ";display:flex;flex-direction:column;z-index:1;gap:16px;padding:", ";margin-right:", ";min-height:490px;&::-webkit-scrollbar{display:none;}@media ", "{width:100%;overflow-y:unset;padding:0;margin-right:0;height:unset;", "}"], function (p) {
  return p.rightSectionHeight ? "592px" : "622px";
}, function (p) {
  return p.rightSectionHeight ? "" : "40px";
}, function (p) {
  return p.rightSectionHeight ? "" : "56px 30px 0";
}, function (p) {
  return p.rightSectionHeight ? "" : "-15px";
}, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return !p.rightSectionHeight && "\n        margin-right: -16px;\n        margin-left: -16px;\n        width: -webkit-fill-available;\n        overflow-y: scroll;\n        flex-shrink:unset;\n        ";
});
var DesktopLayoutHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutHeading",
  componentId: "ylfaze-5"
})(["display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.tsx










var DesktopLayout = function DesktopLayout(_ref) {
  var title = _ref.title,
      leftComp = _ref.leftComp,
      rightComp = _ref.rightComp,
      bottomComp = _ref.bottomComp,
      headingComp = _ref.headingComp,
      height = _ref.height,
      alignCenter = _ref.alignCenter,
      leftSectionMargin = _ref.leftSectionMargin,
      rightSectionHeight = _ref.rightSectionHeight,
      leftSectionHeight = _ref.leftSectionHeight,
      landingMargin = _ref.landingMargin,
      subTitle = _ref.subTitle,
      shimmer = _ref.shimmer,
      landingPageProp = _ref.landingPageProp,
      goToMyOrders = _ref.goToMyOrders;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)(); // console.log(context);

  var _useState = (0,react.useState)(undefined),
      windowHeight = _useState[0],
      setWindowHeight = _useState[1];

  (0,react.useEffect)(function () {
    var handleResize = function handleResize() {
      setWindowHeight(window.innerHeight);
    };

    if (true) {
      setWindowHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSectionWrap, {
    id: "pageId",
    height: height,
    pageTheme: context ? context : undefined,
    landingPageProp: landingPageProp,
    "data-test-id": "DesktopLayout-DesktopLayoutStyleSectionWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSection, {
      landingMargin: landingMargin,
      alignCenter: alignCenter,
      pageTheme: context ? context : undefined,
      "data-test-id": "DesktopLayout-DesktopLayoutStyleSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutLeftSection, {
        leftSectionHeight: leftSectionHeight,
        leftSectionMargin: leftSectionMargin,
        pageTheme: context ? context : undefined,
        "data-test-id": "DesktopLayout-DesktopLayoutLeftSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: shimmer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            flexDirection: "column",
            gap: "4px",
            "data-test-id": "DesktopLayout-FlexComp",
            children: [subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
              width: "375px",
              height: "38px",
              "data-test-id": "DesktopLayout-Shimmer"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
              width: "100%",
              height: "56px",
              "data-test-id": "DesktopLayout-Shimmer"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [subTitle && (device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              margin: device == "lg" ? "40px 0 0" : "",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: "md",
              fontWeight: "black",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-ParaTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
              "data-test-id": "DesktopLayout-H2Tag",
              children: title ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              }) : null
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              "data-test-id": "DesktopLayout-H4Tag",
              children: title ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              }) : null
            })]
          })
        }), leftComp]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutRightSection, {
        rightSectionHeight: rightSectionHeight,
        "data-test-id": "DesktopLayout-DesktopLayoutRightSection",
        children: [context && landingPageProp && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignSelf: "flex-end",
          isCursorPointer: true,
          gap: "4px",
          alignItems: "center",
          margin: "0 0 8px",
          "data-test-id": "DesktopLayout-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            fontWeight: "bold",
            handleClick: goToMyOrders,
            "data-test-id": "DesktopLayout-AnchorTag",
            children: "My Orders"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(icons_ArrowRight, {
            width: 16,
            height: 16,
            "data-test-id": "DesktopLayout-ArrowRight"
          })]
        }), rightComp]
      })]
    }), bottomComp && /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopLayoutBotttomSection, {
      "data-test-id": "DesktopLayout-DesktopLayoutBotttomSection",
      children: bottomComp
    })]
  });
};

/* harmony default export */ var DesktopLayout_DesktopLayout = (DesktopLayout);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global_theme = {
  blackText: "#000",
  blackText3: "#022135",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#2B825E",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "rgba(255, 255, 255, 0.8)",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenNeonText3: "#5EE8BA",
  blueText2: "#F6FAFF",
  darkGreen2: "#227055",
  greenBg: "rgba(43, 130, 94, 0.5)"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.style.ts


var DnldPolicyComponentStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DnldPolicyComponentstyle__DnldPolicyComponentStyle",
  componentId: "sc-10opecw-0"
})(["border-radius:6px;background:#fff;padding:20px;@media ", "{padding:16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var TravNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DnldPolicyComponentstyle__TravNumber",
  componentId: "sc-10opecw-1"
})(["border-radius:100%;background:#f6f6f6;width:16px;height:16px;font-size:12px;font-weight:700;display:flex;justify-content:center;align-items:center;"]);
var PolicyItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DnldPolicyComponentstyle__PolicyItem",
  componentId: "sc-10opecw-2"
})(["display:flex;gap:18px;align-items:baseline;padding:12px 16px;border:1px solid #e2e2e2;border-top:none;", ""], function (p) {
  return p.firstChild && "border-top: 1px solid #e2e2e2;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.tsx







var DnldPolicyComponent = function DnldPolicyComponent(_ref) {
  var data = _ref.data,
      travellersInsured = _ref.travellersInsured;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DnldPolicyComponentStyle, {
    "data-test-id": "DnldPolicyComponent-DnldPolicyComponentStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "8px",
      alignItems: "center",
      margin: "0 0 24px",
      "data-test-id": "DnldPolicyComponent-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/people_Group_Icon_d97975a5cb.svg",
        "data-test-id": "DnldPolicyComponent-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "black",
        fontSize: "large",
        color: Global_theme.greyText,
        "data-test-id": "DnldPolicyComponent-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travellersInsured,
          "data-test-id": "DnldPolicyComponent-FormattedText"
        })
      })]
    }), data === null || data === void 0 ? void 0 : data.map(function (item, index) {
      var _item$Link;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(PolicyItem, {
        firstChild: index == 0,
        "data-test-id": `DnldPolicyComponent-PolicyItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravNumber, {
          "data-test-id": "DnldPolicyComponent-TravNumber",
          children: index + 1
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [item.Title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            "data-test-id": "DnldPolicyComponent-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.Title,
              "data-test-id": "DnldPolicyComponent-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: item.Description && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontSize: "xs",
              color: Global_theme.greyText7,
              "data-test-id": "DnldPolicyComponent-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.Description,
                "data-test-id": "DnldPolicyComponent-FormattedText"
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          margin: "0 0 0 auto",
          textTransform: "uppercase",
          fontWeight: "black",
          hrefProp: item === null || item === void 0 ? void 0 : (_item$Link = item.Link) === null || _item$Link === void 0 ? void 0 : _item$Link.DownloadUrl,
          download: true,
          targetProp: "_blank",
          "data-test-id": "DnldPolicyComponent-AnchorTag",
          children: "Download"
        })]
      }, index);
    })]
  });
};

/* harmony default export */ var DnldPolicyComponent_DnldPolicyComponent = (DnldPolicyComponent);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 2 modules
var navigation = __webpack_require__(2817);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTravelDetail.style.ts

var DomesticTripStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__DomesticTripStyle",
  componentId: "sc-813ho8-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:8px;"]);
var ContainerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__ContainerStyle",
  componentId: "sc-813ho8-1"
})(["display:flex;", ";", ";"], function (props) {
  return props.flexDirection && "flex-direction: ".concat(props.flexDirection);
}, function (props) {
  return props.gap && "gap: ".concat(props.gap);
});
var TagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__TagStyle",
  componentId: "sc-813ho8-2"
})(["color:#ffffff;padding:2px 8px 2px 8px;font-weight:600;font-size:10px;align-items:center;border-radius:8px 0px 8px 0px;", ";"], function (props) {
  var _props$startColor, _props$endColor;

  return "background: linear-gradient(45deg, ".concat((_props$startColor = props === null || props === void 0 ? void 0 : props.startColor) !== null && _props$startColor !== void 0 ? _props$startColor : "#00d2ff", " 14.64%, ").concat((_props$endColor = props === null || props === void 0 ? void 0 : props.endColor) !== null && _props$endColor !== void 0 ? _props$endColor : "#3a7bd5", " 85.36%)");
});
var DomesticTravelDetail_style_ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__ArrowButtonWrap",
  componentId: "sc-813ho8-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var BannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__BannerStyle",
  componentId: "sc-813ho8-4"
})(["display:flex;background:#eaf5ff;padding:8px 15px 12px 16px;border-radius:0px 0px 8px 8px;gap:8px;font-size:14px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTrip.tsx


function DomesticTrip_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DomesticTrip_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DomesticTrip_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DomesticTrip_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var DomesticTrip_analytics = (0,insurance/* getAnalytics */.I)();

var DomesticTrip = function DomesticTrip(_ref) {
  var _tripData$tag, _tripData$tag2, _tripData$tag3, _tripData$banner;

  var trips = _ref.trips,
      title = _ref.title;
  (0,react.useEffect)(function () {
    DomesticTrip_analytics === null || DomesticTrip_analytics === void 0 ? void 0 : DomesticTrip_analytics.trackLandingEvents({
      actionType: "upcoming_domestic_trips_shown"
    });
  }, []);
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var tripData = trips === null || trips === void 0 ? void 0 : trips[0];

  var handleDomesticClick = function handleDomesticClick() {
    var _trips$;

    var searchParams = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(searchParams.entries());

    var params = DomesticTrip_objectSpread(DomesticTrip_objectSpread({}, queryParams), {}, {
      isUpcomingTrip: true,
      bookingId: trips === null || trips === void 0 ? void 0 : (_trips$ = trips[0]) === null || _trips$ === void 0 ? void 0 : _trips$.bookingId
    });

    DomesticTrip_analytics === null || DomesticTrip_analytics === void 0 ? void 0 : DomesticTrip_analytics.trackLandingEvents({
      actionType: "upcoming_domestic_trips_clicked"
    });
    navigation/* navigationActions.navigateToTravellerDetails */.e.navigateToTravellerDetails(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerStyle, {
    flexDirection: "column",
    gap: "10px",
    "data-test-id": "DomesticTrip-ContainerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
      value: title,
      baseStyle: {
        color: Global/* theme.blackText */.rS.blackText
      },
      "data-test-id": "DomesticTrip-FormattedText"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DomesticTripStyle, {
      "data-test-id": "DomesticTrip-DomesticTripStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
        "data-test-id": "DomesticTrip-ContainerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagStyle, {
          startColor: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag = tripData.tag) === null || _tripData$tag === void 0 ? void 0 : _tripData$tag.startColor,
          endColor: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag2 = tripData.tag) === null || _tripData$tag2 === void 0 ? void 0 : _tripData$tag2.endColor,
          "data-test-id": "DomesticTrip-TagStyle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: tripData === null || tripData === void 0 ? void 0 : (_tripData$tag3 = tripData.tag) === null || _tripData$tag3 === void 0 ? void 0 : _tripData$tag3.title,
            "data-test-id": "DomesticTrip-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 15px 12px 16px",
        handleClick: handleDomesticClick,
        "data-test-id": "DomesticTrip-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          "data-test-id": "DomesticTrip-SpanTag",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: tripData === null || tripData === void 0 ? void 0 : tripData.description,
            baseStyle: {
              color: "#4A4A4A",
              fontWeight: "400px",
              fontSize: "12px"
            },
            "data-test-id": "DomesticTrip-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            margin: "7px 0px 0px 0px",
            isCursorPointer: true,
            "data-test-id": "DomesticTrip-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "32px",
              height: "32px",
              margin: "0px 8px 0px 0px",
              src: tripData === null || tripData === void 0 ? void 0 : tripData.image,
              "data-test-id": "DomesticTrip-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: tripData === null || tripData === void 0 ? void 0 : tripData.title,
                baseStyle: {
                  color: "#000000",
                  fontWeight: "700",
                  fontSize: "14px"
                },
                "data-test-id": "DomesticTrip-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
                "data-test-id": "DomesticTrip-ContainerStyle",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: tripData === null || tripData === void 0 ? void 0 : tripData.subtitle,
                  baseStyle: {
                    color: "#4A4A4A",
                    fontWeight: "400",
                    fontSize: "12px"
                  },
                  "data-test-id": "DomesticTrip-FormattedText"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DomesticTravelDetail_style_ArrowButtonWrap, {
          "data-test-id": "DomesticTrip-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "9px",
            height: "9px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
            "data-test-id": "DomesticTrip-ImageComponent"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerStyle, {
        "data-test-id": "DomesticTrip-BannerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: tripData === null || tripData === void 0 ? void 0 : (_tripData$banner = tripData.banner) === null || _tripData$banner === void 0 ? void 0 : _tripData$banner.description,
          "data-test-id": "DomesticTrip-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var DomesticTravelDetail_DomesticTrip = (DomesticTrip);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTraveller.style.ts

var EditTraveller_style_AccordianCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__AccordianCompStyle",
  componentId: "sc-1wc3syu-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
var EditTraveller_style_GenderTypeItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__GenderTypeItem",
  componentId: "sc-1wc3syu-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:5px 12px;cursor:pointer;", ""], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n    border-radius: 6px;\n";
});
var EditTravelSheetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__EditTravelSheetStyle",
  componentId: "sc-1wc3syu-2"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#f2f2f2;overflow-y:scroll;"]);
var BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__BtnWrap",
  componentId: "sc-1wc3syu-3"
})(["background:#fff;padding:8px 16px;position:fixed;bottom:0;left:0;right:0;"]);
var TravllerNum = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__TravllerNum",
  componentId: "sc-1wc3syu-4"
})(["border-radius:18px;background:#f6f6f6;width:20px;height:20px;display:flex;justify-content:center;align-items:center;font-size:12px;font-weight:700;flex-shrink:0;"]);
var EditTravllerItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__EditTravllerItem",
  componentId: "sc-1wc3syu-5"
})(["border-bottom:1px solid #e2e2e2;padding:12px 16px;background:#fff;"]);
var EditTraveller_style_TravellerAddShimmer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EditTravellerstyle__TravellerAddShimmer",
  componentId: "sc-1wc3syu-6"
})(["padding:24px 30px;border-top:1px solid #e8e8e8;display:flex;justify-content:space-between;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTraveller.tsx














var EditTraveller_minDate = "1970-01-01";
var EditTraveller_maxDate = new Date().toISOString().split("T")[0];

var EditTraveller = function EditTraveller(_ref) {
  var _name$isRequired, _dob$isRequired, _passport$isRequired, _gender$isRequired;

  var index = _ref.index,
      title = _ref.title,
      refId = _ref.refId,
      fullName = _ref.fullName,
      dobValue = _ref.dobValue,
      passportValue = _ref.passportValue,
      genderValue = _ref.genderValue,
      travellerDetails = _ref.travellerDetails,
      travellerAttributes = _ref.travellerAttributes,
      goBackTxt = _ref.goBackTxt,
      updateContactTxt = _ref.updateContactTxt,
      handleUpdateDetails = _ref.handleUpdateDetails,
      handleClose = _ref.handleClose;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = (0,react.useState)(),
      editError = _useState2[0],
      setEditError = _useState2[1];

  var _ref2 = travellerAttributes || {},
      name = _ref2.name,
      dob = _ref2.dob,
      passport = _ref2.passport,
      gender = _ref2.gender;

  var _useForm = useForm({
    defaultValues: {
      name: fullName || "",
      dob: dobValue || "",
      passport: passportValue || "",
      gender: genderValue || ""
    },
    mode: "onTouched"
  }),
      control = _useForm.control,
      errors = _useForm.formState.errors,
      setValue = _useForm.setValue,
      setError = _useForm.setError,
      handleSubmit = _useForm.handleSubmit;

  var handleGenderChange = function handleGenderChange(value) {
    if (value) {
      setValue("gender", value);
    }
  };

  var handleServerErrors = function handleServerErrors(error) {
    var _ref3 = (error === null || error === void 0 ? void 0 : error.validationError) || {},
        _ref3$displaySecondar = _ref3.displaySecondaryError,
        displaySecondaryError = _ref3$displaySecondar === void 0 ? [] : _ref3$displaySecondar;

    displaySecondaryError.map(function (item) {
      var travellerId = item.travellerId;

      if (travellerId === refId) {
        var _item$displayError = item === null || item === void 0 ? void 0 : item.displayError,
            _name = _item$displayError.name,
            _dob = _item$displayError.dob,
            _passport = _item$displayError.passport;

        if (_name) {
          setError("name", {
            message: _name
          });
        }

        if (_dob) {
          setError("dob", {
            message: _dob
          });
        }

        if (_passport) {
          setError("passport", {
            message: _passport
          });
        }
      }
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(formData) {
      var travellerData, queryParams, bookingId, partner, response, responseStatus, error, _err$response, _err$response$data, _Error, _error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              travellerData = travellerDetails.map(function (item, i) {
                var _formData$name;

                var refId = item.refId,
                    name = item.name,
                    dob = item.dob,
                    passport = item.passport,
                    gender = item.gender;
                return {
                  refId: refId,
                  FullName: i === index ? (_formData$name = formData.name) === null || _formData$name === void 0 ? void 0 : _formData$name.trim() : name,
                  Dob: i === index ? formData.dob : dob,
                  Gender: i === index ? formData.gender : gender,
                  PassportNo: i === index ? formData.passport : passport
                };
              });
              queryParams = new URLSearchParams(window.location.search);
              bookingId = queryParams.get("bookingId");
              partner = (0,utils/* getPartnerOnClientSide */.et)();
              setIsLoading(true);
              _context.next = 8;
              return (0,api/* editInsuranceDetails */.oe)({
                partner: partner,
                bookingID: bookingId,
                data: travellerData
              });

            case 8:
              response = _context.sent;
              responseStatus = response.responseStatus;

              if (!(responseStatus === src.RESPONSE_STATUS.SUCCESS)) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return handleUpdateDetails(formData);

            case 13:
              _context.next = 19;
              break;

            case 15:
              error = response.Error;

              if (error) {
                _context.next = 18;
                break;
              }

              throw new Error("Something went wrong");

            case 18:
              handleServerErrors(error);

            case 19:
              setIsLoading(false);
              _context.next = 28;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](0);
              console.log("ERROR IN UPDATING TRAVELLER DETAILS----", {
                err: _context.t0
              });
              setIsLoading(false);
              _err$response$data = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data, _Error = _err$response$data.Error, _error = _err$response$data.error;

              if (_Error && (_Error === null || _Error === void 0 ? void 0 : _Error.code) === src.ERROR_CODES.DISPLAY_ERROR) {
                handleServerErrors(_Error);
              } else {
                setEditError(_error);
              }

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 22]]);
    }));

    return function onSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  if (editError && true) {
    throw new utility_src/* ClientError */.XF(editError);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    customTitle: title,
    handleClick: handleClose,
    "data-test-id": "EditTraveller-CommonModalDweb",
    children: [(name === null || name === void 0 ? void 0 : name.isEnabled) && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
      control: control,
      name: "name",
      rules: {
        required: {
          value: (_name$isRequired = name === null || name === void 0 ? void 0 : name.isRequired) !== null && _name$isRequired !== void 0 ? _name$isRequired : true,
          message: (0,utils/* getFormFieldErrorMsg */.YV)("name")
        },
        pattern: {
          value: new RegExp((name === null || name === void 0 ? void 0 : name.regex) || ""),
          message: (0,utils/* getFormFieldErrorMsg */.YV)("name", name === null || name === void 0 ? void 0 : name.errorMessage)
        }
      },
      render: function render(_ref5) {
        var _errors$name;

        var _ref5$field = _ref5.field,
            value = _ref5$field.value,
            onChange = _ref5$field.onChange,
            onBlur = _ref5$field.onBlur;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
          requiredField: name === null || name === void 0 ? void 0 : name.isRequired,
          placeholderTxt: name === null || name === void 0 ? void 0 : name.placeholder,
          labelTxt: name === null || name === void 0 ? void 0 : name.title,
          inputValue: value,
          errorState: (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
          disableState: isLoading,
          handleChange: onChange,
          handleBlur: onBlur,
          inputWidth: "100%",
          margin: "0 0 16px",
          "data-test-id": "EditTraveller-LandingInput"
        });
      },
      "data-test-id": "EditTraveller-Controller"
    }), (dob === null || dob === void 0 ? void 0 : dob.isEnabled) && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
      control: control,
      name: "dob",
      rules: {
        required: {
          value: (_dob$isRequired = dob === null || dob === void 0 ? void 0 : dob.isRequired) !== null && _dob$isRequired !== void 0 ? _dob$isRequired : true,
          message: (0,utils/* getFormFieldErrorMsg */.YV)("dob")
        },
        validate: function validate(value) {
          return (0,utils/* isDobValid */.qP)(value || "", dob === null || dob === void 0 ? void 0 : dob.regex) || (0,utils/* getFormFieldErrorMsg */.YV)("dob", dob === null || dob === void 0 ? void 0 : dob.errorMessage);
        }
      },
      render: function render(_ref6) {
        var _errors$dob;

        var _ref6$field = _ref6.field,
            value = _ref6$field.value,
            onChange = _ref6$field.onChange,
            onBlur = _ref6$field.onBlur;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
          requiredField: dob === null || dob === void 0 ? void 0 : dob.isRequired,
          placeholderTxt: " ",
          labelTxt: dob === null || dob === void 0 ? void 0 : dob.title,
          inputType: "date",
          inputValue: value,
          minValue: EditTraveller_minDate,
          maxValue: EditTraveller_maxDate,
          errorState: (_errors$dob = errors.dob) === null || _errors$dob === void 0 ? void 0 : _errors$dob.message,
          disableState: isLoading,
          handleChange: onChange,
          handleBlur: onBlur,
          inputWidth: "100%",
          margin: "0 0 16px",
          "data-test-id": "EditTraveller-LandingInput"
        });
      },
      "data-test-id": "EditTraveller-Controller"
    }), (passport === null || passport === void 0 ? void 0 : passport.isEnabled) && /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
      control: control,
      name: "passport",
      rules: {
        required: {
          value: (_passport$isRequired = passport === null || passport === void 0 ? void 0 : passport.isRequired) !== null && _passport$isRequired !== void 0 ? _passport$isRequired : true,
          message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
        },
        pattern: {
          value: new RegExp((passport === null || passport === void 0 ? void 0 : passport.regex) || ""),
          message: (0,utils/* getFormFieldErrorMsg */.YV)("passport", passport === null || passport === void 0 ? void 0 : passport.errorMessage)
        }
      },
      render: function render(_ref7) {
        var _errors$passport;

        var _ref7$field = _ref7.field,
            value = _ref7$field.value,
            onChange = _ref7$field.onChange,
            onBlur = _ref7$field.onBlur;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
          requiredField: passport === null || passport === void 0 ? void 0 : passport.isRequired,
          placeholderTxt: passport === null || passport === void 0 ? void 0 : passport.placeholder,
          labelTxt: passport === null || passport === void 0 ? void 0 : passport.title,
          inputValue: value,
          errorState: (_errors$passport = errors.passport) === null || _errors$passport === void 0 ? void 0 : _errors$passport.message,
          disableState: isLoading,
          handleChange: onChange,
          handleBlur: onBlur,
          inputWidth: "100%",
          margin: "0 0 16px",
          "data-test-id": "EditTraveller-LandingInput"
        });
      },
      "data-test-id": "EditTraveller-Controller"
    }), (gender === null || gender === void 0 ? void 0 : gender.isEnabled) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        margin: "0 0 8px",
        fontSize: "md",
        fontWeight: "bold",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "EditTraveller-SpanTag",
        children: "Gender"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        gap: "8px",
        "data-test-id": "EditTraveller-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
          control: control,
          name: "gender",
          rules: {
            required: {
              value: (_gender$isRequired = gender === null || gender === void 0 ? void 0 : gender.isRequired) !== null && _gender$isRequired !== void 0 ? _gender$isRequired : true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("gender")
            }
          },
          render: function render(_ref8) {
            var _gender$values;

            var value = _ref8.field.value;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: gender === null || gender === void 0 ? void 0 : (_gender$values = gender.values) === null || _gender$values === void 0 ? void 0 : _gender$values.map(function (item, index) {
                var _item$label, _item$label2, _item$label3;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(EditTraveller_style_GenderTypeItem, {
                  selected: ((_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()),
                  onClick: function onClick() {
                    handleGenderChange(item.label);
                  },
                  "data-test-id": "EditTraveller-GenderTypeItem",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButton_RadioButton, {
                    activeBtn: ((_item$label2 = item.label) === null || _item$label2 === void 0 ? void 0 : _item$label2.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()),
                    "data-test-id": "EditTraveller-RadioButton",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                      fontSize: "xs",
                      fontWeight: "bold",
                      color: ((_item$label3 = item.label) === null || _item$label3 === void 0 ? void 0 : _item$label3.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()) ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
                      "data-test-id": "EditTraveller-SpanTag",
                      children: item.label
                    })
                  })
                }, item.id);
              })
            });
          },
          "data-test-id": "EditTraveller-Controller"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "32px 0 0",
      gap: "10px",
      "data-test-id": "EditTraveller-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        onClick: handleSubmit(onSubmit),
        customWidth: "210px",
        customTitle: updateContactTxt,
        isLoading: isLoading,
        "data-test-id": "EditTraveller-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        handleClick: handleClose,
        fontSize: "md",
        fontWeight: "bold",
        textTransform: "uppercase",
        "data-test-id": "EditTraveller-AnchorTag",
        children: goBackTxt
      })]
    })]
  });
};

/* harmony default export */ var EditTraveller_EditTraveller = (EditTraveller);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTravellerSheet.tsx













var EditTravellerSheet_minDate = "1970-01-01";
var EditTravellerSheet_maxDate = new Date().toISOString().split("T")[0];

var EditTravellerSheet = function EditTravellerSheet(_ref) {
  var handleClose = _ref.handleClose,
      travellerData = _ref.travellerData,
      editTraveller = _ref.editTraveller,
      updateOrderDetails = _ref.updateOrderDetails;

  var _useState = (0,react.useState)(-1),
      editTravller = _useState[0],
      setEditTraveller = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isError = _useState3[0],
      setIsError = _useState3[1];

  var travellers = travellerData.map(function (item, i) {
    var refId = item.refId,
        name = item.name,
        dob = item.dob,
        passport = item.passport,
        gender = item.gender;
    return {
      refId: refId,
      FullName: name,
      Dob: dob,
      Gender: gender,
      PassportNo: passport
    };
  });

  var _useState4 = (0,react.useState)(_toConsumableArray(travellers)),
      travellerDataState = _useState4[0],
      setTravellerDataState = _useState4[1];

  var emptyErrorList = travellerData.map(function () {
    return {
      nameError: "",
      dobError: "",
      passportError: ""
    };
  });

  var _useState5 = (0,react.useState)(_toConsumableArray(emptyErrorList)),
      errorMessages = _useState5[0],
      setErrorMessages = _useState5[1];

  var handleEditTravller = function handleEditTravller(index) {
    setEditTraveller(index);
  };

  var handleServerErrors = function handleServerErrors(error) {
    setIsError(true);

    var _ref2 = (error === null || error === void 0 ? void 0 : error.validationError) || {},
        _ref2$displaySecondar = _ref2.displaySecondaryError,
        displaySecondaryError = _ref2$displaySecondar === void 0 ? [] : _ref2$displaySecondar;

    displaySecondaryError.map(function (item, index) {
      var _item$displayError = item === null || item === void 0 ? void 0 : item.displayError,
          name = _item$displayError.name,
          dob = _item$displayError.dob,
          passport = _item$displayError.passport;

      if (name) {
        var updatedErrorMessages = _toConsumableArray(errorMessages);

        updatedErrorMessages[index].nameError = name;
        setErrorMessages(updatedErrorMessages);
        setEditTraveller(index);
      }

      if (dob) {
        var _updatedErrorMessages = _toConsumableArray(errorMessages);

        _updatedErrorMessages[index].dobError = dob;
        setErrorMessages(_updatedErrorMessages);
        setEditTraveller(index);
      }

      if (passport) {
        var _updatedErrorMessages2 = _toConsumableArray(errorMessages);

        _updatedErrorMessages2[index].passportError = passport;
        setErrorMessages(_updatedErrorMessages2);
        setEditTraveller(index);
      }
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var queryParams, bookingId, partner, response, responseStatus, error, _err$response, _err$response$data, _Error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              queryParams = new URLSearchParams(window.location.search);
              bookingId = queryParams.get("bookingId");
              partner = (0,utils/* getPartnerOnClientSide */.et)();
              setIsLoading(true);
              _context.next = 7;
              return (0,api/* editInsuranceDetails */.oe)({
                partner: partner,
                bookingID: bookingId,
                data: travellerDataState
              });

            case 7:
              response = _context.sent;
              responseStatus = response.responseStatus;

              if (!(responseStatus === src.RESPONSE_STATUS.SUCCESS)) {
                _context.next = 14;
                break;
              }

              _context.next = 12;
              return updateOrderDetails === null || updateOrderDetails === void 0 ? void 0 : updateOrderDetails();

            case 12:
              _context.next = 18;
              break;

            case 14:
              error = response.Error;

              if (error) {
                _context.next = 17;
                break;
              }

              throw new Error("Something went wrong");

            case 17:
              handleServerErrors(error);

            case 18:
              setEditTraveller(-1);
              _context.next = 26;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              console.log("ERROR IN UPDATING TRAVELLER DETAILS----", {
                err: _context.t0
              });
              _err$response$data = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data, _Error = _err$response$data.Error;

              if (_Error && (_Error === null || _Error === void 0 ? void 0 : _Error.code) === src.ERROR_CODES.DISPLAY_ERROR) {
                handleServerErrors(_Error);
              }

            case 26:
              setIsLoading(false);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));

    return function onSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onNameChange = function onNameChange(updatedName, index) {
    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].FullName = updatedName;
    setTravellerDataState(updatedTravellerDataState);
    validateName(updatedName, index);
  };

  var validateName = function validateName(updatedName, index) {
    var _editTraveller$travel, _editTraveller$travel2, _editTraveller$travel3;

    var isNameValid = (0,utils/* isFieldValid */.K0)((_editTraveller$travel = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel2 = editTraveller.travellerAttributes) === null || _editTraveller$travel2 === void 0 ? void 0 : (_editTraveller$travel3 = _editTraveller$travel2.name) === null || _editTraveller$travel3 === void 0 ? void 0 : _editTraveller$travel3.regex) !== null && _editTraveller$travel !== void 0 ? _editTraveller$travel : "", updatedName);

    if (!isNameValid) {
      var _editTraveller$travel4, _editTraveller$travel5, _editTraveller$travel6;

      setIsError(true);

      var updatedErrorMessages = _toConsumableArray(errorMessages);

      updatedErrorMessages[index].nameError = (_editTraveller$travel4 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel5 = editTraveller.travellerAttributes) === null || _editTraveller$travel5 === void 0 ? void 0 : (_editTraveller$travel6 = _editTraveller$travel5.name) === null || _editTraveller$travel6 === void 0 ? void 0 : _editTraveller$travel6.errorMessage) !== null && _editTraveller$travel4 !== void 0 ? _editTraveller$travel4 : "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages(_toConsumableArray(emptyErrorList));
    }
  };

  var onPassportChange = function onPassportChange(updatedPassport, index) {
    var _updatedPassport$trim;

    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].PassportNo = updatedPassport === null || updatedPassport === void 0 ? void 0 : (_updatedPassport$trim = updatedPassport.trim) === null || _updatedPassport$trim === void 0 ? void 0 : _updatedPassport$trim.call(updatedPassport);
    setTravellerDataState(updatedTravellerDataState);
    validatePassport(updatedPassport, index);
  };

  var validatePassport = function validatePassport(updatedPassport, index) {
    var _editTraveller$travel7, _editTraveller$travel8, _editTraveller$travel9;

    var isPassportValid = (0,utils/* isFieldValid */.K0)((_editTraveller$travel7 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel8 = editTraveller.travellerAttributes) === null || _editTraveller$travel8 === void 0 ? void 0 : (_editTraveller$travel9 = _editTraveller$travel8.passport) === null || _editTraveller$travel9 === void 0 ? void 0 : _editTraveller$travel9.regex) !== null && _editTraveller$travel7 !== void 0 ? _editTraveller$travel7 : "", updatedPassport);

    if (!isPassportValid) {
      var _editTraveller$travel10, _editTraveller$travel11, _editTraveller$travel12;

      setIsError(true);

      var updatedErrorMessages = _toConsumableArray(errorMessages);

      updatedErrorMessages[index].passportError = (_editTraveller$travel10 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel11 = editTraveller.travellerAttributes) === null || _editTraveller$travel11 === void 0 ? void 0 : (_editTraveller$travel12 = _editTraveller$travel11.passport) === null || _editTraveller$travel12 === void 0 ? void 0 : _editTraveller$travel12.errorMessage) !== null && _editTraveller$travel10 !== void 0 ? _editTraveller$travel10 : "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages(_toConsumableArray(emptyErrorList));
    }
  };

  var onDobChange = function onDobChange(updatedDob, index) {
    var _updatedDob$trim;

    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].Dob = updatedDob === null || updatedDob === void 0 ? void 0 : (_updatedDob$trim = updatedDob.trim) === null || _updatedDob$trim === void 0 ? void 0 : _updatedDob$trim.call(updatedDob);
    setTravellerDataState(updatedTravellerDataState);
    validateDob(updatedDob, index);
  };

  var validateDob = function validateDob(updatedDob, index) {
    var _editTraveller$travel13, _editTraveller$travel14, _editTraveller$travel15;

    var isDobValid = (0,utils/* isFieldValid */.K0)((_editTraveller$travel13 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel14 = editTraveller.travellerAttributes) === null || _editTraveller$travel14 === void 0 ? void 0 : (_editTraveller$travel15 = _editTraveller$travel14.dob) === null || _editTraveller$travel15 === void 0 ? void 0 : _editTraveller$travel15.regex) !== null && _editTraveller$travel13 !== void 0 ? _editTraveller$travel13 : "", (0,utils/* formatDate */.p6)(updatedDob, src.DATE_FORMATS["DD/MM/YYYY"]));

    if (!isDobValid) {
      var _editTraveller$travel16, _editTraveller$travel17, _editTraveller$travel18;

      setIsError(true);

      var updatedErrorMessages = _toConsumableArray(errorMessages);

      updatedErrorMessages[index].dobError = (_editTraveller$travel16 = editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel17 = editTraveller.travellerAttributes) === null || _editTraveller$travel17 === void 0 ? void 0 : (_editTraveller$travel18 = _editTraveller$travel17.dob) === null || _editTraveller$travel18 === void 0 ? void 0 : _editTraveller$travel18.errorMessage) !== null && _editTraveller$travel16 !== void 0 ? _editTraveller$travel16 : "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages(_toConsumableArray(emptyErrorList));
    }
  };

  var onGenderChange = function onGenderChange(updatedGender, index) {
    var _updatedGender$trim;

    var updatedTravellerDataState = _toConsumableArray(travellerDataState);

    updatedTravellerDataState[index].Gender = updatedGender === null || updatedGender === void 0 ? void 0 : (_updatedGender$trim = updatedGender.trim) === null || _updatedGender$trim === void 0 ? void 0 : _updatedGender$trim.call(updatedGender);
    setTravellerDataState(updatedTravellerDataState);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_ReactPortalComp, {
    "data-test-id": "EditTravellerSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravelSheetStyle, {
      "data-test-id": "EditTravellerSheet-EditTravelSheetStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeader_LandingHeaderMobile, {
        displayWhiteHeader: true,
        headerTitle: "Edit Traveller Details",
        handleBackBtn: handleClose,
        "data-test-id": "EditTravellerSheet-LandingHeaderMobile"
      }), travellerDataState === null || travellerDataState === void 0 ? void 0 : travellerDataState.map(function (item, index) {
        var _errorMessages$index, _errorMessages$index2, _editTraveller$travel19, _editTraveller$travel20, _editTraveller$travel21, _errorMessages$index3;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EditTravllerItem, {
            "data-test-id": `EditTravellerSheet-EditTravllerItem-${index}`,
            children: [editTravller != index && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              justifyContent: "space-between",
              "data-test-id": "EditTravellerSheet-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                gap: "10px",
                "data-test-id": "EditTravellerSheet-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravllerNum, {
                  "data-test-id": "EditTravellerSheet-TravllerNum",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: "".concat(index + 1),
                    "data-test-id": "EditTravellerSheet-FormattedText"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                    fontWeight: "bold",
                    "data-test-id": "EditTravellerSheet-ParaTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                      value: item.FullName,
                      "data-test-id": "EditTravellerSheet-FormattedText"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                      fontSize: "xs",
                      color: Global/* theme.greyText */.rS.greyText,
                      "data-test-id": "EditTravellerSheet-SpanTag",
                      children: (item === null || item === void 0 ? void 0 : item.Dob) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                        value: (0,utils/* formatDate */.p6)(item.Dob, src.DATE_FORMATS["DD/MM/YYYY"]),
                        "data-test-id": "EditTravellerSheet-FormattedText"
                      })
                    }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                      fontSize: "xs",
                      color: Global/* theme.greyText */.rS.greyText,
                      "data-test-id": "EditTravellerSheet-SpanTag",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                        value: item.Gender,
                        "data-test-id": "EditTravellerSheet-FormattedText"
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
                textTransform: "uppercase",
                fontSize: "xs",
                fontWeight: "bold",
                handleClick: function handleClick() {
                  return handleEditTravller(index);
                },
                "data-test-id": "EditTravellerSheet-AnchorTag",
                children: "Edit"
              })]
            }), editTravller == index && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
                margin: "0 0 18px",
                fontWeight: "bold",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "EditTravellerSheet-ParaTag",
                children: ["Traveller ", index + 1]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                flex: "1",
                requiredField: true,
                placeholderTxt: "FULL NAME",
                labelTxt: "FULL NAME",
                inputValue: item.FullName,
                errorState: errorMessages === null || errorMessages === void 0 ? void 0 : (_errorMessages$index = errorMessages[index]) === null || _errorMessages$index === void 0 ? void 0 : _errorMessages$index.nameError // disableState={isLoading}
                ,
                handleChange: function handleChange(event) {
                  return onNameChange(event.target.value, index);
                },
                handleBlur: function handleBlur(event) {
                  validateName(event.target.value, index);
                },
                autoComplete: "off",
                margin: "0 0 8px",
                "data-test-id": "EditTravellerSheet-LandingInput"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                flex: "1",
                placeholderTxt: "Date of birth",
                requiredField: true,
                labelTxt: "Date of birth",
                inputType: "date",
                inputValue: item.Dob,
                minValue: EditTravellerSheet_minDate,
                maxValue: EditTravellerSheet_maxDate,
                errorState: errorMessages === null || errorMessages === void 0 ? void 0 : (_errorMessages$index2 = errorMessages[index]) === null || _errorMessages$index2 === void 0 ? void 0 : _errorMessages$index2.dobError // disableState={isLoading}
                ,
                handleChange: function handleChange(event) {
                  onDobChange(event.target.value, index); // saveFormValuesOnBlur();
                },
                handleBlur: function handleBlur(event) {
                  validateDob(event.target.value, index);
                },
                margin: "0 0 8px",
                "data-test-id": "EditTravellerSheet-LandingInput"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                margin: "0 0 8px",
                fontSize: "md",
                fontWeight: "bold",
                color: Global/* theme.greyText */.rS.greyText,
                "data-test-id": "EditTravellerSheet-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: "Gender",
                  "data-test-id": "EditTravellerSheet-FormattedText"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
                gap: "8px",
                margin: "0 0 10px",
                "data-test-id": "EditTravellerSheet-FlexComp",
                children: editTraveller === null || editTraveller === void 0 ? void 0 : (_editTraveller$travel19 = editTraveller.travellerAttributes) === null || _editTraveller$travel19 === void 0 ? void 0 : (_editTraveller$travel20 = _editTraveller$travel19.gender) === null || _editTraveller$travel20 === void 0 ? void 0 : (_editTraveller$travel21 = _editTraveller$travel20.values) === null || _editTraveller$travel21 === void 0 ? void 0 : _editTraveller$travel21.map(function (gender) {
                  var _gender$label, _item$Gender, _gender$label2, _item$Gender2, _gender$label3, _item$Gender3;

                  return /*#__PURE__*/(0,jsx_runtime.jsx)(EditTraveller_style_GenderTypeItem, {
                    selected: ((_gender$label = gender.label) === null || _gender$label === void 0 ? void 0 : _gender$label.toLowerCase()) == ((_item$Gender = item.Gender) === null || _item$Gender === void 0 ? void 0 : _item$Gender.toLowerCase()),
                    onClick: function onClick() {
                      onGenderChange(gender.label, index); // saveFormValuesOnBlur();
                    },
                    "data-test-id": "EditTravellerSheet-GenderTypeItem",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButton_RadioButton, {
                      activeBtn: ((_gender$label2 = gender.label) === null || _gender$label2 === void 0 ? void 0 : _gender$label2.toLowerCase()) == ((_item$Gender2 = item.Gender) === null || _item$Gender2 === void 0 ? void 0 : _item$Gender2.toLowerCase()),
                      "data-test-id": "EditTravellerSheet-RadioButton",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                        fontSize: "xs",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        color: ((_gender$label3 = gender.label) === null || _gender$label3 === void 0 ? void 0 : _gender$label3.toLowerCase()) == ((_item$Gender3 = item.Gender) === null || _item$Gender3 === void 0 ? void 0 : _item$Gender3.toLowerCase()) ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
                        "data-test-id": "EditTravellerSheet-SpanTag",
                        children: gender.label
                      })
                    })
                  }, gender.id);
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                flex: "1",
                placeholderTxt: "PASSPORT NO.",
                labelTxt: "PASSPORT NO.",
                inputValue: item.PassportNo,
                errorState: errorMessages === null || errorMessages === void 0 ? void 0 : (_errorMessages$index3 = errorMessages[index]) === null || _errorMessages$index3 === void 0 ? void 0 : _errorMessages$index3.passportError // disableState={isLoading}
                ,
                handleChange: function handleChange(event) {
                  onPassportChange(event.target.value, index); // saveFormValuesOnBlur();
                },
                handleBlur: function handleBlur(event) {
                  validatePassport(event.target.value, index);
                },
                "data-test-id": "EditTravellerSheet-LandingInput"
              })]
            })]
          }, index)
        });
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
        "data-test-id": "EditTravellerSheet-BtnWrap",
        children: editTravller >= 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
          customTitle: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.updateNowBtnTxt,
          customWidth: "100%",
          onClick: onSubmit,
          isLoading: isLoading,
          disableState: isError,
          "data-test-id": "EditTravellerSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ var EditTraveller_EditTravellerSheet = (EditTravellerSheet);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/ExclusiveOffers.style.ts




var ExclusiveOffersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__ExclusiveOffersStyle",
  componentId: "fapl6g-0"
})(["width:100%;background:", ";position:relative;z-index:1;overflow:hidden;display:flex;", "{width:64%;}@media ", "{padding:0 16px;}"], Global/* theme.whiteText */.rS.whiteText, TextStyles_style/* H2TagStyle */.FI, static_utils/* deviceType.mobile */.vO.mobile);
var OfferItemStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ExclusiveOffersstyle__OfferItemStyle",
  componentId: "fapl6g-1"
})(["display:inline-block;background-color:", ";border-radius:8px;width:450px;height:220px;flex-shrink:0;overflow:hidden;@media ", "{width:286px;height:180px;border-radius:16px;", "}"], Global/* theme.whiteText */.rS.whiteText, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.singleItem && "\n      width: calc(100vw - 32px);\n      height: calc((100vw - 32px) / 1.5888888888888888);\n    ";
});
var OffersWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__OffersWrap",
  componentId: "fapl6g-2"
})(["display:flex;align-items:center;gap:20px;overflow-x:auto;margin-left:-16px;padding-left:16px;margin-right:-16px;padding-right:16px;"]);
var SliderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderWrap",
  componentId: "fapl6g-3"
})(["display:flex;padding-left:7px;padding-top:7px;"]);
var SlidesBtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SlidesBtnWrap",
  componentId: "fapl6g-4"
})(["box-shadow:0px 1px 7px 0px #00000033;background-color:", ";border-radius:100px;padding:4px 14px;width:72px;height:28px;display:flex;align-items:center;justify-content:space-between;"], Global/* theme.whiteText */.rS.whiteText);
var SliderArrowLeft = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowLeft",
  componentId: "fapl6g-5"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(135deg);-webkit-transform:rotate(135deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, function (p) {
  return p.disable && "opacity: 0.5;";
});
var SliderArrowRight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowRight",
  componentId: "fapl6g-6"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, function (p) {
  return p.disable && "opacity: 0.5;";
});
var SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderContainer",
  componentId: "fapl6g-7"
})(["overflow:hidden;width:100%;position:relative;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ImageTag/ImageTag.style.ts

var ImageTagStyle = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ImageTagstyle__ImageTagStyle",
  componentId: "sc-16jb4o3-0"
})(["display:inline-block;margin:", ";width:", ";", " flex-shrink:0;"], function (props) {
  return props.margin;
}, function (props) {
  return props.width;
}, function (props) {
  return props.showCursorPointer && " cursor: pointer;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ImageTag/ImageTag.tsx



var ImageTag = function ImageTag(_ref) {
  var src = _ref.src,
      width = _ref.width,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "image-tag" : _ref$alt,
      margin = _ref.margin,
      height = _ref.height,
      _ref$showCursorPointe = _ref.showCursorPointer,
      showCursorPointer = _ref$showCursorPointe === void 0 ? false : _ref$showCursorPointe;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTagStyle, {
    src: src,
    width: width,
    margin: margin,
    height: height,
    showCursorPointer: showCursorPointer,
    alt: alt,
    "data-test-id": "ImageTag-ImageTagStyle"
  });
};

/* harmony default export */ var ImageTag_ImageTag = (ImageTag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/OfferItem.tsx




var aspectRatio = (/* unused pure expression or super */ null && (286 / 180));

var OfferItem = function OfferItem(_ref) {
  var cta = _ref.cta,
      image_url = _ref.image_url,
      handleClickOfferItem = _ref.handleClickOfferItem,
      offerItemLength = _ref.offerItemLength;
  var device = useBreakpoint();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferItemStyle, {
    onClick: handleClickOfferItem,
    href: cta.url,
    rel: "noreferrer",
    target: "_blank",
    singleItem: offerItemLength == 1 && device == "sm",
    "data-test-id": "OfferItem-OfferItemStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag, {
      src: image_url,
      width: "100%",
      height: "100%",
      "data-test-id": "OfferItem-ImageTag"
    })
  });
};

/* harmony default export */ var ExculsiveOffers_OfferItem = (OfferItem);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/ExclusiveOffers.tsx










var ExclusiveOffers_analytics = (0,insurance/* getAnalytics */.I)();

var ExclusiveOffers = function ExclusiveOffers(_ref) {
  var data = _ref.data;
  var device = useBreakpoint();

  var _useState = (0,react.useState)(0),
      currentSlide = _useState[0],
      setCurrentSlide = _useState[1];

  var handleNext = function handleNext() {
    if (currentSlide < data.items.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  var handlePrev = function handlePrev() {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  (0,react.useEffect)(function () {
    data.items.forEach(function (item, index) {
      var element = document.getElementById("slide".concat(index));
      var observer = new IntersectionObserver(obCallback, {
        threshold: 1
      });
      element && observer.observe(element);

      function obCallback(entries) {
        if (entries[0].isIntersecting) {
          ExclusiveOffers_analytics === null || ExclusiveOffers_analytics === void 0 ? void 0 : ExclusiveOffers_analytics.trackLandingEvents({
            actionType: "offer_banner".concat(index + 1, "_shown")
          });
        }
      }
    });
  }, [data.items]);

  var _handleClickOfferItem = function handleClickOfferItem(index) {
    ExclusiveOffers_analytics === null || ExclusiveOffers_analytics === void 0 ? void 0 : ExclusiveOffers_analytics.trackLandingEvents({
      actionType: "offer_banner".concat(index + 1, "_clicked")
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExclusiveOffersStyle, {
    "data-test-id": "ExclusiveOffers-ExclusiveOffersStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "ExclusiveOffers-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        margin: "0 0 60px",
        alignItems: "center",
        justifyContent: "space-between",
        "data-test-id": "ExclusiveOffers-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
          "data-test-id": "ExclusiveOffers-H2Tag",
          children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data.title,
            "data-test-id": "ExclusiveOffers-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlidesBtnWrap, {
          "data-test-id": "ExclusiveOffers-SlidesBtnWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowLeft, {
            disable: currentSlide == 0,
            onClick: handlePrev,
            "data-test-id": "ExclusiveOffers-SliderArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowRight, {
            disable: currentSlide == data.items.length - 1,
            onClick: handleNext,
            "data-test-id": "ExclusiveOffers-SliderArrowRight"
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        margin: "0 0 20px",
        "data-test-id": "ExclusiveOffers-H5Tag",
        children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: data.title,
          "data-test-id": "ExclusiveOffers-FormattedText"
        })
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(OffersWrap, {
        "data-test-id": "ExclusiveOffers-OffersWrap",
        children: data.items && data.items.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: "slide".concat(index),
            "data-test-id": `ExclusiveOffers-${index}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
              handleClickOfferItem: function handleClickOfferItem() {
                return _handleClickOfferItem(index);
              },
              cta: item.cta,
              image_url: item.image_url,
              offerItemLength: data.items.length,
              "data-test-id": "ExclusiveOffers-OfferItem"
            })
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderContainer, {
        "data-test-id": "ExclusiveOffers-SliderContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrap, {
          style: {
            transform: "translateX(-".concat(currentSlide * 42, "%)"),
            transition: "transform 0.5s ease-in-out"
          },
          "data-test-id": "ExclusiveOffers-SliderWrap",
          children: data.items && data.items.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "slide".concat(index),
              style: {
                marginRight: 20
              },
              "data-test-id": `ExclusiveOffers-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
                handleClickOfferItem: function handleClickOfferItem() {
                  return _handleClickOfferItem(index);
                },
                cta: item.cta,
                image_url: item.image_url,
                "data-test-id": "ExclusiveOffers-OfferItem"
              })
            }, index);
          })
        })
      })]
    })
  });
};

/* harmony default export */ var ExculsiveOffers_ExclusiveOffers = (ExclusiveOffers);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.style.ts

var FilterBottomComp_style_FilterBottomCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterBottomCompStyle",
  componentId: "sc-1tibgkx-0"
})(["border-radius:6px;background:rgba(9,18,32,0.95);box-shadow:0px 0px 7px 0px rgba(0,0,0,0.43);position:fixed;bottom:16px;left:16px;right:16px;display:flex;align-items:center;z-index:3;overflow:hidden;max-height:68px;"]);
var FilterBottomComp_style_FilterLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterLeftSection",
  componentId: "sc-1tibgkx-1"
})(["display:flex;gap:6px;overflow-x:scroll;padding:8px;div{border-radius:4px;background:#202e3c;padding:6px;text-align:center;flex:1;}"]);
var FilterBottomComp_style_FilterRightSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterRightSection",
  componentId: "sc-1tibgkx-2"
})(["width:72px;height:68px;flex-shrink:0;background:#008cff;align-self:flex-end;display:flex;flex-direction:column;gap:6px;align-items:center;justify-content:center;margin-left:auto;position:relative;"]);
var FilterBottomComp_style_FilterNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterNumber",
  componentId: "sc-1tibgkx-3"
})(["width:14px;height:14px;border-radius:100%;background:#fff;color:#008cff;text-align:center;font-size:10px;font-weight:700;line-height:14px;position:absolute;top:8px;left:43px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.tsx







var FilterBottomComp = function FilterBottomComp(_ref) {
  var filtersList = _ref.filtersList,
      handleFilterClick = _ref.handleFilterClick;
  return /*#__PURE__*/_jsxs(FilterBottomCompStyle, {
    "data-test-id": "FilterBottomComp-FilterBottomCompStyle",
    children: [/*#__PURE__*/_jsx(FilterLeftSection, {
      "data-test-id": "FilterBottomComp-FilterLeftSection",
      children: filtersList === null || filtersList === void 0 ? void 0 : filtersList.map(function (item, index) {
        return /*#__PURE__*/_jsxs("div", {
          "data-test-id": "FilterBottomComp",
          children: [item.title && /*#__PURE__*/_jsx(ParaTag, {
            color: theme.whiteText,
            fontWeight: "bold",
            fontSize: "xs",
            "data-test-id": "FilterBottomComp-ParaTag",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.title,
              "data-test-id": "FilterBottomComp-FormattedText"
            })
          }), item.planInfoMob && /*#__PURE__*/_jsxs(SpanTag, {
            color: theme.whiteText,
            fontSize: "xs",
            "data-test-id": "FilterBottomComp-SpanTag",
            children: ["(", /*#__PURE__*/_jsx(FormattedText, {
              value: item.planInfoMob,
              "data-test-id": "FilterBottomComp-FormattedText"
            }), ")"]
          })]
        }, "".concat(index));
      })
    }), /*#__PURE__*/_jsxs(FilterRightSection, {
      onClick: handleFilterClick,
      "data-test-id": "FilterBottomComp-FilterRightSection",
      children: [/*#__PURE__*/_jsx(ImageComponent, {
        width: "28px",
        height: "28px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/filter_Icon_eab36b44ec.svg",
        "data-test-id": "FilterBottomComp-ImageComponent"
      }), /*#__PURE__*/_jsx(FilterNumber, {
        "data-test-id": "FilterBottomComp-FilterNumber",
        children: filtersList === null || filtersList === void 0 ? void 0 : filtersList.length
      }), /*#__PURE__*/_jsx(SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: theme.whiteText,
        "data-test-id": "FilterBottomComp-SpanTag",
        children: "Filter"
      })]
    })]
  });
};

/* harmony default export */ var FilterBottomComp_FilterBottomComp = ((/* unused pure expression or super */ null && (FilterBottomComp)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.style.ts

var FilterPlansStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "FilterPlansstyle__FilterPlansStyle",
  componentId: "sc-1psxbt6-0"
})(["position:relative;"]);
var PlanTypeStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__PlanTypeStyle",
  componentId: "sc-1psxbt6-1"
})(["background:#ffffff;padding:16px 0px;"]);
var FilterPlans_style_BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__BtnWrap",
  componentId: "sc-1psxbt6-2"
})(["padding:16px 30px;background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:0px 0px 20px 20px;position:sticky;bottom:-20px;margin:auto -30px -20px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/PlanTypeComp.tsx







var PlanTypeComp = function PlanTypeComp(_ref) {
  var title = _ref.title,
      data = _ref.data,
      tagData = _ref.tagData,
      handleClickTab = _ref.handleClickTab;

  var _useState = (0,react.useState)(data),
      planData = _useState[0],
      setPlanData = _useState[1];

  var planTypeHandler = function planTypeHandler(id) {
    setPlanData(planData === null || planData === void 0 ? void 0 : planData.map(function (item) {
      if (id === item.id) {
        item.isSelected = !item.isSelected;
      }

      return item;
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanTypeStyle, {
    "data-test-id": "PlanTypeComp-PlanTypeStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "md",
      fontWeight: "bold",
      color: Global/* theme.blackText */.rS.blackText,
      margin: "0 0 16px",
      "data-test-id": "PlanTypeComp-ParaTag",
      children: title
    }), tagData && /*#__PURE__*/(0,jsx_runtime.jsx)(Tags_Tags, {
      handleClickTab: handleClickTab,
      data: tagData,
      "data-test-id": "PlanTypeComp-Tags"
    }), data && data.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton_CheckButton // inputIndex={item.id}
      , {
        inputId: item.id,
        margin: index != data.length - 1 ? "0 0 16px" : "",
        isChecked: item.isSelected,
        handleChange: function handleChange() {
          return planTypeHandler(item.id);
        },
        "data-test-id": "PlanTypeComp-CheckButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          gap: "10px",
          justifyContent: "space-between",
          "data-test-id": "PlanTypeComp-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            gap: "0",
            flexDirection: "column",
            "data-test-id": "PlanTypeComp-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: "md",
              color: Global/* theme.blackText */.rS.blackText,
              margin: "0 0 4px",
              "data-test-id": "PlanTypeComp-ParaTag",
              children: item.planTitle
            }), item.planInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "PlanTypeComp-ParaTag",
              children: item.planInfo
            })]
          }), item.planIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "24px",
            height: "24px",
            src: item.planIcon,
            "data-test-id": "PlanTypeComp-ImageComponent"
          })]
        })
      });
    })]
  });
};

/* harmony default export */ var FilterPlans_PlanTypeComp = (PlanTypeComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.tsx







var FilterPlans = function FilterPlans(_ref) {
  var title = _ref.title,
      btnText = _ref.btnText,
      filterData = _ref.filterData,
      tagData = _ref.tagData,
      filterPlanHandleClick = _ref.filterPlanHandleClick;

  var _useState = (0,react.useState)(tagData),
      tabIndex = _useState[0],
      setTabIndex = _useState[1];

  var handleTabIndex = function handleTabIndex(id) {
    setTabIndex(tagData === null || tagData === void 0 ? void 0 : tagData.map(function (item) {
      if (id === item.id) {
        item.isSelected = true;
      } else item.isSelected = false;

      return item;
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    customTitle: title,
    handleClick: filterPlanHandleClick,
    "data-test-id": "FilterPlans-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      data: filterData === null || filterData === void 0 ? void 0 : filterData.popularData,
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
      small: true,
      "data-test-id": "FilterPlans-SectionDividers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      data: filterData === null || filterData === void 0 ? void 0 : filterData.planType,
      title: "Plan Type",
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
      small: true,
      "data-test-id": "FilterPlans-SectionDividers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      tagData: tagData,
      title: "Sum Insured Per Traveller",
      handleClickTab: handleTabIndex,
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
      small: true,
      "data-test-id": "FilterPlans-SectionDividers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      data: filterData === null || filterData === void 0 ? void 0 : filterData.benefits,
      title: "Benefits Included",
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_style_BtnWrap, {
      "data-test-id": "FilterPlans-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        customTitle: btnText,
        "data-test-id": "FilterPlans-LandingButton"
      })
    })]
  });
};

/* harmony default export */ var FilterPlans_FilterPlans = (FilterPlans);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoice.style.ts


var GreatChoiceStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "GreatChoicestyle__GreatChoiceStyle",
  componentId: "sc-1njux19-0"
})(["", ";", ";", ";"], function (props) {
  return props.background && "background: ".concat(props.background);
}, function (props) {
  return props.radius && "border-radius: ".concat(props.radius);
}, function (props) {
  return props.padding && "padding: ".concat(props.padding);
});
var ChoiceText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "GreatChoicestyle__ChoiceText",
  componentId: "sc-1njux19-1"
})(["position:relative;margin-top:16px;color:", ";"], Global/* theme.blackText */.rS.blackText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoice.tsx







var GreatChoice = function GreatChoice(_ref) {
  var title = _ref.title,
      info = _ref.info,
      icon = _ref.icon,
      background = _ref.background,
      padding = _ref.padding,
      radius = _ref.radius;
  var data = {
    text: [{
      value: "Over "
    }, {
      value: "15k",
      styles: {
        fontWeight: "bold"
      }
    }, {
      value: " Travellers insured in the last 3 months."
    }]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GreatChoiceStyle, {
    background: background,
    padding: padding,
    radius: radius,
    "data-test-id": "GreatChoice-GreatChoiceStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      margin: "0 0 8px",
      alignItems: "center",
      gap: "12px",
      "data-test-id": "GreatChoice-FlexComp",
      children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        src: icon,
        height: "32",
        width: "32",
        "data-test-id": "GreatChoice-ImageComponent"
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        color: Global/* theme.greenText */.rS.greenText,
        "data-test-id": "GreatChoice-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "GreatChoice-FormattedText"
        })
      })]
    }), (info || data) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "GreatChoice-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: info ? info : data,
        "data-test-id": "GreatChoice-FormattedText"
      })
    })]
  });
};

/* harmony default export */ var GreatChoice_GreatChoice = (GreatChoice);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoiceShimmer.tsx






var GreatChoiceShimmer = function GreatChoiceShimmer(_ref) {
  var title = _ref.title,
      info = _ref.info;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GreatChoiceStyle, {
    "data-test-id": "GreatChoiceShimmer-GreatChoiceStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
      width: "283px",
      height: "32px",
      margin: "0 0 8px",
      "data-test-id": "GreatChoiceShimmer-Shimmer"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
      width: "100%",
      height: "22px",
      "data-test-id": "GreatChoiceShimmer-Shimmer"
    })]
  });
};

/* harmony default export */ var GreatChoice_GreatChoiceShimmer = (GreatChoiceShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx



var ImageComponent_ImageComponent = function ImageComponent(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$cdnUrlWidths = _ref.cdnUrlWidths,
      cdnUrlWidths = _ref$cdnUrlWidths === void 0 ? [] : _ref$cdnUrlWidths,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? "" : _ref$sizes,
      margin = _ref.margin;
  var imgStyle = margin ? {
    margin: margin
  } : {};

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith && src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      style: imgStyle,
      className: className,
      id: id,
      width: width,
      height: height,
      "data-test-id": "ImageComponent"
    });
  }

  var srcsetUrl = (0,static_utils/* generateSourceSetImageUrl */.sI)(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    "data-test-id": "ImageComponent-picture",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width,
      "data-test-id": "ImageComponent-source"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      style: imgStyle
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.style.ts



var InsuranceBooked_style_InsuranceBookedStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__InsuranceBookedStyle",
  componentId: "sc-16uf35k-0"
})(["background-color:", ";border-radius:8px;padding:28px 26px;min-height:295px;@media ", "{min-height:0;padding:12px 16px;}"], Global/* theme.neonGreen */.rS.neonGreen, static_utils/* deviceType.mobile */.vO.mobile);
var ListingSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceBookedstyle__ListingSpan",
  componentId: "sc-16uf35k-1"
})(["font-size:14px;line-height:20px;color:", ";padding-right:12px;margin-right:12px;position:relative;flex-shrink:0;&:last-child{border:none;flex-shrink:unset;}&:after{content:\"\";position:absolute;right:0;top:4px;width:1px;height:14px;background:#4a4a4a;}&:last-child:after{width:0;border:none;flex-shrink:unset;}@media ", "{font-size:12px;}"], Global/* theme.greyText */.rS.greyText, static_utils/* deviceType.mobile */.vO.mobile);
var GreenArrowWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__GreenArrowWrap",
  componentId: "sc-16uf35k-2"
})(["transition:0.4s ease-in;transform-origin:center;flex-shrink:0;width:40px;height:40px;display:flex;", ""], function (p) {
  return p.showinsDetails && "\ntransform:rotate(180deg);\n";
});
var InsuranceBookedPackStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__InsuranceBookedPackStyle",
  componentId: "sc-16uf35k-3"
})(["display:flex;flex-direction:column;border-bottom:1px solid ", ";padding-bottom:8px;margin-bottom:24px;@media ", "{padding-bottom:12px;margin-bottom:12px;}"], Global/* theme.lightSilver */.rS.lightSilver, static_utils/* deviceType.mobile */.vO.mobile);
var ViewPlanBenefitStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceBookedstyle__ViewPlanBenefitStyle",
  componentId: "sc-16uf35k-4"
})(["display:flex;align-items:center;justify-content:space-between;border-bottom:none;margin-bottom:20px;gap:8px;@media ", "{flex-direction:column;gap:4px;align-items:flex-start;margin-bottom:12px;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedTravel.tsx










var InsuranceBookedTravel = function InsuranceBookedTravel(_ref) {
  var selectedPlanData = _ref.selectedPlanData;
  var device = useBreakpoint();

  var _ref2 = selectedPlanData || {},
      countryTitle = _ref2.countryTitle,
      travelDate = _ref2.travelDate,
      travellerCount = _ref2.travellerCount,
      travelPurpose = _ref2.travelPurpose;

  var _ref3 = travelDate || {},
      startDate = _ref3.startDate,
      endDate = _ref3.endDate;

  console.log({
    travelPurpose: travelPurpose,
    travellerCount: travellerCount
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H6Tag, {
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "InsuranceBookedTravel-H6Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: countryTitle,
        "data-test-id": "InsuranceBookedTravel-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      margin: device == "lg" ? "8px 0 0" : "",
      "data-test-id": "InsuranceBookedTravel-FlexComp",
      children: [startDate && endDate && /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingSpan, {
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "InsuranceBookedTravel-ListingSpan",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "InsuranceBookedTravel-SpanTag",
          children: [(0,utils/* formatDate */.p6)(startDate, src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(startDate, src.DATE_FORMATS.YY), " -To-", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "InsuranceBookedTravel-SpanTag",
          children: [(0,utils/* formatDate */.p6)(endDate, src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(endDate, src.DATE_FORMATS.YY)]
      }), travellerCount && /*#__PURE__*/(0,jsx_runtime.jsx)(ListingSpan, {
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "InsuranceBookedTravel-ListingSpan",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travellerCount,
          "data-test-id": "InsuranceBookedTravel-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBookedTravel = (InsuranceBookedTravel);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedPack.tsx







var InsuranceBookedPack = function InsuranceBookedPack(_ref) {
  var selectedPlanData = _ref.selectedPlanData,
      viewBenefitsCta = _ref.viewBenefitsCta,
      handleViewBenefits = _ref.handleViewBenefits;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _ref2 = selectedPlanData || {},
      planType = _ref2.planType,
      planName = _ref2.planName,
      vendorName = _ref2.vendorName,
      vendorIcon = _ref2.vendorIcon,
      settleMentRatio = _ref2.settleMentRatio,
      planTypeColor = _ref2.planTypeColor;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceBookedPackStyle, {
    "data-test-id": "InsuranceBookedPack-InsuranceBookedPackStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "xs",
      fontWeight: "black",
      "data-test-id": "InsuranceBookedPack-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: planType,
        "data-test-id": "InsuranceBookedPack-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ViewPlanBenefitStyle, {
      "data-test-id": "InsuranceBookedPack-ViewPlanBenefitStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "black",
        fontSize: "md",
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "InsuranceBookedPack-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: planName,
          "data-test-id": "InsuranceBookedPack-FormattedText"
        })
      }), viewBenefitsCta && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        fontSize: "sm",
        fontWeight: "black",
        handleClick: handleViewBenefits,
        "data-test-id": "InsuranceBookedPack-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: viewBenefitsCta,
          "data-test-id": "InsuranceBookedPack-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      alignItems: "center",
      borderBottom: "none",
      padding: "0",
      gap: "14px",
      margin: "0",
      "data-test-id": "InsuranceBookedPack-FlexComp",
      children: [vendorIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "48px",
        height: "48px",
        src: vendorIcon,
        "data-test-id": "InsuranceBookedPack-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "sm",
          fontWeight: "black",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "InsuranceBookedPack-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: vendorName,
            "data-test-id": "InsuranceBookedPack-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "InsuranceBookedPack-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: settleMentRatio,
            "data-test-id": "InsuranceBookedPack-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBookedPack = (InsuranceBookedPack);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.tsx










var InsuranceBooked = function InsuranceBooked(_ref) {
  var title = _ref.title,
      selectedPlanData = _ref.selectedPlanData,
      viewBenefitsCta = _ref.viewBenefitsCta,
      handleViewBenefits = _ref.handleViewBenefits;

  var _ref2 = selectedPlanData || {},
      payAmtTxt = _ref2.payAmtTxt,
      payAmt = _ref2.payAmt;

  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(false),
      insDetails = _useState[0],
      setInsDetails = _useState[1];

  var handleInsuranceExpand = function handleInsuranceExpand() {
    setInsDetails(!insDetails);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceBooked_style_InsuranceBookedStyle, {
    "data-test-id": "InsuranceBooked-InsuranceBookedStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      justifyContent: "space-between",
      alignItems: device == "lg" ? "center" : "flex-start",
      borderBottom: insDetails && device == "sm" ? "1px solid #d8d8d8" : device == "lg" ? "1px solid #d8d8d8" : "",
      padding: insDetails && device == "sm" ? "0 0 12px" : device == "lg" ? "0 0 24px" : "",
      margin: insDetails && device == "sm" ? "0 0 12px" : device == "lg" ? "0 0 8px" : "",
      handleClick: handleInsuranceExpand,
      "data-test-id": "InsuranceBooked-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        justifyContent: "space-between",
        width: "100%",
        alignItems: device === "lg" ? "center" : "",
        flexDirection: device === "lg" ? "row" : "column",
        "data-test-id": "InsuranceBooked-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignItems: "center",
          gap: "8px",
          padding: "0",
          margin: "0 10px 0 0",
          borderBottom: "none",
          "data-test-id": "InsuranceBooked-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "24px",
            height: "24px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_48_Copy_4b90426dd9.svg",
            "data-test-id": "InsuranceBooked-ImageComponent"
          }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
            color: Global/* theme.blackText */.rS.blackText,
            "data-test-id": "InsuranceBooked-H5Tag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: title,
              "data-test-id": "InsuranceBooked-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H6Tag, {
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "InsuranceBooked-H6Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: title,
                "data-test-id": "InsuranceBooked-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              flexShrink: "0",
              flexDirection: "row",
              gap: "2px",
              "data-test-id": "InsuranceBooked-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                color: Global/* theme.greenText5 */.rS.greenText5,
                fontSize: "xs",
                "data-test-id": "InsuranceBooked-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: payAmtTxt,
                  "data-test-id": "InsuranceBooked-FormattedText"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                color: Global/* theme.greenText5 */.rS.greenText5,
                fontSize: "xs",
                fontWeight: "black",
                "data-test-id": "InsuranceBooked-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: payAmt,
                  "data-test-id": "InsuranceBooked-FormattedText"
                })
              })]
            })]
          })]
        }), device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          flexDirection: "row",
          gap: "4px",
          margin: device === "lg" ? "0 0 0 auto" : "",
          "data-test-id": "InsuranceBooked-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            color: Global/* theme.greenText5 */.rS.greenText5,
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceBooked-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: payAmtTxt,
              "data-test-id": "InsuranceBooked-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            color: Global/* theme.greenText5 */.rS.greenText5,
            fontSize: device == "lg" ? "md" : "xs",
            fontWeight: "black",
            "data-test-id": "InsuranceBooked-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: payAmt,
              "data-test-id": "InsuranceBooked-FormattedText"
            })
          })]
        })]
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(GreenArrowWrap, {
        showinsDetails: insDetails,
        onClick: handleInsuranceExpand,
        "data-test-id": "InsuranceBooked-GreenArrowWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "40px",
          height: "40px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_1244832110_61908827b9.svg",
          "data-test-id": "InsuranceBooked-ImageComponent"
        })
      })]
    }), (insDetails && device == "sm" || device == "lg") && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceBooked_InsuranceBookedPack, {
        selectedPlanData: selectedPlanData,
        viewBenefitsCta: viewBenefitsCta,
        handleViewBenefits: handleViewBenefits,
        "data-test-id": "InsuranceBooked-InsuranceBookedPack"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceBooked_InsuranceBookedTravel, {
        selectedPlanData: selectedPlanData,
        "data-test-id": "InsuranceBooked-InsuranceBookedTravel"
      })]
    })]
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBooked = (InsuranceBooked);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedShimmer.tsx



var InsuranceBookedShimmer = function InsuranceBookedShimmer() {
  return /*#__PURE__*/_jsx(InsuranceBookedStyle, {
    "data-test-id": "InsuranceBookedShimmer-InsuranceBookedStyle"
  });
};

/* harmony default export */ var InsuranceBooked_InsuranceBookedShimmer = ((/* unused pure expression or super */ null && (InsuranceBookedShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.style.ts





var InsurancePlansStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlansStyle",
  componentId: "sc-1k7o2k3-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;padding:30px;picture{display:inherit;}@media ", "{padding:24px 16px;border-radius:16px 16px 0 0;}"], static_utils/* deviceType.mobile */.vO.mobile);
var InsurancePlansCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlansCompStyle",
  componentId: "sc-1k7o2k3-1"
})(["border:1px solid #e2e2e2;border-radius:8px;overflow:hidden;margin-bottom:24px;"]);
var PlanHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__PlanHeader",
  componentId: "sc-1k7o2k3-2"
})(["background:#f6f6f6;border-radius:8px 8px 0px 0px;padding:16px;display:flex;align-items:center;gap:12px;", "{flex-direction:row-reverse;gap:10px;}"], CheckButtonStyle);
var InsurancePlanSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanSection",
  componentId: "sc-1k7o2k3-3"
})(["background:#fff;padding:16px;"]);
var InsuranceTypeSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsuranceTypeSection",
  componentId: "sc-1k7o2k3-4"
})(["display:flex;flex-direction:column;gap:2px;flex-shrink:0;width:54%;@media ", "{flex-shrink:unset;width:80%;}"], static_utils/* deviceType.mobile */.vO.mobile);
var InsurancePlanTypeHd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanTypeHd",
  componentId: "sc-1k7o2k3-5"
})(["background:linear-gradient( 0deg,rgba(0,140,255,0.04),rgba(0,140,255,0.04) ),#f6f8ff;border-radius:8px 8px 0px 0px;padding:12px 16px;display:flex;justify-content:space-between;align-items:center;", "{padding-bottom:10px;margin-bottom:-10px;}@media ", "{padding:12px 8px;}"], TextStyles_style/* AnchorTagStyle */.C2, static_utils/* deviceType.mobile */.vO.mobile);
var InsurancePlanTypeSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__InsurancePlanTypeSection",
  componentId: "sc-1k7o2k3-6"
})(["background:linear-gradient( 149.61deg,rgba(239,255,254,0.5) 0.83%,rgba(230,237,255,0.368088) 26.25%,rgba(234,246,255,0.5) 97.19% );border-radius:0 0 8px 8px;padding:12px 16px;"]);
var ActivityStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__ActivityStatus",
  componentId: "sc-1k7o2k3-7"
})(["display:flex;align-items:center;gap:8px;padding-top:12px;border-top:1px solid #e2e2e2;margin-top:12px;"]);
var TravelAssistanceSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__TravelAssistanceSection",
  componentId: "sc-1k7o2k3-8"
})(["background:rgba(228,251,244,0.5);border-radius:4px;padding:8px;margin-top:16px;display:flex;align-items:center;gap:8px;"]);
var PopularTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__PopularTag",
  componentId: "sc-1k7o2k3-9"
})(["background:linear-gradient(87.29deg,#c86dd7 0%,#3023ae 100%);border-radius:0px 16px 16px 0px;padding:1px 8px 2px;margin-left:-16px;flex-shrink:0;@media ", "{border-radius:16px;margin-left:0;}"], static_utils/* deviceType.mobile */.vO.mobile);
var AmountWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__AmountWrap",
  componentId: "sc-1k7o2k3-10"
})(["display:flex;justify-content:space-between;background:#ffffff;box-shadow:", ";padding:16px 30px;position:sticky;bottom:-20px;margin:auto -30px -20px;@media ", "{padding:8px 20px;}"], function (p) {
  return p.boxShadow ? p.boxShadow : "0px 1px 7px rgba(0, 0, 0, 0.2)";
}, static_utils/* deviceType.mobile */.vO.mobile);
var EmptyBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__EmptyBorder",
  componentId: "sc-1k7o2k3-11"
})(["width:100%;height:1px;background:#e2e2e2;"]);
var GreyChevWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__GreyChevWrap",
  componentId: "sc-1k7o2k3-12"
})(["cursor:pointer;flex-shrink:0;transition:0.5s ease-in;transform-origin:center;width:32px;height:32px;display:flex;", ""], function (p) {
  return p.chevOpen ? "\n    transform:rotate(180deg);\n   \n    " : "\n    transform:rotate(0deg);\n   \n    ";
});
var BenefitName = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "InsurancePlansstyle__BenefitName",
  componentId: "sc-1k7o2k3-13"
})(["flex-shrink:0;text-transform:uppercase;@media ", "{font-size:12px;font-weight:600;color:", ";}"], static_utils/* deviceType.mobile */.vO.mobile, Global/* theme.greyText6 */.rS.greyText6);
var BenefitPrice = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "InsurancePlansstyle__BenefitPrice",
  componentId: "sc-1k7o2k3-14"
})(["flex-shrink:0;"]);
var TravAssistWraning = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__TravAssistWraning",
  componentId: "sc-1k7o2k3-15"
})(["background:#ffedd1;border-radius:8px;padding:20px;display:flex;align-items:flex-start;gap:8px;svg{flex-shrink:0;}"]);
var PlanSectionItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__PlanSectionItem",
  componentId: "sc-1k7o2k3-16"
})(["display:grid;grid-template-columns:1fr 1fr 1fr 0.5fr;gap:30px;", "{width:\"max-content\";}@media ", "{grid-template-columns:repeat(1,1fr);gap:12px;}"], TextStyles_style/* ParaTagStyle */.OG, static_utils/* deviceType.mobile */.vO.mobile);
var VendorWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__VendorWrap",
  componentId: "sc-1k7o2k3-17"
})(["display:flex;gap:8px;align-items:center;", " img{border-radius:4px;}"], function (p) {
  return p.margin && "margin:".concat(p.margin, ";");
});
var InsurancePlans_style_TagWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsurancePlansstyle__TagWrap",
  componentId: "sc-1k7o2k3-18"
})(["display:flex;background:linear-gradient(88.44deg,#12714f 0.02%,#1ca099 100.01%);padding:2px 8px 2px 8px;border-radius:16px;height:20px;color:#ffffff;align-items:center;font-size:12px;font-weight:700;width:fit-content;margin:0px 0px 10px 0px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/BenefitItem.tsx








var BenefitItem = function BenefitItem(_ref) {
  var data = _ref.data,
      benefitName = _ref.benefitName,
      isAddOnBenefits = _ref.isAddOnBenefits;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(true),
      benefitOpen = _useState[0],
      setBenefit = _useState[1];

  var handleBenefit = function handleBenefit() {
    setBenefit(!benefitOpen);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      alignItems: "center",
      justifyContent: "space-between",
      gap: device == "lg" ? "24px" : "16px",
      handleClick: handleBenefit,
      "data-test-id": "BenefitItem-FlexComp",
      children: [benefitName && isAddOnBenefits ? /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitName, {
        color: device == "lg" ? Global/* theme.greyText */.rS.greyText : Global/* theme.greyText7 */.rS.greyText7,
        "data-test-id": "BenefitItem-BenefitName",
        children: benefitName
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitName, {
        color: device == "lg" ? Global/* theme.greyText */.rS.greyText : Global/* theme.greyText7 */.rS.greyText7,
        "data-test-id": "BenefitItem-BenefitName",
        children: [data && data.length, " \xA0", benefitName]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyBorder, {
        "data-test-id": "BenefitItem-EmptyBorder"
      }), !isAddOnBenefits && /*#__PURE__*/(0,jsx_runtime.jsx)(GreyChevWrap, {
        chevOpen: benefitOpen,
        "data-test-id": "BenefitItem-GreyChevWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "32px",
          height: "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Grey_Bg_Chev_81a870a4f8.svg",
          "data-test-id": "BenefitItem-ImageComponent"
        })
      })]
    }), benefitOpen && data && (data === null || data === void 0 ? void 0 : data.map(function (item2, index2) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        alignItems: "flex-start",
        gap: "20px",
        "data-test-id": `BenefitItem-FlexComp-${index2}`,
        children: [item2.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          src: item2.icon,
          height: device == "lg" ? "30" : "20px",
          width: device == "lg" ? "30" : "20px",
          "data-test-id": "BenefitItem-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          width: "100%",
          flexDirection: "column",
          "data-test-id": "BenefitItem-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            justifyContent: "space-between",
            gap: "8px",
            "data-test-id": "BenefitItem-FlexComp",
            children: [item2.title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "BenefitItem-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item2.title,
                "data-test-id": "BenefitItem-FormattedText"
              })
            }), item2.price && /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitPrice, {
              txtfontSize: "xs",
              txtcolor: Global/* theme.greenText */.rS.greenText,
              txtfontWeight: "bold",
              "data-test-id": "BenefitItem-BenefitPrice",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item2.price,
                "data-test-id": "BenefitItem-FormattedText"
              })
            })]
          }), item2.info && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "BenefitItem-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item2.info,
              "data-test-id": "BenefitItem-FormattedText"
            })
          })]
        })]
      }, index2);
    }))]
  });
};

/* harmony default export */ var InsurancePlans_BenefitItem = (BenefitItem);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsPlanModalCommonInfo.tsx







var InsPlanModalCommonInfo = function InsPlanModalCommonInfo(_ref) {
  var data = _ref.data,
      isAddOnBenefits = _ref.isAddOnBenefits,
      tag = _ref.tag;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.packName) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "xs",
      fontWeight: "black" // color={data?.packNameColor}
      ,
      margin: "0 0 4px",
      "data-test-id": "InsPlanModalCommonInfo-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: data === null || data === void 0 ? void 0 : data.packName,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), tag && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_style_TagWrap, {
      "data-test-id": "InsPlanModalCommonInfo-TagWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: tag,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), data.insuranceType && /*#__PURE__*/(0,jsx_runtime.jsxs)(VendorWrap, {
      margin: isAddOnBenefits ? "0px 0px 8px 0px" : "0",
      "data-test-id": "InsPlanModalCommonInfo-VendorWrap",
      children: [(data === null || data === void 0 ? void 0 : data.vendorDisplayIcon) && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        src: data === null || data === void 0 ? void 0 : data.vendorDisplayIcon,
        height: "34px",
        width: "32px" // margin="0px 0px 4px 0px"
        ,
        "data-test-id": "InsPlanModalCommonInfo-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        fontSize: isAddOnBenefits ? "md" : "large",
        margin: "0 0 4px",
        color: Global/* theme.blackText */.rS.blackText,
        fontWeight: "black",
        "data-test-id": "InsPlanModalCommonInfo-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: data === null || data === void 0 ? void 0 : data.insuranceType,
          "data-test-id": "InsPlanModalCommonInfo-FormattedText"
        })
      })]
    }), data.insPlanName && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "xs",
      margin: "0 0 4px",
      "data-test-id": "InsPlanModalCommonInfo-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
        fontSize: "xs",
        color: Global/* theme.greyText7 */.rS.greyText7,
        "data-test-id": "InsPlanModalCommonInfo-SpanTag",
        children: [data === null || data === void 0 ? void 0 : data.vendorDisplayPrefix, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: data === null || data === void 0 ? void 0 : data.insPlanName,
          "data-test-id": "InsPlanModalCommonInfo-FormattedText"
        })]
      })
    }), (data === null || data === void 0 ? void 0 : data.ctaLink) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
      fontSize: "xs",
      margin: "0 0 16px",
      hrefProp: data === null || data === void 0 ? void 0 : data.tncLink,
      targetProp: "_blank",
      "data-test-id": "InsPlanModalCommonInfo-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: data === null || data === void 0 ? void 0 : data.ctaLink,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), (data === null || data === void 0 ? void 0 : data.planExtraInfo) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontSize: "xs",
      color: Global/* theme.greyText7 */.rS.greyText7,
      margin: "0 0 14px",
      "data-test-id": "InsPlanModalCommonInfo-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: data === null || data === void 0 ? void 0 : data.planExtraInfo,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    }), (data === null || data === void 0 ? void 0 : data.service) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontSize: "xs",
      color: Global/* theme.greyText7 */.rS.greyText7,
      margin: "0 0 14px",
      "data-test-id": "InsPlanModalCommonInfo-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: data === null || data === void 0 ? void 0 : data.service,
        "data-test-id": "InsPlanModalCommonInfo-FormattedText"
      })
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsPlanModalCommonInfo = (InsPlanModalCommonInfo);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.tsx



function InsurancePlans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsurancePlans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsurancePlans_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsurancePlans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var InsurancePlans_analytics = (0,insurance/* getAnalytics */.I)();

var InsurancePlans = function InsurancePlans(_ref) {
  var data = _ref.data,
      title = _ref.title,
      quickFiltersTitle = _ref.quickFiltersTitle,
      quickFilters = _ref.quickFilters,
      setQuickFilters = _ref.setQuickFilters,
      tagData = _ref.tagData,
      filterData = _ref.filterData,
      compareToastData = _ref.compareToastData,
      comparePlan = _ref.comparePlan;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(data),
      planSelected = _useState[0],
      setPlanSelected = _useState[1];

  var _useState2 = (0,react.useState)(0),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      quoteId1ForCompare = _useState3[0],
      setQuoteId1ForCompare = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      quoteId2ForCompare = _useState4[0],
      setQuoteId2ForCompare = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      productId1ForCompare = _useState5[0],
      setProductId1ForCompare = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      productId2ForCompare = _useState6[0],
      setProductId2ForCompare = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      showFilter = _useState7[0],
      setShowFilter = _useState7[1];

  var _useState8 = (0,react.useState)("0/2 Products Selected"),
      comparePlanText = _useState8[0],
      setComparePlanText = _useState8[1];

  var _useState9 = (0,react.useState)(true),
      isDisable = _useState9[0],
      setIsDisable = _useState9[1];

  var _useState10 = (0,react.useState)(-1),
      showTravAssist = _useState10[0],
      setshowTravAssist = _useState10[1];

  var _useState11 = (0,react.useState)(-1),
      showBenefits = _useState11[0],
      setShowBenefits = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showCompareNow = _useState12[0],
      setShowCompareNow = _useState12[1];

  (0,react.useEffect)(function () {
    if (count === 1) {
      setComparePlanText("1/2 Products Selected");
    } else if (count > 1) {
      setComparePlanText("2/2 Products Selected");
    } else {
      setComparePlanText("0/2 Products Selected");
    }
  }, [count]);
  (0,react.useEffect)(function () {
    if (count === 2) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [count]);
  (0,react.useEffect)(function () {
    if (quickFilters) {
      var _quickFilters$filter$, _quickFilters$filter;

      setPlanSelected(data);
      var selectedFiltersCardIds = (_quickFilters$filter$ = (_quickFilters$filter = quickFilters.filter(function (filter) {
        return filter.isSelected;
      })) === null || _quickFilters$filter === void 0 ? void 0 : _quickFilters$filter.reduce(function (acc, item) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(item.cardIds || item.plans));
      }, [])) !== null && _quickFilters$filter$ !== void 0 ? _quickFilters$filter$ : [];
      var filteredCards = data === null || data === void 0 ? void 0 : data.filter(function (plan) {
        return selectedFiltersCardIds.includes(plan.id);
      });
      (filteredCards === null || filteredCards === void 0 ? void 0 : filteredCards.length) && setPlanSelected(filteredCards);
    }
  }, [quickFilters]);

  var handleShowFilter = function handleShowFilter() {
    setShowFilter(!showFilter);
  };

  var toggleBenefitsModal = function toggleBenefitsModal(index) {
    showBenefits === index ? setShowBenefits(-1) : setShowBenefits(index);
  };

  var _handleTravAssist = function handleTravAssist(index) {
    showTravAssist == index ? setshowTravAssist(-1) : setshowTravAssist(index);
  };

  var handleFilterChange = function handleFilterChange(id) {
    if (quickFilters) {
      var changedFilters = quickFilters.map(function (item) {
        if (item.id == id) {
          InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
            actionType: "sum_insured_selected",
            payload: item.name
          });
          return InsurancePlans_objectSpread(InsurancePlans_objectSpread({}, item), {}, {
            isSelected: true
          });
        } else {
          return InsurancePlans_objectSpread(InsurancePlans_objectSpread({}, item), {}, {
            isSelected: false
          });
        }
      });
      setQuickFilters(changedFilters);
    }
  };

  var handlePlanSelected = function handlePlanSelected(productId) {
    var updateCompareState = function updateCompareState(item, id, quoteId) {
      if (!item.selectedForCompare && count === 2) {
        return item;
      } else {
        item.selectedForCompare = !item.selectedForCompare;
      }

      if (item.selectedForCompare) {
        setCount(count + 1);

        if (quoteId1ForCompare == "") {
          setQuoteId1ForCompare(quoteId);
          setProductId1ForCompare(id);
        } else {
          setQuoteId2ForCompare(quoteId);
          setProductId2ForCompare(id);
        }
      } else {
        setCount(count - 1);

        if (quoteId == quoteId1ForCompare) {
          setQuoteId1ForCompare(quoteId2ForCompare);
          setProductId1ForCompare(productId2ForCompare);
        }

        setQuoteId2ForCompare("");
        setProductId2ForCompare("");
      }
    };

    var updatedPlanSelected = planSelected === null || planSelected === void 0 ? void 0 : planSelected.map(function (item) {
      if (item !== null && item !== void 0 && item.cardData && productId === item.id) {
        updateCompareState(item.cardData, item.cardData.productId, item.cardData.quoteId);
      } else if (productId === item.productId) {
        updateCompareState(item, item.productId, item.quoteId);
      }

      return item;
    });
    setPlanSelected(updatedPlanSelected);
  };

  var handleSelectCompare = function handleSelectCompare() {
    if (!showCompareNow) {
      InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
        actionType: "comparenow_opened"
      });
    }

    setShowCompareNow(!showCompareNow);
  };

  var buyProduct = function buyProduct(quoteId, productId) {
    var searchParams = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(searchParams.entries());

    var params = InsurancePlans_objectSpread(InsurancePlans_objectSpread({}, queryParams), {}, {
      countries: searchParams.get("countries"),
      startDate: searchParams.get("startDate"),
      endDate: searchParams.get("endDate"),
      travellers: searchParams.get("travellers"),
      isUpcomingTrip: searchParams.has("isUpcomingTrip") ? searchParams.get("isUpcomingTrip") : false,
      productId: productId,
      quoteId: quoteId
    });

    navigation/* navigationActions.navigateToTravellerDetails */.e.navigateToTravellerDetails(params);
  }; // TODO: add logic to compare productId from comparisonIds


  var closeToast = function closeToast() {
    setPlanSelected(planSelected === null || planSelected === void 0 ? void 0 : planSelected.map(function (item) {
      item.cardData ? item.cardData.selectedForCompare = false : item.selectedForCompare = false;
      return item;
    }));
    data === null || data === void 0 ? void 0 : data.map(function (item) {
      item.cardData ? item.cardData.selectedForCompare = false : item.selectedForCompare = false;
    });
    setQuoteId1ForCompare("");
    setProductId1ForCompare("");
    return setCount(0);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlansStyle, {
    "data-test-id": "InsurancePlans-InsurancePlansStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
      margin: "0 0 16px",
      "data-test-id": "InsurancePlans-H5Tag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "InsurancePlans-FormattedText"
      })
    }), quickFiltersTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      color: Global/* theme.greyText */.rS.greyText,
      fontSize: "sm",
      fontWeight: "black",
      margin: "0 0 8px",
      "data-test-id": "InsurancePlans-SpanTag",
      children: quickFiltersTitle
    }), tagData && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      alignItems: device == "lg" ? "center" : "flex-start",
      justifyContent: "space-between",
      margin: device == "lg" ? "0 0 40px" : "0 0 24px",
      gap: "10px",
      flexDirection: device == "lg" ? "row" : "column",
      "data-test-id": "InsurancePlans-FlexComp",
      children: quickFilters && /*#__PURE__*/(0,jsx_runtime.jsx)(Tags_Tags, {
        handleClickTab: handleFilterChange,
        data: quickFilters,
        "data-test-id": "InsurancePlans-Tags"
      })
    }), planSelected === null || planSelected === void 0 ? void 0 : planSelected.map(function (item, index) {
      var _item$packName, _item$packName$text, _item$packName$text$v, _item$packName$text$v2, _cardData$image, _cardData$image2, _cardData$image3, _cardData$image4, _cardData$image5;

      var productType = // @ts-ignore
      item === null || item === void 0 ? void 0 : (_item$packName = item.packName) === null || _item$packName === void 0 ? void 0 : (_item$packName$text = _item$packName.text) === null || _item$packName$text === void 0 ? void 0 : (_item$packName$text$v = _item$packName$text.value) === null || _item$packName$text$v === void 0 ? void 0 : (_item$packName$text$v2 = _item$packName$text$v.toLowerCase) === null || _item$packName$text$v2 === void 0 ? void 0 : _item$packName$text$v2.call(_item$packName$text$v);

      var _ref2 = item || {},
          cardType = _ref2.cardType,
          cardData = _ref2.cardData;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [cardType == "BANNER" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
          margin: "0 0 24px",
          "data-test-id": "InsurancePlans-FlexComp",
          children: (cardData === null || cardData === void 0 ? void 0 : (_cardData$image = cardData.image) === null || _cardData$image === void 0 ? void 0 : _cardData$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: cardData === null || cardData === void 0 ? void 0 : (_cardData$image2 = cardData.image) === null || _cardData$image2 === void 0 ? void 0 : _cardData$image2.url,
            width: cardData !== null && cardData !== void 0 && (_cardData$image3 = cardData.image) !== null && _cardData$image3 !== void 0 && _cardData$image3.width ? cardData === null || cardData === void 0 ? void 0 : (_cardData$image4 = cardData.image) === null || _cardData$image4 === void 0 ? void 0 : _cardData$image4.width : "100%",
            height: cardData === null || cardData === void 0 ? void 0 : (_cardData$image5 = cardData.image) === null || _cardData$image5 === void 0 ? void 0 : _cardData$image5.height
          })
        }) : cardType == "PLAN" || !cardType ? /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_InsurancePlansComp, {
          data: cardData ? cardData : item,
          handleCompareSelect: function handleCompareSelect() {
            return handlePlanSelected(cardData ? item.id : item === null || item === void 0 ? void 0 : item.productId);
          },
          handleMoreBenefits: function handleMoreBenefits() {
            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "View_details_".concat(productType)
            });
            toggleBenefitsModal(index);
          },
          handleTravAssist: function handleTravAssist() {
            _handleTravAssist(index);

            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "View_details_".concat(productType)
            });
          },
          handleBuyButton: function handleBuyButton(data) {
            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "buy_now_clicked_outside_".concat(productType)
            });
            buyProduct(data === null || data === void 0 ? void 0 : data.quoteId, data === null || data === void 0 ? void 0 : data.productId);
          },
          "data-test-id": `InsurancePlans-InsurancePlansComp-${index}`
        }, index) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), showBenefits === index && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_MoreBenefits, {
          handleClose: function handleClose() {
            return toggleBenefitsModal(index);
          },
          moreBenfitsTitle: item !== null && item !== void 0 && item.cardData ? "".concat(item === null || item === void 0 ? void 0 : item.cardData.totalBenefits, " Benefits") : "".concat(item === null || item === void 0 ? void 0 : item.totalBenefits, " Benefits"),
          data: item !== null && item !== void 0 && item.cardData ? item.cardData : item,
          handleBuyButton: function handleBuyButton(data) {
            InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
              actionType: "buy_now_clicked_details_".concat(productType)
            });
            buyProduct(item !== null && item !== void 0 && item.cardData ? item === null || item === void 0 ? void 0 : item.cardData.quoteId : data === null || data === void 0 ? void 0 : data.quoteId, item !== null && item !== void 0 && item.cardData ? item === null || item === void 0 ? void 0 : item.cardData.productId : item === null || item === void 0 ? void 0 : item.productId);
          },
          "data-test-id": "InsurancePlans-MoreBenefits"
        }), showTravAssist == index && /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_TravelAssistanceModal, {
          data: item.cardData ? item.cardData : item,
          handleTravAssist: function handleTravAssist() {
            return _handleTravAssist(index);
          },
          travelAssistTitle: "Travel Assistance" // should come from CB
          ,
          "data-test-id": "InsurancePlans-TravelAssistanceModal"
        })]
      }, index);
    }), showFilter && /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_FilterPlans, {
      tagData: tagData,
      btnText: "Apply Filter",
      filterData: filterData,
      title: "Filter Plan",
      filterPlanHandleClick: handleShowFilter,
      "data-test-id": "InsurancePlans-FilterPlans"
    }), count > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_ToastCompare, {
      toastCloseIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
      toastIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/toast_Icon_4389f5385c.svg",
      planSelectedTxt: comparePlanText,
      toastCtaTxt: compareToastData === null || compareToastData === void 0 ? void 0 : compareToastData.toastCtaTxt,
      handleClickCta: handleSelectCompare,
      handleClose: closeToast,
      isDisable: isDisable,
      "data-test-id": "InsurancePlans-ToastCompare"
    }), showCompareNow && comparePlan && /*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_ComparePlan, {
      modalTitle: compareToastData === null || compareToastData === void 0 ? void 0 : compareToastData.modalTitle,
      data: comparePlan,
      handleClose: handleSelectCompare,
      handleBuyButton: function handleBuyButton(quoteId, productId) {
        InsurancePlans_analytics === null || InsurancePlans_analytics === void 0 ? void 0 : InsurancePlans_analytics.trackListingEvents({
          actionType: "buy_from_compare"
        });
        buyProduct(quoteId, productId);
      },
      productId1ForCompare: productId1ForCompare,
      quoteId1ForCompare: quoteId1ForCompare,
      productId2ForCompare: productId2ForCompare,
      quoteId2ForCompare: quoteId2ForCompare,
      "data-test-id": "InsurancePlans-ComparePlan"
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlans = (InsurancePlans);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansComp.tsx








var InsurancePlansComp_analytics = (0,insurance/* getAnalytics */.I)();

var InsurancePlansComp = function InsurancePlansComp(_ref) {
  var _data$packName, _data$packName$text, _data$packName$text$v, _data$packName$text$v2, _data$insurerDetails, _data$insurerDetails2, _data$insurerDetails3, _data$insurerDetails4, _data$insurerDetails5, _data$insurerDetails6, _data$insurerDetails7, _data$insurerDetails8;

  var data = _ref.data,
      handleMoreBenefits = _ref.handleMoreBenefits,
      handleTravAssist = _ref.handleTravAssist,
      handleCompareSelect = _ref.handleCompareSelect,
      handleBuyButton = _ref.handleBuyButton;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var productType = // @ts-ignore
  data === null || data === void 0 ? void 0 : (_data$packName = data.packName) === null || _data$packName === void 0 ? void 0 : (_data$packName$text = _data$packName.text) === null || _data$packName$text === void 0 ? void 0 : (_data$packName$text$v = _data$packName$text.value) === null || _data$packName$text$v === void 0 ? void 0 : (_data$packName$text$v2 = _data$packName$text$v.toLowerCase) === null || _data$packName$text$v2 === void 0 ? void 0 : _data$packName$text$v2.call(_data$packName$text$v);

  var _useState = (0,react.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var handleMouseEnter = function handleMouseEnter() {
    setIsHovered(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
  };

  (0,react.useEffect)(function () {
    var planName = data === null || data === void 0 ? void 0 : data.packName;

    if (planName) {
      InsurancePlansComp_analytics === null || InsurancePlansComp_analytics === void 0 ? void 0 : InsurancePlansComp_analytics.trackListingEvents({
        actionType: "".concat(planName, "_seen")
      });
    }
  }, [data]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlansCompStyle, {
    "data-test-id": "InsurancePlansComp-InsurancePlansCompStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_InsurancePlansHeader, {
      handleCompareSelect: handleCompareSelect ? function () {
        return handleCompareSelect(parseInt(data === null || data === void 0 ? void 0 : data.productId));
      } : function () {},
      data: data,
      "data-test-id": "InsurancePlansComp-InsurancePlansHeader"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlanSection, {
      "data-test-id": "InsurancePlansComp-InsurancePlanSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "16px",
        justifyContent: "space-between",
        margin: "0 0 16px",
        "data-test-id": "InsurancePlansComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceTypeSection, {
          "data-test-id": "InsurancePlansComp-InsuranceTypeSection",
          children: [(data === null || data === void 0 ? void 0 : data.insuranceType) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            "data-test-id": "InsurancePlansComp-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.insuranceType,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            gap: "8px",
            alignItems: "center",
            "data-test-id": "InsurancePlansComp-FlexComp",
            children: [(data === null || data === void 0 ? void 0 : data.popularTag) && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(PopularTag, {
              "data-test-id": "InsurancePlansComp-PopularTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "xs",
                fontWeight: "bold",
                color: Global/* theme.whiteText */.rS.whiteText,
                textTransform: "uppercase",
                "data-test-id": "InsurancePlansComp-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: "Popular",
                  "data-test-id": "InsurancePlansComp-FormattedText"
                })
              })
            }), (data === null || data === void 0 ? void 0 : data.planExtraInfo) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText */.rS.greyText,
              "data-test-id": "InsurancePlansComp-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: data === null || data === void 0 ? void 0 : data.planExtraInfo,
                "data-test-id": "InsurancePlansComp-FormattedText"
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          margin: "0 0 0 auto",
          gap: "0",
          flexDirection: "column",
          alignItems: "flex-end",
          flexShrink: "0",
          width: device == "lg" ? "16%" : "25%",
          "data-test-id": "InsurancePlansComp-FlexComp",
          children: [(data === null || data === void 0 ? void 0 : data.discountText) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            color: Global/* theme.greenText */.rS.greenText,
            "data-test-id": "InsurancePlansComp-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.discountText,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            gap: "2px",
            alignItems: "center",
            "data-test-id": "InsurancePlansComp-FlexComp",
            children: [(data === null || data === void 0 ? void 0 : data.originalPrice) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.originalPrice,
              baseStyle: {
                fontSize: 12,
                fontWeight: "regular",
                color: "".concat(Global/* theme.greyText6 */.rS.greyText6),
                textDecoration: "line-through",
                textDecorationThickness: 0.7,
                textAlign: "right",
                whiteSpace: "nowrap"
              },
              "data-test-id": "InsurancePlansComp-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.insAmount,
              baseStyle: {
                fontSize: "md",
                fontWeight: "bold",
                color: "#000",
                textAlign: "right"
              },
              "data-test-id": "InsurancePlansComp-FormattedText"
            })]
          }), (data === null || data === void 0 ? void 0 : data.paxPerDay) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "InsurancePlansComp-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.paxPerDay,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          }), (data === null || data === void 0 ? void 0 : data.ctaLink) && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            color: Global/* theme.blueText */.rS.blueText,
            fontSize: "xs",
            hrefProp: data === null || data === void 0 ? void 0 : data.tncLink,
            targetProp: "_blank",
            handleClick: function handleClick() {
              InsurancePlansComp_analytics === null || InsurancePlansComp_analytics === void 0 ? void 0 : InsurancePlansComp_analytics.trackListingEvents({
                actionType: "TnC_clicked_".concat(productType)
              });
            },
            "data-test-id": "InsurancePlansComp-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.ctaLink,
              "data-test-id": "InsurancePlansComp-FormattedText"
            })
          })]
        }), (data === null || data === void 0 ? void 0 : data.buyBtn) && device == "lg" && handleBuyButton && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
          onClick: function onClick() {
            return handleBuyButton(data);
          },
          customWidth: "fit-content",
          customTitle: data === null || data === void 0 ? void 0 : data.buyBtn,
          "data-test-id": "InsurancePlansComp-LandingButton"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlanTypeHd, {
        "data-test-id": "InsurancePlansComp-InsurancePlanTypeHd",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          gap: "8px",
          alignItems: "center",
          "data-test-id": "InsurancePlansComp-FlexComp",
          children: [(data === null || data === void 0 ? void 0 : data.insIcon) && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "24px",
            height: "24px",
            src: data === null || data === void 0 ? void 0 : data.insIcon,
            "data-test-id": "InsurancePlansComp-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
            fontSize: "sm",
            fontWeight: "black",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "InsurancePlansComp-SpanTag",
            children: [(data === null || data === void 0 ? void 0 : data.insPlanName) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: data === null || data === void 0 ? void 0 : data.insPlanName,
              "data-test-id": "InsurancePlansComp-FormattedText"
            }), (data === null || data === void 0 ? void 0 : data.insurerNumber) && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_AnchorTag, {
              handleMouseEnter: handleMouseEnter,
              handleMouseLeave: handleMouseLeave,
              fontSize: "sm",
              fontWeight: "black",
              "data-test-id": "InsurancePlansComp-AnchorTag",
              children: [device == "lg" ? "&nbsp;" : "", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: data === null || data === void 0 ? void 0 : data.insurerNumber,
                "data-test-id": "InsurancePlansComp-FormattedText"
              }), isHovered && /*#__PURE__*/(0,jsx_runtime.jsxs)(ToolTipComp_ToolTipComp, {
                handleMouseEnter: handleMouseEnter,
                handleMouseLeave: handleMouseLeave,
                left: "40%",
                top: "23px",
                toolTipArrow: "top",
                width: "247px",
                "data-test-id": "InsurancePlansComp-ToolTipComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                  fontSize: "sm",
                  color: Global/* theme.whiteText */.rS.whiteText,
                  "data-test-id": "InsurancePlansComp-SpanTag",
                  children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails = data.insurerDetails) === null || _data$insurerDetails === void 0 ? void 0 : _data$insurerDetails.insurer) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: data === null || data === void 0 ? void 0 : (_data$insurerDetails2 = data.insurerDetails) === null || _data$insurerDetails2 === void 0 ? void 0 : _data$insurerDetails2.insurer,
                    "data-test-id": "InsurancePlansComp-FormattedText"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                  fontSize: "sm",
                  color: Global/* theme.whiteText */.rS.whiteText,
                  "data-test-id": "InsurancePlansComp-SpanTag",
                  children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails3 = data.insurerDetails) === null || _data$insurerDetails3 === void 0 ? void 0 : _data$insurerDetails3.details) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: data === null || data === void 0 ? void 0 : (_data$insurerDetails4 = data.insurerDetails) === null || _data$insurerDetails4 === void 0 ? void 0 : _data$insurerDetails4.details,
                    "data-test-id": "InsurancePlansComp-FormattedText"
                  })
                })]
              })]
            }), isHovered && /*#__PURE__*/(0,jsx_runtime.jsxs)(ToolTipComp_ToolTipComp, {
              handleMouseEnter: handleMouseEnter,
              handleMouseLeave: handleMouseLeave,
              left: "40%",
              top: "23px",
              toolTipArrow: "top",
              width: "247px",
              "data-test-id": "InsurancePlansComp-ToolTipComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "sm",
                color: Global/* theme.whiteText */.rS.whiteText,
                "data-test-id": "InsurancePlansComp-SpanTag",
                children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails5 = data.insurerDetails) === null || _data$insurerDetails5 === void 0 ? void 0 : _data$insurerDetails5.insurer) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: data === null || data === void 0 ? void 0 : (_data$insurerDetails6 = data.insurerDetails) === null || _data$insurerDetails6 === void 0 ? void 0 : _data$insurerDetails6.insurer,
                  "data-test-id": "InsurancePlansComp-FormattedText"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "sm",
                color: Global/* theme.whiteText */.rS.whiteText,
                "data-test-id": "InsurancePlansComp-SpanTag",
                children: (data === null || data === void 0 ? void 0 : (_data$insurerDetails7 = data.insurerDetails) === null || _data$insurerDetails7 === void 0 ? void 0 : _data$insurerDetails7.details) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: data === null || data === void 0 ? void 0 : (_data$insurerDetails8 = data.insurerDetails) === null || _data$insurerDetails8 === void 0 ? void 0 : _data$insurerDetails8.details,
                  "data-test-id": "InsurancePlansComp-FormattedText"
                })
              })]
            })]
          })]
        }), (data === null || data === void 0 ? void 0 : data.ctaLink) && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          color: Global/* theme.blueText */.rS.blueText,
          fontSize: "xs",
          fontWeight: "black",
          hrefProp: data === null || data === void 0 ? void 0 : data.tncLink,
          targetProp: "_blank",
          handleClick: function handleClick() {
            InsurancePlansComp_analytics === null || InsurancePlansComp_analytics === void 0 ? void 0 : InsurancePlansComp_analytics.trackListingEvents({
              actionType: "TnC_clicked_".concat(productType)
            });
          },
          "data-test-id": "InsurancePlansComp-AnchorTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data === null || data === void 0 ? void 0 : data.ctaLink,
            "data-test-id": "InsurancePlansComp-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_InsurancePlanTypeSection, {
        data: data,
        handleMoreBenefits: handleMoreBenefits,
        handleTravAssist: handleTravAssist,
        "data-test-id": "InsurancePlansComp-InsurancePlanTypeSectionComp"
      }), (data === null || data === void 0 ? void 0 : data.buyBtn) && device == "sm" && handleBuyButton && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        onClick: function onClick() {
          return handleBuyButton(data);
        },
        customWidth: "100%",
        customTitle: data === null || data === void 0 ? void 0 : data.buyBtn,
        margin: "16px 0 0",
        "data-test-id": "InsurancePlansComp-LandingButton"
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlansComp = (InsurancePlansComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansHeader.tsx







var InsurancePlansHeader = function InsurancePlansHeader(_ref) {
  var data = _ref.data,
      handleCompareSelect = _ref.handleCompareSelect;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanHeader, {
    "data-test-id": "InsurancePlansHeader-PlanHeader",
    children: [(data === null || data === void 0 ? void 0 : data.popularTag) && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(PopularTag, {
      "data-test-id": "InsurancePlansHeader-PopularTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.whiteText */.rS.whiteText,
        textTransform: "uppercase",
        "data-test-id": "InsurancePlansHeader-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: data === null || data === void 0 ? void 0 : data.popularTag,
          "data-test-id": "InsurancePlansHeader-FormattedText"
        })
      })
    }), (data === null || data === void 0 ? void 0 : data.packName) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontSize: device == "lg" ? "sm" : "xs",
      fontWeight: "bold",
      textTransform: "uppercase",
      "data-test-id": "InsurancePlansHeader-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: data === null || data === void 0 ? void 0 : data.packName,
        "data-test-id": "InsurancePlansHeader-FormattedText"
      })
    }), (data === null || data === void 0 ? void 0 : data.comparePlans) && /*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton_CheckButton, {
      inputIndex: data === null || data === void 0 ? void 0 : data.productId,
      inputId: data === null || data === void 0 ? void 0 : data.productId,
      handleChange: handleCompareSelect ? function () {
        return handleCompareSelect(parseInt(data === null || data === void 0 ? void 0 : data.productId));
      } : function () {},
      isChecked: data === null || data === void 0 ? void 0 : data.selectedForCompare,
      margin: "0 0 0 auto",
      "data-test-id": "InsurancePlansHeader-CheckButton",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "InsurancePlansHeader-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: data === null || data === void 0 ? void 0 : data.comparePlans,
          "data-test-id": "InsurancePlansHeader-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlansHeader = (InsurancePlansHeader);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlanTypeSection.tsx








var InsurancePlanTypeSectionComp = function InsurancePlanTypeSectionComp(_ref) {
  var data = _ref.data,
      handleMoreBenefits = _ref.handleMoreBenefits,
      handleTravAssist = _ref.handleTravAssist;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var expertAssistanceInfo = data.expertAssistanceInfo,
      sportsActivity = data.sportsActivity,
      expertAssistanceIcon = data.expertAssistanceIcon,
      assistanceCovers = data.assistanceCovers,
      insBenefits = data.insBenefits;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InsurancePlanTypeSection, {
    "data-test-id": "InsurancePlanTypeSectionComp-InsurancePlanTypeSection",
    children: [expertAssistanceInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      justifyContent: "space-between",
      margin: "0 0 12px",
      alignItems: "center",
      "data-test-id": "InsurancePlanTypeSectionComp-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.greenText3 */.rS.greenText3,
        "data-test-id": "InsurancePlanTypeSectionComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: expertAssistanceInfo,
          "data-test-id": "InsurancePlanTypeSectionComp-FormattedText"
        })
      }), expertAssistanceIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: device == "lg" ? "30px" : "24px",
        height: device == "lg" ? "30px" : "24px",
        src: expertAssistanceIcon,
        "data-test-id": "InsurancePlanTypeSectionComp-ImageComponent"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanSectionItem, {
      "data-test-id": "InsurancePlanTypeSectionComp-PlanSectionItem",
      children: [insBenefits && insBenefits.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          gap: "0",
          width: device == "lg" ? "max-content" : "100%",
          flexDirection: device == "lg" ? "column" : "row",
          justifyContent: device == "sm" ? "space-between" : "unset",
          "data-test-id": `InsurancePlanTypeSectionComp-FlexComp-${index}`,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontWeight: index == 0 ? "bold" : "regular",
            fontSize: "xs",
            "data-test-id": "InsurancePlanTypeSectionComp-ParaTag",
            children: item.policyTitle
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontWeight: index == 0 ? "bold" : "regular",
            fontSize: "xs",
            "data-test-id": "InsurancePlanTypeSectionComp-SpanTag",
            children: item.policyAmt
          })]
        }, index);
      }), assistanceCovers && assistanceCovers.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          fontSize: "xs",
          "data-test-id": `InsurancePlanTypeSectionComp-ParaTag-${index}`,
          children: item
        }, index);
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_AnchorTag, {
        handleClick: insBenefits && handleMoreBenefits ? function () {
          return handleMoreBenefits(parseInt(data.productId));
        } : assistanceCovers && handleTravAssist ? function () {
          return handleTravAssist(parseInt(data.productId));
        } : function () {},
        fontSize: "xs",
        fontWeight: "bold",
        textAlign: device == "lg" ? "right" : "left",
        "data-test-id": "InsurancePlanTypeSectionComp-AnchorTag",
        children: [insBenefits && "".concat(data === null || data === void 0 ? void 0 : data.totalBenefits, " More Benefits"), assistanceCovers && "View Details"]
      })]
    }), sportsActivity && /*#__PURE__*/(0,jsx_runtime.jsxs)(ActivityStatus, {
      "data-test-id": "InsurancePlanTypeSectionComp-ActivityStatus",
      children: [(sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: device == "lg" ? "24px" : "16px",
        height: device == "lg" ? "24px" : "16px",
        src: sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.icon,
        "data-test-id": "InsurancePlanTypeSectionComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "InsurancePlanTypeSectionComp-SpanTag",
        children: (sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: sportsActivity === null || sportsActivity === void 0 ? void 0 : sportsActivity.title,
          "data-test-id": "InsurancePlanTypeSectionComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_InsurancePlanTypeSection = (InsurancePlanTypeSectionComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits.tsx








var MoreBenefits_analytics = (0,insurance/* getAnalytics */.I)();

var MoreBenefits = function MoreBenefits(_ref) {
  var _Object$keys;

  var moreBenfitsTitle = _ref.moreBenfitsTitle,
      data = _ref.data,
      tag = _ref.tag,
      handleClose = _ref.handleClose,
      handleBuyButton = _ref.handleBuyButton,
      isAddOnBenefits = _ref.isAddOnBenefits,
      customBtnTitle = _ref.customBtnTitle;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  (0,react.useEffect)(function () {
    var _data$packName, _data$packName$text, _data$packName$text$v, _data$packName$text$v2;

    var productType = // @ts-ignore
    data === null || data === void 0 ? void 0 : (_data$packName = data.packName) === null || _data$packName === void 0 ? void 0 : (_data$packName$text = _data$packName.text) === null || _data$packName$text === void 0 ? void 0 : (_data$packName$text$v = _data$packName$text.value) === null || _data$packName$text$v === void 0 ? void 0 : (_data$packName$text$v2 = _data$packName$text$v.toLowerCase) === null || _data$packName$text$v2 === void 0 ? void 0 : _data$packName$text$v2.call(_data$packName$text$v);
    MoreBenefits_analytics === null || MoreBenefits_analytics === void 0 ? void 0 : MoreBenefits_analytics.trackListingEvents({
      // @ts-ignore
      actionType: "details_pop_shown_".concat(productType)
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    handleClick: handleClose,
    customTitle: moreBenfitsTitle,
    "data-test-id": "MoreBenefits-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_InsPlanModalCommonInfo, {
      data: data,
      isAddOnBenefits: isAddOnBenefits,
      tag: tag,
      "data-test-id": "MoreBenefits-InsPlanModalCommonInfo"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      flexDirection: "column",
      gap: "24px",
      margin: "0 0 20px",
      "data-test-id": "MoreBenefits-FlexComp",
      children: (data === null || data === void 0 ? void 0 : data.moreBenefits) && ((_Object$keys = Object.keys(data.moreBenefits)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (item, index) {
        var _data$moreBenefits;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_BenefitItem, {
          isAddOnBenefits: isAddOnBenefits,
          data: (_data$moreBenefits = data.moreBenefits) === null || _data$moreBenefits === void 0 ? void 0 : _data$moreBenefits[item],
          benefitName: item,
          "data-test-id": "MoreBenefits-BenefitItem"
        }, "".concat(index));
      }))
    }), isAddOnBenefits && /*#__PURE__*/(0,jsx_runtime.jsx)(AmountWrap, {
      boxShadow: "0",
      "data-test-id": "MoreBenefits-AmountWrap",
      children: (data === null || data === void 0 ? void 0 : data.buyBtn) && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        customWidth: "-webkit-fill-available",
        customTitle: customBtnTitle,
        onClick: function onClick() {
          return handleBuyButton === null || handleBuyButton === void 0 ? void 0 : handleBuyButton(data);
        },
        "data-test-id": "MoreBenefits-LandingButton"
      })
    }), (data === null || data === void 0 ? void 0 : data.insAmount) && /*#__PURE__*/(0,jsx_runtime.jsxs)(AmountWrap, {
      "data-test-id": "MoreBenefits-AmountWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "0",
        flexDirection: "column",
        "data-test-id": "MoreBenefits-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "MoreBenefits-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data === null || data === void 0 ? void 0 : data.insAmount,
            "data-test-id": "MoreBenefits-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "MoreBenefits-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data === null || data === void 0 ? void 0 : data.paxPerDay,
            "data-test-id": "MoreBenefits-FormattedText"
          })
        })]
      }), (data === null || data === void 0 ? void 0 : data.buyBtn) && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        customWidth: device == "sm" ? "158px" : "unset",
        customTitle: data.buyBtn,
        onClick: function onClick() {
          return handleBuyButton === null || handleBuyButton === void 0 ? void 0 : handleBuyButton(data);
        },
        "data-test-id": "MoreBenefits-LandingButton"
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_MoreBenefits = (MoreBenefits);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/TravelAssistanceModal.tsx







var TravelAssistanceModal = function TravelAssistanceModal(_ref) {
  var travelAssistTitle = _ref.travelAssistTitle,
      data = _ref.data,
      handleTravAssist = _ref.handleTravAssist;

  var travelAssistanceCover = function travelAssistanceCover() {
    for (var i in data === null || data === void 0 ? void 0 : data.travelAssistanceCovers) {
      var _data$travelAssistanc, _data$travelAssistanc2;

      return data === null || data === void 0 ? void 0 : (_data$travelAssistanc = data.travelAssistanceCovers) === null || _data$travelAssistanc === void 0 ? void 0 : (_data$travelAssistanc2 = _data$travelAssistanc[i]) === null || _data$travelAssistanc2 === void 0 ? void 0 : _data$travelAssistanc2.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignItems: "flex-start",
          margin: "0 0 20px",
          gap: "20px",
          "data-test-id": `TravelAssistanceModal-travelAssistanceCover-FlexComp-${index}`,
          children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            src: item.icon,
            "data-test-id": "TravelAssistanceModal-travelAssistanceCover-ImageComponent"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              margin: "0 0 8px",
              fontSize: "sm",
              fontWeight: "bold",
              "data-test-id": "TravelAssistanceModal-travelAssistanceCover-ParaTag",
              children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "TravelAssistanceModal-travelAssistanceCover-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "TravelAssistanceModal-travelAssistanceCover-ParaTag",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.info,
                "data-test-id": "TravelAssistanceModal-travelAssistanceCover-FormattedText"
              })
            })]
          })]
        }, index);
      });
    }

    return;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    handleClick: handleTravAssist ? function () {
      var _parseInt;

      return handleTravAssist((_parseInt = parseInt(data === null || data === void 0 ? void 0 : data.productId)) !== null && _parseInt !== void 0 ? _parseInt : 0);
    } : function () {},
    customTitle: travelAssistTitle,
    "data-test-id": "TravelAssistanceModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsurancePlans_InsPlanModalCommonInfo, {
      data: data,
      "data-test-id": "TravelAssistanceModal-InsPlanModalCommonInfo"
    }), travelAssistanceCover(), (data === null || data === void 0 ? void 0 : data.travelAssistanceWarning) && /*#__PURE__*/(0,jsx_runtime.jsxs)(TravAssistWraning, {
      "data-test-id": "TravelAssistanceModal-TravAssistWraning",
      children: [data.travelAssistanceWarning.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        src: data.travelAssistanceWarning.icon,
        "data-test-id": "TravelAssistanceModal-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [data.travelAssistanceWarning.title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          margin: "0 0 8px",
          fontSize: "large",
          fontWeight: "bold",
          color: Global/* theme.yellowText */.rS.yellowText,
          "data-test-id": "TravelAssistanceModal-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data.travelAssistanceWarning.title,
            "data-test-id": "TravelAssistanceModal-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "md",
          "data-test-id": "TravelAssistanceModal-ParaTag",
          children: (data === null || data === void 0 ? void 0 : data.travelAssistanceWarning.info) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: data === null || data === void 0 ? void 0 : data.travelAssistanceWarning.info,
            "data-test-id": "TravelAssistanceModal-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var InsurancePlans_TravelAssistanceModal = (TravelAssistanceModal);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.style.ts



var InsuranceStatsWrap = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsWrap",
  componentId: "mtxv9q-0"
})(["width:100%;@media ", "{padding:0 16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var InsuranceStatsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceStatsstyle__InsuranceStatsStyle",
  componentId: "mtxv9q-1"
})(["background:#fff;border-radius:16px;padding:40px 80px;display:flex;gap:114px;width:1200px;margin:0 auto;position:relative;z-index:1;display:grid;grid-template-columns:repeat(4,1fr);box-shadow:0px 3px 30px rgba(0,0,0,0.1);", " @media ", "{width:100%;gap:24px;padding:16px;grid-template-columns:repeat(2,1fr);box-shadow:none;", "}"], function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    border-radius: 20px;\n    background: #FFF;\n    ";
}, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #fff;\n    box-shadow:none;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.tsx








var InsuranceStats = function InsuranceStats(_ref) {
  var data = _ref.data;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsWrap, {
    id: "insurance-stats",
    "data-test-id": "InsuranceStats-InsuranceStatsWrap",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceStatsStyle, {
      pageTheme: context ? context : undefined,
      "data-test-id": "InsuranceStats-InsuranceStatsStyle",
      children: data && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-test-id": `InsuranceStats-${index}`,
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H4Tag",
            children: item.title
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
            margin: "0 0 4px",
            "data-test-id": "InsuranceStats-H5Tag",
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: device == "lg" ? "md" : "xs",
            "data-test-id": "InsuranceStats-ParaTag",
            children: item.info
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ var InsuranceStats_InsuranceStats = (InsuranceStats);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.tsx








var LandingButton = function LandingButton(_ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      shimmerBtn = _ref.shimmerBtn,
      flex = _ref.flex,
      customHeight = _ref.customHeight,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon,
      fontSize = _ref.fontSize,
      isLoading = _ref.isLoading,
      buttonref = _ref.buttonref;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_style/* LandingButtonStyle */.zm, {
    ref: buttonref,
    onClick: onClick,
    customWidth: customWidth,
    margin: margin,
    customHeight: customHeight,
    flexShrink: flexShrink,
    flex: flex,
    fontSize: fontSize,
    disableState: disableState,
    btnTheme: context ? context : undefined,
    txtClipIcon: btnLeftIcon !== "" && btnRightIcon !== "",
    "data-test-id": "LandingButton-LandingButtonStyle",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner_Spinner, {
      spinnerColor: "#fff",
      "data-test-id": "LandingButton-Spinner"
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [btnLeftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: btnLeftIcon,
        "data-test-id": "LandingButton-ImageComponent"
      }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.blueText */.rS.blueText,
        fontSize: "md",
        fontWeight: "black",
        "data-test-id": "LandingButton-SpanTag",
        children: customTitle
      }), shimmerBtn && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_style/* ShimmerWrap */.vj, {
        "data-test-id": "LandingButton-ShimmerWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "../../../images/shimmerBtn.svg"
        })
      }), btnRightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "16px",
        height: "16px",
        margin: "0 0 0 auto",
        src: btnRightIcon,
        "data-test-id": "LandingButton-ImageComponent"
      })]
    })
  });
};

/* harmony default export */ var LandingButton_LandingButton = (LandingButton);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButtonTertiary.tsx







var LandingButtonTertiary = function LandingButtonTertiary(_ref) {
  var title = _ref.title,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingButton_style/* LandingButtonTertiaryStyle */.mS, {
    onClick: onClick,
    disableState: disableState,
    "data-test-id": "LandingButtonTertiary-LandingButtonTertiaryStyle",
    children: [btnLeftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      color: Global/* theme.blueText */.rS.blueText,
      fontSize: "xs",
      fontWeight: "bold",
      "data-test-id": "LandingButtonTertiary-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "LandingButtonTertiary-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonTertiary-ImageComponent"
    })]
  });
};

/* harmony default export */ var LandingButton_LandingButtonTertiary = (LandingButtonTertiary);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButtonWhite.tsx







var LandingButtonWhite_LandingButtonWhite = function LandingButtonWhite(_ref) {
  var customTitle = _ref.customTitle,
      margin = _ref.margin,
      customWidth = _ref.customWidth,
      customHeight = _ref.customHeight,
      disableState = _ref.disableState,
      onClick = _ref.onClick,
      flexShrink = _ref.flexShrink,
      flex = _ref.flex,
      btnLeftIcon = _ref.btnLeftIcon,
      btnRightIcon = _ref.btnRightIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingButton_style/* LandingButtonWhiteStyle */.aA, {
    onClick: onClick,
    customWidth: customWidth,
    customHeight: customHeight,
    margin: margin,
    flexShrink: flexShrink,
    flex: flex,
    disableState: disableState,
    "data-test-id": "LandingButtonWhite-LandingButtonWhiteStyle",
    children: [btnLeftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "24px",
      height: "24px",
      src: btnLeftIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      color: Global/* theme.blueText */.rS.blueText,
      fontSize: "md",
      fontWeight: "bold",
      "data-test-id": "LandingButtonWhite-SpanTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: customTitle,
        "data-test-id": "LandingButtonWhite-FormattedText"
      })
    }), btnRightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "16px",
      height: "16px",
      margin: "0 0 0 auto",
      src: btnRightIcon,
      "data-test-id": "LandingButtonWhite-ImageComponent"
    })]
  });
};

/* harmony default export */ var LandingButton_LandingButtonWhite = (LandingButtonWhite_LandingButtonWhite);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.style.ts



var LandingFooter_style_LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooterstyle__LandingFooterStyle",
  componentId: "d0b0t6-0"
})(["background:", ";color:", ";padding-top:32px;padding-bottom:64px;width:100%;@media screen and ", "{padding-bottom:22px;}"], Global/* theme.blackText */.rS.blackText, Global/* theme.whiteText */.rS.whiteText, static_utils/* deviceType.mobile */.vO.mobile);
var ChevronContainerIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingFooterstyle__ChevronContainerIcon",
  componentId: "d0b0t6-1"
})(["transform:", ";"], function (props) {
  return props.isInvert ? "rotate(180deg)" : "rotate(0deg)";
});
var LinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__LinksContainer",
  componentId: "d0b0t6-2"
})(["margin-bottom:100px;& > li:not(:last-child){margin-bottom:24px;}@media screen and ", "{margin-bottom:40px;& > li{padding:16px;border-bottom:1px ", " solid;}& > li:not(:last-child){margin-bottom:unset;}}"], static_utils/* deviceType.mobile */.vO.mobile, Global/* theme.greyText */.rS.greyText);
var FooterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__FooterSection",
  componentId: "d0b0t6-3"
})(["width:964px;@media screen and ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
var InnerLinksContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooterstyle__InnerLinksContainer",
  componentId: "d0b0t6-4"
})(["display:flex;margin-top:10px;flex-wrap:wrap;& > li{position:relative;color:white;font-size:12px;line-height:16px;}& > li::after{content:\"\u2022\";margin-left:4px;margin-right:4px;}& > li:last-child:after{content:\"\";}"]);
var LandingFooter_style_LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooterstyle__LandingFooterWrap",
  componentId: "d0b0t6-5"
})(["margin:0 auto;width:1200px;@media screen and ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/index.ts + 7 modules
var icons = __webpack_require__(4204);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.tsx








var LandingFooter = function LandingFooter(_ref) {
  var footerData = _ref.footerData,
      _ref$footerTextOne = _ref.footerTextOne,
      footerTextOne = _ref$footerTextOne === void 0 ? "An initiative" : _ref$footerTextOne,
      _ref$footerTextTwo = _ref.footerTextTwo,
      footerTextTwo = _ref$footerTextTwo === void 0 ? "towards solving Travel Finance" : _ref$footerTextTwo,
      _ref$followUsText = _ref.followUsText,
      followUsText = _ref$followUsText === void 0 ? "FOLLOW US" : _ref$followUsText,
      _ref$downloadText = _ref.downloadText,
      downloadText = _ref$downloadText === void 0 ? "DOWNLOAD" : _ref$downloadText,
      _ref$countryText = _ref.countryText,
      countryText = _ref$countryText === void 0 ? "Country" : _ref$countryText,
      _ref$locationText = _ref.locationText,
      locationText = _ref$locationText === void 0 ? "INDIA" : _ref$locationText,
      _ref$mmtText = _ref.mmtText,
      mmtText = _ref$mmtText === void 0 ? "MAKEMYTRIP PVT. LTD." : _ref$mmtText,
      playStoreImgURI = _ref.playStoreImgURI,
      appStoreImgURI = _ref.appStoreImgURI,
      linkedInImgURI = _ref.linkedInImgURI,
      facebookImgURI = _ref.facebookImgURI,
      twitterImgURI = _ref.twitterImgURI,
      mmtIcon = _ref.mmtIcon,
      downIcon = _ref.downIcon,
      footerHeartIcon = _ref.footerHeartIcon;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(-1),
      activeIdx = _useState[0],
      setActiveIdx = _useState[1];

  var optionsHandler = function optionsHandler(index) {
    if (activeIdx === index) {
      setActiveIdx(-1);
      return;
    }

    setActiveIdx(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooter_style_LandingFooterStyle, {
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFooter_style_LandingFooterWrap, {
      "data-test-id": "LandingFooter-LandingFooterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterSection, {
        "data-test-id": "LandingFooter-FooterSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignItems: "center",
          justifyContent: device === "sm" ? "center" : undefined,
          margin: "0px 0px 50px 0px",
          "data-test-id": "LandingFooter-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 8px 4px 0px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextOne
          }), mmtIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "85px",
            height: "27px",
            src: mmtIcon,
            "data-test-id": "LandingFooter-ImageComponent"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* MMTIcon */.Zp, {
            "data-test-id": "LandingFooter-MMTIcon"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: device == "lg" ? "sm" : "xxs",
            margin: "0px 0px 4px 8px",
            color: "white",
            "data-test-id": "LandingFooter-SpanTag",
            children: footerTextTwo
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinksContainer, {
          "data-test-id": "LandingFooter-LinksContainer",
          children: footerData === null || footerData === void 0 ? void 0 : footerData.map(function (item, idx) {
            return (item === null || item === void 0 ? void 0 : item.label) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              onClick: device === "sm" ? function () {
                return optionsHandler(idx);
              } : undefined,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                justifyContent: device === "sm" ? "space-between" : undefined,
                gap: "8px",
                alignItems: "center",
                "data-test-id": "LandingFooter-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                  gap: "10px",
                  "data-test-id": "LandingFooter-FlexComp",
                  children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                    width: "18px",
                    height: "18px",
                    src: item.icon,
                    "data-test-id": "LandingFooter-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                    color: "white",
                    fontWeight: "black",
                    "data-test-id": "LandingFooter-ParaTag",
                    children: item.label
                  })]
                }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronContainerIcon, {
                  isInvert: activeIdx !== idx,
                  "data-test-id": "LandingFooter-ChevronContainerIcon",
                  children: downIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag, {
                    src: downIcon,
                    "data-test-id": "LandingFooter-ImageTag"
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* ChevronUpIcon */.g8, {
                    "data-test-id": "LandingFooter-ChevronUpIcon"
                  })
                })]
              }), device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(function (point) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              }) : activeIdx === idx && /*#__PURE__*/(0,jsx_runtime.jsx)(InnerLinksContainer, {
                "data-test-id": "LandingFooter-InnerLinksContainer",
                children: item.listPoints.map(function (point) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    "data-test-id": "LandingFooter",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
                      color: "#fff",
                      fontSize: "xs",
                      hrefProp: point.link || "#",
                      targetProp: "_blank",
                      "data-test-id": "LandingFooter-AnchorTag",
                      children: point.label
                    })
                  }, point.id);
                })
              })]
            }, item.id);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        flexDirection: device === "sm" ? "column" : undefined,
        justifyContent: "space-between",
        "data-test-id": "LandingFooter-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
            textAlign: device === "lg" ? "left" : "center",
            color: "white",
            "data-test-id": "LandingFooter-ParaTag",
            children: ["\xA9 ", new Date().getFullYear(), " ", mmtText]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
            textAlign: device === "lg" ? "right" : "center",
            "data-test-id": "LandingFooter-ParaTag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              color: "white",
              "data-test-id": "LandingFooter-SpanTag",
              children: countryText
            }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              color: "white",
              fontWeight: "bold",
              "data-test-id": "LandingFooter-SpanTag",
              children: locationText
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var LandingFooter_LandingFooter = (LandingFooter);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter2.style.ts

var LandingFooter2_style_LandingFooterStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingFooter2style__LandingFooterStyle",
  componentId: "sc-1fi2m66-0"
})(["background:#000;padding-top:32px;padding-bottom:64px;width:100%;"]);
var LandingFooter2_style_LandingFooterSub = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterSub",
  componentId: "sc-1fi2m66-1"
})(["display:flex;align-items:center;gap:10px;margin-bottom:14px;", ""], function (p) {
  return p.openedLink && "";
});
var LandingFooter2_style_LandingFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterWrap",
  componentId: "sc-1fi2m66-2"
})(["margin:0 auto;width:1200px;"]);
var LandingFooter2_style_LandingFooterImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterImg",
  componentId: "sc-1fi2m66-3"
})(["width:325px;height:27px;margin-bottom:50px;"]);
var LandingFooter2_style_LandingFooterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingFooter2style__LandingFooterList",
  componentId: "sc-1fi2m66-4"
})(["display:flex;gap:10px;margin-bottom:26px;width:964px;flex-wrap:wrap;margin:", ";li{position:relative;}li:last-child{position:static;}li:after{content:\"\";position:absolute;width:4px;height:4px;border-radius:100%;background:#fff;top:12px;right:-7px;}li:last-child:after{width:0;height:0;}li a{font-weight:400;font-size:12px;line-height:16px;color:#ffffff;}&:last-child{margin-bottom:100px;}", ""], function (props) {
  return props.margin ? props.margin : "";
}, function (props) {
  return props.flexWrap && "\n      height:198px;\n      flex-wrap:wrap;\n  ";
});
var LandingFooter2_style_LandingFooterFlex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterFlex",
  componentId: "sc-1fi2m66-5"
})(["display:flex;gap:95px;margin-top:100px;"]);
var LandingFooter2_style_LandingFooterCopyRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingFooter2style__LandingFooterCopyRight",
  componentId: "sc-1fi2m66-6"
})(["display:flex;flex-direction:column;align-items:flex-end;margin-left:auto;align-self:center;span:nth-child(2){font-weight:600;margin-top:3px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MmtInitiative.png
/* harmony default export */ var icons_MmtInitiative = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/MmtInitiative.3f9ab9c4.png","height":56,"width":652,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAKUlEQVR4nGP8+/WrOBMX16evmzf7/n3w0JovN6f076dPQky8vH8ZgAAAJNgPEW2QH28AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/CitiesIcon.svg
/* harmony default export */ var icons_CitiesIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/CitiesIcon.c19a3538.svg","height":19,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/QuickLinks.svg
/* harmony default export */ var icons_QuickLinks = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/QuickLinks.db19e1dd.svg","height":21,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/FollowIcon.svg
/* harmony default export */ var icons_FollowIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/FollowIcon.4a0bda04.svg","height":20,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlogIcon.svg
/* harmony default export */ var icons_BlogIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/BlogIcon.56d04790.svg","height":21,"width":20});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/twitterIcon.png
/* harmony default export */ var twitterIcon = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-standalone/_next/static/media/twitterIcon.c163d894.png","height":53,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAYFBMVEUlJSUFBQUAAAD////7+/vs6+zc3NzZ2dm0s7QAAAD////7+/vn5+fm5ubl5OXQ0NG+vr62tra0tLWwsLCmpqaLiotzc3Q3Nzc1NTUrKiskJCUiIiIbGxsUFBQODg4AAACkAQV1AAAACnRSTlPm5ub+/v7+/v7+oMtKbgAAADxJREFUeNoNwYcBgCAQBMETIy/mHHD771JmlDknl4jtZQrzJV+XTZFXXixmra2IszfrbsQ+hPEgiu8BIj9b4gPJAqifVwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooterInsurance.tsx














var footerLinks = {
  cities: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  blog: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi", "Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi", "Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  quickLinks: ["Mumbai", "Bengaluru", "Chennai", "Pune", "Hyderabad", "Kolkata", "Lucknow", "Jaipur", "Surat", "Bhopal", "Goa", "Noida", "Thane", "Varanasi"],
  others: ["About us", "Privacy Policy", "User Agreement", " Terms of Services", " Mail us"]
};

var LandingFooterInsurance_LandingFooter = function LandingFooter(_ref) {
  _objectDestructuringEmpty(_ref);

  var _useState = useState(-1),
      link = _useState[0],
      setLink = _useState[1];

  var handleClick = function handleClick(index) {
    index != index ? setLink(index) : setLink(-1);
  };

  return /*#__PURE__*/_jsx(LandingFooterStyle, {
    "data-test-id": "LandingFooter-LandingFooterStyle",
    children: /*#__PURE__*/_jsx(InnerContentWrap, {
      "data-test-id": "LandingFooter-InnerContentWrap",
      children: /*#__PURE__*/_jsxs(LandingFooterWrap, {
        "data-test-id": "LandingFooter-LandingFooterWrap",
        children: [/*#__PURE__*/_jsx(LandingFooterImg, {
          "data-test-id": "LandingFooter-LandingFooterImg",
          children: /*#__PURE__*/_jsx(ImageComponent, {
            width: "325px",
            height: "27px",
            src: MmtInitiative.src,
            "data-test-id": "LandingFooter-ImageComponent"
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: CitiesIcon.src,
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: "BUSINESS CITIES"
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.cities && footerLinks.cities.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                "aria-label": "cities",
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: BlogIcon.src,
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: [" ", "BLOG"]
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.blog && footerLinks.blog.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                "aria-label": "blog",
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: QuickLinks.src,
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: [" ", "QUICK LINKS"]
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.quickLinks && footerLinks.quickLinks.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterSub, {
          "data-test-id": "LandingFooter-LandingFooterSub",
          children: [/*#__PURE__*/_jsx(ImageComponent, {
            width: "20px",
            height: "20px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/other_Icon_5614215b70.png",
            "data-test-id": "LandingFooter-ImageComponent"
          }), /*#__PURE__*/_jsxs(SpanTag, {
            fontSize: "sm",
            fontWeight: "bold",
            color: theme.whiteText,
            "data-test-id": "LandingFooter-SpanTag",
            children: [" ", "OTHERS"]
          })]
        }), /*#__PURE__*/_jsx(LandingFooterList, {
          "data-test-id": "LandingFooter-LandingFooterList",
          children: footerLinks.others && footerLinks.others.map(function (item, index) {
            return /*#__PURE__*/_jsx("li", {
              "data-test-id": `LandingFooter-${index}`,
              children: /*#__PURE__*/_jsx(AnchorTag, {
                color: theme.whiteText,
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: item
              })
            }, index);
          })
        }), /*#__PURE__*/_jsxs(LandingFooterFlex, {
          "data-test-id": "LandingFooter-LandingFooterFlex",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(LandingFooterSub, {
              "data-test-id": "LandingFooter-LandingFooterSub",
              children: [/*#__PURE__*/_jsx(ImageComponent, {
                width: "18px",
                height: "18px",
                src: FollowIcon.src,
                "data-test-id": "LandingFooter-ImageComponent"
              }), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: theme.whiteText,
                "data-test-id": "LandingFooter-SpanTag",
                children: "FOLLOW US"
              })]
            }), /*#__PURE__*/_jsxs(FlexComp, {
              gap: "16px",
              "data-test-id": "LandingFooter-FlexComp",
              children: [/*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: TwitterIcon.src,
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              }), /*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/fb_Icon_8eab71f726.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              }), /*#__PURE__*/_jsx(AnchorTag, {
                "aria-label": "linkedin",
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "27px",
                  height: "27px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/Linkedin_Icon_fec59ba5c7.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(LandingFooterSub, {
              "data-test-id": "LandingFooter-LandingFooterSub",
              children: [/*#__PURE__*/_jsx(ImageComponent, {
                width: "18px",
                height: "18px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/download_Icon_f3c8f1d5d2.png",
                "data-test-id": "LandingFooter-ImageComponent"
              }), /*#__PURE__*/_jsx(SpanTag, {
                fontSize: "sm",
                fontWeight: "bold",
                color: theme.whiteText,
                "data-test-id": "LandingFooter-SpanTag",
                children: "DOWNLOAD"
              })]
            }), /*#__PURE__*/_jsxs(FlexComp, {
              gap: "10px",
              "data-test-id": "LandingFooter-FlexComp",
              children: [/*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "128px",
                  height: "36px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/play_Store_Icon_ddbbe2de64.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              }), /*#__PURE__*/_jsx(AnchorTag, {
                hrefProp: "#",
                "data-test-id": "LandingFooter-AnchorTag",
                children: /*#__PURE__*/_jsx(ImageComponent, {
                  width: "128px",
                  height: "36px",
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/app_Store_Icon_07d258a1b2.png",
                  "data-test-id": "LandingFooter-ImageComponent"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(LandingFooterCopyRight, {
            "data-test-id": "LandingFooter-LandingFooterCopyRight",
            children: [/*#__PURE__*/_jsxs(SpanTag, {
              fontSize: "xs",
              color: theme.whiteText,
              fontWeight: "bold",
              "data-test-id": "LandingFooter-SpanTag",
              children: [" ", "\xA9 2022 MAKEMYTRIP PVT.LTD"]
            }), /*#__PURE__*/_jsx(SpanTag, {
              fontSize: "xs",
              color: theme.whiteText,
              fontWeight: "bold",
              "data-test-id": "LandingFooter-SpanTag",
              children: "Country India"
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var LandingFooterInsurance = ((/* unused pure expression or super */ null && (LandingFooterInsurance_LandingFooter)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeader.style.ts


var LandingHeaderStyle = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderStyle",
  componentId: "sc-2vdv0h-0"
})(["height:80px;width:100%;background:rgba(0,0,0);color:rgba(255,255,255,0.6);z-index:40;box-shadow:0px 1px 16px rgba(0,0,0,0.2);position:sticky;top:0;.displayNone{display:none;}"]);
var LandingHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderWrap",
  componentId: "sc-2vdv0h-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;z-index:100;background:#000;z-index:40;"]);
var TmLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LandingHeaderstyle__TmLogo",
  componentId: "sc-2vdv0h-2"
})(["width:140px;height:40px;flex-shrink:0;opacity:0;"]);
var LandingHeaderList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderList",
  componentId: "sc-2vdv0h-3"
})(["margin-left:auto;display:flex;align-items:center;gap:32px;cursor:pointer;"]);
var LandingHeaderItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderItem",
  componentId: "sc-2vdv0h-4"
})(["position:relative;& a{color:inherit;font-weight:400;font-size:16px;line-height:22px;}&:first-child{margin-right:16px;}&:first-child:after{content:\"\";position:absolute;border:solid #008cff;border-width:0 2px 2px 0;display:inline-block;padding:4px;top:3px;right:-22px;transition:ease-in 0.4s;", " ", "}"], function (p) {
  return p.opened && "\n        transform: rotate(-135deg);\n        -webkit-transform: rotate(-135deg);\n        top: 9px;\n        ";
}, function (p) {
  return p.closed && "\n        transform: rotate(45deg);\n        -webkit-transform: rotate(45deg);\n        ";
});
var LandingHeaderBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderBtn",
  componentId: "sc-2vdv0h-5"
})(["width:90px;height:44px;display:flex;align-items:center;justify-content:center;border:none;outline:none;font-weight:900;color:#008cff;font-size:16px;line-height:20px;margin-left:45px;border-radius:96px;background:linear-gradient(0deg,#ffffff,#ffffff),linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);-webkit-box-shadow:0px 1px 7px rgba(0,0,0,0.2);-webkit-appearance:none;cursor:pointer;"]);
var ProductLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingHeaderstyle__ProductLinks",
  componentId: "sc-2vdv0h-6"
})(["background:#ffffff;box-shadow:0px 2px 16px rgba(0,0,0,0.16);border-radius:6px;padding:24px 16px;position:absolute;top:35px;left:0;width:230px;display:flex;flex-direction:column;gap:24px;a{width:100%;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#4a4a4a;}"]);
var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingHeaderstyle__Flex",
  componentId: "sc-2vdv0h-7"
})(["display:flex;align-items:center;font-weight:700;font-size:10px;line-height:12px;color:#ffffff;cursor:pointer;svg{margin-left:8px;}"]);
var ImageIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingHeaderstyle__ImageIcon",
  componentId: "sc-2vdv0h-8"
})(["width:21px;height:21px;border-radius:100%;margin-right:10px;background:#000;color:#fff;font-weight:700;font-size:10px;line-height:12px;color:#ffffff;display:flex;align-items:center;justify-content:center;flex-shrink:0;"]);
var LandingHeaderMob = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderMob",
  componentId: "sc-2vdv0h-9"
})(["background:#fff;padding:16px;display:flex;flex-direction:column;gap:16px;box-shadow:0px 1px 16px rgba(0,0,0,0.2);position:sticky;top:0;z-index:4;", "{display:flex;}"], TextStyles_style/* AnchorTagStyle */.C2);
var LandingHeaderMobBlack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingHeaderstyle__LandingHeaderMobBlack",
  componentId: "sc-2vdv0h-10"
})(["background:transparent;padding:16px;display:flex;flex-direction:column;gap:16px;position:sticky;top:0;z-index:4;", " ", "{display:flex;}picture{width:75px;height:24px;}", ""], function (p) {
  return p.displayWhiteHeader && "\n    background:#fff;\n    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.2);\n    ";
}, TextStyles_style/* AnchorTagStyle */.C2, function (p) {
  return p.insuranceHeader && "\n    position:fixed;\n    top:0;\n    width:100%;\n    left:0;\n    right:0;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeader.tsx







var productLinks = ["Foreign Currency", "Forex Cards", "Travel Insurance", "Travel Loan", "Foreign Money Trasfer"];

var LandingHeader = function LandingHeader(_ref) {
  var loginState = _ref.loginState,
      logoUrl = _ref.logoUrl;

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var handleClick = function handleClick() {
    setShow(!show);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderStyle, {
    id: "header-id",
    "data-test-id": "LandingHeader-LandingHeaderStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderWrap, {
      id: "headerWrap-id",
      "data-test-id": "LandingHeader-LandingHeaderWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        "data-test-id": "LandingHeader-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* TripMoneyLogo */.im, {
          "data-test-id": "LandingHeader-TripMoneyLogo"
        })
      }), !loginState && /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderList, {
          "data-test-id": "LandingHeader-LandingHeaderList",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderItem, {
            opened: show,
            closed: !show,
            onClick: handleClick,
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              hrefProp: "#",
              "aria-label": "products",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "Products"
            }), show && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductLinks, {
              "data-test-id": "LandingHeader-ProductLinks",
              children: productLinks && productLinks.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
                  hrefProp: "#",
                  "data-test-id": `LandingHeader-AnchorTag-${index}`,
                  children: item
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderItem, {
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              hrefProp: "#",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "Blogs"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderItem, {
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              hrefProp: "#",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "FAQ\u2019s"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderItem, {
            "data-test-id": "LandingHeader-LandingHeaderItem",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              hrefProp: "#",
              "data-test-id": "LandingHeader-AnchorTag",
              children: "About Us"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBtn, {
          "data-test-id": "LandingHeader-LandingHeaderBtn",
          children: "LOGIN"
        })]
      }), loginState && /*#__PURE__*/(0,jsx_runtime.jsxs)(Flex, {
        "data-test-id": "LandingHeader-Flex",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageIcon, {
          "data-test-id": "LandingHeader-ImageIcon",
          children: "C"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xxs",
          color: Global/* theme.whiteText */.rS.whiteText,
          fontWeight: "bold",
          "data-test-id": "LandingHeader-SpanTag",
          children: "Hey Chavi"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "14px",
          height: "14px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/white_Chev_8257cb46d7.svg",
          "data-test-id": "LandingHeader-ImageComponent"
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingHeader_LandingHeader = (LandingHeader);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hooks/index.ts + 3 modules
var hooks = __webpack_require__(736);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderBackButton.tsx





var LandingHeaderBackButton = function LandingHeaderBackButton(props) {
  var serverReferrer = (0,hooks/* useReferrerContext */.u)();
  var handleBackButton = serverReferrer ? function () {
    return navigation/* navigationActions.goBack */.e.goBack();
  } : function () {
    return history.back();
  };
  var _props$handleBackBtn = props.handleBackBtn,
      handleBackBtn = _props$handleBackBtn === void 0 ? handleBackButton : _props$handleBackBtn,
      displayWhiteHeader = props.displayWhiteHeader;
  return handleBackBtn ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
    handleClick: handleBackBtn,
    "data-test-id": "LandingHeaderBackButton-AnchorTag",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z",
        fill: "#4A4A4A"
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: {
      width: "24px",
      height: "24px"
    }
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderMobile.tsx











var LandingHeaderMobile = function LandingHeaderMobile(_ref) {
  var handleBackBtn = _ref.handleBackBtn,
      headerTitle = _ref.headerTitle,
      children = _ref.children,
      myOrders = _ref.myOrders,
      goToMyOrders = _ref.goToMyOrders,
      displayWhiteHeader = _ref.displayWhiteHeader,
      partnerType = _ref.partnerType,
      insuranceHeader = _ref.insuranceHeader;

  var _useState = (0,react.useState)(0),
      scrollPos = _useState[0],
      setScrollPos = _useState[1];

  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      setScrollPos(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  var blackHeaderStyle = {
    display: scrollPos > 40 ? "none" : "block"
  };
  var whiteHeaderStyle = {
    display: scrollPos > 40 ? "block" : "none"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderMobBlack, {
      displayWhiteHeader: displayWhiteHeader,
      id: "blackHeader",
      style: blackHeaderStyle,
      insuranceHeader: insuranceHeader,
      "data-test-id": "LandingHeaderMobile-LandingHeaderMobBlack",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "12px",
        alignItems: "center",
        justifyContent: displayWhiteHeader ? "flex-start" : "space-between",
        "data-test-id": "LandingHeaderMobile-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBackButton, {
          handleBackBtn: handleBackBtn,
          "data-test-id": "LandingHeaderMobile-LandingHeaderBackButton"
        }), headerTitle && displayWhiteHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "LandingHeaderMobile-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: headerTitle,
            "data-test-id": "LandingHeaderMobile-FormattedText"
          })
        }), device == "sm" && myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "75px",
          height: "24px",
          src: partnerType === src.PARTNER.MMT ? "https://tripmoneycmsimgak.mmtcdn.com/img/Group_46_699159e12c.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_512_6736e70735.png",
          "data-test-id": "LandingHeaderMobile-ImageComponent"
        }), myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          color: Global_theme.blueText,
          fontWeight: "bold",
          handleClick: goToMyOrders,
          "data-test-id": "LandingHeaderMobile-AnchorTag",
          children: "My Orders"
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingHeaderMob, {
      id: "whiteHeader",
      style: whiteHeaderStyle,
      "data-test-id": "LandingHeaderMobile-LandingHeaderMob",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "12px",
        alignItems: "center",
        "data-test-id": "LandingHeaderMobile-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderBackButton, {
          handleBackBtn: handleBackBtn,
          displayWhiteHeader: true,
          "data-test-id": "LandingHeaderMobile-LandingHeaderBackButton"
        }), headerTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "LandingHeaderMobile-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: headerTitle,
            "data-test-id": "LandingHeaderMobile-FormattedText"
          })
        }), myOrders && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          margin: "0 0 0 auto",
          fontWeight: "bold",
          handleClick: goToMyOrders,
          "data-test-id": "LandingHeaderMobile-AnchorTag",
          children: "My Orders"
        })]
      }), children]
    })]
  });
};

/* harmony default export */ var LandingHeader_LandingHeaderMobile = (LandingHeaderMobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.style.ts



var LandingInput_style_InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingInputstyle__InputWrap",
  componentId: "sc-1tw2ggf-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;width:100%;label{font-weight:700;font-size:14px;line-height:16px;color:#4a4a4a;display:block;margin-bottom:8px;transition:all 0.3s ease;display:inline-block;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inputWidth;
}, function (p) {
  return p.flex ? p.flex : "";
});
var LandingInput_style_ErrorTxt = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "LandingInputstyle__ErrorTxt",
  componentId: "sc-1tw2ggf-1"
})(["color:#eb2026;"]);
var LandingInput_style_LandingInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "LandingInputstyle__LandingInputStyle",
  componentId: "sc-1tw2ggf-2"
})(["background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;padding:10px;font-weight:900;font-size:14px;line-height:19px;width:100%;height:41px;&::placeholder{font-weight:400 !important;color:rgba(0,0,0,0.3) !important;}&:focus + label{color:#008cff;}", " ", " @media ", "{width:calc(100vw - 32px);}", " &:focus{outline:none;border:1px solid #008cff;background:#f9fcff;}&[type=\"number\"]::-webkit-outer-spin-button,&[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=\"number\"]{-moz-appearance:textfield;}"], function (props) {
  return props.disableState && "\n      opacity: 0.3;\n      pointer-events: none;\n\t";
}, function (props) {
  return props.errorState && "\n      border: 1px solid #EB2026;\n\t";
}, static_utils/* deviceType.mobile */.vO.mobile, function (props) {
  return props.Verify && "\n      color: #008CFF;\n      background: #F9FCFF;\n      border: 1px solid #008CFF;\n      pointer-events: none;\n\t";
});
var CalenderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingInputstyle__CalenderWrap",
  componentId: "sc-1tw2ggf-3"
})(["cursor:pointer;position:absolute;right:16px;top:36px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.tsx







var LandingInput = function LandingInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      Verify = _ref.Verify,
      flex = _ref.flex,
      requiredField = _ref.requiredField,
      handleKeyDown = _ref.handleKeyDown,
      maxInputLength = _ref.maxInputLength,
      inputType = _ref.inputType,
      handleFocus = _ref.handleFocus,
      handleBlur = _ref.handleBlur,
      maxValue = _ref.maxValue,
      minValue = _ref.minValue,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "on" : _ref$autoComplete,
      calender = _ref.calender,
      handleOpenCalender = _ref.handleOpenCalender,
      autofocus = _ref.autofocus,
      isDisabled = _ref.isDisabled;

  var handleMouseWheel = function handleMouseWheel(event) {
    event.preventDefault();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingInput_style_InputWrap, {
    margin: margin,
    flex: flex,
    inputWidth: inputWidth,
    Verify: Verify,
    "data-test-id": "LandingInput-InputWrap",
    children: [labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: labelTxt,
      "data-test-id": "LandingInput-label",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "LandingInput-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_style_LandingInputStyle, {
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      errorState: errorState,
      id: labelTxt,
      disableState: disableState,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      min: minValue,
      max: maxValue,
      onWheel: handleMouseWheel,
      autoComplete: autoComplete,
      autoFocus: autofocus,
      inputWidth: inputWidth,
      disabled: isDisabled,
      "data-test-id": "LandingInput-LandingInputStyle"
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_style_ErrorTxt, {
      txtfontSize: "xs",
      margin: "4px 0 0",
      txtcolor: Global/* theme.redText */.rS.redText,
      txtfontWeight: "bold",
      "data-test-id": "LandingInput-ErrorTxt",
      children: errorState
    }), calender && /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderWrap, {
      onClick: handleOpenCalender,
      "data-test-id": "LandingInput-CalenderWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Calendar_b8e9e22a64.svg",
        "data-test-id": "LandingInput-ImageComponent"
      })
    })]
  });
};

/* harmony default export */ var LandingInput_LandingInput = (LandingInput);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.style.ts



var LandingTestimonialsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestimonialsStyle",
  componentId: "sc-1au5c5p-0"
})(["display:flex;background:#fff;flex-direction:column;margin-bottom:137px;width:100%;@media ", "{margin-bottom:40px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingTestTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestTitle",
  componentId: "sc-1au5c5p-1"
})(["font-family:\"Lato\";font-weight:500;font-size:56px;line-height:72px;color:#000000;margin-bottom:34px;display:flex;align-items:center;@media ", "{font-size:24px;line-height:32px;margin-bottom:12px;padding:0px 16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var TestimonialContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialContent",
  componentId: "sc-1au5c5p-2"
})(["display:flex;margin-bottom:8px;> img{margin-right:17px;border-radius:8px;}"]);
var LandingTest = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTest",
  componentId: "sc-1au5c5p-3"
})(["display:inline-block;img{object-fit:contain;}@media ", "{font-weight:400;color:#4a4a4a;align-items:flex-start;border-radius:10px;position:relative;background:#fff;z-index:1;width:100% !important;flex-direction:column !important;padding:4px 16px;font-size:14px;line-height:20px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingTestWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestWrap",
  componentId: "sc-1au5c5p-4"
})(["display:flex;width:575px;padding:32px 30px;background:#fff;position:relative;z-index:1;border-radius:10px;margin-right:20px;", "{white-space:initial;}@media ", "{width:unset;padding:16px;", "{font-size:14px;line-height:20px;}box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:10px;margin-right:unset;}"], TextStyles_style/* ParaTagStyle */.OG, static_utils/* deviceType.mobile */.vO.mobile, TextStyles_style/* ParaTagStyle */.OG);
var LandingTestImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestImg",
  componentId: "sc-1au5c5p-5"
})(["width:150px;height:250px;flex-shrink:0;position:relative;margin-right:20px;z-index:1;> img{border-radius:20px;}@media ", "{width:84px;height:87px;display:flex;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingTextCrd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTextCrd",
  componentId: "sc-1au5c5p-6"
})(["padding:4px 8px 4px 8px;border-radius:19px;font-weight:700;font-size:12px;line-height:11px;color:#fff;position:absolute;bottom:-7px;left:25px;text-transform:uppercase;", " ", " @media ", "{position:static;width:fit-content;}"], function (p) {
  return p.cardType == "travelLoan" && "\n    background: linear-gradient(88.44deg, #43e1a8 0.02%, #28beb2 100.01%);\n    ";
}, function (p) {
  return p.cardType == "forexCard" && "\n    background: linear-gradient(85.23deg, #ff7f3f 0%, #ff3e5e 100%);\n    ";
}, static_utils/* deviceType.mobile */.vO.mobile);
var PersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__PersonName",
  componentId: "sc-1au5c5p-7"
})(["font-weight:700;font-size:24px;line-height:36px;color:#012136;margin-bottom:2px;display:block;@media ", "{font-size:16px;line-height:20px;font-weight:900;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "LandingTestimonialsstyle__Date",
  componentId: "sc-1au5c5p-8"
})(["font-weight:400;font-size:14px;line-height:18px;color:#9b9b9b;@media ", "{font-size:12px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingTestCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__LandingTestCntnt",
  componentId: "sc-1au5c5p-9"
})(["z-index:1;@media ", "{white-space:initial;}"], static_utils/* deviceType.mobile */.vO.mobile);
var LandingTestimonials_style_Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__Flex",
  componentId: "sc-1au5c5p-10"
})(["display:flex;width:100%;margin-bottom:8px;"]);
var SlideShowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowContainer",
  componentId: "sc-1au5c5p-11"
})(["margin:0 auto;overflow:hidden;max-width:1200px;@media ", "{max-width:100%;cursor:grab;}"], static_utils/* deviceType.mobile */.vO.mobile);
var SlideShowSLider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowSLider",
  componentId: "sc-1au5c5p-12"
})(["white-space:nowrap;transition:ease 1000ms;"]);
var SlideDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideDots",
  componentId: "sc-1au5c5p-13"
})(["text-align:center;@media ", "{margin-top:12px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var SlideShowDotItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__SlideShowDotItem",
  componentId: "sc-1au5c5p-14"
})(["background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;", ""], function (p) {
  return p.active && "\n        width: 32px;\n        height: 12px;\n        background: #000000 !important;\n        opacity: 1;\n        border-radius: 6px;\n        ";
});
var StarRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRating",
  componentId: "sc-1au5c5p-15"
})(["display:flex;gap:8px;", " @media ", "{gap:5px;}"], function (p) {
  return p.starRateFull && "\n    position: absolute;\n    top: 0;\n    ";
}, static_utils/* deviceType.mobile */.vO.mobile);
var StarRatingWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__StarRatingWrap",
  componentId: "sc-1au5c5p-16"
})(["margin-bottom:12px;position:relative;"]);
var TestimonialTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "LandingTestimonialsstyle__TestimonialTag",
  componentId: "sc-1au5c5p-17"
})(["background:rgba(120,198,255,0.2);border:1px solid rgba(120,198,255,0.4);border-radius:8px;padding:2px 12px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.tsx











var LandingTestimonials = function LandingTestimonials(_ref) {
  var customTitle = _ref.customTitle,
      test = _ref.test;

  var _useState = (0,react.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var _useState2 = (0,react.useState)(test === null || test === void 0 ? void 0 : test.length),
      length = _useState2[0],
      setLength = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      touchPosition = _useState3[0],
      setTouchPosition = _useState3[1];

  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState4 = (0,react.useState)(false),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  (0,react.useEffect)(function () {
    setLength(test === null || test === void 0 ? void 0 : test.length);
  }, [test]);

  var next = function next() {
    if (currentIndex < length - 1) {
      setCurrentIndex(function (prevState) {
        return prevState + 1;
      });
    }
  };

  var prev = function prev() {
    if (currentIndex > 0) {
      setCurrentIndex(function (prevState) {
        return prevState - 1;
      });
    }
  };

  var handleTouchStart = function handleTouchStart(e) {
    var touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  var handleTouchMove = function handleTouchMove(e) {
    var touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    var currentTouch = e.touches[0].clientX;
    var diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);

    if (isHovered) {
      resetTimeout();
    }
  };

  var timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(function () {
    resetTimeout();
    timeoutRef.current = window.setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
    return function () {
      resetTimeout();
      timeoutRef.current = window.setTimeout(function () {
        return setCurrentIndex(function (prevIndex) {
          return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
        });
      }, 2500);
    };
  }, [currentIndex]);

  var handleMouseEnter = function handleMouseEnter() {
    setIsHovered(true);
    resetTimeout();
  };

  var handleMouseLeave = function handleMouseLeave() {
    setIsHovered(false);
    resetTimeout();
    timeoutRef.current = window.setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === (test === null || test === void 0 ? void 0 : test.length) - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonialsStyle, {
    "data-test-id": "LandingTestimonials-LandingTestimonialsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "LandingTestimonials-InnerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestTitle, {
        "data-test-id": "LandingTestimonials-LandingTestTitle",
        children: [customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: customTitle,
          "data-test-id": "LandingTestimonials-FormattedText"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: device == "lg" ? "66px" : "32px",
          height: device == "lg" ? "66px" : "32px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/heart_9289dd4a1d.svg",
          "data-test-id": "LandingTestimonials-ImageComponent"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlideShowContainer, {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-test-id": "LandingTestimonials-SlideShowContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowSLider, {
          style: {
            transform: "translateX(-".concat(currentIndex * (device === "lg" ? 50 : 100), "%)")
          },
          "data-test-id": "LandingTestimonials-SlideShowSLider",
          children: test && test.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTest, {
              "data-test-id": `LandingTestimonials-LandingTest-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestWrap, {
                "data-test-id": "LandingTestimonials-LandingTestWrap",
                children: [device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestImg, {
                  "data-test-id": "LandingTestimonials-LandingTestImg",
                  children: [item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                    width: "150",
                    height: "250",
                    alt: "hello",
                    src: item.personImg.src,
                    "data-test-id": "LandingTestimonials-ImageComponent"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                    cardType: item.personCrdClass,
                    "data-test-id": "LandingTestimonials-LandingTextCrd",
                    children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                      value: item.personCard,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTestCntnt, {
                  "data-test-id": "LandingTestimonials-LandingTestCntnt",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TestimonialContent, {
                    "data-test-id": "LandingTestimonials-TestimonialContent",
                    children: [device !== "lg" && item.personImg && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                      width: "84",
                      height: "87",
                      alt: "",
                      src: item.personImg.src
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonName, {
                        "data-test-id": "LandingTestimonials-PersonName",
                        children: item.personName && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                          value: item.personName,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StarRatingWrap, {
                        "data-test-id": "LandingTestimonials-StarRatingWrap",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: 5
                          }, function (_, index) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarEmpty */.rj, {
                              height: device !== "lg" ? 16 : 25,
                              width: device !== "lg" ? 16 : 26,
                              "data-test-id": `LandingTestimonials-StarEmpty-${index}`
                            }, index);
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StarRating, {
                          starRateFull: true,
                          "data-test-id": "LandingTestimonials-StarRating",
                          children: Array.from({
                            length: Number(item.personRating)
                          }, function (_, index) {
                            return /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* StarFull */.Um, {
                              height: device !== "lg" ? 16 : 25,
                              width: device !== "lg" ? 16 : 26,
                              "data-test-id": `LandingTestimonials-StarFull-${index}`
                            }, index);
                          })
                        })]
                      }), device !== "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTextCrd, {
                        "data-test-id": "LandingTestimonials-LandingTextCrd",
                        children: item.personCard && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                          value: item.personCard,
                          "data-test-id": "LandingTestimonials-FormattedText"
                        })
                      })]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                    fontSize: "md",
                    color: Global/* theme.greyText */.rS.greyText,
                    "data-test-id": "LandingTestimonials-ParaTag",
                    children: item.testInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                      value: item.testInfo,
                      "data-test-id": "LandingTestimonials-FormattedText"
                    })
                  })]
                })]
              })
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
          "data-test-id": "LandingTestimonials-SlideDots",
          children: test === null || test === void 0 ? void 0 : test.map(function (_, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(SlideShowDotItem, {
              active: currentIndex === idx,
              onClick: function onClick() {
                setCurrentIndex(idx);
              },
              "data-test-id": `LandingTestimonials-SlideShowDotItem-${idx}`
            }, idx);
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var LandingTestimonials_LandingTestimonials = (LandingTestimonials);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryFormatter/index.tsx





function CountryFormatter(_ref) {
  var title = _ref.title;

  var _useState = (0,react.useState)(),
      country = _useState[0],
      setCountry = _useState[1];

  var _useState2 = (0,react.useState)(),
      count = _useState2[0],
      setCount = _useState2[1];

  (0,react.useEffect)(function () {
    if (title && (title === null || title === void 0 ? void 0 : title.length) > 30) {
      var _title$substring;

      var tempCountry = title === null || title === void 0 ? void 0 : (_title$substring = title.substring(0, 30)) === null || _title$substring === void 0 ? void 0 : _title$substring.split(/[,&]/);

      if (tempCountry.length > 1) {
        tempCountry.pop();
      }

      setCountry(tempCountry === null || tempCountry === void 0 ? void 0 : tempCountry.join(", "));
      var tempCount = title && (title === null || title === void 0 ? void 0 : title.split(/[,&]/).length) - tempCountry.length;
      setCount(tempCount);
    } else {
      setCountry(title);
    }
  }, [title]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [country, title && (title === null || title === void 0 ? void 0 : title.length) > 30 ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      style: {
        fontSize: 12,
        marginLeft: 0,
        color: "#9B9B9B"
      },
      "data-test-id": "",
      children: " ...  +".concat(count, " more")
    }) : null]
  });
}

/* harmony default export */ var components_CountryFormatter = (CountryFormatter);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.style.ts





var ListingEditDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListingEditDetailsstyle__ListingEditDetailsStyle",
  componentId: "sc-18qpjo8-0"
})(["background:#fff;border:1px solid rgba(242,242,242,0.16);border-radius:8px;padding:24px;& > ", ":first-child{margin-bottom:8px;}@media ", "{padding:12px 16px;& > ", ":first-child{margin-bottom:0px;}}"], FlexCompStyle, src.deviceType.mobile, FlexCompStyle);
var ListingWidgetDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListingEditDetailsstyle__ListingWidgetDetails",
  componentId: "sc-18qpjo8-1"
})(["background:#f6f6f6;border-radius:4px;padding:12px;"]);
var ListingEditDetails_style_ListingSpan = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "ListingEditDetailsstyle__ListingSpan",
  componentId: "sc-18qpjo8-2"
})(["font-size:14px;line-height:20px;color:", ";padding-right:12px;margin-right:12px;position:relative;flex-shrink:0;&:last-child{border:none;flex-shrink:unset;}&:after{content:\"\";position:absolute;right:0;top:4px;width:1px;height:14px;background:#000;}&:last-child:after{width:0;}@media ", "{font-size:12px;}"], Global/* theme.blackText */.rS.blackText, src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.tsx












var ListingEditDetails_analytics = (0,insurance/* getAnalytics */.I)();

var ListingEditDetails = function ListingEditDetails(_ref) {
  var mode = _ref.mode,
      title = _ref.title,
      travelPurpose = _ref.travelPurpose,
      travelDates = _ref.travelDates,
      travellerCount = _ref.travellerCount,
      showEditIcon = _ref.showEditIcon;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _ref2 = travelDates || {},
      startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  var handleEditClick = function handleEditClick() {
    ListingEditDetails_analytics === null || ListingEditDetails_analytics === void 0 ? void 0 : ListingEditDetails_analytics.trackListingEvents({
      actionType: "edit_clicked"
    });
    var referrer = document.referrer;
    var hostname = referrer ? new URL(referrer).hostname : "";

    if (hostname === "www.makemytrip.com" || hostname === "www.goibibo.com") {
      navigation/* navigationActions.goBack */.e.goBack();
    }

    var queryParams = new URLSearchParams(window.location.search);
    var params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment")
    };
    navigation/* navigationActions.navigateToLanding */.e.navigateToLanding(params, false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingEditDetailsStyle, {
    "data-test-id": "ListingEditDetails-ListingEditDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      alignItems: "enter",
      justifyContent: "space-between",
      flexWrap: "wrap",
      "data-test-id": "ListingEditDetails-FlexComp",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components_CountryFormatter, {
          title: title,
          "data-test-id": "ListingEditDetails-CountryFormatter"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        fontSize: "md",
        fontWeight: "black",
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ParaTag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(components_CountryFormatter, {
          title: title,
          "data-test-id": "ListingEditDetails-CountryFormatter"
        })
      }), showEditIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        handleClick: handleEditClick,
        "data-test-id": "ListingEditDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "25px",
          height: "25px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg",
          "data-test-id": "ListingEditDetails-ImageComponent"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      "data-test-id": "ListingEditDetails-FlexComp",
      children: [mode && /*#__PURE__*/(0,jsx_runtime.jsx)(ListingEditDetails_style_ListingSpan, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ListingSpan",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "md",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "ListingEditDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: mode,
            "data-test-id": "ListingEditDetails-FormattedText"
          })
        })
      }), startDate && endDate && /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingEditDetails_style_ListingSpan, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ListingSpan",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: [(0,utils/* formatDate */.p6)(startDate, src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(startDate, src.DATE_FORMATS.YY), " -To-", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: [(0,utils/* formatDate */.p6)(endDate, src.DATE_FORMATS["D MMM"]), "'"]
        }), (0,utils/* formatDate */.p6)(endDate, src.DATE_FORMATS.YY)]
      }), travellerCount && travellerCount > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingEditDetails_style_ListingSpan, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ListingEditDetails-ListingSpan",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: [travellerCount, "\xA0"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: "md",
          "data-test-id": "ListingEditDetails-SpanTag",
          children: travellerCount > 1 ? "Travellers" : "Traveller"
        })]
      }) : null]
    })]
  });
};

/* harmony default export */ var ListingEditDetails_ListingEditDetails = (ListingEditDetails);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.style.ts


var ListingTravelDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListingTravelDetailsstyle__ListingTravelDetailsStyle",
  componentId: "za921k-0"
})(["background:#fff;border:1px solid rgba(242,242,242,0.16);border-radius:8px;padding:24px;@media ", "{padding:12px 16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.tsx








var ListingTravelDetails_analytics = (0,insurance/* getAnalytics */.I)();

var ListingTravelDetails = function ListingTravelDetails(_ref) {
  var _previewBenefits$bene, _previewBenefits$bene2, _previewBenefits$bene3;

  var data = _ref.data,
      tnc = _ref.tnc,
      handleTnc = _ref.handleTnc,
      handleViewBenefits = _ref.handleViewBenefits,
      previewBenefits = _ref.previewBenefits,
      vendorDisplayIcon = _ref.vendorDisplayIcon,
      addOnProductDetails = _ref.addOnProductDetails;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _ref2 = data || {},
      planType = _ref2.planType,
      planName = _ref2.planName,
      sumInsured = _ref2.sumInsured,
      amountToPay = _ref2.amountToPay,
      editEnabled = _ref2.editEnabled,
      priceDetails = _ref2.priceDetails;

  var handleEditClick = function handleEditClick() {
    ListingTravelDetails_analytics === null || ListingTravelDetails_analytics === void 0 ? void 0 : ListingTravelDetails_analytics.trackTravDetailsEvents({
      actionType: "edit_product_clicked"
    });
    var referrer = document.referrer;
    var hostname = referrer ? new URL(referrer).hostname : "";

    if (hostname === "www.makemytrip.com" || hostname === "www.goibibo.com") {
      navigation/* navigationActions.goBack */.e.goBack();
    }

    var queryParams = new URLSearchParams(window.location.search);
    var params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment")
    };
    navigation/* navigationActions.navigateToListing */.e.navigateToListing(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingTravelDetailsStyle, {
    "data-test-id": "ListingTravelDetails-ListingTravelDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      margin: "0 0 4px",
      justifyContent: "space-between",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [planType && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "xs",
          fontWeight: "black",
          margin: "0 0 4px",
          "data-test-id": "ListingTravelDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: planType,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        }), addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.productTitle ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "ListingTravelDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.productTitle,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        }) : planName && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "ListingTravelDetails-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: planName,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        })]
      }), previewBenefits ? /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "38px",
        height: "38px",
        src: vendorDisplayIcon,
        "data-test-id": "ListingTravelDetails-ImageComponent"
      }) : editEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        handleClick: handleEditClick,
        "data-test-id": "ListingTravelDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "25px",
          height: "25px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg",
          "data-test-id": "ListingTravelDetails-ImageComponent"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      borderBottom: previewBenefits ? "" : "1px solid rgba(242, 242, 242, 0.2)",
      alignItems: device == "lg" ? "center" : "flex-start",
      gap: "6px",
      margin: "0 0 8px",
      padding: "0 0 8px",
      flexDirection: device == "lg" ? "row" : "column",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: sumInsured && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontWeight: "bold",
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: device == "lg" ? "sm" : "xs",
          "data-test-id": "ListingTravelDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: sumInsured,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        })
      })
    }), previewBenefits && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      borderBottom: "1px solid rgba(242, 242, 242, 0.2)",
      flexDirection: "column",
      margin: "-8px 0 4px",
      padding: "0 0 4px",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: [previewBenefits === null || previewBenefits === void 0 ? void 0 : (_previewBenefits$bene = previewBenefits.benefits) === null || _previewBenefits$bene === void 0 ? void 0 : (_previewBenefits$bene2 = _previewBenefits$bene[0].features) === null || _previewBenefits$bene2 === void 0 ? void 0 : (_previewBenefits$bene3 = _previewBenefits$bene2.map) === null || _previewBenefits$bene3 === void 0 ? void 0 : _previewBenefits$bene3.call(_previewBenefits$bene2, function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          justifyContent: "space-between",
          "data-test-id": "ListingTravelDetails-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            justifyContent: "space-between",
            "data-test-id": "ListingTravelDetails-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "16px",
              height: "16px",
              src: item === null || item === void 0 ? void 0 : item.icon,
              margin: "0 20px 4px 0",
              "data-test-id": "ListingTravelDetails-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              color: Global/* theme.blackText */.rS.blackText,
              fontSize: "xs",
              "data-test-id": "ListingTravelDetails-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.name,
                "data-test-id": "ListingTravelDetails-FormattedText"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            color: Global/* theme.blackText */.rS.blackText,
            fontSize: "xs",
            fontWeight: "bold",
            "data-test-id": "ListingTravelDetails-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.cover,
              "data-test-id": "ListingTravelDetails-FormattedText"
            })
          })]
        });
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        targetProp: "_blank",
        handleClick: handleViewBenefits,
        "data-test-id": "ListingTravelDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: previewBenefits === null || previewBenefits === void 0 ? void 0 : previewBenefits.ctaText,
          baseStyle: {
            fontWeight: "700",
            fontSize: "12px"
          },
          "data-test-id": "ListingTravelDetails-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      alignItems: "center",
      gap: "4px",
      justifyContent: "space-between",
      "data-test-id": "ListingTravelDetails-FlexComp",
      children: [priceDetails ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        alignItems: "center",
        gap: "4px",
        "data-test-id": "ListingTravelDetails-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: device == "lg" ? "md" : "sm",
          "data-test-id": "ListingTravelDetails-SpanTag",
          children: [(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.title,
            "data-test-id": "ListingTravelDetails-FormattedText"
          }), (priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.originalPrice) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.originalAmountToPay ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.originalAmountToPay : priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.originalPrice,
            baseStyle: {
              textDecoration: "line-through",
              textDecorationThickness: 0.8
            },
            "data-test-id": "ListingTravelDetails-FormattedText"
          }), (priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.discountedPrice) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.totalAmountToPay ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.totalAmountToPay : priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.discountedPrice,
            baseStyle: {
              fontWeight: 900
            },
            "data-test-id": "ListingTravelDetails-FormattedText"
          })]
        })
      }) : amountToPay && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        alignItems: "center",
        gap: "4px",
        "data-test-id": "ListingTravelDetails-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          color: Global/* theme.blackText */.rS.blackText,
          fontSize: device == "lg" ? "md" : "sm",
          "data-test-id": "ListingTravelDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: amountToPay,
            "data-test-id": "ListingTravelDetails-FormattedText"
          })
        })
      }), (tnc === null || tnc === void 0 ? void 0 : tnc.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        targetProp: "_blank",
        handleClick: handleTnc,
        hrefProp: addOnProductDetails !== null && addOnProductDetails !== void 0 && addOnProductDetails.tncLink ? addOnProductDetails === null || addOnProductDetails === void 0 ? void 0 : addOnProductDetails.tncLink : tnc.url,
        fontSize: "xs",
        fontWeight: "black",
        "data-test-id": "ListingTravelDetails-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: tnc.title,
          "data-test-id": "ListingTravelDetails-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var ListingTravelDetails_ListingTravelDetails = (ListingTravelDetails);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsurance.style.ts



var ManageInsuranceStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceStyle",
  componentId: "zxsmvf-0"
})(["background:linear-gradient(46.21deg,#f7f4ff 0.78%,#dceaff 97.21%),#ffffff;border:1px solid #ffffff;border-radius:16px;padding:10px 16px;position:relative;overflow:hidden;> img{position:absolute;top:-7px;right:-7px;}svg{fill:#fff;}"]);
var ManageInsuranceInfo = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceInfo",
  componentId: "zxsmvf-1"
})(["margin-bottom:8px;font-size:12px;line-height:16px;color:#4a4a4a;span{font-weight:800;}"]);
var ManageInsurance_style_ManageInsuranceStyleShimmer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceStyleShimmer",
  componentId: "zxsmvf-2"
})(["background:#e2e2e2;border-radius:4px;height:176px;padding:16px;display:flex;"]);
var TitleText = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* ParaTagStyle */.OG).withConfig({
  displayName: "ManageInsurancestyle__TitleText",
  componentId: "zxsmvf-3"
})(["max-width:200px;font-size:16px;font-weight:900;margin-bottom:8px;"]);
var InfoText = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* ParaTagStyle */.OG).withConfig({
  displayName: "ManageInsurancestyle__InfoText",
  componentId: "zxsmvf-4"
})(["width:95%;font-size:12px;margin-bottom:8px;color:#4a4a4a;@media ", "{width:80%;}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsurance.tsx







var ManageInsurance = function ManageInsurance(_ref) {
  var title = _ref.title,
      info = _ref.info,
      orderBtn = _ref.orderBtn,
      handleManageOrder = _ref.handleManageOrder,
      goHomeText = _ref.goHomeText;

  var gotoHome = function gotoHome() {
    navigation/* navigationActions.navigateToLanding */.e.navigateToLanding();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ManageInsuranceStyle, {
    "data-test-id": "ManageInsurance-ManageInsuranceStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: "104px",
      height: "104px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/manage_Ins_Bg_410326bba8.svg",
      "data-test-id": "ManageInsurance-ImageComponent"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TitleText, {
      "data-test-id": "ManageInsurance-TitleText",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "ManageInsurance-FormattedText"
      })
    }), info && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoText, {
      "data-test-id": "ManageInsurance-InfoText",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: info,
        "data-test-id": "ManageInsurance-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      btnRightIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/white_Chev_8257cb46d7.svg",
      customWidth: "100%",
      customTitle: orderBtn,
      onClick: handleManageOrder,
      "data-test-id": "ManageInsurance-LandingButton"
    }), goHomeText && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      margin: "16px 0 0",
      isCursorPointer: true,
      alignItems: "center",
      gap: "4px",
      handleClick: gotoHome,
      "data-test-id": "ManageInsurance-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        textTransform: "uppercase",
        fontSize: "xs",
        fontWeight: "black",
        "data-test-id": "ManageInsurance-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: goHomeText,
          "data-test-id": "ManageInsurance-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/right_arrow_4a1f2bfef9.svg",
        "data-test-id": "ManageInsurance-ImageComponent"
      })]
    })]
  });
};

/* harmony default export */ var ManageInsurance_ManageInsurance = (ManageInsurance);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsuranceShimmer.tsx






var ManageInsuranceShimmer = function ManageInsuranceShimmer(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsx(ManageInsuranceStyleShimmer, {
    "data-test-id": "ManageInsuranceShimmer-ManageInsuranceStyleShimmer",
    children: /*#__PURE__*/_jsx(ShimmerVersion3, {
      margin: "auto 0 0",
      height: "44px",
      width: "100%",
      "data-test-id": "ManageInsuranceShimmer-ShimmerVersion3"
    })
  });
};

/* harmony default export */ var ManageInsurance_ManageInsuranceShimmer = ((/* unused pure expression or super */ null && (ManageInsuranceShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.style.ts

var NoInsurancePlan_style_NoInsurancePlanStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NoInsurancePlanstyle__NoInsurancePlanStyle",
  componentId: "qwiuqk-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;padding:32px;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.tsx









var NoInsurancePlan = function NoInsurancePlan(_ref) {
  var title = _ref.title,
      info = _ref.info;
  var device = useBreakpointV2();
  return /*#__PURE__*/_jsxs(NoInsurancePlanStyle, {
    "data-test-id": "NoInsurancePlan-NoInsurancePlanStyle",
    children: ["\xA0\xA0", " ", /*#__PURE__*/_jsx(ImageComponent, {
      width: "80px",
      height: "80px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/No_Ins_Icon_55794fe5f5.svg",
      "data-test-id": "NoInsurancePlan-ImageComponent"
    }), title && /*#__PURE__*/_jsx(ParaTag, {
      margin: device == "lg" ? "24px 0 8px" : "32px 0 32px",
      fontSize: "large",
      fontWeight: "bold",
      color: theme.blackText,
      "data-test-id": "NoInsurancePlan-ParaTag",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: title,
        "data-test-id": "NoInsurancePlan-FormattedText"
      })
    }), info && /*#__PURE__*/_jsx(ParaTag, {
      fontSize: "sm",
      color: theme.greyText7,
      "data-test-id": "NoInsurancePlan-ParaTag",
      children: /*#__PURE__*/_jsx(FormattedText, {
        value: info,
        "data-test-id": "NoInsurancePlan-FormattedText"
      })
    })]
  });
};

/* harmony default export */ var NoInsurancePlan_NoInsurancePlan = ((/* unused pure expression or super */ null && (NoInsurancePlan)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailComp.style.ts



var OrderDetailComp_style_OrderDetailCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailCompStyle",
  componentId: "hdko8w-0"
})(["background:#ffffff;border-radius:16px;padding:20px;picture{display:inherit;flex-shrink:0;}@media ", "{padding:16px 16px 12px;border-radius:0px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var OrderDetailTravellerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailTravellerStyle",
  componentId: "hdko8w-1"
})(["border:1px solid #e2e2e2;@media ", "{border:none;padding-left:24px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var TravellerItem = (0,styled_components_browser_esm/* default */.ZP)(FlexCompStyle).withConfig({
  displayName: "OrderDetailCompstyle__TravellerItem",
  componentId: "hdko8w-2"
})(["border-bottom:1px solid #e2e2e2;padding:12px 16px;:last-child{border-bottom:none;}@media ", "{padding:8px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var OrderDetailComp_style_PlanDetailStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__PlanDetailStyle",
  componentId: "hdko8w-3"
})(["background:#f6faff;border-radius:8px;padding:16px;@media ", "{background:transparent;padding:0;min-height:100%;padding-left:32px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var PlanDetailsInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__PlanDetailsInfo",
  componentId: "hdko8w-4"
})(["background:#ffffff;margin-top:16px;display:grid;grid-template-columns:2fr 2fr 2fr 0.6fr;", "{border-right:1px solid #e8e8e8;padding:12px 16px;:last-child{border:none;}}@media ", "{display:flex;flex-direction:column;", "{border:none;border-bottom:1px solid #e8e8e8;padding:12px 0 12px 0px;}", ":last-child{border:none;}}"], FlexCompStyle, static_utils/* deviceType.mobile */.vO.mobile, FlexCompStyle, FlexCompStyle);
var OrderDetailsTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailsTable",
  componentId: "hdko8w-5"
})(["display:grid;grid-template-columns:repeat(3,1fr);border:1px solid #e8e8e8;", "{:nth-child(n + 3){border-bottom:none;}:nth-child(3){border-right:none;border-bottom:1px solid #e8e8e8;}}@media ", "{display:flex;flex-direction:column;border:none;", "{border-bottom:1px solid #e8e8e8;padding:12px 0;border-right:none;:nth-child(n + 3){border-bottom:1px solid #e8e8e8;}:last-child{border-bottom:none;}}}"], FlexCompStyle, static_utils/* deviceType.mobile */.vO.mobile, FlexCompStyle);
var OrderDetailsItem = (0,styled_components_browser_esm/* default */.ZP)(FlexCompStyle).withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailsItem",
  componentId: "hdko8w-6"
})(["border-right:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;padding:12px 16px;:last-child{border-right:none;}@media ", "{display:flex;justify-content:space-between;}"], static_utils/* deviceType.mobile */.vO.mobile);
var OrderMobCtaWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderMobCtaWrap",
  componentId: "hdko8w-7"
})(["display:flex;align-items:center;justify-content:space-between;padding:16px 20px 16px 48px;background:#fff;border:1px solid rgba(232,232,232,1);box-shadow:0px 1px 4px 0px rgba(74,74,74,0.2);"]);
var OrderMobAmtWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderMobAmtWrap",
  componentId: "hdko8w-8"
})(["display:flex;align-items:center;justify-content:space-between;padding:16px;background:#fff;border:1px solid rgba(232,232,232,1);"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailInsurance.tsx








var OrderDetailInsurance = function OrderDetailInsurance(_ref) {
  var _forInsuranceContaine;

  var insPlanName = _ref.insPlanName,
      orderDetailIcon = _ref.orderDetailIcon,
      orderDetails = _ref.orderDetails,
      insuranceType = _ref.insuranceType,
      insuranceInfo = _ref.insuranceInfo,
      insuranceTypeColor = _ref.insuranceTypeColor,
      forInsuranceContainer = _ref.forInsuranceContainer,
      handleClickInsurance = _ref.handleClickInsurance;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailComp_style_OrderDetailCompStyle, {
    "data-test-id": "OrderDetailInsurance-OrderDetailCompStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      flexDirection: device == "lg" ? "row" : "row-reverse",
      justifyContent: device == "lg" ? "" : "space-between",
      alignItems: device == "lg" ? "" : "center",
      margin: device == "lg" ? "0 0 24px" : "0 0 14px",
      gap: "8px",
      "data-test-id": "OrderDetailInsurance-FlexComp",
      children: [orderDetailIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "56px",
        height: "56px",
        src: orderDetailIcon,
        "data-test-id": "OrderDetailInsurance-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        gap: "2px",
        margin: "0",
        "data-test-id": "OrderDetailInsurance-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "large" : "md",
          fontWeight: "bold",
          "data-test-id": "OrderDetailInsurance-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: insPlanName,
            "data-test-id": "OrderDetailInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "OrderDetailInsurance-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: insuranceInfo,
            "data-test-id": "OrderDetailInsurance-FormattedText"
          })
        })]
      }), device == "lg" && insuranceType && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        textTransform: "uppercase",
        margin: "0 0 0 auto",
        color: insuranceTypeColor,
        "data-test-id": "OrderDetailInsurance-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: insuranceType,
          "data-test-id": "OrderDetailInsurance-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailsTable, {
      "data-test-id": "OrderDetailInsurance-OrderDetailsTable",
      children: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailsItem, {
          gap: "16px",
          "data-test-id": `OrderDetailInsurance-OrderDetailsItem-${index}`,
          children: [item.label && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            textTransform: "uppercase",
            color: Global/* theme.greyText7 */.rS.greyText7,
            fontSize: "xs",
            "data-test-id": "OrderDetailInsurance-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.label,
              "data-test-id": "OrderDetailInsurance-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            "data-test-id": "OrderDetailInsurance-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.value,
              "data-test-id": "OrderDetailInsurance-FormattedText"
            })
          })]
        }, index);
      })
    }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      gap: "35px",
      borderTop: "1px solid #e2e2e2",
      margin: "16px -16px 0",
      padding: "16px 16px 0",
      justifyContent: "space-between",
      "data-test-id": "OrderDetailInsurance-FlexComp",
      children: forInsuranceContainer === null || forInsuranceContainer === void 0 ? void 0 : (_forInsuranceContaine = forInsuranceContainer.forInsurance) === null || _forInsuranceContaine === void 0 ? void 0 : _forInsuranceContaine.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          flex: "1",
          flexDirection: "column",
          alignItems: "center",
          gap: "6px",
          handleClick: function handleClick() {
            return handleClickInsurance(item);
          },
          "data-test-id": `OrderDetailInsurance-FlexComp-${index}`,
          children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "36px",
            height: "36px",
            src: item.icon,
            "data-test-id": "OrderDetailInsurance-ImageComponent"
          }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            fontSize: "xs",
            "data-test-id": "OrderDetailInsurance-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.title,
              "data-test-id": "OrderDetailInsurance-FormattedText"
            })
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailInsurance = (OrderDetailInsurance);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailPlan.tsx








var OrderDetailPlan = function OrderDetailPlan(_ref) {
  var title = _ref.title,
      orderDetailIcon = _ref.orderDetailIcon,
      planBenefits = _ref.planBenefits,
      handleMoreBenefits = _ref.handleMoreBenefits,
      ctaLink = _ref.ctaLink,
      subTitle = _ref.subTitle,
      benefitsCTA = _ref.benefitsCTA;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test-id": "OrderDetailPlan",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailComp_style_OrderDetailCompStyle, {
      "data-test-id": "OrderDetailPlan-OrderDetailCompStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        "data-test-id": "OrderDetailPlan-FlexComp",
        children: [orderDetailIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon,
          "data-test-id": "OrderDetailPlan-ImageComponent"
        }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "OrderDetailPlan-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "OrderDetailPlan-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailComp_style_PlanDetailStyle, {
        "data-test-id": "OrderDetailPlan-PlanDetailStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          fontSize: "large",
          "data-test-id": "OrderDetailPlan-ParaTag",
          children: subTitle
        })
      })]
    })
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailPlan = (OrderDetailPlan);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailPlanShimmer.tsx






var OrderDetailPlanShimmer = function OrderDetailPlanShimmer() {
  return /*#__PURE__*/_jsxs(OrderDetailCompStyle, {
    "data-test-id": "OrderDetailPlanShimmer-OrderDetailCompStyle",
    children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
      width: "366px",
      height: "25px",
      margin: "0 0 24px",
      "data-test-id": "OrderDetailPlanShimmer-ShimmerVersion2"
    }), /*#__PURE__*/_jsx(PlanDetailStyle, {
      "data-test-id": "OrderDetailPlanShimmer-PlanDetailStyle"
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailPlanShimmer = ((/* unused pure expression or super */ null && (OrderDetailPlanShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailTraveller.tsx





function OrderDetailTraveller_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OrderDetailTraveller_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OrderDetailTraveller_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OrderDetailTraveller_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var OrderDetailTraveller_analytics = (0,insurance/* getAnalytics */.I)();

var OrderDetailTraveller = function OrderDetailTraveller(_ref) {
  var title = _ref.title,
      orderDetailIcon = _ref.orderDetailIcon,
      travellerDetails = _ref.travellerDetails,
      editEnabled = _ref.editEnabled,
      editTraveller = _ref.editTraveller,
      updateOrderDetails = _ref.updateOrderDetails,
      handleClickEditDetailSheet = _ref.handleClickEditDetailSheet;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(-1),
      editTravellerIndex = _useState[0],
      setEditTravellerIndex = _useState[1];

  var _useState2 = (0,react.useState)([]),
      travellerData = _useState2[0],
      setTravellerData = _useState2[1];

  (0,react.useEffect)(function () {
    if (travellerDetails) {
      setTravellerData(travellerDetails);
    }
  }, [travellerDetails]);

  var handleClickEditDetails = function handleClickEditDetails(index) {
    setEditTravellerIndex(index);
  };

  var _handleUpdateDetails = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(updatedData, index) {
      var travellers;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              travellers = _toConsumableArray(travellerData);
              travellers[index] = OrderDetailTraveller_objectSpread(OrderDetailTraveller_objectSpread({}, travellers[index]), updatedData);
              setTravellerData(travellers);
              _context.next = 5;
              return updateOrderDetails === null || updateOrderDetails === void 0 ? void 0 : updateOrderDetails();

            case 5:
              setEditTravellerIndex(-1);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpdateDetails(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-test-id": "OrderDetailTraveller",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailComp_style_OrderDetailCompStyle, {
      "data-test-id": "OrderDetailTraveller-OrderDetailCompStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        "data-test-id": "OrderDetailTraveller-FlexComp",
        children: [orderDetailIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon,
          "data-test-id": "OrderDetailTraveller-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "OrderDetailTraveller-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "OrderDetailTraveller-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailTravellerStyle, {
        "data-test-id": "OrderDetailTraveller-OrderDetailTravellerStyle",
        children: travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerItem, {
            alignItems: "baseline",
            justifyContent: "space-between",
            "data-test-id": `OrderDetailTraveller-TravellerItem-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              gap: "4px",
              flexDirection: "column",
              "data-test-id": `OrderDetailTraveller-FlexComp-${index}`,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                fontSize: device == "lg" ? "md" : "sm",
                fontWeight: "bold",
                "data-test-id": "OrderDetailTraveller-ParaTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: item.name,
                  "data-test-id": "OrderDetailTraveller-FormattedText"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [(item === null || item === void 0 ? void 0 : item.dob) && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderDetailTraveller-SpanTag",
                  children: ["\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: (0,utils/* formatDate */.p6)(item.dob, src.DATE_FORMATS["DD/MM/YYYY"]),
                    "data-test-id": "OrderDetailTraveller-FormattedText"
                  }), " ", "|"]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderDetailTraveller-SpanTag",
                  children: ["\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: item.gender,
                    "data-test-id": "OrderDetailTraveller-FormattedText"
                  })]
                })]
              })]
            }, index), device == "lg" && editEnabled && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              handleClick: function handleClick() {
                OrderDetailTraveller_analytics === null || OrderDetailTraveller_analytics === void 0 ? void 0 : OrderDetailTraveller_analytics.trackOrderDetailsEvents({
                  actionType: "edit_details_clicked"
                });
                handleClickEditDetails(index);
              },
              "data-test-id": "OrderDetailTraveller-AnchorTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                width: "16px",
                height: "16px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/Edit_Icon_9bd6098b75.svg",
                "data-test-id": "OrderDetailTraveller-ImageComponent"
              })
            }), editTravellerIndex === index && /*#__PURE__*/(0,jsx_runtime.jsx)(EditTraveller_EditTraveller, {
              index: index,
              title: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.title,
              travellerDetails: travellerData,
              travellerAttributes: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.travellerAttributes,
              fullName: item.name,
              dobValue: item.dob,
              passportValue: item.passport,
              genderValue: item.gender,
              refId: item.refId,
              goBackTxt: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.goBackBtnTxt,
              updateContactTxt: editTraveller === null || editTraveller === void 0 ? void 0 : editTraveller.updateNowBtnTxt,
              handleUpdateDetails: function handleUpdateDetails(updatedData) {
                return _handleUpdateDetails(updatedData, index);
              },
              handleClose: function handleClose() {
                return setEditTravellerIndex(-1);
              },
              "data-test-id": "OrderDetailTraveller-EditTraveller"
            })]
          }, index);
        })
      })]
    }), device == "sm" && editEnabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderMobCtaWrap, {
      onClick: handleClickEditDetailSheet,
      "data-test-id": "OrderDetailTraveller-OrderMobCtaWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        fontWeight: "bold",
        "data-test-id": "OrderDetailTraveller-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: "Edit Traveller Details",
          "data-test-id": "OrderDetailTraveller-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg",
        "data-test-id": "OrderDetailTraveller-ImageComponent"
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailComp_OrderDetailTraveller = (OrderDetailTraveller);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/PrimaryContact.tsx








var PrimaryContact = function PrimaryContact(_ref) {
  var title = _ref.title,
      orderDetailIcon = _ref.orderDetailIcon,
      contactDetails = _ref.contactDetails,
      handleAlternateContact = _ref.handleAlternateContact;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test-id": "PrimaryContact",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailComp_style_OrderDetailCompStyle, {
      "data-test-id": "PrimaryContact-OrderDetailCompStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        "data-test-id": "PrimaryContact-FlexComp",
        children: [orderDetailIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon,
          "data-test-id": "PrimaryContact-ImageComponent"
        }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "PrimaryContact-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "PrimaryContact-FormattedText"
          })
        })]
      }), (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.name) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        margin: "0 0 10px 32px",
        fontSize: "md",
        fontWeight: "bold",
        "data-test-id": "PrimaryContact-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.name,
          "data-test-id": "PrimaryContact-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        margin: "0 0 10px",
        alignItems: "center",
        gap: "6px",
        padding: "0 0 0 32px",
        "data-test-id": "PrimaryContact-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "16px",
          height: "16px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/mail_Icon_cf3395e217.svg",
          "data-test-id": "PrimaryContact-ImageComponent"
        }), (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "PrimaryContact-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.email,
            "data-test-id": "PrimaryContact-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        justifyContent: "space-between",
        padding: "0 0 0 32px",
        "data-test-id": "PrimaryContact-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          alignItems: "center",
          gap: "6px",
          "data-test-id": "PrimaryContact-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "16px",
            height: "16px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/call_Icon_94b21de941.svg",
            "data-test-id": "PrimaryContact-ImageComponent"
          }), (contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.contactNo) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: device == "lg" ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "PrimaryContact-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.contactNo,
              "data-test-id": "PrimaryContact-FormattedText"
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var OrderDetailComp_PrimaryContact = (PrimaryContact);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderDetailRightComp.style.ts



var OrderDetailRightComp_style_OrderRightStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightStyle",
  componentId: "cex5w1-0"
})(["background:#ffffff;border-radius:16px;"]);
var OrderDetailRightComp_style_OrderRightHd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightHd",
  componentId: "cex5w1-1"
})(["padding:20px 20px 12px;border-bottom:1px solid #f2f2f2;display:flex;justify-content:space-between;gap:10px;"]);
var OrderDetailRightComp_style_OrderRightCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightCntnt",
  componentId: "cex5w1-2"
})(["padding:12px 20px;"]);
var OrderDetailRightComp_style_PriceText = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "OrderDetailRightCompstyle__PriceText",
  componentId: "cex5w1-3"
})(["flex-shrink:0;"]);
var OrderDetailRightComp_style_MmtServiceFee = (0,styled_components_browser_esm/* default */.ZP)(FlexCompStyle).withConfig({
  displayName: "OrderDetailRightCompstyle__MmtServiceFee",
  componentId: "cex5w1-4"
})(["margin-top:12px;padding-top:12px;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid #f2f2f2;border-top:1px solid #f2f2f2;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderAmtPaid.tsx







var OrderAmtPaid = function OrderAmtPaid(_ref) {
  var title = _ref.title,
      info = _ref.info,
      handleInvoice = _ref.handleInvoice,
      amountPaid = _ref.amountPaid;

  var _ref2 = amountPaid !== null && amountPaid !== void 0 ? amountPaid : {},
      breakupTxt = _ref2.breakupTxt,
      details = _ref2.details;

  var _ref3 = details !== null && details !== void 0 ? details : {},
      bank = _ref3.bank,
      accNo = _ref3.accNo,
      amt = _ref3.amt;

  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    "data-test-id": "OrderAmtPaid-OrderRightStyle",
    children: [/*#__PURE__*/_jsxs(OrderRightHd, {
      "data-test-id": "OrderAmtPaid-OrderRightHd",
      children: [title && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderAmtPaid-SpanTag",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title,
          "data-test-id": "OrderAmtPaid-FormattedText"
        })
      }), info && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderAmtPaid-SpanTag",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info,
          "data-test-id": "OrderAmtPaid-FormattedText"
        })
      })]
    }), /*#__PURE__*/_jsxs(OrderRightCntnt, {
      "data-test-id": "OrderAmtPaid-OrderRightCntnt",
      children: [breakupTxt && /*#__PURE__*/_jsx(ParaTag, {
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "OrderAmtPaid-ParaTag",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: breakupTxt,
          "data-test-id": "OrderAmtPaid-FormattedText"
        })
      }), /*#__PURE__*/_jsxs(FlexComp, {
        justifyContent: "space-between",
        margin: "8px 0 16px",
        "data-test-id": "OrderAmtPaid-FlexComp",
        children: [/*#__PURE__*/_jsxs(FlexComp, {
          flexDirection: "column",
          margin: "unset",
          "data-test-id": "OrderAmtPaid-FlexComp",
          children: [bank && /*#__PURE__*/_jsx(ParaTag, {
            fontSize: "xs",
            "data-test-id": "OrderAmtPaid-ParaTag",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: bank,
              "data-test-id": "OrderAmtPaid-FormattedText"
            })
          }), accNo && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            "data-test-id": "OrderAmtPaid-SpanTag",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: accNo,
              "data-test-id": "OrderAmtPaid-FormattedText"
            })
          })]
        }), amt && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          "data-test-id": "OrderAmtPaid-SpanTag",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: amt,
            "data-test-id": "OrderAmtPaid-FormattedText"
          })
        })]
      }), /*#__PURE__*/_jsx(LandingButtonWhite, {
        customWidth: "100%",
        customTitle: "DOWNLOAD INVOICE",
        onClick: handleInvoice,
        "data-test-id": "OrderAmtPaid-LandingButtonWhite"
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderAmtPaid = ((/* unused pure expression or super */ null && (OrderAmtPaid)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderGetHelp.tsx







var OrderGetHelp = function OrderGetHelp(_ref) {
  var title = _ref.title,
      info = _ref.info,
      getHelp = _ref.getHelp;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRightComp_style_OrderRightStyle, {
    "data-test-id": "OrderGetHelp-OrderRightStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRightComp_style_OrderRightHd, {
      "data-test-id": "OrderGetHelp-OrderRightHd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderGetHelp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "OrderGetHelp-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderGetHelp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "OrderGetHelp-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailRightComp_style_OrderRightCntnt, {
      "data-test-id": "OrderGetHelp-OrderRightCntnt",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        justifyContent: device == "lg" ? "space-between" : "center",
        gap: device == "lg" ? "20px" : "42px",
        "data-test-id": "OrderGetHelp-FlexComp",
        children: getHelp === null || getHelp === void 0 ? void 0 : getHelp.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            gap: "8px",
            alignItems: "center",
            flexDirection: "column",
            "data-test-id": `OrderGetHelp-FlexComp-${index}`,
            children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "27px",
              height: "27px",
              src: item.icon,
              "data-test-id": "OrderGetHelp-ImageComponent"
            }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              fontSize: "xs",
              "data-test-id": "OrderGetHelp-AnchorTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "OrderGetHelp-FormattedText"
              })
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderGetHelp = (OrderGetHelp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderInsurance.tsx






var OrderInsurance = function OrderInsurance(_ref) {
  var title = _ref.title,
      info = _ref.info,
      forInsurance = _ref.forInsurance,
      handleClickInsurance = _ref.handleClickInsurance;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRightComp_style_OrderRightStyle, {
    "data-test-id": "OrderInsurance-OrderRightStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRightComp_style_OrderRightHd, {
      "data-test-id": "OrderInsurance-OrderRightHd",
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderInsurance-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "OrderInsurance-FormattedText"
        })
      }), info && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderInsurance-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "OrderInsurance-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailRightComp_style_OrderRightCntnt, {
      "data-test-id": "OrderInsurance-OrderRightCntnt",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        gap: "14px",
        "data-test-id": "OrderInsurance-FlexComp",
        children: forInsurance === null || forInsurance === void 0 ? void 0 : forInsurance.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            alignItems: "center",
            gap: "16px",
            handleClick: function handleClick() {
              return handleClickInsurance(item);
            },
            "data-test-id": `OrderInsurance-FlexComp-${index}`,
            children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "20px",
              height: "20px",
              src: item.icon,
              "data-test-id": "OrderInsurance-ImageComponent"
            }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              fontWeight: "bold",
              "data-test-id": "OrderInsurance-AnchorTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "OrderInsurance-FormattedText"
              })
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderInsurance = (OrderInsurance);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderPriceBreakup.tsx








var OrderPriceBreakup = function OrderPriceBreakup(_ref) {
  var title = _ref.title,
      info = _ref.info,
      priceBreakup = _ref.priceBreakup,
      totalPrice = _ref.totalPrice,
      mmtServiceFee = _ref.mmtServiceFee;
  return /*#__PURE__*/_jsxs(OrderRightStyle, {
    "data-test-id": "OrderPriceBreakup-OrderRightStyle",
    children: [/*#__PURE__*/_jsxs(OrderRightHd, {
      "data-test-id": "OrderPriceBreakup-OrderRightHd",
      children: [title && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderPriceBreakup-SpanTag",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: title,
          "data-test-id": "OrderPriceBreakup-FormattedText"
        })
      }), info && /*#__PURE__*/_jsx(SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderPriceBreakup-SpanTag",
        children: /*#__PURE__*/_jsx(FormattedText, {
          value: info,
          "data-test-id": "OrderPriceBreakup-FormattedText"
        })
      })]
    }), /*#__PURE__*/_jsxs(OrderRightCntnt, {
      "data-test-id": "OrderPriceBreakup-OrderRightCntnt",
      children: [priceBreakup && priceBreakup.map(function (item, index) {
        return /*#__PURE__*/_jsxs(FlexComp, {
          justifyContent: "space-between",
          "data-test-id": `OrderPriceBreakup-FlexComp-${index}`,
          children: [item.title && /*#__PURE__*/_jsx(SpanTag, {
            fontSize: "xs",
            color: theme.greyText7,
            "data-test-id": "OrderPriceBreakup-SpanTag",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.title,
              "data-test-id": "OrderPriceBreakup-FormattedText"
            })
          }), item.price && /*#__PURE__*/_jsx(PriceText, {
            txtfontSize: "xs",
            "data-test-id": "OrderPriceBreakup-PriceText",
            children: /*#__PURE__*/_jsx(FormattedText, {
              value: item.price,
              "data-test-id": "OrderPriceBreakup-FormattedText"
            })
          })]
        }, index);
      }), /*#__PURE__*/_jsxs(MmtServiceFee, {
        justifyContent: "space-between",
        "data-test-id": "OrderPriceBreakup-MmtServiceFee",
        children: [(mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.title) && /*#__PURE__*/_jsx(SpanTag, {
          fontSize: "xs",
          color: theme.blackText,
          "data-test-id": "OrderPriceBreakup-SpanTag",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.title,
            "data-test-id": "OrderPriceBreakup-FormattedText"
          })
        }), (mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.price) && /*#__PURE__*/_jsx(PriceText, {
          txtfontSize: "xs",
          txtfontWeight: "bold",
          "data-test-id": "OrderPriceBreakup-PriceText",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: mmtServiceFee === null || mmtServiceFee === void 0 ? void 0 : mmtServiceFee.price,
            "data-test-id": "OrderPriceBreakup-FormattedText"
          })
        })]
      }), /*#__PURE__*/_jsxs(FlexComp, {
        justifyContent: "space-between",
        "data-test-id": "OrderPriceBreakup-FlexComp",
        children: [/*#__PURE__*/_jsx(SpanTag, {
          fontWeight: "bold",
          fontSize: "md",
          "data-test-id": "OrderPriceBreakup-SpanTag",
          children: "Total Price"
        }), totalPrice && /*#__PURE__*/_jsx(PriceText, {
          txtfontWeight: "bold",
          txtfontSize: "md",
          "data-test-id": "OrderPriceBreakup-PriceText",
          children: /*#__PURE__*/_jsx(FormattedText, {
            value: totalPrice,
            "data-test-id": "OrderPriceBreakup-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var OrderDetailRightComp_OrderPriceBreakup = ((/* unused pure expression or super */ null && (OrderPriceBreakup)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetails.style.ts


var OrderDetails_style_OrderDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsStyle",
  componentId: "jnokfb-0"
})(["background:#ffffff;box-shadow:0px 1px 8px rgba(0,0,0,0.179518);border-radius:16px;overflow:hidden;margin:", ";picture,img{flex-shrink:0;}@media ", "{padding-bottom:16px;}"], function (props) {
  return props.margin;
}, src.deviceType.mobile);
var OrderDetails_style_OrderDetailsSectionOne = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionOne",
  componentId: "jnokfb-1"
})(["padding:16px 30px;background:#fff;display:flex;align-items:center;justify-content:space-between;font-weight:700;font-size:14px;line-height:19px;text-transform:uppercase;color:#000000;"]);
var OrderDetails_style_OrderDetailsSectionTwo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionTwo",
  componentId: "jnokfb-2"
})(["padding:16px 30px;background:linear-gradient(93.36deg,#f2eae6 -17.08%,#ffffff 118.39%);display:flex;align-items:center;gap:20px;margin-bottom:8px;min-height:90px;.imgWrap{width:145px;height:88px;}"]);
var OrderDetailsSectionThree = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionThree",
  componentId: "jnokfb-3"
})(["padding:16px 30px;background:#fff;display:flex;flex-direction:column;border:1px dashed #fafafa;background:#fafafa;margin:8px 0;"]);
var OrderDetails_style_OrderDetailsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsList",
  componentId: "jnokfb-4"
})(["border-top:1px dashed #d8d8d8;padding-top:16px;padding-bottom:2px;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetails.tsx









var OrderDetails = function OrderDetails(_ref) {
  var orderDetails = _ref.orderDetails,
      margin = _ref.margin,
      downloadPolicy = _ref.downloadPolicy,
      navigateToDownloadPolicy = _ref.navigateToDownloadPolicy;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _ref2 = orderDetails !== null && orderDetails !== void 0 ? orderDetails : {},
      planName = _ref2.planName,
      packName = _ref2.packName,
      insPackName = _ref2.insPackName,
      packColor = _ref2.packColor,
      packImg = _ref2.packImg,
      orderDetailAmt = _ref2.orderDetailAmt;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetails_style_OrderDetailsStyle, {
    margin: margin,
    "data-test-id": "OrderDetails-OrderDetailsStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetails_style_OrderDetailsSectionOne, {
      "data-test-id": "OrderDetails-OrderDetailsSectionOne",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "black",
        "data-test-id": "OrderDetails-SpanTag",
        children: "Plan details"
      }), insPackName && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        color: packColor,
        "data-test-id": "OrderDetails-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: insPackName,
          "data-test-id": "OrderDetails-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetails_style_OrderDetailsSectionTwo, {
      "data-test-id": "OrderDetails-OrderDetailsSectionTwo",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "59px",
        height: "59px",
        src: packImg ? packImg : "",
        "data-test-id": "OrderDetails-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        "data-test-id": "OrderDetails-FlexComp",
        children: [planName && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "black",
          color: Global/* theme.blackText */.rS.blackText,
          "data-test-id": "OrderDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: planName,
            "data-test-id": "OrderDetails-FormattedText"
          })
        }), packName && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "OrderDetails-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: packName,
            "data-test-id": "OrderDetails-FormattedText"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetails_style_OrderDetailsList, {
      "data-test-id": "OrderDetails-OrderDetailsList",
      children: orderDetailAmt && (orderDetailAmt === null || orderDetailAmt === void 0 ? void 0 : orderDetailAmt.map(function (item, index) {
        var _orderDetailAmt$lengt;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          justifyContent: "space-between",
          borderBottom: "1px dashed #dbdbdb",
          padding: index == ((_orderDetailAmt$lengt = orderDetailAmt === null || orderDetailAmt === void 0 ? void 0 : orderDetailAmt.length) !== null && _orderDetailAmt$lengt !== void 0 ? _orderDetailAmt$lengt : 0) - 1 ? "0 30px 8px" : "0 30px 8px",
          margin: "0 0 8px",
          "data-test-id": `OrderDetails-FlexComp-${index}`,
          children: [item.orderDetail && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: index == 0 ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            fontWeight: index == 0 ? "black" : "regular",
            "data-test-id": "OrderDetails-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.orderDetail,
              "data-test-id": "OrderDetails-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: index == 0 ? "md" : "xs",
            color: Global/* theme.blackText */.rS.blackText,
            fontWeight: "black",
            "data-test-id": "OrderDetails-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.info,
              "data-test-id": "OrderDetails-FormattedText"
            })
          })]
        }, index);
      }))
    }), device == "sm" && downloadPolicy && downloadPolicy !== null && downloadPolicy !== void 0 && downloadPolicy.isEnabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonWhite, {
      btnLeftIcon: downloadPolicy === null || downloadPolicy === void 0 ? void 0 : downloadPolicy.leftIconUrl,
      btnRightIcon: downloadPolicy === null || downloadPolicy === void 0 ? void 0 : downloadPolicy.rightIconUrl,
      customTitle: downloadPolicy === null || downloadPolicy === void 0 ? void 0 : downloadPolicy.buttonTitle,
      customWidth: "calc(100% - 24px)",
      margin: "0 auto",
      onClick: navigateToDownloadPolicy,
      "data-test-id": "OrderDetails-LandingButtonWhite"
    }) : null]
  });
};

/* harmony default export */ var OrderDetails_OrderDetails = (OrderDetails);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetailsShimmer.tsx






var OrderDetailsShimmer = function OrderDetailsShimmer(_ref) {
  var _orderDetails$orderDe;

  var orderDetails = _ref.orderDetails,
      margin = _ref.margin;
  return /*#__PURE__*/_jsxs(OrderDetailsStyle, {
    margin: margin,
    "data-test-id": "OrderDetailsShimmer-OrderDetailsStyle",
    children: [/*#__PURE__*/_jsxs(OrderDetailsSectionOne, {
      "data-test-id": "OrderDetailsShimmer-OrderDetailsSectionOne",
      children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "300px",
        height: "20px",
        "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
      }), /*#__PURE__*/_jsx(ShimmerVersion2, {
        width: "136px",
        height: "20px",
        "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/_jsx(OrderDetailsSectionTwo, {
      "data-test-id": "OrderDetailsShimmer-OrderDetailsSectionTwo"
    }), /*#__PURE__*/_jsx(OrderDetailsList, {
      "data-test-id": "OrderDetailsShimmer-OrderDetailsList",
      children: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.orderDetailAmt) && (orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$orderDe = orderDetails.orderDetailAmt) === null || _orderDetails$orderDe === void 0 ? void 0 : _orderDetails$orderDe.map(function (item, index) {
        var _orderDetails$orderDe2, _orderDetails$orderDe3;

        return /*#__PURE__*/_jsxs(FlexComp, {
          justifyContent: "space-between",
          borderBottom: "1px dashed #dbdbdb",
          padding: index == ((_orderDetails$orderDe2 = orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$orderDe3 = orderDetails.orderDetailAmt) === null || _orderDetails$orderDe3 === void 0 ? void 0 : _orderDetails$orderDe3.length) !== null && _orderDetails$orderDe2 !== void 0 ? _orderDetails$orderDe2 : 0) - 1 ? "0 30px 16px" : "0 30px 8px",
          margin: "0 0 8px",
          "data-test-id": `OrderDetailsShimmer-FlexComp-${index}`,
          children: [/*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "144px",
            height: "18px",
            "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
          }), /*#__PURE__*/_jsx(ShimmerVersion2, {
            width: "144px",
            height: "18px",
            "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
          })]
        }, index);
      }))
    })]
  });
};

/* harmony default export */ var OrderDetails_OrderDetailsShimmer = ((/* unused pure expression or super */ null && (OrderDetailsShimmer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.style.ts


var OrderListingCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderListingCompstyle__OrderListingCompStyle",
  componentId: "sc-1wp0u3b-0"
})(["background:#fff;padding:16px;display:flex;justify-content:space-between;align-items:baseline;gap:16px;border-radius:16px;cursor:pointer;div:last-child{}img{display:inline-block;margin-bottom:auto;}@media ", "{max-height:100%;gap:12px;border-radius:0;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.tsx










var OrderListingComp_analytics = (0,insurance/* getAnalytics */.I)();

var OrderListingComp = function OrderListingComp(_ref) {
  var data = _ref.data;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
      var icon = item.icon,
          orderDate = item.orderDate,
          bookingId = item.bookingId,
          amount = item.amount,
          insurerName = item.insurerName,
          countries = item.countries,
          currency = item.currency,
          validity = item.validity,
          status = item.status,
          isPassportDetailsAvailable = item.isPassportDetailsAvailable,
          sumInsured = item.sumInsured,
          addPassportCta = item.addPassportCta;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderListingCompStyle, {
        onClick: function onClick() {
          OrderListingComp_analytics === null || OrderListingComp_analytics === void 0 ? void 0 : OrderListingComp_analytics.trackOrderSummaryEvents({
            actionType: "order_clicked"
          });
          navigation/* navigationActions.navigateToOrderDetails */.e.navigateToOrderDetails({
            bookingId: item.bookingId
          });
        },
        "data-test-id": `OrderListingComp-OrderListingCompStyle-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: "20px",
          height: "20px",
          src: icon,
          "data-test-id": "OrderListingComp-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          gap: "12px",
          flexDirection: "column",
          flex: "1",
          "data-test-id": "OrderListingComp-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            "data-test-id": "OrderListingComp-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              flex: "2",
              gap: "8px",
              flexDirection: device == "lg" ? "row" : "column",
              "data-test-id": "OrderListingComp-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                flex: "1",
                flexDirection: "column",
                gap: "0px",
                "data-test-id": "OrderListingComp-FlexComp",
                children: [insurerName && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                  fontSize: device == "lg" ? "md" : "sm",
                  fontWeight: "black",
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: insurerName,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                }), countries && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: countries,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                flex: "1",
                flexDirection: "column",
                gap: "2px",
                "data-test-id": "OrderListingComp-FlexComp",
                children: [sumInsured && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                  fontSize: device == "lg" ? "md" : "xs",
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: sumInsured,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                }), validity && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: validity,
                    "data-test-id": "OrderListingComp-FormattedText"
                  }), status && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
                    fontWeight: "black",
                    color: status == "EXPIRED" ? Global/* theme.yellowText */.rS.yellowText : Global/* theme.greenText */.rS.greenText,
                    fontSize: "xs",
                    "data-test-id": "OrderListingComp-SpanTag",
                    children: ["\xA0 (", status, ")"]
                  })]
                }), bookingId && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: ["Order ID: \xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: bookingId,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              alignItems: "flex-end",
              flexDirection: "column",
              gap: "8px",
              flex: "1",
              "data-test-id": "OrderListingComp-FlexComp",
              children: [amount && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
                fontSize: "md",
                fontWeight: "black",
                "data-test-id": "OrderListingComp-ParaTag",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: amount,
                  "data-test-id": "OrderListingComp-FormattedText"
                }), currency && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                  fontSize: "md",
                  fontWeight: "black",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-SpanTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                    value: currency,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                }), "\xA0"]
              }), orderDate && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                margin: device == "sm" ? "auto 0 0" : "",
                "data-test-id": "OrderListingComp-ParaTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: orderDate,
                  "data-test-id": "OrderListingComp-FormattedText"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              margin: "2px 4px 4px",
              "data-test-id": "OrderListingComp-AnchorTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                width: "12px",
                height: "12px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg",
                "data-test-id": "OrderListingComp-ImageComponent"
              })
            })]
          }), isPassportDetailsAvailable && item.bookingId && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderStatusComp_OrderStatusComp, {
            ctatText: addPassportCta,
            orderStatus: "Pending",
            orderPending: true,
            bookingId: item === null || item === void 0 ? void 0 : item.bookingId,
            "data-test-id": "OrderListingComp-OrderStatusComp"
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ var OrderListingComp_OrderListingComp = (OrderListingComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.style.ts

var OrderStatusCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderStatusCompstyle__OrderStatusCompStyle",
  componentId: "sc-1e3p997-0"
})(["display:flex;align-items:center;justify-content:space-between;gap:10px;border-radius:2px;padding:4px 8px;background:", ";"], function (p) {
  return p.pending ? "#FFEDD1" : p.failed ? "#FCDADB" : "#fff";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.tsx









var OrderStatusComp = function OrderStatusComp(_ref) {
  var orderStatus = _ref.orderStatus,
      orderFailed = _ref.orderFailed,
      orderPending = _ref.orderPending,
      ctatText = _ref.ctatText,
      bookingId = _ref.bookingId;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderStatusCompStyle, {
    pending: orderPending,
    failed: orderFailed,
    "data-test-id": "OrderStatusComp-OrderStatusCompStyle",
    children: [orderStatus && /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
      fontSize: "xs",
      fontWeight: "bold",
      color: orderFailed ? Global_theme.redText : orderPending ? Global_theme.brownText : Global_theme.blackText,
      "data-test-id": "OrderStatusComp-SpanTag",
      children: [orderPending && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "regular",
        "data-test-id": "OrderStatusComp-SpanTag",
        children: "Documents:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: orderStatus,
        "data-test-id": "OrderStatusComp-FormattedText"
      })]
    }), "\xA0\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      handleClick: function handleClick() {
        return navigation/* navigationActions.navigateToAddPassport */.e.navigateToAddPassport({
          bookingId: bookingId,
          pageId: src.PASSPORT_DETAILS_PAGE_ID.ORDER_CONFIRMED
        });
      },
      alignItems: "center",
      gap: "4px",
      "data-test-id": "OrderStatusComp-FlexComp",
      children: [ctatText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "OrderStatusComp-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: ctatText,
          "data-test-id": "OrderStatusComp-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/right_arrow_4a1f2bfef9.svg",
        "data-test-id": "OrderStatusComp-ImageComponent"
      })]
    })]
  });
};

/* harmony default export */ var OrderStatusComp_OrderStatusComp = (OrderStatusComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/PassportNumComp.style.ts




var PassportNumCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PassportNumCompstyle__PassportNumCompStyle",
  componentId: "sc-4ddzx4-0"
})(["background:#ffffff;border-radius:16px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);flex:1;display:flex;flex-direction:column;@media ", "{border-radius:16px 16px 0 0;}"], static_utils/* deviceType.mobile */.vO.mobile);
var PassportHd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PassportNumCompstyle__PassportHd",
  componentId: "sc-4ddzx4-1"
})(["padding:30px;border-bottom:1px solid #e8e8e8;display:flex;flex-direction:column;gap:8px;@media ", "{padding:24px 16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var PassportItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PassportNumCompstyle__PassportItem",
  componentId: "sc-4ddzx4-2"
})(["display:grid;grid-template-columns:repeat(2,1fr);border-bottom:", ";padding:16px 30px;gap:8px;@media ", "{grid-template-columns:repeat(1,1fr);padding:16px;}"], function (p) {
  return p.itemIndex ? "none" : "1px solid #e8e8e8";
}, static_utils/* deviceType.mobile */.vO.mobile);
var ButtonWrap = (0,styled_components_browser_esm/* default */.ZP)(FlexCompStyle).withConfig({
  displayName: "PassportNumCompstyle__ButtonWrap",
  componentId: "sc-4ddzx4-3"
})(["display:flex;align-items:center;padding:30px;margin-top:auto;", "{flex:1;}", "{flex:1;text-align:center;}@media ", "{padding:24px 16px;}"], LandingButton_style/* LandingButtonStyle */.zm, FlexCompStyle, static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/AddPassportModal.tsx






var AddPassportModal = function AddPassportModal(_ref) {
  var handleSkip = _ref.handleSkip,
      handleClose = _ref.handleClose,
      data = _ref.data;

  var _ref2 = data || {},
      title = _ref2.title,
      info = _ref2.info,
      addBtnText = _ref2.addBtnText,
      skipBtnText = _ref2.skipBtnText;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    handleClick: handleClose,
    customTitle: title,
    customIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/Geeric_caution_b863e71f7f.svg",
    nonClipHeading: true,
    "data-test-id": "AddPassportModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "md",
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "AddPassportModal-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: info,
        "data-test-id": "AddPassportModal-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "26px 0 0",
      gap: "10px",
      "data-test-id": "AddPassportModal-FlexComp",
      children: [addBtnText && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        onClick: handleClose,
        customWidth: "122px",
        customTitle: addBtnText,
        "data-test-id": "AddPassportModal-LandingButton"
      }), skipBtnText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        handleClick: handleSkip,
        fontSize: "md",
        fontWeight: "bold",
        "data-test-id": "AddPassportModal-AnchorTag",
        children: skipBtnText
      })]
    })]
  });
};

/* harmony default export */ var PassportNumComp_AddPassportModal = (AddPassportModal);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/PassportNumComp.tsx










var PassportNumComp_analytics = (0,insurance/* getAnalytics */.I)();

var PassportNumComp = function PassportNumComp(_ref) {
  var isLoading = _ref.isLoading,
      title = _ref.title,
      info = _ref.info,
      travellerData = _ref.travellerData,
      submitCtaText = _ref.submitCtaText,
      skipCtaText = _ref.skipCtaText,
      passportFormData = _ref.passportFormData,
      handleSubmitClick = _ref.handleSubmitClick,
      handleAddPassportModal = _ref.handleAddPassportModal;

  var _ref2 = passportFormData || {},
      isRequired = _ref2.isRequired,
      label = _ref2.label,
      placeHolder = _ref2.placeHolder,
      pattern = _ref2.pattern,
      maxLength = _ref2.maxLength,
      error_message = _ref2.error_message;

  var travellerCount = (travellerData === null || travellerData === void 0 ? void 0 : travellerData.length) || 0;

  var _useForm = useForm({
    defaultValues: {
      //array name should match with field array name in useFieldAray()
      passportData: Array.from({
        length: travellerCount
      }).map(function (_, index) {
        var _travellerData$index, _travellerData$index2;

        return {
          name: (travellerData === null || travellerData === void 0 ? void 0 : (_travellerData$index = travellerData[index]) === null || _travellerData$index === void 0 ? void 0 : _travellerData$index.name) || "",
          passport: (travellerData === null || travellerData === void 0 ? void 0 : (_travellerData$index2 = travellerData[index]) === null || _travellerData$index2 === void 0 ? void 0 : _travellerData$index2.passportNum) || ""
        };
      })
    },
    mode: "onTouched"
  }),
      control = _useForm.control,
      formState = _useForm.formState,
      handleSubmit = _useForm.handleSubmit;

  var _useFieldArray = useFieldArray({
    control: control,
    name: "passportData" // unique name for field array

  }),
      fields = _useFieldArray.fields;

  var errors = formState.errors;

  var onSubmit = function onSubmit(formData) {
    PassportNumComp_analytics === null || PassportNumComp_analytics === void 0 ? void 0 : PassportNumComp_analytics.trackAddPassportEvents({
      actionType: "submit_clicked"
    });
    PassportNumComp_analytics === null || PassportNumComp_analytics === void 0 ? void 0 : PassportNumComp_analytics.trackAddPassportEvents({
      actionType: "details_filled"
    });

    var _ref3 = formData || {},
        passportData = _ref3.passportData;

    var reqData = travellerData === null || travellerData === void 0 ? void 0 : travellerData.map(function (item, index) {
      var _ref4 = item || {},
          refId = _ref4.refId,
          name = _ref4.name,
          _ref4$dob = _ref4.dob,
          dob = _ref4$dob === void 0 ? "" : _ref4$dob,
          gender = _ref4.gender;

      return {
        refId: refId,
        FullName: name,
        Dob: (0,utils/* formatDate */.p6)(dob, src.DATE_FORMATS["YYYY-MM-DD"]),
        Gender: gender,
        PassportNo: passportData[index].passport
      };
    });
    handleSubmitClick(reqData);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PassportNumCompStyle, {
    "data-test-id": "PassportNumComp-PassportNumCompStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PassportHd, {
      "data-test-id": "PassportNumComp-PassportHd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        "data-test-id": "PassportNumComp-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "PassportNumComp-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "PassportNumComp-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "PassportNumComp-FormattedText"
        })
      })]
    }), fields.map(function (item, index) {
      var _errors$passportData;

      var error = errors === null || errors === void 0 ? void 0 : (_errors$passportData = errors.passportData) === null || _errors$passportData === void 0 ? void 0 : _errors$passportData[index];
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PassportItem, {
        itemIndex: index == fields.length - 1,
        "data-test-id": `PassportNumComp-PassportItem-${index}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Controller, {
          control: control,
          name: "passportData.".concat(index, ".passport"),
          rules: {
            required: {
              value: isRequired !== null && isRequired !== void 0 ? isRequired : true,
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport")
            },
            pattern: {
              value: new RegExp(pattern || ""),
              message: (0,utils/* getFormFieldErrorMsg */.YV)("passport", error_message)
            }
          },
          render: function render(_ref5) {
            var _error$passport;

            var _ref5$field = _ref5.field,
                onChange = _ref5$field.onChange,
                onBlur = _ref5$field.onBlur,
                value = _ref5$field.value;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "md",
                fontWeight: "bold",
                color: Global/* theme.blackText */.rS.blackText,
                "data-test-id": "PassportNumComp-SpanTag",
                children: item.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput_LandingInput, {
                requiredField: isRequired,
                placeholderTxt: placeHolder,
                labelTxt: label,
                errorState: error === null || error === void 0 ? void 0 : (_error$passport = error.passport) === null || _error$passport === void 0 ? void 0 : _error$passport.message,
                inputValue: value,
                maxInputLength: maxLength,
                disableState: isLoading,
                handleChange: onChange,
                handleBlur: onBlur,
                "data-test-id": "PassportNumComp-LandingInput"
              })]
            });
          },
          "data-test-id": "PassportNumComp-Controller"
        })
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonWrap, {
      alignItems: "center",
      gap: "24px",
      "data-test-id": "PassportNumComp-ButtonWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        isLoading: isLoading,
        customTitle: submitCtaText,
        onClick: handleSubmit(onSubmit),
        "data-test-id": "PassportNumComp-LandingButton"
      }), skipCtaText && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        "data-test-id": "PassportNumComp-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          fontSize: "md",
          fontWeight: "bold",
          handleClick: handleAddPassportModal,
          "data-test-id": "PassportNumComp-AnchorTag",
          children: skipCtaText
        })
      })]
    })]
  });
};

/* harmony default export */ var PassportNumComp_PassportNumComp = (PassportNumComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.style.ts

var PaymentStatusCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentStatusCompstyle__PaymentStatusCompStyle",
  componentId: "v9sidz-0"
})(["background:#fff;height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
var Confetti = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentStatusCompstyle__Confetti",
  componentId: "v9sidz-1"
})(["width:278px;height:185px;animation:confetti 0.5s ease-in;@keyframes confetti{0%{transform:scale(0.5);}100%{transform:scale(1);}}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.tsx







var PaymentStatusComp = function PaymentStatusComp(_ref) {
  var title = _ref.title,
      infoTxt = _ref.infoTxt,
      subInfoTxt = _ref.subInfoTxt,
      imageIcon = _ref.imageIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentStatusCompStyle, {
    "data-test-id": "PaymentStatusComp-PaymentStatusCompStyle",
    children: [imageIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(Confetti, {
      "data-test-id": "PaymentStatusComp-Confetti",
      children: imageIcon
    }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "large",
      fontWeight: "bold",
      margin: "0 0 8px",
      color: Global/* theme.blackText */.rS.blackText,
      "data-test-id": "PaymentStatusComp-ParaTag",
      children: title
    }), infoTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      margin: "0 0 2px",
      fontSize: "xs",
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "PaymentStatusComp-SpanTag",
      children: infoTxt
    }), subInfoTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontSize: "xs",
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "PaymentStatusComp-SpanTag",
      children: subInfoTxt
    })]
  });
};

/* harmony default export */ var PaymentStatusComp_PaymentStatusComp = (PaymentStatusComp);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBanner.style.tsx
var PersuasionBanner_style = __webpack_require__(2207);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBanner.tsx






var PersuasionBanner = function PersuasionBanner(_ref) {
  var heading = _ref.heading,
      bgImage = _ref.bgImage,
      bulletPoints = _ref.bulletPoints,
      btnText = _ref.btnText,
      margin = _ref.margin,
      btnHandler = _ref.btnHandler,
      info = _ref.info;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PersuasionBanner_style/* PersuasionBannerStyle */.G, {
    margin: margin,
    bgImage: bgImage,
    "data-test-id": "PersuasionBanner-PersuasionBannerStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H3Tag, {
      "data-test-id": "PersuasionBanner-H3Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: heading,
        "data-test-id": "PersuasionBanner-FormattedText"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
      "data-test-id": "PersuasionBanner-H5Tag",
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: heading,
        "data-test-id": "PersuasionBanner-FormattedText"
      })]
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      gap: "6px",
      "data-test-id": "PersuasionBanner-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        dangerousText: info,
        "data-test-id": "PersuasionBanner-ParaTag"
      })
    }), (bulletPoints === null || bulletPoints === void 0 ? void 0 : bulletPoints.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(PersuasionBanner_style/* BulletListStyle */.c, {
      "data-test-id": "PersuasionBanner-BulletListStyle",
      children: bulletPoints.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletListItem_BulletListItem, {
          "data-test-id": "PersuasionBanner-BulletListItem",
          children: [item.boldText && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontWeight: "bold",
            "data-test-id": "PersuasionBanner-SpanTag",
            children: item.boldText
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            "data-test-id": "PersuasionBanner-SpanTag",
            children: item.normalText
          })]
        }, item.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: btnText,
      onClick: btnHandler,
      padding: "0px 40px",
      margin: "auto 0 0",
      "data-test-id": "PersuasionBanner-LandingButton"
    })]
  });
};

/* harmony default export */ var PersuasionBanner_PersuasionBanner = (PersuasionBanner);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/MarkdownText/MarkdownText.tsx + 236 modules
var MarkdownText = __webpack_require__(6518);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBannerInsurance.tsx







var PersuasionBannerInsurance = function PersuasionBannerInsurance(_ref) {
  var crossSell = _ref.crossSell,
      btnHandler = _ref.btnHandler;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  if (!crossSell) {
    return null;
  }

  var title = crossSell.title,
      background = crossSell.background,
      description = crossSell.description,
      cta = crossSell.cta,
      info = crossSell.info;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PersuasionBanner_style/* PersuasionBannerStyle */.G, {
    bgImage: background === null || background === void 0 ? void 0 : background.url,
    "data-test-id": "PersuasionBannerInsurance-PersuasionBannerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H3Tag, {
      "data-test-id": "PersuasionBannerInsurance-H3Tag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "PersuasionBannerInsurance-FormattedText"
      })
    }), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
      gap: "6px",
      "data-test-id": "PersuasionBannerInsurance-FlexComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        "data-test-id": "PersuasionBannerInsurance-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "PersuasionBannerInsurance-FormattedText"
        })
      })
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(MarkdownText/* default */.Z, {
      value: description,
      "data-test-id": "PersuasionBannerInsurance-MarkdownText"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customTitle: cta === null || cta === void 0 ? void 0 : cta.title,
      onClick: btnHandler,
      padding: "0px 40px",
      "data-test-id": "PersuasionBannerInsurance-LandingButton"
    })]
  });
};

/* harmony default export */ var PersuasionBanner_PersuasionBannerInsurance = (PersuasionBannerInsurance);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RadioButton/RadioButton.tsx





var RadioButton = function RadioButton(_ref) {
  var children = _ref.children,
      activeBtn = _ref.activeBtn,
      handleChange = _ref.handleChange,
      inputIndex = _ref.inputIndex,
      inputId = _ref.inputId,
      isPadding = _ref.isPadding,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel;

  var handleRadioChange = function handleRadioChange() {
    if (handleChange && inputIndex !== undefined) {
      handleChange(inputIndex);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RadioButtonStyle, {
    isPadding: isPadding,
    onChange: handleRadioChange,
    showLabel: showLabel,
    "data-test-id": "RadioButton-RadioButtonStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "radio",
      onChange: handleRadioChange,
      checked: activeBtn,
      id: inputId,
      name: "radio-group"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      "data-test-id": "RadioButton-label",
      children: children
    })]
  });
};

/* harmony default export */ var RadioButton_RadioButton = (RadioButton);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/utils/index.js

// Holidays array
var holidays = [{
  date: "2023-03-08",
  name: "Holi"
}, {
  date: "2023-03-30",
  name: "Ram Navami"
}, {
  date: "2023-04-04",
  name: "Mahavir Jayanti"
}, {
  date: "2023-04-07",
  name: "Good Friday"
}, {
  date: "2023-04-22",
  name: "Eid-ul-fitr"
}, {
  date: "2023-05-01",
  name: "Labor Day"
}, {
  date: "2023-05-05",
  name: "Budhha Purnima"
}, {
  date: "2023-07-29",
  name: "Muharram"
}, {
  date: "2023-08-15",
  name: "Independence Day"
}, {
  date: "2023-08-29",
  name: "Onam"
}, {
  date: "2023-08-30",
  name: "Raksha Bandhan"
}, {
  date: "2023-09-07",
  name: "Ganesh Chaturthi"
}, {
  date: "2023-10-02",
  name: "Gandhi Jayanti"
}, {
  date: "2023-10-24",
  name: "Dussehra"
}, {
  date: "2023-10-28",
  name: "Valmiki Jayanti"
}, {
  date: "2023-11-12",
  name: "Diwali"
}, {
  date: "2023-11-27",
  name: "Guru Nanak Jayanti"
}, {
  date: "2023-12-25",
  name: "Christmas"
}, {
  date: "2024-01-01",
  name: "New Year's Day"
}]; // Get all days in a month

function utils_getDaysInMonth(year, month, showHolidays) {
  var daysInMonth = new Date(year, month + 1, 0).getDate();
  var days = [];
  var holidaysCount = 0;

  for (var i = 1; i <= daysInMonth; i++) {
    /* istanbul ignore next */
    if (showHolidays) {
      (function () {
        var dateTimestamp = Date.UTC(year, month, i);
        var isHoliday = false;
        var holidayName = "";
        holidays.forEach(function (holiday) {
          var holidayDate = new Date(holiday.date);
          var holidayTimestamp = Date.UTC(holidayDate.getFullYear(), holidayDate.getMonth(), holidayDate.getDate());

          if (dateTimestamp === holidayTimestamp) {
            isHoliday = true;
            holidayName = holiday.name;
            holidaysCount++;
          }
        });
        days.push({
          date: new Date(year, month, i),
          isHoliday: isHoliday,
          holidayName: holidayName
        });
      })();
    } else {
      days.push({
        date: new Date(year, month, i)
      });
    }
  }

  return {
    days: days,
    holidaysCount: holidaysCount
  };
} // Get all calendar data

function getCalendarData(startDate, endDate, showHolidays) {
  var currentDate = startDate ? new Date(startDate) : new Date();
  var lastDate = endDate ? new Date(endDate) : new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
  var monthData = [];

  while (currentDate <= lastDate) {
    var year = currentDate.getFullYear();
    var month = currentDate.getMonth();
    var firstDay = new Date(year, month, 1).getDay();
    var lastDay = new Date(year, month + 1, 0).getDate();
    var daysInMonth = utils_getDaysInMonth(year, month, showHolidays);
    monthData.push({
      month: month,
      year: year,
      daysInMonth: daysInMonth,
      firstDayOfWeek: firstDay
    });
    currentDate.setMonth(month + 1);
    currentDate.setDate(1);
  }

  return monthData;
} // Generate empty cell before start date

function emptyCellBefore(data, daysInMonth) {
  var daysBefore = new Array(data).fill(null).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "empty",
      "data-test-id": "daysBefore"
    }, "empty-".concat(i));
  });
  return daysBefore;
} // Generate empty cell after end date

function emptyCellAfter(data, daysInMonth) {
  var emptyDaysAfter = new Array(7 - (emptyCellBefore().length + daysInMonth.days.length) % 7).fill(null).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "empty",
      "data-test-id": "emptyDaysAfter"
    }, "empty-after-".concat(i));
  });
  return emptyDaysAfter;
}
var formatDate = function formatDate(dateString) {
  var date = new Date(dateString);
  var day = date.getDate();
  var month = date.getMonth() + 1; // Month starts from 0, so we add 1 to get the correct month.

  var year = date.getFullYear() % 100; // Get the last two digits of the year.

  return "".concat(day, "/").concat(month, "/").concat(year);
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.style.ts

var Calendar_style_CalenderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderWrap",
  componentId: "qjvs5t-0"
})(["flex:1;overflow-y:auto;padding-bottom:10px;"]);
var CalenderMonthName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderMonthName",
  componentId: "qjvs5t-1"
})(["background-color:#fff;padding:20px 16px;font-size:16px;font-weight:700;color:#4a4a4a;display:flex;align-items:center;"]);
var CalenderDays = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDays",
  componentId: "qjvs5t-2"
})(["display:grid;grid-template-columns:repeat(7,1fr);border-bottom:1px solid #e7e7e7;background-color:#f2f2f2;"]);
var CalenderDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDate",
  componentId: "qjvs5t-3"
})(["border-left:1px solid #e7e7e7;border-top:1px solid #e7e7e7;padding:20px 5px;display:flex;align-items:center;justify-content:center;background-color:#fff;position:relative;", " ", " ", ""], function (p) {
  return p.isSelected && " background-color: #008cff;";
}, function (p) {
  return p.isWithinRange && "background-color: #f0f8ff;";
}, function (p) {
  return p.isDisabled && " pointer-events: none;";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.tsx









var Calendar = function Calendar(_ref) {
  var handleDayClick = _ref.handleDayClick,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      monthNameType = _ref.monthNameType,
      yearType = _ref.yearType,
      selected = _ref.selected,
      _ref$numberOfMonth = _ref.numberOfMonth,
      numberOfMonth = _ref$numberOfMonth === void 0 ? 13 : _ref$numberOfMonth,
      maxEndDate = _ref.maxEndDate;
  // const [sDate, setSDate] = useState(startDate);
  // const [eDate, setEDate] = useState(endDate);
  var monthRefs = (0,react.useRef)([]);
  var calendarData = getCalendarData(new Date(), maxEndDate);
  (0,react.useEffect)(function () {
    if (selected !== null && selected !== void 0 && selected.from) {
      var _monthRefs$current$re;

      var selectedMonth = selected.from.getMonth();
      var selectedYear = selected.from.getFullYear();
      var refIndex = calendarData === null || calendarData === void 0 ? void 0 : calendarData.findIndex(function (_ref2) {
        var month = _ref2.month,
            year = _ref2.year;
        return month === selectedMonth && year === selectedYear;
      });
      refIndex && ((_monthRefs$current$re = monthRefs.current[refIndex]) === null || _monthRefs$current$re === void 0 ? void 0 : _monthRefs$current$re.scrollIntoView({
        behavior: "auto",
        block: "start"
      }));
    }
  }, [selected, calendarData]);

  var disabledDays = function disabledDays(date) {
    return isBefore(startOfDay(date), startOfDay(new Date())) || !!(maxEndDate && isAfter(date, maxEndDate));
  };

  var isBefore = function isBefore(date1, date2) {
    return date1 < date2;
  };

  var isAfter = function isAfter(date1, date2) {
    return date1 > date2;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_style_CalenderWrap, {
    "data-test-id": "Calendar-CalenderWrap",
    children: calendarData === null || calendarData === void 0 ? void 0 : calendarData.map(function (_ref3, index) {
      var month = _ref3.month,
          year = _ref3.year,
          daysInMonth = _ref3.daysInMonth,
          firstDayOfWeek = _ref3.firstDayOfWeek;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: function ref(_ref4) {
          return monthRefs.current[index] = _ref4;
        },
        "data-test-id": "Calendar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderMonthName, {
          "data-test-id": "Calendar-CalenderMonthName",
          children: [new Date(year, month).toLocaleString("en-us", {
            month: monthNameType
          }), " ", "\xA0", new Date(year, month).toLocaleString("en-us", {
            year: yearType
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderDays, {
          "data-test-id": "Calendar-CalenderDays",
          children: [emptyCellBefore(firstDayOfWeek, daysInMonth), daysInMonth.days.map(function (day) {
            var d = new Date();
            var curDate = d.getDate();
            var curMonth = d.getMonth();
            var curYear = d.getFullYear();
            var isSelected = day.date.getTime() === ((selected === null || selected === void 0 ? void 0 : selected.from) && (selected === null || selected === void 0 ? void 0 : selected.from.getTime())) || day.date.getTime() === ((selected === null || selected === void 0 ? void 0 : selected.to) && (selected === null || selected === void 0 ? void 0 : selected.to.getTime()));
            var isWithinRange = selected && day.date > selected.from && day.date < selected.to;
            var isDisabled = disabledDays(day.date);
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderDate, {
              isSelected: isSelected,
              isWithinRange: isWithinRange,
              isDisabled: isDisabled,
              onClick: handleDayClick ? function () {
                return handleDayClick(day.date);
              } : function () {},
              "data-test-id": "Calendar-CalenderDate",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                color: isSelected ? Global/* theme.whiteText */.rS.whiteText : isDisabled ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
                "data-test-id": "Calendar-SpanTag",
                children: day.date.getDate()
              })
            }, "".concat(day));
          }), emptyCellAfter(firstDayOfWeek, daysInMonth)]
        })]
      }, "".concat(index));
    })
  });
};

/* harmony default export */ var Calendar_Calendar = (Calendar);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.style.ts

var CalenderFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFooterWrap",
  componentId: "fnv5ae-0"
})(["background-color:#fff;padding:16px;box-shadow:0 0 6px rgba(0,0,0,0.2);position:relative;"]);
var CalenderFootRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFootRange",
  componentId: "fnv5ae-1"
})(["display:flex;align-items:center;gap:8px;margin-bottom:16px;"]);
var CalFootRangeCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalFootRangeCol",
  componentId: "fnv5ae-2"
})(["flex:1;background-color:#f7f7f7;border:1px solid #e7e7e7;border-radius:2px;padding:8px 10px;height:54px;position:relative;", " &:last-child{padding:8px 10px 8px 16px;}"], function (p) {
  return p.selected && "\n        border: 1px solid #008CFF;\n        background: #F9FCFF;\n    ";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.tsx









var CalendarFooter = function CalendarFooter(_ref) {
  var checkinDate = _ref.checkinDate,
      checkoutDate = _ref.checkoutDate,
      onSubmitButtonPress = _ref.onSubmitButtonPress;

  var _useState = (0,react.useState)(0),
      selected = _useState[0],
      setSelected = _useState[1];

  (0,react.useEffect)(function () {
    checkinDate && setSelected(1);
    checkinDate && checkoutDate && setSelected(0);
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFooterWrap, {
    "data-test-id": "CalendarFooter-CalenderFooterWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFootRange, {
      "data-test-id": "CalendarFooter-CalenderFootRange",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 0,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 0 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "start date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkinDate ? formatDate(checkinDate) : "-"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 1,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 1 ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "end date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkoutDate ? formatDate(checkoutDate) : "-"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
      customWidth: "100%",
      onClick: onSubmitButtonPress ? function () {
        return onSubmitButtonPress(checkinDate, checkoutDate);
      } : function () {},
      customTitle: "Confirm",
      disableState: !checkinDate || !checkoutDate,
      "data-test-id": "CalendarFooter-LandingButton"
    })]
  });
};

/* harmony default export */ var CalendarFooter_CalendarFooter = (CalendarFooter);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.style.ts

var CalenderHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarHeaderstyle__CalenderHeaderWrap",
  componentId: "sc-1hfcczo-0"
})(["background-color:#fff;padding:12px 16px;position:sticky;display:flex;align-items:center;top:0;z-index:6;"]);
var CalHeaderBackBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "CalendarHeaderstyle__CalHeaderBackBtn",
  componentId: "sc-1hfcczo-1"
})(["width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;background:transparent;outline:0;border:0;position:relative;flex-shrink:0;margin-right:15px;&:after{content:\"\";border:solid #000;border-width:0 2px 2px 0;padding:5px;transform:rotate(135deg);position:absolute;left:2;}&:before{width:16px;height:2px;background-color:#000;content:\"\";flex-shrink:0;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.tsx






var CalendarHeader = function CalendarHeader(_ref) {
  var checkinDate = _ref.checkinDate,
      checkoutDate = _ref.checkoutDate,
      onBackPress = _ref.onBackPress;

  var _useState = (0,react.useState)("Select Travel Dates"),
      text = _useState[0],
      setText = _useState[1];

  (0,react.useEffect)(function () {
    checkinDate && setText("Select Travel Dates");
    checkinDate && checkoutDate && setText("Select Travel Dates");
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderHeaderWrap, {
    "data-test-id": "CalendarHeader-CalenderHeaderWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CalHeaderBackBtn, {
      onClick: onBackPress,
      "data-test-id": "CalendarHeader-CalHeaderBackBtn"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
      fontWeight: "bold",
      fontSize: "md",
      "data-test-id": "CalendarHeader-SpanTag",
      children: text
    })]
  });
};

/* harmony default export */ var CalendarHeader_CalendarHeader = (CalendarHeader);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.style.ts

var WeekDayWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WeekDaysstyle__WeekDayWrap",
  componentId: "rgj0qq-0"
})(["background-color:#fff;padding:2px 0;position:sticky;top:49px;z-index:1;box-shadow:0 2px 6px rgba(0,0,0,0.2);display:grid;grid-template-columns:repeat(7,1fr);span{font-size:12px;font-weight:400;color:#000;display:flex;align-items:center;justify-content:center;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.tsx

 // import './WeekDays.css';




var WeekDays = function WeekDays(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WeekDayWrap, {
    style: {
      top: top
    },
    "data-test-id": "WeekDays-WeekDayWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sun"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Mon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Tue"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Wed"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Thu"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Fri"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sat"
    })]
  });
};

/* harmony default export */ var WeekDays_WeekDays = (WeekDays);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/styles/styles.style.ts

var calenderAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var RangeDatePickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__RangeDatePickerStyle",
  componentId: "r5aesx-0"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;"], calenderAnim);
var styles_style_ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__ErrorToast",
  componentId: "r5aesx-1"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/RangeDatePicker.tsx











// import './styles/styles.css';
var RangeDatePicker = function RangeDatePicker(_ref) {
  var calendarHeader = _ref.calendarHeader,
      _ref$calendarWeekdays = _ref.calendarWeekdays,
      calendarWeekdays = _ref$calendarWeekdays === void 0 ? true : _ref$calendarWeekdays,
      _ref$monthNameType = _ref.monthNameType,
      monthNameType = _ref$monthNameType === void 0 ? "short" : _ref$monthNameType,
      _ref$yearType = _ref.yearType,
      yearType = _ref$yearType === void 0 ? "numeric" : _ref$yearType,
      calendarFooter = _ref.calendarFooter,
      onBackPress = _ref.onBackPress,
      onSubmitButtonPress = _ref.onSubmitButtonPress,
      range = _ref.range,
      from = _ref.from,
      to = _ref.to,
      showToast = _ref.showToast,
      toastMessage = _ref.toastMessage,
      handleDayClick = _ref.handleDayClick,
      selected = _ref.selected,
      maxEndDate = _ref.maxEndDate;

  var _useState = (0,react.useState)(from),
      startDate = _useState[0],
      setStartDate = _useState[1];

  var _useState2 = (0,react.useState)(to),
      endDate = _useState2[0],
      setEndDate = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RangeDatePickerStyle, {
    className: "cal__container",
    "data-test-id": "RangeDatePicker-RangeDatePickerStyle",
    children: [calendarHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarHeader_CalendarHeader, {
      checkinDate: startDate,
      checkoutDate: endDate,
      onBackPress: onBackPress,
      "data-test-id": "RangeDatePicker-CalendarHeader"
    }), calendarWeekdays && /*#__PURE__*/(0,jsx_runtime.jsx)(WeekDays_WeekDays, {
      top: calendarHeader ? 49 : 0,
      "data-test-id": "RangeDatePicker-WeekDays"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_Calendar, {
      handleDayClick: handleDayClick,
      startDate: startDate,
      endDate: endDate,
      monthNameType: monthNameType,
      yearType: yearType,
      selected: selected,
      maxEndDate: maxEndDate,
      "data-test-id": "RangeDatePicker-Calendar"
    }), calendarFooter && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarFooter_CalendarFooter, {
      checkinDate: selected === null || selected === void 0 ? void 0 : selected.from,
      checkoutDate: selected === null || selected === void 0 ? void 0 : selected.to,
      onSubmitButtonPress: onSubmitButtonPress ? function () {
        return onSubmitButtonPress(selected === null || selected === void 0 ? void 0 : selected.from, selected === null || selected === void 0 ? void 0 : selected.to);
      } : function () {},
      "data-test-id": "RangeDatePicker-CalendarFooter"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(styles_style_ErrorToast, {
      "data-test-id": "RangeDatePicker-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "RangeDatePicker-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: toastMessage,
          "data-test-id": "RangeDatePicker-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ var RangeDatePicker_RangeDatePicker = (RangeDatePicker);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(8316);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ReactPortalComp.tsx




var ReactPortalComp = function ReactPortalComp(props) {
  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  (0,react.useEffect)(function () {
    ref.current = document.querySelector("#portal");
    setMounted(true);
  }, []);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return mounted && ref.current ? /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    "data-test-id": "ReactPortalComp",
    children: props.children
  }), ref.current) : null;
};

/* harmony default export */ var components_ReactPortalComp = (ReactPortalComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.style.ts



var SafenSecureTravStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravStyle",
  componentId: "e1cu42-0"
})(["width:100%;background:#fff;position:relative;z-index:1;overflow:hidden;", "{width:64%;}@media ", "{padding:0 16px;}"], TextStyles_style/* H2TagStyle */.FI, static_utils/* deviceType.mobile */.vO.mobile);
var SafenSecureTravCrdStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravCrdStyle",
  componentId: "e1cu42-1"
})(["background:linear-gradient( 128.03deg,rgba(227,247,245,0.36) 2.1%,rgba(230,237,255,0.441706) 49.06%,rgba(214,232,244,0.6) 80.75% ),#fcffff;border-radius:14px;padding:24px;flex:1;position:relative;display:flex;flex-direction:column;gap:24px;> img{position:absolute;right:30px;bottom:24px;}@media ", "{gap:12px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var FeatList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SafenSecureTravstyle__FeatList",
  componentId: "e1cu42-2"
})(["display:flex;flex-direction:column;gap:16px;max-width:80%;li{position:relative;padding-left:14px;}li:after{content:\"\";position:absolute;background:#000000;border-radius:2px;width:4px;height:14px;top:6px;left:0;}@media ", "{margin-bottom:12px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var SafenSecureBgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureBgWrap",
  componentId: "e1cu42-3"
})(["position:absolute;top:17px;right:-122px;width:100%;z-index:-1;height:558px;img{width:100%;height:558px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTravCrd.tsx








var SafenSecureTravCrd = function SafenSecureTravCrd(_ref) {
  var title = _ref.title,
      featList = _ref.featList,
      cardImg = _ref.cardImg,
      poweredBy = _ref.poweredBy;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravCrdStyle, {
    "data-test-id": "SafenSecureTravCrd-SafenSecureTravCrdStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
      "data-test-id": "SafenSecureTravCrd-H5Tag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontWeight: "black",
      fontSize: "large",
      margin: device == "sm" ? "" : "0 0 12px",
      "data-test-id": "SafenSecureTravCrd-ParaTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatList, {
      "data-test-id": "SafenSecureTravCrd-FeatList",
      children: featList && (featList === null || featList === void 0 ? void 0 : featList.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          "data-test-id": `SafenSecureTravCrd-${index}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: item,
            "data-test-id": "SafenSecureTravCrd-FormattedText"
          })
        }, index);
      }))
    }), poweredBy && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      margin: "auto 0 0",
      gap: "20px",
      alignItems: "Center",
      "data-test-id": "SafenSecureTravCrd-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        "data-test-id": "SafenSecureTravCrd-SpanTag",
        children: "Powered By"
      }), poweredBy && poweredBy.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          src: item,
          width: "32px",
          height: "22px",
          "data-test-id": `SafenSecureTravCrd-ImageComponent-${index}`
        }, index);
      })]
    }), cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
      width: device == "lg" ? "92px" : "54px",
      height: device == "lg" ? "102px" : "60px",
      src: cardImg,
      "data-test-id": "SafenSecureTravCrd-ImageComponent"
    })]
  });
};

/* harmony default export */ var SafenSecureTrav_SafenSecureTravCrd = (SafenSecureTravCrd);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.tsx


function SafenSecureTrav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SafenSecureTrav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SafenSecureTrav_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SafenSecureTrav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var SafenSecureTrav = function SafenSecureTrav(_ref) {
  var title = _ref.title,
      data = _ref.data;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravStyle, {
    "data-test-id": "SafenSecureTrav-SafenSecureTravStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureBgWrap, {
      "data-test-id": "SafenSecureTrav-SafenSecureBgWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "100%",
        height: "558px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg",
        "data-test-id": "SafenSecureTrav-ImageComponent"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "SafenSecureTrav-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
        margin: "0 0 60px",
        "data-test-id": "SafenSecureTrav-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        margin: "0 0 20px",
        "data-test-id": "SafenSecureTrav-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        gap: device == "lg" ? "60px" : "20px",
        flexDirection: device == "sm" ? "column" : "row",
        flexWrap: "wrap",
        "data-test-id": "SafenSecureTrav-FlexComp",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureTrav_SafenSecureTravCrd, SafenSecureTrav_objectSpread(SafenSecureTrav_objectSpread({}, item), {}, {
            "data-test-id": `SafenSecureTrav-SafenSecureTravCrd-${index}`
          }), index);
        })
      })]
    })]
  });
};

/* harmony default export */ var SafenSecureTrav_SafenSecureTrav = (SafenSecureTrav);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.style.ts
var SectionDividers_style = __webpack_require__(2287);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.tsx



var SectionDividers = function SectionDividers(_ref) {
  var small = _ref.small,
      large = _ref.large,
      xs = _ref.xs,
      width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      margin = _ref.margin,
      backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_style/* SectionDividersStyle */.$, {
    backgroundColor: backgroundColor,
    small: small,
    large: large,
    xs: xs,
    width: width,
    height: height,
    borderRadius: borderRadius,
    margin: margin,
    "data-test-id": "SectionDividers-SectionDividersStyle"
  });
};

/* harmony default export */ var SectionDividers_SectionDividers = (SectionDividers);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.style.ts




var SecureTravOfferStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravOfferStyle",
  componentId: "pvlpoe-0"
})(["display:flex;flex-direction:column;gap:24px;svg{flex-shrink:0;}", "{font-size:22px;font-weight:900;}"], TextStyles_style/* H5TagStyle */.Wl);
var SecureTravItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravItem",
  componentId: "pvlpoe-1"
})(["display:flex;gap:24px;@media ", "{gap:8px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var SecureTravImgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravImgWrap",
  componentId: "pvlpoe-2"
})(["background:linear-gradient( 125.09deg,#474747 0%,rgba(255,255,255,0) 64.55% );border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:72px;height:80px;", ""], function (p) {
  return p.pageTheme === src.PARTNER.MMT ? "\n     background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);\n    " : p.pageTheme === src.PARTNER.GI ? "background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);" : "\n    ";
});
var SecureTravContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravContent",
  componentId: "pvlpoe-3"
})(["align-self:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.tsx









var SecureTravOffer = function SecureTravOffer(_ref) {
  var data = _ref.data;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravOfferStyle, {
    "data-test-id": "SecureTravOffer-SecureTravOfferStyle",
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravItem, {
        "data-test-id": `SecureTravOffer-SecureTravItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravImgWrap, {
          pageTheme: context ? context : undefined,
          "data-test-id": "SecureTravOffer-SecureTravImgWrap",
          children: item.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "48px",
            height: "48px",
            src: item.travImg,
            loading: "eager",
            "data-test-id": "SecureTravOffer-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravContent, {
          "data-test-id": "SecureTravOffer-SecureTravContent",
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-H5Tag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "md",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            margin: device == "lg" ? "16px 0 0" : "8px 0 0",
            fontSize: device == "lg" ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.info,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ var SecureTravOffer_SecureTravOffer = (SecureTravOffer);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts
var TMFloatingInput_style = __webpack_require__(599);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.style.ts

var ToolTipCompWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ToolTipCompstyle__ToolTipCompWrapper",
  componentId: "sc-7xkig7-0"
})(["position:absolute;background:#1a7971;border:4px solid #1a7971;left:", ";right:", ";top:", ";bottom:", ";width:", ";font-size:14px;line-height:20px;padding:8px;border-radius:4px;gap:20px;z-index:1;color:#ffffff;&:after,&:before{border:solid transparent;content:\"\";height:0;width:0;position:absolute;pointer-events:none;}&:after{border-color:rgba(0,0,0,0);border-width:13px;}&:before{border-color:rgba(0,0,0,0);border-width:13px;}", " ", " ", " ", ""], function (props) {
  return props.left;
}, function (props) {
  return props.right;
}, function (props) {
  return props.top;
}, function (props) {
  return props.bottom;
}, function (props) {
  return props.width;
}, function (props) {
  return props.toolTipArrow == "top" && "\n&:after, &:before {\n\tbottom: 100%;\n\tleft: 50%;\n}\n\n&:after {\n\tborder-bottom-color: #1A7971;\n\tmargin-top: -30px;\n}\n&:before {\n\tborder-bottom-color: #1A7971;\n\tmargin-top: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "bottom" && "\n&:after, &:before {\n\ttop: 100%;\n\tleft: 50%;\n}\n\n&:after {\n\tborder-top-color: #1A7971;;\n\tmargin-left: -34px;\n}\n&:before {\n\tborder-top-color: #1A7971;\n\tmargin-left: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "right" && "\n&:after, &:before {\n\tleft: 100%;\n\ttop: 50%;\n}\n\n&:after {\n\tborder-left-color: #1A7971;\n\tmargin-top: -30px;\n}\n&:before {\n\tborder-left-color: #1A7971;\n\tmargin-top: -36px;\n}\n\n";
}, function (props) {
  return props.toolTipArrow == "left" && "\n&:after, &:before {\n\tright: 100%;\n\ttop: 50%;\n}\n\n&:after {\n\tborder-right-color: #1A7971;\n\tmargin-top: -17px;\n}\n&:before {\n\tborder-right-color: #1A7971;\n\tmargin-top: -19px;\n}\n\n";
});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModal.style.ts








var SelectCountryModalStyle = (0,styled_components_browser_esm/* default */.ZP)(CommonModalDweb_style/* CommonModalDwebStyle */.E5).withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryModalStyle",
  componentId: "one95n-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
var CountryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountryItem",
  componentId: "one95n-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;cursor:pointer;", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], LandingButton_style/* LandingButtonStyle */.zm, CheckButtonStyle, Global/* theme.yellowText3 */.rS.yellowText3, ToolTipCompWrapper);
var SelectCountryModal_style_BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__BtnWrap",
  componentId: "one95n-2"
})(["position:sticky;bottom:16px;left:16px;width:calc(100% - 32px);"]);
var CountrySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySection",
  componentId: "one95n-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
var CountrySectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySectionWrap",
  componentId: "one95n-4"
})(["overflow-y:scroll;@media ", "{padding:16px;}"], src.deviceType.mobile);
var PopularRegionCountries = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__PopularRegionCountries",
  componentId: "one95n-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
var SelectCountrySheetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountrySheetStyle",
  componentId: "one95n-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], TMFloatingInput_style/* TMInputWrap */.dd);
var SelectCountryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryHeader",
  componentId: "one95n-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function classCallCheck_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function createClass_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/defineProperty.js

function defineProperty_defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ../../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ../../node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/calculateSizeAndPositionDataAndUpdateScrollOffset.js
/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/types.js


var bpfrpt_proptype_CellPosition =  true ? null : 0;
var bpfrpt_proptype_CellRendererParams =  true ? null : 0;
var bpfrpt_proptype_CellRenderer =  true ? null : 0;
var bpfrpt_proptype_CellCache =  true ? null : 0;
var bpfrpt_proptype_StyleCache =  true ? null : 0;
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : 0;
var bpfrpt_proptype_CellRangeRenderer =  true ? null : 0;
var bpfrpt_proptype_CellSizeGetter =  true ? null : 0;
var bpfrpt_proptype_CellSize =  true ? null : 0;
var bpfrpt_proptype_NoContentRenderer =  true ? null : 0;
var bpfrpt_proptype_Scroll =  true ? null : 0;
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : 0;
var bpfrpt_proptype_RenderedSection =  true ? null : 0;
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : 0;
var bpfrpt_proptype_OverscanIndices =  true ? null : 0;
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : 0;
var bpfrpt_proptype_Alignment =  true ? null : 0;
var bpfrpt_proptype_VisibleCellRange =  true ? null : 0;



















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/CellSizeAndPositionManager.js




/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    classCallCheck_classCallCheck(this, CellSizeAndPositionManager);

    defineProperty_defineProperty(this, "_cellSizeAndPositionData", {});

    defineProperty_defineProperty(this, "_lastMeasuredIndex", -1);

    defineProperty_defineProperty(this, "_lastBatchedIndex", -1);

    defineProperty_defineProperty(this, "_cellCount", void 0);

    defineProperty_defineProperty(this, "_cellSizeGetter", void 0);

    defineProperty_defineProperty(this, "_estimatedCellSize", void 0);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  createClass_createClass(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/maxElementSize.js
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/ScalingCellSizeAndPositionManager.js







/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize,
        params = _objectWithoutProperties(_ref, ["maxScrollSize"]);

    classCallCheck_classCallCheck(this, ScalingCellSizeAndPositionManager);

    defineProperty_defineProperty(this, "_cellSizeAndPositionManager", void 0);

    defineProperty_defineProperty(this, "_maxScrollSize", void 0);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new CellSizeAndPositionManager(params);
    this._maxScrollSize = maxScrollSize;
  }

  createClass_createClass(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/createCallbackMemoizer.js
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/defaultOverscanIndicesGetter.js
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/utils/updateScrollIndexHelper.js

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/defaultCellRangeRenderer.js
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {}

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {}
}


;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var esm_canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/scrollbarSize.js

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (esm_canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/animationFrame.js
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/requestAnimationTimeout.js

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : 0;
var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return caf(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = raf(timeout);
    }
  };

  var frame = {
    id: raf(timeout)
  };
  return frame;
};


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/Grid.js









var _class, _temp;

function Grid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Grid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Grid_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Grid_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    classCallCheck_classCallCheck(this, Grid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Grid).call(this, props));

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onGridRenderedMemoizer", createCallbackMemoizer());

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    defineProperty_defineProperty(_assertThisInitialized(_this), "_deferredInvalidateColumnIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_deferredInvalidateRowIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_recomputeScrollLeftFlag", false);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_recomputeScrollTopFlag", false);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_horizontalScrollBarSize", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_verticalScrollBarSize", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_scrollbarPresenceChanged", false);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_scrollingContainer", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_childrenToDisplay", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_columnStartIndex", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_columnStopIndex", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_rowStartIndex", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_rowStopIndex", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_renderedColumnStartIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_renderedColumnStopIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_renderedRowStartIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_renderedRowStopIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_initialScrollTop", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_initialScrollLeft", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_disablePointerEventsTimeoutId", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_styleCache", {});

    defineProperty_defineProperty(_assertThisInitialized(_this), "_cellCache", {});

    defineProperty_defineProperty(_assertThisInitialized(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });

    var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  createClass_createClass(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = Grid_objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(Grid_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(Grid_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = Grid_objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return react.createElement("div", _extends({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: clsx_m('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: Grid_objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && react.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: Grid_objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = requestAnimationTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return Grid_objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);

  return Grid;
}(react.PureComponent), defineProperty_defineProperty(_class, "propTypes",  true ? null : 0), _temp);

defineProperty_defineProperty(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: defaultCellRangeRenderer,
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: scrollbarSize,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});

polyfill(Grid);
/* harmony default export */ var Grid_Grid = (Grid);















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/accessibilityOverscanIndicesGetter.js
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_BACKWARD = (/* unused pure expression or super */ null && (-1));
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD = 1;
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Grid/index.js





















;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/types.js
var bpfrpt_proptype_ScrollIndices =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/ArrowKeyStepper.js








var ArrowKeyStepper_class, ArrowKeyStepper_temp;

function ArrowKeyStepper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ArrowKeyStepper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArrowKeyStepper_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArrowKeyStepper_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = (ArrowKeyStepper_temp = ArrowKeyStepper_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ArrowKeyStepper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_defineProperty(_assertThisInitialized(_this), "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_columnStartIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_columnStopIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_rowStartIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_rowStopIndex", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onKeyDown", function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;

      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow; // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;

        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;

        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;

        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onSectionRendered", function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });

    return _this;
  }

  createClass_createClass(ArrowKeyStepper, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;
      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children;

      var _this$_getScrollState3 = this._getScrollState(),
          scrollToColumn = _this$_getScrollState3.scrollToColumn,
          scrollToRow = _this$_getScrollState3.scrollToRow;

      return react.createElement("div", {
        className: className,
        onKeyDown: this._onKeyDown
      }, children({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;
      var _this$props3 = this.props,
          isControlled = _this$props3.isControlled,
          onScrollToChange = _this$props3.onScrollToChange;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }

      if (!isControlled) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return {};
      }

      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return ArrowKeyStepper_objectSpread({}, prevState, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }

      return {};
    }
  }]);

  return ArrowKeyStepper;
}(react.PureComponent), defineProperty_defineProperty(ArrowKeyStepper_class, "propTypes",  true ? null : 0), ArrowKeyStepper_temp);

defineProperty_defineProperty(ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
});

polyfill(ArrowKeyStepper);
/* harmony default export */ var ArrowKeyStepper_ArrowKeyStepper = ((/* unused pure expression or super */ null && (ArrowKeyStepper)));



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ArrowKeyStepper/index.js




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/detectElementResize.js
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = __webpack_require__.g;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/AutoSizer/AutoSizer.js








var AutoSizer_class, AutoSizer_temp;

function AutoSizer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AutoSizer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AutoSizer_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AutoSizer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var AutoSizer = (AutoSizer_temp = AutoSizer_class =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_defineProperty(_assertThisInitialized(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_parentNode", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_autoSizer", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_window", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_detectElementResize", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });

    return _this;
  }

  createClass_createClass(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = createDetectElementResize(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return react.createElement("div", {
        className: className,
        ref: this._setRef,
        style: AutoSizer_objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);

  return AutoSizer;
}(react.Component), defineProperty_defineProperty(AutoSizer_class, "propTypes",  true ? null : 0), AutoSizer_temp);

defineProperty_defineProperty(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/AutoSizer/index.js


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/types.js
var bpfrpt_proptype_CellMeasureCache =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurer.js








var CellMeasurer_class, CellMeasurer_temp;




/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer_CellMeasurer = (CellMeasurer_temp = CellMeasurer_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, CellMeasurer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CellMeasurer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_defineProperty(_assertThisInitialized(_this), "_child", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_measure", function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }

      _this._child = element;

      if (element) {
        _this._maybeMeasureCell();
      }
    });

    return _this;
  }

  createClass_createClass(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child || (0,react_dom.findDOMNode)(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.

        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }

        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660

        if (styleWidth) {
          node.style.width = styleWidth;
        }

        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
          cache = _this$props2.cache,
          _this$props2$columnIn = _this$props2.columnIndex,
          columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
          parent = _this$props2.parent,
          _this$props2$rowIndex = _this$props2.rowIndex,
          rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;

      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
            height = _this$_getCellMeasure2.height,
            width = _this$_getCellMeasure2.width;

        cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.

        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(react.PureComponent), defineProperty_defineProperty(CellMeasurer_class, "propTypes",  true ? null : 0), CellMeasurer_temp); // Used for DEV mode warning check

defineProperty_defineProperty(CellMeasurer_CellMeasurer, "__internalCellMeasurerFlag", false);



if (false) {}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/CellMeasurerCache.js



var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CellMeasurerCache);

    _defineProperty(this, "_cellHeightCache", {});

    _defineProperty(this, "_cellWidthCache", {});

    _defineProperty(this, "_columnWidthCache", {});

    _defineProperty(this, "_rowHeightCache", {});

    _defineProperty(this, "_defaultHeight", void 0);

    _defineProperty(this, "_defaultWidth", void 0);

    _defineProperty(this, "_minHeight", void 0);

    _defineProperty(this, "_minWidth", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    _defineProperty(this, "_hasFixedHeight", void 0);

    _defineProperty(this, "_hasFixedWidth", void 0);

    _defineProperty(this, "_columnCount", 0);

    _defineProperty(this, "_rowCount", 0);

    _defineProperty(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
    });

    _defineProperty(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
    });

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {}
  }

  _createClass(CellMeasurerCache, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }

      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      } // Size is cached per cell so we don't have to re-measure if cells are re-ordered.


      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;

        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }

        var columnKey = this._keyMapper(0, columnIndex);

        this._columnWidthCache[columnKey] = columnWidth;
      }

      if (!this._hasFixedHeight) {
        var rowHeight = 0;

        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }

        var rowKey = this._keyMapper(rowIndex, 0);

        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}()));



function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/CellMeasurer/index.js


/* harmony default export */ var es_CellMeasurer = ((/* unused pure expression or super */ null && (CellMeasurer)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/CollectionView.js








function CollectionView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CollectionView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CollectionView_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CollectionView_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var CollectionView_SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, CollectionView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollectionView)).call.apply(_getPrototypeOf2, [this].concat(args))); // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()

    defineProperty_defineProperty(_assertThisInitialized(_this), "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_calculateSizeAndPositionDataOnNextUpdate", false);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onSectionRenderedMemoizer", createCallbackMemoizer());

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScrollMemoizer", createCallbackMemoizer(false));

    defineProperty_defineProperty(_assertThisInitialized(_this), "_invokeOnSectionRenderedHelper", function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;

      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_updateScrollPositionForScrollToCell", function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;

      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._enablePointerEventsAfterDelay(); // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.


      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;
      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop)); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? CollectionView_SCROLL_POSITION_CHANGE_REASONS.OBSERVED : CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED; // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)

        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    });

    _this._scrollbarSize = scrollbarSize();

    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }

    return _this;
  }
  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  createClass_createClass(CollectionView, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          cellLayoutManager = _this$props4.cellLayoutManager,
          scrollLeft = _this$props4.scrollLeft,
          scrollToCell = _this$props4.scrollToCell,
          scrollTop = _this$props4.scrollTop; // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = scrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      } // Update onSectionRendered callback.


      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width; // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
          height = _this$props5.height,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToCell = _this$props5.scrollToCell,
          width = _this$props5.width;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollPositionChangeReason = _this$state2.scrollPositionChangeReason,
          scrollTop = _this$state2.scrollTop; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Update scroll offsets if the current :scrollToCell values requires it


      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoHeight = _this$props6.autoHeight,
          cellCount = _this$props6.cellCount,
          cellLayoutManager = _this$props6.cellLayoutManager,
          className = _this$props6.className,
          height = _this$props6.height,
          horizontalOverscanSize = _this$props6.horizontalOverscanSize,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          style = _this$props6.style,
          verticalOverscanSize = _this$props6.verticalOverscanSize,
          width = _this$props6.width;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollLeft = _this$state3.scrollLeft,
          scrollTop = _this$state3.scrollTop; // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width; // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];
      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      }; // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0; // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23

      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      return react.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Collection', className),
        id: id,
        onScroll: this._onScroll,
        role: "grid",
        style: CollectionView_objectSpread({}, collectionStyle, {}, style),
        tabIndex: 0
      }, cellCount > 0 && react.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;

        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;

      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          totalHeight = _ref.totalHeight,
          totalWidth = _ref.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
              scrollTop = _ref2.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: CollectionView_SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(react.PureComponent);

defineProperty_defineProperty(CollectionView, "defaultProps", {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});

CollectionView.propTypes =  false ? 0 : {};
polyfill(CollectionView);
/* harmony default export */ var Collection_CollectionView = (CollectionView);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/types.js
var bpfrpt_proptype_Index =  true ? null : 0;
var bpfrpt_proptype_PositionInfo =  true ? null : 0;
var bpfrpt_proptype_ScrollPosition =  true ? null : 0;
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : 0;
var bpfrpt_proptype_SizeInfo =  true ? null : 0;






;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/Section.js



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section =
/*#__PURE__*/
function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    classCallCheck_classCallCheck(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }
  /** Add a cell to this section. */


  createClass_createClass(Section, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;

        this._indices.push(index);
      }
    }
    /** Get all cell indices that have been added to this section. */

  }, {
    key: "getCellIndices",
    value: function getCellIndices() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);

  return Section;
}();




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/SectionManager.js



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */

var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager =
/*#__PURE__*/
function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    classCallCheck_classCallCheck(this, SectionManager);

    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }
  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  createClass_createClass(SectionManager, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;
      var indices = {};
      this.getSections({
        height: height,
        width: width,
        x: x,
        y: y
      }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      }); // Object keys are strings; this function returns numbers

      return Object.keys(indices).map(function (index) {
        return indices[index];
      });
    }
    /** Get size and position information for the cell specified. */

  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;
      return this._cellMetadata[index];
    }
    /** Get all Sections overlapping the specified region. */

  }, {
    key: "getSections",
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);

          if (!this._sections[key]) {
            this._sections[key] = new Section({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }
    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      return Object.keys(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: "registerCell",
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;
      this._cellMetadata[index] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({
          index: index
        });
      });
    }
  }]);

  return SectionManager;
}();




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/utils/calculateSizeAndPositionData.js

function calculateSizeAndPositionData_calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new SectionManager(sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index
    });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/utils/getUpdatedOffsetForIndex.js
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;

    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/Collection.js














/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection_Collection =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Collection, _React$PureComponent);

  function Collection(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, Collection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collection).call(this, props, context));
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = []; // Cell cache during scroll (for performance)

    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(_assertThisInitialized(_this));
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(Collection, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }
    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];

      this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */

  }, {
    key: "render",
    value: function render() {
      var props = _extends({}, this.props);

      return react.createElement(Collection_CollectionView, _extends({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }
    /** CellLayoutManager interface */

  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData() {
      var _this$props = this.props,
          cellCount = _this$props.cellCount,
          cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter,
          sectionSize = _this$props.sectionSize;

      var data = calculateSizeAndPositionData_calculateSizeAndPositionData({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;

      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });
        scrollTop = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _this$props2 = this.props,
          cellGroupRenderer = _this$props2.cellGroupRenderer,
          cellRenderer = _this$props2.cellRenderer; // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(react.PureComponent);

defineProperty_defineProperty(Collection_Collection, "defaultProps", {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
});


Collection_Collection.propTypes =  false ? 0 : {};

function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;
  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index
    });
    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    }; // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.

    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Collection/index.js

/* harmony default export */ var es_Collection = ((/* unused pure expression or super */ null && (Collection)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ColumnSizer/ColumnSizer.js








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer_ColumnSizer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, ColumnSizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnSizer).call(this, props, context));
    _this._registerChild = _this._registerChild.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(ColumnSizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          columnMaxWidth = _this$props.columnMaxWidth,
          columnMinWidth = _this$props.columnMinWidth,
          columnCount = _this$props.columnCount,
          width = _this$props.width;

      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          columnMaxWidth = _this$props2.columnMaxWidth,
          columnMinWidth = _this$props2.columnMinWidth,
          columnCount = _this$props2.columnCount,
          width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(react.PureComponent);


ColumnSizer_ColumnSizer.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ColumnSizer/index.js

/* harmony default export */ var es_ColumnSizer = ((/* unused pure expression or super */ null && (ColumnSizer)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function arrayWithoutHoles_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function iterableToArray_iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function nonIterableSpread_nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function toConsumableArray_toConsumableArray(arr) {
  return arrayWithoutHoles_arrayWithoutHoles(arr) || iterableToArray_iterableToArray(arr) || _unsupportedIterableToArray(arr) || nonIterableSpread_nonIterableSpread();
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/InfiniteLoader/InfiniteLoader.js











/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader_InfiniteLoader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, InfiniteLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InfiniteLoader).call(this, props, context));
    _this._loadMoreRowsMemoizer = createCallbackMemoizer();
    _this._onRowsRendered = _this._onRowsRendered.bind(_assertThisInitialized(_this));
    _this._registerChild = _this._registerChild.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(InfiniteLoader, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = createCallbackMemoizer();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);

        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _this$props = this.props,
          isRowLoaded = _this$props.isRowLoaded,
          minimumBatchSize = _this$props.minimumBatchSize,
          rowCount = _this$props.rowCount,
          threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      }); // For memoize comparison

      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, toConsumableArray_toConsumableArray(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges: squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(react.PureComponent);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


defineProperty_defineProperty(InfiniteLoader_InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});


InfiniteLoader_InfiniteLoader.propTypes =  false ? 0 : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */

function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({
      index: index
    });

    if (!loaded) {
      rangeStopIndex = index;

      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  } // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.


  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  } // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.


  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}
/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */

function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/InfiniteLoader/index.js

/* harmony default export */ var es_InfiniteLoader = ((/* unused pure expression or super */ null && (InfiniteLoader)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/types.js

var bpfrpt_proptype_RowRendererParams =  true ? null : 0;
var bpfrpt_proptype_RowRenderer =  true ? null : 0;
var bpfrpt_proptype_RenderedRows =  true ? null : 0;
var types_bpfrpt_proptype_Scroll =  true ? null : 0;





;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/List.js









var List_class, List_temp;




/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = (List_temp = List_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_defineProperty(_assertThisInitialized(_this), "Grid", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });

    return _this;
  }

  createClass_createClass(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = clsx_m('ReactVirtualized__List', className);
      return react.createElement(Grid_Grid, _extends({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(react.PureComponent), defineProperty_defineProperty(List_class, "propTypes",  true ? null : 0), List_temp);

defineProperty_defineProperty(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});














;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/List/index.js




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/binarySearchBounds.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/
function _GEA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GEP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GTP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LTP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LEP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function _EQP(a, l, h, y, c) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);

    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ var binarySearchBounds = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/vendor/intervalTree.js
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);

  if (idx < 0) {
    return NOT_FOUND;
  }

  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);

  if (this.left) {
    this.left.intervals(result);
  }

  if (this.right) {
    this.right.intervals(result);
  }

  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;

  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin);
    var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;

  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }

    var rw = this.right ? this.right.count : 0;

    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.left.remove(interval);

    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }

    var lw = this.left ? this.left.count : 0;

    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.right.remove(interval);

    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }

    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;

        while (n.right) {
          p = n;
          n = n.right;
        }

        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }

        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }

      return SUCCESS;
    }

    for (var l = binarySearchBounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }

      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);

        for (var r = binarySearchBounds.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }

    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];

  if (d) {
    return d;
  }

  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];

  if (d) {
    return d;
  }

  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }

  var pts = [];

  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }

  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];

  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];

    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  } //Split center intervals


  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
} //User friendly wrapper that makes it possible to support empty trees


function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);

    if (r === EMPTY) {
      this.root = null;
    }

    return r !== NOT_FOUND;
  }

  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }

    return 0;
  }
});
Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }

    return [];
  }
});
function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }

  return new IntervalTree(createIntervalTree(intervals));
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/PositionCache.js






// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache =
/*#__PURE__*/
function () {
  function PositionCache() {
    classCallCheck_classCallCheck(this, PositionCache);

    defineProperty_defineProperty(this, "_columnSizeMap", {});

    defineProperty_defineProperty(this, "_intervalTree", createWrapper());

    defineProperty_defineProperty(this, "_leftMap", {});
  }

  createClass_createClass(PositionCache, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    } // Render all cells visible within the viewport range defined.

  }, {
    key: "range",
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);

      this._leftMap[index] = left;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];

      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: "tallestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/Masonry.js








var Masonry_class, Masonry_temp;

function Masonry_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Masonry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Masonry_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Masonry_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var emptyObject = {};
/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry_Masonry = (Masonry_temp = Masonry_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Masonry, _React$PureComponent);

  function Masonry() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, Masonry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Masonry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_defineProperty(_assertThisInitialized(_this), "state", {
      isScrolling: false,
      scrollTop: 0
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_debounceResetIsScrollingId", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_invalidateOnUpdateStartIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_invalidateOnUpdateStopIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_positionCache", new PositionCache());

    defineProperty_defineProperty(_assertThisInitialized(_this), "_startIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_startIndexMemoized", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_stopIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_stopIndexMemoized", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_debounceResetIsScrollingCallback", function () {
      _this.setState({
        isScrolling: false
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScroll", function (event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop); // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.

      if (eventScrollTop !== scrollTop) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._debounceResetIsScrolling(); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.


      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    });

    return _this;
  }

  createClass_createClass(Masonry, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new PositionCache();
      this.forceUpdate();
    } // HACK This method signature was intended for Grid

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new PositionCache();

      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          cellCount = _this$props.cellCount,
          cellMeasurerCache = _this$props.cellMeasurerCache,
          cellRenderer = _this$props.cellRenderer,
          className = _this$props.className,
          height = _this$props.height,
          id = _this$props.id,
          keyMapper = _this$props.keyMapper,
          overscanByPixels = _this$props.overscanByPixels,
          role = _this$props.role,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          width = _this$props.width,
          rowDirection = _this$props.rowDirection;
      var _this$state = this.state,
          isScrolling = _this$state.isScrolling,
          scrollTop = _this$state.scrollTop;
      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, defineProperty_defineProperty(_style, rowDirection === 'ltr' ? 'left' : 'right', left), defineProperty_defineProperty(_style, "position", 'absolute'), defineProperty_defineProperty(_style, "top", top), defineProperty_defineProperty(_style, "width", cellMeasurerCache.getWidth(index)), _style)
        }));
      }); // We need to measure additional cells for this layout


      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return react.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx_m('ReactVirtualized__Masonry', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: Masonry_objectSpread({
          boxSizing: 'border-box',
          direction: 'ltr',
          height: autoHeight ? 'auto' : height,
          overflowX: 'hidden',
          overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
          position: 'relative',
          width: width,
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform'
        }, style),
        tabIndex: tabIndex
      }, react.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: '100%',
          height: estimateTotalHeight,
          maxWidth: '100%',
          maxHeight: estimateTotalHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }
      }, children));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null; // Query external layout logic for position of newly-measured cells

        this._populatePositionCache(startIndex, stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = requestAnimationTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props,
          cellCount = _this$props2.cellCount,
          cellMeasurerCache = _this$props2.cellMeasurerCache,
          width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props,
          height = _this$props3.height,
          onScroll = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;

      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _this$props4 = this.props,
          cellMeasurerCache = _this$props4.cellMeasurerCache,
          cellPositioner = _this$props4.cellPositioner;

      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            left = _cellPositioner.left,
            top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(react.PureComponent), defineProperty_defineProperty(Masonry_class, "propTypes",  true ? null : 0), Masonry_temp);

defineProperty_defineProperty(Masonry_Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: Masonry_DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
});

function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : 0;
polyfill(Masonry_Masonry);
/* harmony default export */ var es_Masonry_Masonry = ((/* unused pure expression or super */ null && (Masonry_Masonry)));
var bpfrpt_proptype_Positioner =  true ? null : 0;




;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/createCellPositioner.js
function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
  var columnHeights;
  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;

    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;
    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];

    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;
    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;
  return cellPositioner;
}


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Masonry/index.js


/* harmony default export */ var es_Masonry = ((/* unused pure expression or super */ null && (Masonry)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/CellMeasurerCacheDecorator.js





/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator =
/*#__PURE__*/
function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck_classCallCheck(this, CellMeasurerCacheDecorator);

    defineProperty_defineProperty(this, "_cellMeasurerCache", void 0);

    defineProperty_defineProperty(this, "_columnIndexOffset", void 0);

    defineProperty_defineProperty(this, "_rowIndexOffset", void 0);

    defineProperty_defineProperty(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    });

    defineProperty_defineProperty(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    });

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  createClass_createClass(CellMeasurerCacheDecorator, [{
    key: "clear",
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/MultiGrid.js










function MultiGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MultiGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MultiGrid_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MultiGrid_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid_MultiGrid =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, MultiGrid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiGrid).call(this, props, context));

    defineProperty_defineProperty(_assertThisInitialized(_this), "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_deferredInvalidateColumnIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_deferredInvalidateRowIndex", null);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_bottomLeftGridRef", function (ref) {
      _this._bottomLeftGrid = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_bottomRightGridRef", function (ref) {
      _this._bottomRightGrid = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_cellRendererBottomLeftGrid", function (_ref) {
      var rowIndex = _ref.rowIndex,
          rest = _objectWithoutProperties(_ref, ["rowIndex"]);

      var _this$props = _this.props,
          cellRenderer = _this$props.cellRenderer,
          fixedRowCount = _this$props.fixedRowCount,
          rowCount = _this$props.rowCount;

      if (rowIndex === rowCount - fixedRowCount) {
        return react.createElement("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          parent: _assertThisInitialized(_this),
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_cellRendererBottomRightGrid", function (_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex,
          rest = _objectWithoutProperties(_ref2, ["columnIndex", "rowIndex"]);

      var _this$props2 = _this.props,
          cellRenderer = _this$props2.cellRenderer,
          fixedColumnCount = _this$props2.fixedColumnCount,
          fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(MultiGrid_objectSpread({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _assertThisInitialized(_this),
        rowIndex: rowIndex + fixedRowCount
      }));
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_cellRendererTopRightGrid", function (_ref3) {
      var columnIndex = _ref3.columnIndex,
          rest = _objectWithoutProperties(_ref3, ["columnIndex"]);

      var _this$props3 = _this.props,
          cellRenderer = _this$props3.cellRenderer,
          columnCount = _this$props3.columnCount,
          fixedColumnCount = _this$props3.fixedColumnCount;

      if (columnIndex === columnCount - fixedColumnCount) {
        return react.createElement("div", {
          key: rest.key,
          style: MultiGrid_objectSpread({}, rest.style, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(MultiGrid_objectSpread({}, rest, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: _assertThisInitialized(_this)
        }));
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_columnWidthRightGrid", function (_ref4) {
      var index = _ref4.index;
      var _this$props4 = _this.props,
          columnCount = _this$props4.columnCount,
          fixedColumnCount = _this$props4.fixedColumnCount,
          columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state,
          scrollbarSize = _this$state.scrollbarSize,
          showHorizontalScrollbar = _this$state.showHorizontalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }

      return typeof columnWidth === 'function' ? columnWidth({
        index: index + fixedColumnCount
      }) : columnWidth;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScroll", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
          scrollTop = scrollInfo.scrollTop;

      _this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      var onScroll = _this.props.onScroll;

      if (onScroll) {
        onScroll(scrollInfo);
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScrollbarPresenceChange", function (_ref5) {
      var horizontal = _ref5.horizontal,
          size = _ref5.size,
          vertical = _ref5.vertical;
      var _this$state2 = _this.state,
          showHorizontalScrollbar = _this$state2.showHorizontalScrollbar,
          showVerticalScrollbar = _this$state2.showVerticalScrollbar;

      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });

        var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;

        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScrollLeft", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;

      _this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onScrollTop", function (scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;

      _this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_rowHeightBottomGrid", function (_ref6) {
      var index = _ref6.index;
      var _this$props5 = _this.props,
          fixedRowCount = _this$props5.fixedRowCount,
          rowCount = _this$props5.rowCount,
          rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state,
          scrollbarSize = _this$state3.scrollbarSize,
          showVerticalScrollbar = _this$state3.showVerticalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }

      return typeof rowHeight === 'function' ? rowHeight({
        index: index + fixedRowCount
      }) : rowHeight;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_topLeftGridRef", function (ref) {
      _this._topLeftGrid = ref;
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_topRightGridRef", function (ref) {
      _this._topRightGrid = ref;
    });

    var deferredMeasurementCache = props.deferredMeasurementCache,
        _fixedColumnCount = props.fixedColumnCount,
        _fixedRowCount = props.fixedRowCount;

    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }

    return _this;
  }

  createClass_createClass(MultiGrid, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$columnIndex = _ref8.columnIndex,
          columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex,
          _ref8$rowIndex = _ref8.rowIndex,
          rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;

      var _this$props6 = this.props,
          fixedColumnCount = _this$props6.fixedColumnCount,
          fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;

      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          scrollLeft = _this$props7.scrollLeft,
          scrollTop = _this$props7.scrollTop;

      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          onScroll = _this$props8.onScroll,
          onSectionRendered = _this$props8.onSectionRendered,
          onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange,
          scrollLeftProp = _this$props8.scrollLeft,
          scrollToColumn = _this$props8.scrollToColumn,
          scrollTopProp = _this$props8.scrollTop,
          scrollToRow = _this$props8.scrollToRow,
          rest = _objectWithoutProperties(_this$props8, ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"]);

      this._prepareForRender(); // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.


      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      } // scrollTop and scrollLeft props are explicitly filtered out and ignored


      var _this$state4 = this.state,
          scrollLeft = _this$state4.scrollLeft,
          scrollTop = _this$state4.scrollTop;
      return react.createElement("div", {
        style: this._containerOuterStyle
      }, react.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollLeft: scrollLeft
      }))), react.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollTop: scrollTop
      })), this._renderBottomRightGrid(MultiGrid_objectSpread({}, rest, {
        onScroll: onScroll,
        onSectionRendered: onSectionRendered,
        scrollLeft: scrollLeft,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        scrollTop: scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;

      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;

      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({
              index: index
            });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;

      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;

      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({
              index: index
            });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props,
          columnWidth = _this$props9.columnWidth,
          enableFixedColumnScroll = _this$props9.enableFixedColumnScroll,
          enableFixedRowScroll = _this$props9.enableFixedRowScroll,
          height = _this$props9.height,
          fixedColumnCount = _this$props9.fixedColumnCount,
          fixedRowCount = _this$props9.fixedRowCount,
          rowHeight = _this$props9.rowHeight,
          style = _this$props9.style,
          styleBottomLeftGrid = _this$props9.styleBottomLeftGrid,
          styleBottomRightGrid = _this$props9.styleBottomRightGrid,
          styleTopLeftGrid = _this$props9.styleTopLeftGrid,
          styleTopRightGrid = _this$props9.styleTopRightGrid,
          width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = MultiGrid_objectSpread({
          height: height,
          overflow: 'visible',
          // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible',
          // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = MultiGrid_objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = MultiGrid_objectSpread({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;

      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = react.createElement(Grid_Grid, _extends({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return react.createElement("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._bottomLeftGridStyle, {
            height: height,
            width: width,
            overflowY: 'hidden'
          })
        }, bottomLeftGrid);
      }

      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;
      return react.createElement(Grid_Grid, _extends({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;

      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return react.createElement(Grid_Grid, _extends({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state,
          showHorizontalScrollbar = _this$state5.showHorizontalScrollbar,
          scrollbarSize = _this$state5.scrollbarSize;

      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = MultiGrid_objectSpread({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = react.createElement(Grid_Grid, _extends({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return react.createElement("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: MultiGrid_objectSpread({}, this._topRightGridStyle, {
            height: height,
            width: width,
            overflowX: 'hidden'
          })
        }, topRightGrid);
      }

      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(react.PureComponent);

defineProperty_defineProperty(MultiGrid_MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});

MultiGrid_MultiGrid.propTypes =  false ? 0 : {};
polyfill(MultiGrid_MultiGrid);
/* harmony default export */ var es_MultiGrid_MultiGrid = ((/* unused pure expression or super */ null && (MultiGrid_MultiGrid)));
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/MultiGrid/index.js

/* harmony default export */ var es_MultiGrid = ((/* unused pure expression or super */ null && (MultiGrid)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ScrollSync/ScrollSync.js








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync_ScrollSync =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    var _this;

    classCallCheck_classCallCheck(this, ScrollSync);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollSync).call(this, props, context));
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(ScrollSync, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          clientHeight = _this$state.clientHeight,
          clientWidth = _this$state.clientWidth,
          scrollHeight = _this$state.scrollHeight,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop,
          scrollWidth = _this$state.scrollWidth;
      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(react.PureComponent);


ScrollSync_ScrollSync.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/ScrollSync/index.js

/* harmony default export */ var es_ScrollSync = ((/* unused pure expression or super */ null && (ScrollSync)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/types.js
var bpfrpt_proptype_CellDataGetterParams =  true ? null : 0;
var types_bpfrpt_proptype_CellRendererParams =  true ? null : 0;
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : 0;
var bpfrpt_proptype_HeaderRendererParams =  true ? null : 0;
var types_bpfrpt_proptype_RowRendererParams =  true ? null : 0;






;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultCellDataGetter.js
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultCellRenderer.js
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultHeaderRowRenderer.js

function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;
  return react.createElement("div", {
    className: className,
    role: "row",
    style: style
  }, columns);
}
defaultHeaderRowRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/SortDirection.js
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};
/* harmony default export */ var Table_SortDirection = (SortDirection);
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/SortIndicator.js




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */

function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames = clsx_m('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === Table_SortDirection.ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === Table_SortDirection.DESC
  });
  return react.createElement("svg", {
    className: classNames,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === Table_SortDirection.ASC ? react.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : react.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), react.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultHeaderRenderer.js



/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children = [react.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === 'string' ? label : null
  }, label)];

  if (showSortIndicator) {
    children.push(react.createElement(SortIndicator, {
      key: "SortIndicator",
      sortDirection: sortDirection
    }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/defaultRowRenderer.js



/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;
  var a11yProps = {
    'aria-rowindex': index + 1
  };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
  }

  return react.createElement("div", _extends({}, a11yProps, {
    className: className,
    key: key,
    role: "row",
    style: style
  }), columns);
}
defaultRowRenderer.propTypes =  true ? null : 0;


;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/Column.js











/**
 * Describes the header and cell contents of a table column.
 */

var Column =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Column, _React$Component);

  function Column() {
    classCallCheck_classCallCheck(this, Column);

    return _possibleConstructorReturn(this, _getPrototypeOf(Column).apply(this, arguments));
  }

  return Column;
}(react.Component);

defineProperty_defineProperty(Column, "defaultProps", {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  defaultSortDirection: Table_SortDirection.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: defaultHeaderRenderer,
  style: {}
});


Column.propTypes =  false ? 0 : {};
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/Table.js









function Table_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Table_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Table_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Table_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table_Table =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Table, _React$PureComponent);

  function Table(props) {
    var _this;

    classCallCheck_classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(_assertThisInitialized(_this));
    _this._createRow = _this._createRow.bind(_assertThisInitialized(_this));
    _this._onScroll = _this._onScroll.bind(_assertThisInitialized(_this));
    _this._onSectionRendered = _this._onSectionRendered.bind(_assertThisInitialized(_this));
    _this._setRef = _this._setRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  createClass_createClass(Table, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = (0,react_dom.findDOMNode)(this.Grid);

        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disableHeader = _this$props.disableHeader,
          gridClassName = _this$props.gridClassName,
          gridStyle = _this$props.gridStyle,
          headerHeight = _this$props.headerHeight,
          headerRowRenderer = _this$props.headerRowRenderer,
          height = _this$props.height,
          id = _this$props.id,
          noRowsRenderer = _this$props.noRowsRenderer,
          rowClassName = _this$props.rowClassName,
          rowStyle = _this$props.rowStyle,
          scrollToIndex = _this$props.scrollToIndex,
          style = _this$props.style,
          width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: -1
      }) : rowStyle; // Precompute and cache column styles before rendering rows and columns to speed things up

      this._cachedColumnStyles = [];
      react.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = Table_objectSpread({
          overflow: 'hidden'
        }, flexStyles);
      }); // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.

      return react.createElement("div", {
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-colcount": react.Children.toArray(children).length,
        "aria-rowcount": this.props.rowCount,
        className: clsx_m('ReactVirtualized__Table', className),
        id: id,
        role: "grid",
        style: style
      }, !disableHeader && headerRowRenderer({
        className: clsx_m('ReactVirtualized__Table__headerRow', rowClass),
        columns: this._getHeaderColumns(),
        style: Table_objectSpread({
          height: headerHeight,
          overflow: 'hidden',
          paddingRight: scrollbarWidth,
          width: width
        }, rowStyleObject)
      }), react.createElement(Grid_Grid, _extends({}, this.props, {
        "aria-readonly": null,
        autoContainerWidth: true,
        className: clsx_m('ReactVirtualized__Table__Grid', gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: undefined,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: Table_objectSpread({}, gridStyle, {
          overflowX: 'hidden'
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({
          columnData: columnData,
          dataKey: dataKey,
          event: event
        });
      };

      var style = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === 'string' ? renderedCell : null; // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942

      return react.createElement("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id,
        className: clsx_m('ReactVirtualized__Table__rowColumn', className),
        key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
        onClick: onClick,
        role: "gridcell",
        style: style,
        title: title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _this$props2 = this.props,
          headerClassName = _this$props2.headerClassName,
          headerStyle = _this$props2.headerStyle,
          onHeaderClick = _this$props2.onHeaderClick,
          sort = _this$props2.sort,
          sortBy = _this$props2.sortBy,
          sortDirection = _this$props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames = clsx_m('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });

      var style = this._getFlexStyleForColumn(column, Table_objectSpread({}, headerStyle, {}, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey; // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.

        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === Table_SortDirection.DESC ? Table_SortDirection.ASC : Table_SortDirection.DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData: columnData,
            dataKey: dataKey,
            event: event
          });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === Table_SortDirection.ASC ? 'ascending' : 'descending';
      } // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942


      return react.createElement("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames,
        id: id,
        key: 'Header-Col' + index,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _this$props3 = this.props,
          children = _this$props3.children,
          onRowClick = _this$props3.onRowClick,
          onRowDoubleClick = _this$props3.onRowDoubleClick,
          onRowRightClick = _this$props3.onRowRightClick,
          onRowMouseOver = _this$props3.onRowMouseOver,
          onRowMouseOut = _this$props3.onRowMouseOut,
          rowClassName = _this$props3.rowClassName,
          rowGetter = _this$props3.rowGetter,
          rowRenderer = _this$props3.rowRenderer,
          rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: index
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: index
      }) : rowStyle;
      var rowData = rowGetter({
        index: index
      });
      var columns = react.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });
      var className = clsx_m('ReactVirtualized__Table__row', rowClass);

      var flattenedStyle = Table_objectSpread({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");

      var style = Table_objectSpread({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : react.Children.toArray(children);
      return items.map(function (column, index) {
        return _this4._createHeader({
          column: column,
          index: index
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === 'function' ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }]);

  return Table;
}(react.PureComponent);

defineProperty_defineProperty(Table_Table, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  rowRenderer: defaultRowRenderer,
  headerRowRenderer: defaultHeaderRowRenderer,
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});


Table_Table.propTypes =  false ? 0 : {};

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/Table/index.js










/* harmony default export */ var es_Table = ((/* unused pure expression or super */ null && (Table)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/utils/onScroll.js

var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    cancelAnimationTimeout(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = requestAnimationTimeout(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
  }

  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }

  mountedInstances.push(component);
}
function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });

  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);

    if (disablePointerEventsTimeoutId) {
      cancelAnimationTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/utils/dimensions.js
/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
// TODO Move this into WindowScroller and import from there
var isWindow = function isWindow(element) {
  return element === window;
};

var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}
/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */

function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);

    var _elementRect = getBoundingBox(element);

    var _containerRect = getBoundingBox(container);

    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}
/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */

function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}
;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/WindowScroller.js








var WindowScroller_class, WindowScroller_temp;

function WindowScroller_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WindowScroller_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WindowScroller_ownKeys(source, true).forEach(function (key) { defineProperty_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WindowScroller_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var WindowScroller_IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller_WindowScroller = (WindowScroller_temp = WindowScroller_class =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck_classCallCheck(this, WindowScroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WindowScroller)).call.apply(_getPrototypeOf2, [this].concat(args)));

    defineProperty_defineProperty(_assertThisInitialized(_this), "_window", getWindow());

    defineProperty_defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_positionFromTop", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_positionFromLeft", 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_detectElementResize", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "_child", void 0);

    defineProperty_defineProperty(_assertThisInitialized(_this), "state", WindowScroller_objectSpread({}, getDimensions(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));

    defineProperty_defineProperty(_assertThisInitialized(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }

      _this._child = element;

      _this.updatePosition();
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onChildScroll", function (_ref) {
      var scrollTop = _ref.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_registerResizeListener", function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_unregisterResizeListener", function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "_onResize", function () {
      _this.updatePosition();
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "__handleWindowScrollEvent", function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;
      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        var scrollOffset = getScrollOffset(scrollElement);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        onScroll({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }
    });

    defineProperty_defineProperty(_assertThisInitialized(_this), "__resetIsScrolling", function () {
      _this.setState({
        isScrolling: false
      });
    });

    return _this;
  }

  createClass_createClass(WindowScroller, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width;
      var thisNode = this._child || react_dom.findDOMNode(this);

      if (thisNode instanceof Element && scrollElement) {
        var offset = getPositionOffset(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = getDimensions(scrollElement, this.props);

      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;
      this._detectElementResize = createDetectElementResize();
      this.updatePosition(scrollElement);

      if (scrollElement) {
        registerScrollListener(this, scrollElement);

        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;

      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);
        unregisterScrollListener(this, prevScrollElement);
        registerScrollListener(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);

        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;

      if (scrollElement) {
        unregisterScrollListener(this, scrollElement);

        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
          isScrolling = _this$state2.isScrolling,
          scrollTop = _this$state2.scrollTop,
          scrollLeft = _this$state2.scrollLeft,
          height = _this$state2.height,
          width = _this$state2.width;
      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }
  }]);

  return WindowScroller;
}(react.PureComponent), defineProperty_defineProperty(WindowScroller_class, "propTypes",  true ? null : 0), WindowScroller_temp);

defineProperty_defineProperty(WindowScroller_WindowScroller, "defaultProps", {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: WindowScroller_IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});



;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/WindowScroller/index.js

/* harmony default export */ var es_WindowScroller = ((/* unused pure expression or super */ null && (WindowScroller)));

;// CONCATENATED MODULE: ../../node_modules/react-virtualized/dist/es/index.js













;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryCodeModal.tsx









var SelectCountryCodeModal = function SelectCountryCodeModal(_ref) {
  var countryData = _ref.countryData,
      handleSelectCountry = _ref.handleSelectCountry,
      handleClose = _ref.handleClose;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var windowWidth = window.innerWidth - 60;

  var _useState = (0,react.useState)(countryData),
      countriesData = _useState[0],
      setCountriesData = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchTxt = _useState2[0],
      setInputValue = _useState2[1];

  var rowHeight = 60;

  var calculateListHeight = function calculateListHeight() {
    var _countriesData$length;

    var rowCount = (_countriesData$length = countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) !== null && _countriesData$length !== void 0 ? _countriesData$length : 0; // Replace with your actual data length

    var height = rowCount * rowHeight;
    return height;
  };

  var countryHandler = function countryHandler(id) {
    if (id) {
      setCountriesData(countryData === null || countryData === void 0 ? void 0 : countryData.map(function (item) {
        if (id === item.id) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      }));
    }
  };

  (0,react.useEffect)(function () {
    if (searchTxt !== null && searchTxt !== void 0 && searchTxt.length) {
      var filteredDataList = searchTxt ? countryData === null || countryData === void 0 ? void 0 : countryData.filter(function (items) {
        var _items$countryName;

        return (_items$countryName = items.countryName) === null || _items$countryName === void 0 ? void 0 : _items$countryName.toLowerCase().includes(searchTxt.toLowerCase());
      }) : countryData;
      setCountriesData(filteredDataList);
    }
  }, [searchTxt]);

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-test-id": `SelectCountryCodeModal-rowRenderer-${key}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CountryItem, {
        onClick: function onClick() {
          return countryHandler(item.id);
        },
        "data-test-id": "SelectCountryCodeModal-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButton_RadioButton, {
          handleChange: function handleChange() {
            return countryHandler(item.id);
          },
          activeBtn: item.isSelected,
          "data-test-id": "SelectCountryCodeModal-rowRenderer-RadioButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              alignItems: "center",
              gap: "8px",
              "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
              children: [item.countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                src: item.countryFlag,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "sm",
                color: Global/* theme.blackText */.rS.blackText,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
                children: item.countryName
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontWeight: "bold",
              fontSize: "xs",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
              children: item.countryCode
            })]
          })
        })
      })
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
    handleClick: handleClose,
    customTitle: "Select Country",
    "data-test-id": "SelectCountryCodeModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_TMFloatingInput, {
      handleChange: function handleChange(e) {
        return setInputValue(e.target.value);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country Name",
      "data-test-id": "SelectCountryCodeModal-TMFloatingInput"
    }), (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(CountrySection, {
      "data-test-id": "SelectCountryCodeModal-CountrySection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Country Name"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Code"
      })]
    }), countriesData && (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      width: device === "lg" ? 360 : windowWidth,
      height: calculateListHeight(),
      style: {
        minHeight: calculateListHeight()
      },
      autoHeight: true,
      rowHeight: rowHeight,
      rowCount: countriesData.length,
      rowRenderer: rowRenderer,
      "data-test-id": "SelectCountryCodeModal-List"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      fontSize: "sm",
      color: Global/* theme.greyText */.rS.greyText,
      margin: "16px 0 16px",
      "data-test-id": "SelectCountryCodeModal-ParaTag",
      children: "No Country Found! Please enter correct name"
    }), (countriesData === null || countriesData === void 0 ? void 0 : countriesData.length) != 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_style_BtnWrap, {
      "data-test-id": "SelectCountryCodeModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        customWidth: "100%",
        customTitle: "Select",
        onClick: function onClick() {
          return handleSelectCountry(countriesData);
        },
        "data-test-id": "SelectCountryCodeModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryCodeModal = (SelectCountryCodeModal);
;// CONCATENATED MODULE: ../../node_modules/fuse.js/dist/fuse.mjs
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray(value) {
  return !Array.isArray
    ? getTag(value) === '[object Array]'
    : Array.isArray(value)
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result
}

function fuse_toString(value) {
  return value == null ? '' : baseToString(value)
}

function fuse_isString(value) {
  return typeof value === 'string'
}

function isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function fuse_isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) == '[object Boolean]')
  )
}

function fuse_isObject(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return fuse_isObject(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = createKey(key);

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;

  if (fuse_isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return { path, id, weight, src, getFn }
}

function createKeyPath(key) {
  return isArray(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray(key) ? key.join('.') : key
}

function fuse_get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (fuse_isString(value) || isNumber(value) || fuse_isBoolean(value))
      ) {
        list.push(fuse_toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, fuse_isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: fuse_get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (fuse_isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (fuse_isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (fuse_isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (fuse_isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;

    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray(query) && fuse_isObject(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function fuse_parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!fuse_isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function fuse_format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    if (
      this.options.useExtendedSearch &&
      !true
    ) {}

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = fuse_isString(query)
      ? fuse_isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return fuse_format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = fuse_parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '7.0.0';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = fuse_parse;
}

{
  register(ExtendedSearch);
}



;// CONCATENATED MODULE: ../../node_modules/react-window/node_modules/@babel/runtime/helpers/esm/extends.js
function extends_extends() {
  extends_extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return extends_extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ../../node_modules/react-window/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function assertThisInitialized_assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ../../node_modules/react-window/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function setPrototypeOf_setPrototypeOf(o, p) {
  setPrototypeOf_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return setPrototypeOf_setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../node_modules/react-window/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf_setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ../../node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);

;// CONCATENATED MODULE: ../../node_modules/react-window/dist/index.esm.js







// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var index_esm_size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (index_esm_size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    index_esm_size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return index_esm_size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;

var defaultItemKey = function defaultItemKey(_ref) {
  var columnIndex = _ref.columnIndex,
      data = _ref.data,
      rowIndex = _ref.rowIndex;
  return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsOverscanCount = null;
var devWarningsOverscanRowsColumnsCount = null;
var devWarningsTagName = null;

if (false) {}

function createGridComponent(_ref2) {
  var _class;

  var getColumnOffset = _ref2.getColumnOffset,
      getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset,
      getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex,
      getColumnWidth = _ref2.getColumnWidth,
      getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight,
      getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth,
      getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment,
      getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment,
      getRowHeight = _ref2.getRowHeight,
      getRowOffset = _ref2.getRowOffset,
      getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset,
      getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex,
      initInstanceProps = _ref2.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref2.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(Grid, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function Grid(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, assertThisInitialized_assertThisInitialized(_this));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: assertThisInitialized_assertThisInitialized(_this),
        isScrolling: false,
        horizontalScrollDirection: 'forward',
        scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: 'forward'
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoize_one_esm(function (overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex: overscanColumnStartIndex,
          overscanColumnStopIndex: overscanColumnStopIndex,
          overscanRowStartIndex: overscanRowStartIndex,
          overscanRowStopIndex: overscanRowStopIndex,
          visibleColumnStartIndex: visibleColumnStartIndex,
          visibleColumnStopIndex: visibleColumnStopIndex,
          visibleRowStartIndex: visibleRowStartIndex,
          visibleRowStopIndex: visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoize_one_esm(function (scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection: horizontalScrollDirection,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          verticalScrollDirection: verticalScrollDirection,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (rowIndex, columnIndex) {
        var _this$props = _this.props,
            columnWidth = _this$props.columnWidth,
            direction = _this$props.direction,
            rowHeight = _this$props.rowHeight;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);

        var key = rowIndex + ":" + columnIndex;
        var style;

        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);

          var isRtl = direction === 'rtl';
          itemStyleCache[key] = style = {
            position: 'absolute',
            left: isRtl ? undefined : _offset,
            right: isRtl ? _offset : undefined,
            top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
            height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
            width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoize_one_esm(function (_, __, ___) {
        return {};
      });

      _this._onScroll = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientHeight = _event$currentTarget.clientHeight,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollTop = _event$currentTarget.scrollTop,
            scrollHeight = _event$currentTarget.scrollHeight,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
          // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
          // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
          // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.

          var calculatedScrollLeft = scrollLeft;

          if (direction === 'rtl') {
            switch (getRTLOffsetType()) {
              case 'negative':
                calculatedScrollLeft = -scrollLeft;
                break;

              case 'positive-descending':
                calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1);
        });
      };

      return _this;
    }

    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = Grid.prototype;

    _proto.scrollTo = function scrollTo(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;

      if (scrollLeft !== undefined) {
        scrollLeft = Math.max(0, scrollLeft);
      }

      if (scrollTop !== undefined) {
        scrollTop = Math.max(0, scrollTop);
      }

      this.setState(function (prevState) {
        if (scrollLeft === undefined) {
          scrollLeft = prevState.scrollLeft;
        }

        if (scrollTop === undefined) {
          scrollTop = prevState.scrollTop;
        }

        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }

        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === void 0 ? 'auto' : _ref4$align,
          columnIndex = _ref4.columnIndex,
          rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          height = _this$props2.height,
          rowCount = _this$props2.rowCount,
          width = _this$props2.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize();

      if (columnIndex !== undefined) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }

      if (rowIndex !== undefined) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }

      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
      // to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.

      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          initialScrollLeft = _this$props3.initialScrollLeft,
          initialScrollTop = _this$props3.initialScrollTop;

      if (this._outerRef != null) {
        var outerRef = this._outerRef;

        if (typeof initialScrollLeft === 'number') {
          outerRef.scrollLeft = initialScrollLeft;
        }

        if (typeof initialScrollTop === 'number') {
          outerRef.scrollTop = initialScrollTop;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollTop = _this$state2.scrollTop,
          scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
        // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
        // So we need to determine which browser behavior we're dealing with, and mimic it.
        var outerRef = this._outerRef;

        if (direction === 'rtl') {
          switch (getRTLOffsetType()) {
            case 'negative':
              outerRef.scrollLeft = -scrollLeft;
              break;

            case 'positive-ascending':
              outerRef.scrollLeft = scrollLeft;
              break;

            default:
              var clientWidth = outerRef.clientWidth,
                  scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }

        outerRef.scrollTop = Math.max(0, scrollTop);
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          columnCount = _this$props4.columnCount,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          rowCount = _this$props4.rowCount,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling;

      var _this$_getHorizontalR = this._getHorizontalRangeToRender(),
          columnStartIndex = _this$_getHorizontalR[0],
          columnStopIndex = _this$_getHorizontalR[1];

      var _this$_getVerticalRan = this._getVerticalRangeToRender(),
          rowStartIndex = _this$_getVerticalRan[0],
          rowStopIndex = _this$_getVerticalRan[1];

      var items = [];

      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push((0,react.createElement)(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : undefined,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
      return (0,react.createElement)(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: extends_extends({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, (0,react.createElement)(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: estimatedTotalWidth
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props,
          columnCount = _this$props5.columnCount,
          onItemsRendered = _this$props5.onItemsRendered,
          onScroll = _this$props5.onScroll,
          rowCount = _this$props5.rowCount;

      if (typeof onItemsRendered === 'function') {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(),
              _overscanColumnStartIndex = _this$_getHorizontalR2[0],
              _overscanColumnStopIndex = _this$_getHorizontalR2[1],
              _visibleColumnStartIndex = _this$_getHorizontalR2[2],
              _visibleColumnStopIndex = _this$_getHorizontalR2[3];

          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(),
              _overscanRowStartIndex = _this$_getVerticalRan2[0],
              _overscanRowStopIndex = _this$_getVerticalRan2[1],
              _visibleRowStartIndex = _this$_getVerticalRan2[2],
              _visibleRowStopIndex = _this$_getVerticalRan2[3];

          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }

      if (typeof onScroll === 'function') {
        var _this$state3 = this.state,
            _horizontalScrollDirection = _this$state3.horizontalScrollDirection,
            _scrollLeft = _this$state3.scrollLeft,
            _scrollTop = _this$state3.scrollTop,
            _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested,
            _verticalScrollDirection = _this$state3.verticalScrollDirection;

        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props,
          columnCount = _this$props6.columnCount,
          overscanColumnCount = _this$props6.overscanColumnCount,
          overscanColumnsCount = _this$props6.overscanColumnsCount,
          overscanCount = _this$props6.overscanCount,
          rowCount = _this$props6.rowCount;
      var _this$state4 = this.state,
          horizontalScrollDirection = _this$state4.horizontalScrollDirection,
          isScrolling = _this$state4.isScrolling,
          scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props,
          columnCount = _this$props7.columnCount,
          overscanCount = _this$props7.overscanCount,
          overscanRowCount = _this$props7.overscanRowCount,
          overscanRowsCount = _this$props7.overscanRowsCount,
          rowCount = _this$props7.rowCount;
      var _this$state5 = this.state,
          isScrolling = _this$state5.isScrolling,
          verticalScrollDirection = _this$state5.verticalScrollDirection,
          scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;

      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return Grid;
  }(react.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    useIsScrolling: false
  }, _class;
}

var validateSharedProps = function validateSharedProps(_ref5, _ref6) {
  var children = _ref5.children,
      direction = _ref5.direction,
      height = _ref5.height,
      innerTagName = _ref5.innerTagName,
      outerTagName = _ref5.outerTagName,
      overscanColumnsCount = _ref5.overscanColumnsCount,
      overscanCount = _ref5.overscanCount,
      overscanRowsCount = _ref5.overscanRowsCount,
      width = _ref5.width;
  var instance = _ref6.instance;

  if (false) {}
};

var DEFAULT_ESTIMATED_ITEM_SIZE = 50;

var getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
  var rowCount = _ref.rowCount;
  var rowMetadataMap = _ref2.rowMetadataMap,
      estimatedRowHeight = _ref2.estimatedRowHeight,
      lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }

  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap,
      estimatedColumnWidth = _ref4.estimatedColumnWidth,
      lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }

  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};

var getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    if (itemType === 'column') {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }

  return itemMetadataMap[index];
};

var findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;

  if (itemType === 'column') {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }

  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size = itemType === 'column' ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
  // To ensure it reflects actual measurements instead of just estimates.

  var estimatedTotalSize = itemType === 'column' ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);

  if (align === 'smart') {
    if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
      align = 'auto';
    } else {
      align = 'center';
    }
  }

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return Math.round(minOffset + (maxOffset - minOffset) / 2);

    case 'auto':
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        // Because we only take into account the scrollbar size when calculating minOffset
        // this value can be larger than maxOffset when at the end of the list
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }

  }
};

var VariableSizeGrid = /*#__PURE__*/createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata('column', props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem('column', props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount,
        width = props.width;
    var itemMetadata = getItemMetadata('column', props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('column', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight: getEstimatedTotalHeight,
  getEstimatedTotalWidth: getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata('row', props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem('row', props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount,
        height = props.height;
    var itemMetadata = getItemMetadata('row', props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata('row', props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props,
        estimatedColumnWidth = _ref5.estimatedColumnWidth,
        estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };

    instance.resetAfterColumnIndex = function (columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        columnIndex: columnIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterRowIndex = function (rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instance.resetAfterIndices({
        rowIndex: rowIndex,
        shouldForceUpdate: shouldForceUpdate
      });
    };

    instance.resetAfterIndices = function (_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex,
          _ref6$shouldForceUpda = _ref6.shouldForceUpdate,
          shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;

      if (typeof columnIndex === 'number') {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }

      if (typeof rowIndex === 'number') {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      } // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.


      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    var columnWidth = _ref7.columnWidth,
        rowHeight = _ref7.rowHeight;

    if (false) {}
  }
});

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (false) {}

function createListComponent(_ref) {
  var _class;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, assertThisInitialized_assertThisInitialized(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: assertThisInitialized_assertThisInitialized(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoize_one_esm(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoize_one_esm(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoize_one_esm(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var _this$props2 = this.props,
          itemCount = _this$props2.itemCount,
          layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.
      // This is an edge case for lists; normally they only scroll in the dominant direction.

      var scrollbarSize = 0;

      if (this._outerRef) {
        var outerRef = this._outerRef;

        if (layout === 'vertical') {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }

      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          initialScrollOffset = _this$props3.initialScrollOffset,
          layout = _this$props3.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props,
          direction = _this$props4.direction,
          layout = _this$props4.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          className = _this$props5.className,
          direction = _this$props5.direction,
          height = _this$props5.height,
          innerRef = _this$props5.innerRef,
          innerElementType = _this$props5.innerElementType,
          innerTagName = _this$props5.innerTagName,
          itemCount = _this$props5.itemCount,
          itemData = _this$props5.itemData,
          _this$props5$itemKey = _this$props5.itemKey,
          itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey,
          layout = _this$props5.layout,
          outerElementType = _this$props5.outerElementType,
          outerTagName = _this$props5.outerTagName,
          style = _this$props5.style,
          useIsScrolling = _this$props5.useIsScrolling,
          width = _this$props5.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push((0,react.createElement)(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return (0,react.createElement)(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: extends_extends({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, (0,react.createElement)(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props,
          itemCount = _this$props6.itemCount,
          overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(react.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (false) { var isHorizontal; }
};

var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;

var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
      itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    instanceProps.lastMeasuredIndex = index;
  }

  return itemMetadataMap[index];
};

var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
      estimatedItemSize = _ref3.estimatedItemSize,
      lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }

  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};

var VariableSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = props.direction,
        height = props.height,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        itemCount = props.itemCount,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
        estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };

    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;

    if (false) {}
  }
});

var FixedSizeGrid = /*#__PURE__*/createGridComponent({
  getColumnOffset: function getColumnOffset(_ref, index) {
    var columnWidth = _ref.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth(_ref2, index) {
    var columnWidth = _ref2.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
    var rowCount = _ref5.rowCount,
        rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
    var columnCount = _ref6.columnCount,
        columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount,
        columnWidth = _ref7.columnWidth,
        width = _ref7.width;
    var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
    var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);

    if (align === 'smart') {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(width / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight,
        height = _ref8.height,
        rowCount = _ref8.rowCount;
    var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
    var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);

    if (align === 'smart') {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        // "Centered" offset is usually the average of the min and max.
        // But near the edges of the list, this doesn't hold true.
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

        if (middleOffset < Math.ceil(height / 2)) {
          return 0; // near the beginning
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset; // near the end
        } else {
          return middleOffset;
        }

      case 'auto':
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          // Because we only take into account the scrollbar size when calculating minOffset
          // this value can be larger than maxOffset when at the end of the list
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth,
        columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth,
        columnCount = _ref10.columnCount,
        width = _ref10.width;
    var left = startIndex * columnWidth;
    var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight,
        rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight,
        rowCount = _ref12.rowCount,
        height = _ref12.height;
    var top = startIndex * rowHeight;
    var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref13) {
    var columnWidth = _ref13.columnWidth,
        rowHeight = _ref13.rowHeight;

    if (false) {}
  }
});

var FixedSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (false) {}
  }
});

// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(prev, next) {
  for (var attribute in prev) {
    if (!(attribute in next)) {
      return true;
    }
  }

  for (var _attribute in next) {
    if (prev[_attribute] !== next[_attribute]) {
      return true;
    }
  }

  return false;
}

var _excluded = (/* unused pure expression or super */ null && (["style"])),
    _excluded2 = (/* unused pure expression or super */ null && (["style"]));
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo

function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style,
      prevRest = _objectWithoutPropertiesLoose(prevProps, _excluded);

  var nextStyle = nextProps.style,
      nextRest = _objectWithoutPropertiesLoose(nextProps, _excluded2);

  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}

// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate

function shouldComponentUpdate(nextProps, nextState) {
  return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx





var AnchorTag_AnchorTag = function AnchorTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      color = _ref.color,
      handleClick = _ref.handleClick,
      hrefProp = _ref.hrefProp,
      textAlign = _ref.textAlign,
      margin = _ref.margin,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave,
      textTransform = _ref.textTransform,
      anchorTitle = _ref.anchorTitle,
      targetProp = _ref.targetProp,
      _ref$download = _ref.download,
      download = _ref$download === void 0 ? false : _ref$download,
      disableState = _ref.disableState;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* AnchorTagStyle */.C2, {
    context: context ? context : undefined,
    textAlign: textAlign,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    onClick: handleClick,
    href: hrefProp,
    margin: margin,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    textTransform: textTransform,
    title: anchorTitle,
    target: targetProp,
    download: download,
    disableState: disableState,
    "data-test-id": "AnchorTag-AnchorTagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_AnchorTag = (AnchorTag_AnchorTag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.style.tsx

var CountryList_style_ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CountryListstyle__ArrowButtonWrap",
  componentId: "sc-10iz6l5-0"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
var DescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__DescriptionWrap",
  componentId: "sc-10iz6l5-1"
})(["cursor:none;margin:10px 0px 0px 32px;border-radius:4px;padding:10px 6px 10px 10px;background-color:#f6f6f6;cursor:", ";"], function (props) {
  return props.isCursorPointer ? "pointer" : "default";
});
var ColumnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__ColumnWrapper",
  componentId: "sc-10iz6l5-2"
})(["display:flex;flex-direction:column;& > span{margin-bottom:-6px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.style.tsx








var SelectCountryModalV2_style_SelectCountryModalStyle = (0,styled_components_browser_esm/* default */.ZP)(CommonModalDweb_style/* CommonModalDwebStyle */.E5).withConfig({
  displayName: "SelectCountryModalV2style__SelectCountryModalStyle",
  componentId: "sc-2hn0ay-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
var SelectCountryModalV2_style_CountryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__CountryItem",
  componentId: "sc-2hn0ay-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;margin:", ";cursor:", ";", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], function (props) {
  return props.margin && "".concat(props.margin);
}, function (props) {
  return props.disableCursor ? "default" : "pointer";
}, LandingButton_style/* LandingButtonStyle */.zm, CheckButtonStyle, Global/* theme.yellowText3 */.rS.yellowText3, ToolTipCompWrapper);
var SelectCountryModalV2_style_BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__BtnWrap",
  componentId: "sc-2hn0ay-2"
})(["position:", ";", ";", ";width:100%;"], function (props) {
  return props.position ? "".concat(props.position) : "sticky";
}, function (props) {
  return props.bottom && "bottom:".concat(props.bottom);
}, function (props) {
  return props.background && "background:".concat(props.background);
});
var SelectCountryModalV2_style_CountrySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__CountrySection",
  componentId: "sc-2hn0ay-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
var SelectCountryModalV2_style_CountrySectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__CountrySectionWrap",
  componentId: "sc-2hn0ay-4"
})(["@media ", "{padding:16px 16px 70px 16px;}"], src.deviceType.mobile);
var SelectCountryModalV2_style_PopularRegionCountries = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__PopularRegionCountries",
  componentId: "sc-2hn0ay-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
var SelectCountryModalV2_style_SelectCountrySheetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__SelectCountrySheetStyle",
  componentId: "sc-2hn0ay-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], TMFloatingInput_style/* TMInputWrap */.dd);
var SelectCountryModalV2_style_SelectCountryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__SelectCountryHeader",
  componentId: "sc-2hn0ay-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.tsx
//TODO: Check and Remove Duplicate components in this file and libs/insurance-landing-ui/src/lib/components (Present for Landing Page Components)















var CountryList = function CountryList(_ref) {
  var countryData = _ref.countryData,
      countryHandler = _ref.countryHandler,
      isCheckedHandler = _ref.isCheckedHandler,
      setCountryData = _ref.setCountryData,
      searchQueryHighlighter = _ref.searchQueryHighlighter,
      setIsSelectedError = _ref.setIsSelectedError,
      showHeader = _ref.showHeader,
      setCountrySelectToastMsg = _ref.setCountrySelectToastMsg;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)(); //TODO: handle default cell height using css var

  var defaultCellHeight = 57; //TODO: Check alternate height calculation using DOM elements

  var windowHeight = window.innerHeight - 213;
  var windowWidth = window.innerWidth - 60;
  var listRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      showViewAllButton = _useState[0],
      setShowViewAllButton = _useState[1];

  (0,react.useEffect)(function () {
    var _listRef$current;

    var temp = countryData.map(function (data) {
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef === null || listRef === void 0 ? void 0 : (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.resetAfterIndex(0);
    setCountryData(temp);
  }, []);
  (0,react.useEffect)(function () {
    var _listRef$current2;

    listRef === null || listRef === void 0 ? void 0 : (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.resetAfterIndex(0);
  }, [countryData]);

  var handleDescription = function handleDescription(code) {
    var data = countryData.filter(function (data) {
      return (data === null || data === void 0 ? void 0 : data.code) === code;
    })[0];

    if (data.showExpandedDescription || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }

    setShowViewAllButton(true);
    var tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    var descData = tempDescData.join(" ") + "...";
    return descData;
  };

  var handleRegionDescription = function handleRegionDescription(code) {
    var _listRef$current3;

    var temp = countryData.map(function (data) {
      if (data.code === code && !data.showDescription) {
        data["showDescription"] = true;
        data["showExpandedDescription"] = false;
        return data;
      }

      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef === null || listRef === void 0 ? void 0 : (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 ? void 0 : _listRef$current3.resetAfterIndex(0);
    setCountryData(temp);
  };

  var handleErrorToast = (0,utils/* debounce */.Ds)(function () {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  var handleCountrySelectError = function handleCountrySelectError(country) {
    var isExclusiveCountrySelected = countryData.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });

    if (isExclusiveCountrySelected && !(country !== null && country !== void 0 && country.isExclusiveSelection) && country.isDisabled) {
      setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
      handleErrorToast();
    } else if (country !== null && country !== void 0 && country.isExclusiveSelection && !isExclusiveCountrySelected && country.isDisabled) {
      setCountrySelectToastMsg("India cannot be chosen for International Travel");
      handleErrorToast();
    } else if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected && !country.showDescription && handleRegionDescription(country.code);
      }
      {
        country.isSelected && country.showDescription && handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  var handleViewAll = function handleViewAll(code) {
    var _listRef$current4;

    var temp = countryData.map(function (data) {
      if (data.code === code) {
        data["showExpandedDescription"] = !data["showExpandedDescription"];
      }

      return data;
    });
    listRef === null || listRef === void 0 ? void 0 : (_listRef$current4 = listRef.current) === null || _listRef$current4 === void 0 ? void 0 : _listRef$current4.resetAfterIndex(0);
    setCountryData(temp);
  };

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key;
    var item = countryData === null || countryData === void 0 ? void 0 : countryData[index];

    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return showHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style_CountryItem, {
        disableCursor: true,
        margin: device === "lg" ? "0px 17px 0px 0px" : "",
        "data-test-id": "CountryList-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: item.name,
          baseStyle: {
            fontWeight: "bold",
            fontSize: "14px"
          },
          "data-test-id": "CountryList-rowRenderer-FormattedText"
        })
      });
    } else if (item.code) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-test-id": `CountryList-rowRenderer-${key}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryModalV2_style_CountryItem, {
          disableCursor: true,
          margin: device === "lg" ? "0px 17px 0px 0px" : "",
          "data-test-id": "CountryList-rowRenderer-CountryItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            "data-test-id": "CountryList-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton_CheckButton, {
              handleChange: function handleChange() {
                return handleCountrySelectError(item);
              },
              isChecked: item.isDisabled ? true : isCheckedHandler(item),
              isDisabled: item.isDisabled,
              "data-test-id": "CountryList-rowRenderer-CheckButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                handleClick: function handleClick() {
                  return handleCountrySelectError(item);
                },
                alignItems: "center",
                justifyContent: "space-between",
                "data-test-id": "CountryList-rowRenderer-FlexComp",
                children: [item.subtitle ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnWrapper, {
                  "data-test-id": "CountryList-rowRenderer-ColumnWrapper",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: searchQueryHighlighter(item.name)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                      value: item.subtitle,
                      baseStyle: {
                        fontSize: "12px",
                        fontWeight: "400"
                      },
                      "data-test-id": "CountryList-rowRenderer-FormattedText"
                    })
                  })]
                }) : searchQueryHighlighter(item.name), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: item.countryCount,
                  baseStyle: {
                    padding: "0px 10px 0px 0px",
                    fontSize: "12px",
                    color: "#4A4A4A"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: item.regionName,
                  baseStyle: {
                    fontSize: "12px",
                    color: "#0000004D"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                })]
              })
            }), item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList_style_ArrowButtonWrap, {
              onClick: function onClick() {
                handleRegionDescription(item.code);
              },
              "data-test-id": "CountryList-rowRenderer-ArrowButtonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: item.showDescription ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                "data-test-id": "CountryList-rowRenderer-ImageComponent"
              })
            })]
          }), item.showDescription && item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrap, {
            "data-test-id": "CountryList-rowRenderer-DescriptionWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.descTitle,
              baseStyle: {
                fontWeight: "bold",
                fontSize: "14px"
              },
              "data-test-id": "CountryList-rowRenderer-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: handleDescription(item.code),
                baseStyle: {
                  fontSize: "14px"
                },
                "data-test-id": "CountryList-rowRenderer-FormattedText"
              })
            }), showViewAllButton && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
              handleClick: function handleClick() {
                handleViewAll(item.code);
              },
              fontWeight: "bold",
              "data-test-id": "CountryList-rowRenderer-AnchorTag",
              children: "View All"
            })]
          })]
        })
      }, key);
    }

    return;
  };

  var getItemSize = function getItemSize(code, isShowDesc, isShowAllDesc) {
    var expansionValue = 0;

    if (isShowAllDesc) {
      expansionValue = 2;
    } else if (isShowDesc) {
      expansionValue = 1;
    }

    return (0,utils/* interpolateRowHeight */.IS)(device === "lg" ? 360 : windowWidth, code, expansionValue) || defaultCellHeight;
  };

  var getItemSizes = function getItemSizes(index) {
    var height = countryData[index].type === "REGION" ? getItemSize(countryData[index].code, countryData[index].showDescription, countryData[index].showExpandedDescription) : defaultCellHeight;
    return height;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(VariableSizeList, {
    height: device === "lg" ? 380 : windowHeight,
    itemCount: countryData.length,
    itemSize: getItemSizes,
    width: device === "lg" ? 360 : windowWidth,
    ref: listRef,
    "data-test-id": "CountryList-FixList",
    children: function children(_ref3) {
      var index = _ref3.index,
          style = _ref3.style;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: style,
        "data-test-id": `CountryList-${index}`,
        children: rowRenderer({
          index: index,
          key: index
        })
      }, index);
    }
  });
};

/* harmony default export */ var SelectCountryModal_CountryList = (CountryList);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalSheetV2.tsx



function SelectCountryModalSheetV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModalSheetV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModalSheetV2_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModalSheetV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var SelectCountryModalSheetV2_analytics = (0,insurance/* getAnalytics */.I)();
var DEBOUNCE_TIME = 300;

var fuzzySearch = function fuzzySearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) {
  var selectedCountriesData = displayCountryData.filter(function (country) {
    return country.isSelected && !country.isDisabled;
  });
  var searchResults = searcher.search(searchValue);
  var filteredData = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (match) {
    return match === null || match === void 0 ? void 0 : match.item;
  });
  var originalSortData = countryData.map(function (country) {
    return displayCountryData.find(function (item) {
      return item.code === country.code;
    });
  });
  var allObjects = [].concat(_toConsumableArray(selectedCountriesData), _toConsumableArray(filteredData), _toConsumableArray(originalSortData));
  var tempObj = allObjects.reduce(function (acc, obj) {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  var uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

var debouncedSearch = (0,utils/* debounce */.Ds)(fuzzySearch, 300);

var SelectCountryModalSheet = function SelectCountryModalSheet(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      setShowCountry = _ref.setShowCountry,
      setCountryData = _ref.setCountryData,
      showCountry = _ref.showCountry,
      countrySelectErrMsg = _ref.countrySelectErrMsg,
      setIsCountryError = _ref.setIsCountryError,
      popularCountries = _ref.popularCountries,
      setPopularCountries = _ref.setPopularCountries,
      handleDescriptionModal = _ref.handleDescriptionModal,
      customSubTitle = _ref.customSubTitle;

  var _useState = (0,react.useState)(countryData),
      displayCountryData = _useState[0],
      setDisplayCountrysData = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchTxt = _useState2[0],
      setSearchTxt = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isSelectedError = _useState3[0],
      setIsSelectedError = _useState3[1];

  var searchedCountriesOmn = (0,react.useRef)([]);
  var selectedCountriesOmn = (0,react.useRef)([]);

  var _useState4 = (0,react.useState)(""),
      countrySelectToastMsg = _useState4[0],
      setCountrySelectToastMsg = _useState4[1];

  var searcher = new Fuse(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  var noSearchResults = function noSearchResults(addTimeOut) {
    var allObjects = [];
    var selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    var selectedCountriesData = displayCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    });
    var originalSortData = countryData.map(function (country) {
      return displayCountryData.find(function (item) {
        return item.code === country.code;
      });
    });

    if (selectedCountriesData.length) {
      allObjects = [SelectCountryModalSheetV2_objectSpread({}, selectedHeader)].concat(_toConsumableArray(selectedCountriesData), _toConsumableArray(originalSortData));
      var tempObj = allObjects.reduce(function (acc, obj) {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      var uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(function () {
    noSearchResults(false);
  }, []);

  var countryClickHandler = function countryClickHandler(code) {
    handleDescriptionModal(displayCountryData.filter(function (data) {
      return data.code === code;
    })[0]);
    var updatedCountryArr = displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.map(function (country) {
      if (country.code === code) {
        var _selectedCountriesOmn;

        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModalSheetV2_objectSpread({}, country);
        }
        /* istanbul ignore next */


        if ((selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn = selectedCountriesOmn.current) === null || _selectedCountriesOmn === void 0 ? void 0 : _selectedCountriesOmn.length) >= 30) {
          var _selectedCountriesOmn2;

          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn2 = selectedCountriesOmn.current) === null || _selectedCountriesOmn2 === void 0 ? void 0 : _selectedCountriesOmn2.slice(1)), [country.code]);
        } else {
          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : selectedCountriesOmn.current), [country.code]);
        }

        return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var isExclusiveCountrySelected = updatedCountryArr.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    updatedCountryArr = updatedCountryArr.map(function (country) {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? SelectCountryModalSheetV2_objectSpread({}, country) : SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
          isDisabled: true
        }) : SelectCountryModalSheetV2_objectSpread({}, country);
      }

      return SelectCountryModalSheetV2_objectSpread({}, country);
    });
    var selectedCountryCodes = updatedCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedCountryCodes.map(function (item) {
      updatedCountryArr = updatedCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModalSheetV2_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    var popularCountryData = updatedCountryArr.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    setPopularCountries([].concat(_toConsumableArray(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    }))));
  };

  var handleSearchtxt = (0,react.useCallback)(function (searchValue) {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  var onSearchChange = function onSearchChange(searchValue) {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalSheet-searchQueryHighlighter-ParaTag"
    });
  };

  var isCheckedHandler = (0,react.useCallback)(function (data) {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  var handleCrossClick = function handleCrossClick() {
    var _searchedCountriesOmn;

    setPopularCountries(showCountry);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn = searchedCountriesOmn.current) !== null && _searchedCountriesOmn !== void 0 && _searchedCountriesOmn.length) {
      var _searchedCountriesOmn2;

      SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn2 = searchedCountriesOmn.current) === null || _searchedCountriesOmn2 === void 0 ? void 0 : _searchedCountriesOmn2.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    var tempCountryData = displayCountryData.map(function (country) {
      return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(function (data) {
      tempCountryData = tempCountryData.map(function (country) {
        if (data.code === country.code) {
          return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheetV2_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(SelectCountryModalSheetV2_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _searchedCountriesOmn3, _selectedCountriesOmn3;

    setIsCountryError(false);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn3 = searchedCountriesOmn.current) !== null && _searchedCountriesOmn3 !== void 0 && _searchedCountriesOmn3.length) {
      var _searchedCountriesOmn4;

      SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn4 = searchedCountriesOmn.current) === null || _searchedCountriesOmn4 === void 0 ? void 0 : _searchedCountriesOmn4.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn !== null && selectedCountriesOmn !== void 0 && (_selectedCountriesOmn3 = selectedCountriesOmn.current) !== null && _selectedCountriesOmn3 !== void 0 && _selectedCountriesOmn3.length) {
      var _selectedCountriesOmn4;

      SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn4 = selectedCountriesOmn.current) === null || _selectedCountriesOmn4 === void 0 ? void 0 : _selectedCountriesOmn4.join("|")
      });
      selectedCountriesOmn.current = [];
    }

    var countryDataArr = countryData.map(function (country) {
      return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(function (data) {
      countryDataArr = countryDataArr.map(function (country) {
        if (country.code === data.code) {
          return SelectCountryModalSheetV2_objectSpread(SelectCountryModalSheetV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalSheetV2_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    var selectedCountryCodes = displayCountryData.filter(function (item) {
      return item.isSelected && !item.isDisabled;
    }).map(function (item) {
      return item.code;
    });
    (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    var selectedNonPopCountries = displayCountryData.filter(function (data) {
      return data.isSelected && !data.isPopular;
    });
    SelectCountryModalSheetV2_analytics === null || SelectCountryModalSheetV2_analytics === void 0 ? void 0 : SelectCountryModalSheetV2_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    });
    handleSelectCountry && handleSelectCountry();
  };

  var handleSearchTxt = function handleSearchTxt(event) {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      var _searchedCountriesOmn5;

      if ((searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn5 = searchedCountriesOmn.current) === null || _searchedCountriesOmn5 === void 0 ? void 0 : _searchedCountriesOmn5.length) >= 30) {
        var _searchedCountriesOmn6;

        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn6 = searchedCountriesOmn.current) === null || _searchedCountriesOmn6 === void 0 ? void 0 : _searchedCountriesOmn6.slice(1)), [searchTxt]);
      } else {
        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : searchedCountriesOmn.current), [searchTxt]);
      }
    }

    setSearchTxt(function (_) {
      return event.target.value;
    });
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_ReactPortalComp, {
    "data-test-id": "SelectCountryModalSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryModalV2_style_SelectCountrySheetStyle, {
      "data-test-id": "SelectCountryModalSheet-SelectCountrySheetStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryModalV2_style_SelectCountryHeader, {
        "data-test-id": "SelectCountryModalSheet-SelectCountryHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
          handleClick: handleCrossClick,
          "data-test-id": "SelectCountryModalSheet-AnchorTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          flexDirection: "column",
          "data-test-id": "SelectCountryModalSheet-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "md",
            fontWeight: "bold",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SelectCountryModalSheet-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: "Select Destinations",
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            color: Global/* theme.greyText6 */.rS.greyText6,
            "data-test-id": "SelectCountryModalSheet-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: customSubTitle,
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_TMFloatingInput, {
        handleChange: function handleChange(e) {
          return handleSearchTxt(e);
        },
        inputValue: searchTxt,
        labelTxt: "Search Country/Region",
        "data-test-id": "SelectCountryModalSheet-TMFloatingInput"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style_CountrySectionWrap, {
        "data-test-id": "SelectCountryModalSheet-CountrySectionWrap",
        children: displayCountryData !== null && displayCountryData !== void 0 && displayCountryData.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_CountryList, {
          countryData: searchTxt.length ? displayCountryData.filter(function (country) {
            return country.type !== "HEADER";
          }) : displayCountryData,
          countryHandler: countryClickHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setDisplayCountrysData,
          setIsSelectedError: setIsSelectedError,
          showHeader: !searchTxt.length,
          setCountrySelectToastMsg: setCountrySelectToastMsg,
          "data-test-id": "SelectCountryModalSheet-CountryList"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "sm",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "30px 0px 0px 0px",
          "data-test-id": "SelectCountryModalSheet-ParaTag",
          children: "No Country Found! Please enter correct name"
        })
      }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "75px",
        "data-test-id": "SelectCountryModalSheet-WebToast"
      }), (displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style_BtnWrap, {
        position: "fixed",
        bottom: "0px",
        background: "white",
        "data-test-id": "SelectCountryModalSheet-BtnWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
          margin: "12px 16px 12px 16px",
          customWidth: "92%",
          customTitle: "Add Destination",
          onClick: onCountrySubmit,
          "data-test-id": "SelectCountryModalSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ var SelectCountryModalSheetV2 = (SelectCountryModalSheet);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.style.tsx





var modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalDwebStyle",
  componentId: "h53l8r-0"
})(["position:fixed;width:", ";height:", ";max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, function (p) {
  return p.customHeight ? p.customHeight : "420px";
}, SectionDividers_style/* SectionDividersStyle */.$, TMFloatingInput_style/* TMInputWrap */.dd, static_utils/* deviceType.mobile */.vO.mobile, modalAnim, TMFloatingInput_style/* TMInputWrap */.dd);
var CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalHeader",
  componentId: "h53l8r-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:85%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style/* H5TagStyle */.Wl, function (p) {
  return p.nonClipHeading && "\n     ".concat(TextStyles_style/* H5TagStyle */.Wl, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, static_utils/* deviceType.mobile */.vO.mobile);
var CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CrossIconWrap",
  componentId: "h53l8r-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.tsx







var RegionCountryModal = function RegionCountryModal(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      customSubTitle = _ref.customSubTitle,
      handleClick = _ref.handleClick,
      requiredField = _ref.requiredField,
      crossIcon = _ref.crossIcon,
      customWidth = _ref.customWidth,
      customIcon = _ref.customIcon,
      errorModal = _ref.errorModal,
      customHeight = _ref.customHeight,
      nonClipHeading = _ref.nonClipHeading;
  (0,react.useEffect)(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(function () {
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
    return function () {};
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_ReactPortalComp, {
    "data-test-id": "RegionCountryModal-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customHeight: customHeight,
      customWidth: customWidth,
      "data-test-id": "RegionCountryModal-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionCountryModal-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
            color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "RegionCountryModal-H5Tag",
            children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "40px",
              height: "40px",
              src: customIcon,
              "data-test-id": "RegionCountryModal-ImageComponent"
            }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: customTitle,
              "data-test-id": "RegionCountryModal-FormattedText"
            })]
          }), customSubTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: customSubTitle,
            "data-test-id": "RegionCountryModal-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "RegionCountryModal-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "RegionCountryModal-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropComp_BackDropComp, {
      onClose: handleClick,
      "data-test-id": "RegionCountryModal-BackDropComp"
    })]
  });
};

/* harmony default export */ var RegionModalDweb_RegionCountryModal = (RegionCountryModal);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.tsx



function SelectCountryModalV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectCountryModalV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectCountryModalV2_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectCountryModalV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var SelectCountryModalV2_analytics = (0,insurance/* getAnalytics */.I)();
var SelectCountryModalV2_DEBOUNCE_TIME = 300;

var SelectCountryModalV2_fuzzySearch = function fuzzySearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) {
  var selectedCountriesData = displayCountryData.filter(function (country) {
    return country.isSelected && !country.isDisabled;
  });
  var searchResults = searcher.search(searchValue);
  var filteredData = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (match) {
    return match === null || match === void 0 ? void 0 : match.item;
  });
  var originalSortData = countryData.map(function (country) {
    return displayCountryData.find(function (item) {
      return item.code === country.code;
    });
  });
  var allObjects = [].concat(_toConsumableArray(selectedCountriesData), _toConsumableArray(filteredData), _toConsumableArray(originalSortData));
  var tempObj = allObjects.reduce(function (acc, obj) {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  var uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

var SelectCountryModalV2_debouncedSearch = (0,utils/* debounce */.Ds)(SelectCountryModalV2_fuzzySearch, SelectCountryModalV2_DEBOUNCE_TIME);

var SelectCountryModalV2 = function SelectCountryModalV2(_ref) {
  var handleSelectCountry = _ref.handleSelectCountry,
      countryData = _ref.countryData,
      setShowCountry = _ref.setShowCountry,
      showCountry = _ref.showCountry,
      setCountryData = _ref.setCountryData,
      countrySelectErrMsg = _ref.countrySelectErrMsg,
      setIsCountryError = _ref.setIsCountryError,
      popularCountries = _ref.popularCountries,
      setPopularCountries = _ref.setPopularCountries,
      customSubTitle = _ref.customSubTitle,
      handleDescriptionModal = _ref.handleDescriptionModal;

  var _useState = (0,react.useState)(countryData),
      displayCountryData = _useState[0],
      setDisplayCountrysData = _useState[1];

  var _useState2 = (0,react.useState)(""),
      searchTxt = _useState2[0],
      setSearchTxt = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isSelectedError = _useState3[0],
      setIsSelectedError = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      countrySelectToastMsg = _useState4[0],
      setCountrySelectToastMsg = _useState4[1];

  var searchedCountriesOmn = (0,react.useRef)([]);
  var selectedCountriesOmn = (0,react.useRef)([]);
  var searcher = new Fuse(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  var noSearchResults = function noSearchResults(addTimeOut) {
    var allObjects = [];
    var selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    var selectedCountriesData = displayCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    });
    var originalSortData = countryData.map(function (country) {
      return displayCountryData.find(function (item) {
        return item.code === country.code;
      });
    });

    if (selectedCountriesData.length) {
      allObjects = [SelectCountryModalV2_objectSpread({}, selectedHeader)].concat(_toConsumableArray(selectedCountriesData), _toConsumableArray(originalSortData));
      var tempObj = allObjects.reduce(function (acc, obj) {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      var uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(uniqueObjects);
      }, SelectCountryModalV2_DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(function () {
        setDisplayCountrysData(originalSortData);
      }, SelectCountryModalV2_DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(function () {
    noSearchResults(false);
  }, []);

  var countryClickHandler = function countryClickHandler(code) {
    handleDescriptionModal(displayCountryData.filter(function (data) {
      return data.code === code;
    })[0]);
    var updatedCountryArr = displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.map(function (country) {
      if (country.code === code) {
        var _selectedCountriesOmn;

        if (country["isSelected"]) {
          country["isSelected"] = false;
          return SelectCountryModalV2_objectSpread({}, country);
        }
        /* istanbul ignore next */


        if ((selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn = selectedCountriesOmn.current) === null || _selectedCountriesOmn === void 0 ? void 0 : _selectedCountriesOmn.length) >= 30) {
          var _selectedCountriesOmn2;

          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn2 = selectedCountriesOmn.current) === null || _selectedCountriesOmn2 === void 0 ? void 0 : _selectedCountriesOmn2.slice(1)), [country.code]);
        } else {
          selectedCountriesOmn.current = [].concat(_toConsumableArray(selectedCountriesOmn.current), [country.code]);
        }

        return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var isExclusiveCountrySelected = updatedCountryArr.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    updatedCountryArr = updatedCountryArr.map(function (country) {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? SelectCountryModalV2_objectSpread({}, country) : SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
          isDisabled: true
        }) : SelectCountryModalV2_objectSpread({}, country);
      }

      return SelectCountryModalV2_objectSpread({}, country);
    });
    var selectedCountryCodes = updatedCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedCountryCodes.map(function (item) {
      updatedCountryArr = updatedCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return SelectCountryModalV2_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    var popularCountryData = updatedCountryArr.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    setPopularCountries([].concat(_toConsumableArray(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    }))));
  };

  var handleSearchtxt = (0,react.useCallback)(function (searchValue) {
    SelectCountryModalV2_debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  var onSearchChange = function onSearchChange(searchValue) {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  var searchQueryHighlighter = function searchQueryHighlighter(ele) {
    var withSpecialCharsSupport = searchTxt === null || searchTxt === void 0 ? void 0 : searchTxt.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var searchRegex = new RegExp("(".concat(withSpecialCharsSupport, ")"), "ig");
    var highlighted = ele.replace(searchRegex, function (match) {
      return "<span class=\"highlight\">".concat(match, "</span>");
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalV2-searchQueryHighlighter-ParaTag"
    });
  };

  var isCheckedHandler = (0,react.useCallback)(function (data) {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  var handleCrossClick = function handleCrossClick() {
    var _searchedCountriesOmn;

    setPopularCountries(showCountry);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn = searchedCountriesOmn.current) !== null && _searchedCountriesOmn !== void 0 && _searchedCountriesOmn.length) {
      var _searchedCountriesOmn2;

      SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn2 = searchedCountriesOmn.current) === null || _searchedCountriesOmn2 === void 0 ? void 0 : _searchedCountriesOmn2.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    var tempCountryData = displayCountryData.map(function (country) {
      return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(function (data) {
      tempCountryData = tempCountryData.map(function (country) {
        if (data.code === country.code) {
          return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalV2_objectSpread({}, country);
      });
    });
    setDisplayCountrysData(SelectCountryModalV2_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  var onCountrySubmit = function onCountrySubmit() {
    var _searchedCountriesOmn3, _selectedCountriesOmn3;

    setIsCountryError(false);

    if (searchedCountriesOmn !== null && searchedCountriesOmn !== void 0 && (_searchedCountriesOmn3 = searchedCountriesOmn.current) !== null && _searchedCountriesOmn3 !== void 0 && _searchedCountriesOmn3.length) {
      var _searchedCountriesOmn4;

      SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
        actionType: "searched_countries",
        payload: (searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn4 = searchedCountriesOmn.current) === null || _searchedCountriesOmn4 === void 0 ? void 0 : _searchedCountriesOmn4.join("|")) + "|"
      });
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn !== null && selectedCountriesOmn !== void 0 && (_selectedCountriesOmn3 = selectedCountriesOmn.current) !== null && _selectedCountriesOmn3 !== void 0 && _selectedCountriesOmn3.length) {
      var _selectedCountriesOmn4;

      SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn === null || selectedCountriesOmn === void 0 ? void 0 : (_selectedCountriesOmn4 = selectedCountriesOmn.current) === null || _selectedCountriesOmn4 === void 0 ? void 0 : _selectedCountriesOmn4.join("|")
      });
      selectedCountriesOmn.current = [];
    }

    var countryDataArr = countryData.map(function (country) {
      return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(function (data) {
      countryDataArr = countryDataArr.map(function (country) {
        if (country.code === data.code) {
          return SelectCountryModalV2_objectSpread(SelectCountryModalV2_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return SelectCountryModalV2_objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    var selectedCountryCodes = displayCountryData.filter(function (item) {
      return item.isSelected && !item.isDisabled;
    }).map(function (item) {
      return item.code;
    });
    (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    var selectedNonPopCountries = displayCountryData.filter(function (data) {
      return data.isSelected && !data.isPopular;
    });
    SelectCountryModalV2_analytics === null || SelectCountryModalV2_analytics === void 0 ? void 0 : SelectCountryModalV2_analytics.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(function (c) {
        return c.name;
      }).join("|")
    });
    handleSelectCountry && handleSelectCountry();
  };

  var handleSearchTxt = function handleSearchTxt(event) {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      var _searchedCountriesOmn5;

      if ((searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn5 = searchedCountriesOmn.current) === null || _searchedCountriesOmn5 === void 0 ? void 0 : _searchedCountriesOmn5.length) >= 30) {
        var _searchedCountriesOmn6;

        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : (_searchedCountriesOmn6 = searchedCountriesOmn.current) === null || _searchedCountriesOmn6 === void 0 ? void 0 : _searchedCountriesOmn6.slice(1)), [searchTxt]);
      } else {
        searchedCountriesOmn.current = [].concat(_toConsumableArray(searchedCountriesOmn === null || searchedCountriesOmn === void 0 ? void 0 : searchedCountriesOmn.current), [searchTxt]);
      }
    }

    setSearchTxt(function (_) {
      return event.target.value;
    });
    onSearchChange(event.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_RegionCountryModal, {
    customHeight: "600px",
    handleClick: handleCrossClick,
    customTitle: "Select Destinations",
    customSubTitle: customSubTitle,
    "data-test-id": "SelectCountryModalV2-RegionCountryModal",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_TMFloatingInput, {
      handleChange: function handleChange(e) {
        return handleSearchTxt(e);
      },
      inputValue: searchTxt,
      labelTxt: "Search Country/Region",
      "data-test-id": "SelectCountryModalV2-TMFloatingInput"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style_CountrySectionWrap, {
      "data-test-id": "SelectCountryModalV2-CountrySectionWrap",
      children: displayCountryData !== null && displayCountryData !== void 0 && displayCountryData.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_CountryList, {
        countryData: searchTxt.length ? displayCountryData.filter(function (country) {
          return country.type !== "HEADER";
        }) : displayCountryData,
        countryHandler: countryClickHandler,
        isCheckedHandler: isCheckedHandler,
        searchQueryHighlighter: searchQueryHighlighter,
        setCountryData: setDisplayCountrysData,
        setIsSelectedError: setIsSelectedError,
        showHeader: !searchTxt.length,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        "data-test-id": "SelectCountryModalV2-CountryList"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "30px 0px 0px 0px",
        "data-test-id": "SelectCountryModalV2-ParaTag",
        children: "No Country Found! Please enter correct name"
      })
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModalV2-WebToast"
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModalV2-WebToast"
    }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
      toastTxt: countrySelectToastMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModalV2-WebToast"
    }), (displayCountryData === null || displayCountryData === void 0 ? void 0 : displayCountryData.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style_BtnWrap, {
      "data-test-id": "SelectCountryModalV2-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        margin: "16px 0px 0px 0px",
        customWidth: "100%",
        customTitle: "Add Destination",
        onClick: onCountrySubmit,
        "data-test-id": "SelectCountryModalV2-LandingButton"
      })
    })]
  });
};

/* harmony default export */ var SelectCountryModal_SelectCountryModalV2 = (SelectCountryModalV2);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Shimmer/Shimmer.tsx
var Shimmer = __webpack_require__(3531);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Shimmer/Shimmer.style.ts
var Shimmer_style = __webpack_require__(9156);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Shimmer/ShimmerVersion2.tsx



function ShimmerVersion2_ShimmerVersion2(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer_style/* ShimmerVersion2Style */.aW, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion2Style",
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Shimmer/ShimmerVersion3.tsx



function ShimmerVersion3_ShimmerVersion3(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      children = _ref.children,
      padding = _ref.padding;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer_style/* ShimmerVersion3Style */.Jh, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion3Style",
    children: children
  });
}
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.style.ts


var ShowInsPlanStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsPlanStyle",
  componentId: "sc-1vtw87g-0"
})(["border:1px solid #e8e8e8;border-radius:8px;flex:1;background:#fff;margin:", ";display:flex;flex-direction:column;", "{text-align:end;[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{padding-right:30px;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{right:0;left:auto;}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{right:3px;left:auto;}}"], function (p) {
  return p.margin ? p.margin : "";
}, RadioButtonStyle);
var ShowInsPlanCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsPlanCntnt",
  componentId: "sc-1vtw87g-1"
})(["padding:12px;"]);
var ShowInsSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsSelect",
  componentId: "sc-1vtw87g-2"
})(["background:#f6f6f6;border-radius:0px 0px 8px 8px;border-top:1px solid transparent;padding:8px 12px;display:flex;align-items:flex-end;margin-top:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.tsx







var ShowInsPlan = function ShowInsPlan(_ref) {
  var data = _ref.data,
      margin = _ref.margin;

  var _useState = (0,react.useState)(-1),
      selectPlan = _useState[0],
      setSelectPlan = _useState[1];

  var handleSelectPlan = function handleSelectPlan(index) {
    setSelectPlan(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
    gap: "12px",
    margin: margin,
    "data-test-id": "ShowInsPlan-FlexComp",
    children: data && data.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ShowInsPlanStyle, {
        onClick: function onClick() {
          return handleSelectPlan(index);
        },
        planSelected: selectPlan == index,
        "data-test-id": `ShowInsPlan-ShowInsPlanStyle-${index}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ShowInsPlanCntnt, {
          "data-test-id": "ShowInsPlan-ShowInsPlanCntnt",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
            gap: "8px",
            alignItems: "center",
            margin: "0 0 8px",
            "data-test-id": "ShowInsPlan-FlexComp",
            children: [item.planIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "24px",
              height: "24px",
              src: item.planIcon,
              "data-test-id": "ShowInsPlan-ImageComponent"
            }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              color: Global/* theme.blackText */.rS.blackText,
              margin: "0 0 0 8px",
              "data-test-id": "ShowInsPlan-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "ShowInsPlan-FormattedText"
              })
            })]
          }), item.planInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "ShowInsPlan-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: item.planInfo,
              "data-test-id": "ShowInsPlan-FormattedText"
            })
          })]
        })
      }, index);
    })
  });
};

/* harmony default export */ var ShowInsPlan_ShowInsPlan = (ShowInsPlan);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.styles.ts

var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerCont = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-1pp3kmk-0"
})(["display:inline-block;height:22px;width:22px;animation:", " 1s linear infinite;border-right-color:transparent;border-radius:50%;margin:-2px auto;"], rotate);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.tsx


function Spinner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Spinner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Spinner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Spinner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Spinner = function Spinner(_ref) {
  var _ref$spinnerWidth = _ref.spinnerWidth,
      spinnerWidth = _ref$spinnerWidth === void 0 ? 22 : _ref$spinnerWidth,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === void 0 ? "#0189d2" : _ref$spinnerColor,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 2 : _ref$thickness,
      customStyle = _ref.customStyle;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerCont, {
    style: Spinner_objectSpread({
      width: spinnerWidth,
      height: spinnerWidth,
      border: "".concat(thickness, "px solid ").concat(spinnerColor),
      borderRightColor: "transparent"
    }, customStyle),
    "data-test-id": "Spinner-SpinnerCont"
  });
};

/* harmony default export */ var Spinner_Spinner = (Spinner);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Tags/Tags.style.ts


var TagsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tagsstyle__TagsStyle",
  componentId: "c49c5y-0"
})(["display:flex;overflow-x:scroll;gap:8px;flex-shrink:0;&::-webkit-scrollbar{display:none;}"]);
var TagItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Tagsstyle__TagItem",
  componentId: "c49c5y-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:0px 10px;cursor:pointer;flex-shrink:0;position:relative;display:flex;align-items:center;justify-content:center;height:33px;", " ", "{position:absolute;top:-5px;left:5px;}"], function (p) {
  return p.isSelected && "\nbackground: #F8FBFF;\nborder: 1px solid #008CFF;\nborder-radius: 6px;\n";
}, ImageTagStyle);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Tags/Tags.tsx







var Tags = function Tags(_ref) {
  var data = _ref.data,
      handleClickTab = _ref.handleClickTab;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TagsStyle, {
    "data-test-id": "Tags-TagsStyle",
    children: data === null || data === void 0 ? void 0 : data.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TagItem, {
          isSelected: item.isSelected,
          onClick: handleClickTab ? function () {
            return handleClickTab(item.id);
          } : function () {},
          "data-test-id": "Tags-TagItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            color: item.isSelected ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
            fontSize: "xs",
            fontWeight: "black",
            "data-test-id": "Tags-SpanTag",
            children: item.name
          }), item.tagImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag, {
            src: item.tagImg,
            width: "30px",
            height: "14px",
            "data-test-id": "Tags-ImageTag"
          })]
        }, item.id)
      });
    })
  });
};

/* harmony default export */ var Tags_Tags = (Tags);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H2Tag.tsx





var H2Tag = function H2Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* H2TagStyle */.FI, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H2Tag-H2TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H2Tag = (H2Tag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H3Tag.tsx





var H3Tag = function H3Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* H3TagStyle */.KO, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H3Tag-H3TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H3Tag = (H3Tag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H4Tag.tsx





var H4Tag = function H4Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* H4TagStyle */.sz, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H4Tag-H4TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H4Tag = (H4Tag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H5Tag.tsx





var H5Tag = function H5Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* H5TagStyle */.Wl, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H5Tag-H5TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H5Tag = (H5Tag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H6Tag.tsx





var H6Tag = function H6Tag(_ref) {
  var children = _ref.children,
      margin = _ref.margin,
      color = _ref.color;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* H6TagStyle */.xT, {
    context: context ? context : undefined,
    txtcolor: color,
    margin: margin,
    "data-test-id": "H6Tag-H6TagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_H6Tag = (H6Tag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/ParaTag.tsx





var ParaTag_ParaTag = function ParaTag(_ref) {
  var children = _ref.children,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      margin = _ref.margin,
      textAlign = _ref.textAlign,
      lineHeight = _ref.lineHeight,
      dangerousText = _ref.dangerousText,
      textTransform = _ref.textTransform;
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* ParaTagStyle */.OG, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle"
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* ParaTagStyle */.OG, {
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    margin: margin,
    textAlign: textAlign,
    lineHeight: lineHeight,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "ParaTag-ParaTagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_ParaTag = (ParaTag_ParaTag);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TextStyles/SpanTag.tsx





var SpanTag_SpanTag = function SpanTag(_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "sm" : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "regular" : _ref$fontWeight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "black" : _ref$color,
      margin = _ref.margin,
      children = _ref.children,
      textTransform = _ref.textTransform,
      dangerousText = _ref.dangerousText,
      style = _ref.style;

  if (dangerousText && typeof dangerousText !== "string") {
    dangerousText = String(dangerousText);
  }

  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return dangerousText ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* SpanTagStyle */.zs, {
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    dangerouslySetInnerHTML: {
      __html: dangerousText
    },
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle"
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_style/* SpanTagStyle */.zs, {
    style: style,
    margin: margin,
    txtfontSize: fontSize,
    txtfontWeight: fontWeight,
    txtcolor: color,
    textTransform: textTransform,
    context: context ? context : undefined,
    "data-test-id": "SpanTag-SpanTagStyle",
    children: children
  });
};

/* harmony default export */ var TextStyles_SpanTag = (SpanTag_SpanTag);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/DownArrow.tsx
var DownArrow = __webpack_require__(6766);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/EditIcon.tsx
var EditIcon = __webpack_require__(2384);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.tsx









var TMFloatingInput = function TMFloatingInput(_ref) {
  var placeholderTxt = _ref.placeholderTxt,
      labelTxt = _ref.labelTxt,
      disableState = _ref.disableState,
      inputWidth = _ref.inputWidth,
      margin = _ref.margin,
      errorState = _ref.errorState,
      inputValue = _ref.inputValue,
      handleChange = _ref.handleChange,
      verifiedTag = _ref.verifiedTag,
      maxLength = _ref.maxLength,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      inputMode = _ref.inputMode,
      flex = _ref.flex,
      _ref$fieldType = _ref.fieldType,
      fieldType = _ref$fieldType === void 0 ? "text" : _ref$fieldType,
      _ref$showEdit = _ref.showEdit,
      showEdit = _ref$showEdit === void 0 ? false : _ref$showEdit,
      handleEditClick = _ref.handleEditClick,
      handleDropdownPress = _ref.handleDropdownPress;

  var _useState = (0,react.useState)(false),
      isFocus = _useState[0],
      setIsFocus = _useState[1];

  var inputFocusHandler = function inputFocusHandler(event) {
    if (fieldType === "select") {
      event.preventDefault();
      event.currentTarget.blur();
    }

    !(fieldType === "select") && setIsFocus(true);
    onFocus && onFocus();
  };

  var inputBlurHandler = function inputBlurHandler() {
    !(fieldType === "select") && setIsFocus(false);
    onBlur && onBlur();
  };

  var handleClick = function handleClick() {
    if (fieldType === "select" && handleDropdownPress) {
      handleDropdownPress();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TMFloatingInput_style/* TMInputWrap */.dd, {
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    flex: flex,
    placeholder: placeholderTxt,
    clickable: fieldType === "select",
    onClick: handleClick,
    "data-test-id": "TMFloatingInput-TMInputWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TMFloatingInput_style/* InputWpr */.qT, {
      "data-test-id": "TMFloatingInput-InputWpr",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_style/* TMInputStyle */.se, {
        id: labelTxt,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: fieldType === "select" ? function () {} : handleChange,
        value: inputValue,
        errorState: errorState,
        onBlur: inputBlurHandler,
        verifiedTag: verifiedTag,
        disableState: disableState,
        onFocus: inputFocusHandler,
        placeholder: placeholderTxt,
        spellCheck: "false",
        maxLength: maxLength,
        type: type,
        required: true,
        clickable: fieldType === "select",
        "data-test-id": "TMFloatingInput-TMInputStyle"
      }), labelTxt && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: fieldType === "select" ? "" : labelTxt,
        className: "labelText",
        "data-test-id": "TMFloatingInput-label",
        children: labelTxt
      }), fieldType === "text" && verifiedTag && /*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_style/* VerifiedContainer */.ZR, {
        "data-test-id": "TMFloatingInput-VerifiedContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "xs",
          fontWeight: "bold",
          color: Global/* theme.darkGreen */.rS.darkGreen,
          "data-test-id": "TMFloatingInput-ParaTag",
          children: verifiedTag
        })
      }), fieldType === "text" && showEdit && /*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_style/* IconContainer */.qk, {
        onClick: handleEditClick,
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(EditIcon/* EditIcon */.d, {
          "data-test-id": "TMFloatingInput-EditIcon"
        })
      }), fieldType === "select" && /*#__PURE__*/(0,jsx_runtime.jsx)(TMFloatingInput_style/* IconContainer */.qk, {
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DownArrow/* DownArrow */.p, {
          "data-test-id": "TMFloatingInput-DownArrow"
        })
      })]
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
      margin: "4px 0 0",
      color: Global/* theme.redText2 */.rS.redText2,
      fontSize: "xs",
      dangerousText: errorState,
      "data-test-id": "TMFloatingInput-ParaTag"
    })]
  });
};

/* harmony default export */ var TMFloatingInput_TMFloatingInput = (TMFloatingInput);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/Toast.tsx







var Toast = function Toast(_ref) {
  var toastCtaTxt = _ref.toastCtaTxt,
      planSelectedTxt = _ref.planSelectedTxt,
      handleClickCta = _ref.handleClickCta,
      handleClose = _ref.handleClose,
      _ref$autoCloseDuratio = _ref.autoCloseDuration,
      autoCloseDuration = _ref$autoCloseDuratio === void 0 ? 3000 : _ref$autoCloseDuratio,
      toastCloseIcon = _ref.toastCloseIcon,
      toastIcon = _ref.toastIcon,
      isDisable = _ref.isDisable,
      showToast = _ref.showToast,
      width = _ref.width,
      height = _ref.height;

  var _useState = (0,react.useState)(true),
      visible = _useState[0],
      setVisible = _useState[1];

  (0,react.useEffect)(function () {
    var timer;

    if (autoCloseDuration) {
      timer = setTimeout(function () {
        if (visible) {
          setVisible(false);
        }
      }, autoCloseDuration);
    }

    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autoCloseDuration, visible]);
  return visible ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ToastStyle, {
    "data-test-id": "Toast-ToastStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "16px",
      alignItems: "center",
      "data-test-id": "Toast-FlexComp",
      children: [toastIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIcon, {
        "data-test-id": "Toast-ToastIcon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon,
          "data-test-id": "Toast-ImageComponent"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "md",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "Toast-SpanTag",
        children: planSelectedTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: planSelectedTxt,
          "data-test-id": "Toast-FormattedText"
        })
      })]
    }), toastCtaTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonWhite, {
      customTitle: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable,
      "data-test-id": "Toast-LandingButtonWhite"
    }), toastCloseIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIconWrap, {
      onClick: handleClose,
      "data-test-id": "Toast-CloseIconWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon,
        "data-test-id": "Toast-ImageComponent"
      })
    })]
  }) : null;
};

/* harmony default export */ var Toast_Toast = (Toast);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Toast/ToastCompare.tsx








var ToastCompare = function ToastCompare(_ref) {
  var toastCtaTxt = _ref.toastCtaTxt,
      planSelectedTxt = _ref.planSelectedTxt,
      handleClickCta = _ref.handleClickCta,
      handleClose = _ref.handleClose,
      toastCloseIcon = _ref.toastCloseIcon,
      toastIcon = _ref.toastIcon,
      isDisable = _ref.isDisable,
      width = _ref.width,
      height = _ref.height;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ToastStyle, {
    "data-test-id": "ToastCompare-ToastStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "4px",
      alignItems: "center",
      "data-test-id": "ToastCompare-FlexComp",
      children: [toastIcon && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIcon, {
        "data-test-id": "ToastCompare-ToastIcon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
          width: width ? width : "50px",
          height: height ? height : "50px",
          src: toastIcon,
          "data-test-id": "ToastCompare-ImageComponent"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: device == "lg" ? "md" : "xs",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "ToastCompare-SpanTag",
        children: planSelectedTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: planSelectedTxt,
          "data-test-id": "ToastCompare-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButtonTertiary, {
      title: toastCtaTxt,
      onClick: handleClickCta,
      disableState: isDisable,
      "data-test-id": "ToastCompare-LandingButtonTertiary"
    }), toastCloseIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIconWrap, {
      onClick: handleClose,
      "data-test-id": "ToastCompare-CloseIconWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "28px",
        height: "28px",
        src: toastCloseIcon,
        "data-test-id": "ToastCompare-ImageComponent"
      })
    })]
  });
};

/* harmony default export */ var Toast_ToastCompare = (ToastCompare);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.tsx




var ToolTipComp = function ToolTipComp(_ref) {
  var message = _ref.message,
      top = _ref.top,
      left = _ref.left,
      right = _ref.right,
      bottom = _ref.bottom,
      width = _ref.width,
      toolTipArrow = _ref.toolTipArrow,
      children = _ref.children,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ToolTipCompWrapper, {
    width: width,
    top: top,
    left: left,
    right: right,
    bottom: bottom,
    toolTipArrow: toolTipArrow,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-test-id": "ToolTipComp-ToolTipCompWrapper",
    children: children
  });
};

/* harmony default export */ var ToolTipComp_ToolTipComp = (ToolTipComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.style.ts


var TravAssistantStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravAssistantstyle__TravAssistantStyle",
  componentId: "iorioc-0"
})(["border-radius:16px;border:1px solid #e2e2e2;background:#fff;padding:16px;@media ", "{border-radius:0;}"], src.deviceType.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.tsx








var TravAssistant = function TravAssistant(_ref) {
  var cardTitle = _ref.cardTitle,
      cardInfo = _ref.cardInfo,
      helpLineNo = _ref.helpLineNo,
      cardIcon = _ref.cardIcon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravAssistantStyle, {
    "data-test-id": "TravAssistant-TravAssistantStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "8px",
      borderBottom: "1px solid #e2e2e2",
      padding: "0 0 8px",
      margin: "0 0 10px",
      "data-test-id": "TravAssistant-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: cardIcon,
        "data-test-id": "TravAssistant-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [cardTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "md",
          fontWeight: "bold",
          color: Global/* theme.greenText */.rS.greenText,
          "data-test-id": "TravAssistant-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: cardTitle,
            "data-test-id": "TravAssistant-FormattedText"
          })
        }), cardInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          "data-test-id": "TravAssistant-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: cardInfo,
            "data-test-id": "TravAssistant-FormattedText"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      alignItems: "center",
      gap: "8px",
      "data-test-id": "TravAssistant-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Phone_8b0592cec7.svg",
        "data-test-id": "TravAssistant-ImageComponent"
      }), helpLineNo && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
        fontWeight: "bold",
        "data-test-id": "TravAssistant-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: helpLineNo,
          "data-test-id": "TravAssistant-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var TravAssistant_TravAssistant = (TravAssistant);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.style.tsx





var RegionModalDweb_style_modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
var RegionModalDweb_style_CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalDwebStyle",
  componentId: "c6vrw8-0"
})(["position:fixed;width:", ";height:fit-content;max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], function (p) {
  return p.customWidth ? p.customWidth : "420px";
}, SectionDividers_style/* SectionDividersStyle */.$, TMFloatingInput_style/* TMInputWrap */.dd, static_utils/* deviceType.mobile */.vO.mobile, RegionModalDweb_style_modalAnim, TMFloatingInput_style/* TMInputWrap */.dd);
var RegionModalDweb_style_CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalHeader",
  componentId: "c6vrw8-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;gap:10px;white-space:nowrap;overflow:hidden;align-items:center;justify-content:space-between;text-overflow:ellipsis;width:100%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style/* H5TagStyle */.Wl, function (p) {
  return p.nonClipHeading && "\n     ".concat(TextStyles_style/* H5TagStyle */.Wl, " {\n        white-space: unset;\n        overflow: auto;\n        width: 100%;\n        span {\n            overflow: auto;\n            white-space: unset;\n            max-width: 100%;\n        }\n    }\n    ");
}, static_utils/* deviceType.mobile */.vO.mobile);
var RegionModalDweb_style_CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CrossIconWrap",
  componentId: "c6vrw8-2"
})(["flex-shrink:0;cursor:pointer;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.tsx






var RegionModalDweb = function RegionModalDweb(_ref) {
  var children = _ref.children,
      customTitle = _ref.customTitle,
      customWidth = _ref.customWidth,
      nonClipHeading = _ref.nonClipHeading,
      handleClick = _ref.handleClick;
  (0,react.useEffect)(function () {
    var parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return function () {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(function () {
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_ReactPortalComp, {
    "data-test-id": "RegionModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(RegionModalDweb_style_CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "RegionModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_style_CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionModalDweb-CommonModalHeader",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
            "data-test-id": "RegionModalDweb-H5Tag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: "28px",
              height: "28px",
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg",
              "data-test-id": "RegionModalDweb-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_style_CrossIconWrap, {
              onClick: handleClick,
              "data-test-id": "RegionModalDweb-CrossIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                width: "28px",
                height: "28px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
                "data-test-id": "RegionModalDweb-ImageComponent"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: "xlarge",
            fontWeight: "black",
            "data-test-id": "RegionModalDweb-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: customTitle,
              "data-test-id": "RegionModalDweb-FormattedText"
            })
          })]
        })
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BackDropComp_BackDropComp, {
      onClose: handleClick,
      "data-test-id": "RegionModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ var RegionModalDweb_RegionModalDweb = (RegionModalDweb);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.style.tsx

var PopularDescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DescriptionModalstyle__PopularDescriptionWrap",
  componentId: "sc-7zo3r7-0"
})(["border-radius:4px;padding:12px;background-color:#f6f6f6;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.tsx







var DescriptionModal = function DescriptionModal(_ref) {
  var handleDescriptionModal = _ref.handleDescriptionModal,
      value = _ref.value,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb_RegionModalDweb, {
    handleClick: handleDescriptionModal,
    customTitle: title,
    "data-test-id": "DescriptionModal-RegionModalDweb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularDescriptionWrap, {
      "data-test-id": "DescriptionModal-PopularDescriptionWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: "Countries Covered: ",
        baseStyle: {
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "xs"
        },
        "data-test-id": "DescriptionModal-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: value,
        "data-test-id": "DescriptionModal-FormattedText"
      })]
    })
  });
};

/* harmony default export */ var DescriptionModal_DescriptionModal = (DescriptionModal);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravelDetails.style.ts






var TravelDetailsStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelDetailsStyle",
  componentId: "sc-4x930j-0"
})(["background:#ffffff;padding:30px;"]);
var TravellingToStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyle",
  componentId: "sc-4x930j-1"
})(["background:#ffffff;padding:30px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;position:relative;", "{padding:5px;margin:-5px;}@media ", "{padding:16px;margin-bottom:36px;}"], TagsStyle, static_utils/* deviceType.mobile */.vO.mobile);
var PopularCountry = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountry",
  componentId: "sc-4x930j-2"
})(["display:flex;flex-wrap:wrap;gap:8px;label{left:0 !important;position:absolute;bottom:8px;z-index:1;}@media ", "{margin-bottom:16px;display:grid;grid-template-columns:repeat(3,1fr);grid-gap:14px;width:calc(100vw - 64px);min-height:178px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var PopularCountryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__PopularCountryItem",
  componentId: "sc-4x930j-3"
})(["background:linear-gradient(228.82deg,#43c6ac 2.05%,#191654 93.35%);border:1px solid #fff;border-radius:6px;z-index:1;padding:8px;overflow:hidden;width:80px;height:82px;position:relative;flex-shrink:0;cursor:pointer;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);", " > div{cursor:pointer;}picture{height:82px;}@media ", "{width:unset;height:82px;picture{height:82px;}}"], function (p) {
  return p.listSelected && "\n        border: 1px solid #008cff;\n        ";
}, static_utils/* deviceType.mobile */.vO.mobile);
var OtherCountyBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__OtherCountyBtn",
  componentId: "sc-4x930j-4"
})(["display:flex;box-shadow:0px 2px 7px 0px rgba(0,0,0,0.24);flex-direction:column;gap:8px;width:80px;height:82px;background:#fff;border-radius:6px;padding:8px;cursor:pointer;@media ", "{width:unset;height:82px;gap:6px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var CountryImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__CountryImg",
  componentId: "sc-4x930j-5"
})(["position:absolute;top:0px;left:0px;bottom:0;z-index:-1;max-width:100%;max-height:100%;width:100%;picture{width:100%;}picture img{width:80px;height:80px;}:after{content:\"\";position:absolute;border-radius:0px 0px 6px 6px;background:linear-gradient( 180deg,rgba(106,106,106,0) 0%,rgba(0,0,0,0.7) 100% );width:100%;height:32px;bottom:1px;left:0;}@media ", "{picture img{width:100%;height:82px;}}"], static_utils/* deviceType.mobile */.vO.mobile);
var TravelNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravelNote",
  componentId: "sc-4x930j-6"
})(["background:linear-gradient( 85.23deg,rgba(67,225,168,0.5) 0%,rgba(33,147,147,0.5) 100% );border-radius:8px 8px 0px 0px;padding:8px 78px;margin:0 auto;color:#fff;font-size:16px;width:550px;text-align:center;em{font-weight:600;color:#8beecd;font-style:normal;}@media ", "{width:92%;padding:12px;font-size:12px;text-align:center;padding-bottom:24px;margin-bottom:-12px;}@media ", "{", "}"], static_utils/* deviceType.mobile */.vO.mobile, static_utils/* deviceType.desktop */.vO.desktop, function (p) {
  return p.pageTheme === src.PARTNER.MMT ? "\n        background: linear-gradient(45deg, #43E1A8 0%, #219393 100%);\n    " : p.pageTheme === src.PARTNER.GI ? "background: #18A160;" : "";
});
var DiscountingNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__DiscountingNote",
  componentId: "sc-4x930j-7"
})(["border-radius:8px 8px 0px 0px;padding:8px 0px 8px 16px;margin:0 auto;color:", ";width:550px;display:flex;align-items:center;@media ", "{width:92%;padding:12px;padding-bottom:24px;margin-bottom:-12px;background:#e4fbf4;}@media ", "{background:#e4fbf4;}"], Global/* theme.greyText5 */.rS.greyText5, static_utils/* deviceType.mobile */.vO.mobile, static_utils/* deviceType.desktop */.vO.desktop);
var TravellingToStyleWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TravellingToStyleWrap",
  componentId: "sc-4x930j-8"
})([""]);
var UpcomingTripStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripStyle",
  componentId: "sc-4x930j-9"
})(["display:flex;align-items:center;justify-content:space-between;background:#ffffff;border-radius:6px;padding:24px 12px 12px;margin-bottom:16px;position:relative;cursor:pointer;", " ", "{width:24px;height:24px;}&::before{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;border:1px solid transparent;background:", ";-webkit-mask:linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border-radius:6px;}"], function (p) {
  return p.selected && "\n    background: #EAF5FF;\n    border: 1px solid #008CFF;\n  ";
}, TextStyles_style/* AnchorTagStyle */.C2, Global/* theme.purpleGradient */.rS.purpleGradient);
var UpcomingTripTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__UpcomingTripTag",
  componentId: "sc-4x930j-10"
})(["background:", ";padding:2px 6px;border-radius:6px 0px 6px 0px;width:fit-content;position:absolute;top:0;left:0;display:flex;"], Global/* theme.purpleGradient */.rS.purpleGradient);
var BgText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TravelDetailsstyle__BgText",
  componentId: "sc-4x930j-11"
})(["background:radial-gradient( 59.37% 231.91% at 3.11% 23.44%,rgba(255,255,255,0.24) 0%,rgba(255,255,255,0.144) 100% );-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-style:normal;font-weight:700;font-size:56px;line-height:64px;position:absolute;top:-59px;right:6px;"]);
var TripUpcoming = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__TripUpcoming",
  componentId: "sc-4x930j-12"
})(["background:linear-gradient( 91.22deg,#9c005e 1.88%,rgba(22,20,60,0.2) 100% );padding:2px 8px;color:#fff;position:absolute;bottom:24px;left:-10px;white-space:nowrap;width:100%;font-weight:400;font-size:9px;line-height:11px;text-transform:uppercase;text-wrap:wrap;"]);
var CountryNameTxt = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TravelDetailsstyle__CountryNameTxt",
  componentId: "sc-4x930j-13"
})(["display:-webkit-box;color:#ffffff;font-size:12px;-webkit-line-clamp:2;font-weight:700;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;white-space:normal;width:75%;text-shadow:0px 0px 8px rgba(0,0,0,0.8);"]);
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelDetailsstyle__ButtonWrapper",
  componentId: "sc-4x930j-14"
})(["position:fixed;bottom:0;background:#fff;padding:16px;left:0;right:0;width:100%;z-index:1;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/PopularCountryCompV2.tsx









var PopularCountryComp = function PopularCountryComp(_ref) {
  var popCountry = _ref.popCountry,
      handleShowOtherCountry = _ref.handleShowOtherCountry,
      otherCountryTxt = _ref.otherCountryTxt,
      handlePopularCountrySelect = _ref.handlePopularCountrySelect,
      setIsSelectedError = _ref.setIsSelectedError,
      setCountrySelectToastMsg = _ref.setCountrySelectToastMsg;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var isCheckedHandler = (0,react.useCallback)(function (data) {
    return data === null || data === void 0 ? void 0 : data.isSelected;
  }, [popCountry]);
  var handleErrorToast = (0,utils/* debounce */.Ds)(function () {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  var handleCountrySelect = function handleCountrySelect(item) {
    if (item.isDisabled) {
      var isExclusiveCountrySelected = popCountry === null || popCountry === void 0 ? void 0 : popCountry.find(function (item) {
        return item.isExclusiveSelection && item.isSelected;
      });

      if (isExclusiveCountrySelected && !(item !== null && item !== void 0 && item.isExclusiveSelection) && item.isDisabled) {
        setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
        handleErrorToast();
      } else if (item !== null && item !== void 0 && item.isExclusiveSelection && !isExclusiveCountrySelected && item.isDisabled) {
        setCountrySelectToastMsg("India cannot be chosen for International Travel");
        handleErrorToast();
      } else if (item.isDisabled) {
        setIsSelectedError(true);
        handleErrorToast();
      }
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularCountry, {
    "data-test-id": "PopularCountryComp-PopularCountry",
    children: [popCountry && popCountry.slice(0, 5).map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularCountryItem, {
        listSelected: isCheckedHandler(item),
        onClick: function onClick() {
          return handleCountrySelect(item);
        },
        "data-test-id": `PopularCountryComp-PopularCountryItem-${index}`,
        children: [index !== popCountry.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckButton_CheckButton, {
          isDisabled: item.isDisabled,
          isChecked: item.isDisabled ? true : isCheckedHandler(item),
          "data-test-id": "PopularCountryComp-CheckButton",
          children: [!item.img && item.name && /*#__PURE__*/(0,jsx_runtime.jsx)(BgText, {
            "data-test-id": "PopularCountryComp-BgText",
            children: item === null || item === void 0 ? void 0 : item.code
          }), item.upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TripUpcoming, {
            "data-test-id": "PopularCountryComp-TripUpcoming",
            children: "TRIP UPCOMING"
          }), (item === null || item === void 0 ? void 0 : item.name) && !item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryNameTxt, {
            title: item.name,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: item === null || item === void 0 ? void 0 : item.name
          }), (item === null || item === void 0 ? void 0 : item.name) && item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryNameTxt, {
            title: item.name + item.subtitle,
            "data-test-id": "PopularCountryComp-CountryNameTxt",
            children: (item === null || item === void 0 ? void 0 : item.name) + " " + item.subtitle
          })]
        }), (item === null || item === void 0 ? void 0 : item.img) && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryImg, {
          "data-test-id": "PopularCountryComp-CountryImg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: device == "sm" ? "100%" : "80px",
            height: device == "lg" ? "80px" : "82px",
            src: item.img,
            loading: "eager",
            "data-test-id": "PopularCountryComp-ImageComponent"
          })
        })]
      }, index);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OtherCountyBtn, {
      onClick: handleShowOtherCountry,
      "data-test-id": "PopularCountryComp-OtherCountyBtn",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
        loading: "eager",
        "data-test-id": "PopularCountryComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.blueText */.rS.blueText,
        "data-test-id": "PopularCountryComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: otherCountryTxt,
          "data-test-id": "PopularCountryComp-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ var PopularCountryCompV2 = (PopularCountryComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/UpcomingTrips.tsx









var UpcomingTrips_analytics = (0,insurance/* getAnalytics */.I)();

var UpcomingTrips = function UpcomingTrips(_ref) {
  var country = _ref.country,
      travelDuration = _ref.travelDuration,
      travellerNum = _ref.travellerNum,
      travellerTitle = _ref.travellerTitle,
      handleUpcomingTripClick = _ref.handleUpcomingTripClick;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var _useState = (0,react.useState)(false),
      isUpcomingTripSelected = _useState[0],
      setIsUpcomingTripSelected = _useState[1];

  (0,react.useEffect)(function () {
    var queryParams = new URLSearchParams(window.location.search);
    var isUpcomingTrip = queryParams.get("isUpcomingTrip");

    if (isUpcomingTrip) {
      setIsUpcomingTripSelected(true);
    }

    UpcomingTrips_analytics === null || UpcomingTrips_analytics === void 0 ? void 0 : UpcomingTrips_analytics.trackLandingEvents({
      actionType: "upcoming_trips_shown"
    });
  }, []);

  var showFormattedDate = function showFormattedDate(date) {
    if (date) {
      var dateValue = (0,static_utils/* convertUnixToDate */.P9)(date);
      return (0,static_utils/* formatDate */.p6)(dateValue, static_utils/* DATE_FORMATS.DD MMM YY */.lv["DD MMM YY"]);
    }

    return "";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(UpcomingTripStyle, {
    selected: isUpcomingTripSelected,
    onClick: handleUpcomingTripClick,
    "data-test-id": "UpcomingTrips-UpcomingTripStyle",
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(UpcomingTripTag, {
      "data-test-id": "UpcomingTrips-UpcomingTripTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "xxs",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: "UPCOMING TRIP"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      flexDirection: "column",
      "data-test-id": "UpcomingTrips-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
        fontWeight: "bold",
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: country,
          "data-test-id": "UpcomingTrips-FormattedText"
        }), "\xA0"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
        fontSize: "xs",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "UpcomingTrips-SpanTag",
        children: [" ".concat(showFormattedDate(travelDuration === null || travelDuration === void 0 ? void 0 : travelDuration.startDate), " - ").concat(showFormattedDate(travelDuration === null || travelDuration === void 0 ? void 0 : travelDuration.endDate)), " ", "| ", travellerNum, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travellerTitle,
          "data-test-id": "UpcomingTrips-FormattedText"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
      "data-test-id": "UpcomingTrips-AnchorTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag_ImageTag, {
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
        width: "16px",
        height: "16px",
        "data-test-id": "UpcomingTrips-ImageTag"
      })
    })]
  });
};

/* harmony default export */ var TravelDetails_UpcomingTrips = (UpcomingTrips);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingTo.tsx





function TravellingTo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravellingTo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravellingTo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravellingTo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var TravellingTo_analytics = (0,insurance/* getAnalytics */.I)();

var TravellingTo = function TravellingTo(_ref) {
  var _upcomingTrip$travelD, _upcomingTrip$travelD2, _isExclusiveCountrySe, _travellerInfoSection, _travelSearchForm$seg6, _travelSearchForm$seg7, _segmentSelected$moda, _segmentSelected$moda2, _segmentSelected$moda3, _segmentSelected$moda4, _segmentSelected$moda5;

  var travellingToSection = _ref.travellingToSection,
      upcomingTrip = _ref.upcomingTrip,
      calendarDatesLimit = _ref.calendarDatesLimit,
      travelSearchBanner = _ref.travelSearchBanner,
      _ref$btnDisabledState = _ref.btnDisabledState,
      btnDisabledState = _ref$btnDisabledState === void 0 ? true : _ref$btnDisabledState,
      nextPageRoute = _ref.nextPageRoute;
  var buttonRef = (0,react.useRef)(null);
  var travellingToRef = (0,react.useRef)(null);
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();

  var _ref2 = travellingToSection || {},
      otherCountryTxt = _ref2.otherCountryTxt,
      travelNote = _ref2.travelNote,
      travDateTitle = _ref2.travDateTitle,
      travCountTitle = _ref2.travCountTitle,
      travPurpTitle = _ref2.travPurpTitle,
      travelPurposeTxt = _ref2.travelPurposeTxt,
      popularCountryTxt = _ref2.popularCountryTxt,
      travelBtnTxt = _ref2.travelBtnTxt,
      travelSearchForm = _ref2.travelSearchForm,
      travellerInfoSection = _ref2.travellerInfoSection;

  var _travelSearchForm$reg = travelSearchForm.regionCountryList,
      label = _travelSearchForm$reg.label,
      error_message = _travelSearchForm$reg.error_message,
      countrySelectErrMsg = _travelSearchForm$reg.countrySelectErrMsg,
      placeHolder = _travelSearchForm$reg.placeHolder,
      value = _travelSearchForm$reg.value;

  var _useState = (0,react.useState)([]),
      popularCountries = _useState[0],
      setPopularCountries = _useState[1];

  var _useState2 = (0,react.useState)([]),
      countryData = _useState2[0],
      setCountryData = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showOtherCountry = _useState3[0],
      setOtherCountry = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      countValue = _useState4[0],
      setCountValue = _useState4[1];

  var _useState5 = (0,react.useState)(),
      calenderValue = _useState5[0],
      setCalenderValue = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      showCountry = _useState6[0],
      setShowCountry = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isCountryError = _useState7[0],
      setIsCountryError = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      descriptionTxt = _useState8[0],
      setDescriptionTxt = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isSelectedError = _useState9[0],
      setIsSelectedError = _useState9[1];

  var _useState10 = (0,react.useState)(""),
      descTitle = _useState10[0],
      setDescTitle = _useState10[1];

  var _useState11 = (0,react.useState)([]),
      segments = _useState11[0],
      setSegments = _useState11[1];

  var _useState12 = (0,react.useState)({}),
      segmentSelected = _useState12[0],
      setSegmentSelected = _useState12[1];

  var _useState13 = (0,react.useState)([]),
      travAgeRange = _useState13[0],
      setTravAgeRange = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      isSegmentModalShown = _useState14[0],
      setIsSegmentModalShown = _useState14[1];

  var _useState15 = (0,react.useState)(""),
      countrySelectToastMsg = _useState15[0],
      setCountrySelectToastMsg = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      isAgeRangeSelectedError = _useState16[0],
      setIsAgeRangeSelectedError = _useState16[1];

  var _useState17 = (0,react.useState)(),
      nextPageError = _useState17[0],
      setNextPageError = _useState17[1]; //set the default selected segement


  (0,react.useEffect)(function () {
    var _travelSearchForm$seg;

    var queryParams = new URLSearchParams(window.location.search);
    var segParam = queryParams.get("segment");
    var segments = travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg = travelSearchForm.segments) === null || _travelSearchForm$seg === void 0 ? void 0 : _travelSearchForm$seg.value;

    if (segments) {
      var segment = segments.find(function (item) {
        return item.id === segParam || !segParam && item.isSelected;
      });

      if (segment) {
        setSegmentSelected(segment);
        (0,utils/* replaceHistory */.df)("segment", segment.id);
      }
    }
  }, []); //set the travelSerachForm.segments to segments

  (0,react.useEffect)(function () {
    var _travelSearchForm$seg2;

    var queryParams = new URLSearchParams(window.location.search);
    var segParam = queryParams.get("segment");

    if (travelSearchForm !== null && travelSearchForm !== void 0 && (_travelSearchForm$seg2 = travelSearchForm.segments) !== null && _travelSearchForm$seg2 !== void 0 && _travelSearchForm$seg2.value) {
      if (segParam) {
        handleSegementSelect(segParam);
      } else {
        var _travelSearchForm$seg3;

        setSegments(travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg3 = travelSearchForm.segments) === null || _travelSearchForm$seg3 === void 0 ? void 0 : _travelSearchForm$seg3.value);
      }
    }
  }, [travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.segments]);
  (0,react.useEffect)(function () {
    travelSearchForm.segments && (TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
      actionType: "special_segments_shown"
    }));
  }, [travelSearchForm.segments]);
  (0,react.useEffect)(function () {
    var queryParams = new URLSearchParams(window.location.search);
    var selectedCountries = queryParams.get("countries");
    var selectedCountryCodes;

    if (selectedCountries) {
      selectedCountryCodes = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.split(",");
    } else if (upcomingTrip !== null && upcomingTrip !== void 0 && upcomingTrip.countryCode) {
      selectedCountryCodes = upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode;
      (0,utils/* replaceHistory */.df)("countries", upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode);
    }

    var totalCountryData = value.map(function (data) {
      var _selectedCountryCodes;

      if ((_selectedCountryCodes = selectedCountryCodes) !== null && _selectedCountryCodes !== void 0 && _selectedCountryCodes.includes(data.code)) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return TravellingTo_objectSpread({}, data);
    });
    var isExclusiveCountrySelected = totalCountryData.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    totalCountryData = totalCountryData.map(function (country) {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread({}, country) : TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (totalCountryData.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      }

      return TravellingTo_objectSpread({}, country);
    });
    var selectedRegionCodes = totalCountryData.filter(function (data) {
      return data.isSelected && data.type === "REGION";
    }).map(function (data) {
      return data.code;
    });
    selectedRegionCodes.map(function (code) {
      totalCountryData = totalCountryData.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(code)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    setCountryData(totalCountryData);
    var popularCountryData = totalCountryData.filter(function (country) {
      return country.isSelected || country.isPopular;
    });
    popularCountryData = [].concat(_toConsumableArray(popularCountryData.filter(function (country) {
      return country.isSelected && !country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return country.isDisabled;
    })), _toConsumableArray(popularCountryData.filter(function (country) {
      return !country.isSelected && !country.isDisabled;
    })));
    setShowCountry(_toConsumableArray(popularCountryData));
    setPopularCountries(_toConsumableArray(popularCountryData));
  }, [value, upcomingTrip, travelSearchForm.segments]);
  (0,react.useEffect)(function () {
    var button = buttonRef.current;
    var viewportMargin = 16;
    var searchBarOffset = 60;

    if (button) {
      var rect = button.getBoundingClientRect();
      var offsetTop = window.scrollY + rect.top;
      var isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        var scrollPosition = offsetTop - window.innerHeight + rect.height + viewportMargin + searchBarOffset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    }
  }, [showCountry]);

  var populateTravelDetails = function populateTravelDetails(countryCodes, startDate, endDate, travellers) {
    if (countryCodes) {
      (0,utils/* replaceHistory */.df)("countries", countryCodes);
    }

    if (startDate) {
      (0,utils/* replaceHistory */.df)("startDate", startDate);
    }

    if (endDate) {
      (0,utils/* replaceHistory */.df)("endDate", endDate);
    }

    if (travellers) {
      (0,utils/* replaceHistory */.df)("travellers", travellers);
    }
  };

  var handleUpcomingTripClick = function handleUpcomingTripClick() {
    var _travelDuration$start, _travelDuration$endDa;

    (0,utils/* replaceHistory */.df)("isUpcomingTrip", "true");
    (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
    TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
      actionType: "upcoming_trips_clicked"
    });

    var _ref3 = upcomingTrip || {},
        countryCode = _ref3.countryCode,
        travelDuration = _ref3.travelDuration,
        travellerNum = _ref3.travellerNum;

    var selectedCountry = countryData === null || countryData === void 0 ? void 0 : countryData.find(function (country) {
      return country.code === countryCode;
    });
    populateTravelDetails(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code, travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$start = travelDuration.startDate) === null || _travelDuration$start === void 0 ? void 0 : _travelDuration$start.toString(), travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$endDa = travelDuration.endDate) === null || _travelDuration$endDa === void 0 ? void 0 : _travelDuration$endDa.toString(), travellerNum === null || travellerNum === void 0 ? void 0 : travellerNum.toString());

    if (nextPageRoute) {
      navigation/* navigationActions.navigateToPageByRouteName */.e.navigateToPageByRouteName("".concat(nextPageRoute, "&isUpcomingTrip=true"));
    } else {
      var _travelDuration$start2, _travelDuration$endDa2, _travellerNum$toStrin;

      var data = {
        startDate: travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$start2 = travelDuration.startDate) === null || _travelDuration$start2 === void 0 ? void 0 : _travelDuration$start2.toString(),
        endDate: travelDuration === null || travelDuration === void 0 ? void 0 : (_travelDuration$endDa2 = travelDuration.endDate) === null || _travelDuration$endDa2 === void 0 ? void 0 : _travelDuration$endDa2.toString(),
        travellers: travellerNum === null || travellerNum === void 0 ? void 0 : (_travellerNum$toStrin = travellerNum.toString) === null || _travellerNum$toStrin === void 0 ? void 0 : _travellerNum$toStrin.call(travellerNum),
        countries: [countryCode],
        isUpcomingTrip: true
      };
      navigation/* navigationActions.navigateToListing */.e.navigateToListing(data);
    }
  };

  var handleShowOtherCountry = function handleShowOtherCountry() {
    if (!showOtherCountry) {
      var countryDataArr = countryData === null || countryData === void 0 ? void 0 : countryData.map(function (country) {
        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: false
        });
      });
      popularCountries.map(function (data) {
        var _countryDataArr;

        countryDataArr = (_countryDataArr = countryDataArr) === null || _countryDataArr === void 0 ? void 0 : _countryDataArr.map(function (country) {
          if (country.code === data.code) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isSelected: data.isSelected
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });

      var _isExclusiveCountrySelected = countryDataArr.find(function (item) {
        return item.isExclusiveSelection && item.isSelected;
      });

      countryDataArr = countryDataArr.map(function (country) {
        if (_isExclusiveCountrySelected) {
          return country.isExclusiveSelection ? TravellingTo_objectSpread({}, country) : TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isSelected: false,
            isDisabled: true
          });
        } else if (countryDataArr.some(function (item) {
          return item.isSelected;
        })) {
          return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          }) : TravellingTo_objectSpread({}, country);
        }

        return TravellingTo_objectSpread({}, country);
      });
      var selectedRegionCodes = countryDataArr.filter(function (data) {
        return data.isSelected && data.type === "REGION";
      }).map(function (data) {
        return data.code;
      });
      selectedRegionCodes.map(function (code) {
        countryDataArr = countryDataArr.map(function (country) {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return TravellingTo_objectSpread({}, country);
        });
      });
      setCountryData(countryDataArr);
    }

    setOtherCountry(!showOtherCountry);
  };

  var handleDescriptionModal = function handleDescriptionModal(country) {
    var clickedTime = (0,utility_src/* getSessionStorageItem */.St)("clickedTime") ? (0,utility_src/* getSessionStorageItem */.St)("clickedTime") : {};
    var currentTime = new Date().getTime();
    var code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      (0,utility_src/* setSessionStorageItem */.D9)("clickedTime", TravellingTo_objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  var handlePopularCountrySelect = function handlePopularCountrySelect(code) {
    setIsCountryError(false);
    var popularCountryArr = popularCountries === null || popularCountries === void 0 ? void 0 : popularCountries.map(function (country) {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return TravellingTo_objectSpread({}, country);
        }

        if (country.type === "REGION") {
          setDescriptionTxt(handleDescriptionModal(country));
          setDescTitle(country.descTitle);
        }

        return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    var isExclusiveCountrySelected = popularCountryArr.find(function (item) {
      return item.isExclusiveSelection && item.isSelected;
    });
    popularCountryArr = popularCountryArr.map(function (country) {
      if (isExclusiveCountrySelected) {
        return !country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      } else if (popularCountryArr.some(function (item) {
        return item.isSelected;
      })) {
        return country.isExclusiveSelection ? TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
          isDisabled: true
        }) : TravellingTo_objectSpread({}, country);
      }

      return TravellingTo_objectSpread({}, country);
    });
    var selectedPopRegionCodes = popularCountryArr.filter(function (country) {
      return country.isSelected && country.type === "REGION";
    }).map(function (country) {
      return country.code;
    });
    selectedPopRegionCodes.map(function (item) {
      popularCountryArr = popularCountryArr.map(function (country) {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return TravellingTo_objectSpread(TravellingTo_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return TravellingTo_objectSpread({}, country);
      });
    });
    setPopularCountries(popularCountryArr);
    setShowCountry(popularCountryArr);
    var countries = popularCountryArr.filter(function (data) {
      return data.isSelected && !data.isDisabled;
    }).map(function (data) {
      return data.code;
    }).join(",");

    if (countries) {
      (0,utils/* replaceHistory */.df)("countries", countries);
    } else {
      (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    }
  };

  var handleSegementSelect = function handleSegementSelect(segmentId) {
    var _travelSearchForm$seg4;

    if (travelSearchForm !== null && travelSearchForm !== void 0 && (_travelSearchForm$seg4 = travelSearchForm.segments) !== null && _travelSearchForm$seg4 !== void 0 && _travelSearchForm$seg4.value) {
      var _travelSearchForm$seg5;

      var updatedData = travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg5 = travelSearchForm.segments) === null || _travelSearchForm$seg5 === void 0 ? void 0 : _travelSearchForm$seg5.value.map(function (item) {
        if (item.id == segmentId) {
          item.isSelected = true;
          setSegmentSelected(item);
          (0,utils/* replaceHistory */.df)("segment", item.id);
          TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
            actionType: item.config.clickEventName
          });
        } else {
          item.isSelected = false;
        }

        return item;
      });
      setSegments(updatedData);
    }
  };

  var toastTimeout = null;

  var toggleSegmentModal = function toggleSegmentModal() {
    var searchParams = new URLSearchParams(window.location.search);
    var countries = searchParams.get("countries");
    var countryCodes = countries === null || countries === void 0 ? void 0 : countries.split(",");

    if (!countryCodes) {
      setIsCountryError(true);
    } else if (countryCodes[0] == "IN" && (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id) === "STUDENT") {
      setCountrySelectToastMsg("We do not have domestic student plans, please select another country to see student plans");
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(function () {
        setCountrySelectToastMsg("");
      }, 2000);
    } else {
      (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.modal) && setIsSegmentModalShown(true);
    }
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var searchParams, countries, isUpcomingTrip, countryCodes, retailAgeError, selectedPopCountries, queryParams, params, partner, requestData, response, responseStatus, nextPageRouteConfig, _err$response, _ref5, error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              searchParams = new URLSearchParams(window.location.search);
              countries = searchParams.get("countries");
              isUpcomingTrip = searchParams.get("isUpcomingTrip");
              countryCodes = countries === null || countries === void 0 ? void 0 : countries.split(",");
              retailAgeError = false;

              if (travellerInfoSection) {
                travAgeRange === null || travAgeRange === void 0 ? void 0 : travAgeRange.forEach(function (item) {
                  if (!item.value || item.value.length !== 2) {
                    setIsAgeRangeSelectedError(true);
                    retailAgeError = true;
                    return;
                  }
                });
              }

              if (!countryCodes) {
                setIsCountryError(true);
                TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
                  actionType: "error_shown",
                  payload: error_message
                });
              }

              if (isUpcomingTrip) {
                (0,utils/* replaceHistoryRemoveParams */._A)("isUpcomingTrip");
                searchParams.delete("isUpcomingTrip");
                (0,utility_src/* removeSessionStorageItem */.lD)(src.STORAGE_KEYS.TRAVELLER_DETAILS);
              }

              (0,utils/* replaceHistory */.df)("segment", segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id);

              if (!(calenderValue && countValue && countryCodes !== null && countryCodes !== void 0 && countryCodes.length && !retailAgeError)) {
                _context.next = 30;
                break;
              }

              selectedPopCountries = (popularCountries !== null && popularCountries !== void 0 ? popularCountries : []).filter(function (country) {
                return countryCodes === null || countryCodes === void 0 ? void 0 : countryCodes.includes(country.code);
              }).map(function (item) {
                return item.name;
              }).join("|");
              TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
                actionType: "popular_country_selected",
                payload: selectedPopCountries
              });
              queryParams = Object.fromEntries(searchParams.entries());
              params = TravellingTo_objectSpread(TravellingTo_objectSpread({}, queryParams), {}, {
                startDate: (0,static_utils/* convertDateToUnix */.cJ)(calenderValue.from).toString(),
                endDate: calenderValue.to ? (0,static_utils/* convertDateToUnix */.cJ)(calenderValue.to).toString() : searchParams.get("endDate"),
                travellers: countValue,
                countries: countryCodes,
                segment: segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id
              });
              TravellingTo_analytics === null || TravellingTo_analytics === void 0 ? void 0 : TravellingTo_analytics.trackLandingEvents({
                actionType: "explore_plan_click"
              });
              partner = (0,utils/* getPartnerOnClientSide */.et)();
              requestData = {
                partner: partner,
                userSearchIntent: {
                  country: countryCodes,
                  departureDateTime: (0,static_utils/* convertDateToUnix */.cJ)(calenderValue.from),
                  arrivalDateTime: calenderValue.to ? (0,static_utils/* convertDateToUnix */.cJ)(calenderValue.to) : Number(searchParams.get("endDate")),
                  numberOfTravellers: countValue,
                  segment: segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.id,
                  travellersData: travAgeRange === null || travAgeRange === void 0 ? void 0 : travAgeRange.map(function (item) {
                    var _item$value, _item$value2;

                    return {
                      travellerAgeRange: {
                        min: item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value[0],
                        max: item === null || item === void 0 ? void 0 : (_item$value2 = item.value) === null || _item$value2 === void 0 ? void 0 : _item$value2[1]
                      }
                    };
                  })
                }
              };
              _context.prev = 17;
              _context.next = 20;
              return (0,api/* getNextPageRouteDetails */.$P)(requestData);

            case 20:
              response = _context.sent;
              responseStatus = response.responseStatus, nextPageRouteConfig = response.nextPageRouteConfig;

              if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
                if ((nextPageRouteConfig === null || nextPageRouteConfig === void 0 ? void 0 : nextPageRouteConfig.type) === "external_link") {
                  window.open(nextPageRouteConfig === null || nextPageRouteConfig === void 0 ? void 0 : nextPageRouteConfig.route, "_blank");
                } else {
                  navigation/* navigationActions.navigateToPageByRouteName */.e.navigateToPageByRouteName("".concat(nextPageRouteConfig === null || nextPageRouteConfig === void 0 ? void 0 : nextPageRouteConfig.route));
                }
              }

              _context.next = 30;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](17);
              console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
                err: _context.t0
              });
              _ref5 = (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data) || {}, error = _ref5.error;
              setNextPageError(error);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 25]]);
    }));

    return function onSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();

  if (nextPageError && true) {
    throw new utility_src/* ClientError */.XF(nextPageError);
  }

  var isExclusiveCountrySelected = popularCountries.find(function (item) {
    return item.isExclusiveSelection && item.isSelected;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToStyleWrap, {
    "data-test-id": "TravellingTo-TravellingToStyleWrap",
    children: [travelSearchBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DiscountingNote, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-DiscountingNote",
      children: [(travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        width: "24px",
        height: "24px",
        src: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.icon,
        style: {
          animation: "rotate 2s linear infinite"
        },
        loading: "eager"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: device === "sm" ? "column" : "row",
        margin: "0px 0px 0px 4px",
        gap: device === "lg" ? "4px" : "0px",
        "data-test-id": "TravellingTo-FlexComp",
        children: [(travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.title,
          baseStyle: {
            fontWeight: "bold",
            fontSize: device === "lg" ? "16px" : "12px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        }), (travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travelSearchBanner === null || travelSearchBanner === void 0 ? void 0 : travelSearchBanner.description,
          baseStyle: {
            fontWeight: "regular",
            fontSize: device === "lg" ? "14px" : "12px",
            marginTop: device === "lg" ? "2px" : "0px",
            color: Global/* theme.greenText5 */.rS.greenText5
          },
          "data-test-id": "TravellingTo-FormattedText"
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravelNote, {
      pageTheme: context ? context : "mmt",
      "data-test-id": "TravellingTo-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
        value: travelNote,
        "data-test-id": "TravellingTo-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToStyle, {
      ref: travellingToRef,
      "data-test-id": "TravellingTo-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "TravellingTo-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: label,
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        margin: "0px 0px 20px 0px",
        "data-test-id": "TravellingTo-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: placeHolder,
          baseStyle: {
            color: "#717171"
          },
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), upcomingTrip && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetails_UpcomingTrips, {
        country: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.country,
        countryCode: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.countryCode,
        travelDuration: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travelDuration,
        travellerNum: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerNum,
        travellerTitle: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerTitle,
        handleUpcomingTripClick: handleUpcomingTripClick,
        "data-test-id": "TravellingTo-UpcomingTrips"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.greyText7 */.rS.greyText7,
        fontWeight: "bold",
        fontSize: "xs",
        margin: "2px 0 8px",
        "data-test-id": "TravellingTo-SpanTag",
        children: popularCountryTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: "Popular Destination",
          "data-test-id": "TravellingTo-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PopularCountryCompV2, {
        otherCountryTxt: otherCountryTxt,
        handleShowOtherCountry: handleShowOtherCountry,
        popCountry: showCountry,
        setIsSelectedError: setIsSelectedError,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        handlePopularCountrySelect: handlePopularCountrySelect,
        "data-test-id": "TravellingTo-PopularCountryComp"
      }), isCountryError && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        color: Global/* theme.redText2 */.rS.redText2,
        fontSize: "xs",
        margin: device === "sm" ? "0 0 8px" : "8px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: error_message
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
        margin: "14px -30px 14px",
        backgroundColor: "#FFFFFF",
        xs: true,
        "data-test-id": "TravellingTo-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidget, {
        travellerInfoSection: travellerInfoSection,
        travelPurposeTxt: travelPurposeTxt,
        travCountTitle: travCountTitle,
        travPurpTitle: travPurpTitle,
        travDateTitle: travDateTitle,
        btnDisabledState: btnDisabledState,
        countValue: countValue,
        setCountValue: setCountValue,
        travAgeRange: travAgeRange,
        setTravAgeRange: setTravAgeRange,
        calendarDatesLimit: calendarDatesLimit,
        setCalenderValue: setCalenderValue,
        setIsAgeRangeSelectedError: setIsAgeRangeSelectedError,
        upcomingTravellerNum: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : upcomingTrip.travellerNum,
        upcomingFromDate: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : (_upcomingTrip$travelD = upcomingTrip.travelDuration) === null || _upcomingTrip$travelD === void 0 ? void 0 : _upcomingTrip$travelD.startDate,
        upcomingToDate: upcomingTrip === null || upcomingTrip === void 0 ? void 0 : (_upcomingTrip$travelD2 = upcomingTrip.travelDuration) === null || _upcomingTrip$travelD2 === void 0 ? void 0 : _upcomingTrip$travelD2.endDate,
        calendarConfig: (isExclusiveCountrySelected === null || isExclusiveCountrySelected === void 0 ? void 0 : (_isExclusiveCountrySe = isExclusiveCountrySelected.config) === null || _isExclusiveCountrySe === void 0 ? void 0 : _isExclusiveCountrySe.calendar) || (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.config) || calendarDatesLimit,
        travellingToRef: travellingToRef,
        "data-test-id": "TravellingTo-TravellingToWidget"
      }), travellerInfoSection && isAgeRangeSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        justifyContent: device === "sm" ? "flex-start" : "right",
        margin: "-22px 0px 24px 0px",
        "data-test-id": "TravellingTo-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          color: "#EB2026",
          "data-test-id": "TravellingTo-SpanTag",
          children: (_travellerInfoSection = travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.selectError) !== null && _travellerInfoSection !== void 0 ? _travellerInfoSection : "Please select age ranges and number of travellers"
        })
      }), (travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.segments) && /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        margin: "0 0 24px",
        gap: "8px",
        flexDirection: "column",
        "data-test-id": "TravellingTo-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "xs",
          fontWeight: "bold",
          textTransform: "uppercase",
          color: Global/* theme.greyText */.rS.greyText,
          "data-test-id": "TravellingTo-ParaTag",
          children: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg6 = travelSearchForm.segments) === null || _travelSearchForm$seg6 === void 0 ? void 0 : _travelSearchForm$seg6.label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tags_Tags, {
          handleClickTab: handleSegementSelect,
          data: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : (_travelSearchForm$seg7 = travelSearchForm.segments) === null || _travelSearchForm$seg7 === void 0 ? void 0 : _travelSearchForm$seg7.value,
          "data-test-id": "TravellingTo-Tags"
        })]
      }), isSegmentModalShown && segmentSelected && (segmentSelected === null || segmentSelected === void 0 ? void 0 : segmentSelected.modal) && /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb_CommonModalDweb, {
        customIcon: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda = segmentSelected.modal) === null || _segmentSelected$moda === void 0 ? void 0 : _segmentSelected$moda.icon,
        customTitle: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda2 = segmentSelected.modal) === null || _segmentSelected$moda2 === void 0 ? void 0 : _segmentSelected$moda2.title,
        handleClick: function handleClick() {
          setIsSegmentModalShown(false);
        },
        nonClipHeading: true,
        "data-test-id": "TravellingTo-CommonModalDweb",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
          fontSize: "md",
          color: Global/* theme.greyText */.rS.greyText,
          margin: "0 0 36px",
          "data-test-id": "TravellingTo-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda3 = segmentSelected.modal) === null || _segmentSelected$moda3 === void 0 ? void 0 : _segmentSelected$moda3.description,
            "data-test-id": "TravellingTo-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravellingTo-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            handleClick: function handleClick() {
              setIsSegmentModalShown(false);
            },
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda4 = segmentSelected.modal) === null || _segmentSelected$moda4 === void 0 ? void 0 : _segmentSelected$moda4.secondaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_AnchorTag, {
            handleClick: onSubmit,
            fontSize: "md",
            fontWeight: "bold",
            "data-test-id": "TravellingTo-AnchorTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: segmentSelected === null || segmentSelected === void 0 ? void 0 : (_segmentSelected$moda5 = segmentSelected.modal) === null || _segmentSelected$moda5 === void 0 ? void 0 : _segmentSelected$moda5.primaryCtaText,
              "data-test-id": "TravellingTo-FormattedText"
            })
          })]
        })]
      }), travelBtnTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        buttonref: buttonRef,
        customWidth: "100%",
        customTitle: travelBtnTxt,
        onClick: segmentSelected !== null && segmentSelected !== void 0 && segmentSelected.modal && travelSearchForm !== null && travelSearchForm !== void 0 && travelSearchForm.segments ? toggleSegmentModal : onSubmit,
        "data-test-id": "TravellingTo-LandingButton"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        color: Global/* theme.greyText */.rS.greyText,
        margin: "16px 0 0",
        "data-test-id": "TravellingTo-ParaTag",
        children: travelSearchForm === null || travelSearchForm === void 0 ? void 0 : travelSearchForm.disclaimer
      }), showOtherCountry && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModal_SelectCountryModalV2, {
        countryData: countryData,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        showCountry: showCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalV2"
      }), showOtherCountry && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalSheetV2, {
        countryData: countryData,
        showCountry: showCountry,
        handleSelectCountry: handleShowOtherCountry,
        setCountryData: setCountryData,
        setShowCountry: setShowCountry,
        setIsCountryError: setIsCountryError,
        popularCountries: popularCountries,
        setPopularCountries: setPopularCountries,
        customSubTitle: placeHolder,
        countrySelectErrMsg: countrySelectErrMsg,
        handleDescriptionModal: handleDescriptionModal,
        "data-test-id": "TravellingTo-SelectCountryModalSheetV2"
      }), descriptionTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionModal_DescriptionModal, {
        handleDescriptionModal: function handleDescriptionModal() {
          return setDescriptionTxt("");
        },
        value: descriptionTxt,
        title: descTitle,
        "data-test-id": "TravellingTo-DescriptionModal"
      }), isSelectedError && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      }), isSelectedError && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "10px",
        "data-test-id": "TravellingTo-WebToast"
      }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(Toast_WebToast, {
        toastTxt: countrySelectToastMsg,
        position: "fixed",
        height: "46px",
        width: "320px",
        bottom: "100px",
        right: "50px",
        "data-test-id": "TravellingTo-WebToast"
      })]
    })]
  });
};

/* harmony default export */ var TravelDetails_TravellingTo = (TravellingTo);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidget.style.ts





var TravellingToWidgetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellingToWidgetStyle",
  componentId: "sc-56hbau-0"
})(["display:flex;margin-bottom:24px;position:relative;@media ", "{flex-direction:column;", "{height:300px;}}", "{position:absolute;top:-20px;left:-20px;background:#005756;bottom:auto;}"], static_utils/* deviceType.mobile */.vO.mobile, CommonModalDweb_style/* CommonModalDwebStyle */.E5, ToastStyle);
var TravelPurposeWigetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelPurposeWigetStyle",
  componentId: "sc-56hbau-1"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;flex:2;cursor:pointer;position:relative;border-left:none;"]);
var TravellerCountWigetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetStyle",
  componentId: "sc-56hbau-2"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;flex:1.1;position:relative;display:flex;justify-content:space-between;gap:8px;align-items:center;@media ", "{border-radius:0 0 8px 8px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var TravellerCountWigetShimmerStyle = (0,styled_components_browser_esm/* default */.ZP)(TravellerCountWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetShimmerStyle",
  componentId: "sc-56hbau-3"
})(["display:flex;gap:20px;align-items:end;"]);
var TravelDateWigetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetStyle",
  componentId: "sc-56hbau-4"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;border-right:none;flex:1;cursor:pointer;position:relative;@media ", "{border-right:1px solid #e7e7e7;border-bottom:none;border-radius:8px 8px 0 0;}"], static_utils/* deviceType.mobile */.vO.mobile);
var TravelDateWigetShimmerStyle = (0,styled_components_browser_esm/* default */.ZP)(TravelDateWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetShimmerStyle",
  componentId: "sc-56hbau-5"
})(["display:flex;gap:20px;align-items:end;"]);
/* istanbul ignore next */

var WidgetList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__WidgetList",
  componentId: "sc-56hbau-6"
})(["background:#ffffff;box-shadow:0px 1px 6px rgba(0,0,0,0.2);border-radius:6px;width:", ";height:213px;overflow-y:scroll;position:absolute;top:30px;right:0;z-index:1;", ""], function (p) {
  return p.width ? p.width : "111px";
}, function (p) {
  return p.travelCount && "\nleft:250px;\n";
});
var ListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ListItem",
  componentId: "sc-56hbau-7"
})(["padding:8px 16px;border-bottom:1px solid #ebebeb;cursor:pointer;display:flex;align-items:center;", " @media ", "{padding:12px 24px;display:flex;align-items:center;justify-content:center;&:last-child{margin-bottom:60px;}}"], function (p) {
  return p.selected && "\n    ".concat(TextStyles_style/* SpanTagStyle */.zs, "{\n        color:#008CFF;\n        font-weight:700;\n    }\n    ");
}, static_utils/* deviceType.mobile */.vO.mobile);
var EmptySpace = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__EmptySpace",
  componentId: "sc-56hbau-8"
})(["width:100%;height:60px;padding:18px;"]);
var ChevWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevWrap",
  componentId: "sc-56hbau-9"
})(["margin-left:auto;"]);
var DateSeparator = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "TravellingToWidgetstyle__DateSeparator",
  componentId: "sc-56hbau-10"
})(["flex-shrink:0;"]);
var ChevStateWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevStateWrap",
  componentId: "sc-56hbau-11"
})(["cursor:pointer;transition:0.5s ease-in;", ""], function (p) {
  return p.open && "\ntransform:rotate(180deg);\n";
});
var TravellingToWidget_style_BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__BtnWrap",
  componentId: "sc-56hbau-12"
})(["background:var(--base-white,#fff);box-shadow:0px -1px 8px 0px rgba(0,0,0,0.25);padding:16px;position:fixed;bottom:0;left:0px;right:0px;"]);
var CounterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CounterWrap",
  componentId: "sc-56hbau-13"
})(["border-radius:", ";background:#fff;box-shadow:", ";padding:", ";display:flex;gap:", ";", ";align-items:center;width:fit-content;height:", ";button{background:transparent;cursor:pointer;display:flex;padding:0;}span{word-break:unset;}"], function (prop) {
  return prop.borderRadius ? prop.borderRadius : "4px";
}, function (prop) {
  return prop.boxShadow ? prop.boxShadow : "0px 0px 6px 0px rgba(0, 0, 0, 0.2)";
}, function (prop) {
  return prop.padding ? prop.padding : "0px 8px";
}, function (prop) {
  return prop.gap ? prop.gap : "14px";
}, function (prop) {
  return prop.border ? "border:".concat(prop.border) : "";
}, function (prop) {
  return prop.height ? prop.height : "40px";
});
var CounterBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TravellingToWidgetstyle__CounterBtn",
  componentId: "sc-56hbau-14"
})(["", ""], function (p) {
  return p.isDiabled && "\npointer-events:none;\nopacity:0.5;\n";
});
var mobileAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]); //here I am

var TravellerAgeRangePickerWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerAgeRangePickerWrap",
  componentId: "sc-56hbau-15"
})(["width:393px;background:#ffffff;box-sizing:border-box;box-shadow:0px 1px 6px 0px #00000033;display:flex;flex-direction:column;z-index:1;border-radius:4px;position:absolute;@media ", "{right:24px;top:24px;}@media ", "{width:100%;position:fixed;left:0;flex-direction:column;", " border-radius:16px 16px 0 0;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation-fill-mode:forwards;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;}"], static_utils/* deviceType.desktop */.vO.desktop, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.isBottomSheetFullScreen && "height: 100vh;";
}, mobileAnim);
var TravellerAgeRangeSelectSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerAgeRangeSelectSection",
  componentId: "sc-56hbau-16"
})(["display:grid;grid-template-columns:1fr 1fr;@media ", "{grid-template-columns:1fr;}gap:8px;"], static_utils/* deviceType.mobile */.vO.mobile);
var AgeRangeSelectSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSelectSection",
  componentId: "sc-56hbau-17"
})(["display:flex;padding:8px 7px;background:#fff;border:1px solid #d8d8d8;border-radius:8px;gap:14px;z-index:3;align-items:center;width:99px;height:32px;@media ", "{position:relative;}"], static_utils/* deviceType.mobile */.vO.mobile);
var CountSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CountSectionWrap",
  componentId: "sc-56hbau-18"
})(["display:flex;flex-direction:column;gap:16px;@media ", "{z-index:-1;position:relative;}padding-bottom:16px;"], static_utils/* deviceType.mobile */.vO.mobile);
var AgeRangeSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSectionWrap",
  componentId: "sc-56hbau-19"
})(["display:flex;padding-top:16px;flex-direction:column;gap:16px;@media ", "{max-height:220px;overflow:scroll;}@media ", "{z-index:-1;position:relative;overflow-y:scroll;overflow-x:hidden;", "}"], static_utils/* deviceType.desktop */.vO.desktop, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.isBottomSheetFullScreen ? "flex-grow: 1;\n    margin-bottom: 145px;\n    " : " max-height: 300px;";
});
var ApplyCtaSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ApplyCtaSectionWrap",
  componentId: "sc-56hbau-20"
})(["display:flex;justify-content:flex-end;gap:10px;padding 19px;box-shadow:0px 1px 6px 0px #00000033;@media ", "{z-index:1000;position:fixed;bottom:0;left:0;right:0;background:#fff;}"], static_utils/* deviceType.mobile */.vO.mobile);
var AgeRangeSelectMobileWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSelectMobileWrap",
  componentId: "sc-56hbau-21"
})(["display:flex;flex-direction:column;max-height:143px;position:fixed;align-items:center;justify-content:center;z-index:1000;left:", "px;bottom:", "px;"], function (p) {
  return p.left && p.left;
}, function (p) {
  return p.bottom && p.bottom;
});
var AgeRangeSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSelect",
  componentId: "sc-56hbau-22"
})(["display:flex;align-items:center;flex-direction:column;background:#fff;border:1px solid #d8d8d8;border-radius:8px;@media ", "{z-index:100;position:fixed;", ";", ";}@media ", "{box-shadow:0px 1px 7px 0px #00000033;}overflow-y:scroll;max-height:134px;"], static_utils/* deviceType.desktop */.vO.desktop, function (p) {
  return p.top && "top:".concat(p.top, "px");
}, function (p) {
  return p.left && "left:".concat(p.left, "px");
}, static_utils/* deviceType.mobile */.vO.mobile);
var AgeSelectItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeSelectItem",
  componentId: "sc-56hbau-23"
})(["padding:1px 25.4px;width:100%;position:relative;background:#fff;cursor:pointer;&:hover{background:#eaf5ff;span{color:#008cff;}}"]);
var RangePickerContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__RangePickerContentWrap",
  componentId: "sc-56hbau-24"
})(["padding:22px;@media ", "{z-index:-1;position:relative;margin-bottom:70px;", "}"], static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.isBottomSheetFullScreen && "display: flex;\n    flex-direction: column;\n    height: 100vh;";
});
var UpsideDownTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__UpsideDownTriangle",
  componentId: "sc-56hbau-25"
})(["width:0;height:0;border-left:6.1px solid transparent;border-right:6.1px solid transparent;border-top:9px solid #fff;filter:drop-shadow(0px 1px 7px #00000033);"]);
var TravellerAgenCountHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerAgenCountHeading",
  componentId: "sc-56hbau-26"
})(["display:flex;align-items:center;gap:8px;margin:24px 0px 0px 0px;padding:11px 16px;border-bottom:1px solid #d8d8d8;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidgetShimmer.tsx







var TravellingToWidgetShimmer = function TravellingToWidgetShimmer(_ref) {
  objectDestructuringEmpty_objectDestructuringEmpty(_ref);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidgetStyle, {
    "data-test-id": "TravellingToWidgetShimmer-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDateWigetShimmerStyle, {
      "data-test-id": "TravellingToWidgetShimmer-TravelDateWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerCountWigetShimmerStyle, {
      "data-test-id": "TravellingToWidgetShimmer-TravellerCountWigetShimmerStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellingToWidgetShimmer = (TravellingToWidgetShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingToShimmer.tsx










var TravellingToShimmer = function TravellingToShimmer() {
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToStyleWrap, {
    "data-test-id": "TravellingToShimmer-TravellingToStyleWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravelNote, {
      "data-test-id": "TravellingToShimmer-TravelNote",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion3_ShimmerVersion3, {
        height: "22px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToStyle, {
      "data-test-id": "TravellingToShimmer-TravellingToStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        margin: "0 0 16px",
        width: "100%",
        height: "28px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
        margin: "0 0 8px",
        width: "80%",
        height: "16px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        margin: device == "sm" ? "0 0 20px" : "",
        flexWrap: "wrap",
        gap: "8px",
        "data-test-id": "TravellingToShimmer-FlexComp",
        children: Array.from({
          length: 5
        }, function (_, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion2_ShimmerVersion2, {
            width: "89px",
            height: "79px",
            "data-test-id": `TravellingToShimmer-ShimmerVersion2-${index}`
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
        margin: "30px -30px 30px",
        xs: true,
        "data-test-id": "TravellingToShimmer-SectionDividers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellingToWidgetShimmer, {
        "data-test-id": "TravellingToShimmer-TravellingToWidgetShimmer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShimmerVersion3_ShimmerVersion3, {
        width: "100%",
        height: "44px",
        "data-test-id": "TravellingToShimmer-ShimmerVersion3"
      })]
    })]
  });
};

/* harmony default export */ var TravelDetails_TravellingToShimmer = (TravellingToShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravelDateWiget.tsx










var TravelDateWiget = function TravelDateWiget(_ref) {
  var showTravDate = _ref.showTravDate,
      handleTravDate = _ref.handleTravDate,
      ref = _ref.ref,
      travDateTitle = _ref.travDateTitle,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelDateWigetStyle, {
    ref: ref,
    onClick: handleTravDate,
    "data-test-id": "TravelDateWiget-TravelDateWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "8px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [travDateTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        textTransform: "uppercase",
        color: showTravDate ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravelDateWiget-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travDateTitle,
          "data-test-id": "TravelDateWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevStateWrap, {
        open: showTravDate,
        "data-test-id": "TravelDateWiget-ChevStateWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
          "data-test-id": "TravelDateWiget-BlueChev"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      gap: "4px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [startDate === null || startDate === void 0 ? void 0 : startDate.getDate(), " \xA0", startDate ? static_utils/* MONTHS */.gg[parseInt(startDate === null || startDate === void 0 ? void 0 : startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear().toString().slice(-2)]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: startDate && static_utils/* LONG_WEEK_DAYS */.vH[startDate.getDay()]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateSeparator, {
        "data-test-id": "TravelDateWiget-DateSeparator",
        children: "-to-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [endDate ? endDate.getDate() : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? 1 : startDate.getDate() + 1 : null, "\xA0", endDate ? static_utils/* MONTHS */.gg[parseInt(endDate.getMonth().toString().slice(-2))] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? static_utils/* MONTHS */.gg[parseInt((startDate.getMonth() + 1).toString().slice(-2))] : static_utils/* MONTHS */.gg[parseInt(startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", endDate ? endDate.getFullYear().toString().slice(-2) : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? startDate.getMonth() === 11 ? (startDate.getFullYear() + 1).toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : null]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: endDate ? static_utils/* LONG_WEEK_DAYS */.vH[endDate.getDay()] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? static_utils/* LONG_WEEK_DAYS */.vH[new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDay()] : static_utils/* LONG_WEEK_DAYS */.vH[startDate.getDay()] : null
        })]
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravelDateWiget = (TravelDateWiget);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravAgeRangenCountPicker.tsx















var TravAgeRangenCountPicker = function TravAgeRangenCountPicker(_ref) {
  var travellerInfoSelectSection = _ref.travellerInfoSelectSection,
      captureCount = _ref.captureCount,
      travAgeRange = _ref.travAgeRange,
      setCaptureCount = _ref.setCaptureCount,
      setTravAgeRange = _ref.setTravAgeRange,
      focusedIndex = _ref.focusedIndex,
      ageRangeSelectIndex = _ref.ageRangeSelectIndex,
      ageRangeSelectRef = _ref.ageRangeSelectRef,
      setIsAgeRangeSelectedError = _ref.setIsAgeRangeSelectedError,
      setFocusedIndex = _ref.setFocusedIndex,
      setAgeRangeSelectIndex = _ref.setAgeRangeSelectIndex,
      travellingToRef = _ref.travellingToRef;

  var _ref2 = travellerInfoSelectSection || {},
      countSection = _ref2.countSection,
      ageRangeSection = _ref2.ageRangeSection,
      ctaText = _ref2.ctaText;

  var _useState = (0,react.useState)({
    left: 0,
    top: 0,
    bottom: 0
  }),
      selectPosition = _useState[0],
      setSelectPosition = _useState[1];

  var _useState2 = (0,react.useState)(1),
      travellerCount = _useState2[0],
      setTravellerCount = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      travellerAgeRange = _useState3[0],
      setTravellerAgeRange = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isSelectedError = _useState4[0],
      setIsSelectedError = _useState4[1];

  var divRefs = (0,react.useRef)([]);
  var applyBtnRef = (0,react.useRef)(null);
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();

  var handleSelectPosition = function handleSelectPosition(index) {
    var currentDiv = divRefs.current[index];

    if (currentDiv) {
      var rect = currentDiv.getBoundingClientRect();
      setSelectPosition({
        left: rect.x - (device === "sm" ? 8 : 0),
        top: rect.top - (device === "sm" ? 150 : 0),
        bottom: window.innerHeight - rect.top + 7
      });
    }
  };

  (0,react.useEffect)(function () {
    var button = applyBtnRef.current;
    var viewportMargin = 16;

    if (button) {
      var rect = button.getBoundingClientRect();
      var offsetTop = window.scrollY + rect.top;
      var isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        var _travellingToRef$curr;

        travellingToRef === null || travellingToRef === void 0 ? void 0 : (_travellingToRef$curr = travellingToRef.current) === null || _travellingToRef$curr === void 0 ? void 0 : _travellingToRef$curr.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    setTravellerCount(captureCount);
    setTravellerAgeRange(travAgeRange);
  }, [captureCount, travAgeRange, focusedIndex]);

  var handleTravellerCountIncr = function handleTravellerCountIncr() {
    var _countSection$maxCoun;

    var newTravAgeRange = _toConsumableArray(travellerAgeRange !== null && travellerAgeRange !== void 0 ? travellerAgeRange : []);

    if (travellerCount < ((_countSection$maxCoun = countSection === null || countSection === void 0 ? void 0 : countSection.maxCount) !== null && _countSection$maxCoun !== void 0 ? _countSection$maxCoun : src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS)) {
      setTravellerCount(travellerCount + 1);
      newTravAgeRange.push({});
    } else {
      var _countSection$maxCoun2;

      setTravellerCount((_countSection$maxCoun2 = countSection === null || countSection === void 0 ? void 0 : countSection.maxCount) !== null && _countSection$maxCoun2 !== void 0 ? _countSection$maxCoun2 : src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);

      if (newTravAgeRange.length < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS) {
        newTravAgeRange.push({});
      }
    }

    setTravellerAgeRange === null || setTravellerAgeRange === void 0 ? void 0 : setTravellerAgeRange(newTravAgeRange);
  };

  var handleTravellerCountDecr = function handleTravellerCountDecr() {
    var newTravAgeRange = _toConsumableArray(travellerAgeRange !== null && travellerAgeRange !== void 0 ? travellerAgeRange : []);

    if (travellerCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      newTravAgeRange.pop();
      setTravellerCount(travellerCount - 1);
    } else {
      setTravellerCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);

      if (newTravAgeRange.length > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
        newTravAgeRange.pop();
      }
    }

    setTravellerAgeRange(newTravAgeRange);
  };

  var handleAgeRangeSelect = function handleAgeRangeSelect(index, value, label, key) {
    setAgeRangeSelectIndex(-1);
    var newTravAgeRange = travellerAgeRange === null || travellerAgeRange === void 0 ? void 0 : travellerAgeRange.map(function (item, i) {
      if (i === index) {
        return {
          value: value,
          label: label,
          key: key
        };
      }

      return item;
    });
    setTravellerAgeRange(newTravAgeRange !== null && newTravAgeRange !== void 0 ? newTravAgeRange : []);
  };

  var handleApply = function handleApply() {
    var isAgeRangeSelected = travellerAgeRange === null || travellerAgeRange === void 0 ? void 0 : travellerAgeRange.every(function (ageRange) {
      return ageRange === null || ageRange === void 0 ? void 0 : ageRange.value;
    });

    if (isAgeRangeSelected) {
      setIsAgeRangeSelectedError(false);
      setFocusedIndex(-1);
      setTravAgeRange(travellerAgeRange);
      setCaptureCount(travellerCount);
      (0,utils/* replaceHistory */.df)("travellers", travellerCount.toString());
      (0,utils/* replaceHistory */.df)("travellerAgeRanges", JSON.stringify(travellerAgeRange.map(function (item) {
        return item.key;
      })));
    } else {
      setIsSelectedError(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerAgeRangePickerWrap, {
    isBottomSheetFullScreen: travellerCount > 10,
    "data-test-id": "TravAgeRangenCountPicker-TravellerAgeRangePickerWrap",
    children: [device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerAgenCountHeading, {
      "data-test-id": "TravAgeRangenCountPicker-TravellerAgenCountHeading",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: function onClick() {
          setFocusedIndex(-1);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
            fill: "#808080"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontSize: "md",
        fontWeight: "bold",
        color: "#4A4A4A",
        "data-test-id": "TravAgeRangenCountPicker-SpanTag",
        children: "TRAVELLERS & AGE"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RangePickerContentWrap, {
      isBottomSheetFullScreen: travellerCount > 10,
      "data-test-id": "TravAgeRangenCountPicker-RangePickerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CountSectionWrap, {
        "data-test-id": "TravAgeRangenCountPicker-CountSectionWrap",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravAgeRangenCountPicker-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "sm",
            "data-test-id": "TravAgeRangenCountPicker-SpanTag",
            children: (countSection === null || countSection === void 0 ? void 0 : countSection.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontSize: "xs",
              fontWeight: "bold",
              color: "#4A4A4A",
              "data-test-id": "TravAgeRangenCountPicker-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: countSection === null || countSection === void 0 ? void 0 : countSection.title,
                "data-test-id": "TravAgeRangenCountPicker-FormattedText"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CounterWrap, {
            borderRadius: "8px",
            padding: "4px",
            gap: "4px",
            height: "32px",
            boxShadow: "0px",
            border: "1px solid #D8D8D8",
            "data-test-id": "TravAgeRangenCountPicker-CounterWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CounterBtn, {
              isDiabled: travellerCount == 1,
              onClick: handleTravellerCountDecr,
              "data-test-id": "TravAgeRangenCountPicker-CounterBtn",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                  width: "24",
                  height: "24",
                  fill: "white",
                  "data-test-id": "TravAgeRangenCountPicker-rect"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
                  fill: "#008CFF"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
              fontWeight: "bold",
              fontSize: "large",
              "data-test-id": "TravAgeRangenCountPicker-SpanTag",
              children: travellerCount && travellerCount <= 9 ? "0" + travellerCount : travellerCount
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CounterBtn, {
              isDiabled: travellerCount == (countSection === null || countSection === void 0 ? void 0 : countSection.maxCount),
              onClick: handleTravellerCountIncr,
              "data-test-id": "TravAgeRangenCountPicker-CounterBtn",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                  width: "24",
                  height: "24",
                  fill: "white",
                  "data-test-id": "TravAgeRangenCountPicker-rect"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
                  fill: "#008CFF"
                })]
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontSize: "sm",
          "data-test-id": "TravAgeRangenCountPicker-SpanTag",
          children: (ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: countSection === null || countSection === void 0 ? void 0 : countSection.description,
            "data-test-id": "TravAgeRangenCountPicker-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          position: "relative",
          zIndex: "-1"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers_SectionDividers, {
          xs: true,
          "data-test-id": "TravAgeRangenCountPicker-SectionDividers"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AgeRangeSectionWrap, {
        isBottomSheetFullScreen: travellerCount > 10,
        "data-test-id": "TravAgeRangenCountPicker-AgeRangeSectionWrap",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
          flexDirection: "column",
          gap: "4px",
          "data-test-id": "TravAgeRangenCountPicker-FlexComp",
          children: [(ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            color: "#4A4A4A",
            "data-test-id": "TravAgeRangenCountPicker-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.title,
              "data-test-id": "TravAgeRangenCountPicker-FormattedText"
            })
          }), (ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
            fontSize: "xs",
            color: "#757575",
            "data-test-id": "TravAgeRangenCountPicker-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.description,
              "data-test-id": "TravAgeRangenCountPicker-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerAgeRangeSelectSection, {
          "data-test-id": "TravAgeRangenCountPicker-TravellerAgeRangeSelectSection",
          children: travellerAgeRange === null || travellerAgeRange === void 0 ? void 0 : travellerAgeRange.map(function (ageRange, index) {
            var _ageRangeSection$ageR, _ageRangeSection$ageR2;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
              alignItems: device === "sm" ? "flex-end" : "center",
              flexDirection: "column",
              "data-test-id": "TravAgeRangenCountPicker-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                width: "100%",
                gap: "4px",
                alignItems: "center",
                justifyContent: "space-between",
                "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
                  fontSize: "xs",
                  margin: "8px 0px",
                  "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                  children: ["Traveller ", (index + 1).toString()]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [device === "lg" && (ageRangeSelectIndex === index ? /*#__PURE__*/(0,jsx_runtime.jsx)(AgeRangeSelect, {
                    ref: ageRangeSelectRef,
                    top: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.top,
                    left: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.left,
                    "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelect",
                    children: (ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.ageRanges) && (ageRangeSection === null || ageRangeSection === void 0 ? void 0 : (_ageRangeSection$ageR = ageRangeSection.ageRanges) === null || _ageRangeSection$ageR === void 0 ? void 0 : _ageRangeSection$ageR.map(function (age, i) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(AgeSelectItem, {
                        onClick: function onClick() {
                          setTimeout(function () {
                            handleAgeRangeSelect(index, [age === null || age === void 0 ? void 0 : age.min, age === null || age === void 0 ? void 0 : age.max], age === null || age === void 0 ? void 0 : age.label, i);
                          }, 1);
                        },
                        "data-test-id": "TravAgeRangenCountPicker-AgeSelectItem",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                          value: age === null || age === void 0 ? void 0 : age.label,
                          baseStyle: {
                            fontSize: "12px"
                          },
                          "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                        })
                      });
                    }))
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AgeRangeSelectSection, {
                      ref: function ref(el) {
                        return divRefs.current[index] = el;
                      } //TODO: Check for Alternative approach rather than using setTimeout
                      ,
                      onClick: function onClick() {
                        setTimeout(function () {
                          setAgeRangeSelectIndex(index);
                        }, 1);
                      },
                      "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelectSection",
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                        justifyContent: "space-between",
                        handleClick: function handleClick() {
                          handleSelectPosition(index);
                        },
                        width: "100%",
                        "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                        children: [ageRange !== null && ageRange !== void 0 && ageRange.value ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                          value: ageRange === null || ageRange === void 0 ? void 0 : ageRange.label,
                          baseStyle: {
                            fontSize: "12px",
                            fontWeight: "bold"
                          },
                          "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                          fontSize: "xs",
                          color: "#4A4A4A",
                          "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                          children: "Select Age"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
                          alignItems: "center",
                          height: "16px",
                          width: "16px",
                          isCursorPointer: true,
                          justifyContent: "center",
                          "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                            height: "5px",
                            width: "8px",
                            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                            "data-test-id": "TravAgeRangenCountPicker-ImageComponent"
                          })
                        })]
                      })
                    })
                  })), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(AgeRangeSelectSection, {
                    "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelectSection",
                    children: [ageRangeSelectIndex === index && /*#__PURE__*/(0,jsx_runtime.jsxs)(AgeRangeSelectMobileWrap, {
                      top: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.top,
                      left: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.left,
                      bottom: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.bottom,
                      "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelectMobileWrap",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AgeRangeSelect, {
                        ref: ageRangeSelectRef,
                        top: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.top,
                        left: selectPosition === null || selectPosition === void 0 ? void 0 : selectPosition.left,
                        "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelect",
                        children: (ageRangeSection === null || ageRangeSection === void 0 ? void 0 : ageRangeSection.ageRanges) && (ageRangeSection === null || ageRangeSection === void 0 ? void 0 : (_ageRangeSection$ageR2 = ageRangeSection.ageRanges) === null || _ageRangeSection$ageR2 === void 0 ? void 0 : _ageRangeSection$ageR2.map(function (age, i) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(AgeSelectItem, {
                            onClick: function onClick() {
                              setTimeout(function () {
                                handleAgeRangeSelect(index, [age === null || age === void 0 ? void 0 : age.min, age === null || age === void 0 ? void 0 : age.max], age === null || age === void 0 ? void 0 : age.label, i);
                              }, 1);
                            },
                            "data-test-id": "TravAgeRangenCountPicker-AgeSelectItem",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                              value: age === null || age === void 0 ? void 0 : age.label,
                              baseStyle: {
                                fontSize: "12px"
                              },
                              "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                            })
                          });
                        }))
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpsideDownTriangle, {
                        "data-test-id": "TravAgeRangenCountPicker-UpsideDownTriangle"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      ref: function ref(el) {
                        return divRefs.current[index] = el;
                      },
                      onClick: function onClick() {
                        setTimeout(function () {
                          setAgeRangeSelectIndex(index);
                        }, 1);
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
                        justifyContent: "space-between",
                        width: "100%",
                        handleClick: function handleClick() {
                          return handleSelectPosition(index);
                        },
                        "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                        children: [ageRange !== null && ageRange !== void 0 && ageRange.value ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                          value: ageRange === null || ageRange === void 0 ? void 0 : ageRange.label,
                          baseStyle: {
                            fontSize: "12px",
                            fontWeight: "bold"
                          },
                          "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                          fontSize: "xs",
                          color: "#4A4A4A",
                          "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                          children: "Select Age"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
                          alignItems: "center",
                          height: "16px",
                          width: "16px",
                          isCursorPointer: true,
                          justifyContent: "center",
                          "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                            height: "5px",
                            width: "8px",
                            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                            "data-test-id": "TravAgeRangenCountPicker-ImageComponent"
                          })
                        })]
                      })
                    })]
                  })]
                })]
              }), isSelectedError && !(ageRange !== null && ageRange !== void 0 && ageRange.value) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                fontSize: "xs",
                color: "#EB2026",
                margin: device === "lg" ? "0px 0px 0px 60px" : "0px 3px 0px 0px",
                "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                children: "Select age range"
              })]
            });
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ApplyCtaSectionWrap, {
      "data-test-id": "TravAgeRangenCountPicker-ApplyCtaSectionWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton_LandingButton, {
        customWidth: device === "sm" ? "100%" : "93px",
        customHeight: device === "sm" ? "44px" : "32px",
        customTitle: ctaText,
        fontSize: device === "sm" ? "16px" : "14px",
        onClick: handleApply,
        buttonref: applyBtnRef,
        "data-test-id": "TravAgeRangenCountPicker-LandingButton"
      })
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravAgeRangenCountPicker = (TravAgeRangenCountPicker);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellerCounterWiget.tsx








var TravellerCounterWiget = function TravellerCounterWiget(_ref) {
  var showTravCount = _ref.showTravCount,
      handleCaptureCountIncr = _ref.handleCaptureCountIncr,
      handleCaptureCountDecr = _ref.handleCaptureCountDecr,
      captureCount = _ref.captureCount,
      ref = _ref.ref,
      travCountTitle = _ref.travCountTitle,
      travCountInfo = _ref.travCountInfo;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerCountWigetStyle, {
    "data-test-id": "TravellerCounterWiget-TravellerCountWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        textTransform: "uppercase",
        color: showTravCount ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: travCountTitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        color: Global/* theme.greyText6 */.rS.greyText6,
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: "Senior citizens above 70yrs are not covered",
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CounterWrap, {
      "data-test-id": "TravellerCounterWiget-CounterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CounterBtn, {
        isDiabled: captureCount == 1,
        onClick: handleCaptureCountDecr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
            fill: "#008CFF"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: captureCount && captureCount <= 9 ? "0" + captureCount : captureCount
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CounterBtn, {
        isDiabled: captureCount == 20,
        onClick: handleCaptureCountIncr,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
            fill: "#008CFF"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellerCounterWiget = (TravellerCounterWiget);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellerCounterWigetV2.tsx








var TravellerCounterWigetV2 = function TravellerCounterWigetV2(_ref) {
  var countValue = _ref.countValue,
      travSelectTitle = _ref.travSelectTitle,
      postSelectTitle = _ref.postSelectTitle,
      postSelectDesc = _ref.postSelectDesc,
      travCountTitle = _ref.travCountTitle,
      isAgeRangeSelected = _ref.isAgeRangeSelected,
      showSelectSection = _ref.showSelectSection,
      handleSelectSection = _ref.handleSelectSection,
      description = _ref.description,
      travAgeRange = _ref.travAgeRange;

  var getAgeRanges = function getAgeRanges(travAgeRange) {
    var ageRanges = travAgeRange.map(function (ageRange) {
      var _ageRange$label, _ageRange$label$text;

      return ageRange === null || ageRange === void 0 ? void 0 : (_ageRange$label = ageRange.label) === null || _ageRange$label === void 0 ? void 0 : (_ageRange$label$text = _ageRange$label.text) === null || _ageRange$label$text === void 0 ? void 0 : _ageRange$label$text.value;
    });
    var ageRangesStr = ageRanges.join(", ");

    if (ageRangesStr.length > 25) {
      return ageRangesStr.substring(0, 25) + "...";
    } else {
      return ageRangesStr;
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerCountWigetStyle, {
    onClick: handleSelectSection,
    "data-test-id": "TravellerCounterWigetV2-TravellerCountWigetStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWigetV2-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        gap: "8px",
        "data-test-id": "TravellerCounterWigetV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          textTransform: "uppercase",
          color: showSelectSection ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
          fontWeight: "bold",
          fontSize: "xs",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: travCountTitle,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevStateWrap, {
          open: showSelectSection,
          "data-test-id": "TravellerCounterWigetV2-ChevStateWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
            "data-test-id": "TravellerCounterWigetV2-BlueChev"
          })
        })]
      }), isAgeRangeSelected ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        gap: "0px",
        "data-test-id": "TravellerCounterWigetV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: [countValue, " ", postSelectTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: postSelectTitle,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_SpanTag, {
          color: Global/* theme.greyText6 */.rS.greyText6,
          fontSize: "xs",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: [postSelectDesc && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: postSelectDesc,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          }), " ", getAgeRanges(travAgeRange !== null && travAgeRange !== void 0 ? travAgeRange : [])]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp, {
        flexDirection: "column",
        gap: "0px",
        "data-test-id": "TravellerCounterWigetV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: travSelectTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: travSelectTitle,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
          color: Global/* theme.greyText6 */.rS.greyText6,
          fontSize: "xs",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: description && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
            value: description,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var TravellingToWidget_TravellerCounterWigetV2 = (TravellerCounterWigetV2);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidget.tsx














var TravellingToWidget_analytics = (0,insurance/* getAnalytics */.I)();

var TravellingToWidget = function TravellingToWidget(_ref) {
  var travelPurposeTxt = _ref.travelPurposeTxt,
      travCountTitle = _ref.travCountTitle,
      travPurpTitle = _ref.travPurpTitle,
      travDateTitle = _ref.travDateTitle,
      btnDisabledState = _ref.btnDisabledState,
      countValue = _ref.countValue,
      setCountValue = _ref.setCountValue,
      calendarDatesLimit = _ref.calendarDatesLimit,
      setCalenderValue = _ref.setCalenderValue,
      calenderRef = _ref.calenderRef,
      travAgeRange = _ref.travAgeRange,
      setTravAgeRange = _ref.setTravAgeRange,
      upcomingTravellerNum = _ref.upcomingTravellerNum,
      upcomingFromDate = _ref.upcomingFromDate,
      upcomingToDate = _ref.upcomingToDate,
      setIsAgeRangeSelectedError = _ref.setIsAgeRangeSelectedError,
      calendarConfig = _ref.calendarConfig,
      travellerInfoSection = _ref.travellerInfoSection,
      travellingToRef = _ref.travellingToRef;
  var defaultSelected = {
    from: new Date(),
    to: new Date(Date.now() + 3600 * 1000 * 24)
  };

  var _ref2 = (calendarConfig ? calendarConfig : calendarDatesLimit) || {},
      endDateErrorMessage = _ref2.endDateErrorMessage,
      insPurchaseDateLimitInDays = _ref2.insPurchaseDateLimitInDays,
      insPurchaseEndDateLimitInDays = _ref2.insPurchaseEndDateLimitInDays,
      insPurchaseStartDateLimitInDays = _ref2.insPurchaseStartDateLimitInDays,
      insPurchaseStartDateMinLimitInDays = _ref2.insPurchaseStartDateMinLimitInDays,
      startDateErrorMessage = _ref2.startDateErrorMessage;

  var maxEndDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseDateLimitInDays);
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var ref = (0,react.useRef)(null);
  var ageRangeSelectRef = (0,react.useRef)(null);
  var divRefs = (0,react.useRef)([]);

  var _useState = (0,react.useState)(1),
      captureCount = _useState[0],
      setCaptureCount = _useState[1];

  var _useState2 = (0,react.useState)(0),
      dateTab = _useState2[0],
      setDateTab = _useState2[1];

  var _useState3 = (0,react.useState)(defaultSelected),
      range = _useState3[0],
      setRange = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showToast = _useState4[0],
      setShowToast = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      toastMessage = _useState5[0],
      setToastMessage = _useState5[1];

  var _useState6 = (0,react.useState)(new Date()),
      startDate = _useState6[0],
      setStartDate = _useState6[1];

  var _useState7 = (0,react.useState)(),
      endDate = _useState7[0],
      setEndDate = _useState7[1];

  var _useState8 = (0,react.useState)(-1),
      focusedIndex = _useState8[0],
      setFocusedIndex = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      isAgeRangeSelected = _useState9[0],
      setIsAgeRangeSelected = _useState9[1];

  var _useState10 = (0,react.useState)(-1),
      ageRangeSelectIndex = _useState10[0],
      setAgeRangeSelectIndex = _useState10[1];

  var prevFocusedIndexRef = (0,react.useRef)(focusedIndex);

  var handleClickOutside = function handleClickOutside(event) {
    var _ref$current, _ageRangeSelectRef$cu;

    if (ref !== null && ref !== void 0 && ref.current && !(ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target))) {
      setFocusedIndex(-1);
      setShowToast(false);
    }

    if (ageRangeSelectRef !== null && ageRangeSelectRef !== void 0 && ageRangeSelectRef.current && !(ageRangeSelectRef !== null && ageRangeSelectRef !== void 0 && (_ageRangeSelectRef$cu = ageRangeSelectRef.current) !== null && _ageRangeSelectRef$cu !== void 0 && _ageRangeSelectRef$cu.contains(event.target))) {
      setAgeRangeSelectIndex(-1);
    }
  };

  var handleWindowScroll = function handleWindowScroll(e) {
    if (ageRangeSelectRef.current) {
      var rect = ageRangeSelectRef.current.getBoundingClientRect();

      if (e.target !== ageRangeSelectRef.current && (window.scrollY < rect.top || window.scrollY > rect.bottom)) {
        setAgeRangeSelectIndex(-1);
      }
    }
  };

  var addTravellerNumber = function addTravellerNumber(travNumber) {
    if (travNumber > src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS || travNumber < src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);
      (0,utils/* replaceHistory */.df)("travellers", src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS.toString());
    } else {
      setCaptureCount(travNumber);
      (0,utils/* replaceHistory */.df)("travellers", travNumber.toString());
    }
  };

  var addTravellerDates = function addTravellerDates(travStartDate, travEndDate) {
    var tempFromDate = (0,static_utils/* convertUnixToDate */.P9)(travStartDate);
    var tempToDate = (0,static_utils/* convertUnixToDate */.P9)(travEndDate);
    (0,utils/* replaceHistory */.df)("startDate", travStartDate.toString());
    (0,utils/* replaceHistory */.df)("endDate", travEndDate.toString());
    setRange({
      from: tempFromDate,
      to: tempToDate
    });
  };

  (0,react.useEffect)(function () {
    document.addEventListener("click", handleClickOutside, false);
    document.addEventListener("scroll", handleWindowScroll, false);
    return function () {
      document.removeEventListener("scroll", handleClickOutside, false);
      document.removeEventListener("click", handleWindowScroll, false);
    };
  }, []);
  (0,react.useEffect)(function () {
    var _queryParameters$get, _travellerInfoSection, _travellerInfoSection2;

    var queryParameters = new URLSearchParams(window.location.search);
    var trav = queryParameters.get("travellers");
    var fromDate = queryParameters.get("startDate");
    var toDate = queryParameters.get("endDate");
    var travellerAgeRangesIndex = JSON.parse((_queryParameters$get = queryParameters.get("travellerAgeRanges")) !== null && _queryParameters$get !== void 0 ? _queryParameters$get : "[]");

    if (trav && !Number.isNaN(parseInt(trav))) {
      addTravellerNumber(parseInt(trav));
    } else if (upcomingTravellerNum) {
      addTravellerNumber(upcomingTravellerNum);
    }

    var diff = (trav && !Number.isNaN(parseInt(trav)) ? parseInt(trav) : 1) - travellerAgeRangesIndex.length;
    var newTravAgeRange = [];
    var ageRange = travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : (_travellerInfoSection = travellerInfoSection.travellerInfoSelectSection) === null || _travellerInfoSection === void 0 ? void 0 : (_travellerInfoSection2 = _travellerInfoSection.ageRangeSection) === null || _travellerInfoSection2 === void 0 ? void 0 : _travellerInfoSection2.ageRanges;
    travellerAgeRangesIndex.forEach(function (item, index) {
      var _ageRange$item, _ageRange$item2, _ageRange$item3;

      newTravAgeRange.push({
        value: [ageRange === null || ageRange === void 0 ? void 0 : (_ageRange$item = ageRange[item]) === null || _ageRange$item === void 0 ? void 0 : _ageRange$item.min, ageRange === null || ageRange === void 0 ? void 0 : (_ageRange$item2 = ageRange[item]) === null || _ageRange$item2 === void 0 ? void 0 : _ageRange$item2.max],
        label: ageRange === null || ageRange === void 0 ? void 0 : (_ageRange$item3 = ageRange[item]) === null || _ageRange$item3 === void 0 ? void 0 : _ageRange$item3.label,
        key: item
      });
    });

    if (diff >= 0) {
      for (var i = 0; i < diff; i++) {
        newTravAgeRange.push({});
      }
    } else {
      newTravAgeRange.splice(diff, -diff);
    }

    setTravAgeRange === null || setTravAgeRange === void 0 ? void 0 : setTravAgeRange(newTravAgeRange);

    if (fromDate && toDate) {
      addTravellerDates(parseInt(fromDate), parseInt(toDate));
    } else if (upcomingFromDate && upcomingToDate) {
      addTravellerDates(upcomingFromDate, upcomingToDate);
    }
  }, []);
  (0,react.useEffect)(function () {
    setEndDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  }, []);
  (0,react.useEffect)(function () {
    if (captureCount >= src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      setCountValue(captureCount);
    }
  }, [captureCount]);
  (0,react.useEffect)(function () {
    if (range) {
      setCalenderValue(range);
    }
  }, [range]);

  var checkIsAgeRangeSelected = function checkIsAgeRangeSelected(travAgeRange) {
    if (travAgeRange.length > 0) {
      var isAgenCountApply = travAgeRange.length === captureCount;
      travAgeRange === null || travAgeRange === void 0 ? void 0 : travAgeRange.forEach(function (item) {
        if (!item.value) {
          isAgenCountApply = false;
        }
      });
      setIsAgeRangeSelected(isAgenCountApply);
    }
  };

  (0,react.useEffect)(function () {
    checkIsAgeRangeSelected(travAgeRange !== null && travAgeRange !== void 0 ? travAgeRange : []);
  }, [travAgeRange]);
  (0,react.useEffect)(function () {
    var datePickerElement = document.getElementById("datePickerContainer");

    if (datePickerElement) {
      var rect = datePickerElement.getBoundingClientRect();
      var isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (prevFocusedIndexRef.current === 0 && focusedIndex !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (focusedIndex === 0 && !isInView) {
        var offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }

    prevFocusedIndexRef.current = focusedIndex;
  }, [focusedIndex]);
  (0,react.useEffect)(function () {
    if ((range === null || range === void 0 ? void 0 : range.to) === undefined && range !== null && range !== void 0 && range.from) {
      var tempToDate = new Date(range === null || range === void 0 ? void 0 : range.from);
      tempToDate.setDate(tempToDate.getDate() + 1);
      (0,utils/* replaceHistory */.df)("endDate", (0,static_utils/* convertDateToUnix */.cJ)(tempToDate).toString());
    }
  }, [range === null || range === void 0 ? void 0 : range.from]);

  var handleClick = function handleClick(index) {
    if (index === focusedIndex) {
      setFocusedIndex(-1);
      setShowToast(false);
    } else {
      setFocusedIndex(index);
    }
  };

  var handleDayClick = function handleDayClick(selectedDate) {
    if (dateTab === 0) {
      var maxStartDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateLimitInDays);

      if (maxStartDate && maxStartDate < selectedDate) {
        // alert(startDateErrorMessage);
        setShowToast(true);
        setToastMessage(startDateErrorMessage);
      } else if (range !== null && range !== void 0 && range.from && range !== null && range !== void 0 && range.to) {
        setRange({
          from: selectedDate,
          to: undefined
        });
        (0,utils/* replaceHistory */.df)("startDate", (0,static_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
        setDateTab(1);
        setShowToast(false);
      }
    } else if (dateTab === 1) {
      if (range !== null && range !== void 0 && range.from) {
        var fromDate = new Date(range === null || range === void 0 ? void 0 : range.from);

        var _maxEndDate = (0,utils/* addDaysToDate */.Xz)(fromDate, calendarConfig === null || calendarConfig === void 0 ? void 0 : calendarConfig.insPurchaseEndDateLimitInDays);

        if ((range === null || range === void 0 ? void 0 : range.from) > selectedDate) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          setShowToast(false);
        } else if (_maxEndDate && _maxEndDate <= selectedDate) {
          setShowToast(true);
          setToastMessage(endDateErrorMessage);
        } else {
          var _range$from, _range$from$toLocaleD, _range$to, _range$to$toLocaleDat;

          setRange({
            from: range === null || range === void 0 ? void 0 : range.from,
            to: selectedDate
          });
          setShowToast(false);
          setDateTab(0);

          if (device == "lg") {
            setFocusedIndex(1);
          }

          (0,utils/* replaceHistory */.df)("endDate", (0,static_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
          TravellingToWidget_analytics === null || TravellingToWidget_analytics === void 0 ? void 0 : TravellingToWidget_analytics.trackLandingEvents({
            actionType: "travel_date_selected",
            payload: {
              departure: (_range$from = range.from) === null || _range$from === void 0 ? void 0 : (_range$from$toLocaleD = _range$from.toLocaleDateString("en-GB")) === null || _range$from$toLocaleD === void 0 ? void 0 : _range$from$toLocaleD.replace(/\//gi, ":"),
              arrival: ((_range$to = range.to) === null || _range$to === void 0 ? void 0 : (_range$to$toLocaleDat = _range$to.toLocaleDateString("en-GB")) === null || _range$to$toLocaleDat === void 0 ? void 0 : _range$to$toLocaleDat.replace(/\//gi, ":")) || ""
            }
          });
        }
      }
    }
  };

  var handleCaptureCountIncr = function handleCaptureCountIncr() {
    captureCount < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS ? setCaptureCount(captureCount + 1) : setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);
    (0,utils/* replaceHistory */.df)("travellers", (captureCount + 1).toString());
  };

  var handleCaptureCountDecr = function handleCaptureCountDecr() {
    captureCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? setCaptureCount(captureCount - 1) : setCaptureCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS); // if (device == 'lg') {
    //     setFocusedIndex(2);
    // }

    (0,utils/* replaceHistory */.df)("travellers", (captureCount - 1).toString());
  };

  var handleSubmit = function handleSubmit(chkIn, chkOut) {
    var _chkIn$toLocaleDateSt, _chkOut$toLocaleDateS;

    chkIn && setStartDate(chkIn);
    chkOut && setEndDate(chkOut);
    TravellingToWidget_analytics === null || TravellingToWidget_analytics === void 0 ? void 0 : TravellingToWidget_analytics.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: (chkIn === null || chkIn === void 0 ? void 0 : (_chkIn$toLocaleDateSt = chkIn.toLocaleDateString("en-GB")) === null || _chkIn$toLocaleDateSt === void 0 ? void 0 : _chkIn$toLocaleDateSt.replace(/\//gi, ":")) || "",
        arrival: (chkOut === null || chkOut === void 0 ? void 0 : (_chkOut$toLocaleDateS = chkOut.toLocaleDateString("en-GB")) === null || _chkOut$toLocaleDateS === void 0 ? void 0 : _chkOut$toLocaleDateS.replace(/\//gi, ":")) || ""
      }
    });
    setFocusedIndex(-1);
    setShowToast(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidgetStyle, {
    ref: device == "lg" ? ref : null,
    "data-test-id": "TravellingToWidget-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravelDateWiget, {
      ref: divRefs.current[0],
      showTravDate: focusedIndex == 0,
      handleTravDate: function handleTravDate() {
        return handleClick(0);
      },
      travDateTitle: travDateTitle,
      startDate: range === null || range === void 0 ? void 0 : range.from,
      endDate: range === null || range === void 0 ? void 0 : range.to,
      "data-test-id": "TravellingToWidget-TravelDateWiget"
    }), travellerInfoSection ? /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWigetV2, {
      countValue: countValue,
      showSelectSection: focusedIndex === 3,
      handleSelectSection: function handleSelectSection() {
        return handleClick(3);
      },
      travSelectTitle: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.selectTitle,
      postSelectTitle: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.postSelectTitle,
      postSelectDesc: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.postSelectDesc,
      travCountTitle: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.title,
      description: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.description,
      isAgeRangeSelected: isAgeRangeSelected,
      travAgeRange: travAgeRange,
      "data-test-id": "TravellingToWidget-TravellerCounterWigetV2"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWiget // ref={divRefs.current[1]}
    // showTravCount={focusedIndex == 1}
    , {
      captureCount: captureCount,
      travCountTitle: travCountTitle,
      handleCaptureCountIncr: handleCaptureCountIncr,
      handleCaptureCountDecr: handleCaptureCountDecr,
      "data-test-id": "TravellingToWidget-TravellerCounterWiget"
    }), focusedIndex == 0 && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(DatePickerComp_DatePickerComp, {
      startDateLabel: "Start Date",
      endDateLabel: "End Date",
      handleDayClick: handleDayClick,
      dateTab: dateTab,
      selected: range,
      from: range === null || range === void 0 ? void 0 : range.from,
      to: range === null || range === void 0 ? void 0 : range.to,
      maxEndDate: maxEndDate,
      toastMessage: toastMessage,
      showToast: showToast,
      "data-test-id": "TravellingToWidget-DatePickerComp"
    }), focusedIndex == 0 && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ReactPortalComp, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RangeDatePicker_RangeDatePicker, {
        calendarFooter: true,
        calendarHeader: true,
        onBackPress: function onBackPress() {
          return handleClick(0);
        },
        onSubmitButtonPress: handleSubmit,
        range: true,
        calenderRef: calenderRef,
        from: range === null || range === void 0 ? void 0 : range.from,
        to: range === null || range === void 0 ? void 0 : range.to,
        toastMessage: toastMessage,
        showToast: showToast,
        selected: range,
        handleDayClick: handleDayClick,
        maxEndDate: maxEndDate,
        "data-test-id": "TravellingToWidget-RangeDatePicker"
      })
    }), focusedIndex === 3 && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravAgeRangenCountPicker, {
      ageRangeSelectRef: ageRangeSelectRef,
      travellerInfoSelectSection: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.travellerInfoSelectSection,
      captureCount: captureCount,
      setTravAgeRange: setTravAgeRange,
      setCaptureCount: setCaptureCount,
      setIsAgeRangeSelectedError: setIsAgeRangeSelectedError,
      focusedIndex: focusedIndex,
      travAgeRange: travAgeRange !== null && travAgeRange !== void 0 ? travAgeRange : [],
      ageRangeSelectIndex: ageRangeSelectIndex,
      setAgeRangeSelectIndex: setAgeRangeSelectIndex,
      setFocusedIndex: setFocusedIndex,
      travellingToRef: travellingToRef,
      "data-test-id": "TravellingToWidget-TravAgeRangenCountPicker"
    }), focusedIndex === 3 && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ReactPortalComp, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravAgeRangenCountPicker, {
        ageRangeSelectRef: ageRangeSelectRef,
        travellerInfoSelectSection: travellerInfoSection === null || travellerInfoSection === void 0 ? void 0 : travellerInfoSection.travellerInfoSelectSection,
        captureCount: captureCount,
        setTravAgeRange: setTravAgeRange,
        setIsAgeRangeSelectedError: setIsAgeRangeSelectedError,
        setCaptureCount: setCaptureCount,
        focusedIndex: focusedIndex,
        travAgeRange: travAgeRange !== null && travAgeRange !== void 0 ? travAgeRange : [],
        ageRangeSelectIndex: ageRangeSelectIndex,
        setAgeRangeSelectIndex: setAgeRangeSelectIndex,
        setFocusedIndex: setFocusedIndex,
        "data-test-id": "TravellingToWidget-TravAgeRangenCountPicker"
      })
    })]
  });
};

/* harmony default export */ var TravellingToWidget_TravellingToWidget = (TravellingToWidget);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.style.ts






var WhatsCoveredStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhatsCoveredstyle__WhatsCoveredStyle",
  componentId: "sc-1tsmpyu-0"
})(["background:#fff;width:100%;", "{max-width:660px;font-weight:900;}", " @media ", "{padding:0 16px;", "{> ", "{overflow-y:auto;-webkit-overflow-scrolling:touch;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;}}}"], TextStyles_style/* H2TagStyle */.FI, function (p) {
  return p.pageTheme === src.PARTNER.MMT && "\n    ".concat(TextStyles_style/* H4TagStyle */.sz, "{\n        font-size:24px;\n        font-weight:900;\n    }\n    ");
}, static_utils/* deviceType.mobile */.vO.mobile, CommonStyles_style/* InnerContentWrap */.I, FlexCompStyle);
var WhatsCovered_style_BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhatsCoveredstyle__BenefitItem",
  componentId: "sc-1tsmpyu-1"
})(["flex:1;@media ", "{width:230px;flex-shrink:0;flex:none;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.tsx











var WhatsCovered = function WhatsCovered(_ref) {
  var data = _ref.data,
      title = _ref.title,
      info = _ref.info;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsCoveredStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "WhatsCovered-WhatsCoveredStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "WhatsCovered-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
        "data-test-id": "WhatsCovered-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H5Tag, {
        "data-test-id": "WhatsCovered-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
        fontSize: device == "lg" ? "large" : "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "0 0 66px",
        "data-test-id": "WhatsCovered-ParaTag",
        children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_FlexComp_FlexComp, {
        gap: device == "lg" ? "82px" : "24px",
        "data-test-id": "WhatsCovered-FlexComp",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhatsCovered_style_BenefitItem, {
            "data-test-id": `WhatsCovered-BenefitItem-${index}`,
            children: [item.cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
              width: device == "lg" ? "164px" : "80px",
              height: device == "lg" ? "164px" : "80px",
              src: item.cardImg,
              "data-test-id": "WhatsCovered-ImageComponent"
            }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H4Tag, {
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-H4Tag",
              children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_ParaTag, {
              fontSize: "large",
              fontWeight: "black",
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-ParaTag",
              children: [" ", item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
              fontSize: device == "lg" ? "large" : "sm",
              color: device == "lg" ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
              "data-test-id": "WhatsCovered-ParaTag",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                value: item.info,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var WhatsCovered_WhatsCovered = (WhatsCovered);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.style.ts




var WhyBuyTravInsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyTravInsStyle",
  componentId: "sc-1sprh6s-0"
})(["background:#fff;width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}@media ", "{padding:0 16px;", "}"], function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #EFF3F8;\n    padding-bottom:80px;\n    ";
}, TextStyles_style/* H2TagStyle */.FI, static_utils/* deviceType.mobile */.vO.mobile, static_utils/* deviceType.mobile */.vO.mobile, function (p) {
  return p.pageTheme === src.PARTNER.GI && "\n    background: #fff;\n    padding-top:16px;\n    ";
});
var WhyFeatListWrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyFeatListWrap",
  componentId: "sc-1sprh6s-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:16px;flex-shrink:0;@media ", "{width:100%;grid-template-columns:repeat(1,1fr);}img{margin-top:4px;}"], static_utils/* deviceType.mobile */.vO.mobile);
var WhyBuyItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyItem",
  componentId: "sc-1sprh6s-2"
})(["display:flex;gap:8px;padding:16px;background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;width:300px;flex-shrink:0;font-size:18px;line-height:25px;svg{flex-shrink:0;}@media ", "{width:100%;box-shadow:none;}"], static_utils/* deviceType.mobile */.vO.mobile);
var ShieldWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuyTravInsstyle__ShieldWrap",
  componentId: "sc-1sprh6s-3"
})(["position:absolute;right:-60px;z-index:-1;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.tsx











var WhyBuyTravIns = function WhyBuyTravIns(_ref) {
  var title = _ref.title,
      info = _ref.info,
      data = _ref.data;
  var device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  var context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuyTravInsStyle, {
    pageTheme: context ? context : undefined,
    "data-test-id": "WhyBuyTravIns-WhyBuyTravInsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "WhyBuyTravIns-InnerContentWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components_FlexComp_FlexComp // flexWrap="wrap"
      , {
        flexDirection: device == "lg" ? "row" : "column",
        alignItems: "center",
        gap: device == "lg" ? "74px" : "24px",
        "data-test-id": "WhyBuyTravIns-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_H2Tag, {
            margin: "0 0 60px",
            "data-test-id": "WhyBuyTravIns-H2Tag",
            children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyles_H5Tag, {
            margin: "0 0 20px",
            "data-test-id": "WhyBuyTravIns-H5Tag",
            children: [" ", title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_ParaTag, {
            fontSize: device == "lg" ? "large" : "sm",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "WhyBuyTravIns-ParaTag",
            children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
              value: info,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyFeatListWrap, {
          "data-test-id": "WhyBuyTravIns-WhyFeatListWrap",
          children: data && data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuyItem, {
              "data-test-id": `WhyBuyTravIns-WhyBuyItem-${index}`,
              children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
                src: item.icon,
                height: "24",
                width: "24",
                "data-test-id": "WhyBuyTravIns-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyles_SpanTag, {
                "data-test-id": "WhyBuyTravIns-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText_FormattedText/* default */.Z, {
                  value: item === null || item === void 0 ? void 0 : item.info,
                  "data-test-id": "WhyBuyTravIns-FormattedText"
                })
              })]
            }, index);
          })
        }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(ShieldWrap, {
          "data-test-id": "WhyBuyTravIns-ShieldWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent_ImageComponent, {
            width: "286px",
            height: "320px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg",
            "data-test-id": "WhyBuyTravIns-ImageComponent"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var WhyBuyTravIns_WhyBuyTravIns = (WhyBuyTravIns);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/index.tsx
































































































 // export { default as LandingFaq } from "./LandingFaq/LandingFaq";







/***/ }),

/***/ 6766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ DownArrow; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var DownArrow = function DownArrow(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "DownArrow",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M11.8583 13.3941C11.9364 13.4722 12.063 13.4722 12.1411 13.3941L16.2423 9.29289C16.6329 8.90237 17.266 8.90237 17.6566 9.29289C18.0471 9.68342 18.0471 10.3166 17.6566 10.7071L12.7068 15.6569C12.3163 16.0474 11.6831 16.0474 11.2926 15.6569L6.34285 10.7071C5.95232 10.3166 5.95232 9.68342 6.34285 9.29289C6.73337 8.90237 7.36654 8.90237 7.75706 9.29289L11.8583 13.3941Z",
      fill: "#008CFF"
    })
  }));
};

/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ EditIcon; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);


var _excluded = ["size", "color", "cursor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var EditIcon = function EditIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008CFF" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", _objectSpread(_objectSpread({
    style: {
      cursor: cursor
    },
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "EditIcon",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.378 5.45329C15.9045 4.9268 16.7581 4.9268 17.2846 5.45328L19.0567 7.2254C19.5832 7.75188 19.5832 8.60548 19.0567 9.13196L18.3203 9.86834C18.1097 10.0789 17.7683 10.0789 17.5577 9.86834L14.6416 6.95229C14.431 6.74169 14.431 6.40025 14.6416 6.18966L15.378 5.45329Z",
      fill: color
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1781 7.64303C13.3887 7.43244 13.7302 7.43244 13.9408 7.64303L16.8568 10.5591C17.0674 10.7697 17.0674 11.1111 16.8568 11.3217L10.3652 17.8134C10.2926 17.8859 10.1997 17.9347 10.0988 17.9532L6.59734 18.5945C6.25606 18.657 5.95467 18.365 6.00634 18.0219L6.55028 14.4106C6.56638 14.3038 6.61629 14.2049 6.69271 14.1285L13.1781 7.64303Z",
      fill: color
    })]
  }));
};

/***/ }),

/***/ 4204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ BlueChev; },
  "g8": function() { return /* reexport */ ChevronUpIcon; },
  "DI": function() { return /* reexport */ Confetti; },
  "Zp": function() { return /* reexport */ MMTIcon; },
  "rj": function() { return /* reexport */ StarEmpty; },
  "Um": function() { return /* reexport */ StarFull; },
  "im": function() { return /* reexport */ TripMoneyLogo; }
});

// UNUSED EXPORTS: DownArrow, EditIcon

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/BlueChev.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var BlueChev = function BlueChev(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "BlueChev",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00005 9.5L12.25 4.25L13.5 5.5L7.00005 12.0028L0.5 5.5L1.75 4.25L7.00005 9.5Z",
      fill: "#008CFF"
    })
  }));
};


// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/ChevronUpIcon.tsx


var _excluded = ["color", "cursor"];

function ChevronUpIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ChevronUpIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChevronUpIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChevronUpIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var ChevronUpIcon = function ChevronUpIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#008cff" : _ref$color,
      _ref$cursor = _ref.cursor,
      cursor = _ref$cursor === void 0 ? "pointer" : _ref$cursor,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", ChevronUpIcon_objectSpread(ChevronUpIcon_objectSpread({
    style: {
      cursor: cursor
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "ChevronUpIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.8583 10.6059C11.9364 10.5278 12.063 10.5278 12.1411 10.6059L16.2423 14.7071C16.6329 15.0976 17.266 15.0976 17.6566 14.7071V14.7071C18.0471 14.3166 18.0471 13.6834 17.6566 13.2929L12.7068 8.34315C12.3163 7.95262 11.6831 7.95262 11.2926 8.34315L6.34285 13.2929C5.95232 13.6834 5.95232 14.3166 6.34285 14.7071V14.7071C6.73337 15.0976 7.36654 15.0976 7.75706 14.7071L11.8583 10.6059Z",
      fill: color
    })
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/Confetti.tsx


function Confetti_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Confetti_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Confetti_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Confetti_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Confetti = function Confetti(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Confetti_objectSpread(Confetti_objectSpread({
    width: 279,
    height: 186,
    viewBox: "0 0 279 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "Confetti",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: 167.047,
      cy: 57.6006,
      rx: 4.08312,
      ry: 4.14746,
      fill: "#052F11",
      "data-test-id": "Confetti-ellipse"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: 96.0929,
      cy: 58.9172,
      rx: 2.05284,
      ry: 2.08519,
      fill: "#052F11",
      "data-test-id": "Confetti-ellipse"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: 184.522,
      cy: 91.1717,
      rx: 2.47839,
      ry: 2.51745,
      fill: "#052F11",
      "data-test-id": "Confetti-ellipse"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: 86.4608,
      cy: 118.832,
      rx: 2.47839,
      ry: 2.51745,
      fill: "#052F11",
      "data-test-id": "Confetti-ellipse"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M141.11 65.0256C145.431 60.2392 153.37 63.527 153.041 69.9673C152.834 74.0228 156.179 77.368 160.234 77.1611C166.674 76.8318 169.963 84.7706 165.176 89.0914C162.162 91.8129 162.162 96.5429 165.176 99.2645C169.963 103.586 166.674 111.524 160.234 111.196C156.179 110.988 152.834 114.333 153.041 118.389C153.37 124.829 145.431 128.117 141.11 123.33C138.389 120.316 133.659 120.316 130.937 123.33C126.615 128.117 118.678 124.829 119.006 118.389C119.214 114.333 115.869 110.988 111.813 111.196C105.373 111.524 102.085 103.586 106.871 99.2645C109.885 96.5429 109.885 91.8129 106.871 89.0914C102.085 84.7706 105.373 76.8318 111.813 77.1611C115.869 77.368 119.214 74.0228 119.006 69.9673C118.678 63.527 126.615 60.2392 130.937 65.0256C133.659 68.0397 138.389 68.0397 141.11 65.0256Z",
      fill: "url(#paint0_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M141.11 65.0256V65.0256C145.431 60.2392 153.37 63.527 153.041 69.9673C152.834 74.0228 156.179 77.368 160.234 77.1611C166.674 76.8318 169.963 84.7706 165.176 89.0914C162.162 91.8129 162.162 96.5429 165.176 99.2645C169.963 103.586 166.674 111.524 160.234 111.196C156.179 110.988 152.834 114.333 153.041 118.389C153.37 124.829 145.431 128.117 141.11 123.33C138.389 120.316 133.659 120.316 130.937 123.33C126.615 128.117 118.678 124.829 119.006 118.389C119.214 114.333 115.869 110.988 111.813 111.196C105.373 111.524 102.085 103.586 106.871 99.2645C109.885 96.5429 109.885 91.8129 106.871 89.0914C102.085 84.7706 105.373 76.8318 111.813 77.1611C115.869 77.368 119.214 74.0228 119.006 69.9673C118.678 63.527 126.615 60.2392 130.937 65.0256C133.659 68.0397 138.389 68.0397 141.11 65.0256",
      stroke: "#052F11",
      strokeWidth: 3.84498
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M121.699 95.1193L130.32 103.74L150.435 83.625",
      stroke: "#052F11",
      strokeWidth: 3.84498,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M219.806 11.7625C218.876 11.3514 217.919 11.0267 216.958 10.732C216.001 10.4355 215.032 10.1728 214.055 9.99866C214.179 10.0222 212.729 9.78728 212.793 9.99213C213.88 13.3471 212.352 17.234 210.728 19.8914C209.808 21.3937 208.602 22.5861 207.244 23.4084C206.661 23.7611 206.025 23.9713 205.392 24.1349C205.097 24.212 204.793 24.2482 204.489 24.2843C204.381 24.2979 204.272 24.295 204.161 24.2989C204.015 24.2635 203.873 24.2262 203.727 24.1909C203.129 24.0503 202.418 23.8357 201.797 23.9205C201.257 23.9935 202.173 24.4619 202.13 24.4381C202.896 24.8565 203.711 25.1323 204.516 25.4188C208.78 26.9319 213.235 28.1374 217.038 24.633C219.699 22.1824 222.277 16.6621 220.922 12.4817C220.801 12.0964 220.024 11.8579 219.804 11.7577L219.806 11.7625Z",
      fill: "url(#paint1_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M250.565 59.0618C250.927 59.222 251.3 59.3486 251.675 59.4635C252.048 59.579 252.425 59.6814 252.806 59.7493C252.758 59.7401 253.323 59.8317 253.298 59.7518C252.874 58.4442 253.47 56.9293 254.103 55.8935C254.462 55.308 254.932 54.8432 255.461 54.5227C255.688 54.3852 255.936 54.3033 256.183 54.2396C256.298 54.2095 256.416 54.1954 256.534 54.1813C256.577 54.176 256.619 54.1772 256.662 54.1757C256.719 54.1894 256.775 54.204 256.832 54.2178C257.065 54.2726 257.342 54.3562 257.584 54.3231C257.794 54.2947 257.437 54.1121 257.454 54.1214C257.156 53.9583 256.838 53.8508 256.524 53.7392C254.862 53.1494 253.126 52.6796 251.644 54.0455C250.606 55.0006 249.602 57.1522 250.13 58.7815C250.177 58.9317 250.48 59.0246 250.566 59.0637L250.565 59.0618Z",
      fill: "url(#paint2_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M214.489 103.654C215.178 106.788 215.864 109.923 216.553 113.057C216.475 112.707 220.813 110.797 220.718 110.365C220.029 107.231 219.344 104.096 218.655 100.962C218.733 101.312 214.394 103.222 214.489 103.654Z",
      fill: "url(#paint3_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M173.185 65.741C175.847 66.2212 178.509 66.7015 181.171 67.1817C180.875 67.1294 181.221 61.194 180.855 61.1314C178.193 60.6512 175.531 60.171 172.869 59.6907C173.165 59.743 172.819 65.6784 173.185 65.741Z",
      fill: "url(#paint4_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M59.1576 118.613C59.383 118.672 60.8262 115.349 60.9577 115.094C61.0742 114.862 62.5512 111.49 62.6988 111.53C59.7428 110.8 57.1597 109.105 54.9999 106.478C55.3043 106.847 51.087 113.108 51.4602 113.566C53.6201 116.194 56.2032 117.888 59.1592 118.618L59.1576 118.613Z",
      fill: "url(#paint5_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M250.592 107.131C253.176 110.107 256.208 112.201 259.598 113.354C259.8 113.424 260.835 112.793 260.933 112.745C262.003 112.238 263.068 111.717 264.133 111.195C265.199 110.674 265.03 111.617 266.091 111.081C266.122 111.066 267.266 110.348 267.402 110.394C264.012 109.241 260.979 107.148 258.395 104.171C258.093 103.824 255.47 104.675 255.092 104.86C254.756 105.024 250.809 107.379 250.592 107.131Z",
      fill: "url(#paint6_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M131.166 48.6691C130.889 48.546 129.33 48.1671 129.19 47.8361C130.364 50.6199 129.065 53.399 127.766 55.7004C126.695 57.5972 125.176 59.1399 123.352 59.352L126.264 61.0485C128.603 61.4168 130.365 59.6147 131.699 57.4089C133.053 55.182 134.273 52.267 133.123 49.5447C132.963 49.1619 131.467 48.7973 131.164 48.6642L131.166 48.6691Z",
      fill: "url(#paint7_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.0545 22.8896C12.4546 22.5164 11.832 22.1966 11.2065 21.8981C10.581 21.5995 9.94703 21.3188 9.29882 21.102C9.37842 21.1304 8.41748 20.8213 8.44875 20.967C8.95765 23.3409 7.6726 25.7966 6.39893 27.4171C5.67964 28.3304 4.78692 29.0092 3.82029 29.425C3.40521 29.6027 2.9617 29.6773 2.52387 29.7235C2.31917 29.7448 2.11163 29.7377 1.90694 29.7306C1.83302 29.7271 1.7591 29.7164 1.68518 29.7093C1.59136 29.6702 1.4947 29.6311 1.40088 29.592C1.00854 29.4356 0.542281 29.2189 0.121513 29.2082C-0.245238 29.2011 0.337583 29.6098 0.311995 29.592C0.800997 29.9509 1.33264 30.2246 1.85292 30.4982C4.62203 31.9588 7.54183 33.2346 10.3365 31.273C12.2925 29.9012 14.3935 26.4505 13.7595 23.4937C13.7027 23.2236 13.1966 22.9784 13.0545 22.8896Z",
      fill: "url(#paint8_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M78.8516 63.6931C80.3129 63.3377 82.2319 60.5231 82.1751 59.3681C82.0955 59.5671 79.7784 59.034 79.8665 58.8848C79.6704 59.9438 77.3732 61.6994 76 61.4044C76.0569 61.4435 77.1429 62.6696 77.285 62.7229C77.3703 62.8579 78.6895 63.7926 78.8516 63.6966V63.6931Z",
      fill: "url(#paint9_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M95.4083 9.33366C95.5334 9.09911 93.6627 6.20276 93.5234 5.96111C93.3983 5.74077 91.502 2.79113 91.5845 2.63477C89.9355 5.71945 87.7265 8.01875 85 9.48291C85.381 9.27679 88.3491 16.4377 88.821 16.1818C91.5475 14.7176 93.7565 12.4183 95.4055 9.33366H95.4083Z",
      fill: "url(#paint10_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.4083 115.584C14.5334 115.349 12.6627 112.453 12.5234 112.211C12.3983 111.991 10.502 109.041 10.5845 108.885C8.9355 111.969 6.72647 114.269 4 115.733C4.38097 115.527 7.34909 122.688 7.82103 122.432C10.5475 120.968 12.7565 118.668 14.4055 115.584H14.4083Z",
      fill: "url(#paint11_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M32.333 69.7695C35.1903 68.4084 37.6751 66.2655 39.7078 63.4118C39.8301 63.2412 39.8386 61.9867 39.8471 61.873C39.9467 60.6327 40.0348 59.396 40.1258 58.1557C40.2139 56.9155 40.2992 55.6752 40.3788 54.4349C40.3788 54.3994 40.3788 53.0063 40.4584 52.8926C38.4256 55.7498 35.9408 57.8892 33.0836 59.2503C32.7481 59.4102 32.6969 64.0657 32.6656 64.5064C32.6372 64.8973 32.5747 69.6558 32.333 69.7695Z",
      fill: "url(#paint12_linear_1129_15509)"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      "data-test-id": "Confetti-defs",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint0_linear_1129_15509",
        x1: 130.576,
        y1: 35.5895,
        x2: 76.2584,
        y2: 95.5823,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#4AFFCD",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#7DBFCC",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint1_linear_1129_15509",
        x1: 209.278,
        y1: 30.6128,
        x2: 216.802,
        y2: 6.36303,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#B4DF86",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#84C743",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint2_linear_1129_15509",
        x1: 254.668,
        y1: 51.7148,
        x2: 251.736,
        y2: 61.1663,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#B4DF86",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#84C743",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint3_linear_1129_15509",
        x1: 215.051,
        y1: 108.262,
        x2: 220.415,
        y2: 106.581,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F71873",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#C6211B",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint4_linear_1129_15509",
        x1: 172.315,
        y1: 62.2785,
        x2: 183.483,
        y2: 64.0504,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F71873",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F8A629",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint5_linear_1129_15509",
        x1: 60.9026,
        y1: 115.893,
        x2: 52.0739,
        y2: 111.483,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#BE1E68",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#B5188D",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint6_linear_1129_15509",
        x1: 260.738,
        y1: 114.32,
        x2: 254.675,
        y2: 101.936,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#B5188D",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#4E69AE",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint7_linear_1129_15509",
        x1: 126.048,
        y1: 61.945,
        x2: 136.85,
        y2: 46.2851,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F71873",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#C6211B",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint8_linear_1129_15509",
        x1: 4.83046,
        y1: 34.4623,
        x2: 12.1426,
        y2: 19.2222,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F71873",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#C6211B",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint9_linear_1129_15509",
        x1: 80.4465,
        y1: 57.648,
        x2: 76.8863,
        y2: 62.6449,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#6DD0E7",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#01A7DB",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint10_linear_1129_15509",
        x1: 94.0188,
        y1: 6.24712,
        x2: 85.4772,
        y2: 11.1176,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FBE422",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#C8D92B",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint11_linear_1129_15509",
        x1: 13.0188,
        y1: 112.497,
        x2: 4.47722,
        y2: 117.368,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FBE422",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#C8D92B",
          "data-test-id": "Confetti-stop"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint12_linear_1129_15509",
        x1: 40.2976,
        y1: 61.8037,
        x2: 30.9061,
        y2: 61.1345,
        gradientUnits: "userSpaceOnUse",
        "data-test-id": "Confetti-linearGradient",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F8B54A",
          "data-test-id": "Confetti-stop"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F8A629",
          "data-test-id": "Confetti-stop"
        })]
      })]
    })]
  }));
};


// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/DownArrow.tsx
var DownArrow = __webpack_require__(6766);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/EditIcon.tsx
var EditIcon = __webpack_require__(2384);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/MMTIcon.tsx


function MMTIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MMTIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MMTIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MMTIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MMTIcon = function MMTIcon(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", MMTIcon_objectSpread(MMTIcon_objectSpread({
    width: 86,
    height: 28,
    viewBox: "0 0 86 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "MMTIcon",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 37.2598,
      y: 4.68359,
      width: 23.8612,
      height: 22.4215,
      rx: 6,
      fill: "white",
      "data-test-id": "MMTIcon-rect"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask0_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 35,
      y: 0,
      width: 28,
      height: 28,
      "data-test-id": "MMTIcon-mask",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M62.6091 27.8695V0.365234H35.2988V27.8695H62.6091Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_1734_41229)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M60.3565 9.77361C59.0587 12.0098 56.74 16.8177 56.74 16.8177C56.74 16.8177 55.5721 19.4131 55.0783 22.0653C54.8587 23.2447 55.2827 24.6147 55.2827 24.6147C55.5999 25.9675 54.0972 25.5958 54.0972 25.5958C52.9995 25.2332 53.03 23.7589 53.03 23.7589C53.03 21.5828 53.9928 19.4794 54.557 18.0716C52.5746 18.8576 51.6475 16.9195 52.2116 14.9624L49.9456 18.0365C49.2164 18.8983 48.498 18.7296 48.498 18.7296C48.4615 18.7296 47.5896 18.6228 47.6337 17.4529C47.6551 16.8864 47.8134 14.5232 47.9949 13.6455C48.0133 13.5537 47.9589 13.4623 47.8859 13.5722C46.9409 15.2542 45.3924 17.0873 45.0845 17.5955C44.6851 18.2544 44.2844 18.5275 44.2844 18.5275C43.9624 18.7885 43.403 18.5912 43.403 18.5912C42.8298 18.3774 42.947 17.7255 42.947 17.7255L43.4898 13.7871C43.4898 13.7331 43.4719 13.7143 43.4172 13.7143C43.2538 13.7143 41.7173 15.8555 40.8695 17.3493L40.3144 18.252C40.3144 18.252 39.8351 19.0085 39.0948 18.5534C38.5159 18.1973 38.6979 17.5318 38.6979 17.5318L40.2856 10.8112C40.2856 10.7929 40.2856 10.6832 40.1943 10.6832C39.7034 10.6832 39.5637 11.9704 38.8925 11.9952C38.5548 12.0077 38.3808 11.8623 38.3808 11.8623C37.923 11.5974 38.1403 10.9105 38.1403 10.9105C38.1403 10.9105 38.8655 8.97975 39.8266 8.4945C39.8266 8.4945 40.3811 8.14464 40.843 8.20718C41.3051 8.26972 42.0443 8.38121 41.6563 10.5005L41.1715 13.2572C41.1715 13.2572 41.1231 13.4983 41.1982 13.5368C41.1982 13.5368 41.3179 13.6566 41.5593 13.333L44.6338 9.10418C45.2961 8.12532 46.0768 8.61909 46.0768 8.61909C46.5968 8.84109 46.4184 9.48236 46.4184 9.48236C46.4184 9.48236 44.903 14.1629 44.903 14.6016C44.903 14.748 45.0306 14.7842 45.1029 14.6751C45.7389 13.7056 47.0844 11.6023 48.2122 10.1944C48.7206 9.57273 49.0121 9.29818 49.5753 9.35319C50.1205 9.40804 50.3752 9.75544 50.3752 10.3041C50.3752 10.3956 50.3568 10.5053 50.3393 10.6151C50.3393 10.6151 49.3391 14.0715 49.2659 15.9184C49.2659 15.9184 49.2504 16.1839 49.3204 16.2376C49.4552 16.3411 49.6215 16.1081 49.6215 16.1081C50.1811 15.488 51.9707 12.6424 52.3752 11.8951L53.6699 9.24514C53.6699 9.24514 54.2194 8.03953 54.9533 8.22699C54.9533 8.22699 56.1209 8.34552 55.5568 9.62381C55.4643 9.83304 54.5754 11.2864 53.8114 14.2863C53.6843 14.7429 53.5204 16.0783 54.3382 16.0783C54.702 16.0783 55.175 15.7851 55.6658 14.8889L58.8834 9.07389C59.156 8.78084 59.3718 8.61909 59.7532 8.61909C60.9445 8.61909 60.3565 9.77361 60.3565 9.77361ZM62.6087 6.59235C62.6087 3.15774 59.8562 0.365234 56.4625 0.365234H41.4468C38.052 0.365234 35.2998 3.15774 35.2998 6.59235L35.3031 21.6389C35.3031 25.0725 38.0548 27.8696 41.4493 27.8696H56.4648C59.8593 27.8696 62.61 25.0733 62.61 21.6389L62.6087 6.59235Z",
        fill: "#EB2226"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask1_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 10,
      width: 11,
      height: 8,
      "data-test-id": "MMTIcon-mask",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 17.5647H10.3158V10.5566H0L0 17.5647Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask1_1734_41229)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.00933 17.5647H4.30673V13.7095C4.30673 13.1602 4.21981 12.7499 4.0468 12.4795C3.87363 12.209 3.58099 12.0735 3.16775 12.0735C2.86697 12.0735 2.59159 12.1481 2.34159 12.2978C2.09078 12.4479 1.87822 12.6609 1.70277 12.9371V17.5647H0V10.5634H0.969709L1.60983 11.505C1.74736 11.3792 1.95602 11.2205 2.12496 11.1107C2.29407 11.0008 2.47245 10.9042 2.66043 10.822C2.84793 10.74 3.04552 10.6758 3.25206 10.6279C3.4586 10.5802 3.67051 10.5566 3.88763 10.5566C4.13746 10.5566 4.358 10.5832 4.54728 10.6372C4.73755 10.6904 4.90535 10.7685 5.05134 10.8718C5.19734 10.9744 5.3251 11.0981 5.4335 11.2429C5.54206 11.3886 5.6376 11.5527 5.72109 11.7359C5.85471 11.6016 6.00592 11.4646 6.17518 11.3237C6.34413 11.1829 6.53097 11.0558 6.73556 10.9419C6.94014 10.8281 7.16312 10.7354 7.40514 10.6639C7.64749 10.5923 7.90985 10.5566 8.19419 10.5566C8.57765 10.5566 8.90381 10.6354 9.17367 10.7924C9.44287 10.9499 9.66178 11.1676 9.83104 11.4461C9.99999 11.7246 10.1224 12.0561 10.1999 12.4402C10.277 12.8246 10.3159 13.2436 10.3159 13.6967V17.5647H8.61313V13.7095C8.61313 13.1602 8.52768 12.7499 8.35646 12.4795C8.18556 12.209 7.89927 12.0735 7.49938 12.0735C7.19877 12.0735 6.92305 12.1439 6.67241 12.2843C6.42225 12.425 6.20139 12.6419 6.00933 12.9371V17.5647Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9324 14.3823H14.4049C13.9962 14.3823 13.6976 14.4792 13.5094 14.6372C13.3219 14.7945 13.228 15.0149 13.228 15.2966C13.228 15.5656 13.3074 15.7729 13.4661 15.9188C13.6246 16.0638 13.8667 16.1375 14.1917 16.1375C14.3883 16.1375 14.5747 16.111 14.7524 16.0586C14.93 16.0055 15.0935 15.9351 15.2438 15.8456C15.3937 15.756 15.5271 15.6503 15.6443 15.5263C15.7607 15.4029 15.8569 15.2724 15.9324 15.1354V14.3823ZM15.9317 16.7939C15.735 17.0092 15.4264 17.2102 15.0777 17.3553C14.7291 17.4994 14.3128 17.5722 13.8291 17.5722C13.491 17.5722 13.1863 17.5179 12.9145 17.4085C12.6434 17.3001 12.4114 17.1472 12.2173 16.9501C12.0233 16.753 11.8739 16.5207 11.7692 16.2517C11.6652 15.9824 11.6133 15.6887 11.6133 15.3691C11.6133 14.0646 12.6159 13.2355 14.2224 13.2355H15.919V12.8485C15.919 12.6095 15.7994 12.4214 15.5593 12.2852C15.3198 12.1489 14.9514 12.08 14.4547 12.08C13.9915 12.08 13.5626 12.1291 13.1686 12.2269C12.7746 12.324 12.556 12.4063 12.2179 12.5464L12.0075 11.0851C12.1323 11.0298 12.285 10.9715 12.4645 10.9099C12.6434 10.8482 12.8444 10.7914 13.0652 10.7382C13.2864 10.6861 13.5263 10.6421 13.7851 10.608C14.0434 10.5733 14.3152 10.5566 14.5987 10.5566C15.5836 10.5566 16.3232 10.7989 16.8179 11.2847C17.3119 11.7695 17.5593 12.4592 17.5593 13.3532V17.5647H16.3461L15.9317 16.7939Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.6119 10.4593L22.8357 13.9617L25.9934 17.5649H23.8528L20.9329 14.01V17.5649H19.2305V7.95508H20.9329V14.01L23.5336 10.4593H25.6119Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.3989 12.0668C29.1738 12.0668 28.9692 12.0946 28.7851 12.1509C28.6017 12.2071 28.441 12.2873 28.3035 12.3899C28.166 12.4932 28.0528 12.6177 27.9651 12.7635C27.8777 12.9105 27.8173 13.0715 27.7838 13.2475H30.8074C30.8074 13.0898 30.779 12.939 30.7224 12.7948C30.6664 12.6502 30.5798 12.5248 30.4626 12.4184C30.3461 12.311 30.1988 12.2259 30.0219 12.1622C29.8442 12.0987 29.637 12.0668 29.3989 12.0668ZM29.7177 16.0621C30.0182 16.0621 30.2906 16.0375 30.5346 15.9899C30.7787 15.9423 31.0011 15.8787 31.2011 15.8011C31.4018 15.723 31.5834 15.6323 31.7458 15.53C31.9084 15.4269 31.8518 15.4758 31.9852 15.3699L32.3137 16.8826C32.0129 17.0753 31.5881 17.2459 31.1602 17.3759C30.7327 17.5064 30.246 17.5722 29.6992 17.5722C29.1025 17.5722 28.5742 17.4879 28.1157 17.3204C27.6564 17.1524 27.269 16.917 26.9538 16.6123C26.6393 16.3077 26.3997 15.9423 26.2373 15.5141C26.0749 15.086 25.9932 14.6116 25.9932 14.0911C25.9932 13.6101 26.0675 13.1555 26.2155 12.7274C26.3636 12.2991 26.5807 11.9245 26.8664 11.6023C27.1523 11.2799 27.5058 11.0254 27.9274 10.8377C28.3492 10.6506 28.8354 10.5566 29.386 10.5566C29.9413 10.5566 30.4195 10.6457 30.8228 10.8237C31.2248 11.0018 31.557 11.2388 31.8174 11.5347C32.0787 11.8313 32.2714 12.1714 32.3972 12.5556C32.5223 12.9397 32.5682 13.338 32.5682 13.7504C32.5682 13.8616 32.5617 13.9894 32.5492 14.1329C32.5367 14.2764 32.5204 14.3982 32.4992 14.497H27.7526C27.7773 14.7391 27.84 14.9568 27.9401 15.1487C28.04 15.3413 28.1748 15.5048 28.3437 15.6397C28.513 15.7746 28.713 15.8787 28.9444 15.9519C29.1761 16.0256 29.434 16.0621 29.7177 16.0621Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M64.2822 11.5566L66.5825 8.80273H67.0869V10.5633H69.0522V12.0875H67.0869V14.9568C67.0869 15.1562 67.1106 15.3227 67.1588 15.456C67.2062 15.5883 67.2727 15.694 67.3564 15.7743C67.4392 15.8537 67.5353 15.9097 67.6435 15.9436C67.7522 15.9766 67.8674 15.993 67.9881 15.993C68.2133 15.993 68.4127 15.9714 68.5854 15.9277C68.759 15.8844 68.9128 15.8294 69.0461 15.7641V17.29C68.8621 17.3821 68.6692 17.4519 68.467 17.4998C68.2646 17.5485 68.0173 17.5722 67.725 17.5722C67.3121 17.5722 66.9571 17.5232 66.6613 17.4245C66.365 17.3258 66.1227 17.1837 65.9355 16.9959C65.7466 16.8076 65.608 16.5793 65.5187 16.3113C65.4292 16.0433 65.3836 15.7394 65.3836 15.3995V12.0875H64.2822V11.5566Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M71.955 12.006C72.1847 11.5864 72.5958 11.1824 72.936 10.9319C73.2757 10.6817 73.6842 10.5566 74.1593 10.5566C74.3219 10.5566 74.4552 10.5648 74.5572 10.581C74.6594 10.5972 74.7374 10.613 74.7918 10.6269C74.7918 10.6269 74.7374 11.0229 74.4788 12.2323C74.374 12.209 74.2491 12.1972 74.1028 12.1972C73.7815 12.1972 73.4952 12.2527 73.2423 12.3646C72.9899 12.4764 72.776 12.6375 72.6012 12.8469C72.4262 13.0568 72.2913 13.3144 72.1974 13.618C72.1028 13.9218 72.0563 14.2658 72.0563 14.6495V17.5647H70.3535V10.5632H71.4445L71.955 12.006Z",
      fill: "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask2_1734_41229",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: 79,
      y: 10,
      width: 7,
      height: 11,
      "data-test-id": "MMTIcon-mask",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.9243 20.3934V10.5566L79.2148 10.5566V20.3934H85.9243Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask2_1734_41229)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.5325 12.0876C82.316 12.0876 82.1192 12.1199 81.9443 12.1847C81.7694 12.2491 81.6147 12.333 81.481 12.4368C81.3473 12.5395 81.2328 12.6575 81.137 12.789C81.0409 12.92 80.963 13.0549 80.9055 13.1927V15.1809C80.9716 15.3009 81.0589 15.4147 81.1645 15.5222C81.2711 15.6293 81.3907 15.7236 81.5248 15.8053C81.6584 15.8868 81.807 15.952 81.9722 16.0019C82.1371 16.0509 82.3132 16.0754 82.5014 16.0754C82.7888 16.0754 83.0386 16.0283 83.2491 15.9335C83.4598 15.8397 83.6348 15.7074 83.7751 15.5381C83.9149 15.3679 84.0188 15.1642 84.0848 14.9257C84.1516 14.6876 84.1848 14.4244 84.1848 14.1364C84.1848 13.836 84.1454 13.5599 84.0656 13.3085C83.9867 13.057 83.8746 12.8414 83.7281 12.661C83.5813 12.4807 83.4078 12.3396 83.2053 12.2391C83.0023 12.1379 82.7787 12.0876 82.5325 12.0876ZM84.2999 10.8505C84.6698 11.0471 84.9753 11.3099 85.2169 11.6388C85.4592 11.9677 85.6376 12.3469 85.7525 12.7778C85.8669 13.2072 85.9244 13.6545 85.9244 14.1171C85.9244 14.5896 85.8638 15.0336 85.7429 15.4511C85.6218 15.8683 85.4395 16.2342 85.1954 16.5498C84.9512 16.8646 84.6475 17.1141 84.2841 17.2975C83.9216 17.481 83.496 17.5722 83.0074 17.5722C82.5318 17.5722 82.1303 17.5026 81.8025 17.3623C81.4751 17.2235 81.188 17.0185 80.9422 16.7482L80.9171 16.7628V20.3934H79.2148V10.5634H80.2331L80.8834 11.4162C81.1302 11.1626 81.4808 10.9162 81.8214 10.7724C82.1619 10.6285 82.5458 10.5566 82.9763 10.5566C83.4895 10.5566 83.9314 10.6554 84.2999 10.8505Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M76.5459 7.68164C76.0555 7.68164 75.6592 8.08111 75.6592 8.57406C75.6592 9.06717 76.0555 9.46697 76.5459 9.46697C77.0359 9.46697 77.4331 9.06717 77.4331 8.57406C77.4331 8.08111 77.0359 7.68164 76.5459 7.68164ZM75.695 17.5648H77.3974V10.5635H75.695V17.5648Z",
      fill: "white"
    })]
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/StarEmpty.tsx


var StarEmpty_excluded = ["width", "height"];

function StarEmpty_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarEmpty_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarEmpty_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarEmpty_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StarEmpty = function StarEmpty(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 26 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 25 : _ref$height,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarEmpty_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarEmpty_objectSpread(StarEmpty_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarEmpty",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0675 19.9704L6.05072 23.7389L7.3908 15.7571L1.71415 10.1044L9.55909 8.93983L13.0675 1.67773L16.5758 8.93983L24.4208 10.1044L18.7441 15.7571L20.0842 23.7389L13.0675 19.9704Z",
      fill: "#E2B634",
      fillOpacity: 0.1,
      stroke: "#E2B634",
      strokeOpacity: 0.4
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/StarFull.tsx


var StarFull_excluded = ["width", "height"];

function StarFull_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function StarFull_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StarFull_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StarFull_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StarFull = function StarFull(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 23 : _ref$height,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, StarFull_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", StarFull_objectSpread(StarFull_objectSpread({
    width: width,
    height: height,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    "data-test-id": "StarFull",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9415 18.9704L4.92475 22.7389L6.26482 14.7571L0.588172 9.10436L8.43311 7.93983L11.9415 0.677734L15.4498 7.93983L23.2948 9.10436L17.6181 14.7571L18.9582 22.7389L11.9415 18.9704Z",
      fill: "#E2B634"
    })
  }));
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/TripMoneyLogo.tsx




var TripMoneyLogo = function TripMoneyLogo(_ref) {
  var darkHeader = _ref.darkHeader,
      lightHeader = _ref.lightHeader;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: 140,
    height: 39,
    viewBox: "0 0 140 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "TripMoneyLogo",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.50765 10.3113V17.873C6.50765 18.5604 6.73679 18.7896 6.87427 18.8812C7.14924 19.0187 7.47004 19.1104 7.8825 19.1104C8.2033 19.1104 9.1657 18.8354 9.71564 18.6062L10.3114 18.4229V21.3101L10.0823 21.4476C9.25735 21.8601 8.38661 22.0892 7.47004 22.0892C3.89542 22.0892 3.11634 19.9353 3.11634 18.1021V10.3113H0L6.50765 3.75781V7.33243H10.3572V10.3113H6.50765Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M21.0806 7.05664V10.2646H20.3932C19.4308 10.2646 18.5142 10.4479 17.6435 10.8146C16.8644 11.1812 16.2686 11.6395 15.8103 12.2353V21.7218H12.4648V7.33161H14.8938L15.4895 9.07309C16.7727 7.74407 18.4225 7.10247 20.3473 7.10247H21.0806V7.05664Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.3506 3.57547C26.3506 4.53787 25.5716 5.31695 24.6092 5.31695C23.6468 5.31695 22.8677 4.53787 22.8677 3.57547C22.8677 2.61307 23.6468 1.83398 24.6092 1.83398C25.5257 1.83398 26.3506 2.61307 26.3506 3.57547Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.2132 7.33203H22.8677V21.8138H26.2132V7.33203Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M41.886 9.074C40.5112 7.69915 38.9072 7.01172 37.074 7.01172C35.2409 7.01172 33.4994 8.1116 32.7203 8.70737L32.0329 7.33252H29.604V27.9095H32.9495V20.6228C34.141 21.5852 35.5159 22.0893 37.0282 22.0893C38.8155 22.0893 40.3737 21.4477 41.7027 20.1645L41.8402 20.027C43.2151 18.6522 43.9025 16.819 43.9025 14.5734C43.9483 12.282 43.2609 10.4489 41.886 9.074ZM36.7074 18.8813C35.2867 18.8813 34.0494 18.3314 32.9495 17.1856V11.9154C34.0494 10.7697 35.2409 10.2197 36.7074 10.2197C37.899 10.2197 38.8155 10.5863 39.5488 11.3196C40.282 12.0529 40.6028 13.1527 40.6028 14.5276C40.6028 15.9024 40.2362 17.0023 39.5488 17.7356C38.8155 18.5147 37.899 18.8813 36.7074 18.8813Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M90.3266 9.11892C88.9976 7.74407 87.2103 7.05664 85.0563 7.05664C82.9024 7.05664 81.1151 7.74407 79.7861 9.11892C78.457 10.4938 77.8154 12.3269 77.8154 14.5267C77.8154 16.7723 78.5029 18.5596 79.7861 19.9344C81.1151 21.3093 82.9024 21.9967 85.0563 21.9967C87.2103 21.9967 88.9976 21.3093 90.3266 19.9344C91.6556 18.5596 92.3431 16.7265 92.3431 14.5267C92.2972 12.3269 91.6098 10.4938 90.3266 9.11892ZM85.0563 18.9262C84.0023 18.9262 83.0857 18.5596 82.3066 17.8263C81.5275 17.1389 81.1151 15.9932 81.1151 14.5267C81.1151 13.0602 81.5275 11.9603 82.2608 11.227C83.0399 10.4938 83.9565 10.1271 85.0105 10.1271C86.0646 10.1271 86.9811 10.4938 87.7602 11.227C88.5393 11.9145 88.9059 13.0143 88.9059 14.5267C88.9059 15.9932 88.4935 17.1389 87.7602 17.8263C87.027 18.5596 86.1104 18.9262 85.0563 18.9262Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M107.788 12.6935V21.7676H104.443V12.9685C104.443 11.0437 103.664 10.173 101.968 10.173C100.593 10.173 99.3099 10.9521 98.0725 12.4186V21.7676H94.7271V7.33161H97.156L97.7976 9.07309C99.2182 7.74407 100.776 7.05664 102.564 7.05664C104.168 7.05664 105.451 7.60658 106.413 8.70647C107.33 9.76052 107.788 11.1354 107.788 12.6935Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M122.132 17.5981C120.849 18.423 119.474 18.8355 118.008 18.8355C116.541 18.8355 115.441 18.5147 114.754 17.9189C114.158 17.4148 113.791 16.7274 113.608 15.8108H123.782V14.0235C123.69 12.1445 123.14 10.5405 122.086 9.21149C120.941 7.74497 119.199 7.01172 116.999 7.01172C114.8 7.01172 113.104 7.74497 111.912 9.21149C110.767 10.678 110.171 12.5111 110.171 14.7109C110.171 16.9107 110.812 18.698 112.142 20.027C113.425 21.356 115.166 21.9976 117.32 21.9976C119.382 21.9976 121.261 21.5394 122.82 20.6686L123.003 20.6228L122.82 17.1856L122.132 17.5981ZM113.562 12.9694C113.7 12.0529 114.066 11.3654 114.616 10.9071C115.304 10.3114 116.083 10.0364 116.954 10.0364C117.824 10.0364 118.603 10.3114 119.291 10.9071C119.887 11.4113 120.253 12.0987 120.345 12.9694H113.562Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M139.18 7.33203L138.951 7.9278L130.656 27.909H127.219L129.694 21.5389L123.919 7.33203H127.494L131.481 17.3685L135.606 7.33203H139.18Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M46.2866 7.43108C46.2866 2.92739 49.214 0 53.7177 0H68.1858C72.6895 0 75.6169 2.92739 75.6169 7.43108V21.8992C75.6169 26.4028 72.6895 29.3302 68.1858 29.3302H53.7177C49.214 29.3302 46.2866 26.4028 46.2866 21.8992V7.43108Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask0_841_14902",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 46,
      y: 0,
      width: 30,
      height: 30,
      "data-test-id": "TripMoneyLogo-mask",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M46.2866 7.43108C46.2866 2.92739 49.214 0 53.7177 0H68.1858C72.6895 0 75.6169 2.92739 75.6169 7.43108V21.8992C75.6169 26.4028 72.6895 29.3302 68.1858 29.3302H53.7177C49.214 29.3302 46.2866 26.4028 46.2866 21.8992V7.43108Z",
        fill: "#ED1C24"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_841_14902)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M66.7918 14.4442C66.5085 15.7447 66.2613 19.2464 66.228 20.0858C66.1947 20.9251 66.4676 21.4404 67.1385 21.7724C67.7125 22.0566 68.2539 22.0493 68.7759 21.6781C68.9716 21.5389 68.6731 19.3183 68.7759 17.812C68.9895 14.6816 70.4515 9.95402 70.4515 9.95402L70.4557 9.92885C70.4818 9.77456 70.5076 9.62172 70.5076 9.49311C70.5076 8.68021 70.11 8.16544 69.2589 8.08418C68.3798 8.00267 67.9247 8.40948 67.131 9.33057C65.3705 11.4168 63.2701 14.5333 62.2771 15.9698C62.1643 16.1314 61.9651 16.0778 61.9651 15.8609C61.9651 15.2108 64.3308 8.27558 64.3308 8.27558C64.3308 8.27558 64.6093 7.32538 63.7975 6.99643C63.7975 6.99643 62.5787 6.2648 61.5449 7.71521L56.7454 13.9811C56.3686 14.4607 56.1816 14.2832 56.1816 14.2832C56.0645 14.2262 56.14 13.8688 56.14 13.8688L56.8968 9.78421C57.5026 6.64396 56.3486 6.47876 55.6272 6.38609C54.9062 6.29343 54.0405 6.81183 54.0405 6.81183C52.5402 7.53085 51.4081 10.3916 51.4081 10.3916C51.4081 10.3916 51.0689 11.4095 51.7836 11.802C51.7836 11.802 52.0552 12.0174 52.5824 11.999C53.6302 11.9621 53.8482 10.0549 54.6145 10.0549C54.757 10.0549 54.757 10.2175 54.757 10.2446L52.2785 20.2027C52.2785 20.2027 51.9945 21.1888 52.8982 21.7164C54.0538 22.3908 54.802 21.2698 54.802 21.2698L55.6687 19.9322C56.9921 17.7189 59.3906 14.5461 59.6457 14.5461C59.7311 14.5461 59.759 14.574 59.759 14.6541L58.9117 20.4897C58.9117 20.4897 58.7287 21.4556 59.6236 21.7724C59.6236 21.7724 60.4968 22.0648 60.9994 21.6781C60.9994 21.6781 61.6249 21.2735 62.2484 20.2971C62.7291 19.5441 65.1464 16.8279 66.6216 14.3356C66.7356 14.1728 66.8205 14.3082 66.7918 14.4442Z",
        fill: "white"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M32.4 37.304L31.7584 35.7459H29.7877L29.192 37.304H28.5962L30.521 32.4004H31.0251L32.9499 37.304H32.4ZM31.6209 35.2418L31.0251 33.6836C31.0251 33.6378 30.9793 33.5919 30.9793 33.5003C30.9334 33.4086 30.9334 33.317 30.8876 33.2253C30.8418 33.1336 30.8418 33.042 30.796 32.9962C30.796 33.0878 30.7501 33.1795 30.7043 33.2711C30.6585 33.3628 30.6585 33.4544 30.6126 33.5003C30.5668 33.5919 30.5668 33.6378 30.5668 33.6836L29.971 35.2418H31.6209Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37.6705 37.304L36.0206 32.9503H35.9748C35.9748 33.042 35.9748 33.1336 36.0206 33.2711C36.0206 33.4086 36.0206 33.5461 36.0206 33.6836C36.0206 33.8211 36.0206 34.0044 36.0206 34.1419V37.2582H35.4707V32.4004H36.3414L37.8996 36.4791H37.9454L39.5494 32.4004H40.3743V37.304H39.8244V34.1419C39.8244 34.0044 39.8244 33.8669 39.8244 33.6836C39.8244 33.5461 39.8244 33.4086 39.8244 33.2711C39.8244 33.1336 39.8244 33.042 39.8244 32.9503H39.7786L38.0829 37.304H37.6705V37.304Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M43.0317 33.5469C43.4899 33.5469 43.8107 33.6385 44.0399 33.8218C44.269 34.0052 44.3607 34.326 44.3607 34.7842V37.3048H43.9482L43.8566 36.7549H43.8107C43.7191 36.8924 43.5816 36.984 43.4899 37.0757C43.3983 37.1673 43.2608 37.2132 43.0775 37.259C42.94 37.3048 42.7567 37.3048 42.5275 37.3048C42.2984 37.3048 42.1151 37.259 41.9318 37.1673C41.7485 37.0757 41.611 36.984 41.5193 36.8007C41.4277 36.6632 41.3818 36.4341 41.3818 36.2049C41.3818 35.8383 41.5193 35.5633 41.8401 35.38C42.1151 35.1967 42.5734 35.0592 43.1691 35.0592L43.8107 35.0134V34.7842C43.8107 34.4634 43.7191 34.2343 43.5816 34.0968C43.4441 33.9593 43.2608 33.9135 42.9858 33.9135C42.8025 33.9135 42.6192 33.9593 42.4359 34.0052C42.2526 34.051 42.1151 34.1426 41.9318 34.1885L41.7485 33.776C41.9318 33.6844 42.1151 33.6385 42.3442 33.5469C42.5734 33.5927 42.8025 33.5469 43.0317 33.5469ZM43.7649 35.4717L43.215 35.5175C42.7567 35.5175 42.4359 35.6092 42.2526 35.7466C42.0693 35.8841 41.9776 36.0674 41.9776 36.2966C41.9776 36.5257 42.0234 36.6632 42.1609 36.7549C42.2984 36.8465 42.4817 36.8924 42.665 36.8924C42.9858 36.8924 43.2608 36.8007 43.4899 36.6174C43.7191 36.4341 43.8107 36.1591 43.8107 35.7925V35.4717H43.7649Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M46.0563 32.0801V34.784C46.0563 34.8756 46.0563 34.9673 46.0563 35.1048C46.0563 35.2422 46.0563 35.3339 46.0563 35.4256H46.1021C46.1479 35.3797 46.2396 35.2881 46.3313 35.1506C46.4229 35.0589 46.5146 34.9673 46.5604 34.8756L47.7978 33.5924H48.4394L46.927 35.1506L48.531 37.2587H47.8436L46.5146 35.5172L46.0563 35.9297V37.2587H45.5063V32.0801H46.0563Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M50.5937 33.5469C50.9145 33.5469 51.1895 33.6385 51.4187 33.776C51.6478 33.9135 51.8311 34.0968 51.9228 34.3718C52.0603 34.6009 52.1061 34.9217 52.1061 35.2425V35.6092H49.5397C49.5397 36.0216 49.6772 36.3882 49.8605 36.6174C50.0896 36.8465 50.3646 36.9382 50.7312 36.9382C50.9604 36.9382 51.1895 36.9382 51.3728 36.8924C51.5561 36.8465 51.7395 36.8007 51.9228 36.709V37.1215C51.7395 37.2132 51.5561 37.259 51.3728 37.3048C51.1895 37.3506 50.9604 37.3506 50.7312 37.3506C50.3646 37.3506 50.0438 37.259 49.8147 37.1215C49.5397 36.984 49.3564 36.7549 49.2189 36.4799C49.0814 36.2049 48.9897 35.8383 48.9897 35.4717C48.9897 35.0592 49.0356 34.7384 49.1731 34.4634C49.3105 34.1885 49.4939 33.9593 49.723 33.776C49.9521 33.6385 50.2271 33.5469 50.5937 33.5469ZM50.5479 34.0052C50.2271 34.0052 49.998 34.0968 49.8147 34.2801C49.6313 34.4634 49.5397 34.7384 49.4939 35.105H51.4645C51.4645 34.8759 51.4187 34.6926 51.3728 34.5093C51.327 34.326 51.1895 34.2343 51.052 34.1426C50.9604 34.051 50.7771 34.0052 50.5479 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M55.314 37.304L53.6642 32.9503H53.6184C53.6184 33.042 53.6184 33.1336 53.6642 33.2711C53.6642 33.4086 53.6642 33.5461 53.6642 33.6836C53.6642 33.8211 53.6642 34.0044 53.6642 34.1419V37.2582H53.1143V32.4004H53.985L55.5432 36.4791H55.589L57.193 32.4004H58.0179V37.304H57.468V34.1419C57.468 34.0044 57.468 33.8669 57.468 33.6836C57.468 33.5461 57.468 33.4086 57.468 33.2711C57.468 33.1336 57.468 33.042 57.468 32.9503L55.7723 37.304H55.314V37.304Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M58.7051 33.6387H59.3008L60.1258 35.7926C60.1716 35.9301 60.2174 36.0218 60.2632 36.1592C60.3091 36.2509 60.3549 36.3884 60.3549 36.48C60.3549 36.5717 60.4007 36.7092 60.4466 36.8008H60.4924C60.5382 36.7092 60.584 36.5259 60.6299 36.3426C60.6757 36.1592 60.7674 35.9759 60.8132 35.7926L61.5923 33.6845H62.188L60.584 37.9007C60.4924 38.1299 60.4007 38.3132 60.2632 38.4965C60.1716 38.6798 60.0341 38.7715 59.8508 38.8631C59.6675 38.9548 59.4842 39.0006 59.255 39.0006C59.1634 39.0006 59.0717 39.0006 58.9801 39.0006C58.8884 39.0006 58.8426 38.9548 58.7509 38.9548V38.4965C58.7967 38.4965 58.8426 38.4965 58.9342 38.5423C59.0259 38.5423 59.0717 38.5423 59.1634 38.5423C59.3008 38.5423 59.4383 38.4965 59.53 38.4507C59.6216 38.4048 59.7133 38.3132 59.805 38.2215C59.8966 38.1299 59.9424 37.9924 59.9883 37.8549L60.1716 37.3508L58.7051 33.6387Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M64.3873 37.304H63.7916V32.9045H62.2334V32.4004H65.9455V32.9045H64.3873V37.304V37.304Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M68.2831 33.5469C68.3747 33.5469 68.4205 33.5469 68.5122 33.5469C68.6039 33.5469 68.6497 33.5469 68.7413 33.5927L68.6497 34.0968C68.6039 34.0968 68.5122 34.051 68.4664 34.051C68.3747 34.051 68.3289 34.051 68.2372 34.051C68.0997 34.051 67.9623 34.0968 67.8248 34.1426C67.6873 34.1885 67.5956 34.2801 67.4581 34.4176C67.3665 34.5093 67.2748 34.6468 67.229 34.8301C67.1832 34.9676 67.1373 35.1509 67.1373 35.3342V37.3048H66.5874V33.6385H67.0457L67.0915 34.326H67.1373C67.229 34.1885 67.3207 34.051 67.4123 33.9593C67.504 33.8677 67.6415 33.776 67.7789 33.6844C67.9623 33.5927 68.0997 33.5469 68.2831 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M69.9796 33.6385V37.3048H69.4296V33.6385H69.9796ZM69.7046 32.2637C69.7962 32.2637 69.8879 32.3095 69.9337 32.3553C69.9796 32.4012 70.0254 32.4928 70.0254 32.6303C70.0254 32.7678 69.9796 32.8594 69.9337 32.9053C69.8879 32.9511 69.7962 32.9969 69.7046 32.9969C69.6129 32.9969 69.5213 32.9511 69.4754 32.9053C69.4296 32.8594 69.3838 32.7678 69.3838 32.6303C69.3838 32.4928 69.4296 32.4012 69.4754 32.3553C69.5671 32.2637 69.6129 32.2637 69.7046 32.2637Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M72.9583 33.5469C73.4166 33.5469 73.7832 33.6844 74.0582 34.0052C74.3331 34.326 74.4706 34.7842 74.4706 35.4258C74.4706 35.8383 74.4248 36.2049 74.2873 36.4799C74.1498 36.7549 73.9665 36.984 73.7374 37.1215C73.5082 37.259 73.2332 37.3506 72.9124 37.3506C72.7291 37.3506 72.5458 37.3048 72.4083 37.259C72.2709 37.2132 72.1334 37.1215 72.0417 37.0298C71.9501 36.9382 71.8584 36.8465 71.7667 36.7549H71.7209C71.7209 36.8465 71.7209 36.9382 71.7667 37.0757C71.7667 37.2132 71.7667 37.3048 71.7667 37.3965V38.9546H71.2168V33.6385H71.6751L71.7667 34.1885H71.8126C71.9042 34.0968 71.95 33.9593 72.0875 33.8677C72.1792 33.776 72.3167 33.6844 72.4542 33.6385C72.5458 33.5927 72.7291 33.5469 72.9583 33.5469ZM72.8208 34.0052C72.5458 34.0052 72.3625 34.051 72.1792 34.1426C72.0417 34.2343 71.9042 34.3718 71.8584 34.6009C71.7667 34.7842 71.7667 35.0592 71.7209 35.3342V35.4258C71.7209 35.7466 71.7667 36.0216 71.8126 36.2049C71.9042 36.4341 71.9959 36.5716 72.1334 36.709C72.3167 36.8007 72.5 36.8924 72.775 36.8924C73.0041 36.8924 73.1874 36.8465 73.3707 36.709C73.5082 36.5716 73.6457 36.4341 73.6915 36.2049C73.7832 35.9758 73.829 35.7466 73.829 35.4258C73.829 35.0134 73.7374 34.6468 73.5541 34.3718C73.4624 34.1426 73.1874 34.0052 72.8208 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M79.4661 34.7375H81.2076V37.1206C80.9326 37.2122 80.6576 37.2581 80.3827 37.3039C80.1077 37.3497 79.7869 37.3497 79.4661 37.3497C78.962 37.3497 78.5037 37.2581 78.1829 37.0289C77.8163 36.8456 77.5413 36.5248 77.358 36.1582C77.1747 35.7916 77.083 35.3333 77.083 34.8292C77.083 34.325 77.1747 33.8668 77.4038 33.5001C77.5871 33.1335 77.9079 32.8127 78.2745 32.6294C78.6412 32.4002 79.0995 32.3086 79.6494 32.3086C79.9244 32.3086 80.1993 32.3544 80.4285 32.4002C80.6576 32.4461 80.8868 32.5377 81.1159 32.6294L80.8868 33.1335C80.7035 33.0419 80.5201 32.996 80.291 32.9502C80.0619 32.9044 79.8327 32.8585 79.6036 32.8585C79.1911 32.8585 78.8703 32.9502 78.5495 33.0877C78.2745 33.271 78.0454 33.5001 77.9079 33.7751C77.7704 34.0959 77.6788 34.4167 77.6788 34.8292C77.6788 35.2416 77.7246 35.6082 77.8621 35.8832C77.9996 36.204 78.1829 36.4332 78.5037 36.5706C78.7787 36.754 79.1453 36.7998 79.6036 36.7998C79.8327 36.7998 80.016 36.7998 80.1993 36.754C80.3827 36.7081 80.5201 36.7081 80.6576 36.6623V35.15H79.4661V34.7375Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M84.0023 33.5469C84.094 33.5469 84.1398 33.5469 84.2314 33.5469C84.3231 33.5469 84.3689 33.5469 84.4606 33.5927L84.3689 34.0968C84.3231 34.0968 84.2314 34.051 84.1856 34.051C84.094 34.051 84.0481 34.051 83.9565 34.051C83.819 34.051 83.6815 34.0968 83.544 34.1426C83.4065 34.1885 83.3149 34.2801 83.1774 34.4176C83.0857 34.5093 82.9941 34.6468 82.9482 34.8301C82.9024 34.9676 82.8566 35.1509 82.8566 35.3342V37.3048H82.3066V33.6385H82.7649L82.8108 34.326H82.8566C82.9482 34.1885 83.0399 34.051 83.1316 33.9593C83.2232 33.8677 83.3607 33.776 83.4982 33.6844C83.6357 33.5927 83.819 33.5469 84.0023 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M88.357 35.4708C88.357 35.7916 88.3112 36.0207 88.2195 36.2957C88.1278 36.5248 88.0362 36.754 87.8987 36.8914C87.7612 37.0748 87.5779 37.1664 87.3488 37.2581C87.1196 37.3497 86.8905 37.3956 86.6155 37.3956C86.3864 37.3956 86.1572 37.3497 85.9281 37.2581C85.7448 37.1664 85.5614 37.0289 85.3781 36.8914C85.2406 36.7081 85.1032 36.5248 85.0115 36.2957C84.9199 36.0665 84.874 35.7916 84.874 35.4708C84.874 35.0583 84.9657 34.7375 85.1032 34.4625C85.2407 34.1876 85.424 33.9584 85.6989 33.8209C85.9739 33.6835 86.2489 33.5918 86.6155 33.5918C86.9363 33.5918 87.2571 33.6835 87.4862 33.8209C87.7612 33.9584 87.9445 34.1876 88.082 34.4625C88.2653 34.6917 88.357 35.0583 88.357 35.4708ZM85.5156 35.4708C85.5156 35.7457 85.5614 36.0207 85.6531 36.2498C85.7448 36.479 85.8364 36.6165 86.0197 36.754C86.203 36.8914 86.3864 36.9373 86.6613 36.9373C86.9363 36.9373 87.1196 36.8914 87.3029 36.754C87.4862 36.6165 87.5779 36.479 87.6696 36.2498C87.7612 36.0207 87.807 35.7916 87.807 35.4708C87.807 35.1958 87.7612 34.9208 87.6696 34.6917C87.5779 34.4625 87.4862 34.3251 87.3029 34.1876C87.1196 34.0501 86.9363 34.0043 86.6613 34.0043C86.2947 34.0043 85.9739 34.1417 85.7906 34.3709C85.6073 34.6459 85.5156 35.0125 85.5156 35.4708Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M92.3888 33.6385V37.3048H91.9305L91.8389 36.8007C91.7472 36.9382 91.6555 37.0298 91.5181 37.1215C91.3806 37.2132 91.2431 37.259 91.1056 37.3048C90.9681 37.3506 90.7848 37.3506 90.6015 37.3506C90.3265 37.3506 90.0515 37.3048 89.8682 37.2132C89.6849 37.1215 89.5016 36.984 89.4099 36.7549C89.3183 36.5716 89.2725 36.2966 89.2725 35.9758V33.5469H89.8224V35.93C89.8224 36.2508 89.9141 36.4799 90.0516 36.6174C90.189 36.7549 90.4182 36.8465 90.6931 36.8465C90.9681 36.8465 91.1973 36.8007 91.3347 36.709C91.5181 36.6174 91.6097 36.4341 91.7014 36.2508C91.793 36.0674 91.793 35.7925 91.793 35.5175V33.5927H92.3888V33.6385Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M95.323 33.5469C95.7813 33.5469 96.1479 33.6844 96.4229 34.0052C96.6979 34.326 96.8354 34.7842 96.8354 35.4258C96.8354 35.8383 96.7895 36.2049 96.6521 36.4799C96.5146 36.7549 96.3313 36.984 96.1021 37.1215C95.873 37.259 95.598 37.3506 95.2772 37.3506C95.0939 37.3506 94.9106 37.3048 94.7731 37.259C94.6356 37.2132 94.4981 37.1215 94.4065 37.0298C94.3148 36.9382 94.2231 36.8465 94.1315 36.7549H94.0857C94.0857 36.8465 94.0857 36.9382 94.1315 37.0757C94.1315 37.2132 94.1315 37.3048 94.1315 37.3965V38.9546H93.5815V33.6385H94.0398L94.1315 34.1885H94.1773C94.269 34.0968 94.3148 33.9593 94.4523 33.8677C94.5439 33.776 94.6814 33.6844 94.8189 33.6385C94.9564 33.5927 95.1397 33.5469 95.323 33.5469ZM95.2314 34.0052C94.9564 34.0052 94.7731 34.051 94.5898 34.1426C94.4523 34.2343 94.3148 34.3718 94.269 34.6009C94.1773 34.7842 94.1773 35.0592 94.1315 35.3342V35.4258C94.1315 35.7466 94.1773 36.0216 94.2231 36.2049C94.3148 36.4341 94.4065 36.5716 94.5439 36.709C94.7273 36.8007 94.9106 36.8924 95.1855 36.8924C95.4147 36.8924 95.598 36.8465 95.7813 36.709C95.9188 36.5716 96.0563 36.4341 96.1021 36.2049C96.1938 35.9758 96.2396 35.7466 96.2396 35.4258C96.2396 35.0134 96.1479 34.6468 95.9646 34.3718C95.8271 34.1426 95.598 34.0052 95.2314 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M101.83 32.8127C101.555 32.8127 101.326 32.8585 101.097 32.9502C100.868 33.0419 100.684 33.1793 100.547 33.3627C100.409 33.546 100.272 33.7293 100.18 34.0042C100.088 34.2334 100.043 34.5542 100.043 34.8292C100.043 35.2416 100.088 35.6082 100.226 35.8832C100.363 36.204 100.547 36.4332 100.822 36.5706C101.097 36.754 101.417 36.7998 101.784 36.7998C102.013 36.7998 102.197 36.7998 102.426 36.754C102.609 36.7081 102.792 36.6623 103.021 36.6165V37.1206C102.838 37.1664 102.655 37.2581 102.472 37.2581C102.288 37.3039 102.059 37.3039 101.784 37.3039C101.28 37.3039 100.868 37.2122 100.501 36.9831C100.18 36.754 99.9051 36.479 99.7218 36.1124C99.5385 35.7457 99.4927 35.2874 99.4927 34.7833C99.4927 34.4167 99.5385 34.0959 99.6302 33.7751C99.7218 33.4543 99.9051 33.1793 100.088 32.996C100.272 32.7669 100.547 32.5836 100.822 32.4919C101.097 32.3544 101.463 32.3086 101.83 32.3086C102.059 32.3086 102.334 32.3544 102.563 32.4002C102.792 32.4461 103.021 32.5377 103.205 32.6294L102.976 33.1335C102.838 33.0419 102.655 32.996 102.472 32.9502C102.242 32.8585 102.059 32.8127 101.83 32.8127Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M107.238 35.4708C107.238 35.7916 107.192 36.0207 107.1 36.2957C107.009 36.5248 106.917 36.754 106.78 36.8914C106.642 37.0748 106.459 37.1664 106.23 37.2581C106 37.3497 105.771 37.3956 105.496 37.3956C105.267 37.3956 105.038 37.3497 104.809 37.2581C104.626 37.1664 104.442 37.0289 104.259 36.8914C104.122 36.7081 103.984 36.5248 103.892 36.2957C103.801 36.0665 103.755 35.7916 103.755 35.4708C103.755 35.0583 103.847 34.7375 103.984 34.4625C104.122 34.1876 104.305 33.9584 104.58 33.8209C104.855 33.6835 105.13 33.5918 105.496 33.5918C105.817 33.5918 106.138 33.6835 106.367 33.8209C106.642 33.9584 106.825 34.1876 106.963 34.4625C107.146 34.6917 107.238 35.0583 107.238 35.4708ZM104.396 35.4708C104.396 35.7457 104.442 36.0207 104.534 36.2498C104.626 36.479 104.717 36.6165 104.901 36.754C105.084 36.8914 105.267 36.9373 105.542 36.9373C105.817 36.9373 106 36.8914 106.184 36.754C106.367 36.6165 106.459 36.479 106.55 36.2498C106.642 36.0207 106.688 35.7916 106.688 35.4708C106.688 35.1958 106.642 34.9208 106.55 34.6917C106.459 34.4625 106.367 34.3251 106.184 34.1876C106 34.0501 105.817 34.0043 105.542 34.0043C105.176 34.0043 104.855 34.1417 104.671 34.3709C104.488 34.6459 104.396 35.0125 104.396 35.4708Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M112.234 33.5469C112.646 33.5469 112.967 33.6385 113.15 33.8677C113.379 34.0968 113.471 34.4176 113.471 34.8759V37.3048H112.921V34.9217C112.921 34.6468 112.875 34.4176 112.738 34.2343C112.6 34.0968 112.417 34.0052 112.142 34.0052C111.775 34.0052 111.5 34.0968 111.363 34.326C111.18 34.5093 111.134 34.8301 111.134 35.2425V37.3048H110.584V34.9217C110.584 34.7384 110.538 34.5551 110.492 34.4176C110.446 34.2801 110.355 34.1885 110.217 34.1426C110.126 34.0968 109.942 34.051 109.805 34.051C109.576 34.051 109.346 34.0968 109.209 34.1885C109.071 34.2801 108.934 34.4176 108.888 34.6468C108.842 34.8301 108.797 35.105 108.797 35.38V37.3048H108.247V33.6385H108.705L108.797 34.1426H108.842C108.934 34.0052 109.026 33.9135 109.117 33.8218C109.209 33.7302 109.346 33.6844 109.484 33.6385C109.621 33.5927 109.759 33.5927 109.942 33.5927C110.217 33.5927 110.446 33.6385 110.63 33.7302C110.813 33.8218 110.95 34.0052 111.042 34.1885H111.088C111.225 33.9593 111.363 33.8218 111.592 33.7302C111.73 33.5927 111.959 33.5469 112.234 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M116.357 33.5469C116.815 33.5469 117.182 33.6844 117.457 34.0052C117.732 34.326 117.87 34.7842 117.87 35.4258C117.87 35.8383 117.824 36.2049 117.686 36.4799C117.549 36.7549 117.365 36.984 117.136 37.1215C116.907 37.259 116.632 37.3506 116.311 37.3506C116.128 37.3506 115.945 37.3048 115.807 37.259C115.67 37.2132 115.532 37.1215 115.441 37.0298C115.349 36.9382 115.257 36.8465 115.166 36.7549H115.12C115.12 36.8465 115.12 36.9382 115.166 37.0757C115.166 37.2132 115.166 37.3048 115.166 37.3965V38.9546H114.616V33.6385H115.074L115.166 34.1885H115.211C115.303 34.0968 115.395 33.9593 115.486 33.8677C115.578 33.776 115.716 33.6844 115.853 33.6385C115.991 33.5927 116.174 33.5469 116.357 33.5469ZM116.266 34.0052C115.991 34.0052 115.807 34.051 115.624 34.1426C115.486 34.2343 115.349 34.3718 115.303 34.6009C115.211 34.7842 115.211 35.0592 115.166 35.3342V35.4258C115.166 35.7466 115.211 36.0216 115.257 36.2049C115.349 36.4341 115.441 36.5716 115.578 36.709C115.761 36.8007 115.945 36.8924 116.22 36.8924C116.449 36.8924 116.632 36.8465 116.815 36.709C116.953 36.5716 117.09 36.4341 117.136 36.2049C117.228 35.9758 117.274 35.7466 117.274 35.4258C117.274 35.0134 117.182 34.6468 116.999 34.3718C116.861 34.1426 116.632 34.0052 116.266 34.0052Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M120.252 33.5469C120.711 33.5469 121.031 33.6385 121.261 33.8218C121.49 34.0052 121.581 34.326 121.581 34.7842V37.3048H121.169L121.077 36.7549H121.031C120.94 36.8924 120.802 36.984 120.711 37.0757C120.619 37.1673 120.482 37.2132 120.298 37.259C120.161 37.3048 119.977 37.3048 119.748 37.3048C119.519 37.3048 119.336 37.259 119.152 37.1673C118.969 37.0757 118.832 36.984 118.74 36.8007C118.648 36.6632 118.603 36.4341 118.603 36.2049C118.603 35.8383 118.74 35.5633 119.061 35.38C119.336 35.1967 119.794 35.0592 120.39 35.0592L121.031 35.0134V34.7842C121.031 34.4634 120.986 34.2343 120.802 34.0968C120.665 33.9593 120.482 33.9135 120.207 33.9135C120.023 33.9135 119.84 33.9593 119.657 34.0052C119.473 34.051 119.29 34.1426 119.152 34.1885L118.969 33.776C119.152 33.6844 119.336 33.6385 119.565 33.5469C119.794 33.5927 120.023 33.5469 120.252 33.5469ZM121.031 35.4717L120.482 35.5175C120.023 35.5175 119.702 35.6092 119.519 35.7466C119.336 35.8841 119.244 36.0674 119.244 36.2966C119.244 36.5257 119.29 36.6632 119.427 36.7549C119.565 36.8465 119.748 36.8924 119.932 36.8924C120.252 36.8924 120.527 36.8007 120.756 36.6174C120.986 36.4341 121.077 36.1591 121.077 35.7925V35.4717H121.031Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M124.47 33.5469C124.928 33.5469 125.249 33.6385 125.478 33.8677C125.707 34.0968 125.799 34.4176 125.799 34.8759V37.259H125.294V34.9217C125.294 34.6009 125.203 34.3718 125.065 34.2343C124.928 34.0968 124.699 34.0052 124.424 34.0052C124.011 34.0052 123.736 34.1426 123.553 34.3718C123.37 34.6009 123.324 34.9217 123.324 35.38V37.3048H122.774V33.6385H123.232L123.324 34.1885H123.37C123.461 34.051 123.553 33.9593 123.69 33.8677C123.828 33.776 123.965 33.7302 124.103 33.6844C124.149 33.5927 124.332 33.5469 124.47 33.5469Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M126.394 33.6387H126.989L127.814 35.7926C127.86 35.9301 127.906 36.0218 127.952 36.1592C127.998 36.2509 128.043 36.3884 128.043 36.48C128.043 36.5717 128.089 36.7092 128.135 36.8008H128.181C128.227 36.7092 128.273 36.5259 128.318 36.3426C128.364 36.1592 128.456 35.9759 128.502 35.7926L129.281 33.6845H129.877L128.273 37.9007C128.181 38.1299 128.089 38.3132 127.952 38.4965C127.86 38.6798 127.723 38.7715 127.539 38.8631C127.356 38.9548 127.173 39.0006 126.944 39.0006C126.852 39.0006 126.76 39.0006 126.669 39.0006C126.577 39.0006 126.531 38.9548 126.439 38.9548V38.4965C126.485 38.4965 126.531 38.4965 126.623 38.5423C126.714 38.5423 126.76 38.5423 126.852 38.5423C126.989 38.5423 127.127 38.4965 127.218 38.4507C127.31 38.4048 127.402 38.3132 127.493 38.2215C127.585 38.1299 127.631 37.9924 127.677 37.8549L127.86 37.3508L126.394 33.6387Z",
      fill: lightHeader ? "white" : darkHeader ? "#124680" : "white"
    })]
  });
};


;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/index.ts










/***/ }),

/***/ 8524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PartnerContextProvider; },
/* harmony export */   "X": function() { return /* binding */ usePartnerContext; }
/* harmony export */ });
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4928);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2322);



var PartnerContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var usePartnerContext = function usePartnerContext() {
  var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PartnerContext);

  if (context === null) {
    console.error("usePartnerContext must be used within a PartnerContextProvider");
  }

  return context;
};
var PartnerContextProvider = function PartnerContextProvider(_ref) {
  var hostname = _ref.hostname,
      children = _ref.children,
      partnerType = _ref.partnerType;
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    var element = document.getElementById("pageId");
    element.classList.remove("mmtTheme", "giTheme");

    if (partnerType === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.MMT) {
      element.classList.add("mmtTheme");
    } else if (partnerType === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.PARTNER.GI) {
      element.classList.add("giTheme");
    }
  }, [partnerType]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(PartnerContext.Provider, {
    value: partnerType,
    children: children
  });
};

/***/ }),

/***/ 4576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ isHostMakemytrip; },
/* harmony export */   "IZ": function() { return /* binding */ calendarLabelFormatter; },
/* harmony export */   "P9": function() { return /* binding */ convertUnixToDate; },
/* harmony export */   "cJ": function() { return /* binding */ convertDateToUnix; },
/* harmony export */   "gg": function() { return /* binding */ MONTHS; },
/* harmony export */   "lv": function() { return /* binding */ DATE_FORMATS; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "sI": function() { return /* binding */ generateSourceSetImageUrl; },
/* harmony export */   "vH": function() { return /* binding */ LONG_WEEK_DAYS; },
/* harmony export */   "vO": function() { return /* binding */ deviceType; }
/* harmony export */ });
/* unused harmony exports breakpoint, randomDayData, dayAdditionalData, SHORT_WEEK_DAYS, mfActiveTypeMatch, insertBrOnNewLine, isOnServer, TRIPMONEY_MMT_DOMAIN_NAMES */
// RESPONSIVE BREAKPOINTS
var breakpoint = {
  mobile: 768
};
var deviceType = {
  mobile: "(max-width: ".concat(breakpoint.mobile, "px)"),
  desktop: "(min-width: ".concat(breakpoint.mobile, "px)")
}; // CALENDAR UTILITY FUNCTIONS

var randomDayData = function randomDayData() {
  var min = 10000;
  var max = 15000;
  var randomNum = Math.floor(Math.random() * (max - min + 1) + min);
  return {
    price: "\u20B9".concat(randomNum),
    class: randomNum <= 12000 ? "greenText" : "redText",
    isSoldOut: randomNum > 12000 && randomNum < 13000,
    availableOnPreviousDate: randomNum >= 13000 && randomNum <= 13500
  };
};
var dayAdditionalData = new Array(31).fill(0).map(function () {
  return randomDayData();
});
var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
var SHORT_WEEK_DAYS = (/* unused pure expression or super */ null && (["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"]));
var LONG_WEEK_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var mfActiveTypeMatch = {
  0: "Option 1",
  1: "Option 2",
  2: "Option 3"
}; // FOR DISPAYING INSIDE THE CALENDAR

var calendarLabelFormatter = function calendarLabelFormatter(dateObj) {
  return dateObj ? "".concat(dateObj.getDate(), " ").concat(MONTHS[dateObj.getMonth()], "' ").concat(dateObj.getFullYear().toString().slice(-2)) : "".concat(new Date().getDate(), " ").concat(MONTHS[new Date().getMonth()], "' ").concat(new Date().getFullYear().toString().slice(-2));
};
var insertBrOnNewLine = function insertBrOnNewLine(text) {
  return text.replace(/\n/g, "<br/>");
};
insertBrOnNewLine("hello he\nyello");
var generateSourceSetImageUrl = function generateSourceSetImageUrl(cdnUrlWidths, imgUrl, width) {
  var imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(function (width) {
    return "".concat(imgUrl, "?im=Resize=(").concat(width, ") ").concat(width, "w");
  }).join(",");
};
var convertDateToUnix = function convertDateToUnix(date) {
  return Math.floor(new Date(date).getTime() / 1000);
};
var convertUnixToDate = function convertUnixToDate(unix) {
  return new Date(unix * 1000);
};
var DATE_FORMATS;

(function (DATE_FORMATS) {
  DATE_FORMATS["DDD"] = "ddd";
  DATE_FORMATS["YY"] = "yy";
  DATE_FORMATS["YYYY"] = "yyyy";
  DATE_FORMATS["D MMM"] = "d MMM";
  DATE_FORMATS["DD/MM/YYYY"] = "dd/MM/yyyy";
  DATE_FORMATS["DD MMM YY"] = "dd MMM'yy";
})(DATE_FORMATS || (DATE_FORMATS = {}));

var MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var formatDate = function formatDate(date, format) {
  try {
    date = new Date(date);

    switch (format) {
      case DATE_FORMATS["DD MMM YY"]:
        return "".concat(date.getDate(), " ").concat(MONTHS_SHORT[date.getMonth()], "'").concat(date.getFullYear().toString().substr(-2));

      default:
        return;
    }
  } catch (error) {
    console.log("Error in formatting given date", date, format);
  }

  return;
};
/* istanbul ignore next */

var isOnServer = function isOnServer() {
  if (false) {}

  return false;
};
var TRIPMONEY_MMT_DOMAIN_NAMES = ["tripmoney.makemytrip.com", "www.makemytrip.com"];
/* istanbul ignore next */

var isHostMakemytrip = function isHostMakemytrip() {
  if (isOnServer()) return false;
  var url = new URL(window.location.href);
  return TRIPMONEY_MMT_DOMAIN_NAMES.includes(url.hostname);
};

/***/ }),

/***/ 1175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ErrorScreen; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2182);
/* harmony import */ var _tm_server_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3611);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7109);
/* harmony import */ var _tm_ui_hoc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7800);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6780);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2322);










var analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)();
var ErrorScreen = function ErrorScreen(_ref) {
  var _error$message3, _error$message4, _error$message5;

  var error = _ref.error,
      _ref$trackError = _ref.trackError,
      trackError = _ref$trackError === void 0 ? false : _ref$trackError,
      pageName = _ref.pageName;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (trackError && pageName && error && typeof error !== "string") {
      var _error$message, _error$message2;

      analytics === null || analytics === void 0 ? void 0 : analytics.trackPageLoadErrorEvent({
        pageName: pageName,
        actionType: "page_load_error",
        error: "".concat(error === null || error === void 0 ? void 0 : (_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.title, "|\n                  ").concat(error === null || error === void 0 ? void 0 : (_error$message2 = error.message) === null || _error$message2 === void 0 ? void 0 : _error$message2.description)
      });
    }
  }, [error, pageName, trackError]);
  var title = typeof error !== "string" && (error === null || error === void 0 ? void 0 : (_error$message3 = error.message) === null || _error$message3 === void 0 ? void 0 : _error$message3.title) || "Sorry!";
  var description = typeof error !== "string" && (error === null || error === void 0 ? void 0 : (_error$message4 = error.message) === null || _error$message4 === void 0 ? void 0 : _error$message4.description) || "We are having trouble communicating with the servers. Please try again.";
  var icon = typeof error !== "string" && (error === null || error === void 0 ? void 0 : (_error$message5 = error.message) === null || _error$message5 === void 0 ? void 0 : _error$message5.icon) || "https://tripmoneycmsimgak.mmtcdn.com/img/error_Img_1e80a42832.svg";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      "data-test-id": "ErrorScreen-Head",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("title", {
        "data-test-id": "ErrorScreen-title",
        children: "Tripmoney Error"
      })
    }), (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__/* .withDeviceProvider */ .JK)((0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_5__/* .withPartnerInsuranceHeader */ .Pw)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(___WEBPACK_IMPORTED_MODULE_6__/* .ErrorPage */ .mf, {
      title: title,
      info: description,
      errorImg: icon,
      headerComponent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {}),
      "data-test-id": "ErrorScreen-ErrorPage"
    })), (0,_tm_server_utils__WEBPACK_IMPORTED_MODULE_3__/* .akamaiGetDevice */ .tZ)({}))]
  });
};

/***/ }),

/***/ 6780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SV": function() { return /* reexport */ ErrorBoundary; },
  "mf": function() { return /* reexport */ ErrorPage; },
  "Cs": function() { return /* reexport */ ErrorScreen/* ErrorScreen */.C; }
});

// UNUSED EXPORTS: ErrorImg, ErrorPageStyle

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(129);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__(4214);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorBoundary/index.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      //   @TODO: Replace this with Sentry
      //   logErrorToMyService(error, info.componentStack);
      console.error("componentDidCatch", error);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        var _this$props$onError, _this$props;

        // You can render any custom fallback UI
        var error = this.state.error.getErrorMessage ? this.state.error.getErrorMessage() : this.state.error;
        return ((_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props, error)) || /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorScreen/* ErrorScreen */.C, {
          error: error,
          "data-test-id": "ErrorBoundary-ErrorScreen"
        });
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true,
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(react.Component);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(4576);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var WHITE_COLOR = {
  "60": "rgba(255, 255, 255, 0.6)"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Header404/index.style.ts


var LandingHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "indexstyle__LandingHeader",
  componentId: "sc-18byzfg-0"
})(["height:80px;position:fixed;top:0;width:100%;z-index:1;color:", ";z-index:40;& .displayNone{display:none;}"], WHITE_COLOR[60]);
var LandingHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingHeaderWrap",
  componentId: "sc-18byzfg-1"
})(["width:1200px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:80px;position:relative;"]);
var TMLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "indexstyle__TMLogo",
  componentId: "sc-18byzfg-2"
})(["width:140px;height:40px;flex-shrink:0;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Header404/index.tsx



/* istanbul ignore next */




var Header = function Header() {
  if (!(0,src.isOnServer)()) {
    var toHome = function toHome() {
      window.location.href = "/";
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeader, {
      "data-test-id": "Header-LandingHeader",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingHeaderWrap, {
        "data-test-id": "Header-LandingHeaderWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TMLogo, {
          "data-test-id": "Header-TMLogo",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: (0,utils/* isHostMakemytrip */.Ho)() ? "https://tripmoneycmsimgak.mmtcdn.com/img/mmt_logo_007ad76964.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/gi_logo_1_dd53c8c777.svg",
            alt: "Blue mmt logo",
            onClick: toHome
          })
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

/* harmony default export */ var Header404 = (Header);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 347 modules
var components = __webpack_require__(6306);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Image/utils.ts
/* istanbul ignore next */
var generateSourceSetImageUrl = function generateSourceSetImageUrl(cdnUrlWidths, imgUrl, width) {
  var imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(function (width) {
    return "".concat(imgUrl, "?im=Resize=(").concat(width, ") ").concat(width, "w");
  }).join(",");
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx



var Image = function Image(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$cdnUrlWidths = _ref.cdnUrlWidths,
      cdnUrlWidths = _ref$cdnUrlWidths === void 0 ? [] : _ref$cdnUrlWidths,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? "" : _ref$sizes;

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith(".svg")) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      "data-test-id": "Image"
    });
  }

  var srcsetUrl = generateSourceSetImageUrl(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
    "data-test-id": "Image-picture",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width,
      "data-test-id": "Image-source"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height
    })]
  });
};
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(2874);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/ErrorPage/index.tsx








var ErrorImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ErrorPage__ErrorImg",
  componentId: "lynp6-0"
})(["width:230px;height:230px;margin-bottom:16px;align-self:center;"]);
var ErrorPageStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ErrorPage__ErrorPageStyle",
  componentId: "lynp6-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;width:100vw;"]);
var ErrorPage = function ErrorPage(_ref) {
  var errorImg = _ref.errorImg,
      title = _ref.title,
      info = _ref.info,
      errorEvent = _ref.errorEvent,
      headerComponent = _ref.headerComponent,
      button1 = _ref.button1,
      button2 = _ref.button2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [headerComponent || /*#__PURE__*/(0,jsx_runtime.jsx)(Header404, {
      "data-test-id": "ErrorPage-Header"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorPageStyle, {
      "data-test-id": "ErrorPage-ErrorPageStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ErrorImg, {
        "data-test-id": "ErrorPage-ErrorImg",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: errorImg,
          width: "230",
          height: "230",
          alt: "Error",
          "data-test-id": "ErrorPage-Image"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* H3Tag */.AI, {
        color: Global/* theme.blackText */.rS.blackText,
        "data-test-id": "ErrorPage-H3Tag",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ParaTag */.dZ, {
        textAlign: "center",
        color: Global/* theme.greyText */.rS.greyText,
        fontSize: "md",
        lineHeight: "32px",
        "data-test-id": "ErrorPage-ParaTag",
        children: info
      }), button1 && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButtonWhite */.Gv, {
        customTitle: button1,
        customWidth: "100%",
        margin: "32px 0 0",
        "data-test-id": "ErrorPage-LandingButtonWhite"
      }), button2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* LandingButtonWhite */.Gv, {
        customTitle: button2,
        customWidth: "100%",
        margin: "32px 0 0",
        "data-test-id": "ErrorPage-LandingButtonWhite"
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/ErrorScreen/index.tsx
var ErrorScreen = __webpack_require__(1175);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/index.ts




/***/ }),

/***/ 131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XF": function() { return /* reexport */ ClientError; },
  "St": function() { return /* reexport */ getSessionStorageItem; },
  "LC": function() { return /* reexport */ utils/* loadGTM */.LC; },
  "lD": function() { return /* reexport */ removeSessionStorageItem; },
  "D9": function() { return /* reexport */ setSessionStorageItem; }
});

// UNUSED EXPORTS: TRIPMONEY_MMT_DOMAIN_NAMES, disableEncrytionInWeb, getDeviceModelType, getHostName, getUtilOptions, isHostMakemytrip

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(129);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__(4214);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(8200);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(303);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/ClientError/index.ts







function _createSuper(Derived) { var hasNativeReflectConstruct = ClientError_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function ClientError_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ClientError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(ClientError, _Error);

  var _super = _createSuper(ClientError);

  function ClientError(message) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ClientError);

    _this = _super.call(this);
    _this.message = message;
    return _this;
  }

  (0,createClass/* default */.Z)(ClientError, [{
    key: "getErrorMessage",
    value: function getErrorMessage() {
      return this.message;
    }
  }]);

  return ClientError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
// EXTERNAL MODULE: ../../node_modules/MMT-UI/storages/client/localStorage/index.js
var localStorage = __webpack_require__(156);
// EXTERNAL MODULE: ../../node_modules/MMT-UI/storages/client/sessionStorage/index.js
var sessionStorage = __webpack_require__(8456);
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/index.ts + 2 modules
var utils = __webpack_require__(4927);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/utils/clientStorageUtils.ts
// prettier-ignore
//@ts-ignore
 // prettier-ignore
//@ts-ignore



/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/
// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

var ES = localStorage.itemType.ES,
    N_ES = localStorage.itemType.N_ES;

function getEssentialItemType(isEssential) {
  return isEssential ? ES : N_ES;
} // sesstion storage utils


function setSessionStorageItem(key, value) {
  var isEssential = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    shouldStringifyJson: true
  };
  options = (0,utils/* getUtilOptions */.Bv)(options);
  (0,sessionStorage.setItemBySession)(key, value, options, getEssentialItemType(isEssential));
}
function getSessionStorageItem(key) {
  var isEssential = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    shouldParseJson: true
  };
  options = (0,utils/* getUtilOptions */.Bv)(options);
  return (0,sessionStorage.getItemBySession)(key, options, getEssentialItemType(isEssential));
}
function removeSessionStorageItem(key) {
  (0,sessionStorage.removeItemBySession)(key);
}
;// CONCATENATED MODULE: ../../libs/utility/src/index.ts




/***/ }),

/***/ 2182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ getAnalytics; }
});

// UNUSED EXPORTS: setLandingPageAnalytics

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 6 modules
var utils = __webpack_require__(1725);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6412);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(3089);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/constants.ts

var LOB_NAME_TM_INS = (0,utils/* isPartnerMMT */.rS)() ? "desktop tripmoney insurance" : "tripmoney insurance";
var LOB_NAME_PS_INS = (0,utils/* isPartnerMMT */.rS)() ? "desktop ps tripmoney insurance" : "ps tripmoney insurance";
var FUNNEL_SITE_SECTION = (0,utils/* isPartnerMMT */.rS)() ? "desktop tripmoney insurance Funnel" : "tripmoney insurance Funnel";
var LANDING_SITE_SECTION = "landing";
var PAGE_NAMES_MAP_MMT = {
  LANDING: "desktop:landing:mmt_insurance:homepage",
  LANDING_RETAIL: "desktop:landing:mmt_insurance:homepage_retail",
  LISTING: "desktop:funnel:mmt_insurance:listing",
  REVIEW: "desktop:funnel:mmt_insurance:review",
  PAYMENT: "desktop:funnel:mmt_insurance:payment",
  THANK_YOU_POLICY: "desktop:funnel:mmt_insurance:TY_policy",
  THANK_YOU_PASSPORT: "desktop:funnel:mmt_insurance:TY_passport",
  ADD_PASSPORT: "desktop:funnel:mmt_insurance:add_passport",
  ORDER_SUMMARY: "desktop:post_Sales:mmt_insurance:order_summary",
  ORDER_DETAILS: "desktop:post_Sales:mmt_insurance:order_details"
};
var PAGE_NAMES_MAP_GI = {
  LANDING: "landing:tripmoney insurance:landing",
  LANDING_RETAIL: "landing:tripmoney insurance:homepage_retail",
  LISTING: "funnel:tripmoney insurance:listing",
  REVIEW: "funnel:tripmoney insurance:review",
  PAYMENT: "funnel:tripmoney insurance:payment",
  THANK_YOU_POLICY: "funnel:tripmoney insurance:thankyoupolicy",
  THANK_YOU_PASSPORT: "funnel:tripmoney insurance:thankyoupassport",
  ADD_PASSPORT: "funnel:tripmoney insurance:addpassport",
  ORDER_SUMMARY: "post sales:ps_tripmoney insurance:order_summary",
  ORDER_DETAILS: "post sales:ps_tripmoney insurance:order_details"
};
var PAGE_NAMES_MAP = (0,utils/* isPartnerMMT */.rS)() ? PAGE_NAMES_MAP_MMT : PAGE_NAMES_MAP_GI;
var pageNameCategoryMap = {
  LANDING: {
    pageName: PAGE_NAMES_MAP["LANDING"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  LANDING_RETAIL: {
    pageName: PAGE_NAMES_MAP["LANDING_RETAIL"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION
  },
  LISTING: {
    pageName: PAGE_NAMES_MAP["LISTING"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  REVIEW: {
    pageName: PAGE_NAMES_MAP["REVIEW"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  PAYMENT: {
    pageName: PAGE_NAMES_MAP["PAYMENT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  THANK_YOU_POLICY: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_POLICY"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  THANK_YOU_PASSPORT: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  ADD_PASSPORT: {
    pageName: PAGE_NAMES_MAP["ADD_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION
  },
  ORDER_DETAILS: {
    pageName: PAGE_NAMES_MAP["ORDER_DETAILS"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA"
  },
  ORDER_SUMMARY: {
    pageName: PAGE_NAMES_MAP["ORDER_SUMMARY"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA"
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/IAnalytics.ts
var landingPageAnalytics;
var setLandingPageAnalytics = function setLandingPageAnalytics(analytics) {
  landingPageAnalytics = analytics;
};
var getLandingPageAnalytics = function getLandingPageAnalytics() {
  return landingPageAnalytics;
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/MmtAnalytics.ts





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var omnitureMap = {
  pageName: "eVar15",
  lob: "eVar24",
  siteSection: "m_ch",
  destination: "eVar31",
  ctaAction: "prop52",
  departureDate: "prop4",
  arrivalDate: "prop5",
  noOftravellers: "eVar8",
  travelPurpose: "eVar12",
  sumInsured: "prop46",
  bookingId: "eVar16",
  bookingStatus: "eVar14",
  errorCode: "eVar22",
  cmp: "m_v81",
  experiment: "eVar120"
};
var MmtAnalytics = /*#__PURE__*/function () {
  function MmtAnalytics() {
    (0,classCallCheck/* default */.Z)(this, MmtAnalytics);
  }

  (0,createClass/* default */.Z)(MmtAnalytics, [{
    key: "trackEvent",
    value: function trackEvent(pageName, omniData) {
      if (true) {
        omniData = _objectSpread(_objectSpread({}, omniData), {}, {
          pageName: pageName
        });

        if (window.omniscriptLoaded) {
          if (typeof window.s !== "undefined") {
            var _window$s, _window$s$t;

            for (var _i = 0, _Object$entries = Object.entries(omniData); _i < _Object$entries.length; _i++) {
              var _Object$entries$_i = (0,slicedToArray/* default */.Z)(_Object$entries[_i], 2),
                  key = _Object$entries$_i[0],
                  value = _Object$entries$_i[1];

              window.s[key] = value;
            }

            (_window$s = window.s) === null || _window$s === void 0 ? void 0 : (_window$s$t = _window$s.t) === null || _window$s$t === void 0 ? void 0 : _window$s$t.call(_window$s);
          }
        } else {
          var _window$omnidata, _window$omnidata$push;

          (_window$omnidata = window.omnidata) === null || _window$omnidata === void 0 ? void 0 : (_window$omnidata$push = _window$omnidata.push) === null || _window$omnidata$push === void 0 ? void 0 : _window$omnidata$push.call(_window$omnidata, omniData);
        }
      }
    }
  }, {
    key: "trackPageLoadEvent",
    value: function trackPageLoadEvent(event) {
      var _objectSpread2;

      var _pageNameCategoryMap$ = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName],
          pageName = _pageNameCategoryMap$.pageName,
          lob = _pageNameCategoryMap$.lob,
          siteSection = _pageNameCategoryMap$.siteSection;

      var omniData = _objectSpread(_objectSpread(_objectSpread((_objectSpread2 = {}, (0,defineProperty/* default */.Z)(_objectSpread2, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_objectSpread2, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_objectSpread2, omnitureMap["siteSection"], siteSection), _objectSpread2), (event === null || event === void 0 ? void 0 : event.bookingId) && (0,defineProperty/* default */.Z)({}, omnitureMap["bookingId"], event.bookingId)), (event === null || event === void 0 ? void 0 : event.bookingStatus) && (0,defineProperty/* default */.Z)({}, omnitureMap["bookingStatus"], event.bookingStatus)), (event === null || event === void 0 ? void 0 : event.experiment) && (0,defineProperty/* default */.Z)({}, omnitureMap["experiment"], event.experiment));

      if (event.pageName === "LISTING") {
        omniData = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, omniData), event.country && (0,defineProperty/* default */.Z)({}, omnitureMap["destination"], event.country)), event.startDate && (0,defineProperty/* default */.Z)({}, omnitureMap["departureDate"], event.startDate)), event.endDate && (0,defineProperty/* default */.Z)({}, omnitureMap["arrivalDate"], event.endDate)), event.purpose && (0,defineProperty/* default */.Z)({}, omnitureMap["travelPurpose"], event.purpose)), event.travellers && (0,defineProperty/* default */.Z)({}, omnitureMap["noOftravellers"], event.travellers));
      }

      this.trackEvent(pageName, _objectSpread(_objectSpread({}, omniData), (event === null || event === void 0 ? void 0 : event.bookingId) && {
        purchaseID: event.bookingId
      }));
    }
  }, {
    key: "trackRawPageLoadEvent",
    value: function trackRawPageLoadEvent(event) {
      if (event !== null && event !== void 0 && event.eVar15) {
        this.trackEvent(event.eVar15, event);
      }
    }
  }, {
    key: "trackPageLoadErrorEvent",
    value: function trackPageLoadErrorEvent(event) {
      var _omniData;

      var pageName = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName].pageName;
      var omniData = (_omniData = {}, (0,defineProperty/* default */.Z)(_omniData, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData, omnitureMap["ctaAction"], event.actionType), (0,defineProperty/* default */.Z)(_omniData, omnitureMap["errorCode"], event.error), _omniData);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackLandingEvents",
    value: function trackLandingEvents(event) {
      var params = new URLSearchParams(window.location.search);
      var isRetail = params.get("isRetail") === "true";
      var landingPageAnalytics = getLandingPageAnalytics();
      var pageName, omniData;

      if (landingPageAnalytics) {
        omniData = _objectSpread(_objectSpread({}, landingPageAnalytics), {}, (0,defineProperty/* default */.Z)({}, omnitureMap["ctaAction"], event.actionType));
        pageName = omniData.eVar15;
      } else {
        var _omniData2;

        pageName = pageNameCategoryMap[isRetail ? "LANDING_RETAIL" : "LANDING"].pageName;
        var lob = pageNameCategoryMap[isRetail ? "LANDING_RETAIL" : "LANDING"].lob;
        omniData = (_omniData2 = {}, (0,defineProperty/* default */.Z)(_omniData2, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData2, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData2, omnitureMap["ctaAction"], event.actionType), _omniData2);
      }

      if (event.actionType === "other_countries_clicked" || event.actionType === "popular_country_selected" || event.actionType === "searched_countries" || event.actionType === "selected_countries") {
        omniData[omnitureMap["destination"]] = event.payload;
      } else if (event.actionType === "travel_date_selected") {
        omniData[omnitureMap["departureDate"]] = event.payload.departure;
        omniData[omnitureMap["arrivalDate"]] = event.payload.arrival;
      } else if (event.actionType === "error_shown") {
        omniData[omnitureMap["errorCode"]] = event.payload;
      }

      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackListingEvents",
    value: function trackListingEvents(event) {
      var _omniData3;

      var _pageNameCategoryMap$2 = pageNameCategoryMap.LISTING,
          pageName = _pageNameCategoryMap$2.pageName,
          lob = _pageNameCategoryMap$2.lob;
      var omniData = (_omniData3 = {}, (0,defineProperty/* default */.Z)(_omniData3, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData3, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData3, omnitureMap["ctaAction"], event.actionType), _omniData3);
      /* istanbul ignore if */

      if (event.actionType === "error_shown") {
        omniData[omnitureMap["errorCode"]] = event.payload;
      } else if (event.actionType === "sum_insured_selected") {
        omniData[omnitureMap["sumInsured"]] = event.payload;
      }

      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackTravDetailsEvents",
    value: function trackTravDetailsEvents(event) {
      var _omniData4;

      var _pageNameCategoryMap$3 = pageNameCategoryMap.REVIEW,
          pageName = _pageNameCategoryMap$3.pageName,
          lob = _pageNameCategoryMap$3.lob;
      var omniData = (_omniData4 = {}, (0,defineProperty/* default */.Z)(_omniData4, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData4, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData4, omnitureMap["ctaAction"], event.actionType), _omniData4);

      if (event.actionType === "error_shown") {
        omniData[omnitureMap["errorCode"]] = event.payload;
      }

      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackThankYouEvents",
    value: function trackThankYouEvents(event) {
      var _omniData5;

      var _pageNameCategoryMap$4 = pageNameCategoryMap[event.pageName],
          pageName = _pageNameCategoryMap$4.pageName,
          lob = _pageNameCategoryMap$4.lob;
      var omniData = (_omniData5 = {}, (0,defineProperty/* default */.Z)(_omniData5, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData5, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData5, omnitureMap["ctaAction"], event.actionType), _omniData5);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackAddPassportEvents",
    value: function trackAddPassportEvents(event) {
      var _omniData6;

      var _pageNameCategoryMap$5 = pageNameCategoryMap.ADD_PASSPORT,
          pageName = _pageNameCategoryMap$5.pageName,
          lob = _pageNameCategoryMap$5.lob;
      var omniData = (_omniData6 = {}, (0,defineProperty/* default */.Z)(_omniData6, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData6, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData6, omnitureMap["ctaAction"], event.actionType), _omniData6);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackOrderSummaryEvents",
    value: function trackOrderSummaryEvents(event) {
      var _omniData7;

      var _pageNameCategoryMap$6 = pageNameCategoryMap.ORDER_SUMMARY,
          pageName = _pageNameCategoryMap$6.pageName,
          lob = _pageNameCategoryMap$6.lob;
      var omniData = (_omniData7 = {}, (0,defineProperty/* default */.Z)(_omniData7, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData7, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData7, omnitureMap["ctaAction"], event.actionType), _omniData7);
      this.trackEvent(pageName, omniData);
    }
  }, {
    key: "trackOrderDetailsEvents",
    value: function trackOrderDetailsEvents(event) {
      var _omniData8;

      var _pageNameCategoryMap$7 = pageNameCategoryMap.ORDER_DETAILS,
          pageName = _pageNameCategoryMap$7.pageName,
          lob = _pageNameCategoryMap$7.lob;
      var omniData = (_omniData8 = {}, (0,defineProperty/* default */.Z)(_omniData8, omnitureMap["pageName"], pageName), (0,defineProperty/* default */.Z)(_omniData8, omnitureMap["lob"], lob), (0,defineProperty/* default */.Z)(_omniData8, omnitureMap["ctaAction"], event.actionType), _omniData8);
      this.trackEvent(pageName, omniData);
    }
  }]);

  return MmtAnalytics;
}();
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/internal.ts
function injectPlatform(eventObj) {
  var _eventObj$page, _eventObj$page2, _eventObj$page2$pageI;

  var isPageViewEvent = ["pageView", "errorScreen"].includes(eventObj === null || eventObj === void 0 ? void 0 : eventObj.event);
  var missingPlatform = (eventObj === null || eventObj === void 0 ? void 0 : (_eventObj$page = eventObj.page) === null || _eventObj$page === void 0 ? void 0 : _eventObj$page.pageInfo) && !(eventObj !== null && eventObj !== void 0 && (_eventObj$page2 = eventObj.page) !== null && _eventObj$page2 !== void 0 && (_eventObj$page2$pageI = _eventObj$page2.pageInfo) !== null && _eventObj$page2$pageI !== void 0 && _eventObj$page2$pageI.platform);

  if (isPageViewEvent && missingPlatform) {
    eventObj.page.pageInfo.platform = /Mobile|Android|BlackBerry/.test(navigator.userAgent) ? "mweb" : "desktop";
  }
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/index.ts

var pushEvent = function pushEvent(eventObj) {
  var isClientSide = typeof navigator !== "undefined" && true;
  if (!isClientSide) return;
  injectPlatform(eventObj); // @ts-ignore

  window.adobeDataLayer = window.adobeDataLayer || []; // @ts-ignore

  window.adobeDataLayer.push(eventObj);
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/GIAnalytics.ts




function GIAnalytics_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GIAnalytics_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GIAnalytics_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GIAnalytics_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var GIAnalytics = /*#__PURE__*/function () {
  function GIAnalytics() {
    (0,classCallCheck/* default */.Z)(this, GIAnalytics);
  }

  (0,createClass/* default */.Z)(GIAnalytics, [{
    key: "trackPageLoadEvent",
    value: function trackPageLoadEvent(event) {
      var _pageNameCategoryMap$ = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName],
          pageName = _pageNameCategoryMap$.pageName,
          lob = _pageNameCategoryMap$.lob,
          siteSection = _pageNameCategoryMap$.siteSection;
      var omniData = {
        event: "pageView",
        page: {
          pageInfo: GIAnalytics_objectSpread({
            pageName: pageName,
            lob: lob,
            section: siteSection
          }, event.experiment && {
            abVariant: event.experiment
          })
        },
        booking: GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, event.bookingId && {
          bookingId: event.bookingId
        }), event.bookingStatus && {
          paymentStatus: event.bookingStatus
        })
      };

      if (event.pageName === "LISTING") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          event: "tm_ins_listing_view",
          booking: GIAnalytics_objectSpread(GIAnalytics_objectSpread(GIAnalytics_objectSpread(GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, event.country && {
            routeCity: event.country
          }), event.startDate && {
            departureDate: event.startDate
          }), event.endDate && {
            returnDate: event.endDate
          }), event.purpose && {
            purposeOfTravel: event.purpose
          }), event.travellers && {
            pax: event.travellers
          })
        });
      }

      pushEvent(omniData);
    }
  }, {
    key: "trackRawPageLoadEvent",
    value: function trackRawPageLoadEvent(event) {}
  }, {
    key: "trackPageLoadErrorEvent",
    value: function trackPageLoadErrorEvent(event) {
      var pageName = pageNameCategoryMap[event === null || event === void 0 ? void 0 : event.pageName].pageName;
      var omniData = {
        event: "pageView",
        page: {
          pageInfo: {
            pageName: pageName
          }
        },
        cta: {
          name: event.actionType
        },
        error: event.error
      };
      pushEvent(omniData);
    }
  }, {
    key: "trackLandingEvents",
    value: function trackLandingEvents(event) {
      var _pageNameCategoryMap$2 = pageNameCategoryMap.LANDING,
          pageName = _pageNameCategoryMap$2.pageName,
          lob = _pageNameCategoryMap$2.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };

      if (event.actionType === "other_countries_clicked" || event.actionType === "popular_country_selected" || event.actionType === "searched_countries" || event.actionType === "selected_countries") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          booking: {
            routeCity: event.payload
          }
        });
      } else if (event.actionType === "travel_date_selected") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          booking: {
            departureDate: event.payload.departure,
            returnDate: event.payload.arrival
          }
        });
      } else if (event.actionType === "error_shown") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          error: event.payload
        });
      }

      pushEvent(omniData);
    }
  }, {
    key: "trackListingEvents",
    value: function trackListingEvents(event) {
      var _pageNameCategoryMap$3 = pageNameCategoryMap.LISTING,
          pageName = _pageNameCategoryMap$3.pageName,
          lob = _pageNameCategoryMap$3.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };

      if (event.actionType === "sum_insured_selected") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          booking: {
            sumInsuredValue: event.payload
          }
        });
      }

      pushEvent(omniData);
    }
  }, {
    key: "trackTravDetailsEvents",
    value: function trackTravDetailsEvents(event) {
      var _pageNameCategoryMap$4 = pageNameCategoryMap.REVIEW,
          pageName = _pageNameCategoryMap$4.pageName,
          lob = _pageNameCategoryMap$4.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };

      if (event.actionType === "error_shown") {
        omniData = GIAnalytics_objectSpread(GIAnalytics_objectSpread({}, omniData), {}, {
          error: event.payload
        });
      }

      pushEvent(omniData);
    }
  }, {
    key: "trackThankYouEvents",
    value: function trackThankYouEvents(event) {
      var _pageNameCategoryMap$5 = pageNameCategoryMap[event.pageName],
          pageName = _pageNameCategoryMap$5.pageName,
          lob = _pageNameCategoryMap$5.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      pushEvent(omniData);
    }
  }, {
    key: "trackAddPassportEvents",
    value: function trackAddPassportEvents(event) {
      var _pageNameCategoryMap$6 = pageNameCategoryMap.ADD_PASSPORT,
          pageName = _pageNameCategoryMap$6.pageName,
          lob = _pageNameCategoryMap$6.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      pushEvent(omniData);
    }
  }, {
    key: "trackOrderSummaryEvents",
    value: function trackOrderSummaryEvents(event) {
      var _pageNameCategoryMap$7 = pageNameCategoryMap.ORDER_SUMMARY,
          pageName = _pageNameCategoryMap$7.pageName,
          lob = _pageNameCategoryMap$7.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      pushEvent(omniData);
    }
  }, {
    key: "trackOrderDetailsEvents",
    value: function trackOrderDetailsEvents(event) {
      var _pageNameCategoryMap$8 = pageNameCategoryMap.ORDER_DETAILS,
          pageName = _pageNameCategoryMap$8.pageName,
          lob = _pageNameCategoryMap$8.lob;
      var omniData = {
        event: "ctaClick",
        page: {
          pageInfo: {
            pageName: pageName,
            lob: lob
          }
        },
        cta: {
          name: event.actionType
        }
      };
      pushEvent(omniData);
    }
  }]);

  return GIAnalytics;
}();
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/analyticsWrapper.ts



var analytics = null;
function getAnalytics() {
  if (analytics === null && (0,utils/* isPartnerMMT */.rS)()) {
    analytics = new MmtAnalytics();
  } else if (analytics === null && (0,utils/* isPartnerGI */.Pk)()) {
    analytics = new GIAnalytics();
  }

  return analytics;
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts



/***/ }),

/***/ 2874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rS": function() { return /* binding */ theme; }
/* harmony export */ });
/* unused harmony exports fontWeight, fontSize, lineHeight */
var theme = {
  blackText: "#000",
  greyText: "#4a4a4a",
  whiteText: "#fff",
  lightGreyText: "#9b9b9b",
  darkText: "#002137",
  greenText: "#2B825E",
  greenText3: " #009997",
  greenText4: "#38A97A",
  greenText5: "#007E7D",
  greyText2: "#cbcbcb",
  greyText3: "#6b6b6b",
  greyText4: "#9b9b9b",
  greyText5: "#AFAFAF",
  greyText6: "#757575",
  greyText7: "#969696",
  greyText8: "rgba(255, 255, 255, 0.6)",
  greyText9: "#717171",
  greyText10: "#c8c2c2",
  redText: "#960D11",
  redText2: "#EB2026",
  greenNeonText: "#8BEECD",
  blueNeonText: "rgba(0, 162, 255, 1)",
  blueText: "#008CFF",
  blueText2: "#F6FAFF",
  brownText: "#6B4300",
  yellowText: "#CF8100",
  lightBlack: "rgba(0, 0, 0, 0.3)",
  gray97: "#f7f7f7",
  lightGrey: "#d2d2d2",
  blueLight: "#F9FCFF",
  smokeWhite: "#F6F6F6",
  lightSilver: "#D8D8D8",
  snowWhite: "#FFFAFA",
  gainsBoro: "#e2e2e2",
  darkGreen: "#1E5C43",
  lightGreen: "#249054",
  persianGreen: "#009997",
  lightRed: "#fcdadb",
  blackText2: "#1E1E1E",
  whiteText2: "#f5f5f5",
  greenText2: "#E4FBF4",
  redText3: "#A73232",
  redText4: "#C53B3B",
  yellowText2: "#FFEDD1",
  yellowText3: "#FFDA9E",
  yellowText4: "#FFC76B",
  darkYellowText: "#B48B28",
  prussianBlue: "#005499",
  purpleTxt: "#A05ACD",
  berryTxt: "#AF0067",
  greenNeonText2: "#33BA9E",
  greenBg: "rgba(43, 130, 94, 0.5)",
  purpleGradient: "linear-gradient(91.22deg, #3023ae 1.88%, #c86dd7 100%)",
  blueGradient: "linear-gradient(to right,#53B2FE,#065AF3)",
  neonGreen: "#E6FFF9",
  orange: "#FF6E39"
};
var fontWeight = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  black: "900"
};
var fontSize = {
  font10: "10px",
  font12: "12px",
  font14: "14px",
  font16: "16px",
  font18: "18px",
  font20: "20px",
  font22: "22px",
  font24: "24px",
  font26: "26px",
  font28: "28px"
};
var lineHeight = {
  lineHeight16: "16px",
  lineHeight20: "20px",
  lineHeight24: "24px",
  lineHeight26: "24px",
  lineHeight32: "32px"
};

/***/ }),

/***/ 8521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oe": function() { return /* reexport */ editInsuranceDetails; },
  "$P": function() { return /* reexport */ getNextPageRouteDetails; },
  "QW": function() { return /* reexport */ paymentCheckout; },
  "S8": function() { return /* reexport */ sendPolicyEmail; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/api-utils/src/index.ts + 4 modules
var src = __webpack_require__(3496);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 6 modules
var utils = __webpack_require__(1725);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(9644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/config.ts


var _excluded = ["cookie"];




var AXIOS_HTTPS_CONFIG = {
  timeout: src/* API_TIMEOUT_IN_MS */.Sb,
  withCredentials: true,
  retry: 1
};
var API_HTTPS = axios_default().create(AXIOS_HTTPS_CONFIG);
API_HTTPS.interceptors.request.use(function (config) {
  var _interceptors$enhance = src/* interceptors.enhanceRequestHeaders */.JQ.enhanceRequestHeaders(config.headers),
      cookie = _interceptors$enhance.cookie,
      headersWithoutCookie = (0,objectWithoutProperties/* default */.Z)(_interceptors$enhance, _excluded);

  config.headers = headersWithoutCookie;
  return config;
});
API_HTTPS.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(error) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", src/* interceptors.retryAxiosRequest */.JQ.retryAxiosRequest(error, API_HTTPS));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/apiRoutes.ts



var apiRoutes_excluded = ["partner", "query"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var paymentCheckout = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(reqData) {
    var _reqData$partner, partner, data, params, urlParams, response;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _reqData$partner = reqData.partner, partner = _reqData$partner === void 0 ? (0,utils/* getPartnerOnClientSide */.et)() : _reqData$partner, data = reqData.data;
            params = {
              context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
              ins_new_flow: true
            };
            urlParams = (0,utils/* setURLQueryParams */.jT)(params);
            _context.next = 6;
            return API_HTTPS.post("".concat(src/* API_ROUTE_PREFIX_HTTPS */.j6, "/").concat(partner, "/").concat(src/* API_ROUTES.PAYMENT_CHECKOUT */.qf.PAYMENT_CHECKOUT).concat(urlParams ? "?".concat(urlParams) : ""), data, {
              headers: {
                cmp: sessionStorage.getItem("cmp") || undefined
              }
            });

          case 6:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.error("Error", {
              error: _context.t0
            });
            throw _context.t0;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function paymentCheckout(_x) {
    return _ref.apply(this, arguments);
  };
}();
var sendPolicyEmail = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
    var bookingId, partner, params, urlParams, response;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            bookingId = data.bookingId, partner = data.partner;
            params = {
              bookingID: bookingId
            };
            urlParams = (0,utils/* setURLQueryParams */.jT)(params);
            _context2.next = 6;
            return API_HTTPS.post("".concat(src/* API_ROUTE_PREFIX */.XO, "/").concat(partner, "/").concat(src/* API_ROUTES.TRIGGER_EMAIL */.qf.TRIGGER_EMAIL).concat(urlParams ? "?".concat(urlParams) : ""), {
              headers: {
                cmp: sessionStorage.getItem("cmp")
              }
            });

          case 6:
            response = _context2.sent;
            return _context2.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            console.log("Error", {
              error: _context2.t0.message
            });
            throw _context2.t0;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function sendPolicyEmail(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var editInsuranceDetails = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(reqData) {
    var bookingID, _reqData$partner2, partner, _reqData$data, data, urlParams, response;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            bookingID = reqData.bookingID, _reqData$partner2 = reqData.partner, partner = _reqData$partner2 === void 0 ? (0,utils/* getPartnerOnClientSide */.et)() : _reqData$partner2, _reqData$data = reqData.data, data = _reqData$data === void 0 ? [] : _reqData$data;

            if (bookingID) {
              _context3.next = 4;
              break;
            }

            throw "editInsuranceDetails: Booking id not present or invalid";

          case 4:
            urlParams = (0,utils/* setURLQueryParams */.jT)({
              bookingID: bookingID
            });
            _context3.next = 7;
            return API_HTTPS.put("".concat(src/* API_ROUTE_PREFIX_HTTPS */.j6, "/").concat(partner, "/").concat(src/* API_ROUTES.EDIT_INSURANCE_DETAILS */.qf.EDIT_INSURANCE_DETAILS).concat(urlParams ? "?".concat(urlParams) : ""), data, {
              headers: {
                cmp: sessionStorage.getItem("cmp") || undefined
              }
            });

          case 7:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            console.error("Error", {
              error: _context3.t0
            });
            throw _context3.t0;

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 11]]);
  }));

  return function editInsuranceDetails(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var getNextPageRouteDetails = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(reqData) {
    var _reqData$partner3, partner, query, data, params, urlParams, url, response;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _reqData$partner3 = reqData.partner, partner = _reqData$partner3 === void 0 ? isomorphic_utils_src.PARTNER.MMT : _reqData$partner3, query = reqData.query, data = (0,objectWithoutProperties/* default */.Z)(reqData, apiRoutes_excluded);
            params = _objectSpread({
              lob: isomorphic_utils_src.LOB.STANDALONE,
              platform: isomorphic_utils_src.PLATFORM.WEB,
              context: isomorphic_utils_src.CONTEXT.STANDALONE_V2,
              isCountryCodesSupported: true.toString(),
              partner: partner
            }, query);
            urlParams = new URLSearchParams(params).toString();
            url = "".concat(src/* API_ROUTE_PREFIX_HTTPS */.j6, "/").concat(partner, "/").concat(src/* API_ROUTES.GET_NEXT_PAGE_ROUTE */.qf.GET_NEXT_PAGE_ROUTE, "?").concat(urlParams);
            _context4.next = 6;
            return API_HTTPS.post(url, data);

          case 6:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getNextPageRouteDetails(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/api/index.ts


/***/ }),

/***/ 2817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ navigationActions; },
  "O": function() { return /* reexport */ setRouter; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/routeConstants.ts
var ROUTE_CONSTANTS = {
  LANDING_PAGE: "/insurance",
  LISTING_SCREEN: "/insurance/listing",
  TRAVELLER_DETAILS: "/insurance/traveller-details",
  PAYMENT_SUCCESS: "/insurance/paymentSuccess",
  PAYMENT_FAILURE: "/insurance/payment-failure",
  ADD_PASSPORT: "/insurance/add-passport",
  ORDER_CONFIRMED: "/insurance/order-confirmed",
  ORDER_LISTING: "/insurance/order-listing",
  ORDER_DETAILS: "/insurance/order-details",
  EDIT_TRAVELLERS: "/insurance/edit-travellers",
  DOWNLOAD_POLICY: "/insurance/download-policy",
  WEBVIEW_SCREEN: "/insurance/webview-screen"
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/navigator.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var router;
var setRouter = function setRouter(routerInstance) {
  if (!routerInstance) {
    throw new Error("Couldn't set router,routerInstance object is null or undefined");
  }

  router = routerInstance;
};

function getURLFromRouteAndParams(route, params) {
  var searchParams = "";
  var routeParts = route.split("?");
  var baseRoute = routeParts[0];
  var existingParams = routeParts[1] ? new URLSearchParams(routeParts[1]) : new URLSearchParams();
  Object.keys(params || {}).forEach(function (key) {
    return existingParams.set(key, params[key]);
  });
  searchParams = existingParams.toString();
  var queryJoin = searchParams.length > 0 ? "?" : "";
  return "".concat(baseRoute).concat(queryJoin).concat(searchParams);
}
/* istanbul ignore next */


function forceRedirectOnWwwSubdomain(pathName) {
  if (typeof location === "undefined") return;
  var host = new URL(location.href).host;

  switch (host) {
    case "insurance.makemytrip.com":
      location.href = "https://www.makemytrip.com".concat(pathName);
      break;

    case "insurance.goibibo.com":
      location.href = "https://www.goibibo.com".concat(pathName);
      break;

    default:
      router.push(pathName);
  }
}

function forceRedirectOnInsuranceSubdomain(pathName) {
  if (typeof location === "undefined") return;
  var host = new URL(location.href).host;

  switch (host) {
    case "www.makemytrip.com":
      location.href = "https://insurance.makemytrip.com".concat(pathName);
      break;

    case "www.goibibo.com":
      location.href = "https://insurance.goibibo.com".concat(pathName);
      break;

    default:
      router.push(pathName);
  }
}

function injectCmpInParams(params) {
  var cmpVal = sessionStorage.getItem("cmp");

  if (typeof cmpVal === "string" && cmpVal != "") {
    params = _objectSpread(_objectSpread({}, params), {}, {
      cmp: cmpVal
    });
  }

  return params;
}

var navigationActions = {
  navigateToLanding: function navigateToLanding(params) {
    var shouldForceRedirectOnWwwSubdomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    params = injectCmpInParams(params);
    var pathName = getURLFromRouteAndParams(ROUTE_CONSTANTS.LANDING_PAGE, params);
    shouldForceRedirectOnWwwSubdomain ? forceRedirectOnWwwSubdomain(pathName) : router.push(pathName);
  },
  navigateToListing: function navigateToListing(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.LISTING_SCREEN, params));
  },
  navigateToTravellerDetails: function navigateToTravellerDetails(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.TRAVELLER_DETAILS, params));
  },
  navigateToAddPassport: function navigateToAddPassport(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ADD_PASSPORT, params));
  },
  navigateToOrderConfirmed: function navigateToOrderConfirmed(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_CONFIRMED, params));
  },
  navigateToOrderListing: function navigateToOrderListing(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_LISTING, params));
  },
  navigateToOrderDetails: function navigateToOrderDetails(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.ORDER_DETAILS, params));
  },
  navigateToDownloadPolicy: function navigateToDownloadPolicy(params) {
    params = injectCmpInParams(params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(ROUTE_CONSTANTS.DOWNLOAD_POLICY, params));
  },
  goBack: function goBack() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        forceExit = _ref.forceExit;

    if (forceExit) {
      window.history.go(-(window.history.length - 2));
    } else {
      router.back();
    }
  },
  navigateToPageByRouteName: function navigateToPageByRouteName(route, params) {
    params = injectCmpInParams(params);
    console.log("-----params", params);
    forceRedirectOnInsuranceSubdomain(getURLFromRouteAndParams(route, params));
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts


/***/ }),

/***/ 1725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xz": function() { return /* reexport */ addDaysToDate; },
  "P9": function() { return /* reexport */ convertUnixToDate; },
  "Ds": function() { return /* reexport */ debounce; },
  "p6": function() { return /* reexport */ formatDate; },
  "A7": function() { return /* reexport */ getCookieByName; },
  "YV": function() { return /* reexport */ getFormFieldErrorMsg; },
  "et": function() { return /* reexport */ getPartnerOnClientSide; },
  "fP": function() { return /* reexport */ getTravDetailsFromMemory; },
  "IS": function() { return /* reexport */ interpolateRowHeight; },
  "qP": function() { return /* reexport */ isDobValid; },
  "K0": function() { return /* reexport */ isFieldValid; },
  "Pk": function() { return /* reexport */ isPartnerGI; },
  "rS": function() { return /* reexport */ isPartnerMMT; },
  "yi": function() { return /* reexport */ openCheckoutPage; },
  "UO": function() { return /* reexport */ persistUtmParams; },
  "df": function() { return /* reexport */ replaceHistory; },
  "_A": function() { return /* reexport */ replaceHistoryRemoveParams; },
  "Yp": function() { return /* reexport */ setTravDetailsInMemory; },
  "jT": function() { return /* reexport */ setURLQueryParams; },
  "rv": function() { return /* reexport */ subtractYrsFromDate; }
});

// UNUSED EXPORTS: calendarLabelFormatter, convertDateToUnix, deepMergeObjects, generateSourceSetImageUrl, isHostMakemytrip, isObject, randomDayData, subtractDurationFromDate

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
// EXTERNAL MODULE: ../../libs/utility/src/lib/utils/index.ts + 2 modules
var utils = __webpack_require__(4927);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(7755);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(3761);
// EXTERNAL MODULE: ../../node_modules/date-fns/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(6893);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(6913);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(2765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(8187);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(9785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addMonths/* default */.Z)(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/sub/index.js





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  if (!duration || (0,esm_typeof/* default */.Z)(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,toInteger/* default */.Z)(duration.years) : 0;
  var months = duration.months ? (0,toInteger/* default */.Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,toInteger/* default */.Z)(duration.weeks) : 0;
  var days = duration.days ? (0,toInteger/* default */.Z)(duration.days) : 0;
  var hours = duration.hours ? (0,toInteger/* default */.Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,toInteger/* default */.Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,toInteger/* default */.Z)(duration.seconds) : 0;

  // Subtract years and months
  var dateWithoutMonths = subMonths(date, months + years * 12);

  // Subtract weeks and days
  var dateWithoutDays = (0,subDays/* default */.Z)(dateWithoutMonths, days + weeks * 7);

  // Subtract hours, minutes and seconds
  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/dateUtils.ts

 // CALENDAR UTILITY FUNCTIONS

var randomDayData = function randomDayData() {
  var min = 10000;
  var max = 15000;
  var randomNum = Math.floor(Math.random() * (max - min + 1) + min);
  return {
    price: "\u20B9".concat(randomNum),
    class: randomNum <= 12000 ? "greenText" : "redText",
    isSoldOut: randomNum > 12000 && randomNum < 13000,
    availableOnPreviousDate: randomNum >= 13000 && randomNum <= 13500
  };
};
var convertUnixToDate = function convertUnixToDate(unix) {
  if (unix) {
    return new Date(unix * 1000);
  }

  return;
};
var convertDateToUnix = function convertDateToUnix(date) {
  return Math.floor(new Date(date).getTime() / 1000);
};
var formatDate = function formatDate(date, dateFormat) {
  if (date) {
    try {
      date = new Date(date);
      return (0,format/* default */.Z)(date, dateFormat);
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in formatting given date", "".concat(date, " | ").concat(dateFormat));
    }
  }

  return "";
};
var addDaysToDate = function addDaysToDate(date) {
  var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  try {
    return (0,addDays/* default */.Z)(date, days);
  } catch (error) {
    /* istanbul ignore next */
    console.log("Error in adding given days to date", "".concat(date, " | ").concat(days));
  }
  /* istanbul ignore next */


  return;
};
var subtractDurationFromDate = function subtractDurationFromDate(date, duration) {
  if (date) {
    try {
      date = new Date(date);
      return sub(date, duration);
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in subtracting given duration from date", "".concat(date, " | ").concat(duration));
    }
  }
  /* istanbul ignore next */


  return new Date();
};
var subtractYrsFromDate = function subtractYrsFromDate(date, years) {
  if (date && years) {
    try {
      return subtractDurationFromDate(date, {
        years: years
      });
    } catch (error) {
      /* istanbul ignore next */
      console.log("Error in subtracting given years from date", "".concat(date, " | ").concat(years));
    }
  }
  /* istanbul ignore next */


  return new Date();
};
var calendarLabelFormatter = function calendarLabelFormatter(dateObj) {
  return dateObj ? "".concat(dateObj.getDate(), " ").concat(MONTHS[dateObj.getMonth()], "' ").concat(dateObj.getFullYear().toString().slice(-2)) : "".concat(new Date().getDate(), " ").concat(MONTHS[new Date().getMonth()], "' ").concat(new Date().getFullYear().toString().slice(-2));
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/utils.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var setURLQueryParams = function setURLQueryParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var usp = new URLSearchParams();
  Object.keys(params).forEach(function (e) {
    if (params[e]) {
      usp.set(e, params[e].toString());
    }
  });
  return usp.toString();
};
var persistUtmParams = function persistUtmParams(queryParam) {
  var utm_source = queryParam.get(src.UTM_PARAMS.UTM_SOURCE);
  var utm_medium = queryParam.get(src.UTM_PARAMS.UTM_MEDIUM);
  var utm_campaign = queryParam.get(src.UTM_PARAMS.UTM_CAMPAIGN);

  if (utm_source) {
    sessionStorage.setItem(src.UTM_PARAMS.UTM_SOURCE, utm_source);
  }

  if (utm_medium) {
    sessionStorage.setItem(src.UTM_PARAMS.UTM_MEDIUM, utm_medium);
  }

  if (utm_campaign) {
    sessionStorage.setItem(src.UTM_PARAMS.UTM_INS_CAMPAIGN, utm_campaign);
  }
};
var replaceHistory = function replaceHistory(param, value) {
  if (true) {
    var baseUrl = window.location.pathname;
    var searchParams = new URLSearchParams(window.location.search);
    (value === null || value === void 0 ? void 0 : value.length) > 0 ? searchParams.set(param, value) : null;
    var url = "".concat(baseUrl).concat(searchParams.toString().length > 0 ? "?" + searchParams : "");
    window.history.replaceState(_objectSpread(_objectSpread({}, window.history.state), {}, {
      as: url,
      url: url
    }), "", url);
  }
};
var replaceHistoryRemoveParams = function replaceHistoryRemoveParams(param) {
  var baseUrl = window.location.pathname;
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(param);
  var url = "".concat(baseUrl).concat(searchParams.toString().length > 0 ? "?" + searchParams : "");
  window.history.replaceState(_objectSpread(_objectSpread({}, window.history.state), {}, {
    as: url,
    url: url
  }), "", url);
};
var getCookieByName = function getCookieByName(cookieName) {
  var cookie = {};
  document.cookie.split(";").forEach(function (el) {
    var _el$split = el.split("="),
        _el$split2 = (0,slicedToArray/* default */.Z)(_el$split, 2),
        key = _el$split2[0],
        value = _el$split2[1];

    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};
var getFormFieldErrorMsg = function getFormFieldErrorMsg(field, errorMsg) {
  if (errorMsg) {
    return errorMsg;
  } else {
    var fieldName = src.FORM_FIELDS_MAP[field] || field;
    return "Please enter ".concat(fieldName);
  }
};
var isDobValid = function isDobValid(value, regex) {
  var formattedDate = formatDate(value, src.DATE_FORMATS["DD/MM/YYYY"]);
  var isValidDate = new RegExp(regex || "").test(formattedDate);
  return isValidDate;
};
var getPartnerOnClientSide = function getPartnerOnClientSide() {
  var hostname = (0,utils/* getHostName */.Lp)() || "";

  if (hostname.includes(src.PARTNER_DOMAIN_NAME.MMT)) {
    return src.PARTNER.MMT;
  } else if (hostname.includes(src.PARTNER_DOMAIN_NAME.GI)) {
    return src.PARTNER.GI;
  } else if (hostname.includes(src.PARTNER_DOMAIN_NAME.TRIPMONEY)) {
    return src.PARTNER.TRIPMONEY;
  } else {
    console.error("Error detecting partner. Unsupported domain hostname - ".concat(hostname));
    return src.PARTNER.TRIPMONEY;
  }
};
var isPartnerMMT = function isPartnerMMT() {
  return getPartnerOnClientSide() === src.PARTNER.MMT;
};
var isPartnerGI = function isPartnerGI() {
  return getPartnerOnClientSide() === src.PARTNER.GI;
};
var isFieldValid = function isFieldValid(regex, updatedField) {
  try {
    var validator = new RegExp(regex || "");
    return validator === null || validator === void 0 ? void 0 : validator.test(updatedField);
  } catch (error) {
    return false;
  }
};
var isHostMakemytrip = function isHostMakemytrip() {
  if (isOnServer()) return false;
  var url = new URL(window.location.href);
  return TRIPMONEY_DOMAIN_NAME.MMT.includes(url.hostname);
};
var debounce = function debounce(func, delay) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};
var generateSourceSetImageUrl = function generateSourceSetImageUrl(cdnUrlWidths, imgUrl, width) {
  var imgWidths = cdnUrlWidths;
  if (!imgWidths || !Array.isArray(imgWidths) || imgWidths.length === 0) imgWidths = [width, width * 2, width * 3];
  return imgWidths.map(function (width) {
    return "".concat(imgUrl, "?im=Resize=(").concat(width, ") ").concat(width, "w");
  }).join(",");
};
var isObject = function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
};
function deepMergeObjects(target) {
  for (var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    sources[_key2 - 1] = arguments[_key2];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!target[key]) target[key] = {};
        target[key] = deepMergeObjects(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }

  return deepMergeObjects.apply(void 0, [target].concat(sources));
}
//TODO: Check for a better way to handle the Dynamic size of cells in react-window
var interpolateRowHeight = function interpolateRowHeight(width, region) {
  var _heightData$lowerWidt, _heightData$upperWidt;

  var expansionLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var heightData = {
    360: {
      normal: [57],
      WW: [57, 159],
      EU: [57, 183, 399],
      SEA: [57, 207, 207],
      WWEUC: [65.5, 215.5, 215]
    },
    370: {
      normal: [57],
      WW: [57, 159],
      SEA: [57, 183, 183],
      EU: [57, 183, 375],
      WWEUC: [65.5, 215.5, 191.5]
    },
    315: {
      normal: [57],
      WW: [57, 183],
      SEA: [57, 207, 231],
      EU: [57, 207, 471],
      WWEUC: [65.5, 215.5, 215.5]
    },
    354: {
      normal: [57],
      WW: [57, 159],
      SEA: [57, 207, 207],
      EU: [57, 183, 399],
      WWEUC: [65.5, 215.5, 215.5]
    },
    300: {
      normal: [57],
      WW: [57, 183],
      SEA: [57, 231, 231],
      EU: [57, 207, 495],
      WWEUC: [65.5, 239.5, 215.5]
    },
    708: {
      normal: [57],
      WW: [57, 135],
      SEA: [57, 159, 159],
      EU: [57, 159, 255],
      WWEUC: [65.5, 167.5, 143.5]
    },
    480: {
      normal: [57],
      WW: [57, 135],
      SEA: [57, 183, 159],
      EU: [57, 183, 303],
      WWEUC: [65.5, 215.5, 191.5]
    }
  };
  var availableWidths = Object.keys(heightData).map(Number).sort(function (a, b) {
    return a - b;
  });

  var findNearestWidths = function findNearestWidths(targetWidth) {
    var lowerWidth = availableWidths[0];
    var upperWidth = availableWidths[availableWidths.length - 1];

    for (var i = 0; i < availableWidths.length - 1; i++) {
      if (availableWidths[i] <= targetWidth && availableWidths[i + 1] >= targetWidth) {
        lowerWidth = availableWidths[i];
        upperWidth = availableWidths[i + 1];
        break;
      }
    }

    return [lowerWidth, upperWidth];
  };

  var _findNearestWidths = findNearestWidths(width),
      _findNearestWidths2 = (0,slicedToArray/* default */.Z)(_findNearestWidths, 2),
      lowerWidth = _findNearestWidths2[0],
      upperWidth = _findNearestWidths2[1];

  var lowerHeights = (heightData === null || heightData === void 0 ? void 0 : (_heightData$lowerWidt = heightData[lowerWidth]) === null || _heightData$lowerWidt === void 0 ? void 0 : _heightData$lowerWidt[region]) || [57];
  var upperHeights = (heightData === null || heightData === void 0 ? void 0 : (_heightData$upperWidt = heightData[upperWidth]) === null || _heightData$upperWidt === void 0 ? void 0 : _heightData$upperWidt[region]) || [57];
  var lowerHeight = lowerHeights[Math.min(expansionLevel, lowerHeights.length - 1)];
  var upperHeight = upperHeights[Math.min(expansionLevel, upperHeights.length - 1)];
  var interpolatedHeight = lowerHeight + (upperHeight - lowerHeight) * (width - lowerWidth) / (upperWidth - lowerWidth);
  return interpolatedHeight;
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/checkout.ts
var openCheckoutPage = function openCheckoutPage(checkoutUrl) {
  try {
    var _window;

    if (!checkoutUrl) {
      /* istanbul ignore next */
      throw new Error("Required parameters missing from native checkout bridge. checkoutUrl: ".concat(checkoutUrl));
    }

    (_window = window) === null || _window === void 0 ? void 0 : _window.open(checkoutUrl, "_self");
  } catch (error) {
    var _console;

    (_console = console) === null || _console === void 0 ? void 0 : _console.log("PAYMENT REDIRECTION FAILED", error);
    /* istanbul ignore next */

    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/travellerDetails.ts
var travellerDetails = {};
var setTravDetailsInMemory = function setTravDetailsInMemory(value) {
  travellerDetails = value;
};
var getTravDetailsFromMemory = function getTravDetailsFromMemory() {
  return travellerDetails;
};
;// CONCATENATED MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts






/***/ }),

/***/ 4927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Lp": function() { return /* binding */ getHostName; },
  "Bv": function() { return /* binding */ getUtilOptions; },
  "LC": function() { return /* binding */ loadGTM; }
});

// UNUSED EXPORTS: TRIPMONEY_MMT_DOMAIN_NAMES, disableEncrytionInWeb, getDeviceModelType, isHostMakemytrip

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(4928);
;// CONCATENATED MODULE: ../../libs/types/src/lib/enum/index.ts
var DEVICE_TYPE;

(function (DEVICE_TYPE) {
  DEVICE_TYPE["DESKTOP"] = "desktop";
  DEVICE_TYPE["MOBILE"] = "mobile";
  DEVICE_TYPE["TABLET"] = "tablet";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));

var DEVICE_MODEL_TYPE;

(function (DEVICE_MODEL_TYPE) {
  DEVICE_MODEL_TYPE["APP"] = "App";
  DEVICE_MODEL_TYPE["WEB"] = "Web";
})(DEVICE_MODEL_TYPE || (DEVICE_MODEL_TYPE = {}));

var HOST = {
  TRIPMONEY: "www.tripmoney.com",
  MAKEMYTRIP: "www.makemytrip.com",
  GOIBIBO: "www.goibibo.com",
  LOCALHOST: "localhost",
  TRIPMONEY_MAKEMYTRIP: "tripmoney.makemytrip.com"
};
;// CONCATENATED MODULE: ../../libs/types/src/index.ts


;// CONCATENATED MODULE: ../../libs/utility/src/lib/utils/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getDeviceModelType = function getDeviceModelType() {
  if ((0,src.isOnServer)()) return null;

  if (window.mmt_android_bridge || window.app_bridge) {
    return DEVICE_MODEL_TYPE.APP;
  }

  return DEVICE_MODEL_TYPE.WEB;
};
function getHostName() {
  var _window, _window$getHostName;

  if ((0,src.isOnServer)()) {
    return null;
  }

  if ( true && typeof window.getHostName === "undefined") {
    window.getHostName = function () {
      return window.location.hostname;
    };
  }

  return (_window = window) === null || _window === void 0 ? void 0 : (_window$getHostName = _window.getHostName) === null || _window$getHostName === void 0 ? void 0 : _window$getHostName.call(_window);
}
function disableEncrytionInWeb() {
  return getDeviceModelType() === DEVICE_MODEL_TYPE.WEB && [HOST.MAKEMYTRIP, HOST.TRIPMONEY_MAKEMYTRIP].includes(getHostName() || "");
}
var isHostMakemytrip = function isHostMakemytrip() {
  if ((0,src.isOnServer)()) return false;
  var url = new URL(window.location.href);
  return TRIPMONEY_MMT_DOMAIN_NAMES.includes(url.hostname);
};

var getGtmScript = function getGtmScript(gtmId) {
  return "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer', '".concat(gtmId, "');\n  ");
};

var loadGTM = function loadGTM() {
  var _window2;

  if (isHostMakemytrip() && true && !((_window2 = window) !== null && _window2 !== void 0 && _window2.dataLayer)) {
    var script = document.createElement("script");
    script.innerHTML = getGtmScript("GTM-NWV3K7C");
    script.defer = true;
    document.head.appendChild(script);
  }
};
function getUtilOptions(options) {
  return disableEncrytionInWeb() ? _objectSpread(_objectSpread({}, options), {}, {
    isPiiData: false
  }) : options;
}
var TRIPMONEY_MMT_DOMAIN_NAMES = ["tripmoney.makemytrip.com", "insurance.makemytrip.com", "www.makemytrip.com"];

/***/ }),

/***/ 6570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(5525);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4766:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7821:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5129:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5153:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 5237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2795)


/***/ }),

/***/ 7729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3233)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5876)


/***/ }),

/***/ 7827:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const { DOCUMENT_MODE } = __webpack_require__(5218);

//Const
const VALID_DOCTYPE_NAME = 'html';
const VALID_SYSTEM_ID = 'about:legacy-compat';
const QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';

const QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//'
];

const QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
]);

const QUIRKS_MODE_PUBLIC_IDS = ['-//w3o//dtd w3 html strict 3.0//en//', '-/w3c/dtd html 4.0 transitional/en', 'html'];
const LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ['-//w3c//dtd xhtml 1.0 frameset//', '-//w3c//dtd xhtml 1.0 transitional//'];

const LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
]);

//Utils
function enquoteDoctypeId(id) {
    const quote = id.indexOf('"') !== -1 ? "'" : '"';

    return quote + id + quote;
}

function hasPrefix(publicId, prefixes) {
    for (let i = 0; i < prefixes.length; i++) {
        if (publicId.indexOf(prefixes[i]) === 0) {
            return true;
        }
    }

    return false;
}

//API
exports.isConforming = function(token) {
    return (
        token.name === VALID_DOCTYPE_NAME &&
        token.publicId === null &&
        (token.systemId === null || token.systemId === VALID_SYSTEM_ID)
    );
};

exports.getDocumentMode = function(token) {
    if (token.name !== VALID_DOCTYPE_NAME) {
        return DOCUMENT_MODE.QUIRKS;
    }

    const systemId = token.systemId;

    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
        return DOCUMENT_MODE.QUIRKS;
    }

    let publicId = token.publicId;

    if (publicId !== null) {
        publicId = publicId.toLowerCase();

        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1) {
            return DOCUMENT_MODE.QUIRKS;
        }

        let prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes)) {
            return DOCUMENT_MODE.QUIRKS;
        }

        prefixes =
            systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes)) {
            return DOCUMENT_MODE.LIMITED_QUIRKS;
        }
    }

    return DOCUMENT_MODE.NO_QUIRKS;
};

exports.serializeContent = function(name, publicId, systemId) {
    let str = '!DOCTYPE ';

    if (name) {
        str += name;
    }

    if (publicId) {
        str += ' PUBLIC ' + enquoteDoctypeId(publicId);
    } else if (systemId) {
        str += ' SYSTEM';
    }

    if (systemId !== null) {
        str += ' ' + enquoteDoctypeId(systemId);
    }

    return str;
};


/***/ }),

/***/ 1445:
/***/ (function(module) {

"use strict";


module.exports = {
    controlCharacterInInputStream: 'control-character-in-input-stream',
    noncharacterInInputStream: 'noncharacter-in-input-stream',
    surrogateInInputStream: 'surrogate-in-input-stream',
    nonVoidHtmlElementStartTagWithTrailingSolidus: 'non-void-html-element-start-tag-with-trailing-solidus',
    endTagWithAttributes: 'end-tag-with-attributes',
    endTagWithTrailingSolidus: 'end-tag-with-trailing-solidus',
    unexpectedSolidusInTag: 'unexpected-solidus-in-tag',
    unexpectedNullCharacter: 'unexpected-null-character',
    unexpectedQuestionMarkInsteadOfTagName: 'unexpected-question-mark-instead-of-tag-name',
    invalidFirstCharacterOfTagName: 'invalid-first-character-of-tag-name',
    unexpectedEqualsSignBeforeAttributeName: 'unexpected-equals-sign-before-attribute-name',
    missingEndTagName: 'missing-end-tag-name',
    unexpectedCharacterInAttributeName: 'unexpected-character-in-attribute-name',
    unknownNamedCharacterReference: 'unknown-named-character-reference',
    missingSemicolonAfterCharacterReference: 'missing-semicolon-after-character-reference',
    unexpectedCharacterAfterDoctypeSystemIdentifier: 'unexpected-character-after-doctype-system-identifier',
    unexpectedCharacterInUnquotedAttributeValue: 'unexpected-character-in-unquoted-attribute-value',
    eofBeforeTagName: 'eof-before-tag-name',
    eofInTag: 'eof-in-tag',
    missingAttributeValue: 'missing-attribute-value',
    missingWhitespaceBetweenAttributes: 'missing-whitespace-between-attributes',
    missingWhitespaceAfterDoctypePublicKeyword: 'missing-whitespace-after-doctype-public-keyword',
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers:
        'missing-whitespace-between-doctype-public-and-system-identifiers',
    missingWhitespaceAfterDoctypeSystemKeyword: 'missing-whitespace-after-doctype-system-keyword',
    missingQuoteBeforeDoctypePublicIdentifier: 'missing-quote-before-doctype-public-identifier',
    missingQuoteBeforeDoctypeSystemIdentifier: 'missing-quote-before-doctype-system-identifier',
    missingDoctypePublicIdentifier: 'missing-doctype-public-identifier',
    missingDoctypeSystemIdentifier: 'missing-doctype-system-identifier',
    abruptDoctypePublicIdentifier: 'abrupt-doctype-public-identifier',
    abruptDoctypeSystemIdentifier: 'abrupt-doctype-system-identifier',
    cdataInHtmlContent: 'cdata-in-html-content',
    incorrectlyOpenedComment: 'incorrectly-opened-comment',
    eofInScriptHtmlCommentLikeText: 'eof-in-script-html-comment-like-text',
    eofInDoctype: 'eof-in-doctype',
    nestedComment: 'nested-comment',
    abruptClosingOfEmptyComment: 'abrupt-closing-of-empty-comment',
    eofInComment: 'eof-in-comment',
    incorrectlyClosedComment: 'incorrectly-closed-comment',
    eofInCdata: 'eof-in-cdata',
    absenceOfDigitsInNumericCharacterReference: 'absence-of-digits-in-numeric-character-reference',
    nullCharacterReference: 'null-character-reference',
    surrogateCharacterReference: 'surrogate-character-reference',
    characterReferenceOutsideUnicodeRange: 'character-reference-outside-unicode-range',
    controlCharacterReference: 'control-character-reference',
    noncharacterCharacterReference: 'noncharacter-character-reference',
    missingWhitespaceBeforeDoctypeName: 'missing-whitespace-before-doctype-name',
    missingDoctypeName: 'missing-doctype-name',
    invalidCharacterSequenceAfterDoctypeName: 'invalid-character-sequence-after-doctype-name',
    duplicateAttribute: 'duplicate-attribute',
    nonConformingDoctype: 'non-conforming-doctype',
    missingDoctype: 'missing-doctype',
    misplacedDoctype: 'misplaced-doctype',
    endTagWithoutMatchingOpenElement: 'end-tag-without-matching-open-element',
    closingOfElementWithOpenChildElements: 'closing-of-element-with-open-child-elements',
    disallowedContentInNoscriptInHead: 'disallowed-content-in-noscript-in-head',
    openElementsLeftAfterEof: 'open-elements-left-after-eof',
    abandonedHeadElementChild: 'abandoned-head-element-child',
    misplacedStartTagForHeadElement: 'misplaced-start-tag-for-head-element',
    nestedNoscriptInHead: 'nested-noscript-in-head',
    eofInElementThatCanContainOnlyText: 'eof-in-element-that-can-contain-only-text'
};


/***/ }),

/***/ 2710:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const Tokenizer = __webpack_require__(3183);
const HTML = __webpack_require__(5218);

//Aliases
const $ = HTML.TAG_NAMES;
const NS = HTML.NAMESPACES;
const ATTRS = HTML.ATTRS;

//MIME types
const MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
const DEFINITION_URL_ATTR = 'definitionurl';
const ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const SVG_ATTRS_ADJUSTMENT_MAP = {
    attributename: 'attributeName',
    attributetype: 'attributeType',
    basefrequency: 'baseFrequency',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    clippathunits: 'clipPathUnits',
    diffuseconstant: 'diffuseConstant',
    edgemode: 'edgeMode',
    filterunits: 'filterUnits',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    limitingconeangle: 'limitingConeAngle',
    markerheight: 'markerHeight',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    refx: 'refX',
    refy: 'refY',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textlength: 'textLength',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    xchannelselector: 'xChannelSelector',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan'
};

const XML_ATTRS_ADJUSTMENT_MAP = {
    'xlink:actuate': { prefix: 'xlink', name: 'actuate', namespace: NS.XLINK },
    'xlink:arcrole': { prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK },
    'xlink:href': { prefix: 'xlink', name: 'href', namespace: NS.XLINK },
    'xlink:role': { prefix: 'xlink', name: 'role', namespace: NS.XLINK },
    'xlink:show': { prefix: 'xlink', name: 'show', namespace: NS.XLINK },
    'xlink:title': { prefix: 'xlink', name: 'title', namespace: NS.XLINK },
    'xlink:type': { prefix: 'xlink', name: 'type', namespace: NS.XLINK },
    'xml:base': { prefix: 'xml', name: 'base', namespace: NS.XML },
    'xml:lang': { prefix: 'xml', name: 'lang', namespace: NS.XML },
    'xml:space': { prefix: 'xml', name: 'space', namespace: NS.XML },
    xmlns: { prefix: '', name: 'xmlns', namespace: NS.XMLNS },
    'xmlns:xlink': { prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS }
};

//SVG tag names adjustment map
const SVG_TAG_NAMES_ADJUSTMENT_MAP = (exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    altglyph: 'altGlyph',
    altglyphdef: 'altGlyphDef',
    altglyphitem: 'altGlyphItem',
    animatecolor: 'animateColor',
    animatemotion: 'animateMotion',
    animatetransform: 'animateTransform',
    clippath: 'clipPath',
    feblend: 'feBlend',
    fecolormatrix: 'feColorMatrix',
    fecomponenttransfer: 'feComponentTransfer',
    fecomposite: 'feComposite',
    feconvolvematrix: 'feConvolveMatrix',
    fediffuselighting: 'feDiffuseLighting',
    fedisplacementmap: 'feDisplacementMap',
    fedistantlight: 'feDistantLight',
    feflood: 'feFlood',
    fefunca: 'feFuncA',
    fefuncb: 'feFuncB',
    fefuncg: 'feFuncG',
    fefuncr: 'feFuncR',
    fegaussianblur: 'feGaussianBlur',
    feimage: 'feImage',
    femerge: 'feMerge',
    femergenode: 'feMergeNode',
    femorphology: 'feMorphology',
    feoffset: 'feOffset',
    fepointlight: 'fePointLight',
    fespecularlighting: 'feSpecularLighting',
    fespotlight: 'feSpotLight',
    fetile: 'feTile',
    feturbulence: 'feTurbulence',
    foreignobject: 'foreignObject',
    glyphref: 'glyphRef',
    lineargradient: 'linearGradient',
    radialgradient: 'radialGradient',
    textpath: 'textPath'
});

//Tags that causes exit from foreign content
const EXITS_FOREIGN_CONTENT = {
    [$.B]: true,
    [$.BIG]: true,
    [$.BLOCKQUOTE]: true,
    [$.BODY]: true,
    [$.BR]: true,
    [$.CENTER]: true,
    [$.CODE]: true,
    [$.DD]: true,
    [$.DIV]: true,
    [$.DL]: true,
    [$.DT]: true,
    [$.EM]: true,
    [$.EMBED]: true,
    [$.H1]: true,
    [$.H2]: true,
    [$.H3]: true,
    [$.H4]: true,
    [$.H5]: true,
    [$.H6]: true,
    [$.HEAD]: true,
    [$.HR]: true,
    [$.I]: true,
    [$.IMG]: true,
    [$.LI]: true,
    [$.LISTING]: true,
    [$.MENU]: true,
    [$.META]: true,
    [$.NOBR]: true,
    [$.OL]: true,
    [$.P]: true,
    [$.PRE]: true,
    [$.RUBY]: true,
    [$.S]: true,
    [$.SMALL]: true,
    [$.SPAN]: true,
    [$.STRONG]: true,
    [$.STRIKE]: true,
    [$.SUB]: true,
    [$.SUP]: true,
    [$.TABLE]: true,
    [$.TT]: true,
    [$.U]: true,
    [$.UL]: true,
    [$.VAR]: true
};

//Check exit from foreign content
exports.causesExit = function(startTagToken) {
    const tn = startTagToken.tagName;
    const isFontWithAttrs =
        tn === $.FONT &&
        (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);

    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
};

exports.adjustTokenSVGAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        const adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrName) {
            token.attrs[i].name = adjustedAttrName;
        }
    }
};

exports.adjustTokenXMLAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
        const adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};

exports.adjustTokenSVGTagName = function(token) {
    const adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];

    if (adjustedTagName) {
        token.tagName = adjustedTagName;
    }
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}

function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
        for (let i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                const value = attrs[i].value.toLowerCase();

                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }

    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}

exports.isIntegrationPoint = function(tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs)) {
        return true;
    }

    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns)) {
        return true;
    }

    return false;
};


/***/ }),

/***/ 5218:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


const NS = (exports.NAMESPACES = {
    HTML: 'http://www.w3.org/1999/xhtml',
    MATHML: 'http://www.w3.org/1998/Math/MathML',
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
    XML: 'http://www.w3.org/XML/1998/namespace',
    XMLNS: 'http://www.w3.org/2000/xmlns/'
});

exports.ATTRS = {
    TYPE: 'type',
    ACTION: 'action',
    ENCODING: 'encoding',
    PROMPT: 'prompt',
    NAME: 'name',
    COLOR: 'color',
    FACE: 'face',
    SIZE: 'size'
};

exports.DOCUMENT_MODE = {
    NO_QUIRKS: 'no-quirks',
    QUIRKS: 'quirks',
    LIMITED_QUIRKS: 'limited-quirks'
};

const $ = (exports.TAG_NAMES = {
    A: 'a',
    ADDRESS: 'address',
    ANNOTATION_XML: 'annotation-xml',
    APPLET: 'applet',
    AREA: 'area',
    ARTICLE: 'article',
    ASIDE: 'aside',

    B: 'b',
    BASE: 'base',
    BASEFONT: 'basefont',
    BGSOUND: 'bgsound',
    BIG: 'big',
    BLOCKQUOTE: 'blockquote',
    BODY: 'body',
    BR: 'br',
    BUTTON: 'button',

    CAPTION: 'caption',
    CENTER: 'center',
    CODE: 'code',
    COL: 'col',
    COLGROUP: 'colgroup',

    DD: 'dd',
    DESC: 'desc',
    DETAILS: 'details',
    DIALOG: 'dialog',
    DIR: 'dir',
    DIV: 'div',
    DL: 'dl',
    DT: 'dt',

    EM: 'em',
    EMBED: 'embed',

    FIELDSET: 'fieldset',
    FIGCAPTION: 'figcaption',
    FIGURE: 'figure',
    FONT: 'font',
    FOOTER: 'footer',
    FOREIGN_OBJECT: 'foreignObject',
    FORM: 'form',
    FRAME: 'frame',
    FRAMESET: 'frameset',

    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    HEAD: 'head',
    HEADER: 'header',
    HGROUP: 'hgroup',
    HR: 'hr',
    HTML: 'html',

    I: 'i',
    IMG: 'img',
    IMAGE: 'image',
    INPUT: 'input',
    IFRAME: 'iframe',

    KEYGEN: 'keygen',

    LABEL: 'label',
    LI: 'li',
    LINK: 'link',
    LISTING: 'listing',

    MAIN: 'main',
    MALIGNMARK: 'malignmark',
    MARQUEE: 'marquee',
    MATH: 'math',
    MENU: 'menu',
    META: 'meta',
    MGLYPH: 'mglyph',
    MI: 'mi',
    MO: 'mo',
    MN: 'mn',
    MS: 'ms',
    MTEXT: 'mtext',

    NAV: 'nav',
    NOBR: 'nobr',
    NOFRAMES: 'noframes',
    NOEMBED: 'noembed',
    NOSCRIPT: 'noscript',

    OBJECT: 'object',
    OL: 'ol',
    OPTGROUP: 'optgroup',
    OPTION: 'option',

    P: 'p',
    PARAM: 'param',
    PLAINTEXT: 'plaintext',
    PRE: 'pre',

    RB: 'rb',
    RP: 'rp',
    RT: 'rt',
    RTC: 'rtc',
    RUBY: 'ruby',

    S: 's',
    SCRIPT: 'script',
    SECTION: 'section',
    SELECT: 'select',
    SOURCE: 'source',
    SMALL: 'small',
    SPAN: 'span',
    STRIKE: 'strike',
    STRONG: 'strong',
    STYLE: 'style',
    SUB: 'sub',
    SUMMARY: 'summary',
    SUP: 'sup',

    TABLE: 'table',
    TBODY: 'tbody',
    TEMPLATE: 'template',
    TEXTAREA: 'textarea',
    TFOOT: 'tfoot',
    TD: 'td',
    TH: 'th',
    THEAD: 'thead',
    TITLE: 'title',
    TR: 'tr',
    TRACK: 'track',
    TT: 'tt',

    U: 'u',
    UL: 'ul',

    SVG: 'svg',

    VAR: 'var',

    WBR: 'wbr',

    XMP: 'xmp'
});

exports.SPECIAL_ELEMENTS = {
    [NS.HTML]: {
        [$.ADDRESS]: true,
        [$.APPLET]: true,
        [$.AREA]: true,
        [$.ARTICLE]: true,
        [$.ASIDE]: true,
        [$.BASE]: true,
        [$.BASEFONT]: true,
        [$.BGSOUND]: true,
        [$.BLOCKQUOTE]: true,
        [$.BODY]: true,
        [$.BR]: true,
        [$.BUTTON]: true,
        [$.CAPTION]: true,
        [$.CENTER]: true,
        [$.COL]: true,
        [$.COLGROUP]: true,
        [$.DD]: true,
        [$.DETAILS]: true,
        [$.DIR]: true,
        [$.DIV]: true,
        [$.DL]: true,
        [$.DT]: true,
        [$.EMBED]: true,
        [$.FIELDSET]: true,
        [$.FIGCAPTION]: true,
        [$.FIGURE]: true,
        [$.FOOTER]: true,
        [$.FORM]: true,
        [$.FRAME]: true,
        [$.FRAMESET]: true,
        [$.H1]: true,
        [$.H2]: true,
        [$.H3]: true,
        [$.H4]: true,
        [$.H5]: true,
        [$.H6]: true,
        [$.HEAD]: true,
        [$.HEADER]: true,
        [$.HGROUP]: true,
        [$.HR]: true,
        [$.HTML]: true,
        [$.IFRAME]: true,
        [$.IMG]: true,
        [$.INPUT]: true,
        [$.LI]: true,
        [$.LINK]: true,
        [$.LISTING]: true,
        [$.MAIN]: true,
        [$.MARQUEE]: true,
        [$.MENU]: true,
        [$.META]: true,
        [$.NAV]: true,
        [$.NOEMBED]: true,
        [$.NOFRAMES]: true,
        [$.NOSCRIPT]: true,
        [$.OBJECT]: true,
        [$.OL]: true,
        [$.P]: true,
        [$.PARAM]: true,
        [$.PLAINTEXT]: true,
        [$.PRE]: true,
        [$.SCRIPT]: true,
        [$.SECTION]: true,
        [$.SELECT]: true,
        [$.SOURCE]: true,
        [$.STYLE]: true,
        [$.SUMMARY]: true,
        [$.TABLE]: true,
        [$.TBODY]: true,
        [$.TD]: true,
        [$.TEMPLATE]: true,
        [$.TEXTAREA]: true,
        [$.TFOOT]: true,
        [$.TH]: true,
        [$.THEAD]: true,
        [$.TITLE]: true,
        [$.TR]: true,
        [$.TRACK]: true,
        [$.UL]: true,
        [$.WBR]: true,
        [$.XMP]: true
    },
    [NS.MATHML]: {
        [$.MI]: true,
        [$.MO]: true,
        [$.MN]: true,
        [$.MS]: true,
        [$.MTEXT]: true,
        [$.ANNOTATION_XML]: true
    },
    [NS.SVG]: {
        [$.TITLE]: true,
        [$.FOREIGN_OBJECT]: true,
        [$.DESC]: true
    }
};


/***/ }),

/***/ 3114:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


const UNDEFINED_CODE_POINTS = [
    0xfffe,
    0xffff,
    0x1fffe,
    0x1ffff,
    0x2fffe,
    0x2ffff,
    0x3fffe,
    0x3ffff,
    0x4fffe,
    0x4ffff,
    0x5fffe,
    0x5ffff,
    0x6fffe,
    0x6ffff,
    0x7fffe,
    0x7ffff,
    0x8fffe,
    0x8ffff,
    0x9fffe,
    0x9ffff,
    0xafffe,
    0xaffff,
    0xbfffe,
    0xbffff,
    0xcfffe,
    0xcffff,
    0xdfffe,
    0xdffff,
    0xefffe,
    0xeffff,
    0xffffe,
    0xfffff,
    0x10fffe,
    0x10ffff
];

exports.REPLACEMENT_CHARACTER = '\uFFFD';

exports.CODE_POINTS = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0d,
    LINE_FEED: 0x0a,
    FORM_FEED: 0x0c,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2d,
    SOLIDUS: 0x2f,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3b,
    LESS_THAN_SIGN: 0x3c,
    EQUALS_SIGN: 0x3d,
    GREATER_THAN_SIGN: 0x3e,
    QUESTION_MARK: 0x3f,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5a,
    RIGHT_SQUARE_BRACKET: 0x5d,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7a,
    REPLACEMENT_CHARACTER: 0xfffd
};

exports.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [0x2d, 0x2d], //--
    DOCTYPE_STRING: [0x44, 0x4f, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
    CDATA_START_STRING: [0x5b, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5b], //[CDATA[
    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4c, 0x49, 0x43], //PUBLIC
    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4d] //SYSTEM
};

//Surrogates
exports.isSurrogate = function(cp) {
    return cp >= 0xd800 && cp <= 0xdfff;
};

exports.isSurrogatePair = function(cp) {
    return cp >= 0xdc00 && cp <= 0xdfff;
};

exports.getSurrogatePairCodePoint = function(cp1, cp2) {
    return (cp1 - 0xd800) * 0x400 + 0x2400 + cp2;
};

//NOTE: excluding NULL and ASCII whitespace
exports.isControlCodePoint = function(cp) {
    return (
        (cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f) ||
        (cp >= 0x7f && cp <= 0x9f)
    );
};

exports.isUndefinedCodePoint = function(cp) {
    return (cp >= 0xfdd0 && cp <= 0xfdef) || UNDEFINED_CODE_POINTS.indexOf(cp) > -1;
};


/***/ }),

/***/ 4369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(814);

class ErrorReportingMixinBase extends Mixin {
    constructor(host, opts) {
        super(host);

        this.posTracker = null;
        this.onParseError = opts.onParseError;
    }

    _setErrorLocation(err) {
        err.startLine = err.endLine = this.posTracker.line;
        err.startCol = err.endCol = this.posTracker.col;
        err.startOffset = err.endOffset = this.posTracker.offset;
    }

    _reportError(code) {
        const err = {
            code: code,
            startLine: -1,
            startCol: -1,
            startOffset: -1,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };

        this._setErrorLocation(err);
        this.onParseError(err);
    }

    _getOverriddenMethods(mxn) {
        return {
            _err(code) {
                mxn._reportError(code);
            }
        };
    }
}

module.exports = ErrorReportingMixinBase;


/***/ }),

/***/ 171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ErrorReportingMixinBase = __webpack_require__(4369);
const ErrorReportingTokenizerMixin = __webpack_require__(9954);
const LocationInfoTokenizerMixin = __webpack_require__(3454);
const Mixin = __webpack_require__(814);

class ErrorReportingParserMixin extends ErrorReportingMixinBase {
    constructor(parser, opts) {
        super(parser, opts);

        this.opts = opts;
        this.ctLoc = null;
        this.locBeforeToken = false;
    }

    _setErrorLocation(err) {
        if (this.ctLoc) {
            err.startLine = this.ctLoc.startLine;
            err.startCol = this.ctLoc.startCol;
            err.startOffset = this.ctLoc.startOffset;

            err.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine;
            err.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol;
            err.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset;
        }
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            _bootstrap(document, fragmentContext) {
                orig._bootstrap.call(this, document, fragmentContext);

                Mixin.install(this.tokenizer, ErrorReportingTokenizerMixin, mxn.opts);
                Mixin.install(this.tokenizer, LocationInfoTokenizerMixin);
            },

            _processInputToken(token) {
                mxn.ctLoc = token.location;

                orig._processInputToken.call(this, token);
            },

            _err(code, options) {
                mxn.locBeforeToken = options && options.beforeToken;
                mxn._reportError(code);
            }
        };
    }
}

module.exports = ErrorReportingParserMixin;


/***/ }),

/***/ 8184:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ErrorReportingMixinBase = __webpack_require__(4369);
const PositionTrackingPreprocessorMixin = __webpack_require__(279);
const Mixin = __webpack_require__(814);

class ErrorReportingPreprocessorMixin extends ErrorReportingMixinBase {
    constructor(preprocessor, opts) {
        super(preprocessor, opts);

        this.posTracker = Mixin.install(preprocessor, PositionTrackingPreprocessorMixin);
        this.lastErrOffset = -1;
    }

    _reportError(code) {
        //NOTE: avoid reporting error twice on advance/retreat
        if (this.lastErrOffset !== this.posTracker.offset) {
            this.lastErrOffset = this.posTracker.offset;
            super._reportError(code);
        }
    }
}

module.exports = ErrorReportingPreprocessorMixin;


/***/ }),

/***/ 9954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ErrorReportingMixinBase = __webpack_require__(4369);
const ErrorReportingPreprocessorMixin = __webpack_require__(8184);
const Mixin = __webpack_require__(814);

class ErrorReportingTokenizerMixin extends ErrorReportingMixinBase {
    constructor(tokenizer, opts) {
        super(tokenizer, opts);

        const preprocessorMixin = Mixin.install(tokenizer.preprocessor, ErrorReportingPreprocessorMixin, opts);

        this.posTracker = preprocessorMixin.posTracker;
    }
}

module.exports = ErrorReportingTokenizerMixin;


/***/ }),

/***/ 4007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(814);

class LocationInfoOpenElementStackMixin extends Mixin {
    constructor(stack, opts) {
        super(stack);

        this.onItemPop = opts.onItemPop;
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            pop() {
                mxn.onItemPop(this.current);
                orig.pop.call(this);
            },

            popAllUpToHtmlElement() {
                for (let i = this.stackTop; i > 0; i--) {
                    mxn.onItemPop(this.items[i]);
                }

                orig.popAllUpToHtmlElement.call(this);
            },

            remove(element) {
                mxn.onItemPop(this.current);
                orig.remove.call(this, element);
            }
        };
    }
}

module.exports = LocationInfoOpenElementStackMixin;


/***/ }),

/***/ 9938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(814);
const Tokenizer = __webpack_require__(3183);
const LocationInfoTokenizerMixin = __webpack_require__(3454);
const LocationInfoOpenElementStackMixin = __webpack_require__(4007);
const HTML = __webpack_require__(5218);

//Aliases
const $ = HTML.TAG_NAMES;

class LocationInfoParserMixin extends Mixin {
    constructor(parser) {
        super(parser);

        this.parser = parser;
        this.treeAdapter = this.parser.treeAdapter;
        this.posTracker = null;
        this.lastStartTagToken = null;
        this.lastFosterParentingLocation = null;
        this.currentToken = null;
    }

    _setStartLocation(element) {
        let loc = null;

        if (this.lastStartTagToken) {
            loc = Object.assign({}, this.lastStartTagToken.location);
            loc.startTag = this.lastStartTagToken.location;
        }

        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
    }

    _setEndLocation(element, closingToken) {
        const loc = this.treeAdapter.getNodeSourceCodeLocation(element);

        if (loc) {
            if (closingToken.location) {
                const ctLoc = closingToken.location;
                const tn = this.treeAdapter.getTagName(element);

                // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
                // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
                const isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;
                const endLoc = {};
                if (isClosingEndTag) {
                    endLoc.endTag = Object.assign({}, ctLoc);
                    endLoc.endLine = ctLoc.endLine;
                    endLoc.endCol = ctLoc.endCol;
                    endLoc.endOffset = ctLoc.endOffset;
                } else {
                    endLoc.endLine = ctLoc.startLine;
                    endLoc.endCol = ctLoc.startCol;
                    endLoc.endOffset = ctLoc.startOffset;
                }

                this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
            }
        }
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            _bootstrap(document, fragmentContext) {
                orig._bootstrap.call(this, document, fragmentContext);

                mxn.lastStartTagToken = null;
                mxn.lastFosterParentingLocation = null;
                mxn.currentToken = null;

                const tokenizerMixin = Mixin.install(this.tokenizer, LocationInfoTokenizerMixin);

                mxn.posTracker = tokenizerMixin.posTracker;

                Mixin.install(this.openElements, LocationInfoOpenElementStackMixin, {
                    onItemPop: function(element) {
                        mxn._setEndLocation(element, mxn.currentToken);
                    }
                });
            },

            _runParsingLoop(scriptHandler) {
                orig._runParsingLoop.call(this, scriptHandler);

                // NOTE: generate location info for elements
                // that remains on open element stack
                for (let i = this.openElements.stackTop; i >= 0; i--) {
                    mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
                }
            },

            //Token processing
            _processTokenInForeignContent(token) {
                mxn.currentToken = token;
                orig._processTokenInForeignContent.call(this, token);
            },

            _processToken(token) {
                mxn.currentToken = token;
                orig._processToken.call(this, token);

                //NOTE: <body> and <html> are never popped from the stack, so we need to updated
                //their end location explicitly.
                const requireExplicitUpdate =
                    token.type === Tokenizer.END_TAG_TOKEN &&
                    (token.tagName === $.HTML || (token.tagName === $.BODY && this.openElements.hasInScope($.BODY)));

                if (requireExplicitUpdate) {
                    for (let i = this.openElements.stackTop; i >= 0; i--) {
                        const element = this.openElements.items[i];

                        if (this.treeAdapter.getTagName(element) === token.tagName) {
                            mxn._setEndLocation(element, token);
                            break;
                        }
                    }
                }
            },

            //Doctype
            _setDocumentType(token) {
                orig._setDocumentType.call(this, token);

                const documentChildren = this.treeAdapter.getChildNodes(this.document);
                const cnLength = documentChildren.length;

                for (let i = 0; i < cnLength; i++) {
                    const node = documentChildren[i];

                    if (this.treeAdapter.isDocumentTypeNode(node)) {
                        this.treeAdapter.setNodeSourceCodeLocation(node, token.location);
                        break;
                    }
                }
            },

            //Elements
            _attachElementToTree(element) {
                //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
                //So we will use token location stored in this methods for the element.
                mxn._setStartLocation(element);
                mxn.lastStartTagToken = null;
                orig._attachElementToTree.call(this, element);
            },

            _appendElement(token, namespaceURI) {
                mxn.lastStartTagToken = token;
                orig._appendElement.call(this, token, namespaceURI);
            },

            _insertElement(token, namespaceURI) {
                mxn.lastStartTagToken = token;
                orig._insertElement.call(this, token, namespaceURI);
            },

            _insertTemplate(token) {
                mxn.lastStartTagToken = token;
                orig._insertTemplate.call(this, token);

                const tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);

                this.treeAdapter.setNodeSourceCodeLocation(tmplContent, null);
            },

            _insertFakeRootElement() {
                orig._insertFakeRootElement.call(this);
                this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
            },

            //Comments
            _appendCommentNode(token, parent) {
                orig._appendCommentNode.call(this, token, parent);

                const children = this.treeAdapter.getChildNodes(parent);
                const commentNode = children[children.length - 1];

                this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
            },

            //Text
            _findFosterParentingLocation() {
                //NOTE: store last foster parenting location, so we will be able to find inserted text
                //in case of foster parenting
                mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);

                return mxn.lastFosterParentingLocation;
            },

            _insertCharacters(token) {
                orig._insertCharacters.call(this, token);

                const hasFosterParent = this._shouldFosterParentOnInsertion();

                const parent =
                    (hasFosterParent && mxn.lastFosterParentingLocation.parent) ||
                    this.openElements.currentTmplContent ||
                    this.openElements.current;

                const siblings = this.treeAdapter.getChildNodes(parent);

                const textNodeIdx =
                    hasFosterParent && mxn.lastFosterParentingLocation.beforeElement
                        ? siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1
                        : siblings.length - 1;

                const textNode = siblings[textNodeIdx];

                //NOTE: if we have location assigned by another token, then just update end position
                const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);

                if (tnLoc) {
                    const { endLine, endCol, endOffset } = token.location;
                    this.treeAdapter.updateNodeSourceCodeLocation(textNode, { endLine, endCol, endOffset });
                } else {
                    this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
                }
            }
        };
    }
}

module.exports = LocationInfoParserMixin;


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(814);
const Tokenizer = __webpack_require__(3183);
const PositionTrackingPreprocessorMixin = __webpack_require__(279);

class LocationInfoTokenizerMixin extends Mixin {
    constructor(tokenizer) {
        super(tokenizer);

        this.tokenizer = tokenizer;
        this.posTracker = Mixin.install(tokenizer.preprocessor, PositionTrackingPreprocessorMixin);
        this.currentAttrLocation = null;
        this.ctLoc = null;
    }

    _getCurrentLocation() {
        return {
            startLine: this.posTracker.line,
            startCol: this.posTracker.col,
            startOffset: this.posTracker.offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }

    _attachCurrentAttrLocationInfo() {
        this.currentAttrLocation.endLine = this.posTracker.line;
        this.currentAttrLocation.endCol = this.posTracker.col;
        this.currentAttrLocation.endOffset = this.posTracker.offset;

        const currentToken = this.tokenizer.currentToken;
        const currentAttr = this.tokenizer.currentAttr;

        if (!currentToken.location.attrs) {
            currentToken.location.attrs = Object.create(null);
        }

        currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
    }

    _getOverriddenMethods(mxn, orig) {
        const methods = {
            _createStartTagToken() {
                orig._createStartTagToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },

            _createEndTagToken() {
                orig._createEndTagToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },

            _createCommentToken() {
                orig._createCommentToken.call(this);
                this.currentToken.location = mxn.ctLoc;
            },

            _createDoctypeToken(initialName) {
                orig._createDoctypeToken.call(this, initialName);
                this.currentToken.location = mxn.ctLoc;
            },

            _createCharacterToken(type, ch) {
                orig._createCharacterToken.call(this, type, ch);
                this.currentCharacterToken.location = mxn.ctLoc;
            },

            _createEOFToken() {
                orig._createEOFToken.call(this);
                this.currentToken.location = mxn._getCurrentLocation();
            },

            _createAttr(attrNameFirstCh) {
                orig._createAttr.call(this, attrNameFirstCh);
                mxn.currentAttrLocation = mxn._getCurrentLocation();
            },

            _leaveAttrName(toState) {
                orig._leaveAttrName.call(this, toState);
                mxn._attachCurrentAttrLocationInfo();
            },

            _leaveAttrValue(toState) {
                orig._leaveAttrValue.call(this, toState);
                mxn._attachCurrentAttrLocationInfo();
            },

            _emitCurrentToken() {
                const ctLoc = this.currentToken.location;

                //NOTE: if we have pending character token make it's end location equal to the
                //current token's start location.
                if (this.currentCharacterToken) {
                    this.currentCharacterToken.location.endLine = ctLoc.startLine;
                    this.currentCharacterToken.location.endCol = ctLoc.startCol;
                    this.currentCharacterToken.location.endOffset = ctLoc.startOffset;
                }

                if (this.currentToken.type === Tokenizer.EOF_TOKEN) {
                    ctLoc.endLine = ctLoc.startLine;
                    ctLoc.endCol = ctLoc.startCol;
                    ctLoc.endOffset = ctLoc.startOffset;
                } else {
                    ctLoc.endLine = mxn.posTracker.line;
                    ctLoc.endCol = mxn.posTracker.col + 1;
                    ctLoc.endOffset = mxn.posTracker.offset + 1;
                }

                orig._emitCurrentToken.call(this);
            },

            _emitCurrentCharacterToken() {
                const ctLoc = this.currentCharacterToken && this.currentCharacterToken.location;

                //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
                //then set it's location at the current preprocessor position.
                //We don't need to increment preprocessor position, since character token
                //emission is always forced by the start of the next character token here.
                //So, we already have advanced position.
                if (ctLoc && ctLoc.endOffset === -1) {
                    ctLoc.endLine = mxn.posTracker.line;
                    ctLoc.endCol = mxn.posTracker.col;
                    ctLoc.endOffset = mxn.posTracker.offset;
                }

                orig._emitCurrentCharacterToken.call(this);
            }
        };

        //NOTE: patch initial states for each mode to obtain token start position
        Object.keys(Tokenizer.MODE).forEach(modeName => {
            const state = Tokenizer.MODE[modeName];

            methods[state] = function(cp) {
                mxn.ctLoc = mxn._getCurrentLocation();
                orig[state].call(this, cp);
            };
        });

        return methods;
    }
}

module.exports = LocationInfoTokenizerMixin;


/***/ }),

/***/ 279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Mixin = __webpack_require__(814);

class PositionTrackingPreprocessorMixin extends Mixin {
    constructor(preprocessor) {
        super(preprocessor);

        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;

        this.offset = 0;
        this.col = 0;
        this.line = 1;
    }

    _getOverriddenMethods(mxn, orig) {
        return {
            advance() {
                const pos = this.pos + 1;
                const ch = this.html[pos];

                //NOTE: LF should be in the last column of the line
                if (mxn.isEol) {
                    mxn.isEol = false;
                    mxn.line++;
                    mxn.lineStartPos = pos;
                }

                if (ch === '\n' || (ch === '\r' && this.html[pos + 1] !== '\n')) {
                    mxn.isEol = true;
                }

                mxn.col = pos - mxn.lineStartPos + 1;
                mxn.offset = mxn.droppedBufferSize + pos;

                return orig.advance.call(this);
            },

            retreat() {
                orig.retreat.call(this);

                mxn.isEol = false;
                mxn.col = this.pos - mxn.lineStartPos + 1;
            },

            dropParsedChunk() {
                const prevPos = this.pos;

                orig.dropParsedChunk.call(this);

                const reduction = prevPos - this.pos;

                mxn.lineStartPos -= reduction;
                mxn.droppedBufferSize += reduction;
                mxn.offset = mxn.droppedBufferSize + this.pos;
            }
        };
    }
}

module.exports = PositionTrackingPreprocessorMixin;


/***/ }),

/***/ 3652:
/***/ (function(module) {

"use strict";


//Const
const NOAH_ARK_CAPACITY = 3;

//List of formatting elements
class FormattingElementList {
    constructor(treeAdapter) {
        this.length = 0;
        this.entries = [];
        this.treeAdapter = treeAdapter;
        this.bookmark = null;
    }

    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement) {
        const candidates = [];

        if (this.length >= NOAH_ARK_CAPACITY) {
            const neAttrsLength = this.treeAdapter.getAttrList(newElement).length;
            const neTagName = this.treeAdapter.getTagName(newElement);
            const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

            for (let i = this.length - 1; i >= 0; i--) {
                const entry = this.entries[i];

                if (entry.type === FormattingElementList.MARKER_ENTRY) {
                    break;
                }

                const element = entry.element;
                const elementAttrs = this.treeAdapter.getAttrList(element);

                const isCandidate =
                    this.treeAdapter.getTagName(element) === neTagName &&
                    this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
                    elementAttrs.length === neAttrsLength;

                if (isCandidate) {
                    candidates.push({ idx: i, attrs: elementAttrs });
                }
            }
        }

        return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
    }

    _ensureNoahArkCondition(newElement) {
        const candidates = this._getNoahArkConditionCandidates(newElement);
        let cLength = candidates.length;

        if (cLength) {
            const neAttrs = this.treeAdapter.getAttrList(newElement);
            const neAttrsLength = neAttrs.length;
            const neAttrsMap = Object.create(null);

            //NOTE: build attrs map for the new element so we can perform fast lookups
            for (let i = 0; i < neAttrsLength; i++) {
                const neAttr = neAttrs[i];

                neAttrsMap[neAttr.name] = neAttr.value;
            }

            for (let i = 0; i < neAttrsLength; i++) {
                for (let j = 0; j < cLength; j++) {
                    const cAttr = candidates[j].attrs[i];

                    if (neAttrsMap[cAttr.name] !== cAttr.value) {
                        candidates.splice(j, 1);
                        cLength--;
                    }

                    if (candidates.length < NOAH_ARK_CAPACITY) {
                        return;
                    }
                }
            }

            //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
            for (let i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
                this.entries.splice(candidates[i].idx, 1);
                this.length--;
            }
        }
    }

    //Mutations
    insertMarker() {
        this.entries.push({ type: FormattingElementList.MARKER_ENTRY });
        this.length++;
    }

    pushElement(element, token) {
        this._ensureNoahArkCondition(element);

        this.entries.push({
            type: FormattingElementList.ELEMENT_ENTRY,
            element: element,
            token: token
        });

        this.length++;
    }

    insertElementAfterBookmark(element, token) {
        let bookmarkIdx = this.length - 1;

        for (; bookmarkIdx >= 0; bookmarkIdx--) {
            if (this.entries[bookmarkIdx] === this.bookmark) {
                break;
            }
        }

        this.entries.splice(bookmarkIdx + 1, 0, {
            type: FormattingElementList.ELEMENT_ENTRY,
            element: element,
            token: token
        });

        this.length++;
    }

    removeEntry(entry) {
        for (let i = this.length - 1; i >= 0; i--) {
            if (this.entries[i] === entry) {
                this.entries.splice(i, 1);
                this.length--;
                break;
            }
        }
    }

    clearToLastMarker() {
        while (this.length) {
            const entry = this.entries.pop();

            this.length--;

            if (entry.type === FormattingElementList.MARKER_ENTRY) {
                break;
            }
        }
    }

    //Search
    getElementEntryInScopeWithTagName(tagName) {
        for (let i = this.length - 1; i >= 0; i--) {
            const entry = this.entries[i];

            if (entry.type === FormattingElementList.MARKER_ENTRY) {
                return null;
            }

            if (this.treeAdapter.getTagName(entry.element) === tagName) {
                return entry;
            }
        }

        return null;
    }

    getElementEntry(element) {
        for (let i = this.length - 1; i >= 0; i--) {
            const entry = this.entries[i];

            if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element) {
                return entry;
            }
        }

        return null;
    }
}

//Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';

module.exports = FormattingElementList;


/***/ }),

/***/ 7045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Tokenizer = __webpack_require__(3183);
const OpenElementStack = __webpack_require__(3203);
const FormattingElementList = __webpack_require__(3652);
const LocationInfoParserMixin = __webpack_require__(9938);
const ErrorReportingParserMixin = __webpack_require__(171);
const Mixin = __webpack_require__(814);
const defaultTreeAdapter = __webpack_require__(9132);
const mergeOptions = __webpack_require__(8395);
const doctype = __webpack_require__(7827);
const foreignContent = __webpack_require__(2710);
const ERR = __webpack_require__(1445);
const unicode = __webpack_require__(3114);
const HTML = __webpack_require__(5218);

//Aliases
const $ = HTML.TAG_NAMES;
const NS = HTML.NAMESPACES;
const ATTRS = HTML.ATTRS;

const DEFAULT_OPTIONS = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    onParseError: null,
    treeAdapter: defaultTreeAdapter
};

//Misc constants
const HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
const AA_OUTER_LOOP_ITER = 8;
const AA_INNER_LOOP_ITER = 3;

//Insertion modes
const INITIAL_MODE = 'INITIAL_MODE';
const BEFORE_HTML_MODE = 'BEFORE_HTML_MODE';
const BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE';
const IN_HEAD_MODE = 'IN_HEAD_MODE';
const IN_HEAD_NO_SCRIPT_MODE = 'IN_HEAD_NO_SCRIPT_MODE';
const AFTER_HEAD_MODE = 'AFTER_HEAD_MODE';
const IN_BODY_MODE = 'IN_BODY_MODE';
const TEXT_MODE = 'TEXT_MODE';
const IN_TABLE_MODE = 'IN_TABLE_MODE';
const IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE';
const IN_CAPTION_MODE = 'IN_CAPTION_MODE';
const IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE';
const IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE';
const IN_ROW_MODE = 'IN_ROW_MODE';
const IN_CELL_MODE = 'IN_CELL_MODE';
const IN_SELECT_MODE = 'IN_SELECT_MODE';
const IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE';
const IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE';
const AFTER_BODY_MODE = 'AFTER_BODY_MODE';
const IN_FRAMESET_MODE = 'IN_FRAMESET_MODE';
const AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE';
const AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE';
const AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
const INSERTION_MODE_RESET_MAP = {
    [$.TR]: IN_ROW_MODE,
    [$.TBODY]: IN_TABLE_BODY_MODE,
    [$.THEAD]: IN_TABLE_BODY_MODE,
    [$.TFOOT]: IN_TABLE_BODY_MODE,
    [$.CAPTION]: IN_CAPTION_MODE,
    [$.COLGROUP]: IN_COLUMN_GROUP_MODE,
    [$.TABLE]: IN_TABLE_MODE,
    [$.BODY]: IN_BODY_MODE,
    [$.FRAMESET]: IN_FRAMESET_MODE
};

//Template insertion mode switch map
const TEMPLATE_INSERTION_MODE_SWITCH_MAP = {
    [$.CAPTION]: IN_TABLE_MODE,
    [$.COLGROUP]: IN_TABLE_MODE,
    [$.TBODY]: IN_TABLE_MODE,
    [$.TFOOT]: IN_TABLE_MODE,
    [$.THEAD]: IN_TABLE_MODE,
    [$.COL]: IN_COLUMN_GROUP_MODE,
    [$.TR]: IN_TABLE_BODY_MODE,
    [$.TD]: IN_ROW_MODE,
    [$.TH]: IN_ROW_MODE
};

//Token handlers map for insertion modes
const TOKEN_HANDLERS = {
    [INITIAL_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInInitialMode,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInInitialMode,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: doctypeInInitialMode,
        [Tokenizer.START_TAG_TOKEN]: tokenInInitialMode,
        [Tokenizer.END_TAG_TOKEN]: tokenInInitialMode,
        [Tokenizer.EOF_TOKEN]: tokenInInitialMode
    },
    [BEFORE_HTML_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenBeforeHtml,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenBeforeHtml,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagBeforeHtml,
        [Tokenizer.END_TAG_TOKEN]: endTagBeforeHtml,
        [Tokenizer.EOF_TOKEN]: tokenBeforeHtml
    },
    [BEFORE_HEAD_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenBeforeHead,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenBeforeHead,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagBeforeHead,
        [Tokenizer.END_TAG_TOKEN]: endTagBeforeHead,
        [Tokenizer.EOF_TOKEN]: tokenBeforeHead
    },
    [IN_HEAD_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInHead,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInHead,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagInHead,
        [Tokenizer.END_TAG_TOKEN]: endTagInHead,
        [Tokenizer.EOF_TOKEN]: tokenInHead
    },
    [IN_HEAD_NO_SCRIPT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInHeadNoScript,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInHeadNoScript,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagInHeadNoScript,
        [Tokenizer.END_TAG_TOKEN]: endTagInHeadNoScript,
        [Tokenizer.EOF_TOKEN]: tokenInHeadNoScript
    },
    [AFTER_HEAD_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenAfterHead,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenAfterHead,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: misplacedDoctype,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterHead,
        [Tokenizer.END_TAG_TOKEN]: endTagAfterHead,
        [Tokenizer.EOF_TOKEN]: tokenAfterHead
    },
    [IN_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInBody,
        [Tokenizer.END_TAG_TOKEN]: endTagInBody,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [TEXT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.NULL_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: ignoreToken,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: ignoreToken,
        [Tokenizer.END_TAG_TOKEN]: endTagInText,
        [Tokenizer.EOF_TOKEN]: eofInText
    },
    [IN_TABLE_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.NULL_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInTable,
        [Tokenizer.END_TAG_TOKEN]: endTagInTable,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_TABLE_TEXT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTableText,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInTableText,
        [Tokenizer.COMMENT_TOKEN]: tokenInTableText,
        [Tokenizer.DOCTYPE_TOKEN]: tokenInTableText,
        [Tokenizer.START_TAG_TOKEN]: tokenInTableText,
        [Tokenizer.END_TAG_TOKEN]: tokenInTableText,
        [Tokenizer.EOF_TOKEN]: tokenInTableText
    },
    [IN_CAPTION_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInCaption,
        [Tokenizer.END_TAG_TOKEN]: endTagInCaption,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_COLUMN_GROUP_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenInColumnGroup,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenInColumnGroup,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInColumnGroup,
        [Tokenizer.END_TAG_TOKEN]: endTagInColumnGroup,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_TABLE_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.NULL_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInTableBody,
        [Tokenizer.END_TAG_TOKEN]: endTagInTableBody,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_ROW_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.NULL_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInRow,
        [Tokenizer.END_TAG_TOKEN]: endTagInRow,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_CELL_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInCell,
        [Tokenizer.END_TAG_TOKEN]: endTagInCell,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_SELECT_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInSelect,
        [Tokenizer.END_TAG_TOKEN]: endTagInSelect,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_SELECT_IN_TABLE_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInSelectInTable,
        [Tokenizer.END_TAG_TOKEN]: endTagInSelectInTable,
        [Tokenizer.EOF_TOKEN]: eofInBody
    },
    [IN_TEMPLATE_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: characterInBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInTemplate,
        [Tokenizer.END_TAG_TOKEN]: endTagInTemplate,
        [Tokenizer.EOF_TOKEN]: eofInTemplate
    },
    [AFTER_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenAfterBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenAfterBody,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendCommentToRootHtmlElement,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterBody,
        [Tokenizer.END_TAG_TOKEN]: endTagAfterBody,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [IN_FRAMESET_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagInFrameset,
        [Tokenizer.END_TAG_TOKEN]: endTagInFrameset,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [AFTER_FRAMESET_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
        [Tokenizer.COMMENT_TOKEN]: appendComment,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterFrameset,
        [Tokenizer.END_TAG_TOKEN]: endTagAfterFrameset,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [AFTER_AFTER_BODY_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: tokenAfterAfterBody,
        [Tokenizer.NULL_CHARACTER_TOKEN]: tokenAfterAfterBody,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendCommentToDocument,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterAfterBody,
        [Tokenizer.END_TAG_TOKEN]: tokenAfterAfterBody,
        [Tokenizer.EOF_TOKEN]: stopParsing
    },
    [AFTER_AFTER_FRAMESET_MODE]: {
        [Tokenizer.CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.NULL_CHARACTER_TOKEN]: ignoreToken,
        [Tokenizer.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
        [Tokenizer.COMMENT_TOKEN]: appendCommentToDocument,
        [Tokenizer.DOCTYPE_TOKEN]: ignoreToken,
        [Tokenizer.START_TAG_TOKEN]: startTagAfterAfterFrameset,
        [Tokenizer.END_TAG_TOKEN]: ignoreToken,
        [Tokenizer.EOF_TOKEN]: stopParsing
    }
};

//Parser
class Parser {
    constructor(options) {
        this.options = mergeOptions(DEFAULT_OPTIONS, options);

        this.treeAdapter = this.options.treeAdapter;
        this.pendingScript = null;

        if (this.options.sourceCodeLocationInfo) {
            Mixin.install(this, LocationInfoParserMixin);
        }

        if (this.options.onParseError) {
            Mixin.install(this, ErrorReportingParserMixin, { onParseError: this.options.onParseError });
        }
    }

    // API
    parse(html) {
        const document = this.treeAdapter.createDocument();

        this._bootstrap(document, null);
        this.tokenizer.write(html, true);
        this._runParsingLoop(null);

        return document;
    }

    parseFragment(html, fragmentContext) {
        //NOTE: use <template> element as a fragment context if context element was not provided,
        //so we will parse in "forgiving" manner
        if (!fragmentContext) {
            fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);
        }

        //NOTE: create fake element which will be used as 'document' for fragment parsing.
        //This is important for jsdom there 'document' can't be recreated, therefore
        //fragment parsing causes messing of the main `document`.
        const documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);

        this._bootstrap(documentMock, fragmentContext);

        if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE) {
            this._pushTmplInsertionMode(IN_TEMPLATE_MODE);
        }

        this._initTokenizerForFragmentParsing();
        this._insertFakeRootElement();
        this._resetInsertionMode();
        this._findFormInFragmentContext();
        this.tokenizer.write(html, true);
        this._runParsingLoop(null);

        const rootElement = this.treeAdapter.getFirstChild(documentMock);
        const fragment = this.treeAdapter.createDocumentFragment();

        this._adoptNodes(rootElement, fragment);

        return fragment;
    }

    //Bootstrap parser
    _bootstrap(document, fragmentContext) {
        this.tokenizer = new Tokenizer(this.options);

        this.stopped = false;

        this.insertionMode = INITIAL_MODE;
        this.originalInsertionMode = '';

        this.document = document;
        this.fragmentContext = fragmentContext;

        this.headElement = null;
        this.formElement = null;

        this.openElements = new OpenElementStack(this.document, this.treeAdapter);
        this.activeFormattingElements = new FormattingElementList(this.treeAdapter);

        this.tmplInsertionModeStack = [];
        this.tmplInsertionModeStackTop = -1;
        this.currentTmplInsertionMode = null;

        this.pendingCharacterTokens = [];
        this.hasNonWhitespacePendingCharacterToken = false;

        this.framesetOk = true;
        this.skipNextNewLine = false;
        this.fosterParentingEnabled = false;
    }

    //Errors
    _err() {
        // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    //Parsing loop
    _runParsingLoop(scriptHandler) {
        while (!this.stopped) {
            this._setupTokenizerCDATAMode();

            const token = this.tokenizer.getNextToken();

            if (token.type === Tokenizer.HIBERNATION_TOKEN) {
                break;
            }

            if (this.skipNextNewLine) {
                this.skipNextNewLine = false;

                if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
                    if (token.chars.length === 1) {
                        continue;
                    }

                    token.chars = token.chars.substr(1);
                }
            }

            this._processInputToken(token);

            if (scriptHandler && this.pendingScript) {
                break;
            }
        }
    }

    runParsingLoopForCurrentChunk(writeCallback, scriptHandler) {
        this._runParsingLoop(scriptHandler);

        if (scriptHandler && this.pendingScript) {
            const script = this.pendingScript;

            this.pendingScript = null;

            scriptHandler(script);

            return;
        }

        if (writeCallback) {
            writeCallback();
        }
    }

    //Text parsing
    _setupTokenizerCDATAMode() {
        const current = this._getAdjustedCurrentElement();

        this.tokenizer.allowCDATA =
            current &&
            current !== this.document &&
            this.treeAdapter.getNamespaceURI(current) !== NS.HTML &&
            !this._isIntegrationPoint(current);
    }

    _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, NS.HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = TEXT_MODE;
    }

    switchToPlaintextParsing() {
        this.insertionMode = TEXT_MODE;
        this.originalInsertionMode = IN_BODY_MODE;
        this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }

    //Fragment parsing
    _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext
            ? this.fragmentContext
            : this.openElements.current;
    }

    _findFormInFragmentContext() {
        let node = this.fragmentContext;

        do {
            if (this.treeAdapter.getTagName(node) === $.FORM) {
                this.formElement = node;
                break;
            }

            node = this.treeAdapter.getParentNode(node);
        } while (node);
    }

    _initTokenizerForFragmentParsing() {
        if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
            const tn = this.treeAdapter.getTagName(this.fragmentContext);

            if (tn === $.TITLE || tn === $.TEXTAREA) {
                this.tokenizer.state = Tokenizer.MODE.RCDATA;
            } else if (
                tn === $.STYLE ||
                tn === $.XMP ||
                tn === $.IFRAME ||
                tn === $.NOEMBED ||
                tn === $.NOFRAMES ||
                tn === $.NOSCRIPT
            ) {
                this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
            } else if (tn === $.SCRIPT) {
                this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;
            } else if (tn === $.PLAINTEXT) {
                this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
            }
        }
    }

    //Tree mutation
    _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';

        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
    }

    _attachElementToTree(element) {
        if (this._shouldFosterParentOnInsertion()) {
            this._fosterParentElement(element);
        } else {
            const parent = this.openElements.currentTmplContent || this.openElements.current;

            this.treeAdapter.appendChild(parent, element);
        }
    }

    _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

        this._attachElementToTree(element);
    }

    _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

        this._attachElementToTree(element);
        this.openElements.push(element);
    }

    _insertFakeElement(tagName) {
        const element = this.treeAdapter.createElement(tagName, NS.HTML, []);

        this._attachElementToTree(element);
        this.openElements.push(element);
    }

    _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();

        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl);
        this.openElements.push(tmpl);
    }

    _insertFakeRootElement() {
        const element = this.treeAdapter.createElement($.HTML, NS.HTML, []);

        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element);
    }

    _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);

        this.treeAdapter.appendChild(parent, commentNode);
    }

    _insertCharacters(token) {
        if (this._shouldFosterParentOnInsertion()) {
            this._fosterParentText(token.chars);
        } else {
            const parent = this.openElements.currentTmplContent || this.openElements.current;

            this.treeAdapter.insertText(parent, token.chars);
        }
    }

    _adoptNodes(donor, recipient) {
        for (let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }

    //Token processing
    _shouldProcessTokenInForeignContent(token) {
        const current = this._getAdjustedCurrentElement();

        if (!current || current === this.document) {
            return false;
        }

        const ns = this.treeAdapter.getNamespaceURI(current);

        if (ns === NS.HTML) {
            return false;
        }

        if (
            this.treeAdapter.getTagName(current) === $.ANNOTATION_XML &&
            ns === NS.MATHML &&
            token.type === Tokenizer.START_TAG_TOKEN &&
            token.tagName === $.SVG
        ) {
            return false;
        }

        const isCharacterToken =
            token.type === Tokenizer.CHARACTER_TOKEN ||
            token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
            token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN;

        const isMathMLTextStartTag =
            token.type === Tokenizer.START_TAG_TOKEN && token.tagName !== $.MGLYPH && token.tagName !== $.MALIGNMARK;

        if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML)) {
            return false;
        }

        if (
            (token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) &&
            this._isIntegrationPoint(current, NS.HTML)
        ) {
            return false;
        }

        return token.type !== Tokenizer.EOF_TOKEN;
    }

    _processToken(token) {
        TOKEN_HANDLERS[this.insertionMode][token.type](this, token);
    }

    _processTokenInBodyMode(token) {
        TOKEN_HANDLERS[IN_BODY_MODE][token.type](this, token);
    }

    _processTokenInForeignContent(token) {
        if (token.type === Tokenizer.CHARACTER_TOKEN) {
            characterInForeignContent(this, token);
        } else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN) {
            nullCharacterInForeignContent(this, token);
        } else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN) {
            insertCharacters(this, token);
        } else if (token.type === Tokenizer.COMMENT_TOKEN) {
            appendComment(this, token);
        } else if (token.type === Tokenizer.START_TAG_TOKEN) {
            startTagInForeignContent(this, token);
        } else if (token.type === Tokenizer.END_TAG_TOKEN) {
            endTagInForeignContent(this, token);
        }
    }

    _processInputToken(token) {
        if (this._shouldProcessTokenInForeignContent(token)) {
            this._processTokenInForeignContent(token);
        } else {
            this._processToken(token);
        }

        if (token.type === Tokenizer.START_TAG_TOKEN && token.selfClosing && !token.ackSelfClosing) {
            this._err(ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
        }
    }

    //Integration points
    _isIntegrationPoint(element, foreignNS) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);

        return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
    }

    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.length;

        if (listLength) {
            let unopenIdx = listLength;
            let entry = null;

            do {
                unopenIdx--;
                entry = this.activeFormattingElements.entries[unopenIdx];

                if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                    unopenIdx++;
                    break;
                }
            } while (unopenIdx > 0);

            for (let i = unopenIdx; i < listLength; i++) {
                entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }

    //Close elements
    _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = IN_ROW_MODE;
    }

    _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion($.P);
        this.openElements.popUntilTagNamePopped($.P);
    }

    //Insertion modes
    _resetInsertionMode() {
        for (let i = this.openElements.stackTop, last = false; i >= 0; i--) {
            let element = this.openElements.items[i];

            if (i === 0) {
                last = true;

                if (this.fragmentContext) {
                    element = this.fragmentContext;
                }
            }

            const tn = this.treeAdapter.getTagName(element);
            const newInsertionMode = INSERTION_MODE_RESET_MAP[tn];

            if (newInsertionMode) {
                this.insertionMode = newInsertionMode;
                break;
            } else if (!last && (tn === $.TD || tn === $.TH)) {
                this.insertionMode = IN_CELL_MODE;
                break;
            } else if (!last && tn === $.HEAD) {
                this.insertionMode = IN_HEAD_MODE;
                break;
            } else if (tn === $.SELECT) {
                this._resetInsertionModeForSelect(i);
                break;
            } else if (tn === $.TEMPLATE) {
                this.insertionMode = this.currentTmplInsertionMode;
                break;
            } else if (tn === $.HTML) {
                this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
                break;
            } else if (last) {
                this.insertionMode = IN_BODY_MODE;
                break;
            }
        }
    }

    _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) {
            for (let i = selectIdx - 1; i > 0; i--) {
                const ancestor = this.openElements.items[i];
                const tn = this.treeAdapter.getTagName(ancestor);

                if (tn === $.TEMPLATE) {
                    break;
                } else if (tn === $.TABLE) {
                    this.insertionMode = IN_SELECT_IN_TABLE_MODE;
                    return;
                }
            }
        }

        this.insertionMode = IN_SELECT_MODE;
    }

    _pushTmplInsertionMode(mode) {
        this.tmplInsertionModeStack.push(mode);
        this.tmplInsertionModeStackTop++;
        this.currentTmplInsertionMode = mode;
    }

    _popTmplInsertionMode() {
        this.tmplInsertionModeStack.pop();
        this.tmplInsertionModeStackTop--;
        this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }

    //Foster parenting
    _isElementCausesFosterParenting(element) {
        const tn = this.treeAdapter.getTagName(element);

        return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
    }

    _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }

    _findFosterParentingLocation() {
        const location = {
            parent: null,
            beforeElement: null
        };

        for (let i = this.openElements.stackTop; i >= 0; i--) {
            const openElement = this.openElements.items[i];
            const tn = this.treeAdapter.getTagName(openElement);
            const ns = this.treeAdapter.getNamespaceURI(openElement);

            if (tn === $.TEMPLATE && ns === NS.HTML) {
                location.parent = this.treeAdapter.getTemplateContent(openElement);
                break;
            } else if (tn === $.TABLE) {
                location.parent = this.treeAdapter.getParentNode(openElement);

                if (location.parent) {
                    location.beforeElement = openElement;
                } else {
                    location.parent = this.openElements.items[i - 1];
                }

                break;
            }
        }

        if (!location.parent) {
            location.parent = this.openElements.items[0];
        }

        return location;
    }

    _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();

        if (location.beforeElement) {
            this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        } else {
            this.treeAdapter.appendChild(location.parent, element);
        }
    }

    _fosterParentText(chars) {
        const location = this._findFosterParentingLocation();

        if (location.beforeElement) {
            this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
        } else {
            this.treeAdapter.insertText(location.parent, chars);
        }
    }

    //Special elements
    _isSpecialElement(element) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);

        return HTML.SPECIAL_ELEMENTS[ns][tn];
    }
}

module.exports = Parser;

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);

    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagName)) {
            formattingElementEntry = null;
        }
    } else {
        genericEndTagInBody(p, token);
    }

    return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;

    for (let i = p.openElements.stackTop; i >= 0; i--) {
        const element = p.openElements.items[i];

        if (element === formattingElementEntry.element) {
            break;
        }

        if (p._isSpecialElement(element)) {
            furthestBlock = element;
        }
    }

    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }

    return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);

    for (let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);

        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;

        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) {
                p.activeFormattingElements.removeEntry(elementEntry);
            }

            p.openElements.remove(element);
        } else {
            element = aaRecreateElementFromEntry(p, elementEntry);

            if (lastElement === furthestBlock) {
                p.activeFormattingElements.bookmark = elementEntry;
            }

            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }

    return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);

    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;

    return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor)) {
        p._fosterParentElement(lastElement);
    } else {
        const tn = p.treeAdapter.getTagName(commonAncestor);
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);

        if (tn === $.TEMPLATE && ns === NS.HTML) {
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        }

        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const token = formattingElementEntry.token;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);

    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);

    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);

    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
    let formattingElementEntry;

    for (let i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);

        if (!formattingElementEntry) {
            break;
        }

        const furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);

        if (!furthestBlock) {
            break;
        }

        p.activeFormattingElements.bookmark = formattingElementEntry;

        const lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);

        p.treeAdapter.detachNode(lastElement);
        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}

//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
    //NOTE: do nothing =)
}

function misplacedDoctype(p) {
    p._err(ERR.misplacedDoctype);
}

function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}

function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}

function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}

function insertCharacters(p, token) {
    p._insertCharacters(token);
}

function stopParsing(p) {
    p.stopped = true;
}

// The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);

    const mode = token.forceQuirks ? HTML.DOCUMENT_MODE.QUIRKS : doctype.getDocumentMode(token);

    if (!doctype.isConforming(token)) {
        p._err(ERR.nonConformingDoctype);
    }

    p.treeAdapter.setDocumentMode(p.document, mode);

    p.insertionMode = BEFORE_HTML_MODE;
}

function tokenInInitialMode(p, token) {
    p._err(ERR.missingDoctype, { beforeToken: true });
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
}

// The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = BEFORE_HEAD_MODE;
    } else {
        tokenBeforeHtml(p, token);
    }
}

function endTagBeforeHtml(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR) {
        tokenBeforeHtml(p, token);
    }
}

function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
}

// The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.HEAD) {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = IN_HEAD_MODE;
    } else {
        tokenBeforeHead(p, token);
    }
}

function endTagBeforeHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR) {
        tokenBeforeHead(p, token);
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}

// The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META) {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $.TITLE) {
        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);
    } else if (tn === $.NOSCRIPT) {
        if (p.options.scriptingEnabled) {
            p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
        } else {
            p._insertElement(token, NS.HTML);
            p.insertionMode = IN_HEAD_NO_SCRIPT_MODE;
        }
    } else if (tn === $.NOFRAMES || tn === $.STYLE) {
        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
    } else if (tn === $.SCRIPT) {
        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);
    } else if (tn === $.TEMPLATE) {
        p._insertTemplate(token, NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    } else if (tn === $.HEAD) {
        p._err(ERR.misplacedStartTagForHeadElement);
    } else {
        tokenInHead(p, token);
    }
}

function endTagInHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HEAD) {
        p.openElements.pop();
        p.insertionMode = AFTER_HEAD_MODE;
    } else if (tn === $.BODY || tn === $.BR || tn === $.HTML) {
        tokenInHead(p, token);
    } else if (tn === $.TEMPLATE) {
        if (p.openElements.tmplCount > 0) {
            p.openElements.generateImpliedEndTagsThoroughly();

            if (p.openElements.currentTagName !== $.TEMPLATE) {
                p._err(ERR.closingOfElementWithOpenChildElements);
            }

            p.openElements.popUntilTagNamePopped($.TEMPLATE);
            p.activeFormattingElements.clearToLastMarker();
            p._popTmplInsertionMode();
            p._resetInsertionMode();
        } else {
            p._err(ERR.endTagWithoutMatchingOpenElement);
        }
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
}

// The "in head no script" insertion mode
//------------------------------------------------------------------
function startTagInHeadNoScript(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (
        tn === $.BASEFONT ||
        tn === $.BGSOUND ||
        tn === $.HEAD ||
        tn === $.LINK ||
        tn === $.META ||
        tn === $.NOFRAMES ||
        tn === $.STYLE
    ) {
        startTagInHead(p, token);
    } else if (tn === $.NOSCRIPT) {
        p._err(ERR.nestedNoscriptInHead);
    } else {
        tokenInHeadNoScript(p, token);
    }
}

function endTagInHeadNoScript(p, token) {
    const tn = token.tagName;

    if (tn === $.NOSCRIPT) {
        p.openElements.pop();
        p.insertionMode = IN_HEAD_MODE;
    } else if (tn === $.BR) {
        tokenInHeadNoScript(p, token);
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenInHeadNoScript(p, token) {
    const errCode =
        token.type === Tokenizer.EOF_TOKEN ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;

    p._err(errCode);
    p.openElements.pop();
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}

// The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.BODY) {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = IN_BODY_MODE;
    } else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    } else if (
        tn === $.BASE ||
        tn === $.BASEFONT ||
        tn === $.BGSOUND ||
        tn === $.LINK ||
        tn === $.META ||
        tn === $.NOFRAMES ||
        tn === $.SCRIPT ||
        tn === $.STYLE ||
        tn === $.TEMPLATE ||
        tn === $.TITLE
    ) {
        p._err(ERR.abandonedHeadElementChild);
        p.openElements.push(p.headElement);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    } else if (tn === $.HEAD) {
        p._err(ERR.misplacedStartTagForHeadElement);
    } else {
        tokenAfterHead(p, token);
    }
}

function endTagAfterHead(p, token) {
    const tn = token.tagName;

    if (tn === $.BODY || tn === $.HTML || tn === $.BR) {
        tokenAfterHead(p, token);
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
    }
}

function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

// The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}

function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}

function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) {
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
    }
}

function bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}

function framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }
}

function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
}

function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    const tn = p.openElements.currentTagName;

    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
        p.openElements.pop();
    }

    p._insertElement(token, NS.HTML);
}

function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}

function formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;

    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($.P)) {
            p._closePElement();
        }

        p._insertElement(token, NS.HTML);

        if (!inTemplate) {
            p.formElement = p.openElements.current;
        }
    }
}

function listItemStartTagInBody(p, token) {
    p.framesetOk = false;

    const tn = token.tagName;

    for (let i = p.openElements.stackTop; i >= 0; i--) {
        const element = p.openElements.items[i];
        const elementTn = p.treeAdapter.getTagName(element);
        let closeTn = null;

        if (tn === $.LI && elementTn === $.LI) {
            closeTn = $.LI;
        } else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT)) {
            closeTn = elementTn;
        }

        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }

        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element)) {
            break;
        }
    }

    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
}

function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}

function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.BUTTON);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}

function aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);

    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    if (p.openElements.hasInScope($.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }

    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}

function tableStartTagInBody(p, token) {
    if (
        p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS &&
        p.openElements.hasInButtonScope($.P)
    ) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
}

function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}

function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);

    const inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE) {
        p.framesetOk = false;
    }

    token.ackSelfClosing = true;
}

function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
}

function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}

function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
}

function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
}

function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;

    if (
        p.insertionMode === IN_TABLE_MODE ||
        p.insertionMode === IN_CAPTION_MODE ||
        p.insertionMode === IN_TABLE_BODY_MODE ||
        p.insertionMode === IN_ROW_MODE ||
        p.insertionMode === IN_CELL_MODE
    ) {
        p.insertionMode = IN_SELECT_IN_TABLE_MODE;
    } else {
        p.insertionMode = IN_SELECT_MODE;
    }
}

function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION) {
        p.openElements.pop();
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY)) {
        p.openElements.generateImpliedEndTags();
    }

    p._insertElement(token, NS.HTML);
}

function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);
    }

    p._insertElement(token, NS.HTML);
}

function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
    }

    p._insertElement(token, NS.HTML);
}

function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenMathMLAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing) {
        p._appendElement(token, NS.MATHML);
    } else {
        p._insertElement(token, NS.MATHML);
    }

    token.ackSelfClosing = true;
}

function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenSVGAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing) {
        p._appendElement(token, NS.SVG);
    } else {
        p._insertElement(token, NS.SVG);
    }

    token.ackSelfClosing = true;
}

function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
    const tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U) {
                bStartTagInBody(p, token);
            } else if (tn === $.P) {
                addressStartTagInBody(p, token);
            } else if (tn === $.A) {
                aStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        case 2:
            if (tn === $.DL || tn === $.OL || tn === $.UL) {
                addressStartTagInBody(p, token);
            } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
                numberedHeaderStartTagInBody(p, token);
            } else if (tn === $.LI || tn === $.DD || tn === $.DT) {
                listItemStartTagInBody(p, token);
            } else if (tn === $.EM || tn === $.TT) {
                bStartTagInBody(p, token);
            } else if (tn === $.BR) {
                areaStartTagInBody(p, token);
            } else if (tn === $.HR) {
                hrStartTagInBody(p, token);
            } else if (tn === $.RB) {
                rbStartTagInBody(p, token);
            } else if (tn === $.RT || tn === $.RP) {
                rtStartTagInBody(p, token);
            } else if (tn !== $.TH && tn !== $.TD && tn !== $.TR) {
                genericStartTagInBody(p, token);
            }

            break;

        case 3:
            if (tn === $.DIV || tn === $.DIR || tn === $.NAV) {
                addressStartTagInBody(p, token);
            } else if (tn === $.PRE) {
                preStartTagInBody(p, token);
            } else if (tn === $.BIG) {
                bStartTagInBody(p, token);
            } else if (tn === $.IMG || tn === $.WBR) {
                areaStartTagInBody(p, token);
            } else if (tn === $.XMP) {
                xmpStartTagInBody(p, token);
            } else if (tn === $.SVG) {
                svgStartTagInBody(p, token);
            } else if (tn === $.RTC) {
                rbStartTagInBody(p, token);
            } else if (tn !== $.COL) {
                genericStartTagInBody(p, token);
            }

            break;

        case 4:
            if (tn === $.HTML) {
                htmlStartTagInBody(p, token);
            } else if (tn === $.BASE || tn === $.LINK || tn === $.META) {
                startTagInHead(p, token);
            } else if (tn === $.BODY) {
                bodyStartTagInBody(p, token);
            } else if (tn === $.MAIN || tn === $.MENU) {
                addressStartTagInBody(p, token);
            } else if (tn === $.FORM) {
                formStartTagInBody(p, token);
            } else if (tn === $.CODE || tn === $.FONT) {
                bStartTagInBody(p, token);
            } else if (tn === $.NOBR) {
                nobrStartTagInBody(p, token);
            } else if (tn === $.AREA) {
                areaStartTagInBody(p, token);
            } else if (tn === $.MATH) {
                mathStartTagInBody(p, token);
            } else if (tn === $.MENU) {
                menuStartTagInBody(p, token);
            } else if (tn !== $.HEAD) {
                genericStartTagInBody(p, token);
            }

            break;

        case 5:
            if (tn === $.STYLE || tn === $.TITLE) {
                startTagInHead(p, token);
            } else if (tn === $.ASIDE) {
                addressStartTagInBody(p, token);
            } else if (tn === $.SMALL) {
                bStartTagInBody(p, token);
            } else if (tn === $.TABLE) {
                tableStartTagInBody(p, token);
            } else if (tn === $.EMBED) {
                areaStartTagInBody(p, token);
            } else if (tn === $.INPUT) {
                inputStartTagInBody(p, token);
            } else if (tn === $.PARAM || tn === $.TRACK) {
                paramStartTagInBody(p, token);
            } else if (tn === $.IMAGE) {
                imageStartTagInBody(p, token);
            } else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD) {
                genericStartTagInBody(p, token);
            }

            break;

        case 6:
            if (tn === $.SCRIPT) {
                startTagInHead(p, token);
            } else if (
                tn === $.CENTER ||
                tn === $.FIGURE ||
                tn === $.FOOTER ||
                tn === $.HEADER ||
                tn === $.HGROUP ||
                tn === $.DIALOG
            ) {
                addressStartTagInBody(p, token);
            } else if (tn === $.BUTTON) {
                buttonStartTagInBody(p, token);
            } else if (tn === $.STRIKE || tn === $.STRONG) {
                bStartTagInBody(p, token);
            } else if (tn === $.APPLET || tn === $.OBJECT) {
                appletStartTagInBody(p, token);
            } else if (tn === $.KEYGEN) {
                areaStartTagInBody(p, token);
            } else if (tn === $.SOURCE) {
                paramStartTagInBody(p, token);
            } else if (tn === $.IFRAME) {
                iframeStartTagInBody(p, token);
            } else if (tn === $.SELECT) {
                selectStartTagInBody(p, token);
            } else if (tn === $.OPTION) {
                optgroupStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        case 7:
            if (tn === $.BGSOUND) {
                startTagInHead(p, token);
            } else if (
                tn === $.DETAILS ||
                tn === $.ADDRESS ||
                tn === $.ARTICLE ||
                tn === $.SECTION ||
                tn === $.SUMMARY
            ) {
                addressStartTagInBody(p, token);
            } else if (tn === $.LISTING) {
                preStartTagInBody(p, token);
            } else if (tn === $.MARQUEE) {
                appletStartTagInBody(p, token);
            } else if (tn === $.NOEMBED) {
                noembedStartTagInBody(p, token);
            } else if (tn !== $.CAPTION) {
                genericStartTagInBody(p, token);
            }

            break;

        case 8:
            if (tn === $.BASEFONT) {
                startTagInHead(p, token);
            } else if (tn === $.FRAMESET) {
                framesetStartTagInBody(p, token);
            } else if (tn === $.FIELDSET) {
                addressStartTagInBody(p, token);
            } else if (tn === $.TEXTAREA) {
                textareaStartTagInBody(p, token);
            } else if (tn === $.TEMPLATE) {
                startTagInHead(p, token);
            } else if (tn === $.NOSCRIPT) {
                if (p.options.scriptingEnabled) {
                    noembedStartTagInBody(p, token);
                } else {
                    genericStartTagInBody(p, token);
                }
            } else if (tn === $.OPTGROUP) {
                optgroupStartTagInBody(p, token);
            } else if (tn !== $.COLGROUP) {
                genericStartTagInBody(p, token);
            }

            break;

        case 9:
            if (tn === $.PLAINTEXT) {
                plaintextStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
                addressStartTagInBody(p, token);
            } else {
                genericStartTagInBody(p, token);
            }

            break;

        default:
            genericStartTagInBody(p, token);
    }
}

function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
    }
}

function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
        p._processToken(token);
    }
}

function addressEndTagInBody(p, token) {
    const tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const formElement = p.formElement;

    if (!inTemplate) {
        p.formElement = null;
    }

    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
        p.openElements.generateImpliedEndTags();

        if (inTemplate) {
            p.openElements.popUntilTagNamePopped($.FORM);
        } else {
            p.openElements.remove(formElement);
        }
    }
}

function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P)) {
        p._insertFakeElement($.P);
    }

    p._closePElement();
}

function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
        p.openElements.popUntilTagNamePopped($.LI);
    }
}

function ddEndTagInBody(p, token) {
    const tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}

function appletEndTagInBody(p, token) {
    const tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}

function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
}

function genericEndTagInBody(p, token) {
    const tn = token.tagName;

    for (let i = p.openElements.stackTop; i > 0; i--) {
        const element = p.openElements.items[i];

        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }

        if (p._isSpecialElement(element)) {
            break;
        }
    }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
    const tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U) {
                callAdoptionAgency(p, token);
            } else if (tn === $.P) {
                pEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 2:
            if (tn === $.DL || tn === $.UL || tn === $.OL) {
                addressEndTagInBody(p, token);
            } else if (tn === $.LI) {
                liEndTagInBody(p, token);
            } else if (tn === $.DD || tn === $.DT) {
                ddEndTagInBody(p, token);
            } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
                numberedHeaderEndTagInBody(p, token);
            } else if (tn === $.BR) {
                brEndTagInBody(p, token);
            } else if (tn === $.EM || tn === $.TT) {
                callAdoptionAgency(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 3:
            if (tn === $.BIG) {
                callAdoptionAgency(p, token);
            } else if (tn === $.DIR || tn === $.DIV || tn === $.NAV || tn === $.PRE) {
                addressEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 4:
            if (tn === $.BODY) {
                bodyEndTagInBody(p, token);
            } else if (tn === $.HTML) {
                htmlEndTagInBody(p, token);
            } else if (tn === $.FORM) {
                formEndTagInBody(p, token);
            } else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR) {
                callAdoptionAgency(p, token);
            } else if (tn === $.MAIN || tn === $.MENU) {
                addressEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 5:
            if (tn === $.ASIDE) {
                addressEndTagInBody(p, token);
            } else if (tn === $.SMALL) {
                callAdoptionAgency(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 6:
            if (
                tn === $.CENTER ||
                tn === $.FIGURE ||
                tn === $.FOOTER ||
                tn === $.HEADER ||
                tn === $.HGROUP ||
                tn === $.DIALOG
            ) {
                addressEndTagInBody(p, token);
            } else if (tn === $.APPLET || tn === $.OBJECT) {
                appletEndTagInBody(p, token);
            } else if (tn === $.STRIKE || tn === $.STRONG) {
                callAdoptionAgency(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 7:
            if (
                tn === $.ADDRESS ||
                tn === $.ARTICLE ||
                tn === $.DETAILS ||
                tn === $.SECTION ||
                tn === $.SUMMARY ||
                tn === $.LISTING
            ) {
                addressEndTagInBody(p, token);
            } else if (tn === $.MARQUEE) {
                appletEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 8:
            if (tn === $.FIELDSET) {
                addressEndTagInBody(p, token);
            } else if (tn === $.TEMPLATE) {
                endTagInHead(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
                addressEndTagInBody(p, token);
            } else {
                genericEndTagInBody(p, token);
            }

            break;

        default:
            genericEndTagInBody(p, token);
    }
}

function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1) {
        eofInTemplate(p, token);
    } else {
        p.stopped = true;
    }
}

// The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT) {
        p.pendingScript = p.openElements.current;
    }

    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}

function eofInText(p, token) {
    p._err(ERR.eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}

// The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    const curTn = p.openElements.currentTagName;

    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = IN_TABLE_TEXT_MODE;
        p._processToken(token);
    } else {
        tokenInTable(p, token);
    }
}

function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
}

function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
}

function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}

function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
}

function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
}

function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}

function inputStartTagInTable(p, token) {
    const inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE) {
        p._appendElement(token, NS.HTML);
    } else {
        tokenInTable(p, token);
    }

    token.ackSelfClosing = true;
}

function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}

function startTagInTable(p, token) {
    const tn = token.tagName;

    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH || tn === $.TR) {
                tdStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 3:
            if (tn === $.COL) {
                colStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 4:
            if (tn === $.FORM) {
                formStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 5:
            if (tn === $.TABLE) {
                tableStartTagInTable(p, token);
            } else if (tn === $.STYLE) {
                startTagInHead(p, token);
            } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
                tbodyStartTagInTable(p, token);
            } else if (tn === $.INPUT) {
                inputStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 6:
            if (tn === $.SCRIPT) {
                startTagInHead(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 7:
            if (tn === $.CAPTION) {
                captionStartTagInTable(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        case 8:
            if (tn === $.COLGROUP) {
                colgroupStartTagInTable(p, token);
            } else if (tn === $.TEMPLATE) {
                startTagInHead(p, token);
            } else {
                tokenInTable(p, token);
            }

            break;

        default:
            tokenInTable(p, token);
    }
}

function endTagInTable(p, token) {
    const tn = token.tagName;

    if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TABLE)) {
            p.openElements.popUntilTagNamePopped($.TABLE);
            p._resetInsertionMode();
        }
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    } else if (
        tn !== $.BODY &&
        tn !== $.CAPTION &&
        tn !== $.COL &&
        tn !== $.COLGROUP &&
        tn !== $.HTML &&
        tn !== $.TBODY &&
        tn !== $.TD &&
        tn !== $.TFOOT &&
        tn !== $.TH &&
        tn !== $.THEAD &&
        tn !== $.TR
    ) {
        tokenInTable(p, token);
    }
}

function tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;

    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}

// The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}

function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}

function tokenInTableText(p, token) {
    let i = 0;

    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++) {
            tokenInTable(p, p.pendingCharacterTokens[i]);
        }
    } else {
        for (; i < p.pendingCharacterTokens.length; i++) {
            p._insertCharacters(p.pendingCharacterTokens[i]);
        }
    }

    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}

// The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TD ||
        tn === $.TFOOT ||
        tn === $.TH ||
        tn === $.THEAD ||
        tn === $.TR
    ) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    } else {
        startTagInBody(p, token);
    }
}

function endTagInCaption(p, token) {
    const tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;

            if (tn === $.TABLE) {
                p._processToken(token);
            }
        }
    } else if (
        tn !== $.BODY &&
        tn !== $.COL &&
        tn !== $.COLGROUP &&
        tn !== $.HTML &&
        tn !== $.TBODY &&
        tn !== $.TD &&
        tn !== $.TFOOT &&
        tn !== $.TH &&
        tn !== $.THEAD &&
        tn !== $.TR
    ) {
        endTagInBody(p, token);
    }
}

// The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.COL) {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $.TEMPLATE) {
        startTagInHead(p, token);
    } else {
        tokenInColumnGroup(p, token);
    }
}

function endTagInColumnGroup(p, token) {
    const tn = token.tagName;

    if (tn === $.COLGROUP) {
        if (p.openElements.currentTagName === $.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    } else if (tn !== $.COL) {
        tokenInColumnGroup(p, token);
    }
}

function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
    }
}

// The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    const tn = token.tagName;

    if (tn === $.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_ROW_MODE;
    } else if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($.TR);
        p.insertionMode = IN_ROW_MODE;
        p._processToken(token);
    } else if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD
    ) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    } else {
        startTagInTable(p, token);
    }
}

function endTagInTableBody(p, token) {
    const tn = token.tagName;

    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    } else if (tn === $.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    } else if (
        (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP) ||
        (tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
    ) {
        endTagInTable(p, token);
    }
}

// The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    const tn = token.tagName;

    if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    } else if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD ||
        tn === $.TR
    ) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else {
        startTagInTable(p, token);
    }
}

function endTagInRow(p, token) {
    const tn = token.tagName;

    if (tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
        }
    } else if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    } else if (
        (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP) ||
        (tn !== $.HTML && tn !== $.TD && tn !== $.TH)
    ) {
        endTagInTable(p, token);
    }
}

// The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.COL ||
        tn === $.COLGROUP ||
        tn === $.TBODY ||
        tn === $.TD ||
        tn === $.TFOOT ||
        tn === $.TH ||
        tn === $.THEAD ||
        tn === $.TR
    ) {
        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    } else {
        startTagInBody(p, token);
    }
}

function endTagInCell(p, token) {
    const tn = token.tagName;

    if (tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_ROW_MODE;
        }
    } else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML) {
        endTagInBody(p, token);
    }
}

// The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION) {
            p.openElements.pop();
        }

        p._insertElement(token, NS.HTML);
    } else if (tn === $.OPTGROUP) {
        if (p.openElements.currentTagName === $.OPTION) {
            p.openElements.pop();
        }

        if (p.openElements.currentTagName === $.OPTGROUP) {
            p.openElements.pop();
        }

        p._insertElement(token, NS.HTML);
    } else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
        if (p.openElements.hasInSelectScope($.SELECT)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();

            if (tn !== $.SELECT) {
                p._processToken(token);
            }
        }
    } else if (tn === $.SCRIPT || tn === $.TEMPLATE) {
        startTagInHead(p, token);
    }
}

function endTagInSelect(p, token) {
    const tn = token.tagName;

    if (tn === $.OPTGROUP) {
        const prevOpenElement = p.openElements.items[p.openElements.stackTop - 1];
        const prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);

        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP) {
            p.openElements.pop();
        }

        if (p.openElements.currentTagName === $.OPTGROUP) {
            p.openElements.pop();
        }
    } else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION) {
            p.openElements.pop();
        }
    } else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
    } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
    }
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.TABLE ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD ||
        tn === $.TR ||
        tn === $.TD ||
        tn === $.TH
    ) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    } else {
        startTagInSelect(p, token);
    }
}

function endTagInSelectInTable(p, token) {
    const tn = token.tagName;

    if (
        tn === $.CAPTION ||
        tn === $.TABLE ||
        tn === $.TBODY ||
        tn === $.TFOOT ||
        tn === $.THEAD ||
        tn === $.TR ||
        tn === $.TD ||
        tn === $.TH
    ) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    } else {
        endTagInSelect(p, token);
    }
}

// The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    const tn = token.tagName;

    if (
        tn === $.BASE ||
        tn === $.BASEFONT ||
        tn === $.BGSOUND ||
        tn === $.LINK ||
        tn === $.META ||
        tn === $.NOFRAMES ||
        tn === $.SCRIPT ||
        tn === $.STYLE ||
        tn === $.TEMPLATE ||
        tn === $.TITLE
    ) {
        startTagInHead(p, token);
    } else {
        const newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;

        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}

function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE) {
        endTagInHead(p, token);
    }
}

function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    } else {
        p.stopped = true;
    }
}

// The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        startTagInBody(p, token);
    } else {
        tokenAfterBody(p, token);
    }
}

function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        if (!p.fragmentContext) {
            p.insertionMode = AFTER_AFTER_BODY_MODE;
        }
    } else {
        tokenAfterBody(p, token);
    }
}

function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

// The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
    } else if (tn === $.FRAME) {
        p._appendElement(token, NS.HTML);
        token.ackSelfClosing = true;
    } else if (tn === $.NOFRAMES) {
        startTagInHead(p, token);
    }
}

function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();

        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET) {
            p.insertionMode = AFTER_FRAMESET_MODE;
        }
    }
}

// The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.NOFRAMES) {
        startTagInHead(p, token);
    }
}

function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML) {
        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
    }
}

// The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        startTagInBody(p, token);
    } else {
        tokenAfterAfterBody(p, token);
    }
}

function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

// The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    const tn = token.tagName;

    if (tn === $.HTML) {
        startTagInBody(p, token);
    } else if (tn === $.NOFRAMES) {
        startTagInHead(p, token);
    }
}

// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = unicode.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}

function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}

function startTagInForeignContent(p, token) {
    if (foreignContent.causesExit(token) && !p.fragmentContext) {
        while (
            p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML &&
            !p._isIntegrationPoint(p.openElements.current)
        ) {
            p.openElements.pop();
        }

        p._processToken(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);

        if (currentNs === NS.MATHML) {
            foreignContent.adjustTokenMathMLAttrs(token);
        } else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        if (token.selfClosing) {
            p._appendElement(token, currentNs);
        } else {
            p._insertElement(token, currentNs);
        }

        token.ackSelfClosing = true;
    }
}

function endTagInForeignContent(p, token) {
    for (let i = p.openElements.stackTop; i > 0; i--) {
        const element = p.openElements.items[i];

        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._processToken(token);
            break;
        }

        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}


/***/ }),

/***/ 3203:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const HTML = __webpack_require__(5218);

//Aliases
const $ = HTML.TAG_NAMES;
const NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;

        case 3:
            return tn === $.RTC;

        case 6:
            return tn === $.OPTION;

        case 8:
            return tn === $.OPTGROUP;
    }

    return false;
}

function isImpliedEndTagRequiredThoroughly(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return (
                tn === $.RB ||
                tn === $.RP ||
                tn === $.RT ||
                tn === $.DD ||
                tn === $.DT ||
                tn === $.LI ||
                tn === $.TD ||
                tn === $.TH ||
                tn === $.TR
            );

        case 3:
            return tn === $.RTC;

        case 5:
            return tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD;

        case 6:
            return tn === $.OPTION;

        case 7:
            return tn === $.CAPTION;

        case 8:
            return tn === $.OPTGROUP || tn === $.COLGROUP;
    }

    return false;
}

function isScopingElement(tn, ns) {
    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH) {
                return ns === NS.HTML;
            } else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS) {
                return ns === NS.MATHML;
            }

            break;

        case 4:
            if (tn === $.HTML) {
                return ns === NS.HTML;
            } else if (tn === $.DESC) {
                return ns === NS.SVG;
            }

            break;

        case 5:
            if (tn === $.TABLE) {
                return ns === NS.HTML;
            } else if (tn === $.MTEXT) {
                return ns === NS.MATHML;
            } else if (tn === $.TITLE) {
                return ns === NS.SVG;
            }

            break;

        case 6:
            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;

        case 7:
            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;

        case 8:
            return tn === $.TEMPLATE && ns === NS.HTML;

        case 13:
            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;

        case 14:
            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }

    return false;
}

//Stack of open elements
class OpenElementStack {
    constructor(document, treeAdapter) {
        this.stackTop = -1;
        this.items = [];
        this.current = document;
        this.currentTagName = null;
        this.currentTmplContent = null;
        this.tmplCount = 0;
        this.treeAdapter = treeAdapter;
    }

    //Index of element
    _indexOf(element) {
        let idx = -1;

        for (let i = this.stackTop; i >= 0; i--) {
            if (this.items[i] === element) {
                idx = i;
                break;
            }
        }
        return idx;
    }

    //Update current element
    _isInTemplate() {
        return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
    }

    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);

        this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }

    //Mutations
    push(element) {
        this.items[++this.stackTop] = element;
        this._updateCurrentElement();

        if (this._isInTemplate()) {
            this.tmplCount++;
        }
    }

    pop() {
        this.stackTop--;

        if (this.tmplCount > 0 && this._isInTemplate()) {
            this.tmplCount--;
        }

        this._updateCurrentElement();
    }

    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);

        this.items[idx] = newElement;

        if (idx === this.stackTop) {
            this._updateCurrentElement();
        }
    }

    insertAfter(referenceElement, newElement) {
        const insertionIdx = this._indexOf(referenceElement) + 1;

        this.items.splice(insertionIdx, 0, newElement);

        if (insertionIdx === ++this.stackTop) {
            this._updateCurrentElement();
        }
    }

    popUntilTagNamePopped(tagName) {
        while (this.stackTop > -1) {
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);

            this.pop();

            if (tn === tagName && ns === NS.HTML) {
                break;
            }
        }
    }

    popUntilElementPopped(element) {
        while (this.stackTop > -1) {
            const poppedElement = this.current;

            this.pop();

            if (poppedElement === element) {
                break;
            }
        }
    }

    popUntilNumberedHeaderPopped() {
        while (this.stackTop > -1) {
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);

            this.pop();

            if (
                tn === $.H1 ||
                tn === $.H2 ||
                tn === $.H3 ||
                tn === $.H4 ||
                tn === $.H5 ||
                (tn === $.H6 && ns === NS.HTML)
            ) {
                break;
            }
        }
    }

    popUntilTableCellPopped() {
        while (this.stackTop > -1) {
            const tn = this.currentTagName;
            const ns = this.treeAdapter.getNamespaceURI(this.current);

            this.pop();

            if (tn === $.TD || (tn === $.TH && ns === NS.HTML)) {
                break;
            }
        }
    }

    popAllUpToHtmlElement() {
        //NOTE: here we assume that root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.stackTop = 0;
        this._updateCurrentElement();
    }

    clearBackToTableContext() {
        while (
            (this.currentTagName !== $.TABLE && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML) ||
            this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML
        ) {
            this.pop();
        }
    }

    clearBackToTableBodyContext() {
        while (
            (this.currentTagName !== $.TBODY &&
                this.currentTagName !== $.TFOOT &&
                this.currentTagName !== $.THEAD &&
                this.currentTagName !== $.TEMPLATE &&
                this.currentTagName !== $.HTML) ||
            this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML
        ) {
            this.pop();
        }
    }

    clearBackToTableRowContext() {
        while (
            (this.currentTagName !== $.TR && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML) ||
            this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML
        ) {
            this.pop();
        }
    }

    remove(element) {
        for (let i = this.stackTop; i >= 0; i--) {
            if (this.items[i] === element) {
                this.items.splice(i, 1);
                this.stackTop--;
                this._updateCurrentElement();
                break;
            }
        }
    }

    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        const element = this.items[1];

        return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
    }

    contains(element) {
        return this._indexOf(element) > -1;
    }

    getCommonAncestor(element) {
        let elementIdx = this._indexOf(element);

        return --elementIdx >= 0 ? this.items[elementIdx] : null;
    }

    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.currentTagName === $.HTML;
    }

    //Element in scope
    hasInScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (tn === tagName && ns === NS.HTML) {
                return true;
            }

            if (isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasNumberedHeaderInScope() {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (
                (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) &&
                ns === NS.HTML
            ) {
                return true;
            }

            if (isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasInListItemScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (tn === tagName && ns === NS.HTML) {
                return true;
            }

            if (((tn === $.UL || tn === $.OL) && ns === NS.HTML) || isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasInButtonScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (tn === tagName && ns === NS.HTML) {
                return true;
            }

            if ((tn === $.BUTTON && ns === NS.HTML) || isScopingElement(tn, ns)) {
                return false;
            }
        }

        return true;
    }

    hasInTableScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (ns !== NS.HTML) {
                continue;
            }

            if (tn === tagName) {
                return true;
            }

            if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML) {
                return false;
            }
        }

        return true;
    }

    hasTableBodyContextInTableScope() {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (ns !== NS.HTML) {
                continue;
            }

            if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT) {
                return true;
            }

            if (tn === $.TABLE || tn === $.HTML) {
                return false;
            }
        }

        return true;
    }

    hasInSelectScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
            const tn = this.treeAdapter.getTagName(this.items[i]);
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);

            if (ns !== NS.HTML) {
                continue;
            }

            if (tn === tagName) {
                return true;
            }

            if (tn !== $.OPTION && tn !== $.OPTGROUP) {
                return false;
            }
        }

        return true;
    }

    //Implied end tags
    generateImpliedEndTags() {
        while (isImpliedEndTagRequired(this.currentTagName)) {
            this.pop();
        }
    }

    generateImpliedEndTagsThoroughly() {
        while (isImpliedEndTagRequiredThoroughly(this.currentTagName)) {
            this.pop();
        }
    }

    generateImpliedEndTagsWithExclusion(exclusionTagName) {
        while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName) {
            this.pop();
        }
    }
}

module.exports = OpenElementStack;


/***/ }),

/***/ 3183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const Preprocessor = __webpack_require__(7567);
const unicode = __webpack_require__(3114);
const neTree = __webpack_require__(4906);
const ERR = __webpack_require__(1445);

//Aliases
const $ = unicode.CODE_POINTS;
const $$ = unicode.CODE_POINT_SEQUENCES;

//C1 Unicode control character reference replacements
const C1_CONTROLS_REFERENCE_REPLACEMENTS = {
    0x80: 0x20ac,
    0x82: 0x201a,
    0x83: 0x0192,
    0x84: 0x201e,
    0x85: 0x2026,
    0x86: 0x2020,
    0x87: 0x2021,
    0x88: 0x02c6,
    0x89: 0x2030,
    0x8a: 0x0160,
    0x8b: 0x2039,
    0x8c: 0x0152,
    0x8e: 0x017d,
    0x91: 0x2018,
    0x92: 0x2019,
    0x93: 0x201c,
    0x94: 0x201d,
    0x95: 0x2022,
    0x96: 0x2013,
    0x97: 0x2014,
    0x98: 0x02dc,
    0x99: 0x2122,
    0x9a: 0x0161,
    0x9b: 0x203a,
    0x9c: 0x0153,
    0x9e: 0x017e,
    0x9f: 0x0178
};

// Named entity tree flags
const HAS_DATA_FLAG = 1 << 0;
const DATA_DUPLET_FLAG = 1 << 1;
const HAS_BRANCHES_FLAG = 1 << 2;
const MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;

//States
const DATA_STATE = 'DATA_STATE';
const RCDATA_STATE = 'RCDATA_STATE';
const RAWTEXT_STATE = 'RAWTEXT_STATE';
const SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE';
const PLAINTEXT_STATE = 'PLAINTEXT_STATE';
const TAG_OPEN_STATE = 'TAG_OPEN_STATE';
const END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE';
const TAG_NAME_STATE = 'TAG_NAME_STATE';
const RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE';
const RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE';
const RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE';
const RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE';
const RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE';
const RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE';
const SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE';
const SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE';
const SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE';
const SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE';
const SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE';
const SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE';
const SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE';
const SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE';
const SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE';
const SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE';
const SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE';
const SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE';
const BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE';
const ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE';
const AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE';
const BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE';
const ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE';
const ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE';
const ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE';
const AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE';
const SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE';
const BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE';
const MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE';
const COMMENT_START_STATE = 'COMMENT_START_STATE';
const COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE';
const COMMENT_STATE = 'COMMENT_STATE';
const COMMENT_LESS_THAN_SIGN_STATE = 'COMMENT_LESS_THAN_SIGN_STATE';
const COMMENT_LESS_THAN_SIGN_BANG_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_STATE';
const COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE';
const COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE';
const COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE';
const COMMENT_END_STATE = 'COMMENT_END_STATE';
const COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE';
const DOCTYPE_STATE = 'DOCTYPE_STATE';
const BEFORE_DOCTYPE_NAME_STATE = 'BEFORE_DOCTYPE_NAME_STATE';
const DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE';
const AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE';
const AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE = 'AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE';
const BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE';
const DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE';
const DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE';
const AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE';
const BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE';
const AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE = 'AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE';
const BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE';
const DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE';
const DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE';
const AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE';
const BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE';
const CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';
const CDATA_SECTION_BRACKET_STATE = 'CDATA_SECTION_BRACKET_STATE';
const CDATA_SECTION_END_STATE = 'CDATA_SECTION_END_STATE';
const CHARACTER_REFERENCE_STATE = 'CHARACTER_REFERENCE_STATE';
const NAMED_CHARACTER_REFERENCE_STATE = 'NAMED_CHARACTER_REFERENCE_STATE';
const AMBIGUOUS_AMPERSAND_STATE = 'AMBIGUOS_AMPERSAND_STATE';
const NUMERIC_CHARACTER_REFERENCE_STATE = 'NUMERIC_CHARACTER_REFERENCE_STATE';
const HEXADEMICAL_CHARACTER_REFERENCE_START_STATE = 'HEXADEMICAL_CHARACTER_REFERENCE_START_STATE';
const DECIMAL_CHARACTER_REFERENCE_START_STATE = 'DECIMAL_CHARACTER_REFERENCE_START_STATE';
const HEXADEMICAL_CHARACTER_REFERENCE_STATE = 'HEXADEMICAL_CHARACTER_REFERENCE_STATE';
const DECIMAL_CHARACTER_REFERENCE_STATE = 'DECIMAL_CHARACTER_REFERENCE_STATE';
const NUMERIC_CHARACTER_REFERENCE_END_STATE = 'NUMERIC_CHARACTER_REFERENCE_END_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}

function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}

function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}

function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}

function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}

function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}

function isAsciiUpperHexDigit(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F;
}

function isAsciiLowerHexDigit(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F;
}

function isAsciiHexDigit(cp) {
    return isAsciiDigit(cp) || isAsciiUpperHexDigit(cp) || isAsciiLowerHexDigit(cp);
}

function toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
    if (cp <= 0xffff) {
        return String.fromCharCode(cp);
    }

    cp -= 0x10000;
    return String.fromCharCode(((cp >>> 10) & 0x3ff) | 0xd800) + String.fromCharCode(0xdc00 | (cp & 0x3ff));
}

function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
}

function findNamedEntityTreeBranch(nodeIx, cp) {
    const branchCount = neTree[++nodeIx];
    let lo = ++nodeIx;
    let hi = lo + branchCount - 1;

    while (lo <= hi) {
        const mid = (lo + hi) >>> 1;
        const midCp = neTree[mid];

        if (midCp < cp) {
            lo = mid + 1;
        } else if (midCp > cp) {
            hi = mid - 1;
        } else {
            return neTree[mid + branchCount];
        }
    }

    return -1;
}

//Tokenizer
class Tokenizer {
    constructor() {
        this.preprocessor = new Preprocessor();

        this.tokenQueue = [];

        this.allowCDATA = false;

        this.state = DATA_STATE;
        this.returnState = '';

        this.charRefCode = -1;
        this.tempBuff = [];
        this.lastStartTagName = '';

        this.consumedAfterSnapshot = -1;
        this.active = false;

        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = null;
    }

    //Errors
    _err() {
        // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    _errOnNextCodePoint(err) {
        this._consume();
        this._err(err);
        this._unconsume();
    }

    //API
    getNextToken() {
        while (!this.tokenQueue.length && this.active) {
            this.consumedAfterSnapshot = 0;

            const cp = this._consume();

            if (!this._ensureHibernation()) {
                this[this.state](cp);
            }
        }

        return this.tokenQueue.shift();
    }

    write(chunk, isLastChunk) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
    }

    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
    }

    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--) {
                this.preprocessor.retreat();
            }

            this.active = false;
            this.tokenQueue.push({ type: Tokenizer.HIBERNATION_TOKEN });

            return true;
        }

        return false;
    }

    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }

    _unconsume() {
        this.consumedAfterSnapshot--;
        this.preprocessor.retreat();
    }

    _reconsumeInState(state) {
        this.state = state;
        this._unconsume();
    }

    _consumeSequenceIfMatch(pattern, startCp, caseSensitive) {
        let consumedCount = 0;
        let isMatch = true;
        const patternLength = pattern.length;
        let patternPos = 0;
        let cp = startCp;
        let patternCp = void 0;

        for (; patternPos < patternLength; patternPos++) {
            if (patternPos > 0) {
                cp = this._consume();
                consumedCount++;
            }

            if (cp === $.EOF) {
                isMatch = false;
                break;
            }

            patternCp = pattern[patternPos];

            if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
                isMatch = false;
                break;
            }
        }

        if (!isMatch) {
            while (consumedCount--) {
                this._unconsume();
            }
        }

        return isMatch;
    }

    //Temp buffer
    _isTempBufferEqualToScriptString() {
        if (this.tempBuff.length !== $$.SCRIPT_STRING.length) {
            return false;
        }

        for (let i = 0; i < this.tempBuff.length; i++) {
            if (this.tempBuff[i] !== $$.SCRIPT_STRING[i]) {
                return false;
            }
        }

        return true;
    }

    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: Tokenizer.START_TAG_TOKEN,
            tagName: '',
            selfClosing: false,
            ackSelfClosing: false,
            attrs: []
        };
    }

    _createEndTagToken() {
        this.currentToken = {
            type: Tokenizer.END_TAG_TOKEN,
            tagName: '',
            selfClosing: false,
            attrs: []
        };
    }

    _createCommentToken() {
        this.currentToken = {
            type: Tokenizer.COMMENT_TOKEN,
            data: ''
        };
    }

    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: Tokenizer.DOCTYPE_TOKEN,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null
        };
    }

    _createCharacterToken(type, ch) {
        this.currentCharacterToken = {
            type: type,
            chars: ch
        };
    }

    _createEOFToken() {
        this.currentToken = { type: Tokenizer.EOF_TOKEN };
    }

    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ''
        };
    }

    _leaveAttrName(toState) {
        if (Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) === null) {
            this.currentToken.attrs.push(this.currentAttr);
        } else {
            this._err(ERR.duplicateAttribute);
        }

        this.state = toState;
    }

    _leaveAttrValue(toState) {
        this.state = toState;
    }

    //Token emission
    _emitCurrentToken() {
        this._emitCurrentCharacterToken();

        const ct = this.currentToken;

        this.currentToken = null;

        //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
        if (ct.type === Tokenizer.START_TAG_TOKEN) {
            this.lastStartTagName = ct.tagName;
        } else if (ct.type === Tokenizer.END_TAG_TOKEN) {
            if (ct.attrs.length > 0) {
                this._err(ERR.endTagWithAttributes);
            }

            if (ct.selfClosing) {
                this._err(ERR.endTagWithTrailingSolidus);
            }
        }

        this.tokenQueue.push(ct);
    }

    _emitCurrentCharacterToken() {
        if (this.currentCharacterToken) {
            this.tokenQueue.push(this.currentCharacterToken);
            this.currentCharacterToken = null;
        }
    }

    _emitEOFToken() {
        this._createEOFToken();
        this._emitCurrentToken();
    }

    //Characters emission

    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken && this.currentCharacterToken.type !== type) {
            this._emitCurrentCharacterToken();
        }

        if (this.currentCharacterToken) {
            this.currentCharacterToken.chars += ch;
        } else {
            this._createCharacterToken(type, ch);
        }
    }

    _emitCodePoint(cp) {
        let type = Tokenizer.CHARACTER_TOKEN;

        if (isWhitespace(cp)) {
            type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;
        } else if (cp === $.NULL) {
            type = Tokenizer.NULL_CHARACTER_TOKEN;
        }

        this._appendCharToCurrentCharacterToken(type, toChar(cp));
    }

    _emitSeveralCodePoints(codePoints) {
        for (let i = 0; i < codePoints.length; i++) {
            this._emitCodePoint(codePoints[i]);
        }
    }

    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
    }

    // Character reference helpers
    _matchNamedCharacterReference(startCp) {
        let result = null;
        let excess = 1;
        let i = findNamedEntityTreeBranch(0, startCp);

        this.tempBuff.push(startCp);

        while (i > -1) {
            const current = neTree[i];
            const inNode = current < MAX_BRANCH_MARKER_VALUE;
            const nodeWithData = inNode && current & HAS_DATA_FLAG;

            if (nodeWithData) {
                //NOTE: we use greedy search, so we continue lookup at this point
                result = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
                excess = 0;
            }

            const cp = this._consume();

            this.tempBuff.push(cp);
            excess++;

            if (cp === $.EOF) {
                break;
            }

            if (inNode) {
                i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;
            } else {
                i = cp === current ? ++i : -1;
            }
        }

        while (excess--) {
            this.tempBuff.pop();
            this._unconsume();
        }

        return result;
    }

    _isCharacterReferenceInAttribute() {
        return (
            this.returnState === ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE ||
            this.returnState === ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE ||
            this.returnState === ATTRIBUTE_VALUE_UNQUOTED_STATE
        );
    }

    _isCharacterReferenceAttributeQuirk(withSemicolon) {
        if (!withSemicolon && this._isCharacterReferenceInAttribute()) {
            const nextCp = this._consume();

            this._unconsume();

            return nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp);
        }

        return false;
    }

    _flushCodePointsConsumedAsCharacterReference() {
        if (this._isCharacterReferenceInAttribute()) {
            for (let i = 0; i < this.tempBuff.length; i++) {
                this.currentAttr.value += toChar(this.tempBuff[i]);
            }
        } else {
            this._emitSeveralCodePoints(this.tempBuff);
        }

        this.tempBuff = [];
    }

    // State machine

    // Data state
    //------------------------------------------------------------------
    [DATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.LESS_THAN_SIGN) {
            this.state = TAG_OPEN_STATE;
        } else if (cp === $.AMPERSAND) {
            this.returnState = DATA_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitCodePoint(cp);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    //  RCDATA state
    //------------------------------------------------------------------
    [RCDATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.AMPERSAND) {
            this.returnState = RCDATA_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = RCDATA_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // RAWTEXT state
    //------------------------------------------------------------------
    [RAWTEXT_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.LESS_THAN_SIGN) {
            this.state = RAWTEXT_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Script data state
    //------------------------------------------------------------------
    [SCRIPT_DATA_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // PLAINTEXT state
    //------------------------------------------------------------------
    [PLAINTEXT_STATE](cp) {
        this.preprocessor.dropParsedChunk();

        if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Tag open state
    //------------------------------------------------------------------
    [TAG_OPEN_STATE](cp) {
        if (cp === $.EXCLAMATION_MARK) {
            this.state = MARKUP_DECLARATION_OPEN_STATE;
        } else if (cp === $.SOLIDUS) {
            this.state = END_TAG_OPEN_STATE;
        } else if (isAsciiLetter(cp)) {
            this._createStartTagToken();
            this._reconsumeInState(TAG_NAME_STATE);
        } else if (cp === $.QUESTION_MARK) {
            this._err(ERR.unexpectedQuestionMarkInsteadOfTagName);
            this._createCommentToken();
            this._reconsumeInState(BOGUS_COMMENT_STATE);
        } else if (cp === $.EOF) {
            this._err(ERR.eofBeforeTagName);
            this._emitChars('<');
            this._emitEOFToken();
        } else {
            this._err(ERR.invalidFirstCharacterOfTagName);
            this._emitChars('<');
            this._reconsumeInState(DATA_STATE);
        }
    }

    // End tag open state
    //------------------------------------------------------------------
    [END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(TAG_NAME_STATE);
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingEndTagName);
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofBeforeTagName);
            this._emitChars('</');
            this._emitEOFToken();
        } else {
            this._err(ERR.invalidFirstCharacterOfTagName);
            this._createCommentToken();
            this._reconsumeInState(BOGUS_COMMENT_STATE);
        }
    }

    // Tag name state
    //------------------------------------------------------------------
    [TAG_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_ATTRIBUTE_NAME_STATE;
        } else if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.tagName += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentToken.tagName += toChar(cp);
        }
    }

    // RCDATA less-than sign state
    //------------------------------------------------------------------
    [RCDATA_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = RCDATA_END_TAG_OPEN_STATE;
        } else {
            this._emitChars('<');
            this._reconsumeInState(RCDATA_STATE);
        }
    }

    // RCDATA end tag open state
    //------------------------------------------------------------------
    [RCDATA_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(RCDATA_STATE);
        }
    }

    // RCDATA end tag name state
    //------------------------------------------------------------------
    [RCDATA_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }

                if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                }

                if (cp === $.GREATER_THAN_SIGN) {
                    this.state = DATA_STATE;
                    this._emitCurrentToken();
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(RCDATA_STATE);
        }
    }

    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    [RAWTEXT_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = RAWTEXT_END_TAG_OPEN_STATE;
        } else {
            this._emitChars('<');
            this._reconsumeInState(RAWTEXT_STATE);
        }
    }

    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    [RAWTEXT_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(RAWTEXT_STATE);
        }
    }

    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    [RAWTEXT_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }

                if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                }

                if (cp === $.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = DATA_STATE;
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(RAWTEXT_STATE);
        }
    }

    // Script data less-than sign state
    //------------------------------------------------------------------
    [SCRIPT_DATA_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
        } else if (cp === $.EXCLAMATION_MARK) {
            this.state = SCRIPT_DATA_ESCAPE_START_STATE;
            this._emitChars('<!');
        } else {
            this._emitChars('<');
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data end tag open state
    //------------------------------------------------------------------
    [SCRIPT_DATA_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data end tag name state
    //------------------------------------------------------------------
    [SCRIPT_DATA_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                } else if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                } else if (cp === $.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = DATA_STATE;
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data escape start state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPE_START_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
            this._emitChars('-');
        } else {
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data escape start dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPE_START_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
            this._emitChars('-');
        } else {
            this._reconsumeInState(SCRIPT_DATA_STATE);
        }
    }

    // Script data escaped state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Script data escaped dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data escaped dash dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_DASH_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = SCRIPT_DATA_STATE;
            this._emitChars('>');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
        } else if (isAsciiLetter(cp)) {
            this.tempBuff = [];
            this._emitChars('<');
            this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
        } else {
            this._emitChars('<');
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data escaped end tag open state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE](cp) {
        if (isAsciiLetter(cp)) {
            this._createEndTagToken();
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
        } else {
            this._emitChars('</');
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data escaped end tag name state
    //------------------------------------------------------------------
    [SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE](cp) {
        if (isAsciiUpper(cp)) {
            this.currentToken.tagName += toAsciiLowerChar(cp);
            this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
            this.currentToken.tagName += toChar(cp);
            this.tempBuff.push(cp);
        } else {
            if (this.lastStartTagName === this.currentToken.tagName) {
                if (isWhitespace(cp)) {
                    this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                    return;
                }

                if (cp === $.SOLIDUS) {
                    this.state = SELF_CLOSING_START_TAG_STATE;
                    return;
                }

                if (cp === $.GREATER_THAN_SIGN) {
                    this._emitCurrentToken();
                    this.state = DATA_STATE;
                    return;
                }
            }

            this._emitChars('</');
            this._emitSeveralCodePoints(this.tempBuff);
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data double escape start state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE](cp) {
        if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
            this.state = this._isTempBufferEqualToScriptString()
                ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE
                : SCRIPT_DATA_ESCAPED_STATE;
            this._emitCodePoint(cp);
        } else if (isAsciiUpper(cp)) {
            this.tempBuff.push(toAsciiLowerCodePoint(cp));
            this._emitCodePoint(cp);
        } else if (isAsciiLower(cp)) {
            this.tempBuff.push(cp);
            this._emitCodePoint(cp);
        } else {
            this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
    }

    // Script data double escaped state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars('<');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // Script data double escaped dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars('<');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this._emitChars('-');
        } else if (cp === $.LESS_THAN_SIGN) {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
            this._emitChars('<');
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = SCRIPT_DATA_STATE;
            this._emitChars('>');
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitChars(unicode.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInScriptHtmlCommentLikeText);
            this._emitEOFToken();
        } else {
            this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
            this._emitCodePoint(cp);
        }
    }

    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.SOLIDUS) {
            this.tempBuff = [];
            this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
            this._emitChars('/');
        } else {
            this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
        }
    }

    // Script data double escape end state
    //------------------------------------------------------------------
    [SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE](cp) {
        if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
            this.state = this._isTempBufferEqualToScriptString()
                ? SCRIPT_DATA_ESCAPED_STATE
                : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;

            this._emitCodePoint(cp);
        } else if (isAsciiUpper(cp)) {
            this.tempBuff.push(toAsciiLowerCodePoint(cp));
            this._emitCodePoint(cp);
        } else if (isAsciiLower(cp)) {
            this.tempBuff.push(cp);
            this._emitCodePoint(cp);
        } else {
            this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
        }
    }

    // Before attribute name state
    //------------------------------------------------------------------
    [BEFORE_ATTRIBUTE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
            this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.EQUALS_SIGN) {
            this._err(ERR.unexpectedEqualsSignBeforeAttributeName);
            this._createAttr('=');
            this.state = ATTRIBUTE_NAME_STATE;
        } else {
            this._createAttr('');
            this._reconsumeInState(ATTRIBUTE_NAME_STATE);
        }
    }

    // Attribute name state
    //------------------------------------------------------------------
    [ATTRIBUTE_NAME_STATE](cp) {
        if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
            this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
            this._unconsume();
        } else if (cp === $.EQUALS_SIGN) {
            this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);
        } else if (isAsciiUpper(cp)) {
            this.currentAttr.name += toAsciiLowerChar(cp);
        } else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN) {
            this._err(ERR.unexpectedCharacterInAttributeName);
            this.currentAttr.name += toChar(cp);
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.name += unicode.REPLACEMENT_CHARACTER;
        } else {
            this.currentAttr.name += toChar(cp);
        }
    }

    // After attribute name state
    //------------------------------------------------------------------
    [AFTER_ATTRIBUTE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
        } else if (cp === $.EQUALS_SIGN) {
            this.state = BEFORE_ATTRIBUTE_VALUE_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this._createAttr('');
            this._reconsumeInState(ATTRIBUTE_NAME_STATE);
        }
    }

    // Before attribute value state
    //------------------------------------------------------------------
    [BEFORE_ATTRIBUTE_VALUE_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.QUOTATION_MARK) {
            this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingAttributeValue);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else {
            this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
        }
    }

    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    [ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $.QUOTATION_MARK) {
            this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        } else if (cp === $.AMPERSAND) {
            this.returnState = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentAttr.value += toChar(cp);
        }
    }

    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    [ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE](cp) {
        if (cp === $.APOSTROPHE) {
            this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        } else if (cp === $.AMPERSAND) {
            this.returnState = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentAttr.value += toChar(cp);
        }
    }

    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    [ATTRIBUTE_VALUE_UNQUOTED_STATE](cp) {
        if (isWhitespace(cp)) {
            this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.AMPERSAND) {
            this.returnState = ATTRIBUTE_VALUE_UNQUOTED_STATE;
            this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._leaveAttrValue(DATA_STATE);
            this._emitCurrentToken();
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
        } else if (
            cp === $.QUOTATION_MARK ||
            cp === $.APOSTROPHE ||
            cp === $.LESS_THAN_SIGN ||
            cp === $.EQUALS_SIGN ||
            cp === $.GRAVE_ACCENT
        ) {
            this._err(ERR.unexpectedCharacterInUnquotedAttributeValue);
            this.currentAttr.value += toChar(cp);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this.currentAttr.value += toChar(cp);
        }
    }

    // After attribute value (quoted) state
    //------------------------------------------------------------------
    [AFTER_ATTRIBUTE_VALUE_QUOTED_STATE](cp) {
        if (isWhitespace(cp)) {
            this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.SOLIDUS) {
            this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._leaveAttrValue(DATA_STATE);
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this._err(ERR.missingWhitespaceBetweenAttributes);
            this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
        }
    }

    // Self-closing start tag state
    //------------------------------------------------------------------
    [SELF_CLOSING_START_TAG_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.currentToken.selfClosing = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInTag);
            this._emitEOFToken();
        } else {
            this._err(ERR.unexpectedSolidusInTag);
            this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
        }
    }

    // Bogus comment state
    //------------------------------------------------------------------
    [BOGUS_COMMENT_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._emitCurrentToken();
            this._emitEOFToken();
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.data += unicode.REPLACEMENT_CHARACTER;
        } else {
            this.currentToken.data += toChar(cp);
        }
    }

    // Markup declaration open state
    //------------------------------------------------------------------
    [MARKUP_DECLARATION_OPEN_STATE](cp) {
        if (this._consumeSequenceIfMatch($$.DASH_DASH_STRING, cp, true)) {
            this._createCommentToken();
            this.state = COMMENT_START_STATE;
        } else if (this._consumeSequenceIfMatch($$.DOCTYPE_STRING, cp, false)) {
            this.state = DOCTYPE_STATE;
        } else if (this._consumeSequenceIfMatch($$.CDATA_START_STRING, cp, true)) {
            if (this.allowCDATA) {
                this.state = CDATA_SECTION_STATE;
            } else {
                this._err(ERR.cdataInHtmlContent);
                this._createCommentToken();
                this.currentToken.data = '[CDATA[';
                this.state = BOGUS_COMMENT_STATE;
            }
        }

        //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
        //results are no longer valid and we will need to start over.
        else if (!this._ensureHibernation()) {
            this._err(ERR.incorrectlyOpenedComment);
            this._createCommentToken();
            this._reconsumeInState(BOGUS_COMMENT_STATE);
        }
    }

    // Comment start state
    //------------------------------------------------------------------
    [COMMENT_START_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_START_DASH_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptClosingOfEmptyComment);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else {
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment start dash state
    //------------------------------------------------------------------
    [COMMENT_START_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_END_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptClosingOfEmptyComment);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '-';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment state
    //------------------------------------------------------------------
    [COMMENT_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_END_DASH_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
            this.currentToken.data += '<';
            this.state = COMMENT_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.data += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += toChar(cp);
        }
    }

    // Comment less-than sign state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_STATE](cp) {
        if (cp === $.EXCLAMATION_MARK) {
            this.currentToken.data += '!';
            this.state = COMMENT_LESS_THAN_SIGN_BANG_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
            this.currentToken.data += '!';
        } else {
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment less-than sign bang state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_BANG_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE;
        } else {
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE;
        } else {
            this._reconsumeInState(COMMENT_END_DASH_STATE);
        }
    }

    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    [COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE](cp) {
        if (cp !== $.GREATER_THAN_SIGN && cp !== $.EOF) {
            this._err(ERR.nestedComment);
        }

        this._reconsumeInState(COMMENT_END_STATE);
    }

    // Comment end dash state
    //------------------------------------------------------------------
    [COMMENT_END_DASH_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.state = COMMENT_END_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '-';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment end state
    //------------------------------------------------------------------
    [COMMENT_END_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EXCLAMATION_MARK) {
            this.state = COMMENT_END_BANG_STATE;
        } else if (cp === $.HYPHEN_MINUS) {
            this.currentToken.data += '-';
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '--';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // Comment end bang state
    //------------------------------------------------------------------
    [COMMENT_END_BANG_STATE](cp) {
        if (cp === $.HYPHEN_MINUS) {
            this.currentToken.data += '--!';
            this.state = COMMENT_END_DASH_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.incorrectlyClosedComment);
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInComment);
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.data += '--!';
            this._reconsumeInState(COMMENT_STATE);
        }
    }

    // DOCTYPE state
    //------------------------------------------------------------------
    [DOCTYPE_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingWhitespaceBeforeDoctypeName);
            this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
        }
    }

    // Before DOCTYPE name state
    //------------------------------------------------------------------
    [BEFORE_DOCTYPE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (isAsciiUpper(cp)) {
            this._createDoctypeToken(toAsciiLowerChar(cp));
            this.state = DOCTYPE_NAME_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this._createDoctypeToken(unicode.REPLACEMENT_CHARACTER);
            this.state = DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypeName);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this._createDoctypeToken(null);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._createDoctypeToken(toChar(cp));
            this.state = DOCTYPE_NAME_STATE;
        }
    }

    // DOCTYPE name state
    //------------------------------------------------------------------
    [DOCTYPE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = AFTER_DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (isAsciiUpper(cp)) {
            this.currentToken.name += toAsciiLowerChar(cp);
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.name += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.name += toChar(cp);
        }
    }

    // After DOCTYPE name state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_NAME_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else if (this._consumeSequenceIfMatch($$.PUBLIC_STRING, cp, false)) {
            this.state = AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE;
        } else if (this._consumeSequenceIfMatch($$.SYSTEM_STRING, cp, false)) {
            this.state = AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE;
        }
        //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
        //results are no longer valid and we will need to start over.
        else if (!this._ensureHibernation()) {
            this._err(ERR.invalidCharacterSequenceAfterDoctypeName);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.QUOTATION_MARK) {
            this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    [BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.QUOTATION_MARK) {
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.currentToken.publicId = '';
            this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $.QUOTATION_MARK) {
            this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.publicId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.publicId += toChar(cp);
        }
    }

    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE](cp) {
        if (cp === $.APOSTROPHE) {
            this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.publicId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypePublicIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.publicId += toChar(cp);
        }
    }

    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.QUOTATION_MARK) {
            this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    [BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.QUOTATION_MARK) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE](cp) {
        if (isWhitespace(cp)) {
            this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.QUOTATION_MARK) {
            this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    [BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.QUOTATION_MARK) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
            this.currentToken.systemId = '';
            this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.missingDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this.state = DATA_STATE;
            this._emitCurrentToken();
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE](cp) {
        if (cp === $.QUOTATION_MARK) {
            this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.systemId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.systemId += toChar(cp);
        }
    }

    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    [DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE](cp) {
        if (cp === $.APOSTROPHE) {
            this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
            this.currentToken.systemId += unicode.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
            this._err(ERR.abruptDoctypeSystemIdentifier);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this.currentToken.systemId += toChar(cp);
        }
    }

    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    [AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE](cp) {
        if (isWhitespace(cp)) {
            return;
        }

        if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInDoctype);
            this.currentToken.forceQuirks = true;
            this._emitCurrentToken();
            this._emitEOFToken();
        } else {
            this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
            this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
    }

    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    [BOGUS_DOCTYPE_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
        } else if (cp === $.NULL) {
            this._err(ERR.unexpectedNullCharacter);
        } else if (cp === $.EOF) {
            this._emitCurrentToken();
            this._emitEOFToken();
        }
    }

    // CDATA section state
    //------------------------------------------------------------------
    [CDATA_SECTION_STATE](cp) {
        if (cp === $.RIGHT_SQUARE_BRACKET) {
            this.state = CDATA_SECTION_BRACKET_STATE;
        } else if (cp === $.EOF) {
            this._err(ERR.eofInCdata);
            this._emitEOFToken();
        } else {
            this._emitCodePoint(cp);
        }
    }

    // CDATA section bracket state
    //------------------------------------------------------------------
    [CDATA_SECTION_BRACKET_STATE](cp) {
        if (cp === $.RIGHT_SQUARE_BRACKET) {
            this.state = CDATA_SECTION_END_STATE;
        } else {
            this._emitChars(']');
            this._reconsumeInState(CDATA_SECTION_STATE);
        }
    }

    // CDATA section end state
    //------------------------------------------------------------------
    [CDATA_SECTION_END_STATE](cp) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
        } else if (cp === $.RIGHT_SQUARE_BRACKET) {
            this._emitChars(']');
        } else {
            this._emitChars(']]');
            this._reconsumeInState(CDATA_SECTION_STATE);
        }
    }

    // Character reference state
    //------------------------------------------------------------------
    [CHARACTER_REFERENCE_STATE](cp) {
        this.tempBuff = [$.AMPERSAND];

        if (cp === $.NUMBER_SIGN) {
            this.tempBuff.push(cp);
            this.state = NUMERIC_CHARACTER_REFERENCE_STATE;
        } else if (isAsciiAlphaNumeric(cp)) {
            this._reconsumeInState(NAMED_CHARACTER_REFERENCE_STATE);
        } else {
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }

    // Named character reference state
    //------------------------------------------------------------------
    [NAMED_CHARACTER_REFERENCE_STATE](cp) {
        const matchResult = this._matchNamedCharacterReference(cp);

        //NOTE: matching can be abrupted by hibernation. In that case match
        //results are no longer valid and we will need to start over.
        if (this._ensureHibernation()) {
            this.tempBuff = [$.AMPERSAND];
        } else if (matchResult) {
            const withSemicolon = this.tempBuff[this.tempBuff.length - 1] === $.SEMICOLON;

            if (!this._isCharacterReferenceAttributeQuirk(withSemicolon)) {
                if (!withSemicolon) {
                    this._errOnNextCodePoint(ERR.missingSemicolonAfterCharacterReference);
                }

                this.tempBuff = matchResult;
            }

            this._flushCodePointsConsumedAsCharacterReference();
            this.state = this.returnState;
        } else {
            this._flushCodePointsConsumedAsCharacterReference();
            this.state = AMBIGUOUS_AMPERSAND_STATE;
        }
    }

    // Ambiguos ampersand state
    //------------------------------------------------------------------
    [AMBIGUOUS_AMPERSAND_STATE](cp) {
        if (isAsciiAlphaNumeric(cp)) {
            if (this._isCharacterReferenceInAttribute()) {
                this.currentAttr.value += toChar(cp);
            } else {
                this._emitCodePoint(cp);
            }
        } else {
            if (cp === $.SEMICOLON) {
                this._err(ERR.unknownNamedCharacterReference);
            }

            this._reconsumeInState(this.returnState);
        }
    }

    // Numeric character reference state
    //------------------------------------------------------------------
    [NUMERIC_CHARACTER_REFERENCE_STATE](cp) {
        this.charRefCode = 0;

        if (cp === $.LATIN_SMALL_X || cp === $.LATIN_CAPITAL_X) {
            this.tempBuff.push(cp);
            this.state = HEXADEMICAL_CHARACTER_REFERENCE_START_STATE;
        } else {
            this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_START_STATE);
        }
    }

    // Hexademical character reference start state
    //------------------------------------------------------------------
    [HEXADEMICAL_CHARACTER_REFERENCE_START_STATE](cp) {
        if (isAsciiHexDigit(cp)) {
            this._reconsumeInState(HEXADEMICAL_CHARACTER_REFERENCE_STATE);
        } else {
            this._err(ERR.absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }

    // Decimal character reference start state
    //------------------------------------------------------------------
    [DECIMAL_CHARACTER_REFERENCE_START_STATE](cp) {
        if (isAsciiDigit(cp)) {
            this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_STATE);
        } else {
            this._err(ERR.absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointsConsumedAsCharacterReference();
            this._reconsumeInState(this.returnState);
        }
    }

    // Hexademical character reference state
    //------------------------------------------------------------------
    [HEXADEMICAL_CHARACTER_REFERENCE_STATE](cp) {
        if (isAsciiUpperHexDigit(cp)) {
            this.charRefCode = this.charRefCode * 16 + cp - 0x37;
        } else if (isAsciiLowerHexDigit(cp)) {
            this.charRefCode = this.charRefCode * 16 + cp - 0x57;
        } else if (isAsciiDigit(cp)) {
            this.charRefCode = this.charRefCode * 16 + cp - 0x30;
        } else if (cp === $.SEMICOLON) {
            this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
        } else {
            this._err(ERR.missingSemicolonAfterCharacterReference);
            this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
    }

    // Decimal character reference state
    //------------------------------------------------------------------
    [DECIMAL_CHARACTER_REFERENCE_STATE](cp) {
        if (isAsciiDigit(cp)) {
            this.charRefCode = this.charRefCode * 10 + cp - 0x30;
        } else if (cp === $.SEMICOLON) {
            this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
        } else {
            this._err(ERR.missingSemicolonAfterCharacterReference);
            this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
    }

    // Numeric character reference end state
    //------------------------------------------------------------------
    [NUMERIC_CHARACTER_REFERENCE_END_STATE]() {
        if (this.charRefCode === $.NULL) {
            this._err(ERR.nullCharacterReference);
            this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (this.charRefCode > 0x10ffff) {
            this._err(ERR.characterReferenceOutsideUnicodeRange);
            this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (unicode.isSurrogate(this.charRefCode)) {
            this._err(ERR.surrogateCharacterReference);
            this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (unicode.isUndefinedCodePoint(this.charRefCode)) {
            this._err(ERR.noncharacterCharacterReference);
        } else if (unicode.isControlCodePoint(this.charRefCode) || this.charRefCode === $.CARRIAGE_RETURN) {
            this._err(ERR.controlCharacterReference);

            const replacement = C1_CONTROLS_REFERENCE_REPLACEMENTS[this.charRefCode];

            if (replacement) {
                this.charRefCode = replacement;
            }
        }

        this.tempBuff = [this.charRefCode];

        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
    }
}

//Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function(token, attrName) {
    for (let i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName) {
            return token.attrs[i].value;
        }
    }

    return null;
};

module.exports = Tokenizer;


/***/ }),

/***/ 4906:
/***/ (function(module) {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate-named-entity-data/README.md)
module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),

/***/ 7567:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const unicode = __webpack_require__(3114);
const ERR = __webpack_require__(1445);

//Aliases
const $ = unicode.CODE_POINTS;

//Const
const DEFAULT_BUFFER_WATERLINE = 1 << 16;

//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
class Preprocessor {
    constructor() {
        this.html = null;

        this.pos = -1;
        this.lastGapPos = -1;
        this.lastCharPos = -1;

        this.gapStack = [];

        this.skipNextNewLine = false;

        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
    }

    _err() {
        // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }

    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.lastCharPos) {
            const nextCp = this.html.charCodeAt(this.pos + 1);

            if (unicode.isSurrogatePair(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;

                //NOTE: add gap that should be avoided during retreat
                this._addGap();

                return unicode.getSurrogatePairCodePoint(cp, nextCp);
            }
        }

        //NOTE: we are at the end of a chunk, therefore we can't infer surrogate pair yet.
        else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return $.EOF;
        }

        //NOTE: isolated surrogate
        this._err(ERR.surrogateInInputStream);

        return cp;
    }

    dropParsedChunk() {
        if (this.pos > this.bufferWaterline) {
            this.lastCharPos -= this.pos;
            this.html = this.html.substring(this.pos);
            this.pos = 0;
            this.lastGapPos = -1;
            this.gapStack = [];
        }
    }

    write(chunk, isLastChunk) {
        if (this.html) {
            this.html += chunk;
        } else {
            this.html = chunk;
        }

        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }

    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1, this.html.length);

        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
    }

    advance() {
        this.pos++;

        if (this.pos > this.lastCharPos) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return $.EOF;
        }

        let cp = this.html.charCodeAt(this.pos);

        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (this.skipNextNewLine && cp === $.LINE_FEED) {
            this.skipNextNewLine = false;
            this._addGap();
            return this.advance();
        }

        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === $.CARRIAGE_RETURN) {
            this.skipNextNewLine = true;
            return $.LINE_FEED;
        }

        this.skipNextNewLine = false;

        if (unicode.isSurrogate(cp)) {
            cp = this._processSurrogate(cp);
        }

        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange =
            (cp > 0x1f && cp < 0x7f) || cp === $.LINE_FEED || cp === $.CARRIAGE_RETURN || (cp > 0x9f && cp < 0xfdd0);

        if (!isCommonValidRange) {
            this._checkForProblematicCharacters(cp);
        }

        return cp;
    }

    _checkForProblematicCharacters(cp) {
        if (unicode.isControlCodePoint(cp)) {
            this._err(ERR.controlCharacterInInputStream);
        } else if (unicode.isUndefinedCodePoint(cp)) {
            this._err(ERR.noncharacterInInputStream);
        }
    }

    retreat() {
        if (this.pos === this.lastGapPos) {
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }

        this.pos--;
    }
}

module.exports = Preprocessor;


/***/ }),

/***/ 9132:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


const { DOCUMENT_MODE } = __webpack_require__(5218);

//Node construction
exports.createDocument = function() {
    return {
        nodeName: '#document',
        mode: DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};

exports.createDocumentFragment = function() {
    return {
        nodeName: '#document-fragment',
        childNodes: []
    };
};

exports.createElement = function(tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};

exports.createCommentNode = function(data) {
    return {
        nodeName: '#comment',
        data: data,
        parentNode: null
    };
};

const createTextNode = function(value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
};

//Tree mutation
const appendChild = (exports.appendChild = function(parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
});

const insertBefore = (exports.insertBefore = function(parentNode, newNode, referenceNode) {
    const insertionIdx = parentNode.childNodes.indexOf(referenceNode);

    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
});

exports.setTemplateContent = function(templateElement, contentElement) {
    templateElement.content = contentElement;
};

exports.getTemplateContent = function(templateElement) {
    return templateElement.content;
};

exports.setDocumentType = function(document, name, publicId, systemId) {
    let doctypeNode = null;

    for (let i = 0; i < document.childNodes.length; i++) {
        if (document.childNodes[i].nodeName === '#documentType') {
            doctypeNode = document.childNodes[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    } else {
        appendChild(document, {
            nodeName: '#documentType',
            name: name,
            publicId: publicId,
            systemId: systemId
        });
    }
};

exports.setDocumentMode = function(document, mode) {
    document.mode = mode;
};

exports.getDocumentMode = function(document) {
    return document.mode;
};

exports.detachNode = function(node) {
    if (node.parentNode) {
        const idx = node.parentNode.childNodes.indexOf(node);

        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};

exports.insertText = function(parentNode, text) {
    if (parentNode.childNodes.length) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];

        if (prevNode.nodeName === '#text') {
            prevNode.value += text;
            return;
        }
    }

    appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function(parentNode, text, referenceNode) {
    const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.nodeName === '#text') {
        prevNode.value += text;
    } else {
        insertBefore(parentNode, createTextNode(text), referenceNode);
    }
};

exports.adoptAttributes = function(recipient, attrs) {
    const recipientAttrsMap = [];

    for (let i = 0; i < recipient.attrs.length; i++) {
        recipientAttrsMap.push(recipient.attrs[i].name);
    }

    for (let j = 0; j < attrs.length; j++) {
        if (recipientAttrsMap.indexOf(attrs[j].name) === -1) {
            recipient.attrs.push(attrs[j]);
        }
    }
};

//Tree traversing
exports.getFirstChild = function(node) {
    return node.childNodes[0];
};

exports.getChildNodes = function(node) {
    return node.childNodes;
};

exports.getParentNode = function(node) {
    return node.parentNode;
};

exports.getAttrList = function(element) {
    return element.attrs;
};

//Node data
exports.getTagName = function(element) {
    return element.tagName;
};

exports.getNamespaceURI = function(element) {
    return element.namespaceURI;
};

exports.getTextNodeContent = function(textNode) {
    return textNode.value;
};

exports.getCommentNodeContent = function(commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function(doctypeNode) {
    return doctypeNode.name;
};

exports.getDocumentTypeNodePublicId = function(doctypeNode) {
    return doctypeNode.publicId;
};

exports.getDocumentTypeNodeSystemId = function(doctypeNode) {
    return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function(node) {
    return node.nodeName === '#text';
};

exports.isCommentNode = function(node) {
    return node.nodeName === '#comment';
};

exports.isDocumentTypeNode = function(node) {
    return node.nodeName === '#documentType';
};

exports.isElementNode = function(node) {
    return !!node.tagName;
};

// Source code location
exports.setNodeSourceCodeLocation = function(node, location) {
    node.sourceCodeLocation = location;
};

exports.getNodeSourceCodeLocation = function(node) {
    return node.sourceCodeLocation;
};

exports.updateNodeSourceCodeLocation = function(node, endLocation) {
    node.sourceCodeLocation = Object.assign(node.sourceCodeLocation, endLocation);
};


/***/ }),

/***/ 8395:
/***/ (function(module) {

"use strict";


module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce((merged, optObj) => {
        Object.keys(optObj).forEach(key => {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};


/***/ }),

/***/ 814:
/***/ (function(module) {

"use strict";


class Mixin {
    constructor(host) {
        const originalMethods = {};
        const overriddenMethods = this._getOverriddenMethods(this, originalMethods);

        for (const key of Object.keys(overriddenMethods)) {
            if (typeof overriddenMethods[key] === 'function') {
                originalMethods[key] = host[key];
                host[key] = overriddenMethods[key];
            }
        }
    }

    _getOverriddenMethods() {
        throw new Error('Not implemented');
    }
}

Mixin.install = function(host, Ctor, opts) {
    if (!host.__mixins) {
        host.__mixins = [];
    }

    for (let i = 0; i < host.__mixins.length; i++) {
        if (host.__mixins[i].constructor === Ctor) {
            return host.__mixins[i];
        }
    }

    const mixin = new Ctor(host, opts);

    host.__mixins.push(mixin);

    return mixin;
};

module.exports = Mixin;


/***/ }),

/***/ 4406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 8262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 3980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(8262)();
}


/***/ }),

/***/ 3586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 6866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=b;exports.ForwardRef=l;exports.Fragment=d;exports.Lazy=q;exports.Memo=p;exports.Portal=c;exports.Profiler=f;exports.StrictMode=e;exports.Suspense=m;
exports.SuspenseList=n;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};exports.isContextProvider=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};exports.isLazy=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
exports.isPortal=function(a){return v(a)===c};exports.isProfiler=function(a){return v(a)===f};exports.isStrictMode=function(a){return v(a)===e};exports.isSuspense=function(a){return v(a)===m};exports.isSuspenseList=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 8570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(6866);
} else {}


/***/ }),

/***/ 6772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(6299);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 4607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _react=_interopRequireWildcard(__webpack_require__(2784));var _excluded=["placeholder","separator","isLastChild","inputStyle","focus","isDisabled","hasErrored","errorStyle","focusStyle","disabledStyle","shouldAutoFocus","isInputNum","index","value","className","isInputSecure"];function _getRequireWildcardCache(nodeInterop){if(typeof WeakMap!=="function")return null;var cacheBabelInterop=new WeakMap();var cacheNodeInterop=new WeakMap();return(_getRequireWildcardCache=function _getRequireWildcardCache(nodeInterop){return nodeInterop?cacheNodeInterop:cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj,nodeInterop){if(!nodeInterop&&obj&&obj.__esModule){return obj;}if(obj===null||_typeof(obj)!=="object"&&typeof obj!=="function"){return{"default":obj};}var cache=_getRequireWildcardCache(nodeInterop);if(cache&&cache.has(obj)){return cache.get(obj);}var newObj={};var hasPropertyDescriptor=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var key in obj){if(key!=="default"&&Object.prototype.hasOwnProperty.call(obj,key)){var desc=hasPropertyDescriptor?Object.getOwnPropertyDescriptor(obj,key):null;if(desc&&(desc.get||desc.set)){Object.defineProperty(newObj,key,desc);}else{newObj[key]=obj[key];}}}newObj["default"]=obj;if(cache){cache.set(obj,newObj);}return newObj;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _objectWithoutProperties(source,excluded){if(source==null)return{};var target=_objectWithoutPropertiesLoose(source,excluded);var key,i;if(Object.getOwnPropertySymbols){var sourceSymbolKeys=Object.getOwnPropertySymbols(source);for(i=0;i<sourceSymbolKeys.length;i++){key=sourceSymbolKeys[i];if(excluded.indexOf(key)>=0)continue;if(!Object.prototype.propertyIsEnumerable.call(source,key))continue;target[key]=source[key];}}return target;}function _objectWithoutPropertiesLoose(source,excluded){if(source==null)return{};var target={};var sourceKeys=Object.keys(source);var key,i;for(i=0;i<sourceKeys.length;i++){key=sourceKeys[i];if(excluded.indexOf(key)>=0)continue;target[key]=source[key];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var BACKSPACE=8;var LEFT_ARROW=37;var RIGHT_ARROW=39;var DELETE=46;var SPACEBAR=32;var isStyleObject=function isStyleObject(obj){return _typeof(obj)==='object';};var SingleOtpInput=function(_PureComponent){_inherits(SingleOtpInput,_PureComponent);var _super=_createSuper(SingleOtpInput);function SingleOtpInput(props){var _this;_classCallCheck(this,SingleOtpInput);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getClasses",function(){for(var _len=arguments.length,classes=new Array(_len),_key=0;_key<_len;_key++){classes[_key]=arguments[_key];}return classes.filter(function(c){return!isStyleObject(c)&&c!==false;}).join(' ');});_defineProperty(_assertThisInitialized(_this),"getType",function(){var _this$props=_this.props,isInputSecure=_this$props.isInputSecure,isInputNum=_this$props.isInputNum;if(isInputSecure){return'password';}if(isInputNum){return'tel';}return'text';});_this.input=_react["default"].createRef();return _this;}_createClass(SingleOtpInput,[{key:"componentDidMount",value:function componentDidMount(){var _this$props2=this.props,focus=_this$props2.focus,shouldAutoFocus=_this$props2.shouldAutoFocus;var inputEl=this.input.current;if(inputEl&&focus&&shouldAutoFocus){inputEl.focus();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var focus=this.props.focus;var inputEl=this.input.current;if(prevProps.focus!==focus&&inputEl&&focus){inputEl.focus();inputEl.select();}}},{key:"render",value:function render(){var _this$props3=this.props,placeholder=_this$props3.placeholder,separator=_this$props3.separator,isLastChild=_this$props3.isLastChild,inputStyle=_this$props3.inputStyle,focus=_this$props3.focus,isDisabled=_this$props3.isDisabled,hasErrored=_this$props3.hasErrored,errorStyle=_this$props3.errorStyle,focusStyle=_this$props3.focusStyle,disabledStyle=_this$props3.disabledStyle,shouldAutoFocus=_this$props3.shouldAutoFocus,isInputNum=_this$props3.isInputNum,index=_this$props3.index,value=_this$props3.value,className=_this$props3.className,isInputSecure=_this$props3.isInputSecure,rest=_objectWithoutProperties(_this$props3,_excluded);return _react["default"].createElement("div",{className:className,style:{display:'flex',alignItems:'center'}},_react["default"].createElement("input",_extends({"aria-label":"".concat(index===0?'Please enter verification code. ':'').concat(isInputNum?'Digit':'Character'," ").concat(index+1),autoComplete:"off",style:Object.assign({width:'1em',textAlign:'center'},isStyleObject(inputStyle)&&inputStyle,focus&&isStyleObject(focusStyle)&&focusStyle,isDisabled&&isStyleObject(disabledStyle)&&disabledStyle,hasErrored&&isStyleObject(errorStyle)&&errorStyle),placeholder:placeholder,className:this.getClasses(inputStyle,focus&&focusStyle,isDisabled&&disabledStyle,hasErrored&&errorStyle),type:this.getType(),maxLength:"1",ref:this.input,disabled:isDisabled,value:value?value:''},rest)),!isLastChild&&separator);}}]);return SingleOtpInput;}(_react.PureComponent);var OtpInput=function(_Component){_inherits(OtpInput,_Component);var _super2=_createSuper(OtpInput);function OtpInput(){var _this2;_classCallCheck(this,OtpInput);for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}_this2=_super2.call.apply(_super2,[this].concat(args));_defineProperty(_assertThisInitialized(_this2),"state",{activeInput:0});_defineProperty(_assertThisInitialized(_this2),"getOtpValue",function(){return _this2.props.value?_this2.props.value.toString().split(''):[];});_defineProperty(_assertThisInitialized(_this2),"getPlaceholderValue",function(){var _this2$props=_this2.props,placeholder=_this2$props.placeholder,numInputs=_this2$props.numInputs;if(typeof placeholder==='string'){if(placeholder.length===numInputs){return placeholder;}if(placeholder.length>0){console.error('Length of the placeholder should be equal to the number of inputs.');}}});_defineProperty(_assertThisInitialized(_this2),"handleOtpChange",function(otp){var onChange=_this2.props.onChange;var otpValue=otp.join('');onChange(otpValue);});_defineProperty(_assertThisInitialized(_this2),"isInputValueValid",function(value){var isTypeValid=_this2.props.isInputNum?!isNaN(parseInt(value,10)):typeof value==='string';return isTypeValid&&value.trim().length===1;});_defineProperty(_assertThisInitialized(_this2),"focusInput",function(input){var numInputs=_this2.props.numInputs;var activeInput=Math.max(Math.min(numInputs-1,input),0);_this2.setState({activeInput:activeInput});});_defineProperty(_assertThisInitialized(_this2),"focusNextInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput+1);});_defineProperty(_assertThisInitialized(_this2),"focusPrevInput",function(){var activeInput=_this2.state.activeInput;_this2.focusInput(activeInput-1);});_defineProperty(_assertThisInitialized(_this2),"changeCodeAtFocus",function(value){var activeInput=_this2.state.activeInput;var otp=_this2.getOtpValue();otp[activeInput]=value[0];_this2.handleOtpChange(otp);});_defineProperty(_assertThisInitialized(_this2),"handleOnPaste",function(e){e.preventDefault();var activeInput=_this2.state.activeInput;var _this2$props2=_this2.props,numInputs=_this2$props2.numInputs,isDisabled=_this2$props2.isDisabled;if(isDisabled){return;}var otp=_this2.getOtpValue();var nextActiveInput=activeInput;var pastedData=e.clipboardData.getData('text/plain').slice(0,numInputs-activeInput).split('');for(var pos=0;pos<numInputs;++pos){if(pos>=activeInput&&pastedData.length>0){otp[pos]=pastedData.shift();nextActiveInput++;}}_this2.setState({activeInput:nextActiveInput},function(){_this2.focusInput(nextActiveInput);_this2.handleOtpChange(otp);});});_defineProperty(_assertThisInitialized(_this2),"handleOnChange",function(e){var value=e.target.value;if(_this2.isInputValueValid(value)){_this2.changeCodeAtFocus(value);}});_defineProperty(_assertThisInitialized(_this2),"handleOnKeyDown",function(e){if(e.keyCode===BACKSPACE||e.key==='Backspace'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}else if(e.keyCode===DELETE||e.key==='Delete'){e.preventDefault();_this2.changeCodeAtFocus('');}else if(e.keyCode===LEFT_ARROW||e.key==='ArrowLeft'){e.preventDefault();_this2.focusPrevInput();}else if(e.keyCode===RIGHT_ARROW||e.key==='ArrowRight'){e.preventDefault();_this2.focusNextInput();}else if(e.keyCode===SPACEBAR||e.key===' '||e.key==='Spacebar'||e.key==='Space'){e.preventDefault();}});_defineProperty(_assertThisInitialized(_this2),"handleOnInput",function(e){if(_this2.isInputValueValid(e.target.value)){_this2.focusNextInput();}else{if(!_this2.props.isInputNum){var nativeEvent=e.nativeEvent;if(nativeEvent.data===null&&nativeEvent.inputType==='deleteContentBackward'){e.preventDefault();_this2.changeCodeAtFocus('');_this2.focusPrevInput();}}}});_defineProperty(_assertThisInitialized(_this2),"renderInputs",function(){var activeInput=_this2.state.activeInput;var _this2$props3=_this2.props,numInputs=_this2$props3.numInputs,inputStyle=_this2$props3.inputStyle,focusStyle=_this2$props3.focusStyle,separator=_this2$props3.separator,isDisabled=_this2$props3.isDisabled,disabledStyle=_this2$props3.disabledStyle,hasErrored=_this2$props3.hasErrored,errorStyle=_this2$props3.errorStyle,shouldAutoFocus=_this2$props3.shouldAutoFocus,isInputNum=_this2$props3.isInputNum,isInputSecure=_this2$props3.isInputSecure,className=_this2$props3.className;var inputs=[];var otp=_this2.getOtpValue();var placeholder=_this2.getPlaceholderValue();var dataCy=_this2.props['data-cy'];var dataTestId=_this2.props['data-testid'];var _loop=function _loop(i){inputs.push(_react["default"].createElement(SingleOtpInput,{placeholder:placeholder&&placeholder[i],key:i,index:i,focus:activeInput===i,value:otp&&otp[i],onChange:_this2.handleOnChange,onKeyDown:_this2.handleOnKeyDown,onInput:_this2.handleOnInput,onPaste:_this2.handleOnPaste,onFocus:function onFocus(e){_this2.setState({activeInput:i});e.target.select();},onBlur:function onBlur(){return _this2.setState({activeInput:-1});},separator:separator,inputStyle:inputStyle,focusStyle:focusStyle,isLastChild:i===numInputs-1,isDisabled:isDisabled,disabledStyle:disabledStyle,hasErrored:hasErrored,errorStyle:errorStyle,shouldAutoFocus:shouldAutoFocus,isInputNum:isInputNum,isInputSecure:isInputSecure,className:className,"data-cy":dataCy&&"".concat(dataCy,"-").concat(i),"data-testid":dataTestId&&"".concat(dataTestId,"-").concat(i)}));};for(var i=0;i<numInputs;i++){_loop(i);}return inputs;});return _this2;}_createClass(OtpInput,[{key:"render",value:function render(){var containerStyle=this.props.containerStyle;return _react["default"].createElement("div",{style:Object.assign({display:'flex'},isStyleObject(containerStyle)&&containerStyle),className:!isStyleObject(containerStyle)?containerStyle:''},this.renderInputs());}}]);return OtpInput;}(_react.Component);_defineProperty(OtpInput,"defaultProps",{numInputs:4,onChange:function onChange(otp){return console.log(otp);},isDisabled:false,shouldAutoFocus:false,value:'',isInputSecure:false});var _default=OtpInput;exports.Z=_default;

/***/ }),

/***/ 8665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 5505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Le; },
  "vJ": function() { return /* binding */ $e; },
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ We; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(8570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(8665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_esm = (isPropValid);

// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(3463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(4406);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,emotion_is_prop_valid_esm,b):!_||emotion_is_prop_valid_esm(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 402:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(2784),n=__webpack_require__(3100);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 3100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(452);
} else {}


/***/ }),

/***/ 1110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(402);
} else {}


/***/ }),

/***/ 6893:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 1512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 406:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 6412:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 3089:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 5235:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 8200:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 129:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(303);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 2269:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 4214:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _possibleConstructorReturn; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(4280);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (helpers_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

/***/ }),

/***/ 303:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 8529:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(7211);
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 7211:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1512);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 624:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ../../node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(1110);
;// CONCATENATED MODULE: ../../node_modules/zustand/esm/index.mjs





const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
function useStore(api, selector = api.getState, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ }),

/***/ 2532:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ shallow; }
/* harmony export */ });
/* unused harmony export default */
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size)
      return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size)
      return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
var shallow$1 = (objA, objB) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { shallow } from 'zustand/shallow'`."
    );
  }
  return shallow(objA, objB);
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6570), __webpack_exec__(5876); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);